// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400;1,9..144,500;1,9..144,600&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400;1,9..144,500;1,9..144,600&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────────
   TeamLio Global Theme — single unified design system
   ─────────────────────────────────────────────────────────────────────────
   The task management aesthetic, applied across the whole project:
   warm cream surfaces, dark forest green primary, Plus Jakarta Sans display
   font, Fraunces serif italic accents, soft rounded surfaces, no glass.
   ──────────────────────────────────────────────────────────────────────── */

/* ════════════════════════════════════════════════════════════════════════════
   DESIGN TOKENS — single source of truth
   ────────────────────────────────────────────────────────────────────────────

   This block defines EVERY design token used in the app:
     • Colours (surfaces, text, borders, brand, accent, status, priority…)
     • Typography (font families, letter-spacing)
     • Radii, shadows, transitions
     • Layout sizing, density

   Theming model:
     • :root                       → light theme (default)
     • [data-theme="dark"]         → dark theme
     • [data-theme="hc"]           → high-contrast theme
     • Add more themes by adding a [data-theme="..."] block below.

   How to switch the active theme at runtime:
     Set \`data-theme="<name>"\` on <html>. The helper in src/lib/theme.ts does
     this + persists the choice to localStorage. The picker UI lives in
     ProfileTab.tsx.

   Variable naming:
     • --gt-* tokens drive the global shell (tasks, calendar, sidebar, …).
     • --gc-* tokens drive the chat surfaces.
     They are kept side-by-side so one theme override updates both palettes
     and chat + the rest of the app stay visually unified.
   ════════════════════════════════════════════════════════════════════════════ */

:root {

  /* ── GLOBAL THEME (--gt-*) ─────────────────────────────────────────────── */

  /* Surfaces */
  --gt-surface-0: #ffffff;
  --gt-surface-1: #ffffff;
  --gt-surface-2: #f5f5f5;
  --gt-surface-3: #e7e7e7;
  --gt-surface-hover: rgba(15, 45, 31, 0.04);
  --gt-surface-rail: #ffffff;
  --gt-surface-rail-soft: #ffffff;

  /* Brand */
  --gt-primary: #0f2d1f;
  --gt-primary-hover: #0a1f15;
  --gt-primary-soft: #1f4030;
  --gt-primary-deep: #061812;
  --gt-primary-container: #e8efe9;
  --gt-primary-container-hover: #d4ddd6;
  --gt-on-primary: #ffffff;

  /* Accent */
  --gt-accent: #1f4030;
  --gt-accent-soft: #d4ddd6;
  --gt-accent-strong: #0f2d1f;

  /* Text */
  --gt-text-primary: #1a1a1a;
  --gt-text-secondary: #4a4a4a;
  --gt-text-tertiary: #8a8580;
  --gt-text-muted: #6b7280;
  --gt-text-disabled: #b8b3ac;
  --gt-text-link: #0f2d1f;

  /* Borders */
  --gt-border: #e8e3d8;
  --gt-border-strong: #d6d0c2;
  --gt-divider: #efeae0;

  /* Status */
  --gt-online: #2f9e6c;
  --gt-away: #d4a356;
  --gt-dnd: #c4574c;
  --gt-offline: #b8b3ac;

  /* Priority */
  --gt-prio-urgent-bg: #fee2e2;
  --gt-prio-urgent-fg: #991b1b;
  --gt-prio-urgent-dot: #dc2626;
  --gt-prio-high-bg:  #ffedd5;
  --gt-prio-high-fg:  #9a3412;
  --gt-prio-high-dot: #ea580c;
  --gt-prio-med-bg:   #fef3c7;
  --gt-prio-med-fg:   #854d0e;
  --gt-prio-med-dot:  #d97706;
  --gt-prio-low-bg:   #dbeafe;
  --gt-prio-low-fg:   #1e3a8a;
  --gt-prio-low-dot:  #2563eb;

  /* Status pills */
  --gt-status-pending-bg:   #f4f1ea;
  --gt-status-pending-fg:   #6a665e;
  --gt-status-progress-bg:  #e8eef6;
  --gt-status-progress-fg:  #2f4a73;
  --gt-status-progress-dot: #6a8bbd;
  --gt-status-done-bg:      #e8efe9;
  --gt-status-done-fg:      #0f2d1f;
  --gt-status-overdue-bg:   #fdecea;
  --gt-status-overdue-fg:   #a83c34;

  /* Shared UI palette */
  --gt-white:        #ffffff;
  --gt-green-100:    #dcfce7;
  --gt-green-500:    #22c55e;
  --gt-green-600:    #16a34a;
  --gt-green-700:    #15803d;
  --gt-green-800:    #166534;
  --gt-green-soft:   #e7f0ea;
  --gt-green-muted:  #86b89a;
  --gt-red-100:      #fee2e2;
  --gt-red-500:      #ef4444;
  --gt-red-600:      #dc2626;
  --gt-red-700:      #b91c1c;
  --gt-red-800:      #991b1b;
  --gt-amber-100:    #fef3c7;
  --gt-amber-500:    #f59e0b;
  --gt-amber-600:    #d97706;
  --gt-amber-800:    #92400e;
  --gt-amber-900:    #854d0e;
  --gt-orange-100:   #ffedd5;
  --gt-orange-500:   #f97316;
  --gt-orange-600:   #ea580c;
  --gt-orange-800:   #9a3412;
  --gt-blue-100:     #dbeafe;
  --gt-blue-500:     #3b82f6;
  --gt-blue-600:     #2563eb;
  --gt-blue-800:     #1e40af;
  --gt-blue-900:     #1e3a8a;
  --gt-purple-100:   #f3e8ff;
  --gt-purple-500:   #a855f7;
  --gt-purple-600:   #9333ea;
  --gt-purple-800:   #6b21a8;
  --gt-emerald-500:  #10b981;
  --gt-emerald-600:  #059669;
  --gt-cyan-600:     #0891b2;
  --gt-indigo-500:   #6366f1;
  --gt-violet-500:   #8b5cf6;
  --gt-violet-600:   #7c3aed;
  --gt-teal-500:     #14b8a6;
  --gt-teal-600:     #0d9488;
  --gt-yellow-500:   #eab308;
  --gt-gray-500:     #6b7280;
  --gt-gray-700:     #374151;
  --gt-slate-100:    #f1f5f9;
  --gt-slate-200:    #eef1f5;
  --gt-slate-400:    #94a3b8;
  --gt-slate-600:    #475569;
  --gt-slate-700:    #334155;
  --gt-overlay-white-22: rgba(255, 255, 255, 0.22);
  --gt-overlay-red-18:   rgba(220, 38, 38, 0.18);
  --gt-overlay-slate-28: rgba(15, 23, 42, 0.28);
  --gt-overlay-slate-55: rgba(15, 23, 42, 0.55);
  --gt-overlay-blue-25:  rgba(37, 99, 235, 0.25);
  --gt-overlay-green-25: rgba(22, 163, 74, 0.25);

  /* Elevation */
  --gt-elev-1: 0 1px 2px rgba(20, 20, 18, 0.04);
  --gt-elev-2: 0 2px 8px rgba(20, 20, 18, 0.05), 0 1px 2px rgba(20, 20, 18, 0.04);
  --gt-elev-3: 0 8px 24px -6px rgba(20, 20, 18, 0.08), 0 2px 6px rgba(20, 20, 18, 0.04);
  --gt-elev-4: 0 16px 40px -10px rgba(20, 20, 18, 0.12), 0 4px 10px rgba(20, 20, 18, 0.06);
  --gt-elev-5: 0 28px 64px -14px rgba(20, 20, 18, 0.16), 0 8px 16px rgba(20, 20, 18, 0.08);
  --gt-glow: 0 4px 14px -4px rgba(15, 45, 31, 0.18);
  --gt-glow-soft: 0 2px 8px -3px rgba(15, 45, 31, 0.12);

  /* Radius */
  --gt-radius-card: 18px;
  --gt-radius-modal: 22px;
  --gt-radius-sheet: 24px;
  --gt-radius-pill: 9999px;
  --gt-radius-input: 14px;

  /* Typography */
  --gt-font: 'Plus Jakarta Sans', 'Inter', 'Segoe UI', system-ui, sans-serif;
  --gt-font-display: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;
  --gt-font-serif: 'Fraunces', 'Iowan Old Style', Georgia, serif;
  --gt-font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
  --gt-letter-display: -0.025em;
  --gt-letter-eyebrow: 0.10em;

  /* Transitions */
  --gt-t-fast: 150ms cubic-bezier(0.33, 1, 0.68, 1);
  --gt-t-mid:  240ms cubic-bezier(0.33, 1, 0.68, 1);
  --gt-t-slow: 360ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Glass aliases (kept solid) */
  --gt-glass-soft: #ffffff;
  --gt-glass-mid:  #ffffff;
  --gt-glass-firm: #ffffff;
  --gt-glass-mint: #f4f1ea;
  --gt-glass-edge: #e8e3d8;
  --gt-grad-from: #1f4030;
  --gt-grad-via:  #143020;
  --gt-grad-to:   #0f2d1f;
  --gt-grad-aurora: #0f2d1f;
  --gt-grad-aurora-soft: #e8efe9;

  /* Heatmap */
  --gt-heat-0: #f4f1ea;
  --gt-heat-1: #e8efe9;
  --gt-heat-2: #d4ddd6;
  --gt-heat-3: #9eb3a4;
  --gt-heat-4: #4d6857;
  --gt-heat-5: #0f2d1f;


  /* ── CHAT (--gc-*) ─────────────────────────────────────────────────────── */

  /* Surfaces */
  --gc-surface-0: #ffffff;
  --gc-surface-1: #ffffff;
  --gc-surface-2: #fafafa;
  --gc-surface-3: #e7e7e7;
  --gc-surface-hover: rgba(31, 46, 35, 0.045);
  --gc-surface-rail: #dcefe1;
  --gc-surface-rail-soft: #ecf6ee;

  /* Brand: deep forest */
  --gc-primary: #1f2e23;
  --gc-primary-hover: #15211a;
  --gc-primary-soft: #2a3d30;
  --gc-primary-container: #dcefe1;
  --gc-primary-container-hover: #c8e3cf;
  --gc-on-primary: #f7faf6;

  /* Sent bubble */
  --gc-bubble-mine-bg: #2f4a3c;
  --gc-bubble-mine-bg-hover: #355241;
  --gc-bubble-mine-text: #f4faf6;

  /* Accent */
  --gc-accent: #10b981;
  --gc-accent-soft: #d1fae5;
  --gc-accent-strong: #047857;

  /* Text */
  --gc-text-primary: #000000;
  --gc-text-secondary: #3d4a42;
  --gc-text-tertiary: #6b766f;
  --gc-text-disabled: #9ba49d;
  --gc-text-link: #047857;
  --gc-text-on-rail: #1f2e23;
  --gc-text-on-rail-mute: #4b5b51;

  /* Status */
  --gc-online: #10b981;
  --gc-away: #f59e0b;
  --gc-dnd: #dc2626;
  --gc-offline: #9ba49d;
  --gc-meeting: #047857;
  --gc-info: #1f2e23;

  /* Borders & Dividers */
  --gc-border: #e3ebe0;
  --gc-border-strong: #cdd8c9;
  --gc-divider: #ecf0e9;

  /* Mention / Highlight */
  --gc-mention-bg: #fef3c7;
  --gc-mention-text: #854d0e;
  --gc-mention-channel-bg: #fee2e2;
  --gc-mention-channel-text: #991b1b;
  --gc-self-mention-bg: #d1fae5;
  --gc-self-mention-text: #047857;

  /* Elevation */
  --gc-elev-0: none;
  --gc-elev-1: 0 1px 2px rgba(15, 29, 20, 0.05), 0 1px 3px rgba(15, 29, 20, 0.03);
  --gc-elev-2: 0 2px 8px rgba(15, 29, 20, 0.06), 0 1px 2px rgba(15, 29, 20, 0.04);
  --gc-elev-3: 0 8px 24px rgba(15, 29, 20, 0.08), 0 2px 6px rgba(15, 29, 20, 0.05);
  --gc-elev-4: 0 16px 40px rgba(15, 29, 20, 0.10), 0 4px 12px rgba(15, 29, 20, 0.06);
  --gc-elev-5: 0 28px 64px rgba(15, 29, 20, 0.14), 0 10px 20px rgba(15, 29, 20, 0.08);

  /* Layout */
  --gc-rail-width: 72px;
  --gc-sidebar-width: 340px;
  --gc-sidebar-min: 260px;
  --gc-sidebar-max: 480px;
  --gc-thread-width: 360px;
  --gc-thread-min: 280px;
  --gc-thread-max: 600px;

  /* Density: Comfortable (default) */
  --gc-msg-row-height: 36px;
  --gc-msg-padding-v: 6px;
  --gc-msg-padding-h: 16px;
  --gc-avatar-size: 36px;

  /* Border Radius */
  --gc-radius-card: 14px;
  --gc-radius-modal: 16px;
  --gc-radius-sheet: 22px;
  --gc-radius-pill: 9999px;
  --gc-radius-avatar: 50%;
  --gc-radius-bubble: 18px;

  /* Typography */
  --gc-font: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
  --gc-font-display: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;
  --gc-font-serif: 'Fraunces', 'Iowan Old Style', Georgia, serif;
  --gc-font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
  --gc-font-size-base: 14px;
  --gc-line-height: 1.55;
  --gc-font-size-sm: 12.5px;
  --gc-font-size-xs: 11px;
  --gc-letter-display: -0.02em;
  --gc-letter-eyebrow: 0.08em;

  /* Transitions */
  --gc-transition-fast: 120ms cubic-bezier(0.33, 1, 0.68, 1);
  --gc-transition-mid: 220ms cubic-bezier(0.33, 1, 0.68, 1);
  --gc-transition-slow: 360ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Presence pill — used in Employees rows + ChatHeader DM line */
  --gc-status-online-bg:   #dcfce7;
  --gc-status-online-fg:   #14532d;
  --gc-status-online-dot:  #10b981;
  --gc-status-offline-bg:  #f1f5f9;
  --gc-status-offline-fg:  #475569;
  --gc-status-offline-dot: #94a3b8;
  --gc-status-away-bg:     #fef9c3;
  --gc-status-away-fg:     #713f12;
  --gc-status-away-dot:    #eab308;
  --gc-status-leave-bg:    #fef3c7;
  --gc-status-leave-fg:    #78350f;
  --gc-status-leave-dot:   #f59e0b;
}


/* ════════════════════════════════════════════════════════════════════════════
   DARK THEME
   ════════════════════════════════════════════════════════════════════════════ */
[data-theme="dark"] {
  color-scheme: dark;

  /* Global (--gt-*) — neutral black/charcoal surfaces (no green tint) */
  --gt-surface: #141414;
  --gt-surface-0: #141414;
  --gt-surface-1: #0a0a0a;
  --gt-surface-2: #1c1c1c;
  --gt-surface-3: #2a2a2a;
  --gt-surface-hover: rgba(255, 255, 255, 0.06);
  --gt-surface-rail: #141414;
  --gt-surface-rail-soft: #1a1a1a;

  --gt-primary: #059669;
  --gt-primary-hover: #047857;
  --gt-primary-soft: #b9d6c0;
  --gt-primary-deep: #ecf6ee;
  --gt-primary-container: #1f2e23;
  --gt-primary-container-hover: #28392d;
  --gt-on-primary: #ffffff;

  --gt-accent: #6ee7b7;
  --gt-accent-soft: #1f2e23;
  --gt-accent-strong: #a7f3d0;

  --gt-text-primary: #ededed;
  --gt-text-secondary: #c7c7c7;
  --gt-text-tertiary: #8f8f8f;
  --gt-text-muted: #8f8f8f;
  --gt-text-disabled: #5e5e5e;
  --gt-text-link: #6ee7b7;

  --gt-border: #2a2a2a;
  --gt-border-strong: #3a3a3a;
  --gt-divider: #1e1e1e;

  --gt-status-pending-bg:   #1d2820;
  --gt-status-pending-fg:   #c4cfc6;
  --gt-status-progress-bg:  #1c2738;
  --gt-status-progress-fg:  #cbd9ec;
  --gt-status-done-bg:      #1f2e23;
  --gt-status-done-fg:      #dcefe1;
  --gt-status-overdue-bg:   #2a1717;
  --gt-status-overdue-fg:   #f5b3aa;

  /* Priority palette — dark values (light defaults are cream/pink and were
     bleeding through via the .bg-amber-50/.bg-red-50 → prio compat mappings,
     e.g. the pinned-messages bar). Dark bg + light fg. */
  --gt-prio-urgent-bg: #2a1717;
  --gt-prio-urgent-fg: #f5b3aa;
  --gt-prio-urgent-dot: #f87171;
  --gt-prio-high-bg:  #2a1d10;
  --gt-prio-high-fg:  #fdba74;
  --gt-prio-high-dot: #fb923c;
  --gt-prio-med-bg:   #2a2410;
  --gt-prio-med-fg:   #fcd34d;
  --gt-prio-med-dot:  #fbbf24;
  --gt-prio-low-bg:   #15233a;
  --gt-prio-low-fg:   #93c5fd;
  --gt-prio-low-dot:  #60a5fa;

  --gt-elev-1: 0 1px 2px rgba(0, 0, 0, 0.30);
  --gt-elev-2: 0 2px 8px rgba(0, 0, 0, 0.35), 0 1px 2px rgba(0, 0, 0, 0.30);
  --gt-elev-3: 0 8px 24px -6px rgba(0, 0, 0, 0.45), 0 2px 6px rgba(0, 0, 0, 0.30);
  --gt-elev-4: 0 16px 40px -10px rgba(0, 0, 0, 0.55), 0 4px 10px rgba(0, 0, 0, 0.35);
  --gt-elev-5: 0 28px 64px -14px rgba(0, 0, 0, 0.65), 0 8px 16px rgba(0, 0, 0, 0.40);
  --gt-glow: 0 4px 14px -4px rgba(110, 231, 183, 0.20);
  --gt-glow-soft: 0 2px 8px -3px rgba(110, 231, 183, 0.14);

  --gt-glass-soft: #141414;
  --gt-glass-mid:  #1c1c1c;
  --gt-glass-firm: #2a2a2a;
  --gt-glass-mint: #1f2e23;
  --gt-glass-edge: #2a2a2a;

  --gt-heat-0: #19241e;
  --gt-heat-1: #1f2e23;
  --gt-heat-2: #2a3d30;
  --gt-heat-3: #4d6857;
  --gt-heat-4: #8eb39a;
  --gt-heat-5: #dcefe1;

  /* Chat (--gc-*) — neutral black/charcoal surfaces (no green tint) */
  --gc-surface-0: #141414;
  --gc-surface-1: #0a0a0a;
  --gc-surface-2: #1c1c1c;
  --gc-surface-3: #2a2a2a;
  --gc-surface-hover: rgba(255, 255, 255, 0.06);
  --gc-surface-rail: #161616;
  --gc-surface-rail-soft: #1f1f1f;

  --gc-text-primary: #ededed;
  --gc-text-secondary: #c7c7c7;
  --gc-text-tertiary: #8f8f8f;
  --gc-text-disabled: #5e5e5e;
  --gc-text-link: #6ee7b7;
  --gc-text-on-rail: #e8e8e8;
  --gc-text-on-rail-mute: #9a9a9a;

  --gc-border: #2a2a2a;
  --gc-border-strong: #3a3a3a;
  --gc-divider: #1e1e1e;

  --gc-primary: #059669;
  --gc-primary-hover: #047857;
  --gc-primary-soft: #b9d6c0;
  --gc-primary-container: #1f2e23;
  --gc-primary-container-hover: #28392d;
  --gc-on-primary: #ffffff;

  --gc-bubble-mine-bg: #355241;
  --gc-bubble-mine-bg-hover: #3d5d4a;
  --gc-bubble-mine-text: #f4faf6;

  --gc-mention-bg: #3c2e0a;
  --gc-mention-text: #fde68a;
  --gc-self-mention-bg: #064e3b;
  --gc-self-mention-text: #6ee7b7;

  /* Presence pills tuned for dark surfaces */
  --gc-status-online-bg:   #042f1f;
  --gc-status-online-fg:   #6ee7b7;
  --gc-status-offline-bg:  #1f2937;
  --gc-status-offline-fg:  #cbd5e1;
  --gc-status-away-bg:     #422006;
  --gc-status-away-fg:     #fde68a;
  --gc-status-leave-bg:    #422006;
  --gc-status-leave-fg:    #fcd34d;
}


/* ════════════════════════════════════════════════════════════════════════════
   HIGH-CONTRAST THEME — accessibility-first.
   Every token gets a high-contrast value (no fall-through to light defaults).
   ════════════════════════════════════════════════════════════════════════════ */
[data-theme="hc"] {
  color-scheme: dark;

  /* ── Global (--gt-*) ───────────────────────────────────────────────────── */

  /* Surfaces — pure-black page, stepped grays for cards & hover so layered
     elements visually separate without breaking the high-contrast palette. */
  --gt-surface-0: #161616;   /* cards / popovers — lift off the black page */
  --gt-surface-1: #000000;   /* page background */
  --gt-surface-2: #2a2a2a;   /* card hover, secondary panels */
  --gt-surface-3: #404040;   /* tertiary / dividers */
  --gt-surface-hover: rgba(255, 255, 255, 0.10);
  --gt-surface-rail: #0a0a0a;
  --gt-surface-rail-soft: #161616;

  /* Brand — bright mint for max contrast on black */
  --gt-primary: #6ee7b7;
  --gt-primary-hover: #a7f3d0;
  --gt-primary-soft: #34d399;
  --gt-primary-deep: #d1fae5;
  --gt-primary-container: #064e3b;
  --gt-primary-container-hover: #065f46;
  --gt-on-primary: #000000;

  /* Accent — bright too, no dark forest tones */
  --gt-accent: #6ee7b7;
  --gt-accent-soft: #064e3b;
  --gt-accent-strong: #a7f3d0;

  /* Text — pure white primary, light grays for secondary */
  --gt-text-primary: #ffffff;
  --gt-text-secondary: #e0e0e0;
  --gt-text-tertiary: #c0c0c0;
  --gt-text-muted: #c0c0c0;
  --gt-text-disabled: #8a8a8a;
  --gt-text-link: #a7f3d0;

  /* Borders — white at full strength */
  --gt-border: #6a6a6a;
  --gt-border-strong: #ffffff;
  --gt-divider: #4a4a4a;

  /* Status */
  --gt-online: #69f0ae;
  --gt-away: #ffd54f;
  --gt-dnd: #ff5252;
  --gt-offline: #9e9e9e;

  /* Priority pills — dark cushion + bright foreground */
  --gt-prio-urgent-bg: #4a0e0e;
  --gt-prio-urgent-fg: #ffb3b3;
  --gt-prio-urgent-dot: #ff5252;
  --gt-prio-high-bg:  #4a2a0e;
  --gt-prio-high-fg:  #ffd1a0;
  --gt-prio-high-dot: #ff9645;
  --gt-prio-med-bg:   #4a3a0e;
  --gt-prio-med-fg:   #ffe7a0;
  --gt-prio-med-dot:  #ffd54f;
  --gt-prio-low-bg:   #0e2a4a;
  --gt-prio-low-fg:   #a0c8ff;
  --gt-prio-low-dot:  #5aa0ff;

  /* Status pills — same pattern */
  --gt-status-pending-bg:   #2d2d2d;
  --gt-status-pending-fg:   #e0e0e0;
  --gt-status-progress-bg:  #0e2a4a;
  --gt-status-progress-fg:  #a0c8ff;
  --gt-status-progress-dot: #5aa0ff;
  --gt-status-done-bg:      #064e3b;
  --gt-status-done-fg:      #a7f3d0;
  --gt-status-overdue-bg:   #4a0e0e;
  --gt-status-overdue-fg:   #ffb3b3;

  /* Elevation — heavy shadows so cards still separate on black */
  --gt-elev-1: 0 0 0 1px rgba(255, 255, 255, 0.10);
  --gt-elev-2: 0 0 0 1px rgba(255, 255, 255, 0.14), 0 2px 8px rgba(0, 0, 0, 0.5);
  --gt-elev-3: 0 0 0 1px rgba(255, 255, 255, 0.18), 0 8px 24px rgba(0, 0, 0, 0.6);
  --gt-elev-4: 0 0 0 1px rgba(255, 255, 255, 0.22), 0 16px 40px rgba(0, 0, 0, 0.7);
  --gt-elev-5: 0 0 0 1px rgba(255, 255, 255, 0.26), 0 28px 64px rgba(0, 0, 0, 0.8);
  --gt-glow: 0 0 0 2px rgba(110, 231, 183, 0.5);
  --gt-glow-soft: 0 0 0 1px rgba(110, 231, 183, 0.35);

  /* Glass / gradient aliases */
  --gt-glass-soft: #0a0a0a;
  --gt-glass-mid:  #1a1a1a;
  --gt-glass-firm: #2d2d2d;
  --gt-glass-mint: #064e3b;
  --gt-glass-edge: #ffffff;
  --gt-grad-from: #a7f3d0;
  --gt-grad-via:  #6ee7b7;
  --gt-grad-to:   #34d399;
  --gt-grad-aurora: #6ee7b7;
  --gt-grad-aurora-soft: #064e3b;

  /* Heatmap — black → bright mint */
  --gt-heat-0: #1a1a1a;
  --gt-heat-1: #064e3b;
  --gt-heat-2: #065f46;
  --gt-heat-3: #34d399;
  --gt-heat-4: #6ee7b7;
  --gt-heat-5: #d1fae5;


  /* ── Chat (--gc-*) ─────────────────────────────────────────────────────── */

  --gc-surface-0: #161616;
  --gc-surface-1: #000000;
  --gc-surface-2: #2a2a2a;
  --gc-surface-3: #404040;
  --gc-surface-hover: rgba(255, 255, 255, 0.10);
  --gc-surface-rail: #0a0a0a;
  --gc-surface-rail-soft: #161616;

  --gc-text-primary: #ffffff;
  --gc-text-secondary: #e0e0e0;
  --gc-text-tertiary: #c0c0c0;
  --gc-text-disabled: #8a8a8a;
  --gc-text-link: #a7f3d0;
  --gc-text-on-rail: #ffffff;
  --gc-text-on-rail-mute: #c0c0c0;

  --gc-border: #6a6a6a;
  --gc-border-strong: #ffffff;
  --gc-divider: #4a4a4a;

  --gc-primary: #6ee7b7;
  --gc-primary-hover: #a7f3d0;
  --gc-primary-soft: #34d399;
  --gc-primary-container: #064e3b;
  --gc-primary-container-hover: #065f46;
  --gc-on-primary: #000000;

  --gc-bubble-mine-bg: #064e3b;
  --gc-bubble-mine-bg-hover: #065f46;
  --gc-bubble-mine-text: #ffffff;

  --gc-accent: #6ee7b7;
  --gc-accent-soft: #064e3b;
  --gc-accent-strong: #a7f3d0;

  --gc-online: #69f0ae;
  --gc-away: #ffd54f;
  --gc-dnd: #ff5252;
  --gc-offline: #9e9e9e;
  --gc-meeting: #a7f3d0;
  --gc-info: #ffffff;

  --gc-mention-bg: #4a3a0e;
  --gc-mention-text: #ffe7a0;
  --gc-mention-channel-bg: #4a0e0e;
  --gc-mention-channel-text: #ffb3b3;
  --gc-self-mention-bg: #064e3b;
  --gc-self-mention-text: #a7f3d0;

  --gc-elev-0: none;
  --gc-elev-1: 0 0 0 1px rgba(255, 255, 255, 0.10);
  --gc-elev-2: 0 0 0 1px rgba(255, 255, 255, 0.14), 0 2px 8px rgba(0, 0, 0, 0.5);
  --gc-elev-3: 0 0 0 1px rgba(255, 255, 255, 0.18), 0 8px 24px rgba(0, 0, 0, 0.6);
  --gc-elev-4: 0 0 0 1px rgba(255, 255, 255, 0.22), 0 16px 40px rgba(0, 0, 0, 0.7);
  --gc-elev-5: 0 0 0 1px rgba(255, 255, 255, 0.26), 0 28px 64px rgba(0, 0, 0, 0.8);

  /* Presence pills */
  --gc-status-online-bg:   #064e3b;
  --gc-status-online-fg:   #a7f3d0;
  --gc-status-online-dot:  #6ee7b7;
  --gc-status-offline-bg:  #2d2d2d;
  --gc-status-offline-fg:  #c0c0c0;
  --gc-status-offline-dot: #9e9e9e;
  --gc-status-away-bg:     #4a3a0e;
  --gc-status-away-fg:     #ffe7a0;
  --gc-status-away-dot:    #ffd54f;
  --gc-status-leave-bg:    #4a2a0e;
  --gc-status-leave-fg:    #ffd1a0;
  --gc-status-leave-dot:   #ff9645;
}

/* ════════════════════════════════════════════════════════════════════════════
   HC overrides for components that hard-code colours via inline style.
   These are component-specific patches — inline style has higher specificity
   than a class rule, so we use !important here on purpose.
   ════════════════════════════════════════════════════════════════════════════ */
[data-theme="hc"] .gt-stat-value         { color: var(--gt-text-primary) !important; }
[data-theme="hc"] .gt-stat                { border-color: var(--gt-border) !important; box-shadow: var(--gt-elev-1) !important; }
[data-theme="hc"] .gt-stat:hover          { border-color: var(--gt-border-strong) !important; }

/* Inline \`color: '#991b1b'\` (overdue red) → bright HC red */
[data-theme="hc"] [style*="#991b1b"]      { color: #ffb3b3 !important; }
/* Inline overdue card border \`rgba(220,38,38,...)\` → keep visible */
[data-theme="hc"] [style*="rgba(220,38,38"] { border-color: #ff5252 !important; }

/* Inline accent-strong text colour reads as the new bright mint */
[data-theme="hc"] [style*="--gt-accent-strong"],
[data-theme="hc"] [style*="--gc-accent-strong"] { color: var(--gt-accent-strong) !important; }

/* Page hero gradient title — keep the italic bright */
[data-theme="hc"] .gt-page-title em       { color: var(--gt-accent) !important; }

/* Filter / scope tab bar — make active state legible */
[data-theme="hc"] .gt-tasks-scope-tab.is-active {
  background: var(--gt-primary-container) !important;
  color: var(--gt-primary-deep) !important;
  border-color: var(--gt-border-strong) !important;
}

/* Inputs, textareas, selects, buttons — force a visible outline so the
   user can find every interactive surface against the black page. */
[data-theme="hc"] input:not([type="checkbox"]):not([type="radio"]),
[data-theme="hc"] textarea,
[data-theme="hc"] select,
[data-theme="hc"] .gt-input,
[data-theme="hc"] .gt-textarea,
[data-theme="hc"] .gt-select {
  background: var(--gt-surface-0) !important;
  color: var(--gt-text-primary) !important;
  border: 1px solid var(--gt-border) !important;
}
[data-theme="hc"] input:focus,
[data-theme="hc"] textarea:focus,
[data-theme="hc"] select:focus,
[data-theme="hc"] .gt-input:focus,
[data-theme="hc"] .gt-textarea:focus,
[data-theme="hc"] .gt-select:focus {
  border-color: var(--gt-primary) !important;
  outline: 2px solid var(--gt-primary) !important;
  outline-offset: 1px !important;
}
[data-theme="hc"] ::placeholder { color: var(--gt-text-tertiary) !important; opacity: 1 !important; }

/* All gt-btn variants get a visible edge */
[data-theme="hc"] .gt-btn { border: 1px solid var(--gt-border) !important; }
[data-theme="hc"] .gt-btn.is-primary {
  background: var(--gt-primary) !important;
  color: var(--gt-on-primary) !important;
  border-color: var(--gt-primary) !important;
}
[data-theme="hc"] .gt-btn.is-ghost { background: transparent !important; color: var(--gt-text-primary) !important; }
[data-theme="hc"] .gt-btn:hover { background: var(--gt-surface-hover) !important; }
[data-theme="hc"] .gt-btn.is-primary:hover { background: var(--gt-primary-hover) !important; }
[data-theme="hc"] .gt-btn:disabled,
[data-theme="hc"] .gt-btn[aria-disabled="true"] {
  opacity: 0.55 !important;
}

/* Card-ish containers — ensure they have a visible edge over the black page */
[data-theme="hc"] .gt-card,
[data-theme="hc"] .gt-dropdown,
[data-theme="hc"] .gt-popover,
[data-theme="hc"] .gt-modal,
[data-theme="hc"] .gt-sheet,
[data-theme="hc"] .gt-stat,
[data-theme="hc"] .gt-stat-tile {
  background: var(--gt-surface-0) !important;
  border: 1px solid var(--gt-border) !important;
}

/* Sidebar item visibility — active state pops against black */
[data-theme="hc"] .gt-sidebar-item.is-active {
  background: var(--gt-primary-container) !important;
  color: var(--gt-primary-deep) !important;
  border-color: var(--gt-border-strong) !important;
}

/* Chat side: bubbles, inputs, message composer */
[data-theme="hc"] .gc-bubble,
[data-theme="hc"] .gc-card,
[data-theme="hc"] .gc-composer,
[data-theme="hc"] .gc-popover {
  border: 1px solid var(--gc-border) !important;
}


/* ════════════════════════════════════════════════════════════════════════════
   DENSITY OVERRIDES (chat only) — orthogonal to theme
   ════════════════════════════════════════════════════════════════════════════ */
[data-chat-density="compact"] {
  --gc-msg-row-height: 28px;
  --gc-msg-padding-v: 3px;
  --gc-avatar-size: 28px;
}
[data-chat-density="spacious"] {
  --gc-msg-row-height: 44px;
  --gc-msg-padding-v: 10px;
  --gc-avatar-size: 44px;
}


/* ════════════════════════════════════════════════════════════════════════════
   REDUCED MOTION — collapse all transition durations to 0
   ════════════════════════════════════════════════════════════════════════════ */
@media (prefers-reduced-motion: reduce) {
  :root {
    --gt-t-fast: 0ms;
    --gt-t-mid: 0ms;
    --gt-t-slow: 0ms;
    --gc-transition-fast: 0ms;
    --gc-transition-mid: 0ms;
    --gc-transition-slow: 0ms;
  }
}


/* ════════════════════════════════════════════════════════════════════════════
   DARK-MODE TAILWIND-CLASS OVERRIDES
   Tailwind utility classes that hardcode light-mode colours (bg-white,
   text-gray-*, border-gray-*) don't adapt automatically. These rules pin them
   to theme tokens so dark/HC themes look correct without per-component edits.
   ════════════════════════════════════════════════════════════════════════════ */
[data-theme="dark"] .bg-white,
[data-theme="hc"]   .bg-white { background-color: var(--gt-surface-0) !important; }

[data-theme="dark"] .bg-gray-50,
[data-theme="dark"] .bg-gray-100,
[data-theme="dark"] .bg-slate-50,
[data-theme="dark"] .bg-slate-100,
[data-theme="dark"] .bg-neutral-50,
[data-theme="dark"] .bg-neutral-100,
[data-theme="dark"] .bg-zinc-50,
[data-theme="dark"] .bg-zinc-100,
[data-theme="dark"] .bg-stone-50,
[data-theme="dark"] .bg-stone-100,
[data-theme="hc"]   .bg-gray-50,
[data-theme="hc"]   .bg-gray-100,
[data-theme="hc"]   .bg-slate-50,
[data-theme="hc"]   .bg-slate-100,
[data-theme="hc"]   .bg-neutral-50,
[data-theme="hc"]   .bg-neutral-100 { background-color: var(--gt-surface-2) !important; }

[data-theme="dark"] .text-gray-900,
[data-theme="dark"] .text-gray-800,
[data-theme="dark"] .text-slate-900,
[data-theme="dark"] .text-slate-800,
[data-theme="dark"] .text-neutral-900,
[data-theme="dark"] .text-neutral-800,
[data-theme="dark"] .text-zinc-900,
[data-theme="dark"] .text-zinc-800,
[data-theme="dark"] .text-black,
[data-theme="hc"]   .text-gray-900,
[data-theme="hc"]   .text-gray-800,
[data-theme="hc"]   .text-black { color: var(--gt-text-primary) !important; }

[data-theme="dark"] .text-gray-700,
[data-theme="dark"] .text-gray-600,
[data-theme="dark"] .text-slate-700,
[data-theme="dark"] .text-slate-600,
[data-theme="dark"] .text-neutral-700,
[data-theme="dark"] .text-neutral-600,
[data-theme="dark"] .text-zinc-700,
[data-theme="dark"] .text-zinc-600,
[data-theme="hc"]   .text-gray-700,
[data-theme="hc"]   .text-gray-600 { color: var(--gt-text-secondary) !important; }

[data-theme="dark"] .text-gray-500,
[data-theme="dark"] .text-gray-400,
[data-theme="dark"] .text-slate-500,
[data-theme="dark"] .text-slate-400,
[data-theme="dark"] .text-neutral-500,
[data-theme="dark"] .text-neutral-400,
[data-theme="dark"] .text-zinc-500,
[data-theme="dark"] .text-zinc-400,
[data-theme="hc"]   .text-gray-500,
[data-theme="hc"]   .text-gray-400 { color: var(--gt-text-tertiary) !important; }

[data-theme="dark"] .border-gray-100,
[data-theme="dark"] .border-gray-200,
[data-theme="dark"] .border-gray-300,
[data-theme="dark"] .border-slate-100,
[data-theme="dark"] .border-slate-200,
[data-theme="dark"] .border-slate-300,
[data-theme="dark"] .border-neutral-200,
[data-theme="dark"] .border-zinc-200,
[data-theme="hc"]   .border-gray-100,
[data-theme="hc"]   .border-gray-200,
[data-theme="hc"]   .border-gray-300 { border-color: var(--gt-border) !important; }

[data-theme="dark"] .divide-gray-100 > * + *,
[data-theme="dark"] .divide-gray-200 > * + *,
[data-theme="dark"] .divide-slate-200 > * + * { border-color: var(--gt-divider) !important; }

/* Hover state — gray-50/100 backgrounds on hover should adapt too */
[data-theme="dark"] .hover\\:bg-gray-50:hover,
[data-theme="dark"] .hover\\:bg-gray-100:hover,
[data-theme="dark"] .hover\\:bg-slate-50:hover,
[data-theme="dark"] .hover\\:bg-slate-100:hover,
[data-theme="hc"]   .hover\\:bg-gray-50:hover,
[data-theme="hc"]   .hover\\:bg-gray-100:hover { background-color: var(--gt-surface-hover) !important; }

/* Dark-mode and HC: bg-black / very-dark-gray classes should still respect
   the theme's surface tokens (so HC stat tiles use the same black as the
   rest of the shell, not a stray Tailwind black). */
[data-theme="dark"] .bg-gray-800,
[data-theme="dark"] .bg-gray-900,
[data-theme="dark"] .bg-slate-800,
[data-theme="dark"] .bg-slate-900,
[data-theme="dark"] .bg-neutral-900,
[data-theme="dark"] .bg-zinc-900,
[data-theme="dark"] .bg-black,
[data-theme="hc"]   .bg-gray-800,
[data-theme="hc"]   .bg-gray-900,
[data-theme="hc"]   .bg-black { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }

/* Coloured text utilities used for status / numbers — keep them readable on dark surfaces. */
[data-theme="hc"] .text-emerald-600,
[data-theme="hc"] .text-emerald-700,
[data-theme="hc"] .text-emerald-800,
[data-theme="hc"] .text-green-600,
[data-theme="hc"] .text-green-700,
[data-theme="hc"] .text-green-800,
[data-theme="hc"] .text-teal-600,
[data-theme="hc"] .text-teal-700 { color: #a7f3d0 !important; }

[data-theme="hc"] .text-red-600,
[data-theme="hc"] .text-red-700,
[data-theme="hc"] .text-rose-600,
[data-theme="hc"] .text-rose-700 { color: #ffb3b3 !important; }

[data-theme="hc"] .text-blue-600,
[data-theme="hc"] .text-blue-700,
[data-theme="hc"] .text-indigo-600,
[data-theme="hc"] .text-indigo-700 { color: #a0c8ff !important; }

[data-theme="hc"] .text-amber-600,
[data-theme="hc"] .text-amber-700,
[data-theme="hc"] .text-yellow-600,
[data-theme="hc"] .text-yellow-700,
[data-theme="hc"] .text-orange-600,
[data-theme="hc"] .text-orange-700 { color: #ffe7a0 !important; }

/* Mirror these for dark mode (less aggressive — only the darkest variants). */
[data-theme="dark"] .text-emerald-700,
[data-theme="dark"] .text-emerald-800,
[data-theme="dark"] .text-green-700,
[data-theme="dark"] .text-green-800 { color: #6ee7b7 !important; }
[data-theme="dark"] .text-red-700,
[data-theme="dark"] .text-red-800 { color: #fca5a5 !important; }
[data-theme="dark"] .text-blue-700,
[data-theme="dark"] .text-blue-800 { color: #93c5fd !important; }
[data-theme="dark"] .text-amber-700,
[data-theme="dark"] .text-amber-800,
[data-theme="dark"] .text-yellow-700,
[data-theme="dark"] .text-yellow-800 { color: #fde68a !important; }


/* ════════════════════════════════════════════════════════════════════════════
   INLINE-STYLE HARDCODE OVERRIDES
   Some legacy components (TaskReports, TaskStats, TodoPlanner, TodoCard,
   JourneyStrip, ProjectDetails) ship inline style objects with literal
   hex / rgba values that ignore the active theme. We catch those by
   attribute substring selector and remap them so dark / HC themes don't
   end up with bright pastel chips floating on black surfaces.
   Match strings come straight from the values the components emit.
   ════════════════════════════════════════════════════════════════════════════ */

/* ── Blue pastels (#dbeafe / #eff6ff / #bfdbfe / rgba(59,130,246,…)) ────── */
[data-theme="dark"] [style*="rgba(59,130,246"],
[data-theme="dark"] [style*="#dbeafe"],
[data-theme="dark"] [style*="#eff6ff"] {
  background-color: rgba(96,165,250,0.14) !important;
  border-color:     rgba(96,165,250,0.30) !important;
}
[data-theme="dark"] [style*="#bfdbfe"]   { border-color: rgba(96,165,250,0.35) !important; }
[data-theme="dark"] [style*="#1e40af"],
[data-theme="dark"] [style*="#1d4ed8"],
[data-theme="dark"] [style*="#1e3a8a"]   { color: #93c5fd !important; }

[data-theme="hc"]   [style*="rgba(59,130,246"],
[data-theme="hc"]   [style*="#dbeafe"],
[data-theme="hc"]   [style*="#eff6ff"] {
  background-color: #0e2a4a !important;
  border-color:     #5aa0ff !important;
}
[data-theme="hc"]   [style*="#bfdbfe"]   { border-color: #5aa0ff !important; }
[data-theme="hc"]   [style*="#1e40af"],
[data-theme="hc"]   [style*="#1d4ed8"],
[data-theme="hc"]   [style*="#1e3a8a"]   { color: #a0c8ff !important; }

/* ── Green / emerald pastels (rgba(34,197,94,…) / #15803d / #166534) ────── */
[data-theme="dark"] [style*="rgba(34,197,94"] {
  background-color: rgba(110,231,183,0.12) !important;
  border-color:     rgba(110,231,183,0.28) !important;
}
[data-theme="dark"] [style*="#15803d"],
[data-theme="dark"] [style*="#166534"]   { color: #6ee7b7 !important; }

[data-theme="hc"]   [style*="rgba(34,197,94"] {
  background-color: #064e3b !important;
  border-color:     #6ee7b7 !important;
}
[data-theme="hc"]   [style*="#15803d"],
[data-theme="hc"]   [style*="#166534"]   { color: #a7f3d0 !important; }

/* ── Amber / yellow pastels (rgba(234,179,8,…) / #854d0e / #fef3c7) ────── */
[data-theme="dark"] [style*="rgba(234,179,8"],
[data-theme="dark"] [style*="#fef3c7"],
[data-theme="dark"] [style*="#fff7e0"] {
  background-color: rgba(253,224,71,0.10) !important;
  border-color:     rgba(253,224,71,0.28) !important;
}
[data-theme="dark"] [style*="#854d0e"],
[data-theme="dark"] [style*="#713f12"]   { color: #fde68a !important; }

[data-theme="hc"]   [style*="rgba(234,179,8"],
[data-theme="hc"]   [style*="#fef3c7"],
[data-theme="hc"]   [style*="#fff7e0"] {
  background-color: #4a3a0e !important;
  border-color:     #ffd54f !important;
}
[data-theme="hc"]   [style*="#854d0e"],
[data-theme="hc"]   [style*="#713f12"]   { color: #ffe7a0 !important; }

/* ── Red / rose pastels (rgba(220,38,38,…) / #991b1b / #fee2e2 / #fdecea) ── */
[data-theme="dark"] [style*="rgba(220,38,38"],
[data-theme="dark"] [style*="#fee2e2"],
[data-theme="dark"] [style*="#fdecea"] {
  background-color: rgba(252,165,165,0.10) !important;
  border-color:     rgba(252,165,165,0.30) !important;
}
[data-theme="dark"] [style*="#991b1b"],
[data-theme="dark"] [style*="#a83c34"]   { color: #fca5a5 !important; }

[data-theme="hc"]   [style*="rgba(220,38,38"],
[data-theme="hc"]   [style*="#fee2e2"],
[data-theme="hc"]   [style*="#fdecea"] {
  background-color: #4a0e0e !important;
  border-color:     #ff5252 !important;
}
[data-theme="hc"]   [style*="#991b1b"],
[data-theme="hc"]   [style*="#a83c34"]   { color: #ffb3b3 !important; }

/* ── Neutral / slate (rgba(107,114,128,…) / #6b7280 / #374151 / #f1f5f9) ─ */
[data-theme="dark"] [style*="rgba(107,114,128"],
[data-theme="dark"] [style*="#f1f5f9"] {
  background-color: var(--gt-surface-2) !important;
  border-color:     var(--gt-border) !important;
}
[data-theme="dark"] [style*="#374151"],
[data-theme="dark"] [style*="#6b7280"]   { color: var(--gt-text-tertiary) !important; }

[data-theme="hc"]   [style*="rgba(107,114,128"],
[data-theme="hc"]   [style*="#f1f5f9"] {
  background-color: #2d2d2d !important;
  border-color:     #ffffff !important;
}
[data-theme="hc"]   [style*="#374151"],
[data-theme="hc"]   [style*="#6b7280"]   { color: #e0e0e0 !important; }

/* ── Hardcoded white backgrounds in inline styles (\`background:'#fff'\`,
   \`background:'#ffffff'\`, \`background-color:'#fff'\`) → use theme surface. */
[data-theme="dark"] [style*="background: #fff"],
[data-theme="dark"] [style*="background:#fff"],
[data-theme="dark"] [style*="background: #ffffff"],
[data-theme="dark"] [style*="background:#ffffff"],
[data-theme="dark"] [style*="background-color: #fff"],
[data-theme="dark"] [style*="background-color:#fff"],
[data-theme="hc"]   [style*="background: #fff"],
[data-theme="hc"]   [style*="background:#fff"],
[data-theme="hc"]   [style*="background: #ffffff"],
[data-theme="hc"]   [style*="background:#ffffff"] { background-color: var(--gt-surface-0) !important; }

/* Inline \`color: #111827\` / \`#1f2937\` (dark text) → theme primary text */
[data-theme="dark"] [style*="#111827"],
[data-theme="dark"] [style*="#1f2937"],
[data-theme="hc"]   [style*="#111827"],
[data-theme="hc"]   [style*="#1f2937"]   { color: var(--gt-text-primary) !important; }

/* ════════════════════════════════════════════════════════════════════════════
   DARK THEME — component overrides for HARD-CODED light values.
   The dark token block above flips every --gc- and --gt- variable, so anything
   built on tokens adapts automatically. The rules below patch the handful of
   chat component styles that were authored with hard-coded light colours
   (white/cream popover surfaces, light status chips) and so ignore the tokens.
   Scoped to [data-theme="dark"] only — the HC theme has its own block above.
   ════════════════════════════════════════════════════════════════════════════ */

/* Chat shell background (was hard-coded #ffffff) */
[data-theme="dark"] .gc-shell { background: var(--gc-surface-0); }

/* App frame — the outer shell had a light sage gradient and the inner card a
   hard-coded white bg + light glow (this was the "white frame" around the app).
   !important so it also wins over the higher-specificity Electron shell rules. */
[data-theme="dark"] .gt-app-shell { background: var(--gt-surface-1) !important; }
[data-theme="dark"] .gt-app-main {
  background: var(--gt-surface-1) !important;
  box-shadow: none !important;
}
[data-theme="dark"] .gc-chat-shell { box-shadow: none; }

/* Primary CTA gradient (e.g. "Employee Planner") used primary→primary-deep;
   primary-deep is pale in dark, so white label vanished. Use a solid emerald
   gradient so the white text reads. */
[data-theme="dark"] .gc-task-cta-mobile {
  background: linear-gradient(135deg, var(--gt-primary) 0%, var(--gt-primary-hover) 100%);
  color: #ffffff;
}

/* Ambient pale-mint radial "glows" layered over the message stream / empty
   state / thread panel — they read as a light diagonal wash on black. Drop the
   glows and use flat dark surfaces. */
[data-theme="dark"] .gc-chat-stream { background: var(--gc-surface-0); }
[data-theme="dark"] .gc-empty-state { background: var(--gc-surface-1); }
[data-theme="dark"] .gc-thread-panel__body { background: var(--gc-surface-1); }

/* ── Contrast fixes (dark) ──────────────────────────────────────────────── */

/* Generic themed links were var(--gt-primary) = emerald (~4:1 on black). Use
   the brighter mint accent so links (incl. the app-sidebar NavLinks) read. */
[data-theme="dark"] .gt-themed a:not(.gt-btn):not([class*="text-"]) { color: var(--gt-accent); }
[data-theme="dark"] .gt-themed a:not(.gt-btn):not([class*="text-"]):hover { color: var(--gt-accent-strong); }

/* App sidebar nav — keep items neutral (the link rule above was tinting every
   row green); accent only the active item. */
[data-theme="dark"] .gt-sidebar-item,
[data-theme="dark"] .gt-sidebar-subitem { color: var(--gt-text-secondary) !important; }
[data-theme="dark"] .gt-sidebar-item.is-active,
[data-theme="dark"] .gt-sidebar-subitem.is-active { color: var(--gt-accent) !important; }

/* Presence filter chips — inactive label colours were dark (built for a light
   chip); brighten so they read on the dark chip. */
[data-theme="dark"] .gc-presence-filter-chip.is-online { color: #6ee7b7; }
[data-theme="dark"] .gc-presence-filter-chip.is-away   { color: #fbbf24; }
[data-theme="dark"] .gc-presence-filter-chip.is-groups { color: #c4b5fd; }
[data-theme="dark"] .gc-presence-filter-chip.is-internal { color: #cbd5e1; }
[data-theme="dark"] .gc-presence-filter-chip.is-external { color: #fcd34d; }
[data-theme="dark"] .gc-presence-filter-chip.is-archived { color: #d6d3d1; }

/* Tailwind opacity-modified gray surfaces (e.g. the "Repeat this task" card's
   bg-gray-50/70) aren't in the compat net — map the common ones to dark. */
[data-theme="dark"] .bg-gray-50\\/70,
[data-theme="dark"] .bg-gray-50\\/60,
[data-theme="dark"] .bg-gray-50\\/50,
[data-theme="dark"] .bg-gray-100\\/70,
[data-theme="dark"] .bg-gray-100\\/60 { background-color: var(--gt-surface-2) !important; }

/* Status stat tiles (Projects/Tasks pages) render inline mid-600 text on a
   faint colour tint — too dark on black. Brighten via the serialized rgba bg
   hook (inactive tiles only; active tiles use a solid hex bg + white text). */
[data-theme="dark"] [style*="rgba(34, 197, 94, 0.1"]   { color: #4ade80 !important; }
[data-theme="dark"] [style*="rgba(234, 179, 8, 0.1"]   { color: #fbbf24 !important; }
[data-theme="dark"] [style*="rgba(59, 130, 246, 0.1"]  { color: #60a5fa !important; }
[data-theme="dark"] [style*="rgba(107, 114, 128, 0.1"] { color: #9ca3af !important; }

/* Pale green/emerald banner gradients (e.g. the "Task Summary" card) aren't in
   the compat flatten list → stay near-white. Flatten to a dark surface. */
[data-theme="dark"] [class*="from-green-50"][class*="to-emerald-50"],
[data-theme="dark"] [class*="from-emerald-50"][class*="to-green-50"],
[data-theme="dark"] [class*="from-green-50"][class*="to-green-100"],
[data-theme="dark"] [class*="from-emerald-50"][class*="to-emerald-100"] {
  background: var(--gt-surface-2) !important;
  background-image: none !important;
}
[data-theme="dark"] .border-green-200 { border-color: var(--gt-border) !important; }

/* Floating popovers / dropdowns — were hard-coded white frosted surfaces */
[data-theme="dark"] .gc-ios-menu,
[data-theme="dark"] .gc-filter-menu,
[data-theme="dark"] .gc-time-pop {
  background: var(--gc-surface-2);
  border-color: var(--gc-border);
}

/* Message hover controls — action bar / emoji popover / action menu.
   The menu items use --gc-text-* tokens (light in dark mode), so the surface
   MUST go dark for them to read. The bar's buttons use fixed slate/emerald
   colours tuned for a light bar, so re-tint them for the dark surface. */
[data-theme="dark"] .gc-msg-action-bar,
[data-theme="dark"] .gc-msg-emoji-pop,
[data-theme="dark"] .gc-msg-action-menu {
  background: var(--gc-surface-2);
  border-color: var(--gc-border);
}
[data-theme="dark"] .gc-msg-action-btn { color: var(--gc-text-secondary); }
[data-theme="dark"] .gc-msg-action-btn:hover,
[data-theme="dark"] .gc-msg-action-btn--reply { color: var(--gc-accent-strong); }
[data-theme="dark"] .gc-msg-action-sep { background: var(--gc-border); }

/* Document viewer modal (was hard-coded #fff / #f8faf9 / #f3f4f6) */
[data-theme="dark"] .gc-doc-modal,
[data-theme="dark"] .gc-doc-modal__iframe { background: var(--gc-surface-1); }
[data-theme="dark"] .gc-doc-modal__bar {
  background: var(--gc-surface-2);
  border-bottom-color: var(--gc-border);
}
[data-theme="dark"] .gc-doc-modal__body { background: var(--gc-surface-0); }

/* Error banner — light red (#fef2f2) → dark maroon */
[data-theme="dark"] .gc-error-banner {
  background-color: var(--gt-status-overdue-bg);
  color: var(--gt-status-overdue-fg);
}

/* Task-card status chips + task-flow accents (light tints → dark) */
[data-theme="dark"] .gc-task-card__status--progress { background: #2e2410; color: #fcd34d; }
[data-theme="dark"] .gc-task-card__status--blocked  { background: var(--gt-status-overdue-bg); color: var(--gt-status-overdue-fg); }
[data-theme="dark"] .gc-task-btn-add-first { background: var(--gc-surface-2); }
[data-theme="dark"] .gc-task-flow-approver { background: #3a2a14; }
[data-theme="dark"] .gc-task-orange-circle { background: #3a2a14; }

/* Quoted reply snippet — the base wash is a near-black tint tuned for the light
   "theirs" bubble; on dark surfaces it vanishes, so lift the card with a faint
   light wash. The sent (mine) bubble stays green in both themes — re-assert its
   recessed dark wash at higher specificity so the rule above doesn't leak in. */
[data-theme="dark"] .gc-quoted { background: rgba(255, 255, 255, 0.05); }
[data-theme="dark"] .gc-quoted[data-clickable="true"]:hover { background: rgba(255, 255, 255, 0.09); }
[data-theme="dark"] .gc-bubble-mine .gc-quoted { background: rgba(0, 0, 0, 0.18); }
[data-theme="dark"] .gc-bubble-mine .gc-quoted[data-clickable="true"]:hover { background: rgba(0, 0, 0, 0.26); }

/* ── Semantic status Tailwind utilities (red = error, amber/orange = warning) ──
   The compat layer below remaps grays/blues/greens in BOTH themes; these
   semantic scales are NOT in it, so we remap them under dark only (light keeps
   Tailwind's own red/amber, which read fine on light surfaces). Solid red/amber
   buttons (bg-red-500/600) are intentionally left vivid. */
[data-theme="dark"] .bg-red-50,
[data-theme="dark"] .bg-red-100,
[data-theme="dark"] .bg-red-200 { background-color: var(--gt-status-overdue-bg) !important; }
[data-theme="dark"] .text-red-400,
[data-theme="dark"] .text-red-500,
[data-theme="dark"] .text-red-600,
[data-theme="dark"] .text-red-700 { color: var(--gt-status-overdue-fg) !important; }
[data-theme="dark"] .border-red-100,
[data-theme="dark"] .border-red-200 { border-color: #5a2a2a !important; }
[data-theme="dark"] .bg-amber-50,
[data-theme="dark"] .bg-amber-100 { background-color: #2e2410 !important; }
[data-theme="dark"] .text-amber-500,
[data-theme="dark"] .text-amber-600,
[data-theme="dark"] .text-amber-700,
[data-theme="dark"] .text-amber-800,
[data-theme="dark"] .text-orange-500 { color: #fcd34d !important; }
[data-theme="dark"] .border-amber-100,
[data-theme="dark"] .border-amber-200 { border-color: #5a4410 !important; }

/* ── Apply base typography & background globally ──────────────────────── */
html, body {
  font-family: var(--gt-font) !important;
}
html { color: var(--gt-text-primary); }
body {
  color: var(--gt-text-primary);
  background: var(--gt-surface-1);
  transition: background var(--gt-t-mid), color var(--gt-t-mid);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}
/* Force theme font on every element so Tailwind/shadcn defaults never win */
*, *::before, *::after { font-family: inherit; }
body * { font-family: var(--gt-font); }
body em, body i, body cite, body q, body blockquote, body figcaption, body dfn,
body .gt-serif-italic, body .serif-italic {
  font-family: var(--gt-font-serif) !important;
}
body code, body pre, body kbd, body samp,
body .gt-numerals, body .font-mono { font-family: var(--gt-font-mono) !important; }

/* Raw HTML elements — base typography that applies project-wide */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--gt-font-display);
  color: var(--gt-text-primary);
  letter-spacing: -0.02em;
  font-weight: 700;
}
p { color: var(--gt-text-secondary); line-height: 1.55; }
em, i, cite, q, blockquote, figcaption, dfn {
  font-family: var(--gt-font-serif);
  font-style: italic;
}
code, pre, kbd, samp { font-family: var(--gt-font-mono); }
hr { border: none; border-top: 1px solid var(--gt-divider); }

/* Selection */
::selection { background: var(--gt-primary-container); color: var(--gt-primary-deep); }

/* Default focus ring on any interactive element.
   No visible ring — each component decides its own focus treatment instead
   of a global pill, which leaked rounded outlines into chat rows / header. */
*:focus-visible {
  outline: none;
  box-shadow: none;
}

/* ──────────────────────────────────────────────────────────────────────────
   Global Tailwind compatibility — applied to any page wrapped in gt-themed.
   Maps generic blue/indigo/purple/gray utility classes to theme tokens so
   legacy pages adopt the active theme without rewrites.
   ──────────────────────────────────────────────────────────────────────── */
.gt-themed {
  font-family: var(--gt-font);
  color: var(--gt-text-primary);
}
.gt-themed h1, .gt-themed h2, .gt-themed h3, .gt-themed h4 {
  font-family: var(--gt-font-display);
  letter-spacing: -0.01em;
  color: var(--gt-text-primary);
}

/* Surfaces */
.gt-themed .bg-white { background-color: var(--gt-surface-0) !important; }
.gt-themed .bg-gray-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-gray-100 { background-color: var(--gt-surface-2) !important; }
.gt-themed .bg-gray-200 { background-color: var(--gt-surface-3) !important; }

/* Borders */
.gt-themed .border-gray-100 { border-color: var(--gt-divider) !important; }
.gt-themed .border-gray-200 { border-color: var(--gt-border) !important; }
.gt-themed .border-gray-300 { border-color: var(--gt-border-strong) !important; }

/* Text */
.gt-themed .text-gray-400 { color: var(--gt-text-disabled) !important; }
.gt-themed .text-gray-500 { color: var(--gt-text-tertiary) !important; }
.gt-themed .text-gray-600,
.gt-themed .text-gray-700 { color: var(--gt-text-secondary) !important; }
.gt-themed .text-gray-800,
.gt-themed .text-gray-900 { color: var(--gt-text-primary) !important; }

/* Blue / indigo / purple → primary */
.gt-themed .text-blue-500, .gt-themed .text-blue-600, .gt-themed .text-blue-700,
.gt-themed .text-indigo-500, .gt-themed .text-indigo-600, .gt-themed .text-indigo-700,
.gt-themed .text-purple-500, .gt-themed .text-purple-600, .gt-themed .text-purple-700,
.gt-themed .text-violet-500, .gt-themed .text-violet-600 { color: var(--gt-primary) !important; }

.gt-themed .bg-blue-50, .gt-themed .bg-indigo-50, .gt-themed .bg-purple-50, .gt-themed .bg-violet-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-blue-100, .gt-themed .bg-indigo-100, .gt-themed .bg-purple-100, .gt-themed .bg-violet-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }
.gt-themed .bg-blue-500, .gt-themed .bg-blue-600,
.gt-themed .bg-indigo-500, .gt-themed .bg-indigo-600,
.gt-themed .bg-purple-500, .gt-themed .bg-purple-600,
.gt-themed .bg-violet-500, .gt-themed .bg-violet-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }
.gt-themed .bg-blue-700, .gt-themed .bg-indigo-700, .gt-themed .bg-purple-700, .gt-themed .bg-violet-700 { background-color: var(--gt-primary-hover) !important; }

.gt-themed .border-blue-200, .gt-themed .border-indigo-200, .gt-themed .border-purple-200 { border-color: var(--gt-border) !important; }
.gt-themed .border-blue-500, .gt-themed .border-indigo-500, .gt-themed .border-purple-500,
.gt-themed .border-blue-600, .gt-themed .border-indigo-600, .gt-themed .border-purple-600 { border-color: var(--gt-primary) !important; }

.gt-themed .focus\\:ring-blue-500:focus,
.gt-themed .focus\\:ring-indigo-500:focus,
.gt-themed .focus\\:ring-purple-500:focus,
.gt-themed .focus\\:ring-blue-400:focus { --tw-ring-color: var(--gt-primary) !important; box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important; }
.gt-themed .focus\\:border-blue-500:focus,
.gt-themed .focus\\:border-indigo-500:focus { border-color: var(--gt-primary) !important; }

.gt-themed .hover\\:bg-blue-50:hover, .gt-themed .hover\\:bg-indigo-50:hover, .gt-themed .hover\\:bg-purple-50:hover { background-color: var(--gt-surface-1) !important; }
.gt-themed .hover\\:bg-blue-100:hover, .gt-themed .hover\\:bg-indigo-100:hover, .gt-themed .hover\\:bg-purple-100:hover { background-color: var(--gt-primary-container) !important; }
.gt-themed .hover\\:text-blue-600:hover, .gt-themed .hover\\:text-indigo-600:hover, .gt-themed .hover\\:text-purple-600:hover { color: var(--gt-primary) !important; }

/* Gradient backgrounds → flat primary (small accents like icon squares).
   Comprehensive coverage of common AI-slop 2-stop saturated gradient combos. */
.gt-themed [class*="from-blue-400"][class*="to-blue-600"],
.gt-themed [class*="from-blue-500"][class*="to-blue-600"],
.gt-themed [class*="from-blue-600"][class*="to-blue-700"],
.gt-themed [class*="from-blue-500"][class*="to-cyan-500"],
.gt-themed [class*="from-blue-500"][class*="to-cyan-600"],
.gt-themed [class*="from-blue-500"][class*="to-indigo-500"],
.gt-themed [class*="from-blue-500"][class*="to-indigo-600"],
.gt-themed [class*="from-blue-600"][class*="to-indigo-600"],
.gt-themed [class*="from-blue-500"][class*="to-purple-600"],
.gt-themed [class*="from-blue-600"][class*="to-purple-600"],
.gt-themed [class*="from-blue-600"][class*="to-purple-700"],
.gt-themed [class*="from-indigo-500"][class*="to-blue-600"],
.gt-themed [class*="from-indigo-500"][class*="to-purple-500"],
.gt-themed [class*="from-indigo-500"][class*="to-purple-600"],
.gt-themed [class*="from-indigo-600"][class*="to-purple-600"],
.gt-themed [class*="from-indigo-600"][class*="to-purple-700"],
.gt-themed [class*="from-violet-500"][class*="to-purple-500"],
.gt-themed [class*="from-violet-500"][class*="to-purple-600"],
.gt-themed [class*="from-violet-600"][class*="to-purple-600"],
.gt-themed [class*="from-purple-500"][class*="to-pink-500"],
.gt-themed [class*="from-purple-500"][class*="to-pink-600"],
.gt-themed [class*="from-purple-600"][class*="to-pink-500"],
.gt-themed [class*="from-purple-600"][class*="to-pink-600"],
.gt-themed [class*="from-purple-600"][class*="to-purple-700"],
.gt-themed [class*="from-pink-500"][class*="to-rose-500"],
.gt-themed [class*="from-pink-500"][class*="to-rose-600"],
.gt-themed [class*="from-pink-500"][class*="to-purple-600"],
.gt-themed [class*="from-fuchsia-500"][class*="to-pink-500"],
.gt-themed [class*="from-fuchsia-500"][class*="to-purple-600"],
.gt-themed [class*="from-cyan-500"][class*="to-blue-500"],
.gt-themed [class*="from-cyan-500"][class*="to-blue-600"],
.gt-themed [class*="from-cyan-600"][class*="to-blue-600"],
.gt-themed [class*="from-emerald-500"][class*="to-teal-500"],
.gt-themed [class*="from-emerald-500"][class*="to-teal-600"],
.gt-themed [class*="from-emerald-600"][class*="to-teal-600"],
.gt-themed [class*="from-green-500"][class*="to-emerald-500"],
.gt-themed [class*="from-green-500"][class*="to-emerald-600"],
.gt-themed [class*="from-green-500"][class*="to-teal-500"],
.gt-themed [class*="from-orange-500"][class*="to-pink-500"],
.gt-themed [class*="from-orange-500"][class*="to-red-500"],
.gt-themed [class*="from-yellow-500"][class*="to-orange-500"],
.gt-themed [class*="from-rose-500"][class*="to-pink-500"] {
  background: var(--gt-primary) !important;
  background-image: none !important;
  color: #ffffff !important;
  box-shadow: var(--gt-glow-soft) !important;
}

/* Hero card strips — saturated gradient with hero-sized padding (p-6/p-8 or
   substantial px-/py-) → FLATTEN to transparent. Distinguishes from small
   icon accents above by requiring large padding. */
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-8"],
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-8"],
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-600"][class*="to-pink-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-8"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-600"][class*="to-purple-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-600"][class*="to-purple-600"][class*="p-8"],
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-600"][class*="to-purple-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-600"][class*="to-purple-600"][class*="p-8"],
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-purple-600"][class*="p-6"],
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-purple-600"][class*="p-8"] {
  background: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

/* Inside those flat hero strips, white text & light-tinted text become muted
   theme text so they read on the cream surface */
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] *:not(svg):not([class*="gt-"]),
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] *:not(svg):not([class*="gt-"]),
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] *:not(svg):not([class*="gt-"]),
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-600"][class*="to-purple-600"][class*="p-6"] *:not(svg):not([class*="gt-"]),
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-600"][class*="to-purple-600"][class*="p-6"] *:not(svg):not([class*="gt-"]),
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-purple-600"][class*="p-6"] *:not(svg):not([class*="gt-"]) {
  color: inherit;
}
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] h1,
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] h2,
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] h1,
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] h2,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] h1,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] h2,
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-purple-600"][class*="p-6"] h1,
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-purple-600"][class*="p-6"] h2 {
  color: var(--gt-text-primary) !important;
  font-family: var(--gt-font-display) !important;
}
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] h1 em,
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] h2 em,
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] h1 em,
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] h2 em,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] h1 em,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] h2 em {
  color: var(--gt-primary) !important;
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-weight: 500 !important;
}
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] .text-white,
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] .text-white,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] .text-white,
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-600"][class*="to-purple-600"][class*="p-6"] .text-white,
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-600"][class*="to-purple-600"][class*="p-6"] .text-white {
  color: var(--gt-text-primary) !important;
}
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] [class*="text-white/"],
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] [class*="text-white/"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] [class*="text-white/"] {
  color: var(--gt-text-tertiary) !important;
}
/* Inner translucent widgets in flat hero strips → solid theme card */
.gt-themed [class*="bg-gradient-to-"][class*="from-blue-500"][class*="to-indigo-600"][class*="p-6"] [class*="bg-white/"],
.gt-themed [class*="bg-gradient-to-"][class*="from-purple-500"][class*="to-pink-600"][class*="p-6"] [class*="bg-white/"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-500"][class*="to-purple-600"][class*="p-6"] [class*="bg-white/"],
.gt-themed [class*="bg-gradient-to-"][class*="from-indigo-600"][class*="to-purple-600"][class*="p-6"] [class*="bg-white/"] {
  background: var(--gt-surface-2) !important;
  border: 1px solid var(--gt-border) !important;
  color: var(--gt-text-primary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* Banner gradients → flat cream */
.gt-themed [class*="from-blue-50"][class*="to-indigo-50"],
.gt-themed [class*="from-blue-50"][class*="to-purple-50"],
.gt-themed [class*="from-indigo-50"][class*="to-purple-50"],
.gt-themed [class*="from-purple-50"][class*="to-pink-50"],
.gt-themed [class*="from-violet-50"][class*="to-pink-50"],
.gt-themed [class*="from-slate-50"][class*="to-blue-50"],
.gt-themed [class*="from-gray-50"][class*="to-gray-100"],
.gt-themed [class*="from-gray-50"][class*="to-white"][class*="to-gray-50"] {
  background: var(--gt-surface-1) !important;
  background-image: none !important;
}

/* Text-gradient titles → solid primary */
.gt-themed [class*="bg-clip-text"][class*="text-transparent"] {
  background: none !important;
  background-clip: initial !important;
  -webkit-text-fill-color: var(--gt-primary) !important;
  color: var(--gt-primary) !important;
  font-family: var(--gt-font-display);
  letter-spacing: -0.03em;
}

/* Emerald / green accents → primary */
.gt-themed .bg-emerald-500, .gt-themed .bg-green-500,
.gt-themed .bg-emerald-600, .gt-themed .bg-green-600,
.gt-themed .bg-teal-500, .gt-themed .bg-teal-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }
.gt-themed .text-emerald-500, .gt-themed .text-emerald-600,
.gt-themed .text-green-500, .gt-themed .text-green-600,
.gt-themed .text-teal-500, .gt-themed .text-teal-600 { color: var(--gt-primary) !important; }
.gt-themed .bg-emerald-50, .gt-themed .bg-green-50, .gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-emerald-100, .gt-themed .bg-green-100, .gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; }
.gt-themed .text-emerald-700, .gt-themed .text-green-700, .gt-themed .text-emerald-800, .gt-themed .text-teal-700 { color: var(--gt-primary-deep) !important; }

/* Inputs auto-style */
.gt-themed input[type="text"]:not([class*="gt-"]),
.gt-themed input[type="email"]:not([class*="gt-"]),
.gt-themed input[type="number"]:not([class*="gt-"]),
.gt-themed input[type="search"]:not([class*="gt-"]),
.gt-themed input[type="tel"]:not([class*="gt-"]),
.gt-themed input[type="url"]:not([class*="gt-"]),
.gt-themed input[type="date"]:not([class*="gt-"]),
.gt-themed input[type="time"]:not([class*="gt-"]),
.gt-themed input[type="datetime-local"]:not([class*="gt-"]),
.gt-themed textarea:not([class*="gt-"]),
.gt-themed select:not([class*="gt-"]) {
  background: var(--gt-surface-0);
  border-color: var(--gt-border);
  color: var(--gt-text-primary);
  font-family: var(--gt-font);
  border-radius: var(--gt-radius-input);
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);
}
.gt-themed input:not([class*="gt-"]):focus,
.gt-themed textarea:not([class*="gt-"]):focus,
.gt-themed select:not([class*="gt-"]):focus {
  border-color: var(--gt-primary) !important;
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);
}

/* Themed scrollbars */
.gt-themed *::-webkit-scrollbar { width: 10px; height: 10px; }
.gt-themed *::-webkit-scrollbar-track { background: transparent; }
.gt-themed *::-webkit-scrollbar-thumb { background: var(--gt-border-strong); border-radius: 9999px; border: 2px solid transparent; background-clip: padding-box; }
.gt-themed *::-webkit-scrollbar-thumb:hover { background: var(--gt-primary); background-clip: padding-box; }
.gt-themed { scrollbar-color: var(--gt-border-strong) transparent; scrollbar-width: thin; }

/* ──────────────────────────────────────────────────────────────────────────
   PROJECT-WIDE THEMING — applied via the global gt-themed wrapper so every
   page inherits the task-management aesthetic without rewrites.
   ──────────────────────────────────────────────────────────────────────── */

/* Typography — all headings use display font with refined tracking */
.gt-themed,
.gt-themed p,
.gt-themed span,
.gt-themed div,
.gt-themed label,
.gt-themed li,
.gt-themed td,
.gt-themed th { font-family: var(--gt-font); }

.gt-themed h1, .gt-themed h2, .gt-themed h3,
.gt-themed h4, .gt-themed h5, .gt-themed h6 {
  font-family: var(--gt-font-display);
  color: var(--gt-text-primary);
  letter-spacing: -0.02em;
  font-weight: 700;
}
.gt-themed h1 { font-size: clamp(1.75rem, 1.2rem + 1.6vw, 2.25rem); line-height: 1.1; letter-spacing: -0.03em; font-weight: 800; }
.gt-themed h2 { font-size: 1.5rem;  line-height: 1.2; }
.gt-themed h3 { font-size: 1.25rem; line-height: 1.25; }
.gt-themed h4 { font-size: 1.05rem; line-height: 1.3; }
/* ──────────────────────────────────────────────────────────────────────
   Fraunces serif italic — applied globally for editorial accents.
   Covers <em>, <i>, <cite>, <q>, <blockquote>, <figcaption>, <address>,
   form <label> elements, table caption, and any element marked
   .gt-serif-italic / .serif-italic / .italic-accent.
   These rules apply project-wide because <body> carries .gt-themed.
   ────────────────────────────────────────────────────────────────────── */
.gt-themed em,
.gt-themed i,
.gt-themed cite,
.gt-themed q,
.gt-themed blockquote,
.gt-themed figcaption,
.gt-themed address,
.gt-themed caption,
.gt-themed dfn,
.gt-themed .gt-serif-italic,
.gt-themed .serif-italic,
.gt-themed .italic-accent,
.gt-themed h1 em, .gt-themed h2 em, .gt-themed h3 em, .gt-themed h4 em,
.gt-themed h1 i,  .gt-themed h2 i,  .gt-themed h3 i,  .gt-themed h4 i {
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-feature-settings: 'ss01', 'ss03';
}

/* Form labels use Fraunces italic for editorial polish */
.gt-themed label,
.gt-themed legend,
.gt-themed .form-label,
.gt-themed .gt-field-label-italic {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 500;
  color: var(--gt-text-secondary);
  letter-spacing: 0.005em;
}

/* Modal / dialog titles get a subtle italic accent on every <em> they contain */
.gt-themed [role="dialog"] h1 em,
.gt-themed [role="dialog"] h2 em,
.gt-themed [role="dialog"] h3 em,
.gt-themed [role="dialog"] h4 em,
.gt-themed [role="dialog"] em {
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-weight: 600;
  color: var(--gt-primary);
}
.gt-themed strong, .gt-themed b { font-weight: 700; color: var(--gt-text-primary); }
.gt-themed code, .gt-themed pre { font-family: var(--gt-font-mono); }

/* Links pick up theme primary */
.gt-themed a:not(.gt-btn):not([class*="text-"]) {
  color: var(--gt-text-link);
  transition: color var(--gt-t-fast);
}
.gt-themed a:not(.gt-btn):not([class*="text-"]):hover { color: var(--gt-primary-hover); }

/* Generic card-like containers — any white rounded surface picks up the soft
   theme card look unless it already declares an explicit border. */
.gt-themed .bg-white.rounded-xl,
.gt-themed .bg-white.rounded-2xl,
.gt-themed .bg-white.rounded-3xl,
.gt-themed .bg-white.shadow,
.gt-themed .bg-white.shadow-sm,
.gt-themed .bg-white.shadow-md,
.gt-themed .bg-white.shadow-lg,
.gt-themed .bg-white.shadow-xl {
  background: var(--gt-surface-0) !important;
  border: 1px solid var(--gt-border) !important;
  box-shadow: var(--gt-elev-1) !important;
  border-radius: var(--gt-radius-card) !important;
}

/* Bare buttons (no styling class) get the soft theme look */
.gt-themed button:not([class*="bg-"]):not([class*="gt-"]):not([class*="gc-"]):not([class*="rounded"]):not([class*="cm-"]):not(:disabled) {
  font-family: var(--gt-font-display);
  font-weight: 600;
  color: var(--gt-text-primary);
  transition: color var(--gt-t-fast), background var(--gt-t-fast);
}

/* shadcn-style class overrides (bg-card / bg-muted / bg-popover etc.) */
.gt-themed .bg-card        { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }
.gt-themed .bg-popover     { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }
.gt-themed .bg-muted       { background-color: var(--gt-surface-2) !important; }
.gt-themed .bg-accent      { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }
.gt-themed .bg-secondary   { background-color: var(--gt-surface-2) !important; }
.gt-themed .bg-primary     { background-color: var(--gt-primary) !important; color: var(--gt-on-primary) !important; }
.gt-themed .bg-destructive { background-color: var(--gt-dnd) !important; color: #ffffff !important; }
.gt-themed .bg-background  { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-foreground  { background-color: var(--gt-text-primary) !important; }

.gt-themed .text-primary       { color: var(--gt-primary) !important; }
.gt-themed .text-primary-foreground { color: var(--gt-on-primary) !important; }
.gt-themed .text-muted-foreground   { color: var(--gt-text-tertiary) !important; }
.gt-themed .text-card-foreground    { color: var(--gt-text-primary) !important; }
.gt-themed .text-popover-foreground { color: var(--gt-text-primary) !important; }
.gt-themed .text-foreground         { color: var(--gt-text-primary) !important; }
.gt-themed .text-secondary-foreground { color: var(--gt-text-primary) !important; }
.gt-themed .text-accent-foreground  { color: var(--gt-primary-deep) !important; }
.gt-themed .text-destructive        { color: var(--gt-dnd) !important; }

.gt-themed .border-border { border-color: var(--gt-border) !important; }
.gt-themed .border-input  { border-color: var(--gt-border) !important; }
.gt-themed .border-primary { border-color: var(--gt-primary) !important; }

/* Tailwind ring tokens used by shadcn focus rings */
.gt-themed .ring-ring,
.gt-themed .focus\\:ring-ring:focus { --tw-ring-color: var(--gt-primary) !important; }

/* Tables — subtle theme defaults */
.gt-themed table { font-family: var(--gt-font); color: var(--gt-text-primary); }

.gt-themed .pr-table thead th,
.gt-shell .pr-table thead th,
.pr-table thead th {
  white-space: nowrap;
  overflow-wrap: normal;
  word-break: normal;
  vertical-align: middle;
}

.gt-sticky-table-wrap {
  position: relative;
  overflow: auto;
  max-height: 70vh;
}

.gt-sticky-table {
  border-collapse: separate;
  border-spacing: 0;
}

.gt-sticky-table thead th {
  position: sticky;
  top: 0;
  z-index: 6;
  background: var(--gt-surface-1, #f8fafc);
}

.gt-sticky-table .gt-sticky-col {
  position: sticky;
  left: 0;
  z-index: 5;
  background: var(--gt-surface-0, #ffffff);
  box-shadow: 1px 0 0 var(--gt-border, #e5e7eb);
}

.gt-sticky-table thead .gt-sticky-col {
  z-index: 8;
  background: var(--gt-surface-1, #f8fafc);
}

.gt-sticky-table .gt-sticky-col-select {
  left: 0;
  width: 48px;
  min-width: 48px;
}

.gt-sticky-table .gt-sticky-col-after-select {
  left: 48px;
}

.gt-sticky-table tbody tr:hover .gt-sticky-col {
  background: var(--gt-surface-1, #f8fafc);
}
.gt-attendance-table thead th {
  color: var(--gt-text-secondary) !important;
  background: var(--gt-surface-2, #f8fafc) !important;
}
.gt-attendance-table tbody td {
  color: var(--gt-text-secondary);
}
.gt-attendance-table tbody .gt-sticky-col {
  background: transparent !important;
  box-shadow: none;
}
.gt-attendance-table tbody tr:hover .gt-sticky-col {
  background: transparent !important;
}
.gt-attendance-detail-row:hover {
  background-color: rgba(255, 255, 255, 0.055) !important;
}
.gt-attendance-detail-row.is-clickable:hover {
  background-color: rgba(16, 185, 129, 0.12) !important;
}
.gt-attendance-employee-name {
  color: var(--gt-text-primary) !important;
}
.gt-attendance-employee-code {
  color: var(--gt-text-tertiary) !important;
}
.gt-att-pill,
.gt-att-summary {
  border-style: solid !important;
  border-width: 1px !important;
  font-weight: 700 !important;
}
.gt-att-pill.gt-att-pill--present,
.gt-att-pill.gt-att-pill--present.bg-green-100,
.gt-att-summary.gt-att-summary--present,
.gt-att-summary.gt-att-summary--present.bg-green-100 {
  background-color: #d8f5e6 !important;
  color: #064e2b !important;
  border-color: #86efac !important;
}
.gt-att-pill.gt-att-pill--leave,
.gt-att-pill.gt-att-pill--leave.bg-amber-100,
.gt-att-summary.gt-att-summary--leave,
.gt-att-summary.gt-att-summary--leave.bg-amber-100 {
  background-color: #fef3c7 !important;
  color: #713f12 !important;
  border-color: #facc15 !important;
}
.gt-att-pill.gt-att-pill--absent,
.gt-att-pill.gt-att-pill--absent.bg-red-100,
.gt-att-summary.gt-att-summary--absent,
.gt-att-summary.gt-att-summary--absent.bg-red-100 {
  background-color: #fee2e2 !important;
  color: #7f1d1d !important;
  border-color: #fca5a5 !important;
}
.gt-att-summary.gt-att-summary--total,
.gt-att-summary.gt-att-summary--total.bg-blue-100 {
  background-color: #dbeafe !important;
  color: #1e3a8a !important;
  border-color: #93c5fd !important;
}
[data-theme="dark"] .gt-attendance-table thead th {
  color: #d6d6d6 !important;
}
[data-theme="dark"] .gt-attendance-employee-code {
  color: #ababab !important;
}
.gt-themed thead th {
  font-family: var(--gt-font-display);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  border-bottom: 1px solid var(--gt-border);
}
.gt-themed tbody tr { border-bottom: 1px solid var(--gt-divider); }
.gt-themed tbody tr:hover { background: var(--gt-surface-hover); }

/* Remove leftover backdrop-filter blur on visible UI inside themed regions */
.gt-themed [class*="backdrop-blur"]:not([class*="bg-black"]) {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* ──────────────────────────────────────────────────────────────────────
   GLOBAL MODAL THEMING — covers portaled modals that render at body level.
   Body carries the .gt-themed class (set by useTheme hook), so all the
   project-wide rules above also apply to dialogs/sheets/popovers. These
   extra rules tighten common modal patterns.
   ────────────────────────────────────────────────────────────────────── */

/* Modal scrims — soft dim, subtle blur, no aurora */
.gt-themed .fixed.inset-0[class*="bg-black"],
body > [data-radix-portal] [class*="bg-black/"],
body > [role="dialog"] + .fixed.inset-0,
.gt-themed [data-state="open"][class*="bg-black"] {
  background: rgba(20, 20, 18, 0.40) !important;
  backdrop-filter: blur(4px) !important;
  -webkit-backdrop-filter: blur(4px) !important;
}

/* Dialog/sheet content surfaces — cream card with theme border + shadow */
.gt-themed [role="dialog"]:not(.gt-modal):not([class*="gt-"]),
.gt-themed [data-radix-dialog-content],
.gt-themed [data-radix-popover-content],
.gt-themed [data-radix-dropdown-menu-content],
.gt-themed [data-radix-context-menu-content],
.gt-themed [data-radix-hover-card-content],
.gt-themed [data-radix-tooltip-content],
.gt-themed [data-state="open"][role="menu"],
.gt-themed [data-state="open"][role="listbox"] {
  background: var(--gt-surface-0) !important;
  color: var(--gt-text-primary) !important;
  border: 1px solid var(--gt-border) !important;
  border-radius: var(--gt-radius-modal) !important;
  box-shadow: var(--gt-elev-4) !important;
  font-family: var(--gt-font) !important;
}

/* Tooltip is smaller — keep tighter */
.gt-themed [data-radix-tooltip-content] {
  font-size: 11.5px !important;
  padding: 6px 10px !important;
  border-radius: 8px !important;
  box-shadow: var(--gt-elev-3) !important;
}

/* Modal headings */
.gt-themed [role="dialog"] h1,
.gt-themed [role="dialog"] h2,
.gt-themed [role="dialog"] h3,
.gt-themed [role="dialog"] h4 {
  font-family: var(--gt-font-display);
  color: var(--gt-text-primary);
  letter-spacing: -0.02em;
}

/* Modal body text */
.gt-themed [role="dialog"] p,
.gt-themed [role="dialog"] label { color: var(--gt-text-secondary); }

/* Modal divider lines — subtle theme divider */
.gt-themed [role="dialog"] hr,
.gt-themed [role="dialog"] [class*="border-t"],
.gt-themed [role="dialog"] [class*="border-b"] {
  border-color: var(--gt-divider) !important;
}

/* Modal action buttons — bare submit/save buttons get theme primary */
.gt-themed [role="dialog"] button[type="submit"]:not([class*="bg-"]):not([class*="gt-"]),
.gt-themed form button[type="submit"]:not([class*="bg-"]):not([class*="gt-"]) {
  background: var(--gt-primary) !important;
  color: var(--gt-on-primary) !important;
  border: 1px solid transparent !important;
  border-radius: var(--gt-radius-pill) !important;
  padding: 9px 18px !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  cursor: pointer !important;
  transition: background var(--gt-t-fast) !important;
}
.gt-themed [role="dialog"] button[type="submit"]:not([class*="bg-"]):not([class*="gt-"]):hover,
.gt-themed form button[type="submit"]:not([class*="bg-"]):not([class*="gt-"]):hover {
  background: var(--gt-primary-hover) !important;
}

/* Modal close (X) icon button — soft cream with theme hover */
.gt-themed [role="dialog"] button[aria-label*="close" i]:not([class*="gt-"]),
.gt-themed [role="dialog"] button[aria-label*="Close" i]:not([class*="gt-"]) {
  color: var(--gt-text-tertiary) !important;
  background: transparent !important;
  border-radius: 10px !important;
  transition: background var(--gt-t-fast), color var(--gt-t-fast) !important;
}
.gt-themed [role="dialog"] button[aria-label*="close" i]:not([class*="gt-"]):hover,
.gt-themed [role="dialog"] button[aria-label*="Close" i]:not([class*="gt-"]):hover {
  background: var(--gt-surface-2) !important;
  color: var(--gt-text-primary) !important;
}

/* Inputs / selects / textareas inside modals — pick up theme styles */
.gt-themed [role="dialog"] input:not([type="checkbox"]):not([type="radio"]):not([class*="gt-"]),
.gt-themed [role="dialog"] textarea:not([class*="gt-"]),
.gt-themed [role="dialog"] select:not([class*="gt-"]) {
  background: var(--gt-surface-0) !important;
  border: 1px solid var(--gt-border) !important;
  color: var(--gt-text-primary) !important;
  border-radius: var(--gt-radius-input) !important;
  font-family: var(--gt-font) !important;
  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast) !important;
}
.gt-themed [role="dialog"] input:focus:not([class*="gt-"]),
.gt-themed [role="dialog"] textarea:focus:not([class*="gt-"]),
.gt-themed [role="dialog"] select:focus:not([class*="gt-"]) {
  border-color: var(--gt-primary) !important;
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important;
}

/* ──────────────────────────────────────────────────────────────────────
   DASHBOARD & GENERAL PAGE THEMING — covers translucent cards, colored
   100-tone backgrounds, and any leftover glass-y patterns project-wide.
   ────────────────────────────────────────────────────────────────────── */

/* Kill translucent white "glass" cards (bg-white/80, /70, /50, /60 …) */
.gt-themed [class*="bg-white/"],
.gt-themed .bg-white\\/80,
.gt-themed .bg-white\\/70,
.gt-themed .bg-white\\/60,
.gt-themed .bg-white\\/50,
.gt-themed .bg-white\\/40,
.gt-themed .bg-white\\/30 {
  background-color: var(--gt-surface-0) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* Kill all backdrop-blur on visible chrome (modal scrims keep theirs) */
.gt-themed .backdrop-blur,
.gt-themed .backdrop-blur-sm,
.gt-themed .backdrop-blur-md,
.gt-themed .backdrop-blur-lg,
.gt-themed .backdrop-blur-xl {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* Color-100 soft backgrounds → soft theme tints */
.gt-themed .bg-green-100,
.gt-themed .bg-emerald-100,
.gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }
.gt-themed .bg-red-100   { background-color: var(--gt-prio-urgent-bg) !important; color: var(--gt-prio-urgent-fg) !important; }
.gt-themed .bg-orange-100,
.gt-themed .bg-amber-100,
.gt-themed .bg-yellow-100 { background-color: var(--gt-prio-high-bg) !important; color: var(--gt-prio-high-fg) !important; }

/* Color-200 borders */
.gt-themed .border-green-200,
.gt-themed .border-emerald-200,
.gt-themed .border-teal-200 { border-color: var(--gt-accent-soft) !important; }
.gt-themed .border-red-200    { border-color: rgba(220, 38, 38, 0.25) !important; }
.gt-themed .border-orange-200,
.gt-themed .border-amber-200,
.gt-themed .border-yellow-200 { border-color: rgba(217, 119, 6, 0.25) !important; }

/* Color-50 backgrounds */
.gt-themed .bg-green-50,
.gt-themed .bg-emerald-50,
.gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-red-50    { background-color: var(--gt-prio-urgent-bg) !important; }
.gt-themed .bg-orange-50,
.gt-themed .bg-amber-50,
.gt-themed .bg-yellow-50 { background-color: var(--gt-prio-med-bg) !important; }

/* Color text 600 */
.gt-themed .text-red-600,
.gt-themed .text-red-500    { color: var(--gt-prio-urgent-fg) !important; }
.gt-themed .text-orange-600,
.gt-themed .text-orange-500,
.gt-themed .text-amber-600,
.gt-themed .text-yellow-600 { color: var(--gt-prio-high-fg) !important; }

/* Neutral page-wrapper gradients (gray/slate/stone/neutral/zinc) → flat cream.
   These are page backgrounds, not hero strips — keep them light. */
.gt-themed [class*="from-gray-"][class*="via-gray-"],
.gt-themed [class*="from-slate-"][class*="via-slate-"],
.gt-themed [class*="from-stone-"][class*="via-stone-"],
.gt-themed [class*="from-neutral-"][class*="via-neutral-"],
.gt-themed [class*="from-zinc-"][class*="via-zinc-"],
.gt-themed [class*="from-gray-50"],
.gt-themed [class*="from-gray-100"],
.gt-themed [class*="from-slate-50"],
.gt-themed [class*="from-slate-100"] {
  background: var(--gt-surface-1) !important;
  background-image: none !important;
  color: var(--gt-text-primary) !important;
  box-shadow: none !important;
}

/* White-card wrappers that exist solely to frame a saturated hero gradient
   (e.g. PayrollRecord's \`bg-white shadow-xl rounded-2xl overflow-hidden\`
   wrapping \`bg-gradient-to-r via-purple-600\`) — dissolve into the page
   surface so the page reads flat like the Task Management pattern.
   Uses :has() (Chrome 105+, Safari 15.4+, Firefox 121+). */
.gt-themed [class*="bg-white"][class*="rounded-2xl"]:has(> [class*="bg-gradient-to-r"][class*="via-"]),
.gt-themed [class*="bg-white"][class*="rounded-2xl"]:has(> [class*="bg-gradient-to-br"][class*="via-"]),
.gt-themed [class*="bg-white"][class*="rounded-3xl"]:has(> [class*="bg-gradient-to-r"][class*="via-"]),
.gt-themed [class*="bg-white"][class*="rounded-xl"]:has(> [class*="bg-gradient-to-r"][class*="via-"]) {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  overflow: visible !important;
  border: 0 !important;
}

/* Generic page-frame cards: a width-constrained \`max-w-* mx-auto bg-white
   shadow-* rounded-*\` outer wrapper used as the page's only visual container
   (e.g. PayrollSetting, AddPayroll, changepass). Flatten so the content sits
   directly on the cream page surface like every other themed page. */
.gt-themed [class*="max-w-"][class*="mx-auto"][class*="bg-white"][class*="shadow-xl"][class*="rounded-2xl"],
.gt-themed [class*="max-w-"][class*="mx-auto"][class*="bg-white"][class*="shadow-2xl"][class*="rounded-2xl"],
.gt-themed [class*="max-w-"][class*="mx-auto"][class*="bg-white"][class*="shadow-lg"][class*="rounded-2xl"],
.gt-themed [class*="max-w-"][class*="mx-auto"][class*="bg-white"][class*="shadow-xl"][class*="rounded-3xl"],
.gt-themed [class*="max-w-"][class*="mx-auto"][class*="bg-white"][class*="shadow-2xl"][class*="rounded-3xl"] {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: 0 !important;
  padding-left: clamp(16px, 3vw, 28px) !important;
  padding-right: clamp(16px, 3vw, 28px) !important;
}

/* Centered-title pattern: a lone \`text-center\` heading at the top of a page
   (no eyebrow, no subtitle) — left-align so it matches the editorial Task
   Management header pattern across the entire app. */
.gt-themed h1[class*="text-center"]:not([class*="bg-clip"]),
.gt-themed h2[class*="text-center"]:not([class*="bg-clip"]) {
  text-align: left !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 700 !important;
  letter-spacing: -0.025em !important;
  color: var(--gt-text-primary) !important;
  font-size: clamp(28px, 3.2vw, 40px) !important;
  line-height: 1.1 !important;
}
.gt-themed h1[class*="text-center"] em,
.gt-themed h1[class*="text-center"] i,
.gt-themed h2[class*="text-center"] em,
.gt-themed h2[class*="text-center"] i {
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-weight: 500 !important;
  color: var(--gt-primary) !important;
  letter-spacing: 0 !important;
}

/* Subtle inner-tinted sections (\`bg-gradient-to-br from-gray-50 to-white\`
   etc.) used as form-card backgrounds inside flattened wrappers — keep flat
   theme surface so they don't reintroduce visual containers */
.gt-themed [class*="bg-gradient-to-br"][class*="from-gray-50"][class*="to-white"],
.gt-themed [class*="bg-gradient-to-br"][class*="from-slate-50"][class*="to-white"],
.gt-themed [class*="bg-gradient-to-r"][class*="from-gray-50"][class*="to-white"] {
  background: transparent !important;
  background-image: none !important;
}

/* Saturated hero gradients (multi-stop with via- and SATURATED color stops
   like 500/600/700 blues, purples, cyans, indigos, pinks) → FLATTEN entirely.
   Per global design rule: every page header should look like the Task module
   pattern (eyebrow + title + subtitle on cream surface, no colored box). */
.gt-themed [class*="bg-gradient-to-r"][class*="via-purple-600"],
.gt-themed [class*="bg-gradient-to-r"][class*="via-purple-500"],
.gt-themed [class*="bg-gradient-to-r"][class*="via-blue-600"],
.gt-themed [class*="bg-gradient-to-r"][class*="via-indigo-600"],
.gt-themed [class*="bg-gradient-to-r"][class*="via-pink-500"],
.gt-themed [class*="bg-gradient-to-r"][class*="via-cyan-600"],
.gt-themed [class*="bg-gradient-to-br"][class*="via-purple-600"],
.gt-themed [class*="bg-gradient-to-br"][class*="via-blue-600"],
.gt-themed [class*="bg-gradient-to-br"][class*="via-indigo-600"],
.gt-themed [class*="bg-gradient-to-l"][class*="via-purple-600"],
.gt-themed [class*="bg-gradient-to-l"][class*="via-blue-600"] {
  background: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Heading inside a flattened hero gets the proper page-title treatment so
   it reads as editorial type, not a box label. */
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] h1,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] h1,
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] h1 {
  color: var(--gt-text-primary) !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 700 !important;
  font-size: clamp(28px, 3.2vw, 40px) !important;
  letter-spacing: -0.025em !important;
  line-height: 1.1 !important;
  margin: 0 !important;
}
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] h1 em,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] h1 i,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] h1 em,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] h1 i,
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] h1 em,
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] h1 i {
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-weight: 500 !important;
  color: var(--gt-primary) !important;
  letter-spacing: 0 !important;
}

.gt-themed [class*="bg-gradient-to-r"][class*="via-"] h2,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] h2 {
  color: var(--gt-text-primary) !important;
  font-family: var(--gt-font-display) !important;
}
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] p,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] p {
  color: var(--gt-text-tertiary) !important;
  font-family: var(--gt-font) !important;
}
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] span:not([class*="bg-"]),
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] span:not([class*="bg-"]) {
  color: inherit !important;
}

/* Translucent inner widgets that used to live on a dark hero (e.g. bg-white/10)
   become subtle theme cards on the flat surface */
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] [class*="bg-white/"],
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] [class*="bg-white/"],
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] [class*="bg-white/"] {
  background: var(--gt-surface-0) !important;
  border: 1px solid var(--gt-border) !important;
  border-radius: var(--gt-radius-card) !important;
  color: var(--gt-text-primary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  box-shadow: var(--gt-elev-1) !important;
}
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] [class*="bg-white/"] *,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] [class*="bg-white/"] *,
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] [class*="bg-white/"] * {
  color: var(--gt-text-primary) !important;
}

/* Gradient-text headings (bg-gradient + bg-clip-text + text-transparent on
   an h1/h2/h3) are a common AI-slop pattern. Flatten globally — heading
   becomes solid theme-primary text. The useTitleAccent hook still wraps the
   last word in <em> so the editorial italic accent appears as designed. */
.gt-themed h1[class*="bg-clip-text"],
.gt-themed h2[class*="bg-clip-text"],
.gt-themed h3[class*="bg-clip-text"],
.gt-themed h1[class*="text-transparent"][class*="bg-gradient"],
.gt-themed h2[class*="text-transparent"][class*="bg-gradient"],
.gt-themed h3[class*="text-transparent"][class*="bg-gradient"],
.gt-themed [class*="bg-clip-text"][class*="text-transparent"] {
  background: none !important;
  background-clip: initial !important;
  -webkit-background-clip: initial !important;
  -webkit-text-fill-color: var(--gt-text-primary) !important;
  color: var(--gt-text-primary) !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 700 !important;
  letter-spacing: -0.025em !important;
}
.gt-themed h1[class*="bg-clip-text"] em,
.gt-themed h1[class*="bg-clip-text"] i,
.gt-themed h2[class*="bg-clip-text"] em,
.gt-themed h2[class*="bg-clip-text"] i,
.gt-themed h1[class*="text-transparent"][class*="bg-gradient"] em,
.gt-themed h1[class*="text-transparent"][class*="bg-gradient"] i,
.gt-themed h2[class*="text-transparent"][class*="bg-gradient"] em,
.gt-themed h2[class*="text-transparent"][class*="bg-gradient"] i {
  font-family: var(--gt-font-serif) !important;
  font-style: italic !important;
  font-weight: 500 !important;
  color: var(--gt-primary) !important;
  -webkit-text-fill-color: var(--gt-primary) !important;
  letter-spacing: 0 !important;
}

/* Inside a flattened gradient hero, white/tinted-white text becomes muted
   secondary text so it reads on the new cream surface. Outside heroes,
   .text-white retains its original white (for legitimate dark buttons). */
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-white,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] .text-white,
.gt-themed [class*="bg-gradient-to-l"][class*="via-"] .text-white {
  color: var(--gt-text-primary) !important;
}
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-blue-100,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-indigo-100,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-indigo-200,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-purple-100,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-purple-200,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-pink-100,
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-cyan-100,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] .text-blue-100,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] .text-indigo-100,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] .text-purple-100 {
  color: var(--gt-text-tertiary) !important;
}

/* Icons that used text-white inside the now-flat hero need a theme color too */
.gt-themed [class*="bg-gradient-to-r"][class*="via-"] .text-white svg,
.gt-themed [class*="bg-gradient-to-br"][class*="via-"] .text-white svg {
  color: var(--gt-primary) !important;
}

/* Loading spinners using border-blue → theme primary */
.gt-themed .border-b-2.border-blue-600,
.gt-themed .border-blue-600.rounded-full,
.gt-themed .animate-spin.border-blue-600 { border-color: var(--gt-primary) !important; border-bottom-color: transparent !important; }

/* Hover scale on cards stays subtle */
.gt-themed [class*="hover:scale-1"]:hover {
  box-shadow: var(--gt-elev-3) !important;
}

/* Soft duo-gradient stat cards (e.g. from-blue-50 to-blue-100) → cream card
   with theme border + subtle shadow + smooth hover */
.gt-themed [class*="from-blue-50"][class*="to-blue-100"],
.gt-themed [class*="from-green-50"][class*="to-green-100"],
.gt-themed [class*="from-emerald-50"][class*="to-emerald-100"],
.gt-themed [class*="from-red-50"][class*="to-red-100"],
.gt-themed [class*="from-orange-50"][class*="to-orange-100"],
.gt-themed [class*="from-amber-50"][class*="to-amber-100"],
.gt-themed [class*="from-yellow-50"][class*="to-yellow-100"],
.gt-themed [class*="from-purple-50"][class*="to-purple-100"],
.gt-themed [class*="from-violet-50"][class*="to-violet-100"],
.gt-themed [class*="from-indigo-50"][class*="to-indigo-100"],
.gt-themed [class*="from-pink-50"][class*="to-pink-100"],
.gt-themed [class*="from-cyan-50"][class*="to-cyan-100"],
.gt-themed [class*="from-teal-50"][class*="to-teal-100"] {
  background: var(--gt-surface-0) !important;
  background-image: none !important;
  border: 1px solid var(--gt-border) !important;
  box-shadow: var(--gt-elev-1) !important;
  border-radius: var(--gt-radius-card) !important;
  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid), transform var(--gt-t-mid) !important;
}
.gt-themed [class*="from-blue-50"][class*="to-blue-100"]:hover,
.gt-themed [class*="from-green-50"][class*="to-green-100"]:hover,
.gt-themed [class*="from-red-50"][class*="to-red-100"]:hover,
.gt-themed [class*="from-purple-50"][class*="to-purple-100"]:hover {
  border-color: var(--gt-border-strong) !important;
  box-shadow: var(--gt-elev-2) !important;
}

/* ──────────────────────────────────────────────────────────────────────
   UNIVERSAL ANIMATION & MICRO-INTERACTION POLISH
   Applied broadly inside .gt-themed for consistency with task module.
   ────────────────────────────────────────────────────────────────────── */

/* Smooth transitions on any interactive surface */
.gt-themed button,
.gt-themed a,
.gt-themed [role="button"],
.gt-themed [role="menuitem"],
.gt-themed [role="option"],
.gt-themed [role="tab"] {
  transition:
    background-color var(--gt-t-fast),
    color var(--gt-t-fast),
    border-color var(--gt-t-fast),
    box-shadow var(--gt-t-fast),
    transform var(--gt-t-fast),
    opacity var(--gt-t-fast);
}

/* Subtle press feedback on any button */
.gt-themed button:active:not(:disabled),
.gt-themed [role="button"]:active:not([aria-disabled="true"]) {
  transform: translateY(0.5px);
}

/* Page mount fade — applied to common page wrapper patterns */
.gt-themed > main > div > div,
.gt-themed [class*="space-y-"] {
  animation: gt-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both;
}

/* Subtle elevation hop on shadcn Cards */
.gt-themed [class*="rounded-xl"][class*="shadow"]:hover,
.gt-themed [class*="rounded-2xl"][class*="shadow"]:hover,
.gt-themed [class*="rounded-3xl"][class*="shadow"]:hover {
  box-shadow: var(--gt-elev-3) !important;
}

/* Dropdown / menu / popover animation */
.gt-themed [data-state="open"][role="menu"],
.gt-themed [data-state="open"][role="listbox"],
.gt-themed [data-radix-popover-content][data-state="open"],
.gt-themed [data-radix-dropdown-menu-content][data-state="open"],
.gt-themed [data-radix-context-menu-content][data-state="open"],
.gt-themed [data-radix-hover-card-content][data-state="open"] {
  animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;
}

/* Tab underline animation */
.gt-themed [role="tablist"] [role="tab"][data-state="active"],
.gt-themed [role="tablist"] [role="tab"][aria-selected="true"] {
  border-bottom: 2px solid var(--gt-primary) !important;
  color: var(--gt-primary) !important;
  font-weight: 700;
}

/* Icon-button hover ring */
.gt-themed button > svg:only-child,
.gt-themed [role="button"] > svg:only-child {
  transition: transform var(--gt-t-fast), color var(--gt-t-fast);
}

/* Toast / notification surfaces (sonner, react-hot-toast etc.) */
.gt-themed [data-sonner-toast],
.gt-themed [class*="Toastify__toast"],
.gt-themed [role="status"][class*="rounded"] {
  background: var(--gt-surface-0) !important;
  color: var(--gt-text-primary) !important;
  border: 1px solid var(--gt-border) !important;
  border-radius: var(--gt-radius-card) !important;
  box-shadow: var(--gt-elev-3) !important;
  font-family: var(--gt-font) !important;
}
/* Sonner action buttons ("Undo", "Open planner"): the generic
   \`.gt-themed button\` colour rule would paint their label the same ink as
   their solid background, hiding it. Give them the theme's primary pill. */
.gt-themed [data-sonner-toast] button[data-button] {
  background: var(--gt-primary) !important;
  color: var(--gt-on-primary, #ffffff) !important;
  border-radius: var(--gt-radius-pill) !important;
  font-weight: 600;
}
.gt-themed [data-sonner-toast] button[data-button]:hover {
  background: var(--gt-primary-hover) !important;
}

/* ============================================================ */
/* Task Management component classes (.gt-*)                    */
/* Merged from src/pages/Task/theme/tokens.css                  */
/* ============================================================ */

@media (prefers-reduced-motion: reduce) {
  :root {
    --gt-t-fast: 0ms;
    --gt-t-mid: 0ms;
    --gt-t-slow: 0ms;
  }
}

/* ──────────────────────────────────────────────────────────────────────
   Page shell — transparent so the unified warm-paper backdrop on
   .gt-app-shell (sage gradient + print-press grain) shows through to
   every page (tasks, calendar, todo, reports).
   ────────────────────────────────────────────────────────────────────── */
.gt-shell {
  position: relative;
  min-height: 100%;
  background: transparent;
  color: var(--gt-text-primary);
  font-family: var(--gt-font);
}
.gt-shell::before { content: none; }
.gt-shell > * { position: relative; z-index: 1; }

/* ── Display / eyebrow / serif accents ─────────────────────────────── */
.gt-display {
  font-family: var(--gt-font-display);
  letter-spacing: var(--gt-letter-display);
  font-weight: 700;
}
.gt-eyebrow {
  font-family: var(--gt-font-display);
  letter-spacing: var(--gt-letter-eyebrow);
  text-transform: uppercase;
  font-size: 10.5px;
  font-weight: 700;
  color: var(--gt-text-tertiary);
}
.gt-serif-italic {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-feature-settings: 'ss01', 'ss03';
}
.gt-numerals { font-feature-settings: 'tnum' 1, 'lnum' 1; }

/* Editorial leaf glyph — solid forest */
.gt-leaf {
  display: inline-block;
  width: 9px; height: 9px;
  background: var(--gt-primary);
  border-radius: 100% 0 100% 0;
  transform: rotate(-15deg);
  flex-shrink: 0;
}
.gt-rule {
  height: 1px;
  background: var(--gt-divider);
}

/* Page title — solid ink + serif italic emphasis */
.gt-page-title {
  font-family: var(--gt-font-display);
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.05;
  color: var(--gt-text-primary);
  font-size: clamp(1.95rem, 1.4rem + 2vw, 2.85rem);
}
.gt-page-title em {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 600;
  background: none;
  background-clip: initial;
  -webkit-text-fill-color: currentColor;
  color: var(--gt-primary);
  filter: none;
}
@keyframes gt-gradient-shift {
  0%, 100% { background-position: 0% 50%; }
  50%      { background-position: 100% 50%; }
}
.gt-page-sub {
  font-family: var(--gt-font);
  color: var(--gt-text-tertiary);
  font-size: 13.5px;
  letter-spacing: 0.005em;
}

/* ── Cards — clean cream with soft border ────────────────────────── */
.gt-card {
  position: relative;
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  box-shadow: var(--gt-elev-1);
  transition:
    border-color var(--gt-t-fast),
    box-shadow var(--gt-t-fast),
    transform var(--gt-t-fast),
    background var(--gt-t-fast);
}
.gt-card::before { content: none; }
.gt-card > * { position: relative; }
.gt-card:hover {
  border-color: var(--gt-border-strong);
  box-shadow: var(--gt-elev-2);
  background: var(--gt-surface-0);
}
.gt-card.is-flat { box-shadow: none; }
.gt-card.is-raised { box-shadow: var(--gt-elev-2); }
.gt-card.is-floating { box-shadow: var(--gt-elev-3); }

/* Bordered column container (Today / Upcoming / Missed) */
.gt-column {
  position: relative;
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-sheet);
  box-shadow: var(--gt-elev-1);
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);
  overflow: hidden;
}
.gt-column::before { content: none; }
.gt-column > * { position: relative; }
.gt-column.is-over {
  background: var(--gt-surface-1);
  border-color: var(--gt-primary);
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10), var(--gt-elev-2);
}
.gt-column-head {
  display: flex; align-items: center; gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--gt-divider);
  background: var(--gt-surface-1);
}
.gt-column-head .gt-icon-tile {
  width: 36px; height: 36px;
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  background: var(--gt-primary);
  color: #ffffff;
  flex-shrink: 0;
  box-shadow: var(--gt-glow-soft);
  position: relative;
}
.gt-column-head .gt-icon-tile::after { content: none; }
.gt-column-head .gt-icon-tile.is-warm  {
  background: #d4a356;
  color: #ffffff;
}
.gt-column-head .gt-icon-tile.is-alert {
  background: #c4574c;
  color: #ffffff;
}
.gt-column-head .gt-icon-tile.is-info {
  background: #6a8bbd;
  color: #ffffff;
}
.gt-column-head .gt-count {
  margin-left: auto;
  font-family: var(--gt-font-display);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  font-weight: 700;
  background: var(--gt-surface-2);
  padding: 4px 10px;
  border-radius: 999px;
}

/* Task card — clean cream with soft border */
.gt-task-card {
  position: relative;
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  box-shadow: var(--gt-elev-1);
  transition:
    transform var(--gt-t-mid),
    border-color var(--gt-t-mid),
    box-shadow var(--gt-t-mid);
  isolation: isolate;
  min-height: 300px;
}

/* Hover-grow — auto-expand a single card on cursor hover (only the hovered card) */
.gt-hover-grow {
  transform-origin: center center;
  transition:
    transform 220ms cubic-bezier(0.33, 1, 0.68, 1),
    box-shadow 220ms cubic-bezier(0.33, 1, 0.68, 1),
    border-color 220ms cubic-bezier(0.33, 1, 0.68, 1);
  will-change: transform;
}
.gt-hover-grow:hover {
  transform: translateY(-4px) scale(1.025);
  box-shadow: var(--gt-elev-3, 0 12px 28px -8px rgba(15, 23, 42, 0.18), 0 6px 12px -6px rgba(15, 23, 42, 0.12)) !important;
  z-index: 5;
}
.gt-task-card::before { content: none; }
.gt-task-card > * { position: relative; }
.gt-task-card:hover {
  border-color: var(--gt-border-strong);
  box-shadow: var(--gt-elev-2);
}
.gt-task-card.is-overdue {
  border-color: var(--gt-prio-urgent-dot);
}
.gt-task-card .gt-prio-bar { display: none; }
.gt-prio-bar.is-urgent { background: var(--gt-prio-urgent-dot); }
.gt-prio-bar.is-high   { background: var(--gt-prio-high-dot); }
.gt-prio-bar.is-medium { background: var(--gt-prio-med-dot); }
.gt-prio-bar.is-low    { background: var(--gt-prio-low-dot); }

/* Priority-tinted cards — vivid left bar, clean white surface */
.gt-task-card.is-prio-urgent {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-left: 4px solid var(--gt-prio-urgent-dot);
  box-shadow: var(--gt-elev-1);
}
.gt-task-card.is-prio-urgent:hover {
  border-color: var(--gt-border-strong);
  border-left-color: var(--gt-prio-urgent-dot);
  box-shadow: var(--gt-elev-2);
}

.gt-task-card.is-prio-high {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-left: 4px solid var(--gt-prio-high-dot);
  box-shadow: var(--gt-elev-1);
}
.gt-task-card.is-prio-high:hover {
  border-color: var(--gt-border-strong);
  border-left-color: var(--gt-prio-high-dot);
  box-shadow: var(--gt-elev-2);
}

.gt-task-card.is-prio-medium {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-left: 4px solid var(--gt-prio-med-dot);
  box-shadow: var(--gt-elev-1);
}
.gt-task-card.is-prio-medium:hover {
  border-color: var(--gt-border-strong);
  border-left-color: var(--gt-prio-med-dot);
  box-shadow: var(--gt-elev-2);
}

.gt-task-card.is-prio-low {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-left: 4px solid var(--gt-prio-low-dot);
  box-shadow: var(--gt-elev-1);
}
.gt-task-card.is-prio-low:hover {
  border-color: var(--gt-border-strong);
  border-left-color: var(--gt-prio-low-dot);
  box-shadow: var(--gt-elev-2);
}

/* Daily planner cards (inside .gt-column) — unified clean white with vivid left bar */
.gt-column .gt-task-card,
.gt-column .gt-task-card.is-prio-urgent,
.gt-column .gt-task-card.is-prio-high,
.gt-column .gt-task-card.is-prio-medium,
.gt-column .gt-task-card.is-prio-low,
.gt-column .gt-task-card.is-done {
  border: 1px solid var(--gt-border) !important;
  border-left: 4px solid var(--gt-border) !important;
  background: var(--gt-surface-0) !important;
  box-shadow: var(--gt-elev-1) !important;
}
.gt-column .gt-task-card.is-prio-urgent { border-left-color: var(--gt-prio-urgent-dot) !important; }
.gt-column .gt-task-card.is-prio-high   { border-left-color: var(--gt-prio-high-dot) !important; }
.gt-column .gt-task-card.is-prio-medium { border-left-color: var(--gt-prio-med-dot) !important; }
.gt-column .gt-task-card.is-prio-low    { border-left-color: var(--gt-prio-low-dot) !important; }
.gt-column .gt-task-card.is-done        { border-left-color: var(--gt-primary) !important; }
.gt-column .gt-task-card:hover {
  border-color: var(--gt-border-strong) !important;
  box-shadow: var(--gt-elev-2) !important;
}
.gt-column .gt-task-card.is-prio-urgent:hover { border-left-color: var(--gt-prio-urgent-dot) !important; }
.gt-column .gt-task-card.is-prio-high:hover   { border-left-color: var(--gt-prio-high-dot) !important; }
.gt-column .gt-task-card.is-prio-medium:hover { border-left-color: var(--gt-prio-med-dot) !important; }
.gt-column .gt-task-card.is-prio-low:hover    { border-left-color: var(--gt-prio-low-dot) !important; }
.gt-column .gt-task-card.is-done:hover        { border-left-color: var(--gt-primary) !important; }

/* Completed state — subtle forest tint */
.gt-task-card.is-done {
  background: var(--gt-primary-container) !important;
  border: 1px solid var(--gt-accent-soft) !important;
  border-left: 3px solid var(--gt-primary) !important;
  box-shadow: var(--gt-elev-1) !important;
}
.gt-task-card.is-done:hover {
  border-color: var(--gt-primary-soft) !important;
  box-shadow: var(--gt-elev-2) !important;
}
.gt-task-card.is-done .gt-prio-bar {
  background: var(--gt-primary) !important;
}

/* Completed badge — solid forest pill */
.gt-completed-badge {
  position: absolute;
  top: 10px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 999px;
  background: var(--gt-primary);
  color: #ffffff;
  font-family: var(--gt-font-display);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  box-shadow: var(--gt-glow-soft);
  z-index: 2;
  isolation: isolate;
}
.gt-completed-badge::after { content: none; }

/* ── Buttons — dark forest primary ── */
.gt-btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 18px;
  border-radius: var(--gt-radius-pill);
  border: 1px solid transparent;
  font-family: var(--gt-font-display);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.005em;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background var(--gt-t-fast),
    color var(--gt-t-fast),
    border-color var(--gt-t-fast),
    transform var(--gt-t-fast),
    box-shadow var(--gt-t-fast);
  -webkit-user-select: none;
          user-select: none;
}
.gt-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.gt-btn:active:not(:disabled) { transform: translateY(0.5px); }

.gt-btn.is-primary {
  background: var(--gt-primary);
  color: #ffffff;
  border-color: transparent;
  box-shadow: var(--gt-glow-soft);
  position: relative;
  overflow: hidden;
}
.gt-btn.is-primary::before { content: none; }
.gt-btn.is-primary > * { position: relative; z-index: 1; }
.gt-btn.is-primary:hover:not(:disabled) {
  background: var(--gt-primary-hover);
  transform: none;
  box-shadow: var(--gt-glow);
}
.gt-btn.is-accent {
  background: var(--gt-primary);
  color: #ffffff;
  border-color: transparent;
  box-shadow: var(--gt-glow-soft);
}
.gt-btn.is-accent:hover:not(:disabled) {
  background: var(--gt-primary-hover);
  transform: none;
  box-shadow: var(--gt-glow);
}
.gt-btn.is-soft {
  background: var(--gt-primary-container);
  color: var(--gt-primary-deep);
  border-color: transparent;
}
.gt-btn.is-soft:hover:not(:disabled) {
  background: var(--gt-primary-container-hover);
  transform: none;
}
.gt-btn.is-ghost {
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  color: var(--gt-text-secondary);
  border-color: var(--gt-border);
  box-shadow: none;
}
.gt-btn.is-ghost:hover:not(:disabled) {
  background: var(--gt-surface-1);
  color: var(--gt-text-primary);
  border-color: var(--gt-border-strong);
  transform: none;
}
.gt-btn.is-danger {
  background: #ffffff;
  color: #a83c34;
  border-color: var(--gt-prio-urgent-dot);
}
.gt-btn.is-danger:hover:not(:disabled) { background: var(--gt-prio-urgent-bg); border-color: #c4574c; }
.gt-btn.is-info {
  background: var(--gt-prio-low-bg);
  color: var(--gt-prio-low-fg);
  border-color: transparent;
}
.gt-btn.is-info:hover:not(:disabled) { background: #d8e1ed; }

.gt-btn.is-sm { padding: 7px 13px; font-size: 12px; gap: 6px; }
.gt-btn.is-lg { padding: 13px 22px; font-size: 14px; }

/* ProjectsPage action row — "+ New Project" + Trash square.
   On phones the primary pill stretches to fill the available width and the
   trash button is a fully-rounded "stadium" shape next to it so the pair
   reads as a single pill-style cluster (matches the reference design).
   On desktop both buttons keep their natural width. */
@media (max-width: 767px) {
  .gt-project-actions {
    width: 100%;
  }
  .gt-project-new-btn {
    flex: 1 1;
    min-width: 0;
    padding: 13px 18px;
    /* 999px = fully rounded ends (pill / stadium shape). */
    border-radius: 999px;
    font-size: 14px;
    letter-spacing: 0.01em;
  }
  .gt-project-trash-btn {
    /* Slightly wider than tall so the rounded sides match the primary
       pill's curvature rather than reading as a perfect circle. */
    width: 64px;
    height: 48px;
    padding: 0;
    border-radius: 999px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-width: 1.5px;
  }
  .gt-project-trash-btn svg {
    width: 18px;
    height: 18px;
  }
}

.gt-btn-kbd {
  display: inline-flex; align-items: center;
  font-family: var(--gt-font-mono);
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  border: 1px solid color-mix(in srgb, currentColor 28%, transparent);
  margin-left: 4px;
  opacity: 0.85;
}

/* Pure icon button */
.gt-icon-btn {
  width: 36px; height: 36px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 12px;
  background: transparent;
  border: 1px solid transparent;
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast), border-color var(--gt-t-fast);
}
.gt-icon-btn:hover { background: var(--gt-surface-2); color: var(--gt-primary); border-color: var(--gt-border); }
.gt-icon-btn.is-sm { width: 30px; height: 30px; border-radius: 10px; }

/* ── Inputs — pill-shaped clean white with soft border ── */
.gt-input,
.gt-select,
.gt-textarea {
  width: 100%;
  padding: 11px 16px;
  border-radius: var(--gt-radius-input);
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  font-family: var(--gt-font);
  font-size: 13.5px;
  color: var(--gt-text-primary);
  outline: none;
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);
  box-shadow: none;
}
.gt-input::placeholder, .gt-textarea::placeholder { color: var(--gt-text-tertiary); }
.gt-input:focus, .gt-select:focus, .gt-textarea:focus {
  border-color: var(--gt-primary);
  background: var(--gt-surface-0);
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);
}
.gt-input.is-search {
  padding-left: 40px;
  background: var(--gt-surface-2);
  border-color: var(--gt-border);
  border-radius: 9999px;
  box-shadow: none;
}
.gt-input.is-search:focus {
  background: var(--gt-surface-0);
  border-color: var(--gt-primary);
}

.gt-field-label {
  font-family: var(--gt-font-display);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  display: block;
  margin-bottom: 6px;
}

/* Search input wrapper */
.gt-search-wrap {
  position: relative;
  display: flex; align-items: center;
}
.gt-search-wrap > svg {
  position: absolute;
  left: 14px;
  width: 16px; height: 16px;
  color: var(--gt-text-tertiary);
  pointer-events: none;
}

/* Quick-add composer */
.gt-composer {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-sheet);
  box-shadow: var(--gt-elev-1);
  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);
  position: relative;
  overflow: visible;
}
.gt-composer:focus-within {
  border-color: var(--gt-primary);
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08), var(--gt-elev-2);
}

.gt-quickadd-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  position: relative;
}

.gt-quickadd-control {
  width: 132px;
  flex: 0 0 132px;
  min-width: 0;
}

.gt-quickadd-chip,
.gt-quickadd-submit {
  justify-content: center;
}

.gt-quickadd-chip {
  padding-left: 11px;
  padding-right: 11px;
}

.gt-quickadd-submit {
  min-width: 112px;
  padding-left: 16px;
  padding-right: 14px;
}

.gt-quickadd-select {
  height: 38px;
  padding-left: 11px;
  padding-right: 10px;
  font-size: 13px;
}

@media (max-width: 640px) {
  .gt-quickadd-control,
  .gt-quickadd-submit {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    width: auto;
  }
}

/* ── Pills — soft tinted badges ── */
.gt-pill {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 11px;
  border-radius: var(--gt-radius-pill);
  font-family: var(--gt-font-display);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
}
.gt-pill .gt-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.gt-pill.is-urgent {
  background: var(--gt-prio-urgent-bg);
  color: var(--gt-prio-urgent-fg);
  border-color: rgba(220, 38, 38, 0.25);
  font-weight: 700;
}
.gt-pill.is-urgent .gt-dot { background: var(--gt-prio-urgent-dot); }

.gt-pill.is-high {
  background: var(--gt-prio-high-bg);
  color: var(--gt-prio-high-fg);
  border-color: rgba(234, 88, 12, 0.25);
  font-weight: 700;
}
.gt-pill.is-high .gt-dot { background: var(--gt-prio-high-dot); }

.gt-pill.is-medium {
  background: var(--gt-prio-med-bg);
  color: var(--gt-prio-med-fg);
  border-color: rgba(217, 119, 6, 0.25);
  font-weight: 700;
}
.gt-pill.is-medium .gt-dot { background: var(--gt-prio-med-dot); }

.gt-pill.is-low {
  background: var(--gt-prio-low-bg);
  color: var(--gt-prio-low-fg);
  border-color: rgba(37, 99, 235, 0.25);
  font-weight: 700;
}
.gt-pill.is-low .gt-dot { background: var(--gt-prio-low-dot); }

.gt-pill.is-pending  { background: var(--gt-status-pending-bg);  color: var(--gt-status-pending-fg); }
.gt-pill.is-progress { background: var(--gt-status-progress-bg); color: var(--gt-status-progress-fg); }
.gt-pill.is-done     { background: var(--gt-status-done-bg);     color: var(--gt-status-done-fg); }
.gt-pill.is-overdue  { background: var(--gt-status-overdue-bg);  color: var(--gt-status-overdue-fg); }
.gt-pill.is-ghost    { background: var(--gt-surface-2);          color: var(--gt-text-secondary); }
.gt-pill.is-personal { background: var(--gt-primary-container);  color: var(--gt-primary-deep); }
.gt-pill.is-assigned { background: var(--gt-prio-low-bg);        color: var(--gt-prio-low-fg); }

/* ── Filter dropdown shell — clean white panel ── */
.gt-dropdown {
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-modal);
  box-shadow: var(--gt-elev-3);
  overflow: hidden;
}
.gt-dropdown-item {
  display: flex; align-items: center; gap: 12px;
  padding: 11px 14px;
  width: 100%;
  border: none;
  background: transparent;
  font-family: var(--gt-font-display);
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gt-text-primary);
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease;
}
.gt-dropdown-item:hover { background: var(--gt-surface-1); color: var(--gt-primary); }
.gt-dropdown-item:active { background: var(--gt-primary-container); }
.gt-dropdown-divider {
  height: 1px;
  margin: 0 12px;
  background: var(--gt-divider);
}

/* Segmented control — minimal */
.gt-segmented {
  display: flex;
  padding: 3px;
  background: var(--gt-surface-2);
  border-radius: 12px;
  position: relative;
  border: 1px solid var(--gt-divider);
}
.gt-segmented-pill {
  flex: 1 1;
  padding: 8px 14px;
  border-radius: 9px;
  border: none;
  background: transparent;
  font-family: var(--gt-font-display);
  font-size: 12px;
  font-weight: 600;
  color: var(--gt-text-tertiary);
  cursor: pointer;
  transition: all var(--gt-t-mid);
}
.gt-segmented-pill.is-active {
  background: var(--gt-primary);
  color: #ffffff;
  box-shadow: var(--gt-glow-soft);
}

/* ──────────────────────────────────────────────────────────────────────
   CALENDAR — minimal cream / forest heatmap
   ────────────────────────────────────────────────────────────────────── */
.gt-cal-day {
  width: 36px; height: 36px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 10px;
  font-size: 13px;
  color: var(--gt-text-secondary);
  font-family: var(--gt-font-display);
  font-weight: 600;
  position: relative;
  cursor: pointer;
  border: 1px solid transparent;
  background: var(--gt-heat-0);
  transition:
    background var(--gt-t-mid),
    color var(--gt-t-mid),
    transform var(--gt-t-mid),
    box-shadow var(--gt-t-mid),
    border-color var(--gt-t-mid);
}
.gt-cal-day:hover  { transform: scale(1.06); box-shadow: var(--gt-elev-2); border-color: var(--gt-primary); }
.gt-cal-day:active { transform: scale(0.96); }

/* Heatmap fills */
.gt-cal-day[data-heat="0"] { background: var(--gt-heat-0); color: var(--gt-text-tertiary); }
.gt-cal-day[data-heat="1"] { background: var(--gt-heat-1); color: var(--gt-primary-deep); }
.gt-cal-day[data-heat="2"] { background: var(--gt-heat-2); color: var(--gt-primary-deep); }
.gt-cal-day[data-heat="3"] { background: var(--gt-heat-3); color: #ffffff; }
.gt-cal-day[data-heat="4"] { background: var(--gt-heat-4); color: #ffffff; }
.gt-cal-day[data-heat="5"] { background: var(--gt-heat-5); color: #ffffff; }

/* State-driven cells */
.gt-cal-day[data-state="absent"]  { background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg); }
.gt-cal-day[data-state="leave"]   { background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg); }
.gt-cal-day[data-state="holiday"] { background: var(--gt-prio-low-bg); color: var(--gt-prio-low-fg); }

.gt-cal-day.is-today {
  outline: 2px solid var(--gt-primary);
  outline-offset: 1px;
  font-weight: 800;
}
.gt-cal-day.is-selected {
  background: var(--gt-primary) !important;
  color: #ffffff !important;
  font-weight: 800;
  box-shadow: var(--gt-glow-soft);
  outline: none;
}
.gt-cal-day.is-other { opacity: 0.4; }
.gt-cal-day.has-event::after {
  content: '';
  position: absolute;
  bottom: 4px; left: 50%;
  transform: translateX(-50%);
  width: 4px; height: 4px;
  border-radius: 50%;
  background: var(--gt-primary);
}
.gt-cal-day.is-selected.has-event::after { background: #ffffff; }

.gt-cal-weekday {
  width: 36px;
  text-align: center;
  font-family: var(--gt-font-display);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.10em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  padding-bottom: 8px;
}

/* Calendar popover panel */
.gt-cal-panel {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-modal);
  box-shadow: var(--gt-elev-4);
  width: 320px;
  overflow: hidden;
  animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;
  transform-origin: top left;
}
.gt-cal-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--gt-divider);
  background: var(--gt-surface-1);
}
.gt-cal-month {
  font-family: var(--gt-font-display);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--gt-text-primary);
}
.gt-cal-month em {
  font-family: var(--gt-font-display);
  font-style: normal;
  font-weight: 800;
  color: var(--gt-primary);
  margin-left: 4px;
}

/* Calendar legend */
.gt-cal-legend {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 8px;
}
.gt-cal-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--gt-font-display);
  font-size: 11px;
  font-weight: 600;
  color: var(--gt-text-tertiary);
}
.gt-cal-legend-item .dot {
  width: 9px; height: 9px;
  border-radius: 3px;
  flex-shrink: 0;
}

/* ── Animations ─── */
@keyframes gt-pop {
  0%   { opacity: 0; transform: translateY(-6px) scale(0.96); }
  60%  { opacity: 1; }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes gt-fade-up {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: none; }
}
.gt-fade-in { animation: gt-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both; }
.gt-pop-in  { animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both; }

/* Forest scrollbar */
.gt-scroll::-webkit-scrollbar,
.gt-shell *::-webkit-scrollbar,
.gt-themed *::-webkit-scrollbar { width: 10px; height: 10px; }
.gt-scroll::-webkit-scrollbar-track,
.gt-shell *::-webkit-scrollbar-track,
.gt-themed *::-webkit-scrollbar-track { background: transparent; }
.gt-scroll::-webkit-scrollbar-thumb,
.gt-shell *::-webkit-scrollbar-thumb,
.gt-themed *::-webkit-scrollbar-thumb {
  background: var(--gt-border-strong);
  border-radius: 9999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.gt-scroll::-webkit-scrollbar-thumb:hover,
.gt-shell *::-webkit-scrollbar-thumb:hover,
.gt-themed *::-webkit-scrollbar-thumb:hover {
  background: var(--gt-primary);
  background-clip: padding-box;
}
.gt-scroll, .gt-shell, .gt-themed { scrollbar-color: var(--gt-border-strong) transparent; scrollbar-width: thin; }

/* ── Header / hero ── */
.gt-page-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 18px;
  position: relative;
}
/* On phone the hero stacks vertically (Tailwind \`flex-col\` toggles
   flex-direction). With column direction, \`align-items: flex-end\` would
   push every child to the right edge of the screen — left-align the
   stacked layout so the title + stats start at the page padding. */
@media (max-width: 767px) {
  .gt-page-hero {
    align-items: stretch;
    text-align: left;
  }
}
.gt-eyebrow-row {
  display: inline-flex; align-items: center; gap: 8px;
  margin-bottom: 8px;
}

/* Status / progress mini bar */
.gt-progress-track {
  height: 6px;
  width: 100%;
  background: var(--gt-surface-2);
  border-radius: 999px;
  overflow: hidden;
}
.gt-progress-fill {
  height: 100%;
  background: var(--gt-primary);
  border-radius: 999px;
  transition: width var(--gt-t-slow);
  box-shadow: none;
}

/* Stat tile — clean cream card */
.gt-stat {
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  padding: 18px 20px;
  position: relative;
  overflow: hidden;
  box-shadow: var(--gt-elev-1);
  transition: border-color var(--gt-t-mid), transform var(--gt-t-mid), box-shadow var(--gt-t-mid);
}
.gt-stat::before { content: none; }
.gt-stat:hover {
  border-color: var(--gt-border-strong);
  box-shadow: var(--gt-elev-2);
}
.gt-stat > * { position: relative; z-index: 1; }
.gt-stat-label {
  font-family: var(--gt-font-display);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  display: flex; align-items: center; gap: 8px;
}
.gt-stat-label > :first-child:not(span) {
  color: var(--gt-primary);
}
.gt-stat-value {
  font-family: var(--gt-font-display);
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--gt-text-primary);
  line-height: 1.05;
  margin-top: 6px;
  font-feature-settings: 'tnum' 1, 'lnum' 1;
}
.gt-stat-foot {
  font-size: 11px;
  color: var(--gt-text-tertiary);
  margin-top: 6px;
  font-family: var(--gt-font);
}

/* Avatar plate — solid forest */
.gt-avatar {
  width: 36px; height: 36px;
  border-radius: 50%;
  background: var(--gt-primary);
  color: #ffffff;
  display: inline-flex; align-items: center; justify-content: center;
  font-family: var(--gt-font-display);
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  position: relative;
  box-shadow: var(--gt-glow-soft);
  isolation: isolate;
}
.gt-avatar::after { content: none; }

/* Modal shell — clean white over soft scrim */
.gt-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 18, 0.32);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 100;
  animation: gt-fade-up 220ms ease-out both;
}
.gt-modal {
  background: var(--gt-surface-0);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-radius: var(--gt-radius-sheet);
  box-shadow: var(--gt-elev-5);
  border: 1px solid var(--gt-border);
  overflow: hidden;
  animation: gt-pop 280ms cubic-bezier(0.33, 1, 0.68, 1) both;
  transform-origin: center;
}

/* Empty state */
.gt-empty {
  text-align: center;
  padding: 60px 20px;
  color: var(--gt-text-tertiary);
  font-family: var(--gt-font);
}
.gt-empty .gt-empty-leaf {
  display: inline-flex;
  width: 64px; height: 64px;
  border-radius: 50%;
  background: var(--gt-primary-container);
  color: var(--gt-primary);
  align-items: center; justify-content: center;
  margin-bottom: 16px;
  box-shadow: none;
}
.gt-empty .gt-empty-title {
  font-family: var(--gt-font-display);
  font-weight: 700;
  font-size: 15px;
  color: var(--gt-text-primary);
  margin-bottom: 4px;
}

/* Loading dots */
.gt-loading-ring {
  width: 32px; height: 32px;
  border: 3px solid var(--gt-primary-container);
  border-top-color: var(--gt-primary);
  border-radius: 50%;
  animation: gt-spin 700ms linear infinite;
}
@keyframes gt-spin { to { transform: rotate(360deg); } }

/* Keyboard hint */
.gt-kbd {
  font-family: var(--gt-font-mono);
  font-size: 10px;
  padding: 1px 5px;
  border: 1px solid var(--gt-border-strong);
  border-radius: 4px;
  color: var(--gt-text-tertiary);
  background: var(--gt-surface-0);
}

/* ── Donut + ring helpers ── */
.gt-ring-track { stroke: var(--gt-surface-2); }
.gt-ring-fill  { stroke: var(--gt-primary); }

/* ── Dark theme ── */
[data-task-theme="dark"] .gt-shell {
  background: var(--gt-surface-1);
}
[data-task-theme="dark"] .gt-shell::before { content: none; }
[data-task-theme="dark"] .gt-dropdown {
  background: var(--gt-surface-0);
  border-color: var(--gt-border);
}

/* ──────────────────────────────────────────────────────────────────────
   AUTO-OVERRIDES for legacy pages (gt-themed wrapper)
   Maps Tailwind purple/indigo/blue patterns → forest palette.
   ────────────────────────────────────────────────────────────────────── */
.gt-themed {
  font-family: var(--gt-font);
  color: var(--gt-text-primary);
}

.gt-themed h1,
.gt-themed h2,
.gt-themed h3,
.gt-themed h4 {
  font-family: var(--gt-font-display);
  letter-spacing: -0.01em;
  color: var(--gt-text-primary);
}

/* Gradient backgrounds → flat dark forest */
.gt-themed [class*="from-blue-500"][class*="to-purple-600"],
.gt-themed [class*="from-blue-600"][class*="to-purple-700"],
.gt-themed [class*="from-blue-500"][class*="to-blue-600"],
.gt-themed [class*="from-blue-600"][class*="to-blue-700"],
.gt-themed [class*="from-indigo-500"][class*="to-purple-600"],
.gt-themed [class*="from-indigo-500"][class*="to-blue-600"],
.gt-themed [class*="from-indigo-600"][class*="to-purple-600"],
.gt-themed [class*="from-violet-500"][class*="to-purple-600"],
.gt-themed [class*="from-purple-500"][class*="to-pink-500"],
.gt-themed [class*="from-purple-600"][class*="to-purple-700"],
.gt-themed [class*="from-emerald-600"][class*="to-teal-600"],
.gt-themed [class*="from-emerald-500"][class*="to-teal-500"] {
  background: var(--gt-primary) !important;
  color: #ffffff !important;
  background-image: none !important;
  box-shadow: var(--gt-glow-soft) !important;
}
.gt-themed [class*="from-blue-500"][class*="to-purple-600"]:hover,
.gt-themed [class*="from-blue-600"][class*="to-purple-700"]:hover,
.gt-themed [class*="from-indigo-500"][class*="to-purple-600"]:hover,
.gt-themed [class*="from-indigo-500"][class*="to-blue-600"]:hover,
.gt-themed [class*="from-emerald-600"][class*="to-teal-600"]:hover {
  background: var(--gt-primary-hover) !important;
  background-image: none !important;
}

/* Text-gradient titles → solid forest */
.gt-themed [class*="bg-clip-text"][class*="text-transparent"] {
  background: none !important;
  background-clip: initial !important;
  -webkit-text-fill-color: var(--gt-primary) !important;
  color: var(--gt-primary) !important;
  font-family: var(--gt-font-display);
  letter-spacing: -0.03em;
}

/* Banner gradient backgrounds → soft cream */
.gt-themed [class*="from-blue-50"][class*="to-indigo-50"],
.gt-themed [class*="from-blue-50"][class*="to-purple-50"],
.gt-themed [class*="from-indigo-50"][class*="to-purple-50"],
.gt-themed [class*="from-purple-50"][class*="to-pink-50"],
.gt-themed [class*="from-violet-50"][class*="to-pink-50"],
.gt-themed [class*="from-slate-50"][class*="to-blue-50"],
.gt-themed [class*="from-slate-50"][class*="via-blue-50"] {
  background: var(--gt-surface-1) !important;
  background-image: none !important;
}

/* Plain blue/indigo/purple/violet accents → forest */
.gt-themed .text-blue-500,
.gt-themed .text-blue-600,
.gt-themed .text-blue-700,
.gt-themed .text-indigo-500,
.gt-themed .text-indigo-600,
.gt-themed .text-indigo-700,
.gt-themed .text-purple-500,
.gt-themed .text-purple-600,
.gt-themed .text-purple-700,
.gt-themed .text-violet-500,
.gt-themed .text-violet-600 { color: var(--gt-primary) !important; }

.gt-themed .bg-blue-50, .gt-themed .bg-indigo-50, .gt-themed .bg-purple-50, .gt-themed .bg-violet-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-blue-100, .gt-themed .bg-indigo-100, .gt-themed .bg-purple-100, .gt-themed .bg-violet-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }
.gt-themed .bg-blue-500, .gt-themed .bg-blue-600, .gt-themed .bg-indigo-500, .gt-themed .bg-indigo-600, .gt-themed .bg-purple-500, .gt-themed .bg-purple-600, .gt-themed .bg-violet-500, .gt-themed .bg-violet-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }
.gt-themed .bg-blue-700, .gt-themed .bg-indigo-700, .gt-themed .bg-purple-700, .gt-themed .bg-violet-700 { background-color: var(--gt-primary-hover) !important; }

.gt-themed .border-blue-200, .gt-themed .border-indigo-200, .gt-themed .border-purple-200 { border-color: var(--gt-border) !important; }
.gt-themed .border-blue-500, .gt-themed .border-indigo-500, .gt-themed .border-purple-500,
.gt-themed .border-blue-600, .gt-themed .border-indigo-600, .gt-themed .border-purple-600 { border-color: var(--gt-primary) !important; }
.gt-themed .border-l-4.border-blue-500 { border-color: var(--gt-primary) !important; }

.gt-themed .focus\\:ring-blue-500:focus, .gt-themed .focus\\:ring-indigo-500:focus, .gt-themed .focus\\:ring-purple-500:focus, .gt-themed .focus\\:ring-blue-400:focus { --tw-ring-color: var(--gt-primary) !important; box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important; }
.gt-themed .focus\\:border-blue-500:focus, .gt-themed .focus\\:border-indigo-500:focus { border-color: var(--gt-primary) !important; }

.gt-themed .hover\\:bg-blue-50:hover, .gt-themed .hover\\:bg-indigo-50:hover, .gt-themed .hover\\:bg-purple-50:hover { background-color: var(--gt-surface-1) !important; }
.gt-themed .hover\\:bg-blue-100:hover, .gt-themed .hover\\:bg-indigo-100:hover, .gt-themed .hover\\:bg-purple-100:hover { background-color: var(--gt-primary-container) !important; }
.gt-themed .hover\\:text-blue-600:hover, .gt-themed .hover\\:text-indigo-600:hover, .gt-themed .hover\\:text-purple-600:hover { color: var(--gt-primary) !important; }

/* Default page background gradients → flat cream */
.gt-themed [class*="from-gray-50"][class*="to-gray-100"],
.gt-themed [class*="from-gray-50"][class*="to-white"][class*="to-gray-50"],
.gt-themed [class*="bg-gradient-to-br"][class*="from-background"][class*="to-muted"] {
  background: var(--gt-surface-1) !important;
  background-image: none !important;
}

/* Card surfaces */
.gt-themed .bg-white { background-color: var(--gt-surface-0) !important; }
.gt-themed .bg-gray-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-gray-100 { background-color: var(--gt-surface-2) !important; }
.gt-themed .border-gray-100 { border-color: var(--gt-divider) !important; }
.gt-themed .border-gray-200 { border-color: var(--gt-border) !important; }
.gt-themed .border-gray-300 { border-color: var(--gt-border-strong) !important; }

.gt-themed .text-gray-400 { color: var(--gt-text-disabled) !important; }
.gt-themed .text-gray-500 { color: var(--gt-text-tertiary) !important; }
.gt-themed .text-gray-600 { color: var(--gt-text-secondary) !important; }
.gt-themed .text-gray-700 { color: var(--gt-text-secondary) !important; }
.gt-themed .text-gray-800,
.gt-themed .text-gray-900 { color: var(--gt-text-primary) !important; }

/* Backdrop / modal */
.gt-themed .fixed.inset-0[class*="bg-black"] { background: rgba(20, 20, 18, 0.32) !important; backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }

/* Inputs auto-style — pill-shaped rounded inputs */
.gt-themed input[type="text"]:not(.gt-input):not([class*="gt-"]),
.gt-themed input[type="email"]:not(.gt-input),
.gt-themed input[type="number"]:not(.gt-input),
.gt-themed input[type="search"]:not(.gt-input),
.gt-themed input[type="tel"]:not(.gt-input),
.gt-themed input[type="url"]:not(.gt-input),
.gt-themed input[type="date"]:not(.gt-input),
.gt-themed input[type="time"]:not(.gt-input),
.gt-themed input[type="datetime-local"]:not(.gt-input),
.gt-themed textarea:not(.gt-textarea),
.gt-themed select:not(.gt-select) {
  background: var(--gt-surface-0);
  border-color: var(--gt-border);
  color: var(--gt-text-primary);
  font-family: var(--gt-font);
  border-radius: var(--gt-radius-input);
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);
}
.gt-themed input[type="text"]:not(.gt-input):focus,
.gt-themed input[type="email"]:not(.gt-input):focus,
.gt-themed input[type="number"]:not(.gt-input):focus,
.gt-themed input[type="search"]:not(.gt-input):focus,
.gt-themed input[type="tel"]:not(.gt-input):focus,
.gt-themed input[type="date"]:not(.gt-input):focus,
.gt-themed input[type="time"]:not(.gt-input):focus,
.gt-themed input[type="datetime-local"]:not(.gt-input):focus,
.gt-themed textarea:not(.gt-textarea):focus,
.gt-themed select:not(.gt-select):focus {
  border-color: var(--gt-primary) !important;
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);
}

/* Status / accent token rewrites — forest-first */
.gt-themed .bg-emerald-500, .gt-themed .bg-green-500, .gt-themed .bg-emerald-600, .gt-themed .bg-green-600, .gt-themed .bg-teal-500, .gt-themed .bg-teal-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }
.gt-themed .text-emerald-500, .gt-themed .text-emerald-600, .gt-themed .text-green-500, .gt-themed .text-green-600, .gt-themed .text-teal-500, .gt-themed .text-teal-600 { color: var(--gt-primary) !important; }
.gt-themed .bg-emerald-50, .gt-themed .bg-green-50, .gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }
.gt-themed .bg-emerald-100, .gt-themed .bg-green-100, .gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; }
.gt-themed .text-emerald-700, .gt-themed .text-green-700, .gt-themed .text-emerald-800, .gt-themed .text-teal-700 { color: var(--gt-primary-deep) !important; }

/* Progress / chart strokes */
.gt-themed .bg-green-500.h-2,
.gt-themed .bg-green-500.h-1,
.gt-themed .bg-emerald-500.h-2,
.gt-themed .bg-emerald-500.h-1 {
  background: var(--gt-primary) !important;
  background-image: none !important;
}

/* Animation tweaks */
.gt-themed .animate-pulse { animation-duration: 2.4s; }

/* ──────────────────────────────────────────────────────────────────────
   GLOBAL GLASS SUPPRESSION — kills any leftover backdrop-filter blur
   inside the task module so the cream theme stays crisp.
   ────────────────────────────────────────────────────────────────────── */
.gt-shell *,
.gt-themed * {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
.gt-shell .gt-modal-backdrop,
.gt-themed .gt-modal-backdrop {
  backdrop-filter: blur(4px) !important;
  -webkit-backdrop-filter: blur(4px) !important;
}

/* ============================================================ */
/* Chat component classes (.gc-*)                               */
/* Merged from src/pages/Chat/theme/tokens.css                  */
/* ============================================================ */
/* ──────────────────────────────────────────────────────────────────────────
   Chat Design Tokens — "Forest Sage" theme (2026)
   Inspired by editorial calm + organic warmth. Forest green primary,
   sage tint surfaces, restrained accents, and a paper-like neutral base.
   Import in Chat.tsx: import './theme/tokens.css';
   All chat surfaces should reference these variables — no raw hex inline.
   ────────────────────────────────────────────────────────────────────── */

/* Distinctive type system — three voices in one chorus:
   ▸ Plus Jakarta Sans — display + UI labels, geometric warmth
   ▸ Fraunces — editorial serif (italics for date dividers, pull-quotes)
   ▸ Inter — body text, optimized at small sizes
   ▸ JetBrains Mono — code spans, message IDs, technical grit
*/

/* ── High-quality emoji rendering ────────────────────────────────────────
   Use .gc-emoji on any element rendering raw emoji characters so glyphs
   resolve to a vector colour set with the same look across every OS.
   Inheritance + fallback chain protects readability if the webfont fails. */
.gc-emoji,
.gc-emoji * {
  font-family: 'Noto Color Emoji', 'Apple Color Emoji', 'Segoe UI Emoji',
               'Segoe UI Symbol', 'Twemoji Mozilla', 'EmojiOne Color',
               'Android Emoji', sans-serif;
  font-variant-emoji: emoji;
  font-feature-settings: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Chat-side tokens are defined at the top of this file (one DESIGN TOKENS
   block holds everything). Layout / component rules continue below. */

/* ──────────────────────────────────────────────────────────
   Chat-scoped utility classes
   ────────────────────────────────────────────────────────── */
.gc-surface-0   { background: var(--gc-surface-0); }
.gc-surface-1   { background: var(--gc-surface-1); }
.gc-surface-2   { background: var(--gc-surface-2); }
.gc-text-primary   { color: var(--gc-text-primary); }
.gc-text-secondary { color: var(--gc-text-secondary); }
.gc-text-tertiary  { color: var(--gc-text-tertiary); }
.gc-border         { border-color: var(--gc-border); }
.gc-divider        { border-color: var(--gc-divider); }
.gc-primary        { color: var(--gc-primary); }
.gc-mention      { background: var(--gc-mention-bg); color: var(--gc-mention-text); border-radius: 4px; padding: 0 4px; font-weight: 600; }
.gc-self-mention { background: var(--gc-self-mention-bg); color: var(--gc-self-mention-text); border-radius: 4px; padding: 0 4px; font-weight: 600; }

/* Display heading utility */
.gc-display {
  font-family: var(--gc-font-display);
  letter-spacing: var(--gc-letter-display);
  font-weight: 700;
}
.gc-eyebrow {
  font-family: var(--gc-font-display);
  letter-spacing: var(--gc-letter-eyebrow);
  text-transform: uppercase;
  font-size: 10.5px;
  font-weight: 700;
}

/* Sage-tinted scrollbar — subtle, organic */
.gc-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
.gc-scroll::-webkit-scrollbar-track { background: transparent; }
.gc-scroll::-webkit-scrollbar-thumb {
  background: var(--gc-border-strong);
  border-radius: 9999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.gc-scroll::-webkit-scrollbar-thumb:hover { background: var(--gc-text-tertiary); background-clip: padding-box; border: 2px solid transparent; }

/* Chat shell — plain white backdrop (sage gradient + grain removed). */
.gc-shell {
  position: relative;
  background: #ffffff;
}
.gc-shell::before { content: none; }
.gc-shell > * { position: relative; z-index: 1; }

/* Tiny editorial flourishes ─────────────────────────────────────── */

/* Italic serif accent — used inline for emphasis & flourishes */
.gc-serif-italic {
  font-family: var(--gc-font-serif);
  font-style: italic;
  font-feature-settings: 'ss01', 'ss03';
}

/* Hand-drawn-feel hairline rule, tapered at both ends */
.gc-rule {
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    var(--gc-border-strong) 25%,
    var(--gc-border-strong) 75%,
    transparent
  );
}

/* Decorative leaf glyph used as a chapter mark in section headers */
.gc-leaf {
  display: inline-block;
  width: 8px; height: 8px;
  background: var(--gc-accent);
  border-radius: 100% 0 100% 0;
  transform: rotate(-15deg);
  flex-shrink: 0;
}

/* Numeric oldstyle figures for time stamps & counts */
.gc-numerals {
  font-feature-settings: 'tnum' 1, 'lnum' 1;
}

/* Conversation row — refined active state with leading bar */
.gc-conv-row {
  position: relative;
  background: transparent;
  border: 0;
  border-radius: 0;
  outline: 0;
  box-shadow: none;
  transition:
    background-color var(--gc-transition-fast),
    transform var(--gc-transition-fast);
}
.gc-conv-row:hover { background: var(--gc-surface-hover); }
.gc-conv-row.is-active {
  background: var(--gc-primary-container);
}
.gc-conv-row.is-active::before {
  content: '';
  position: absolute;
  left: 0; top: 10px; bottom: 10px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--gc-primary);
}
.gc-conv-row__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
}
.gc-conv-row__title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}
.gc-conv-row__identity {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
}
.gc-conv-row__title-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 0 1 auto;
  line-height: 1.2;
}
.gc-conv-row__title-text > .truncate {
  min-width: 0;
}
.gc-conv-row__title-presence-dot {
  flex: 0 0 auto;
  width: 12px;
  height: 12px;
  border-width: 2px;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px rgba(16, 185, 129, 0.22);
  /* PERF: no idle animation. Every online row used to run four infinite
     keyframe animations; with a dozen online peers that forced a style
     recalc + paint + composite on EVERY frame (60/s) for as long as the
     app was open — even hidden in the tray. Presence is shown statically. */
}
.gc-conv-row__title-presence-dot.is-away {
  background: #facc15;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px rgba(250, 204, 21, 0.38);
}
.gc-conv-row__title-presence-dot.is-dnd {
  background: var(--gc-dnd);
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px color-mix(in srgb, var(--gc-dnd) 42%, transparent);
}
.gc-conv-row__title-presence-dot.is-leave {
  background: #f97316;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px rgba(249, 115, 22, 0.42);
}
.gc-conv-row__title-presence-dot.is-offline {
  opacity: 0.78;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.10);
}
.gc-conv-row__unread {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 7px;
  line-height: 1;
  flex: 0 0 auto;
}
.gc-conv-row__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  min-width: max-content;
  white-space: nowrap;
}
.gc-conv-row__time {
  flex: 0 0 auto;
  line-height: 1;
}
.gc-conv-row__kebab {
  flex: 0 0 18px;
}
.gc-conv-row__body .gc-row-last {
  min-width: 0;
}

/* Sent message bubble — softer dark-teal forest, refined corner */
.gc-bubble-mine {
  background: var(--gc-bubble-mine-bg);
  color: var(--gc-bubble-mine-text);
  border-radius: var(--gc-radius-bubble) var(--gc-radius-bubble) 4px var(--gc-radius-bubble);
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.08);
}
.gc-bubble-mine:hover { background: var(--gc-bubble-mine-bg-hover); }
.gc-bubble-mine .chat-rich-render,
.gc-bubble-mine .chat-rich-render .ProseMirror,
.gc-bubble-mine .chat-rich-render .ProseMirror p,
.gc-bubble-mine .chat-rich-render .ProseMirror li,
.gc-bubble-mine .chat-rich-render .ProseMirror span,
.gc-bubble-mine .chat-rich-render .ProseMirror strong,
.gc-bubble-mine .chat-rich-render .ProseMirror em {
  color: var(--gc-bubble-mine-text);
}
.gc-bubble-mine .chat-rich-render .ProseMirror a,
.gc-bubble-mine .chat-rich-render .ProseMirror a *,
.gc-bubble-mine .chat-rich-render .ProseMirror a span {
  color: #ffffff !important;
  text-decoration: underline !important;
  text-decoration-color: #ffffff !important;
  text-underline-offset: 2px;
  word-break: break-all;
  overflow-wrap: anywhere;
}
.gc-bubble-mine .chat-rich-render .ProseMirror a:hover,
.gc-bubble-mine .chat-rich-render .ProseMirror a:hover * {
  opacity: 0.85;
}
.gc-bubble-mine .chat-rich-render .ProseMirror code,
.gc-bubble-mine .chat-rich-render .ProseMirror pre {
  background: rgba(255, 255, 255, 0.12);
  color: var(--gc-bubble-mine-text);
}
.gc-bubble-theirs {
  background: var(--gc-surface-2);
  color: var(--gc-text-primary);
  border-radius: var(--gc-radius-bubble) var(--gc-radius-bubble) var(--gc-radius-bubble) 4px;
  border: 1px solid var(--gc-border);
}

/* ── Quoted reply snippet (in-bubble + composer pill) ───────────
   Theme-aware inset card fronted by a gradient "quote stripe" on
   the leading edge. The stripe is the shared signature of a reply —
   it reappears on the composer ReplyPill so the two read as one
   system. Adapts to the dark sent bubble (black wash + bright mint
   stripe) vs the light received bubble (faint wash + deep emerald). */
.gc-quoted {
  position: relative;
  display: block;
  width: 100%;
  margin: 0 0 8px;
  padding: 6px 12px 6px 14px;
  border: 0;
  border-radius: 5px 9px 9px 5px;
  background: rgba(15, 23, 18, 0.045);
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: default;
  transition: background 180ms ease, transform 120ms ease;
  appearance: none;
  overflow: hidden;
}
/* The quote stripe — gradient emerald → mint; widens & brightens on hover */
.gc-quoted::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, var(--gc-accent-strong), #34d399);
  transition: width 160ms ease, filter 160ms ease;
}
.gc-quoted[data-clickable="true"] { cursor: pointer; }
.gc-quoted[data-clickable="true"]:hover {
  background: rgba(15, 23, 18, 0.08);
}
.gc-quoted[data-clickable="true"]:hover::before {
  width: 4px;
  filter: brightness(1.12) saturate(1.1);
}
.gc-quoted[data-clickable="true"]:active { transform: scale(0.99); }

.gc-quoted__sender {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12.75px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.005em;
  color: var(--gc-accent-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-quoted__sender svg { flex-shrink: 0; }

.gc-quoted__text {
  display: block;
  font-size: 12.5px;
  line-height: 1.35;
  color: var(--gc-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
}
.gc-quoted__text--deleted {
  font-style: italic;
  opacity: 0.7;
}

/* Image-quote layout: text column on the left, thumbnail pinned right */
.gc-quoted--media {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gc-quoted__main {
  min-width: 0;
  flex: 1 1 auto;
}
.gc-quoted__thumb {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 6px;
  object-fit: cover;
  background: rgba(15, 23, 18, 0.06);
}

/* Dark sent-bubble context: black wash + bright mint stripe */
.gc-bubble-mine .gc-quoted {
  background: rgba(0, 0, 0, 0.13);
}
.gc-bubble-mine .gc-quoted::before {
  background: linear-gradient(180deg, #6ee7b7, #34d399);
}
.gc-bubble-mine .gc-quoted[data-clickable="true"]:hover {
  background: rgba(0, 0, 0, 0.2);
}
.gc-bubble-mine .gc-quoted__sender { color: #a7f3d0; }
.gc-bubble-mine .gc-quoted__text { color: rgba(244, 250, 246, 0.8); }
.gc-bubble-mine .gc-quoted__thumb { background: rgba(255, 255, 255, 0.12); }

/* Loading skeleton: shimmer until original resolves */
.gc-quoted--loading {
  min-height: 30px;
}
.gc-quoted--loading::before { opacity: 0.65; }
.gc-bubble-mine .gc-quoted--loading::before {
  background: rgba(110, 231, 183, 0.5);
}
.gc-quoted--loading::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.04) 40%,
    rgba(255, 255, 255, 0.10) 50%,
    rgba(255, 255, 255, 0.04) 60%,
    transparent 100%
  );
  /* Finite: a reply whose original is outside the loaded window (or was
     purged) never resolves, so an infinite shimmer would animate forever in
     the always-visible message list. Six passes read as "loading", then the
     placeholder rests. */
  animation: gc-quoted-shimmer 1.6s ease-in-out 6;
}
@keyframes gc-quoted-shimmer {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Composer-pill variant — appears above the input, not inside a bubble */
.gc-quoted--composer {
  background: rgba(16, 185, 129, 0.08);
}
.gc-quoted--composer::before {
  background: linear-gradient(180deg, var(--gc-accent-strong), #34d399);
}
.gc-quoted--composer:hover {
  background: rgba(16, 185, 129, 0.12);
}

/* ── Composer pills (reply + edit banners) ──────────────────────
   The bar that slides in above the input when you reply to or edit
   a message. Echoes the gradient quote-stripe from .gc-quoted so the
   composer previews how the message relates to the thread. Driven by
   a single --pill-accent variable: reply = emerald (default), edit =
   amber. Fully token-driven → adapts to light / dark / high-contrast. */
.gc-compose-pill {
  --pill-accent: var(--gc-accent-strong);
  --pill-accent-2: #34d399;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 9px 12px 9px 15px;
  border-top: 1px solid var(--gc-border);
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--pill-accent) 10%, transparent),
    color-mix(in srgb, var(--pill-accent) 3%, transparent) 55%,
    transparent
  );
  animation: gc-compose-pill-in 240ms cubic-bezier(0.22, 1, 0.36, 1);
}
.gc-compose-pill__bar {
  position: absolute;
  left: 0;
  top: 7px;
  bottom: 7px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(180deg, var(--pill-accent), var(--pill-accent-2));
}
.gc-compose-pill__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 27px;
  height: 27px;
  border-radius: 9px;
  color: var(--pill-accent);
  background: color-mix(in srgb, var(--pill-accent) 14%, transparent);
}
.gc-compose-pill__body {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.gc-compose-pill__label {
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0.01em;
  color: var(--gc-text-secondary);
}
.gc-compose-pill__label strong {
  font-weight: 700;
  color: var(--pill-accent);
}
.gc-compose-pill__text {
  display: block;
  max-width: 100%;
  font-size: 12.5px;
  line-height: 1.3;
  color: var(--gc-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-compose-pill__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--gc-text-tertiary);
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease,
    transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}
.gc-compose-pill__close:hover {
  background: color-mix(in srgb, var(--pill-accent) 13%, transparent);
  color: var(--pill-accent);
  transform: rotate(90deg);
}
.gc-compose-pill__close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--gc-surface-0), 0 0 0 4px var(--pill-accent);
}
@keyframes gc-compose-pill-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Edit banner — amber accent (distinct from the emerald reply banner).
   Amber isn't a theme token, so the accent is set per colour scheme. */
.gc-edit-pill { --pill-accent: #b45309; --pill-accent-2: #f59e0b; }
[data-theme="dark"] .gc-edit-pill { --pill-accent: #fbbf24; --pill-accent-2: #f59e0b; }
[data-theme="hc"] .gc-edit-pill { --pill-accent: #fcd34d; --pill-accent-2: #fbbf24; }

/* Composer — pill input with subtle inner glow */
.gc-composer {
  background: var(--gc-surface-2);
  border: 1px solid var(--gc-border);
  border-radius: 18px;
  transition: border-color var(--gc-transition-fast), background var(--gc-transition-fast), box-shadow var(--gc-transition-fast);
}
.gc-composer:focus-within {
  background: var(--gc-surface-0);
  border-color: var(--gc-primary);
  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);
}

/* Sidebar header / search */
.gc-sidebar-search {
  background: var(--gc-surface-2);
  border: 1px solid transparent;
  border-radius: 12px;
  transition: background var(--gc-transition-fast), border-color var(--gc-transition-fast);
}
.gc-sidebar-search:focus-within {
  background: var(--gc-surface-0);
  border-color: var(--gc-primary);
  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.07);
}

/* Tiny pulse for status dots
   PERF: box-shadow ripple triggered repaint on every online dot every frame
   (very expensive on Electron when many users are online). Switched to an
   opacity pulse on the dot itself — GPU-composited, no paint cost. */
.gc-online-dot {
  background: var(--gc-online);
}

/* Subtle entrance for the whole shell on first paint */
@keyframes gc-fade-up {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: none; }
}
.gc-fade-in { animation: gc-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both; }

/* ──────────────────────────────────────────────────────────
   Right panel (Files + Schedule)
   ────────────────────────────────────────────────────────── */
.gc-rpanel-card {
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-divider);
  border-radius: 16px;
  transition: border-color var(--gc-transition-fast), box-shadow var(--gc-transition-fast);
}
.gc-rpanel-card:hover { border-color: var(--gc-border-strong); }

/* Calendar — iOS-inspired, minimal, premium */
.gc-modal-compact .gc-cal-day {
  width: 30px; height: 30px;
  border-radius: 10px;
  font-size: 12px;
}
.gc-modal-compact .gc-cal-weekday {
  font-size: 10px;
  letter-spacing: 0.05em;
}
.gc-cal-day {
  width: 34px; height: 34px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 12px;
  font-size: 13px;
  color: var(--gc-text-primary);
  font-family: var(--gc-font-display);
  font-weight: 500;
  position: relative;
  cursor: pointer;
  border: none;
  background: transparent;
  transition:
    background 220ms cubic-bezier(0.33, 1, 0.68, 1),
    color 220ms cubic-bezier(0.33, 1, 0.68, 1),
    transform 220ms cubic-bezier(0.33, 1, 0.68, 1),
    box-shadow 220ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-cal-day:hover {
  background: var(--gc-surface-2);
  transform: scale(1.04);
}
.gc-cal-day:active { transform: scale(0.96); }
.gc-cal-day.is-today {
  color: var(--gc-primary);
  font-weight: 700;
}
.gc-cal-day.is-today:not(.is-selected) {
  background: var(--gc-primary-container);
}
.gc-cal-day.is-selected {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(31, 46, 35, 0.18);
}
.gc-cal-day.is-other { color: var(--gc-text-disabled); opacity: 0.5; }
.gc-cal-day.has-event::after {
  content: '';
  position: absolute;
  bottom: 5px; left: 50%;
  transform: translateX(-50%);
  width: 4px; height: 4px;
  border-radius: 50%;
  background: var(--gc-accent);
}
.gc-cal-day.is-selected.has-event::after { background: var(--gc-on-primary); }

.gc-cal-weekday {
  width: 34px;
  text-align: center;
  font-family: var(--gc-font-display);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.10em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
  padding-bottom: 6px;
}

/* ──────────────────────────────────────────────────────────
   iOS-style dropdown menu (Meeting picker, etc.)
   ────────────────────────────────────────────────────────── */
@keyframes gc-menu-pop {
  0%   { opacity: 0; transform: translateY(-6px) scale(0.96); }
  60%  { opacity: 1; }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes gc-menu-pop-out {
  from { opacity: 1; transform: translateY(0) scale(1); }
  to   { opacity: 0; transform: translateY(-6px) scale(0.96); }
}
.gc-ios-menu {
  /* PERF: Removed \`backdrop-filter: blur(20px) saturate(180%)\` — Electron's
     compositor can't GPU-accelerate it, causing big lag whenever this menu
     opens. Solid bg is a near-identical look at a fraction of the cost. */
  background: #ffffff;
  border: 1px solid rgba(15, 29, 20, 0.08);
  border-radius: 16px;
  box-shadow:
    0 12px 32px rgba(15, 29, 20, 0.14),
    0 4px 8px rgba(15, 29, 20, 0.06),
    0 0 0 0.5px rgba(15, 29, 20, 0.04);
  overflow: hidden;
  transform-origin: top right;
  animation: gc-menu-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;
}
.gc-ios-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  width: 100%;
  border: none;
  background: transparent;
  font-family: var(--gc-font-display);
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gc-text-primary);
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease;
}
.gc-ios-menu-item:hover { background: var(--gc-surface-2); }
.gc-ios-menu-item:active { background: var(--gc-primary-container); }
.gc-ios-menu-item .gc-ios-menu-glyph {
  width: 30px; height: 30px;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  flex-shrink: 0;
}
.gc-ios-menu-item .gc-ios-menu-glyph.is-accent {
  background: var(--gc-accent-soft);
  color: var(--gc-accent-strong);
}
.gc-ios-menu-divider {
  height: 1px;
  margin: 0 12px;
  background: var(--gc-divider);
}

/* iOS-style segmented control reused for calendar filter pills */
.gc-segmented {
  display: flex;
  padding: 3px;
  background: var(--gc-surface-2);
  border-radius: 11px;
  position: relative;
}
.gc-segmented-pill {
  flex: 1 1;
  padding: 7px 10px;
  border-radius: 8px;
  border: none;
  background: transparent;
  font-family: var(--gc-font-display);
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.005em;
  color: var(--gc-text-tertiary);
  cursor: pointer;
  transition: all 220ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-segmented-pill.is-active {
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  box-shadow: 0 1px 3px rgba(15, 29, 20, 0.10), 0 0 0 0.5px rgba(15, 29, 20, 0.04);
}

/* Three-dot bubble menu — same pop animation but origin-aware */
@keyframes gc-bubble-menu-pop {
  0%   { opacity: 0; transform: translateY(4px) scale(0.94); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
.gc-bubble-menu {
  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;
}
.gc-bubble-menu.origin-right { transform-origin: bottom right; }
.gc-bubble-menu.origin-left  { transform-origin: bottom left; }

/* File-icon plate */
.gc-file-icon {
  width: 36px; height: 36px;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

/* ──────────────────────────────────────────────────────────────────────────
   Presence + Leave Status — 2026-05-03 (priority: on_leave > dnd/away > online > offline)
   ────────────────────────────────────────────────────────────────────────── */
/* Presence status pill tokens (--gc-status-*-{bg,fg,dot}) live in the
   DESIGN TOKENS block at the top of this file. */

/* Pill — used in Employees rows + ChatHeader DM line */
.gc-presence-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 8px;
  border-radius: 999px;
  font-family: var(--gc-font-display);
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.2;
  white-space: nowrap;
  transition: background-color 300ms cubic-bezier(0.33, 1, 0.68, 1),
              color 300ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-presence-pill.is-online  { background: var(--gc-status-online-bg);  color: var(--gc-status-online-fg); }
.gc-presence-pill.is-away    { background: var(--gc-status-away-bg);    color: var(--gc-status-away-fg); }
.gc-presence-pill.is-dnd     { background: color-mix(in srgb, var(--gc-dnd) 14%, var(--gc-surface-0)); color: var(--gc-dnd); }
.gc-presence-pill.is-offline { background: var(--gc-status-offline-bg); color: var(--gc-status-offline-fg); }
.gc-presence-pill.is-leave   { background: var(--gc-status-leave-bg);   color: var(--gc-status-leave-fg); }

/* Dot — small variant for avatar overlays + roster rows */
.gc-presence-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid var(--gc-surface-0, #fff);
  transition: background-color 300ms cubic-bezier(0.33, 1, 0.68, 1);
  position: relative;
}
.gc-presence-dot.is-online  { background: var(--gc-status-online-dot); }
.gc-presence-dot.is-away    { background: var(--gc-status-away-dot); }
.gc-presence-dot.is-dnd     { background: var(--gc-dnd); }
.gc-presence-dot.is-offline { background: var(--gc-status-offline-dot); }
.gc-presence-dot.is-leave   { background: var(--gc-status-leave-dot); }
.gc-presence-dot.is-sm { width: 8px; height: 8px; border-width: 1.5px; }
.gc-presence-dot.is-lg { width: 12px; height: 12px; border-width: 2.5px; }
.gc-presence-dot--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: none;
  background: transparent;
  line-height: 0;
}
.gc-presence-dot--icon .gc-presence-icon-glyph {
  display: block;
  transition: transform 260ms cubic-bezier(0.33, 1, 0.68, 1),
              opacity 260ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-presence-dot--icon.is-online,
.gc-presence-dot--icon.is-away,
.gc-presence-dot--icon.is-dnd,
.gc-presence-dot--icon.is-offline,
.gc-presence-dot--icon.is-leave {
  color: currentColor;
}
.gc-presence-dot--icon.is-online { color: var(--gc-status-online-dot); }
.gc-presence-dot--icon.is-away { color: var(--gc-status-away-dot); }
.gc-presence-dot--icon.is-dnd { color: var(--gc-dnd); }
.gc-presence-dot--icon.is-offline { color: var(--gc-status-offline-dot); }
.gc-presence-dot--icon.is-leave { color: var(--gc-status-leave-dot); }
.gc-presence-dot--icon.is-online::after,
.gc-presence-dot--icon:not(.is-online)::after {
  content: none;
}

/* Conversation title dots intentionally override the shared presence palette:
   Away and Leave must read differently in the dense chat list. */
.gc-conv-row__title-presence-dot.is-away {
  background: #facc15;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px rgba(250, 204, 21, 0.38);
}
.gc-conv-row__title-presence-dot.is-leave {
  background: #f97316;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.12),
    0 0 12px rgba(249, 115, 22, 0.42);
}

/* Static halo ring — only on truly online (not on_leave). Was an infinite
   pulse; see the PERF note on .gc-conv-row__title-presence-dot. */
.gc-presence-dot.is-online::after {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 2px solid var(--gc-status-online-dot);
  opacity: 0.35;
  pointer-events: none;
}

/* Avatar overlay positioning helper */
.gc-presence-overlay {
  position: absolute;
  right: -2px;
  bottom: -2px;
  z-index: 2;
  pointer-events: none;
}

/* Compact DM avatar presence strip */
.gc-avatar-presence-frame {
  width: 40px;
  height: 40px;
  border-radius: 0.75rem;
  overflow: hidden;
  isolation: isolate;
}
.gc-avatar-presence-frame .gc-avatar,
.gc-avatar-presence-frame .gc-avatar__inner,
.gc-avatar-presence-frame .gc-avatar__img {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}
.gc-avatar-presence-strip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 18px;
  padding: 0 2px 3px;
  pointer-events: none;
  overflow: hidden;
  color: #ffffff;
  font-family: var(--gc-font-display);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  text-align: center;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  box-shadow:
    0 -1px 0 rgba(255, 255, 255, 0.10) inset,
    0 -6px 14px rgba(0, 0, 0, 0.18);
}
.gc-avatar-presence-strip__text {
  position: relative;
  z-index: 1;
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-avatar-presence-strip::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.26) 48%, transparent 100%);
  transform: translateX(-120%);
}
.gc-avatar-presence-strip.is-online {
  background: linear-gradient(180deg, rgba(13, 148, 136, 0) 0%, rgba(13, 148, 136, 0.70) 36%, rgba(4, 120, 87, 0.96) 100%);
}
.gc-avatar-presence-strip.is-away {
  background: linear-gradient(180deg, rgba(234, 179, 8, 0) 0%, rgba(202, 138, 4, 0.72) 36%, rgba(133, 77, 14, 0.96) 100%);
}
.gc-avatar-presence-strip.is-dnd {
  background: linear-gradient(180deg, rgba(220, 38, 38, 0) 0%, rgba(220, 38, 38, 0.74) 36%, rgba(127, 29, 29, 0.97) 100%);
}
.gc-avatar-presence-strip.is-offline {
  background: linear-gradient(180deg, rgba(100, 116, 139, 0) 0%, rgba(71, 85, 105, 0.76) 36%, rgba(30, 41, 59, 0.97) 100%);
}
.gc-avatar-presence-strip.is-leave {
  background: linear-gradient(180deg, rgba(249, 115, 22, 0) 0%, rgba(194, 65, 12, 0.74) 36%, rgba(124, 45, 18, 0.97) 100%);
}
.gc-conv-row:hover .gc-avatar-presence-strip {
  filter: saturate(1.1);
}
@media (prefers-reduced-motion: reduce) {
  .gc-avatar-presence-strip,
  .gc-avatar-presence-strip::after {
    animation: none;
    transition: none;
  }
}

/* On-leave system message pill (centered chip rendered by SystemMessagePill) */
.gc-system-leave-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-family: var(--gc-font-display);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.3;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);
  max-width: min(640px, 90%);
  text-align: center;
}
.gc-system-leave-pill.is-start {
  background: var(--gc-status-leave-bg);
  color: var(--gc-status-leave-fg);
  border-color: color-mix(in srgb, var(--gc-status-leave-fg) 28%, transparent);
}
.gc-system-leave-pill.is-end {
  background: var(--gc-status-online-bg);
  color: var(--gc-status-online-fg);
  border-color: color-mix(in srgb, var(--gc-status-online-fg) 28%, transparent);
}
.gc-system-row--away {
  margin: 12px 0;
  padding: 1px 20px;
}
.gc-system-away-pill {
  gap: 8px;
  padding: 5px 14px;
  min-height: 30px;
  max-width: min(560px, calc(100% - 48px));
  background: #facc15;
  color: #1f1a05;
  border-color: color-mix(in srgb, #facc15 72%, #7c4a03);
  box-shadow:
    0 8px 20px rgba(250, 204, 21, 0.14),
    0 1px 0 rgba(255, 255, 255, 0.26) inset;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
}
.gc-system-away-pill.is-start,
.gc-system-away-pill.is-end {
  background: #facc15;
  color: #1f1a05;
}
.gc-system-away-pill.is-dnd {
  background: #dc2626;
  color: #ffffff;
  border-color: color-mix(in srgb, #dc2626 70%, #7f1d1d);
  box-shadow:
    0 8px 20px rgba(220, 38, 38, 0.18),
    0 1px 0 rgba(255, 255, 255, 0.22) inset;
}
.gc-away-remind-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, currentColor 30%, transparent);
  background: color-mix(in srgb, currentColor 9%, transparent);
  color: inherit;
  font: inherit;
  font-size: 11px;
  line-height: 1.1;
  cursor: pointer;
  white-space: nowrap;
}
.gc-away-remind-btn:hover:not(:disabled) {
  background: color-mix(in srgb, currentColor 16%, transparent);
}
.gc-away-remind-btn:disabled {
  cursor: default;
  opacity: 0.72;
}
.gc-pinned-status-notice {
  width: fit-content;
  max-width: calc(100% - 24px);
  justify-content: center;
  box-sizing: border-box;
}
.gc-pinned-status-notice__content {
  flex: 0 1 auto;
  min-width: 0;
  text-align: center;
}

/* ──────────────────────────────────────────────────────────────────────────
   Conversation-row status tag — refined editorial chip
   Used in the chat sidebar, top-right of every DM row.
   Three variants: is-online (emerald pulse), is-leave (amber breath +
   leaf glyph), is-offline (quiet slate, no motion).
   ────────────────────────────────────────────────────────────────────────── */
.gc-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2.5px 8px 2.5px 6px;
  border-radius: 999px;
  font-family: var(--gc-font-display);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid transparent;
  position: relative;
  isolation: isolate;
  transition:
    transform 280ms cubic-bezier(0.33, 1, 0.68, 1),
    box-shadow 280ms cubic-bezier(0.33, 1, 0.68, 1),
    filter 280ms cubic-bezier(0.33, 1, 0.68, 1);
}

.gc-status-tag-glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  position: relative;
}
.gc-status-tag-glyph svg { display: block; }

/* — Online — emerald gradient + soft halo + double-pulse ring — */
.gc-status-tag.is-online {
  background:
    linear-gradient(135deg, #ecfdf5 0%, #d1fae5 60%, #a7f3d0 100%);
  color: #064e3b;
  border-color: rgba(16, 185, 129, 0.35);
  box-shadow:
    0 0 0 1px rgba(16, 185, 129, 0.06) inset,
    0 1px 2px rgba(6, 78, 59, 0.08),
    0 0 8px rgba(16, 185, 129, 0.18);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
}
.gc-status-tag.is-online .gc-status-tag-glyph {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #34d399 0%, #10b981 60%, #059669 100%);
  box-shadow:
    0 0 0 1.5px rgba(16, 185, 129, 0.22),
    0 0 6px rgba(16, 185, 129, 0.55);
}
.gc-status-tag.is-online .gc-status-tag-glyph::before,
.gc-status-tag.is-online .gc-status-tag-glyph::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 1px solid #10b981;
  pointer-events: none;
}
.gc-status-tag.is-online .gc-status-tag-glyph::before {
  opacity: 0.45;
}
.gc-status-tag.is-online .gc-status-tag-glyph::after {
  display: none;
}

/* — On Leave — amber gradient + breathing leaf glyph — */
.gc-status-tag.is-leave {
  background:
    linear-gradient(135deg, #fffbeb 0%, #fef3c7 60%, #fde68a 100%);
  color: #78350f;
  border-color: rgba(217, 119, 6, 0.4);
  box-shadow:
    0 0 0 1px rgba(217, 119, 6, 0.06) inset,
    0 1px 2px rgba(120, 53, 15, 0.10),
    0 0 8px rgba(245, 158, 11, 0.22);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);
}
.gc-status-tag.is-leave .gc-status-tag-glyph {
  color: #b45309;
  width: 9px;
  height: 9px;
  filter: drop-shadow(0 0 2px rgba(245, 158, 11, 0.45));
}

/* — Away — soft yellow, gentle breathing dot (idle but still connected) — */
.gc-status-tag.is-away {
  background:
    linear-gradient(135deg, #fefce8 0%, #fef9c3 60%, #fef08a 100%);
  color: #713f12;
  border-color: rgba(234, 179, 8, 0.38);
  box-shadow:
    0 0 0 1px rgba(234, 179, 8, 0.05) inset,
    0 1px 2px rgba(113, 63, 18, 0.08),
    0 0 8px rgba(234, 179, 8, 0.18);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);
}
.gc-status-tag.is-away .gc-status-tag-glyph {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #facc15 0%, #eab308 60%, #ca8a04 100%);
  box-shadow:
    0 0 0 1.5px rgba(234, 179, 8, 0.22),
    0 0 6px rgba(234, 179, 8, 0.40);
}

/* — Offline — whisper-quiet — */
.gc-status-tag.is-offline {
  background: var(--gc-surface-1);
  color: #64748b;
  border-color: var(--gc-divider);
  opacity: 0.78;
  box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.04) inset;
}
.gc-status-tag.is-offline .gc-status-tag-glyph {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: inset 0 0 0 1px #94a3b8;
}

/* Row-hover lift (parent .gc-conv-row hovered) */
.gc-conv-row:hover .gc-status-tag.is-online,
.gc-conv-row:hover .gc-status-tag.is-away,
.gc-conv-row:hover .gc-status-tag.is-leave {
  transform: translateY(-0.5px);
  filter: saturate(1.08);
}
.gc-conv-row:hover .gc-status-tag.is-offline {
  opacity: 0.95;
}

/* Reduced motion — kill animations but keep visuals intact */
@media (prefers-reduced-motion: reduce) {
  .gc-status-tag.is-online .gc-status-tag-glyph::before,
  .gc-status-tag.is-online .gc-status-tag-glyph::after,
  .gc-status-tag.is-away .gc-status-tag-glyph,
  .gc-status-tag.is-leave .gc-status-tag-glyph {
    animation: none;
  }
}

/* Group chat header chip — "N on leave" — clickable */
.gc-group-onleave-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--gc-status-leave-bg);
  color: var(--gc-status-leave-fg);
  font-family: var(--gc-font-display);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: transform 150ms cubic-bezier(0.33, 1, 0.68, 1),
              filter 150ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-group-onleave-chip:hover { filter: brightness(0.97); transform: translateY(-1px); }
.gc-group-onleave-chip:active { transform: translateY(0); }

/* ──────────────────────────────────────────────────────────────────────────
   Editorial system message divider — replaces the flat italic gray fallback.
   Used by SystemMessagePill (default branch) and the legacy SystemMessageRow.
   Composition:
     [hairline gradient rule] · sparkle · serif-italic copy · sparkle · [rule]
   The rules fade in from the gutters using a tinted gradient so the row
   feels like a drop-cap chapter break rather than a generic separator.
   ────────────────────────────────────────────────────────────────────────── */
.gc-system-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 14px 0;
  padding: 0 24px;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
}
.gc-system-row > .gc-system-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: var(--gc-status-leave-bg);
  border: 1px solid color-mix(in srgb, var(--gc-status-leave-fg) 28%, transparent);
  box-shadow: 0 1px 2px color-mix(in srgb, var(--gc-status-leave-fg) 12%, transparent);
  max-width: min(640px, 90%);
}
.gc-system-flourish {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: color-mix(in srgb, var(--gc-status-leave-fg) 80%, var(--gc-status-leave-bg));
  flex-shrink: 0;
}
.gc-system-text {
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.005em;
  color: var(--gc-status-leave-fg);
  text-align: center;
  padding: 0 2px;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
  font-family: var(--gc-font-display);
}

/* ──────────────────────────────────────────────────────────────────────────
   Deleted message tombstone — refined, with optional deleter attribution.
   Replaces the previous flat gray italic line. Bubble-aligned, soft-tinted,
   with a tiny "trash" glyph and an italic micro-line for the deleter name.
   ────────────────────────────────────────────────────────────────────────── */
.gc-deleted-bubble {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 10px;
  border-radius: 14px;
  background: color-mix(in srgb, var(--gc-text-tertiary) 6%, var(--gc-surface-0));
  border: 1px dashed color-mix(in srgb, var(--gc-text-tertiary) 32%, transparent);
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font);
  font-size: 12.5px;
  font-style: italic;
  line-height: 1.35;
  max-width: min(420px, 78%);
}
.gc-deleted-bubble-icon {
  flex-shrink: 0;
  color: color-mix(in srgb, var(--gc-dnd) 55%, var(--gc-text-tertiary));
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gc-deleted-bubble-text { display: flex; flex-direction: column; line-height: 1.3; }
.gc-deleted-bubble-main { color: var(--gc-text-secondary); }
.gc-deleted-bubble-by {
  margin-top: 1px;
  font-style: normal;
  font-size: 10.5px;
  color: var(--gc-text-tertiary);
  letter-spacing: 0.01em;
}
.gc-deleted-bubble-by b {
  font-weight: 600;
  color: color-mix(in srgb, var(--gc-text-secondary) 88%, var(--gc-primary));
}

/* ──────────────────────────────────────────────────────────────────────────
   Header inline action chip — used to surface "Select messages" beside the
   three-dot menu rather than burying it inside a popover.
   ────────────────────────────────────────────────────────────────────────── */
.gc-header-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px 5px 9px;
  border-radius: 999px;
  font-family: var(--gc-font-display);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.005em;
  color: var(--gc-text-secondary);
  background: var(--gc-surface-2);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 160ms cubic-bezier(0.33,1,0.68,1),
              color 160ms cubic-bezier(0.33,1,0.68,1),
              transform 160ms cubic-bezier(0.33,1,0.68,1),
              border-color 160ms cubic-bezier(0.33,1,0.68,1);
  white-space: nowrap;
}
.gc-header-chip:hover {
  background: color-mix(in srgb, var(--gc-primary) 8%, var(--gc-surface-2));
  color: var(--gc-primary);
  transform: translateY(-1px);
}
.gc-header-chip.is-active {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  border-color: color-mix(in srgb, var(--gc-primary) 30%, transparent);
}

/* ──────────────────────────────────────────────────────────────────────────
   Voice recorder panel — anchored above composer (composer-attached),
   replacing the prior fullscreen bottom-modal that left huge dead space.
   ────────────────────────────────────────────────────────────────────────── */
.gc-voice-panel {
  position: relative;
  margin: 8px 12px 0;
  padding: 8px 12px;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--gc-primary) 5%, var(--gc-surface-0)) 0%,
    var(--gc-surface-0) 100%
  );
  border: 1px solid color-mix(in srgb, var(--gc-primary) 22%, var(--gc-border));
  box-shadow: 0 8px 28px -16px color-mix(in srgb, var(--gc-primary) 40%, transparent);
  display: flex;
  align-items: center;
  gap: 10px;
}

/* ──────────────────────────────────────────────────────────────────────────
   Section header trailing folio — keeps the calendar's month-nav from
   colliding with the "ii. Schedule" chapter title in the right panel.
   Adds a small breath gap so chevrons & numerals don't smash into them.
   ────────────────────────────────────────────────────────────────────────── */
.gc-rpanel-card .gc-cal-header-spacer { height: 6px; }


/* ──────────────────────────────────────────────────────────────────────────
   FINAL FORM-CONTROL & SHADCN POLISH
   Themes form controls (checkbox, radio, range, date/time pickers) and
   shadcn Button/Card/Input variants project-wide so every page matches the
   task management aesthetic.
   ────────────────────────────────────────────────────────────────────── */

/* Checkbox & radio — themed accent color and minimal visual */
.gt-themed input[type="checkbox"]:not([class*="gt-"]),
.gt-themed input[type="radio"]:not([class*="gt-"]) {
  accent-color: var(--gt-primary);
  cursor: pointer;
}

/* Range slider tone */
.gt-themed input[type="range"]:not([class*="gt-"]) {
  accent-color: var(--gt-primary);
}

/* Native date / time / datetime-local pickers — round corners + theme padding */
.gt-themed input[type="date"]:not([class*="gt-"]),
.gt-themed input[type="time"]:not([class*="gt-"]),
.gt-themed input[type="datetime-local"]:not([class*="gt-"]),
.gt-themed input[type="month"]:not([class*="gt-"]),
.gt-themed input[type="week"]:not([class*="gt-"]) {
  padding: 9px 14px !important;
  font-family: var(--gt-font-mono) !important;
  font-feature-settings: 'tnum' 1, 'lnum' 1 !important;
  letter-spacing: 0.01em !important;
}

/* shadcn-style Button variants — auto-style by data-variant or class hint */
.gt-themed button[class*="default"]:not([class*="bg-"]):not([class*="gt-"]),
.gt-themed [data-variant="default"]:not([class*="bg-"]):not([class*="gt-"]) {
  background: var(--gt-primary) !important;
  color: var(--gt-on-primary) !important;
  border: 1px solid transparent !important;
  border-radius: var(--gt-radius-pill) !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 600 !important;
  padding: 9px 18px !important;
  transition: background var(--gt-t-fast), transform var(--gt-t-fast), box-shadow var(--gt-t-fast) !important;
}
.gt-themed button[class*="default"]:not([class*="bg-"]):not([class*="gt-"]):hover,
.gt-themed [data-variant="default"]:not([class*="bg-"]):not([class*="gt-"]):hover {
  background: var(--gt-primary-hover) !important;
  box-shadow: var(--gt-glow) !important;
}

.gt-themed button[class*="outline"]:not([class*="bg-"]):not([class*="gt-"]):not([class*="gc-"]):not([class*="focus:outline-none"]),
.gt-themed [data-variant="outline"]:not([class*="bg-"]):not([class*="gt-"]):not([class*="gc-"]) {
  background: var(--gt-surface-0) !important;
  color: var(--gt-text-primary) !important;
  border: 1px solid var(--gt-border) !important;
  border-radius: var(--gt-radius-pill) !important;
  font-family: var(--gt-font-display) !important;
  font-weight: 600 !important;
  transition: border-color var(--gt-t-fast), background var(--gt-t-fast) !important;
}
.gt-themed button[class*="outline"]:not([class*="bg-"]):not([class*="gt-"]):not([class*="gc-"]):not([class*="focus:outline-none"]):hover,
.gt-themed [data-variant="outline"]:not([class*="bg-"]):not([class*="gt-"]):not([class*="gc-"]):hover {
  border-color: var(--gt-border-strong) !important;
  background: var(--gt-surface-1) !important;
}

.gt-themed button[class*="ghost"]:not([class*="bg-"]):not([class*="gt-"]),
.gt-themed [data-variant="ghost"]:not([class*="bg-"]):not([class*="gt-"]) {
  background: transparent !important;
  color: var(--gt-text-secondary) !important;
  border: 1px solid transparent !important;
  border-radius: var(--gt-radius-pill) !important;
}
.gt-themed button[class*="ghost"]:not([class*="bg-"]):not([class*="gt-"]):hover,
.gt-themed [data-variant="ghost"]:not([class*="bg-"]):not([class*="gt-"]):hover {
  background: var(--gt-surface-2) !important;
  color: var(--gt-text-primary) !important;
}

.gt-themed button[class*="destructive"]:not([class*="bg-"]):not([class*="gt-"]),
.gt-themed [data-variant="destructive"]:not([class*="bg-"]):not([class*="gt-"]) {
  background: var(--gt-dnd) !important;
  color: #ffffff !important;
  border: 1px solid transparent !important;
  border-radius: var(--gt-radius-pill) !important;
  font-weight: 600 !important;
}
.gt-themed button[class*="destructive"]:not([class*="bg-"]):not([class*="gt-"]):hover {
  background: #a83c34 !important;
}

/* shadcn Card pattern — already mapped via .bg-card; ensure padding & radius */
.gt-themed [class*="rounded-lg"][class*="border"][class*="bg-card"],
.gt-themed [class*="rounded-xl"][class*="border"][class*="bg-card"],
.gt-themed [class*="rounded-2xl"][class*="border"][class*="bg-card"] {
  background: var(--gt-surface-0) !important;
  border-color: var(--gt-border) !important;
  box-shadow: var(--gt-elev-1) !important;
  border-radius: var(--gt-radius-card) !important;
}

/* shadcn Tab/Trigger — themed underline + colors */
.gt-themed [role="tab"] {
  font-family: var(--gt-font-display);
  font-weight: 600;
  font-size: 13px;
  color: var(--gt-text-tertiary);
  border-radius: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  transition: color var(--gt-t-fast), border-color var(--gt-t-fast);
}
.gt-themed [role="tab"]:hover { color: var(--gt-text-primary); }

/* shadcn Switch — track + thumb in theme tones */
.gt-themed [role="switch"][data-state="checked"] {
  background-color: var(--gt-primary) !important;
}
.gt-themed [role="switch"][data-state="unchecked"] {
  background-color: var(--gt-surface-3) !important;
}

/* shadcn Avatar fallback */
.gt-themed [class*="rounded-full"][class*="bg-muted"] {
  background-color: var(--gt-primary-container) !important;
  color: var(--gt-primary-deep) !important;
  font-family: var(--gt-font-display);
  font-weight: 700;
}

/* shadcn Separator */
.gt-themed [role="separator"],
.gt-themed [data-orientation="horizontal"][class*="bg-border"] {
  background: var(--gt-divider) !important;
}

/* Generic page wrappers (min-h-screen / h-screen with light bg) → cream */
.gt-themed .min-h-screen.bg-white,
.gt-themed .min-h-screen.bg-gray-50,
.gt-themed .min-h-screen.bg-gray-100,
.gt-themed .h-screen.bg-white,
.gt-themed .h-screen.bg-gray-50 {
  background: var(--gt-surface-1) !important;
}

/* Common section divider — dashed border that pages use */
.gt-themed [class*="border-t-2"][class*="border-dashed"],
.gt-themed [class*="border-b-2"][class*="border-dashed"] {
  border-color: var(--gt-border-strong) !important;
  border-style: dashed !important;
}

/* ──────────────────────────────────────────────────────────────────────────
   APP CHROME — Sidebar, Topbar, Page Headers, Stat Tiles, Filter Pills
   These are the reusable structural components that frame every page.
   Consuming these classes (rather than raw Tailwind) means a single change
   in this file restyles the entire application chrome.
   ──────────────────────────────────────────────────────────────────────── */

/* ── Sidebar ───────────────────────────────────────────────────────────── */
.gt-sidebar {
  background: var(--gt-surface-rail-soft);
  font-family: var(--gt-font);
  color: var(--gt-text-primary);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04), 0 6px 18px rgba(15, 29, 20, 0.05);
  transition: width 0.22s ease, background var(--gt-t-mid);
}
.gt-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid var(--gt-divider);
  min-height: 64px;
  overflow: hidden;
}
.gt-sidebar.is-collapsed .gt-sidebar-header {
  justify-content: center;
  padding: 26px 12px 10px;
  overflow: visible;
}
.gt-sidebar-brand {
  font-family: var(--gt-font-display);
  font-weight: 700;
  font-size: 18px;
  letter-spacing: var(--gt-letter-display);
  color: var(--gt-text-primary);
  flex-shrink: 0;
}
.gt-sidebar-collapse {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: var(--gt-text-tertiary);
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast), border-color var(--gt-t-fast);
}
.gt-sidebar-collapse:hover {
  background: var(--gt-surface-2);
  color: var(--gt-text-primary);
  border-color: var(--gt-border);
}
.gt-sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.gt-sidebar-nav::-webkit-scrollbar { width: 6px; }
.gt-sidebar-nav::-webkit-scrollbar-thumb {
  background: var(--gt-border-strong);
  border-radius: 999px;
}

.gt-sidebar-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  font-family: var(--gt-font);
  font-size: 14px;
  font-weight: 500;
  color: var(--gt-text-secondary);
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  transition: background var(--gt-t-fast), color var(--gt-t-fast),
              border-color var(--gt-t-fast), transform var(--gt-t-fast);
}
.gt-sidebar-item:hover {
  background: var(--gt-surface-hover);
  color: var(--gt-text-primary);
}
.gt-sidebar-item.is-active {
  background: var(--gt-primary-container);
  color: var(--gt-primary-deep);
  font-weight: 600;
}
.gt-sidebar-item.is-active:hover {
  background: var(--gt-primary-container-hover);
}
.gt-sidebar-item .gt-sidebar-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: currentColor;
  opacity: 0.85;
}
.gt-sidebar-item.is-active .gt-sidebar-icon {
  opacity: 1;
  color: var(--gt-primary);
}
.gt-sidebar-item .gt-sidebar-label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 1;
  max-width: 200px;
  transition: opacity 0.18s ease, max-width 0.18s ease;
}
.gt-sidebar-item .gt-sidebar-chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--gt-text-tertiary);
  opacity: 1;
  max-width: 20px;
  overflow: hidden;
  transition: transform var(--gt-t-fast), opacity 0.18s ease, max-width 0.18s ease;
}
.gt-sidebar-item[aria-expanded="true"] .gt-sidebar-chevron {
  color: var(--gt-text-secondary);
}

/* Collapsed state — fade labels and chevrons out.
   Zero the flex gap so group items (which carry an extra hidden chevron
   child) center on the icon the same way leaf items do — otherwise the
   gap on either side of the collapsed label pushes the icon off-center. */
.gt-sidebar.is-collapsed .gt-sidebar-item {
  justify-content: center;
  gap: 0;
}
.gt-sidebar.is-collapsed .gt-sidebar-label,
.gt-sidebar.is-collapsed .gt-sidebar-chevron {
  opacity: 0;
  max-width: 0;
  pointer-events: none;
}

/* Brand text */
.gt-sidebar-brand {
  opacity: 1;
  max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  transition: opacity 0.18s ease, max-width 0.18s ease;
}
.gt-sidebar.is-collapsed .gt-sidebar-brand {
  opacity: 0;
  max-width: 0;
}

/* Sidebar attendance clock — compact rail control above notifications */
.gt-sidebar-clock-slot {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 8px 8px;
}
.gt-sidebar-header .gt-sidebar-clock-slot {
  padding: 0;
}
.gt-sidebar-clock-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 14px;
  border: 1px solid var(--gt-border);
  background: var(--gt-surface-1);
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),
              color var(--gt-t-fast), transform var(--gt-t-fast),
              box-shadow var(--gt-t-fast);
}
.gt-sidebar-clock-btn:hover:not(:disabled):not(.is-disabled) {
  background: var(--gt-surface-hover);
  color: var(--gt-text-primary);
  transform: translateY(-1px);
}
.gt-sidebar-clock-btn.is-clock-in {
  background: linear-gradient(135deg, #ecfdf5 0%, #dff7ec 100%);
  border-color: rgba(16, 185, 129, 0.36);
  color: #047857;
  box-shadow: 0 8px 18px rgba(16, 185, 129, 0.12);
}
.gt-sidebar-clock-btn.is-clock-in:hover:not(:disabled):not(.is-disabled) {
  background: linear-gradient(135deg, #d1fae5 0%, #bbf7d0 100%);
  border-color: rgba(5, 150, 105, 0.48);
  color: #065f46;
  box-shadow: 0 11px 24px rgba(16, 185, 129, 0.22);
}
.gt-sidebar-clock-btn.is-clock-out {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border-color: rgba(245, 158, 11, 0.42);
  color: #b45309;
  box-shadow: 0 8px 18px rgba(245, 158, 11, 0.13);
}
.gt-sidebar-clock-btn.is-clock-out:hover:not(:disabled):not(.is-disabled) {
  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
  border-color: rgba(217, 119, 6, 0.54);
  color: #92400e;
  box-shadow: 0 11px 24px rgba(245, 158, 11, 0.22);
}
/* PERF: static ring instead of a box-shadow keyframe loop (repaint/frame).
   The hover rule above is more specific, and an animation used to outrank it
   automatically — so the second selector re-states the ring for the hovered
   case, or the "shift running" cue vanished exactly as the user reached for
   the button to clock out. */
.gt-sidebar-clock-btn.is-active,
.gt-sidebar-clock-btn.is-clock-out.is-active:hover:not(:disabled):not(.is-disabled) {
  box-shadow:
    0 8px 18px rgba(245, 158, 11, 0.16),
    0 0 0 3px rgba(245, 158, 11, 0.14);
}
.gt-sidebar-clock-btn.is-done {
  color: var(--gt-text-tertiary);
  background: var(--gt-surface-2);
}
.gt-sidebar-clock-btn:disabled,
.gt-sidebar-clock-btn.is-disabled {
  cursor: default;
  opacity: 0.72;
}
.gt-sidebar-clock-btn__icon {
  width: 18px;
  height: 18px;
}
.gt-sidebar-clock-btn__icon.is-spinning {
  animation: gt-spin 0.9s linear infinite;
}
.gt-sidebar-clock-btn__dot {
  position: absolute;
  right: 7px;
  top: 7px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #10b981;
  box-shadow: 0 0 0 2px var(--gt-surface-1);
}
.gt-sidebar-clock-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% - 2px);
  z-index: 40;
  box-sizing: border-box;
  width: max-content;
  max-width: 66px;
  padding: 5px 7px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.94);
  color: #fff;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1.05;
  text-align: center;
  white-space: normal;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 2px) scale(0.96);
  transform-origin: bottom center;
  transition: opacity var(--gt-t-fast), transform var(--gt-t-fast);
}
.gt-sidebar-clock-tooltip::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -4px;
  width: 8px;
  height: 8px;
  background: rgba(15, 23, 42, 0.94);
  transform: translateX(-50%) rotate(45deg);
}
.gt-sidebar-clock-slot:hover .gt-sidebar-clock-tooltip,
.gt-sidebar-clock-btn:focus-visible + .gt-sidebar-clock-tooltip {
  opacity: 1;
  transform: translate(-50%, 0) scale(1);
}
.gt-sidebar-clock-confirmation {
  position: fixed;
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  box-sizing: border-box;
  min-height: 44px;
  max-width: min(248px, calc(100vw - 24px));
  padding: 9px 12px 10px 10px;
  border: 1px solid rgba(20, 184, 166, 0.28);
  border-radius: 12px;
  background: rgba(240, 253, 250, 0.98);
  color: #134e4a;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;
  overflow: hidden;
  pointer-events: none;
  transform: translate(-4px, -50%) scale(0.96);
  transform-origin: left center;
  opacity: 0;
  animation: gt-clock-confirmation-pop 0.32s cubic-bezier(0.2, 0.9, 0.24, 1.18) forwards;
}
.gt-sidebar-clock-confirmation.is-out {
  border-color: rgba(234, 88, 12, 0.28);
  background: rgba(255, 247, 237, 0.98);
  color: #7c2d12;
}
.gt-sidebar-clock-confirmation::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, #0d9488, #14b8a6);
  transform-origin: left center;
  animation: gt-clock-confirmation-progress 3.6s linear forwards;
}
.gt-sidebar-clock-confirmation.is-out::after {
  background: linear-gradient(90deg, #ea580c, #f59e0b);
}
.gt-sidebar-clock-confirmation__icon {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  color: #0d9488;
}
.gt-sidebar-clock-confirmation.is-out .gt-sidebar-clock-confirmation__icon {
  color: #ea580c;
}
.gt-sidebar-clock-confirmation__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
  line-height: 1.2;
}
.gt-sidebar-clock-confirmation__copy strong {
  font-size: 12.5px;
  font-weight: 800;
  color: currentColor;
  white-space: nowrap;
}
.gt-sidebar-clock-confirmation__copy small {
  font-size: 11px;
  font-weight: 600;
  color: currentColor;
  opacity: 0.74;
  white-space: nowrap;
}
@keyframes gt-spin {
  to { transform: rotate(360deg); }
}
@keyframes gt-clock-confirmation-pop {
  0% { opacity: 0; transform: translate(-8px, -50%) scale(0.94); }
  72% { opacity: 1; transform: translate(1px, -50%) scale(1.01); }
  100% { opacity: 1; transform: translate(0, -50%) scale(1); }
}
@keyframes gt-clock-confirmation-progress {
  to { transform: scaleX(0); }
}
@media (prefers-reduced-motion: reduce) {
  .gt-sidebar-clock-btn,
  .gt-sidebar-clock-btn.is-active,
  .gt-sidebar-clock-btn__dot,
  .gt-sidebar-clock-tooltip,
  .gt-sidebar-clock-confirmation,
  .gt-sidebar-clock-confirmation::after {
    animation: none;
    transition: none;
  }
}
html.os-mac .gt-sidebar-clock-btn {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

/* Notification bells row */
.gt-sidebar-bells {
  display: flex;
  gap: 4px;
  padding: 0 8px 8px 8px;
  justify-content: flex-start;
  border-bottom: 1px solid var(--gt-divider, rgba(0,0,0,.06));
  margin-bottom: 8px;
  transition: justify-content 0s;
}
.gt-sidebar-bells.is-collapsed {
  justify-content: center;
}

/* Task nav panel — right-edge resize handle. The hit-area is invisible; a small
   grip pill fades in on hover/drag so it's discoverable without adding chrome. */
.gt-task-panel__resize::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3px;
  height: 34px;
  border-radius: 999px;
  background: var(--gt-border-strong);
  opacity: 0;
  transition: opacity 0.15s ease;
}
.gt-task-panel__resize:hover::after,
.gt-task-panel__resize:active::after {
  opacity: 1;
}

/* Submenu — animate open/close with max-height */
.gt-sidebar-submenu-outer {
  overflow: hidden;
  transition: max-height 0.25s ease;
}
.gt-sidebar-submenu {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin: 4px 0 6px 16px;
  padding-left: 14px;
  border-left: 1px solid var(--gt-divider);
}
.gt-sidebar-subitem {
  display: block;
  padding: 8px 12px;
  border-radius: 10px;
  font-family: var(--gt-font);
  font-size: 13px;
  font-weight: 500;
  color: var(--gt-text-tertiary);
  text-decoration: none;
  transition: background var(--gt-t-fast), color var(--gt-t-fast);
}
.gt-sidebar-subitem:hover {
  background: var(--gt-surface-hover);
  color: var(--gt-text-primary);
}
.gt-sidebar-subitem.is-active {
  background: var(--gt-primary-container);
  color: var(--gt-primary-deep);
  font-weight: 600;
}

/* .gt-sidebar.is-minimized replaced by .gt-sidebar.is-collapsed above */

.gt-sidebar-tooltip {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
  padding: 6px 10px;
  background: var(--gt-primary-deep);
  color: #ffffff;
  font-family: var(--gt-font);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity var(--gt-t-fast);
  z-index: 60;
  box-shadow: var(--gt-elev-3);
}
.gt-sidebar-item-wrap:hover .gt-sidebar-tooltip { opacity: 1; }

.gt-sidebar-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  min-width: 22px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  font-family: var(--gt-font);
  font-size: 11px;
  font-weight: 700;
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  line-height: 1;
}

/* ── Topbar (header) ───────────────────────────────────────────────────── */
.gt-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 28px;
  background: var(--gt-surface-rail-soft);
  border-bottom: 1px solid var(--gt-border);
  font-family: var(--gt-font);
  color: var(--gt-text-primary);
  min-height: 64px;
  position: relative;
  z-index: 30;
}
.gt-topbar-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
.gt-topbar-action {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast),
              border-color var(--gt-t-fast);
}
.gt-topbar-action:hover {
  background: var(--gt-surface-2);
  color: var(--gt-text-primary);
  border-color: var(--gt-border);
}
.gt-topbar-action.is-active {
  background: var(--gt-primary-container);
  color: var(--gt-primary-deep);
  border-color: var(--gt-primary-container-hover);
}
.gt-topbar-menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid var(--gt-border);
  background: var(--gt-surface-0);
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast);
}
.gt-topbar-menu-btn:hover {
  background: var(--gt-surface-2);
  color: var(--gt-text-primary);
}

/* ── Page Header ───────────────────────────────────────────────────────── */
.gt-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 32px 32px 24px;
  flex-wrap: wrap;
}
.gt-page-header-text { flex: 1 1; min-width: 280px; }
.gt-page-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.gt-page-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--gt-font);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: var(--gt-letter-eyebrow);
  color: var(--gt-text-tertiary);
  margin-bottom: 10px;
}
.gt-page-eyebrow::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gt-primary);
  display: inline-block;
}
.gt-page-heading {
  font-family: var(--gt-font-display);
  font-size: clamp(28px, 3.2vw, 40px);
  font-weight: 700;
  letter-spacing: var(--gt-letter-display);
  color: var(--gt-text-primary);
  line-height: 1.1;
  margin: 0;
}
.gt-page-heading em,
.gt-page-heading i {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 500;
  color: var(--gt-primary);
  letter-spacing: 0;
}
.gt-page-subheading {
  font-family: var(--gt-font);
  font-size: 14px;
  font-weight: 500;
  color: var(--gt-text-tertiary);
  margin-top: 8px;
  line-height: 1.5;
}
.gt-page-subheading em,
.gt-page-subheading i {
  font-family: var(--gt-font-serif);
  font-style: italic;
  color: var(--gt-text-secondary);
}

/* ── Stat Tile (the "TOTAL TASKS / OPEN TASKS / OVERDUE" cards) ───────── */
.gt-stat-tile {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--gt-elev-1);
  transition: box-shadow var(--gt-t-fast), transform var(--gt-t-fast),
              border-color var(--gt-t-fast);
  font-family: var(--gt-font);
  position: relative;
}
.gt-stat-tile:hover {
  box-shadow: var(--gt-elev-2);
  transform: translateY(-1px);
  border-color: var(--gt-border-strong);
}
.gt-stat-tile-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: var(--gt-letter-eyebrow);
  color: var(--gt-text-tertiary);
}
.gt-stat-tile-label-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  background: var(--gt-primary-container);
  color: var(--gt-primary);
}
.gt-stat-tile-value {
  font-family: var(--gt-font-display);
  font-size: 38px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--gt-text-primary);
  line-height: 1;
}
.gt-stat-tile-meta {
  font-size: 12px;
  color: var(--gt-text-tertiary);
  font-weight: 500;
}

/* Stat tile color variants — use the priority/status palette */
.gt-stat-tile.is-success .gt-stat-tile-label-icon {
  background: #e8efe9; color: #0f2d1f;
}
.gt-stat-tile.is-warning .gt-stat-tile-label-icon {
  background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg);
}
.gt-stat-tile.is-danger .gt-stat-tile-label-icon {
  background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg);
}
.gt-stat-tile.is-info .gt-stat-tile-label-icon {
  background: var(--gt-prio-low-bg); color: var(--gt-prio-low-fg);
}

/* ── Filter Pill (the "All / To Do / In Progress / Blocked" tabs) ─────── */
.gt-filter-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 14px;
  border: 1px solid var(--gt-border);
  background: var(--gt-surface-0);
  font-family: var(--gt-font);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),
              transform var(--gt-t-fast), box-shadow var(--gt-t-fast);
}
.gt-filter-pill:hover {
  border-color: var(--gt-border-strong);
  transform: translateY(-1px);
  box-shadow: var(--gt-elev-1);
}
.gt-filter-pill.is-active {
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  border-color: var(--gt-primary);
}
.gt-filter-pill-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9px;
  background: var(--gt-primary-container);
  color: var(--gt-primary);
}
.gt-filter-pill.is-active .gt-filter-pill-icon {
  background: rgba(255, 255, 255, 0.18);
  color: var(--gt-on-primary);
}
.gt-filter-pill-count {
  font-family: var(--gt-font-display);
  font-size: 18px;
  font-weight: 800;
  color: var(--gt-text-primary);
  letter-spacing: -0.02em;
}
.gt-filter-pill.is-active .gt-filter-pill-count { color: var(--gt-on-primary); }

/* Filter pill semantic variants for state colors */
.gt-filter-pill.tone-todo .gt-filter-pill-icon {
  background: var(--gt-status-pending-bg); color: var(--gt-status-pending-fg);
}
.gt-filter-pill.tone-progress .gt-filter-pill-icon {
  background: var(--gt-status-progress-bg); color: var(--gt-status-progress-fg);
}
.gt-filter-pill.tone-review .gt-filter-pill-icon {
  background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg);
}
.gt-filter-pill.tone-blocked .gt-filter-pill-icon {
  background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg);
}
.gt-filter-pill.tone-done .gt-filter-pill-icon {
  background: var(--gt-status-done-bg); color: var(--gt-status-done-fg);
}

/* ── Page action buttons (Create / Recently Deleted) ──────────────────── */
.gt-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: 999px;
  border: 1px solid var(--gt-primary);
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  font-family: var(--gt-font);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast),
              transform var(--gt-t-fast), box-shadow var(--gt-t-fast);
  text-decoration: none;
}
.gt-action-btn:hover {
  background: var(--gt-primary-hover);
  border-color: var(--gt-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--gt-glow);
}
.gt-action-btn.is-ghost {
  background: var(--gt-surface-0);
  color: var(--gt-text-primary);
  border-color: var(--gt-border-strong);
}
.gt-action-btn.is-ghost:hover {
  background: var(--gt-surface-2);
  border-color: var(--gt-text-tertiary);
}
.gt-action-btn.is-danger-outline {
  background: transparent;
  color: var(--gt-dnd);
  border-color: var(--gt-dnd);
}
.gt-action-btn.is-danger-outline:hover {
  background: var(--gt-prio-urgent-bg);
  border-color: var(--gt-dnd);
  color: var(--gt-prio-urgent-fg);
}

/* ── Tab strip (All Tasks / My Tasks / Team Tasks) ─────────────────────── */
.gt-tab-strip {
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid var(--gt-divider);
  padding: 0 4px;
}
.gt-tab-strip-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 4px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: var(--gt-font);
  font-size: 14px;
  font-weight: 600;
  color: var(--gt-text-tertiary);
  cursor: pointer;
  transition: color var(--gt-t-fast), border-color var(--gt-t-fast);
  margin-bottom: -1px;
}
.gt-tab-strip-item:hover { color: var(--gt-text-primary); }
.gt-tab-strip-item.is-active {
  color: var(--gt-text-primary);
  border-bottom-color: var(--gt-primary);
}

/* When sidebar/topbar are inside .gt-themed shell, suppress legacy
   Tailwind compatibility overrides that would otherwise re-paint them. */
.gt-themed .gt-sidebar,
.gt-themed .gt-topbar,
.gt-themed .gt-sidebar *,
.gt-themed .gt-topbar * { font-family: var(--gt-font); }

/* ──────────────────────────────────────────────────────────────────────────
   TeamLio Expense Shell — full TeamLio HR layout for the canonical /expenses
   route inside Messenger. It intentionally opts out of the floating Messenger
   AppShell chrome while reusing the same TeamLio tokens and page components.
   ────────────────────────────────────────────────────────────────────────── */
.teamlio-expense-shell {
  display: flex;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--gt-surface-1, #ffffff);
  color: var(--gt-text-primary, #1a1a1a);
  font-family: var(--gt-font);
}

.teamlio-expense-sidebar.gt-sidebar {
  width: 264px;
  min-width: 264px;
  max-width: 264px;
  border-radius: 0;
  box-shadow: none;
  border-right: 1px solid var(--gt-border, #e8e3d8);
  background: var(--gt-surface-rail-soft, #ffffff);
}

.teamlio-expense-sidebar.gt-sidebar.is-collapsed {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.teamlio-expense-sidebar .gt-sidebar-header {
  min-height: 124px;
  padding: 26px 20px 20px;
}

.teamlio-expense-sidebar .gt-sidebar-identity {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1 1;
}

.teamlio-expense-sidebar .gt-sidebar-user {
  min-width: 0;
  font-family: var(--gt-font-display);
  font-weight: 800;
  font-size: 16px;
  line-height: 1.18;
  letter-spacing: var(--gt-letter-display);
  color: var(--gt-text-primary);
  overflow-wrap: anywhere;
}

.teamlio-expense-sidebar .gt-sidebar-role {
  font-family: var(--gt-font-mono);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--gt-primary);
  white-space: nowrap;
}

.teamlio-expense-sidebar .gt-sidebar-company {
  margin-top: 4px;
  font-family: var(--gt-font-serif);
  font-size: 13px;
  font-style: italic;
  font-weight: 500;
  color: var(--gt-text-secondary);
}

.teamlio-expense-shell__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--gt-surface-1, #ffffff);
}

.teamlio-expense-topbar.gt-topbar {
  min-height: 88px;
  padding: 0 28px;
  background: var(--gt-surface-rail-soft, #ffffff);
  border-bottom: 1px solid var(--gt-divider, #efeae0);
}

.teamlio-expense-ticker {
  min-width: 0;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--gt-primary, #0f2d1f);
}

.teamlio-expense-ticker strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 800;
}

.teamlio-expense-ticker button {
  flex-shrink: 0;
  border: 0;
  background: transparent;
  color: var(--gt-text-tertiary, #8a8580);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.teamlio-expense-bell span {
  position: absolute;
  top: -3px;
  right: -3px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--gt-red-600, #dc2626);
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  line-height: 19px;
  text-align: center;
}

.teamlio-expense-shell__content {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  background: var(--gt-surface-1, #ffffff);
}

.teamlio-expense-shell__content > * {
  min-height: 100%;
}

@media (max-width: 767px) {
  .teamlio-expense-shell {
    display: block;
    overflow: auto;
  }

  .teamlio-expense-sidebar.gt-sidebar {
    display: none !important;
  }

  .teamlio-expense-topbar.gt-topbar {
    min-height: 64px;
    padding: 0 14px;
  }

  .teamlio-expense-ticker {
    justify-content: flex-start;
  }

  .teamlio-expense-ticker strong {
    font-size: 12px;
  }
}


/* ──────────────────────────────────────────────────────────────────────────
   Conversation row — final flat override.
   Strips visible border / rounded outline / focus ring that leaks in via
   shadcn's global \`* { @apply border-border }\` (src/index.css:73) and
   browser default button styling. The leading active-bar is re-enabled
   below so the selected-row accent survives.
   ──────────────────────────────────────────────────────────────────────── */
html body .gc-conv-row,
html body button.gc-conv-row {
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -webkit-tap-highlight-color: transparent !important;
}
html body .gc-conv-row:hover,
html body .gc-conv-row:focus,
html body .gc-conv-row:focus-visible,
html body .gc-conv-row.is-active {
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}
/* Preserve the leading-bar accent on the active row */
html body .gc-conv-row.is-active::before {
  display: block !important;
}

/* ══════════════════════════════════════════════════════════════════════════
   SHARED REUSABLE UTILITIES — usable globally from any component
   These replace inline \`style={{...}}\` blocks that were duplicated across
   the chat surface. Any component can apply them by className.
   ══════════════════════════════════════════════════════════════════════════ */

/* — Primary action button (filled). Pair with elevation modifier as needed — */
.gc-btn-primary {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  box-shadow: var(--gc-elev-2);
  --tw-ring-color: var(--gc-primary);
}
.gc-btn-primary.is-elev-3 { box-shadow: var(--gc-elev-3); }
.gc-btn-primary.is-elev-1 { box-shadow: var(--gc-elev-1); }

/* — Inline badge filled with primary color (e.g. unread count) — */
.gc-badge-primary {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-family: var(--gc-font-display);
}

/* — Display-family text variants — */
.gc-text-display {
  font-family: var(--gc-font-display);
  color: var(--gc-text-primary);
}
.gc-text-display-bold {
  font-family: var(--gc-font-display);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gc-text-primary);
}

/* — Tertiary helper text — */
.gc-text-tertiary { color: var(--gc-text-tertiary); }
.gc-text-disabled-italic {
  color: var(--gc-text-disabled);
  font-style: italic;
}

/* — Monospace time/numeric stamp — */
.gc-text-mono-time {
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font-mono);
  letter-spacing: 0.02em;
}

/* — Circular icon container filled with primary gradient — */
.gc-icon-circle-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: linear-gradient(135deg, var(--gc-primary) 0%, var(--gc-primary-soft) 100%);
  color: var(--gc-on-primary);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* — Generic "message removed" dot — */
.gc-removed-dot {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: var(--gc-text-disabled);
  opacity: 0.6;
  flex-shrink: 0;
}

/* — Conversational text in row: switches color when unread — */
.gc-row-last { color: var(--gc-text-tertiary); }
.gc-row-last.is-unread { color: var(--gc-text-primary); }

/* — "Draft:" marker, shown in place of the last message — */
.gc-row-draft { color: var(--gc-accent-strong); font-weight: 600; }
/* --gc-accent-strong is a deep emerald tuned for white; it goes muddy on the
   dark surface, so dark mode borrows the brighter accent instead. The high
   contrast theme redefines the token itself and needs no override here. */
[data-theme="dark"] .gc-row-draft { color: var(--gc-accent); }

/* — Rich text renderer (TipTap render-only) base — */
.chat-rich-render {
  font-size: var(--gc-font-size-md);
  line-height: 1.45;
}

/* — Voice audio player (used in attachment bubble) — */
.gc-voice-audio {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gc-voice-audio__el {
  max-width: 320px;
  height: 36px;
}
.gc-link-sm {
  font-size: 12px;
  color: var(--gc-link);
  text-decoration: underline;
}

/* — Generic flex-shrink helper for svgs/glyphs — */
.gc-noshrink { flex-shrink: 0; }

/* — Inline-flex tooltip-trigger wrapper — */
.gc-inline-flex { display: inline-flex; }

/* — Avatar: dynamic size driven by --avatar-size / --avatar-font-size CSS vars — */
.gc-avatar {
  position: relative;
  flex-shrink: 0;
  width: var(--avatar-size, 36px);
  height: var(--avatar-size, 36px);
}
.gc-avatar__inner {
  font-size: var(--avatar-font-size, 14px);
  width: 100%;
  height: 100%;
}
.gc-avatar__status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  border: 2px solid var(--gc-surface-0);
  background: var(--gc-offline);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.gc-avatar__status-dot.is-online { background: var(--gc-online); }

/* — Google brand controls (used by GoogleConnectModal) — */
.gc-google-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  background: #e8f0fe;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gc-btn-google {
  background: #1a73e8;
}

/* — TypingIndicator staggered animation — */
.gc-typing-dot { animation-delay: 0ms; }
.gc-typing-dot.is-d1 { animation-delay: 150ms; }
.gc-typing-dot.is-d2 { animation-delay: 300ms; }

/* — PresenceBadge size modifiers + inner dot — */
.gc-presence-pill.is-size-sm {
  font-size: 10px;
  padding: 2px 8px 2px 6px;
}
.gc-presence-pill.is-size-lg {
  font-size: 13px;
  padding: 4px 12px 4px 10px;
}
.gc-presence-pill__inner-dot {
  width: 7px;
  height: 7px;
  border: none;
}

/* ──────────────────────────────────────────────────────────────────────────
   DateDivider
   ────────────────────────────────────────────────────────────────────────── */
.gc-date-divider-line {
  background: linear-gradient(to right, transparent, var(--gc-border-strong) 35%, var(--gc-border-strong) 65%, transparent);
}
.gc-date-divider-center {
  color: var(--gc-text-tertiary);
}
.gc-date-divider-flourish {
  font-size: 9.5px;
  color: var(--gc-text-disabled);
  letter-spacing: 0.18em;
}
.gc-date-divider-label {
  font-family: var(--gc-font-serif);
  font-style: italic;
  font-weight: 500;
  font-size: 13.5px;
  color: var(--gc-text-secondary);
  letter-spacing: 0.005em;
}

/* ──────────────────────────────────────────────────────────────────────────
   FilterDropdown
   ────────────────────────────────────────────────────────────────────────── */
.gc-filter-trigger {
  background: var(--gc-surface-1);
  color: var(--gc-text-secondary);
  border: 1px solid var(--gc-border);
  border-radius: 12px;
  font-family: var(--gc-font);
  letter-spacing: -0.005em;
  box-shadow: none;
}
.gc-filter-trigger.is-open {
  border-color: var(--gc-primary);
  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);
}
.gc-filter-trigger__label {
  color: var(--gc-text-tertiary);
  font-weight: 500;
}
.gc-filter-trigger__label.is-selected {
  color: var(--gc-text-primary);
  font-weight: 600;
}
.gc-filter-trigger__chevron {
  color: var(--gc-text-tertiary);
  transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-filter-trigger__chevron.is-open {
  transform: rotate(180deg);
}
.gc-filter-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
}
.gc-filter-menu {
  z-index: 1001;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid var(--gc-border);
  border-radius: 14px;
  padding: 4px;
  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);
  /* PERF: backdrop-filter removed for Electron compositor cost — see gc-ios-menu */
  background: #ffffff;
  max-height: min(320px, calc(100vh - 64px));
  overflow-y: auto;
  font-family: var(--gc-font);
  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;
  transform-origin: top left;
}
.gc-filter-option {
  background: transparent;
  color: var(--gc-text-primary);
  font-size: 12.5px;
  font-weight: 500;
  font-family: var(--gc-font);
  border: none;
  cursor: pointer;
}
.gc-filter-option:hover { background: var(--gc-surface-2); }
.gc-filter-option.is-active {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  font-weight: 600;
}
.gc-filter-option.is-active:hover { background: var(--gc-primary-container); }
.gc-filter-option__check-slot {
  width: 14px;
  display: inline-flex;
  justify-content: center;
  color: var(--gc-primary);
}

/* ──────────────────────────────────────────────────────────────────────────
   LinkUnfurl
   ────────────────────────────────────────────────────────────────────────── */
.gc-unfurl {
  max-width: 480px;
  background: var(--gc-surface-1);
  /* Keep only the left accent rail; drop the full outline + shadow so it reads
     as one soft card rather than a heavy framed box. Radius echoes the bubble. */
  border: none;
  border-left: 3px solid var(--gc-primary);
  border-radius: var(--gc-radius-bubble);
  display: flex;
  align-items: stretch;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  box-shadow: none;
}
.gc-unfurl__body {
  flex: 1 1;
  padding: 10px 12px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.gc-unfurl__site-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 2px;
}
.gc-unfurl__favicon {
  border-radius: 2px;
  flex-shrink: 0;
}
.gc-unfurl__site {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gc-unfurl__title {
  margin: 0;
  font-family: var(--gc-font);
  font-size: var(--gc-font-size-base);
  font-weight: 600;
  color: var(--gc-text-primary);
  line-height: var(--gc-line-height);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gc-unfurl__desc {
  margin: 0;
  font-family: var(--gc-font);
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-secondary);
  line-height: var(--gc-line-height);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gc-unfurl__domain {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-link);
  font-family: var(--gc-font);
  margin-top: 2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gc-unfurl__image-wrap {
  width: 120px;
  flex-shrink: 0;
  overflow: hidden;
}
.gc-unfurl__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0 var(--gc-radius-card) var(--gc-radius-card) 0;
  display: block;
}
.gc-unfurl__dismiss {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: none;
  background: var(--gc-surface-2);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gc-text-tertiary);
  padding: 0;
  transition: background var(--gc-transition-fast);
}
.gc-unfurl__dismiss.has-image { right: 128px; }
.gc-unfurl__dismiss:hover { background: var(--gc-surface-3); }

/* ──────────────────────────────────────────────────────────────────────────
   E2EEBadge
   ────────────────────────────────────────────────────────────────────────── */
.gc-e2ee-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.gc-e2ee-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--gc-radius-pill);
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
  font-size: var(--gc-font-size-xs);
  font-family: var(--gc-font);
  cursor: pointer;
  line-height: 1.4;
  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);
}
.gc-e2ee-trigger:hover {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
}
.gc-e2ee-backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
}
.gc-e2ee-popover {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 101;
  width: 280px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  box-shadow: var(--gc-elev-3);
  padding: 14px 16px;
  font-family: var(--gc-font);
}
.gc-e2ee-popover__arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 10px;
  height: 10px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-bottom: none;
  border-right: none;
}
.gc-e2ee-popover__title {
  margin: 0 0 6px;
  font-weight: 600;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
}
.gc-e2ee-popover__body {
  margin: 0 0 10px;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-secondary);
  line-height: var(--gc-line-height);
}
.gc-e2ee-popover__meta {
  margin: 0 0 12px;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-tertiary);
  line-height: var(--gc-line-height);
}
.gc-e2ee-popover__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.gc-btn-pill-outline-danger {
  padding: 4px 10px;
  border-radius: var(--gc-radius-pill);
  border: 1px solid var(--gc-border);
  background: transparent;
  color: var(--gc-dnd);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  cursor: pointer;
}
.gc-btn-pill-primary {
  padding: 4px 10px;
  border-radius: var(--gc-radius-pill);
  border: none;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  cursor: pointer;
}

/* ──────────────────────────────────────────────────────────────────────────
   EmptyState
   ────────────────────────────────────────────────────────────────────────── */
.gc-empty-state {
  background:
    radial-gradient(circle at 28% 32%, rgba(220, 239, 225, 0.55) 0%, transparent 38%),
    radial-gradient(circle at 72% 78%, rgba(236, 246, 238, 0.6) 0%, transparent 42%),
    var(--gc-surface-1);
}
.gc-empty-state__folio {
  top: 14%;
  left: 50%;
  transform: translateX(-50%);
  font-family: var(--gc-font-serif);
  font-style: italic;
  font-weight: 500;
  font-size: 240px;
  line-height: 1;
  color: var(--gc-primary-container);
  opacity: 0.55;
  letter-spacing: -0.03em;
}
.gc-empty-state__eyebrow {
  color: var(--gc-text-tertiary);
}
.gc-empty-state__leaf-flip {
  transform: rotate(165deg);
}
.gc-empty-state__headline {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 38px;
  line-height: 1.05;
  color: var(--gc-text-primary);
  letter-spacing: -0.035em;
  max-width: 520px;
}
.gc-empty-state__headline-em {
  color: var(--gc-primary);
  font-weight: 500;
  font-size: 42px;
}
.gc-empty-state__tagline {
  color: var(--gc-text-tertiary);
  font-size: 14.5px;
}
.gc-empty-state__tagline-em {
  color: var(--gc-text-secondary);
}
.gc-empty-state__cta {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  box-shadow: var(--gc-elev-3);
  font-family: var(--gc-font-display);
  letter-spacing: 0.005em;
  --tw-ring-color: var(--gc-primary);
}
.gc-empty-state__hint {
  color: var(--gc-text-disabled);
}
.gc-empty-state__kbd {
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  font-family: var(--gc-font-mono);
  color: var(--gc-text-secondary);
}
.gc-empty-state__hint-plus { margin-left: 4px; }
.gc-empty-state__watermark {
  bottom: 36px;
  right: 44px;
  opacity: 0.18;
  color: var(--gc-primary);
}

/* ──────────────────────────────────────────────────────────────────────────
   MeetInviteCard
   ────────────────────────────────────────────────────────────────────────── */
.gc-meet-card {
  /* Flattened — the message bubble is the single rounded container (matches the
     already-flat .is-inverted variant and the flush image attachment). The card
     no longer nests its own framed/shadowed box inside the bubble. */
  border: none;
  border-radius: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
  max-width: 360px;
  font-family: var(--gc-font);
}
.gc-meet-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.gc-meet-card__icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--gc-primary-container);
  color: var(--gc-primary);
}
.gc-meet-card__title {
  font-size: 14px;
  letter-spacing: -0.01em;
  color: var(--gc-text-primary);
  font-family: var(--gc-font-display);
}
.gc-meet-card__when {
  font-size: 12px;
  color: var(--gc-text-secondary);
  margin-bottom: 2px;
}
.gc-meet-card__sender {
  font-size: 11px;
  color: var(--gc-text-tertiary);
  margin-bottom: 12px;
}
.gc-meet-card__join {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: var(--gc-primary);
  /* Pair with the brand's on-primary foreground; the fallback guarantees a
     light label even if the token ever fails to resolve, so the text can never
     inherit the dark bubble color and vanish into the button. */
  color: var(--gc-on-primary, #f7faf6);
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.005em;
  font-family: var(--gc-font-display);
  text-decoration: none;
  box-shadow: var(--gc-elev-2);
  transition: background 140ms ease, transform 140ms ease, box-shadow 140ms ease;
}
/* Keep the glyphs locked to the label color regardless of cascade. */
.gc-meet-card__join svg { color: inherit; }
.gc-meet-card__join:hover {
  background: var(--gc-primary-hover, #15211a);
  transform: translateY(-1px);
  box-shadow: var(--gc-elev-3);
}
.gc-meet-card__join:active {
  transform: translateY(0);
  box-shadow: var(--gc-elev-1);
}
/* Inverted (inside sent bubble) */
.gc-meet-card.is-inverted {
  border: none;
  border-radius: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
  font-family: var(--gc-font, inherit);
  color: var(--gc-bubble-mine-text);
  min-width: 220px;
  max-width: 320px;
}
.gc-meet-card.is-inverted .gc-meet-card__head { gap: 8px; margin-bottom: 6px; }
.gc-meet-card.is-inverted .gc-meet-card__icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.92);
}
.gc-meet-card.is-inverted .gc-meet-card__title {
  font-size: 13.5px;
  letter-spacing: -0.005em;
  color: inherit;
}
.gc-meet-card.is-inverted .gc-meet-card__when {
  font-size: 12px;
  color: inherit;
  opacity: 0.78;
}
.gc-meet-card.is-inverted .gc-meet-card__sender {
  font-size: 11px;
  color: inherit;
  opacity: 0.6;
  margin-bottom: 10px;
}
.gc-meet-card.is-inverted .gc-meet-card__join {
  padding: 7px 14px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--gc-primary);
  font-size: 12px;
  box-shadow: none;
  transition: transform 120ms ease, background 120ms ease;
}
.gc-meet-card.is-inverted .gc-meet-card__join:hover { transform: scale(1.03); }

/* ──────────────────────────────────────────────────────────────────────────
   InstantMeetForm
   ────────────────────────────────────────────────────────────────────────── */
.gc-meet-form {
  margin: 0 12px 12px;
  padding: 12px;
  background: var(--gc-surface-1, #f9fafb);
  border-radius: 12px;
  border: 1px solid var(--gc-divider, #e5e7eb);
  font-family: var(--gc-font, inherit);
}
.gc-meet-form__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.gc-meet-form__head-title {
  flex: 1 1;
  font-size: 14px;
}
.gc-meet-form__close {
  border: none;
  background: transparent;
  cursor: pointer;
}
.gc-meet-form__input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--gc-outline, #d1d5db);
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 10px;
  background: var(--gc-surface-0, #fff);
  color: var(--gc-text-primary, #111827);
  box-sizing: border-box;
}
.gc-meet-form__notify-wrap { margin-bottom: 10px; }
.gc-meet-form__notify-label {
  font-size: 12px;
  color: var(--gc-text-secondary, #6b7280);
  margin-bottom: 6px;
}
.gc-meet-form__notify-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 96px;
  overflow-y: auto;
}
.gc-meet-form__notify-chip {
  padding: 4px 10px;
  border-radius: 9999px;
  border: 1px solid var(--gc-outline, #d1d5db);
  background: var(--gc-surface-0, #fff);
  color: var(--gc-text-primary, #111827);
  font-size: 12px;
  cursor: pointer;
}
.gc-meet-form__notify-chip.is-on {
  border-color: var(--gc-primary, #2563eb);
  background: var(--gc-primary-container, #dbeafe);
  color: var(--gc-primary, #2563eb);
}
.gc-meet-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.gc-btn-outline-sm {
  padding: 6px 14px;
  border: 1px solid var(--gc-outline, #d1d5db);
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
}
.gc-btn-filled-sm {
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  background: var(--gc-primary, #2563eb);
  color: #fff;
  cursor: pointer;
  font-size: 13px;
}
.gc-btn-filled-sm:disabled { opacity: 0.6; }

/* ──────────────────────────────────────────────────────────────────────────
   Admin tables (shared between DLP / Holds / Audit tabs)
   ────────────────────────────────────────────────────────────────────────── */
.gc-admin-wrap {
  overflow-x: auto;
  font-family: var(--gc-font);
}
.gc-admin-table {
  width: 100%;
  border-collapse: collapse;
}
.gc-admin-table__cell {
  padding: 8px 10px;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-primary);
  border-bottom: 1px solid var(--gc-divider);
  vertical-align: middle;
  white-space: nowrap;
}
.gc-admin-table__head {
  padding: 8px 10px;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-tertiary);
  font-weight: 600;
  background: var(--gc-surface-1);
  position: sticky;
  top: 0;
  border-bottom: 1px solid var(--gc-divider);
  vertical-align: middle;
  white-space: nowrap;
}
.gc-admin-table__cell.is-mono {
  font-family: monospace;
  font-size: 11px;
}
.gc-admin-table__row { background: var(--gc-surface-0); }
/* External chat: shown in place of the composer while a reply is outstanding.
   The thread stays readable; this says why nothing more can be sent yet. */
.gc-frozen-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--gc-text-tertiary);
  background: var(--gc-surface-1, transparent);
  border-top: 1px solid var(--gc-border-strong);
}

.gc-admin-state {
  padding: 16px;
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font);
}
.gc-admin-state.is-error { color: var(--gc-dnd); }
.gc-admin-chip-rule {
  padding: 2px 6px;
  border-radius: var(--gc-radius-pill);
  background: var(--gc-surface-2);
  font-size: var(--gc-font-size-xs);
  font-weight: 600;
  color: var(--gc-text-secondary);
}
.gc-admin-action-text {
  color: var(--gc-text-primary);
  font-weight: 600;
  font-size: var(--gc-font-size-xs);
}
.gc-admin-action-text.is-flagged { color: var(--gc-away); }
.gc-admin-action-text.is-blocked { color: var(--gc-dnd); }
.gc-admin-action-text.is-redacted { color: var(--gc-text-tertiary); }
.gc-admin-btn-review {
  padding: 3px 10px;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-pill);
  background: transparent;
  color: var(--gc-primary);
  font-size: var(--gc-font-size-xs);
  cursor: pointer;
  font-family: var(--gc-font);
}

/* ──────────────────────────────────────────────────────────────────────────
   AdminConsole — side panel + tabs
   ────────────────────────────────────────────────────────────────────────── */
.gc-admin-console {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 640px;
  max-width: 100vw;
  background: var(--gc-surface-0);
  border-left: 1px solid var(--gc-border);
  box-shadow: var(--gc-elev-4);
  display: flex;
  flex-direction: column;
  z-index: 200;
  font-family: var(--gc-font);
}
.gc-admin-console__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--gc-divider);
  flex-shrink: 0;
}
.gc-admin-console__title {
  font-weight: 600;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
}
.gc-admin-console__close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--gc-text-tertiary);
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: var(--gc-radius-card);
}
.gc-admin-console__tabs {
  display: flex;
  border-bottom: 1px solid var(--gc-divider);
  overflow-x: auto;
  flex-shrink: 0;
  background: var(--gc-surface-0);
}
.gc-admin-console__tab {
  padding: 8px 16px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--gc-text-secondary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  transition: color var(--gc-transition-fast), border-color var(--gc-transition-fast);
}
.gc-admin-console__tab.is-active {
  border-bottom-color: var(--gc-primary);
  color: var(--gc-primary);
  font-weight: 600;
}
.gc-admin-console__body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

/* ──────────────────────────────────────────────────────────────────────────
   AdminHoldsTab
   ────────────────────────────────────────────────────────────────────────── */
.gc-admin-holds-wrap { font-family: var(--gc-font); }
.gc-admin-holds-toolbar {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-btn-primary-pill-sm {
  padding: 6px 14px;
  border: none;
  border-radius: var(--gc-radius-pill);
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  cursor: pointer;
  font-weight: 500;
}
.gc-btn-primary-pill-sm:disabled,
.gc-btn-primary-pill-sm.is-busy {
  background: var(--gc-surface-3);
  cursor: not-allowed;
}
.gc-admin-form {
  padding: 16px;
  background: var(--gc-surface-1);
  border-bottom: 1px solid var(--gc-divider);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gc-form-label {
  display: block;
  margin-bottom: 4px;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-secondary);
  font-family: var(--gc-font);
  font-weight: 500;
}
.gc-form-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  box-sizing: border-box;
}
.gc-form-input--textarea {
  min-height: 60px;
  resize: vertical;
}
.gc-form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.gc-form-error {
  margin: 0;
  color: var(--gc-dnd);
  font-size: var(--gc-font-size-sm);
}
.gc-form-actions {
  display: flex;
  justify-content: flex-end;
}
.gc-admin-holds-name { font-weight: 500; }
.gc-admin-holds-desc {
  color: var(--gc-text-tertiary);
  font-size: var(--gc-font-size-xs);
}
.gc-admin-holds-active { font-weight: 600; }
.gc-admin-holds-active.is-yes { color: var(--gc-online); }
.gc-admin-holds-active.is-no { color: var(--gc-text-disabled); }

/* ──────────────────────────────────────────────────────────────────────────
   TimePicker
   ────────────────────────────────────────────────────────────────────────── */
.gc-time-trigger {
  padding: 10px 12px;
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  border: 1px solid var(--gc-border);
  border-radius: 12px;
  font-family: var(--gc-font);
  font-size: 13.5px;
  text-align: left;
  box-shadow: none;
  cursor: pointer;
}
.gc-time-trigger.is-open {
  border-color: var(--gc-primary);
  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);
}
.gc-time-trigger__icon {
  color: var(--gc-text-tertiary);
  flex-shrink: 0;
}
.gc-time-trigger__value {
  flex: 1 1;
  font-weight: 600;
  letter-spacing: -0.005em;
}
.gc-time-trigger__chevron {
  color: var(--gc-text-tertiary);
  transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1);
  flex-shrink: 0;
}
.gc-time-trigger__chevron.is-open { transform: rotate(180deg); }
.gc-time-pop {
  z-index: 1001;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid var(--gc-border);
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);
  /* PERF: backdrop-filter removed for Electron compositor cost — see gc-ios-menu */
  background: #ffffff;
  font-family: var(--gc-font);
  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;
  transform-origin: top left;
}
.gc-time-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 0.85fr;
  gap: 8px;
}
.gc-time-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 2px;
}
.gc-time-col-header {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font-display);
  text-align: center;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--gc-divider);
  margin-bottom: 6px;
}
.gc-time-item {
  width: 100%;
  padding: 7px 6px;
  border-radius: 9px;
  font-size: 13.5px;
  font-family: var(--gc-font);
  font-weight: 500;
  color: var(--gc-text-primary);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 140ms ease, color 140ms ease, transform 140ms ease;
  letter-spacing: 0;
  text-align: center;
  box-shadow: none;
}
.gc-time-item:hover { background: var(--gc-surface-2); }
.gc-time-item.is-active {
  font-family: var(--gc-font-display);
  font-weight: 700;
  color: var(--gc-on-primary);
  background: var(--gc-primary);
  letter-spacing: -0.005em;
  box-shadow: 0 4px 10px rgba(15, 29, 20, 0.18);
}
.gc-time-item.is-active:hover { background: var(--gc-primary); }
.gc-time-item.is-period {
  padding: 12px 6px;
  font-size: 13px;
  letter-spacing: 0.08em;
}
.gc-time-period-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gc-time-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid var(--gc-divider);
}
.gc-time-now-btn {
  padding: 6px 12px;
  font-size: 11.5px;
  font-family: var(--gc-font-display);
  font-weight: 600;
  border-radius: 9px;
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-0);
  color: var(--gc-text-secondary);
  cursor: pointer;
  letter-spacing: 0.02em;
}
.gc-time-done-btn {
  padding: 6px 14px;
  font-size: 12px;
  font-family: var(--gc-font-display);
  font-weight: 700;
  border-radius: 9px;
  border: none;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  cursor: pointer;
  letter-spacing: 0.005em;
  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);
}

/* ──────────────────────────────────────────────────────────────────────────
   ThreadPanel
   ────────────────────────────────────────────────────────────────────────── */
.gc-thread-panel {
  background: var(--gc-surface-0);
  border-left: 1px solid var(--gc-divider);
}
.gc-thread-panel__header {
  background: var(--gc-surface-0);
  border-bottom: 1px solid var(--gc-divider);
}
.gc-thread-panel__icon-square {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
}
.gc-thread-panel__eyebrow {
  color: var(--gc-text-tertiary);
  font-size: 9px;
}
.gc-thread-panel__title {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.02em;
  color: var(--gc-text-primary);
}
.gc-thread-panel__close { color: var(--gc-text-tertiary); }
.gc-thread-panel__close:hover {
  background: var(--gc-surface-2);
  color: var(--gc-text-primary);
}
.gc-thread-panel__body {
  background:
    radial-gradient(circle at 0% 0%, rgba(220, 239, 225, 0.30) 0%, transparent 32%),
    var(--gc-surface-1);
}
.gc-thread-replies-meta {
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font-display);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.gc-thread-replies-meta__count {
  color: var(--gc-primary);
  font-weight: 700;
}
.gc-thread-panel__composer {
  background: var(--gc-surface-2);
  border-top: 1px solid var(--gc-divider);
}
.gc-thread-panel__send {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  box-shadow: var(--gc-elev-2);
}

/* ──────────────────────────────────────────────────────────────────────────
   VoiceRecorder
   ────────────────────────────────────────────────────────────────────────── */
.gc-voice-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: var(--gc-surface-1);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
}
.gc-voice-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--gc-surface-1);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  color: var(--gc-dnd);
  font-family: var(--gc-font);
  font-size: var(--gc-font-size-sm);
}
.gc-voice-error__text { flex: 1 1; }
.gc-voice-error__close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gc-text-tertiary);
  display: flex;
}
.gc-voice-icon-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background var(--gc-transition-fast);
}
.gc-voice-icon-btn.is-danger {
  background: var(--gc-mention-channel-bg);
  color: var(--gc-dnd);
}
.gc-voice-icon-btn.is-stop {
  background: var(--gc-dnd);
  color: var(--gc-on-primary);
}
.gc-voice-icon-btn.is-primary {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
}
.gc-voice-icon-btn.is-primary.is-busy {
  background: var(--gc-surface-3);
  cursor: not-allowed;
  opacity: 0.6;
}
.gc-voice-record-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.gc-voice-record-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--gc-dnd);
  flex-shrink: 0;
}
.gc-voice-record-time {
  font-family: var(--gc-font);
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-primary);
  font-variant-numeric: tabular-nums;
  min-width: 36px;
}
.gc-voice-record-time.is-secondary { color: var(--gc-text-secondary); }
.gc-voice-bars {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.gc-voice-bar {
  border-radius: 2px;
  background: var(--gc-primary);
  flex-shrink: 0;
  transition: height 80ms ease;
}
.gc-voice-bar.is-static { transition: none; opacity: 0.6; }
.gc-voice-bar:not(.is-static) { opacity: 0.7; }

/* ──────────────────────────────────────────────────────────────────────────
   EmojiPicker
   ────────────────────────────────────────────────────────────────────────── */
.gc-emoji-picker {
  width: 320px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--gc-font);
}
.gc-emoji-picker__search-wrap {
  padding: 8px 8px 0;
  position: relative;
}
.gc-emoji-picker__search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gc-text-tertiary);
  pointer-events: none;
}
.gc-emoji-picker__search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px 6px 28px;
  border: 1px solid var(--gc-border);
  border-radius: 20px;
  background: var(--gc-surface-1);
  color: var(--gc-text-primary);
  font-size: var(--gc-font-size-sm);
  outline: none;
}
.gc-emoji-picker__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px 4px;
}
.gc-emoji-picker__skin-wrap { position: relative; }
.gc-emoji-picker__skin-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 2px;
  border-radius: 4px;
  line-height: 1;
}
.gc-emoji-picker__skin-pop {
  position: absolute;
  top: 110%;
  left: 0;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: 8px;
  padding: 6px 8px;
  display: flex;
  gap: 4px;
  z-index: 10;
  box-shadow: var(--gc-elev-2);
}
.gc-emoji-picker__skin-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline-offset: 1px;
}
.gc-emoji-picker__skin-dot.is-default { background: var(--gc-text-secondary); }
.gc-emoji-picker__skin-dot.is-active { outline: 2px solid var(--gc-primary); }
.gc-emoji-picker__close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gc-text-tertiary);
  display: flex;
  align-items: center;
}
.gc-emoji-picker__tabs {
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid var(--gc-divider);
  scrollbar-width: none;
  padding: 0 4px;
}
.gc-emoji-picker__tab {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  font-size: 16px;
  border-bottom: 2px solid transparent;
  opacity: 0.55;
  transition: opacity 0.1s, border-color 0.1s;
}
.gc-emoji-picker__tab.is-active {
  border-bottom-color: var(--gc-primary);
  opacity: 1;
}
.gc-emoji-picker__cat-label {
  padding: 6px 10px 2px;
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.gc-emoji-picker__grid {
  display: grid;
  grid-template-columns: repeat(8, 32px);
  gap: 2px;
  padding: 4px 8px 10px;
  overflow-y: auto;
  max-height: 224px;
  justify-content: center;
}
.gc-emoji-picker__grid-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: var(--gc-font-size-sm);
  padding: 16px 0;
}
.gc-emoji-picker__item {
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 1;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--gc-transition-fast);
}
.gc-emoji-picker__item:hover { background: var(--gc-surface-2); }

/* ──────────────────────────────────────────────────────────────────────────
   Shared MODAL primitives — reused by Export/Forward/NewConv/Poll/Reminder/etc
   ────────────────────────────────────────────────────────────────────────── */
.gc-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 300;
}
.gc-modal-wrap {
  position: fixed;
  inset: 0;
  z-index: 301;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.gc-modal-card {
  width: 460px;
  max-width: 95vw;
  background: var(--gc-surface-0);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-5);
  font-family: var(--gc-font);
  pointer-events: all;
}
.gc-modal-card.is-wide { width: 560px; }
.gc-modal-card.is-narrow { width: 380px; }
.gc-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-modal-title {
  font-weight: 600;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
}
.gc-modal-close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--gc-text-tertiary);
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: var(--gc-radius-card);
}
.gc-modal-form {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.gc-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}
.gc-radio-row {
  display: flex;
  gap: 20px;
}
.gc-radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-primary);
}
.gc-radio-input { accent-color: var(--gc-primary); }
.gc-btn-cancel {
  padding: 7px 16px;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-pill);
  background: transparent;
  color: var(--gc-text-secondary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  cursor: pointer;
}
.gc-btn-submit {
  padding: 7px 18px;
  border: none;
  border-radius: var(--gc-radius-pill);
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: var(--gc-font-size-sm);
  font-family: var(--gc-font);
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background var(--gc-transition-fast);
}
.gc-btn-submit:disabled,
.gc-btn-submit.is-busy {
  background: var(--gc-surface-3);
  cursor: not-allowed;
}
.gc-spinner-12 {
  width: 12px;
  height: 12px;
  border: 2px solid var(--gc-on-primary);
  border-top-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: gc-spin 0.7s linear infinite;
}
@keyframes gc-spin { to { transform: rotate(360deg); } }
.gc-result-pill {
  padding: 10px 12px;
  background: var(--gc-primary-container);
  border-radius: var(--gc-radius-card);
  font-size: var(--gc-font-size-sm);
  color: var(--gc-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-result-pill code { font-family: monospace; }

/* ──────────────────────────────────────────────────────────────────────────
   ChatRightPanel
   ────────────────────────────────────────────────────────────────────────── */
.gc-right-panel {
  background: var(--gc-surface-1);
  border-left: 1px solid var(--gc-divider);
}

/* On phones / tablets (below xl=1280px) the Files & Schedule panel slides
   in from the right as a fixed overlay rather than living inline. Its
   sibling backdrop dims the chat behind it and dismisses on tap. */
.gc-right-panel-backdrop { display: none; }

@media (max-width: 1279px) {
  .gc-right-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100dvh;
    width: 100%;
    max-width: 360px;
    z-index: 50;
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
    animation: gc-right-panel-slide-in 200ms cubic-bezier(0.33, 1, 0.68, 1) both;
  }
  .gc-right-panel-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.32);
    z-index: 45;
    animation: gc-right-panel-fade-in 200ms ease both;
  }
}

@keyframes gc-right-panel-slide-in {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}
@keyframes gc-right-panel-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.gc-section-folio {
  font-size: 14px;
  font-weight: 500;
  color: var(--gc-primary);
  letter-spacing: -0.01em;
}
.gc-section-title {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.02em;
  color: var(--gc-text-primary);
}
.gc-section-chevron { color: var(--gc-text-tertiary); }
.gc-section-counter {
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
  font-family: var(--gc-font-display);
}
.gc-file-row {
  color: inherit;
  background: transparent;
  transition: background var(--gc-transition-fast);
}
.gc-file-row:hover { background: var(--gc-surface-2); }
.gc-file-badge {
  background: var(--file-badge-bg);
  color: var(--file-badge-fg);
}
.gc-file-name {
  color: var(--gc-text-primary);
  font-family: var(--gc-font-display);
}
.gc-file-meta { color: var(--gc-text-tertiary); }
.gc-mini-cal {
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);
}
.gc-mini-cal__month {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 14px;
  color: var(--gc-text-primary);
  letter-spacing: -0.01em;
}
.gc-mini-cal__nav {
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
}
.gc-event-row {
  background: transparent;
  transition: background var(--gc-transition-fast);
}
.gc-event-row:hover { background: var(--gc-surface-2); }
.gc-event-row__accent {
  background: var(--event-accent, var(--gc-primary));
}
.gc-event-row__title {
  color: var(--gc-text-primary);
  font-family: var(--gc-font-display);
  letter-spacing: -0.005em;
}
.gc-event-row__meta { color: var(--gc-text-tertiary); }
.gc-event-row__join {
  background: var(--event-accent-soft, var(--gc-primary-container));
  color: var(--gc-accent-strong);
  border: 1px solid rgba(16, 185, 129, 0.25);
  font-family: var(--gc-font-display);
}
.gc-text-tertiary-eyebrow { color: var(--gc-text-tertiary); }
.gc-text-accent-tag { color: var(--gc-accent-strong); }
.gc-text-dnd { color: var(--gc-dnd); }
.gc-divider-top { border-top: 1px solid var(--gc-divider); }
.gc-close-panel-btn {
  color: var(--gc-text-secondary);
  border-color: var(--gc-divider);
}

/* ──────────────────────────────────────────────────────────────────────────
   RichTextEditor
   ────────────────────────────────────────────────────────────────────────── */
.gc-rte {
  position: relative;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  background: var(--gc-surface-0);
  transition: border-color var(--gc-transition-fast);
  font-family: var(--gc-font);
}
.gc-rte.is-focused { border-color: var(--gc-primary); }
.gc-rte-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: var(--gc-text-secondary);
  transition: background var(--gc-transition-fast);
}
.gc-rte-btn.is-active {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
}
.gc-rte-bubble {
  display: flex;
  gap: 2px;
  padding: 4px 6px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  box-shadow: var(--gc-elev-3);
}
.gc-rte-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--gc-border);
}
.gc-rte-toolbar__divider {
  width: 1px;
  height: 20px;
  background: var(--gc-border);
  margin: 0 4px;
}
.gc-rte-editor-wrap {
  position: relative;
}
.gc-rte-editor {
  min-height: 2.25rem;
  max-height: 9rem;
  overflow-y: auto;
  padding: 8px 12px;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
  line-height: var(--gc-line-height);
}
.gc-rte-slash {
  position: absolute;
  bottom: 100%;
  left: 8px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  box-shadow: var(--gc-elev-3);
  z-index: 50;
  min-width: 160px;
  overflow: hidden;
}
.gc-rte-slash__item {
  display: block;
  width: 100%;
  padding: 7px 12px;
  text-align: left;
  border: none;
  cursor: pointer;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-primary);
  background: transparent;
  font-family: var(--gc-font);
}
.gc-rte-slash__item.is-selected { background: var(--gc-surface-2); }
.gc-rte-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 6px;
}
.gc-rte-hint {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  opacity: 0.7;
}
.gc-rte-counter {
  font-size: var(--gc-font-size-xs);
  color: var(--counter-color, var(--gc-text-tertiary));
}
.gc-rte-counter.is-warn { color: var(--gc-away); }
.gc-rte-counter.is-danger { color: var(--gc-dnd); }
.gc-rte-send {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: var(--gc-radius-pill);
  border: none;
  cursor: pointer;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: var(--gc-font-size-sm);
  font-weight: 600;
  font-family: var(--gc-font);
  transition: background var(--gc-transition-fast);
}
.gc-rte-send:disabled {
  cursor: default;
  background: var(--gc-surface-2);
  color: var(--gc-text-disabled);
}

/* ProseMirror — moved from inline \\3c style> block in RichTextEditor */
.ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  color: var(--gc-text-disabled);
  pointer-events: none;
  float: left;
  height: 0;
}
.ProseMirror { outline: none; }
.ProseMirror ul[data-type="taskList"] { padding-left: 0; list-style: none; }
.ProseMirror ul[data-type="taskList"] li { display: flex; gap: 6px; align-items: flex-start; }
.ProseMirror ul[data-type="taskList"] li > label { margin-top: 2px; }
.ProseMirror pre { background: var(--gc-surface-2); border-radius: 6px; padding: 10px 14px; overflow-x: auto; }
.ProseMirror code { background: var(--gc-surface-2); border-radius: 3px; padding: 1px 4px; font-size: 0.88em; }
.ProseMirror pre code { background: transparent; padding: 0; }
.ProseMirror a { color: var(--gc-text-link); text-decoration: underline; }
.ProseMirror mark { background: var(--gc-mention-bg); border-radius: 2px; padding: 0 2px; }

/* ──────────────────────────────────────────────────────────────────────────
   AdminAuditTab
   ────────────────────────────────────────────────────────────────────────── */
.gc-audit-wrap {
  font-family: var(--gc-font);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.gc-audit-filterbar {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--gc-divider);
  background: var(--gc-surface-1);
  position: sticky;
  top: 0;
  z-index: 2;
  align-items: center;
  flex-shrink: 0;
}
.gc-audit-search-wrap {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-pill);
}
.gc-audit-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-primary);
  font-family: inherit;
}
.gc-audit-select {
  padding: 6px 10px;
  border: 1px solid var(--gc-border);
  border-radius: 8px;
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  font-size: var(--gc-font-size-sm);
  font-family: inherit;
  cursor: pointer;
}
.gc-audit-body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}
.gc-audit-error {
  margin: 16px;
  padding: 12px 14px;
  border: 1px solid rgba(220, 38, 38, 0.25);
  border-radius: var(--gc-radius-card);
  background: rgba(220, 38, 38, 0.06);
  color: var(--gc-dnd);
  font-size: var(--gc-font-size-sm);
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-audit-skeleton-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-audit-skeleton-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--gc-surface-2);
}
.gc-audit-skeleton-stack {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gc-audit-skeleton-bar {
  height: 12px;
  width: 60%;
  border-radius: 6px;
  background: var(--gc-surface-2);
}
.gc-audit-skeleton-bar.is-short {
  height: 10px;
  width: 35%;
}
.gc-audit-empty {
  padding: 48px 24px;
  text-align: center;
  color: var(--gc-text-tertiary);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.gc-audit-empty__icon-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--gc-surface-2);
  display: grid;
  place-items: center;
  color: var(--gc-text-tertiary);
}
.gc-audit-empty__title {
  font-size: var(--gc-font-size-base);
  font-weight: 600;
  color: var(--gc-text-secondary);
}
.gc-audit-empty__hint {
  margin-top: 4px;
  font-size: var(--gc-font-size-sm);
}
.gc-audit-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 16px;
  border-bottom: 1px solid var(--gc-divider);
  background: var(--gc-surface-0);
  transition: background var(--gc-transition-fast);
  cursor: default;
}
.gc-audit-row:hover { background: var(--gc-surface-hover); }
.gc-audit-row__avatar-wrap {
  position: relative;
  padding-top: 2px;
}
.gc-audit-row__overlay {
  position: absolute;
  bottom: -2px;
  right: -2px;
  background: var(--gc-surface-0);
  border-radius: 8px;
  padding: 2px;
  box-shadow: var(--gc-elev-1);
}
.gc-audit-avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--gc-radius-avatar);
  background: hsl(var(--avatar-hue, 200), 36%, 88%);
  color: hsl(var(--avatar-hue, 200), 50%, 26%);
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}
.gc-audit-cat-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--cat-bg);
  color: var(--cat-fg);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.gc-audit-row__sentence {
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
  line-height: 1.45;
  word-break: break-word;
}
.gc-audit-row__sentence strong { font-weight: 600; }
.gc-audit-row__sentence-muted { color: var(--gc-text-secondary); }
.gc-audit-row__resource-name {
  font-weight: 500;
  color: var(--gc-text-primary);
}
.gc-audit-row__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
}
.gc-audit-row__conv-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 8px;
  border-radius: var(--gc-radius-pill);
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
  font-weight: 500;
}
.gc-audit-row__mono {
  font-family: var(--gc-font-mono, monospace);
  font-size: 10px;
}
.gc-audit-row__pill-wrap { padding-top: 4px; }
.gc-audit-row__cat-pill {
  padding: 2px 9px;
  border-radius: var(--gc-radius-pill);
  background: var(--cat-pill-bg);
  color: var(--cat-pill-fg);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
}
.gc-audit-date-header {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 8px 16px;
  background: var(--gc-surface-1);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
  border-top: 1px solid var(--gc-divider);
  border-bottom: 1px solid var(--gc-divider);
}
.gc-audit-sentinel {
  padding: 16px;
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: var(--gc-font-size-sm);
}

/* ──────────────────────────────────────────────────────────────────────────
   Admin Away Tracking
   ────────────────────────────────────────────────────────────────────────── */
.gc-away-admin-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
  min-height: 100%;
  background: var(--gc-surface-0);
}
.gc-away-admin-toolbar {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto auto;
  gap: 10px;
  align-items: center;
}
.gc-away-admin-refresh {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-1);
  color: var(--gc-text-secondary);
  cursor: pointer;
}
.gc-away-admin-loading {
  padding: 28px;
  text-align: center;
  color: var(--gc-text-secondary);
}
.gc-away-admin-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}
.gc-away-admin-stat {
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  background: var(--gc-surface-1);
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 3px 8px;
  align-items: center;
}
.gc-away-admin-stat__icon {
  grid-row: span 2;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(250, 204, 21, 0.18);
  color: #d6a500;
}
.gc-away-admin-icon-fallback {
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 999px;
  background: currentColor;
}
.gc-away-admin-stat__label {
  font-size: 11px;
  color: var(--gc-text-secondary);
}
.gc-away-admin-stat strong {
  color: var(--gc-text-primary);
  font-size: 18px;
  line-height: 1.1;
}
.gc-away-admin-focus {
  padding: 10px 12px;
  border: 1px solid rgba(250, 204, 21, 0.24);
  border-radius: var(--gc-radius-card);
  background: rgba(250, 204, 21, 0.08);
  color: var(--gc-text-secondary);
  font-size: 13px;
}
.gc-away-admin-focus strong {
  color: var(--gc-text-primary);
}
.gc-away-admin-list {
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  overflow: hidden;
  background: var(--gc-surface-1);
}
.gc-away-admin-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-away-admin-row:last-child {
  border-bottom: 0;
}
.gc-away-admin-avatar {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(250, 204, 21, 0.18);
  color: #8a6500;
  font-weight: 800;
  flex-shrink: 0;
}
.gc-away-admin-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gc-away-admin-row__main {
  min-width: 0;
}
.gc-away-admin-row__top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.gc-away-admin-row__top strong {
  color: var(--gc-text-primary);
  font-size: 14px;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-away-admin-row__sub {
  margin-top: 3px;
  color: var(--gc-text-secondary);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-away-admin-row__metric {
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: var(--gc-text-secondary);
  font-size: 11px;
}
.gc-away-admin-row__metric strong {
  color: var(--gc-text-primary);
  font-size: 15px;
}
.gc-away-admin-row__metric em {
  font-style: normal;
  color: #d6a500;
}
.gc-away-admin-badge {
  padding: 2px 8px;
  border-radius: 999px;
  background: #facc15;
  color: #1f1a05;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

@media (max-width: 720px) {
  .gc-away-admin-toolbar {
    grid-template-columns: 1fr;
  }
  .gc-away-admin-stats {
    grid-template-columns: 1fr;
  }
  .gc-away-admin-row {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .gc-away-admin-row__metric {
    grid-column: 2;
    text-align: left;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   ForwardModal (and shared bits usable by other modals)
   ────────────────────────────────────────────────────────────────────────── */
.gc-modal-backdrop-centered {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.gc-modal-shell {
  background-color: var(--gc-surface-0);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-4);
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}
.gc-modal-shell-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-modal-shell-header__left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-modal-shell-header__icon { color: var(--gc-primary); }
.gc-modal-shell-header__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--gc-text-primary);
}
.gc-modal-shell-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  color: var(--gc-text-tertiary);
  display: flex;
}
.gc-modal-shell-body {
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.gc-modal-shell-footer {
  padding: 14px 20px;
  border-top: 1px solid var(--gc-divider);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.gc-error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background-color: #fef2f2;
  border-radius: var(--gc-radius-card);
  color: #b91c1c;
  font-size: 13px;
}
.gc-forward-quote {
  padding: 12px;
  border-left: 3px solid var(--gc-primary);
  background-color: var(--gc-surface-2);
  border-radius: 8px;
  font-size: 13px;
  color: var(--gc-text-secondary);
  max-height: 120px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.gc-field-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--gc-text-secondary);
  margin-bottom: 6px;
}
.gc-input-card {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  padding: 8px 12px;
  font-size: 14px;
  color: var(--gc-text-primary);
  background-color: var(--gc-surface-0);
  outline: none;
  font-family: var(--gc-font);
}
.gc-input-card.is-textarea {
  resize: vertical;
  line-height: var(--gc-line-height);
  padding-bottom: 22px;
}
.gc-input-card.has-leading-icon {
  padding-left: 32px;
}
.gc-input-wrap { position: relative; }
.gc-input-leading-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gc-text-tertiary);
}
.gc-input-counter {
  position: absolute;
  bottom: 8px;
  right: 10px;
  font-size: 11px;
  color: var(--gc-text-disabled);
}
.gc-list-bordered {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
}
/* The forward picker's list, which must not collapse. It is the only
   shrinkable item in a flex column, and \`overflow-y: auto\` makes its
   min-height resolve to 0 -- so once the preview, caption and search exceed
   the modal's 90vh the list was squeezed down to a single visible row with a
   scrollbar. A row is ~57px, so this holds 5-6 of them, and it gives way on
   a short window rather than pushing the footer off screen. */
.gc-forward-list {
  flex: 1 1 auto;
  min-height: min(368px, 46vh);
  max-height: min(420px, 52vh);
}
.gc-list-empty {
  padding: 24px;
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: 13px;
}

/* ── Call people-picker ("Add to call" / "New call") ──────────────────────
 * A premium dark "call sheet": header + search pinned, ONLY the people list
 * scrolls, Call button pinned at the bottom. Rendered ABOVE the in-call
 * overlay (z 9999) so it stays fully interactive during a live call.
 * Self-contained dark palette → identical in light & dark themes.
 */
.gc-callpick-backdrop {
  z-index: 10050;                 /* above .cs-overlay (9999) and pill (9998) */
  background-color: rgba(6, 11, 14, 0.62);
}

.gc-callpick.gc-modal-shell {
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  background:
    radial-gradient(520px 360px at 50% -10%, rgba(37, 211, 102, 0.16), transparent 60%),
    linear-gradient(180deg, #1f2c33 0%, #131f26 55%, #0b141a 100%);
  box-shadow:
    0 30px 80px rgba(0, 0, 0, 0.6),
    0 0 0 1px rgba(0, 0, 0, 0.4);
  color: #fff;
}

/* Header */
.gc-callpick .gc-modal-shell-header {
  padding: 16px 18px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.gc-callpick__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(145deg, #25d366, #0d9488);
  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
}
.gc-callpick .gc-modal-shell-header__title {
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.gc-callpick__close {
  color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}
.gc-callpick__close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

/* Search (pinned) */
.gc-callpick__search {
  padding: 14px 18px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gc-callpick__search-icon { color: rgba(255, 255, 255, 0.45); left: 14px; }
.gc-callpick__search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px 11px 40px;
  font-size: 14px;
  font-family: var(--gc-font);
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 13px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.gc-callpick__search-input::placeholder { color: rgba(255, 255, 255, 0.4); }
.gc-callpick__search-input:focus {
  border-color: rgba(37, 211, 102, 0.7);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.18);
}

/* Selected chips */
.gc-callpick__chips { display: flex; flex-wrap: wrap; gap: 6px; }
.gc-callpick__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 9px 3px 4px;
  border-radius: 999px;
  border: 1px solid rgba(37, 211, 102, 0.4);
  background: rgba(37, 211, 102, 0.16);
  color: #eafff2;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  font-family: var(--gc-font);
  transition: background 0.15s ease, transform 0.15s ease;
}
.gc-callpick__chip:hover { background: rgba(37, 211, 102, 0.26); transform: translateY(-1px); }
.gc-callpick__chip-name { line-height: 1; }
.gc-callpick__chip-x { color: rgba(255, 255, 255, 0.6); }

/* Scrolling people list — the single scroll container */
.gc-callpick__list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 4px 10px 8px;
}
.gc-callpick__list::-webkit-scrollbar { width: 8px; }
.gc-callpick__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.gc-callpick__list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.24);
  background-clip: padding-box;
}

.gc-callpick__empty {
  padding: 32px 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.45);
  font-size: 13px;
}

.gc-callpick__row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 9px 11px;
  border: none;
  border-radius: 14px;
  background: transparent;
  cursor: pointer;
  font-family: var(--gc-font);
  transition: background 0.14s ease;
}
.gc-callpick__row:hover { background: rgba(255, 255, 255, 0.06); }
.gc-callpick__row:active { background: rgba(255, 255, 255, 0.1); }
.gc-callpick__row:disabled { opacity: 0.5; cursor: default; }
.gc-callpick__row.is-selected { background: rgba(37, 211, 102, 0.15); }
.gc-callpick__row-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.gc-callpick__row-name {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-callpick__row-sub {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-callpick__check {
  flex-shrink: 0;
  width: 23px;
  height: 23px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.14s ease, border-color 0.14s ease, transform 0.14s ease;
}
.gc-callpick__check.is-checked {
  background: #25d366;
  border-color: #25d366;
  transform: scale(1.06);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
}
.gc-callpick__row-call {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #25d366;
  background: rgba(37, 211, 102, 0.16);
  opacity: 0;
  transition: opacity 0.14s ease;
}
.gc-callpick__row:hover .gc-callpick__row-call { opacity: 1; }

/* Footer */
.gc-callpick__footer {
  padding: 12px 18px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}
.gc-callpick__confirm {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: none;
  border-radius: 14px;
  font-size: 14.5px;
  font-weight: 700;
  font-family: var(--gc-font);
  color: #fff;
  cursor: pointer;
  background: linear-gradient(145deg, #25d366, #10b981);
  box-shadow: 0 10px 24px rgba(37, 211, 102, 0.32);
  transition: filter 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}
.gc-callpick__confirm:hover:not(:disabled) { filter: brightness(1.05); transform: translateY(-1px); }
.gc-callpick__confirm:active:not(:disabled) { transform: translateY(0); }
.gc-callpick__confirm:disabled {
  cursor: default;
  color: rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.1);
  box-shadow: none;
}
.gc-forward-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: var(--gc-font);
  border-bottom: 1px solid var(--gc-divider);
}
.gc-forward-option.is-selected { background: var(--gc-primary-container); }
.gc-forward-option.is-disabled { cursor: not-allowed; opacity: 0.5; }
.gc-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid var(--gc-border);
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gc-checkbox.is-checked {
  border-color: var(--gc-primary);
  background-color: var(--gc-primary);
  color: white;
}
.gc-forward-option__name {
  font-size: 14px;
  font-weight: 500;
  color: var(--gc-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-forward-option__type {
  font-size: 11px;
  color: var(--gc-text-tertiary);
}
.gc-btn-outline-card {
  padding: 8px 18px;
  border-radius: var(--gc-radius-card);
  border: 1px solid var(--gc-border);
  background: none;
  font-size: 14px;
  color: var(--gc-text-secondary);
  cursor: pointer;
  font-family: var(--gc-font);
}
.gc-btn-primary-card {
  padding: 8px 20px;
  border-radius: var(--gc-radius-card);
  border: none;
  background-color: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--gc-font);
}
.gc-btn-primary-card:disabled,
.gc-btn-primary-card.is-disabled {
  background-color: var(--gc-surface-3);
  color: var(--gc-text-disabled);
  cursor: not-allowed;
}

/* ──────────────────────────────────────────────────────────────────────────
   NewConvModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-new-conv-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 29, 20, 0.42);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  z-index: 1000;
  padding: 28px 16px;
}
.gc-new-conv-modal {
  background: var(--gc-surface-0);
  border-radius: 16px;
  width: min(480px, calc(100vw - 24px));
  font-family: var(--gc-font);
  box-shadow: 0 24px 56px rgba(15, 29, 20, 0.18), 0 6px 16px rgba(15, 29, 20, 0.08);
  border: 1px solid var(--gc-border);
  overflow: hidden;
  max-height: min(680px, calc(100vh - 32px));
  display: flex;
  flex-direction: column;
}
.gc-new-conv-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-new-conv-icon {
  width: 42px;
  height: 42px;
  border-radius: 13px;
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.gc-new-conv-title {
  margin: 0;
  font-size: 20px;
  font-family: var(--gc-font-display);
  font-weight: 700;
  letter-spacing: 0;
  color: var(--gc-text-primary);
}
.gc-new-conv-subtitle {
  font-size: 13px;
  color: var(--gc-text-tertiary);
  margin-top: 3px;
}
.gc-new-conv-close {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: var(--gc-surface-2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gc-text-secondary);
}
.gc-new-conv-body {
  padding: 18px 22px 20px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}
.gc-new-conv-segmented-wrap { margin-bottom: 16px; }
.gc-new-conv-segmented-wrap .gc-segmented-pill {
  padding: 10px 12px;
  font-size: 13px;
}
.gc-input-pill {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--gc-border);
  border-radius: 12px;
  font-size: 14.5px;
  box-sizing: border-box;
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  font-family: var(--gc-font);
  outline: none;
}
.gc-input-pill.has-leading-icon { padding-left: 40px; }
.gc-input-pill.is-invalid {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.08);
}
.gc-new-conv-group-setup {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 12px;
  align-items: stretch;
  margin-bottom: 14px;
}
.gc-new-conv-group-photo-row {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--gc-border);
  border-radius: 13px;
  background: var(--gc-surface-1);
}
.gc-new-conv-photo-button {
  position: relative;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.gc-new-conv-photo-button__badge {
  position: absolute;
  right: -3px;
  bottom: -3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--gc-surface-1);
  background: var(--gt-accent, #1f4d3f);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gc-new-conv-photo-hint {
  min-width: 0;
  color: var(--gc-text-tertiary);
  font-size: 12.5px;
  line-height: 1.3;
}
.gc-new-conv-group-fields {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
}
.gc-new-conv-group-description {
  min-height: 48px;
  max-height: 76px;
  padding-top: 10px;
  padding-bottom: 10px;
  resize: vertical;
}
.gc-new-conv-name-error {
  margin: 6px 4px 0;
  font-size: 12px;
  color: #dc2626;
  line-height: 1.35;
}
.gc-input-pill-wrap {
  position: relative;
  margin-bottom: 14px;
}
.gc-input-pill-wrap__icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gc-text-tertiary);
  pointer-events: none;
}
.gc-user-list {
  max-height: clamp(260px, 42vh, 360px);
  overflow-y: auto;
  margin: 0 -6px;
  padding: 2px 6px;
}
.gc-user-list__loading,
.gc-user-list__empty {
  text-align: center;
  padding: 34px 0;
  font-size: 13px;
  color: var(--gc-text-tertiary);
}
.gc-user-list__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 30px 0;
}
/* External chat: divider above partner-company people in the picker. */
/* Internal / external filter above the people list in New conversation. */
.gc-scope-filter {
  display: flex;
  gap: 6px;
  margin: 8px 0 2px;
}
.gc-scope-filter__btn {
  flex: 1 1;
  padding: 5px 8px;
  /* "Other companies" wraps mid-phrase at 375px and makes every chip 46px
     tall. Measured on a phone viewport: nowrap fits all three in 302px of
     318px, so flex just hands the longest label the extra width. */
  white-space: nowrap;
  font-size: 11.5px;
  font-weight: 500;
  border-radius: 999px;
  border: 1px solid var(--gc-border-strong);
  background: transparent;
  color: var(--gc-text-tertiary);
  cursor: pointer;
}
.gc-scope-filter__btn:hover { color: var(--gc-text-primary); }
/* --gc-primary / --gc-on-primary, not --gc-accent-soft: the accent tokens are
   declared in :root and [data-theme="hc"] but NOT in [data-theme="dark"], so
   in dark mode the pale :root mint stayed behind near-white text and the label
   vanished. --gc-on-primary exists precisely to be legible on --gc-primary,
   and it is what .gc-presence-filter-chip.is-active already uses. */
.gc-scope-filter__btn.is-on {
  background: var(--gc-primary);
  border-color: var(--gc-primary);
  color: var(--gc-on-primary);
  font-weight: 600;
}

/* On a phone the org badge and the subtitle say the same thing, and the badge
   costs 111px of a 351px row -- measured at 375px, it squeezed "Acme Logistics
   Private Limited" down to 74px. Drop the badge there and let the subtitle
   spell the organisation out, which is the whole point of showing it. */
@media (max-width: 480px) {
  .gc-user-option .gc-org-badge { display: none; }
}

/* A group picker lists colleagues and people at other organisations in one
   scroll, so each run of rows says which it is. */
.gc-user-list__section {
  padding: 8px 10px 4px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
}

/* The people picked for a group. They are shown as chips because the two
   halves of the directory scroll independently -- and the external half is
   re-queried on every keystroke -- so a pick can easily be off screen. */
.gc-new-conv-picked {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 8px 0 2px;
}
.gc-new-conv-picked__chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid var(--gc-border-strong);
  background: var(--gc-surface-2, transparent);
  color: var(--gc-text-primary);
  font-size: 11.5px;
  cursor: pointer;
}
.gc-new-conv-picked__chip:hover { border-color: var(--gc-primary); }
.gc-new-conv-picked__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}
/* The company is what tells two same-named people apart, so it rides along on
   the chip rather than only on the row that is no longer visible. */
.gc-new-conv-picked__org {
  color: var(--gc-text-tertiary);
  font-size: 10.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 110px;
}

/* External results are paged: the platform is bigger than one company. */
.gc-user-list__more {
  display: block;
  width: 100%;
  padding: 9px;
  margin-top: 4px;
  font-size: 12px;
  background: transparent;
  border: 0;
  color: var(--gc-text-tertiary);
  cursor: pointer;
}
.gc-user-list__more:hover:not(:disabled) { color: var(--gc-text-primary); }
.gc-user-list__more:disabled { cursor: default; opacity: 0.6; }

.gc-user-list__section-heading {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
  padding: 10px 8px 4px;
  border-top: 1px solid var(--gc-border-subtle, var(--gc-border-strong));
  margin-top: 6px;
}
.gc-user-option {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  background: transparent;
  transition: background 160ms ease;
}
.gc-user-option:hover { background: var(--gc-surface-2); }
.gc-user-option.is-selected,
.gc-user-option.is-selected:hover { background: var(--gc-primary-container); }
.gc-user-option__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--gc-text-primary);
  font-family: var(--gc-font-display);
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-user-option__sub {
  font-size: 12.5px;
  color: var(--gc-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
}
.gc-user-option__check {
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid var(--gc-border);
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 160ms ease;
}
.gc-user-option__check.is-on {
  border-color: var(--gc-primary);
  background: var(--gc-primary);
  color: var(--gc-on-primary);
}
.gc-hidden-input { display: none; }
.gc-new-conv-footer {
  padding: 14px 22px;
  border-top: 1px solid var(--gc-divider);
  background: var(--gc-surface-1);
  display: flex;
  align-items: center;
  gap: 12px;
}
.gc-new-conv-footer__hint {
  font-size: 12.5px;
  color: var(--gc-text-tertiary);
}
.gc-new-conv-submit {
  margin-left: auto;
  padding: 11px 22px;
  border: none;
  border-radius: 12px;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: var(--gc-font-display);
  letter-spacing: 0;
  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);
  transition: opacity 180ms ease;
}
.gc-new-conv-submit:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 520px) {
  .gc-new-conv-backdrop {
    padding: 18px 10px;
  }

  .gc-new-conv-header {
    gap: 12px;
    padding: 16px;
  }

  .gc-new-conv-title {
    font-size: 18px;
  }

  .gc-new-conv-subtitle {
    font-size: 12px;
  }

  .gc-new-conv-body {
    padding: 16px;
  }

  .gc-new-conv-group-setup {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .gc-user-list {
    max-height: clamp(220px, 40vh, 320px);
  }

  .gc-new-conv-footer {
    padding: 12px 16px;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   ReminderModal (amber accent variant)
   ────────────────────────────────────────────────────────────────────────── */
.gc-reminder-icon { color: #f59e0b; }
.gc-reminder-quote {
  padding: 10px;
  border-left: 3px solid #f59e0b;
  background-color: var(--gc-surface-2);
  border-radius: 8px;
  font-size: 12px;
  color: var(--gc-text-secondary);
  max-height: 80px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.gc-preset-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.gc-preset-btn {
  padding: 10px 12px;
  border-radius: var(--gc-radius-card);
  border: 1px solid var(--gc-border);
  background-color: var(--gc-surface-0);
  cursor: pointer;
  text-align: left;
  font-family: var(--gc-font);
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.gc-preset-btn.is-active {
  border-color: var(--gc-primary);
  background-color: var(--gc-primary-container);
}
.gc-preset-btn__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--gc-text-primary);
}
.gc-preset-btn__time {
  font-size: 11px;
  color: var(--gc-text-tertiary);
}
.gc-btn-amber {
  padding: 8px 20px;
  border-radius: var(--gc-radius-card);
  border: none;
  background-color: #f59e0b;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--gc-font);
}
.gc-btn-amber:disabled,
.gc-btn-amber.is-disabled {
  background-color: var(--gc-surface-3);
  color: var(--gc-text-disabled);
  cursor: not-allowed;
}

/* ──────────────────────────────────────────────────────────────────────────
   RemindersList
   ────────────────────────────────────────────────────────────────────────── */
.gc-reminders-aside {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 380px;
  max-width: 100vw;
  background-color: var(--gc-surface-0);
  border-left: 1px solid var(--gc-divider);
  box-shadow: var(--gc-elev-3);
  z-index: 55;
  display: flex;
  flex-direction: column;
}
.gc-reminders-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-reminders-header__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--gc-text-primary);
}
.gc-reminders-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px;
}
.gc-reminders-state {
  padding: 30px;
  text-align: center;
  color: var(--gc-text-tertiary);
}
.gc-reminders-empty {
  padding: 40px;
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: 13px;
  line-height: 1.5;
}
.gc-reminders-empty__icon {
  margin: 0 auto 10px;
  opacity: 0.4;
  display: block;
}
.gc-reminders-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gc-reminder-card {
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  padding: 12px;
  background-color: var(--gc-surface-0);
}
.gc-reminder-edit-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gc-edit-input {
  border: 1px solid var(--gc-border);
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 13px;
}
.gc-edit-input.is-textarea { resize: vertical; }
.gc-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
.gc-btn-mini-outline {
  padding: 4px 10px;
  font-size: 12px;
  border: 1px solid var(--gc-border);
  background: none;
  border-radius: 6px;
  cursor: pointer;
}
.gc-btn-mini-primary {
  padding: 4px 10px;
  font-size: 12px;
  border: none;
  background: var(--gc-primary);
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.gc-reminder-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.gc-reminder-card__when {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
}
.gc-reminder-card__actions {
  display: flex;
  gap: 2px;
}
.gc-icon-action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: var(--gc-text-tertiary);
  display: flex;
}
.gc-icon-action-btn.is-danger { color: #b91c1c; }
.gc-reminder-card__note {
  font-size: 13px;
  color: var(--gc-text-primary);
  margin-bottom: 4px;
  word-break: break-word;
}
.gc-reminder-card__meta {
  font-size: 11px;
  color: var(--gc-text-tertiary);
}
.gc-reminder-card__jump {
  background: none;
  border: none;
  color: var(--gc-primary);
  cursor: pointer;
  font-size: 11px;
  margin-left: 8px;
  padding: 0;
}

/* ──────────────────────────────────────────────────────────────────────────
   TranslatePanel
   ────────────────────────────────────────────────────────────────────────── */
.gc-translate-panel {
  width: 280px;
  background-color: var(--gc-surface-0);
  border-radius: 12px;
  box-shadow: var(--gc-elev-3);
  border: 1px solid var(--gc-border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.gc-translate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-translate-header__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--gc-text-primary);
}
.gc-translate-header__icon { color: var(--gc-primary); }
.gc-translate-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  color: var(--gc-text-tertiary);
  display: flex;
  align-items: center;
  transition: background var(--gc-transition-fast);
}
.gc-translate-close:hover { background: var(--gc-surface-2); }
.gc-translate-lang-row {
  padding: 12px 14px;
  border-bottom: 1px solid var(--gc-divider);
}
.gc-translate-lang-label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: var(--gc-text-tertiary);
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.gc-translate-select {
  width: 100%;
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  padding: 6px 10px;
  font-size: 13px;
  color: var(--gc-text-primary);
  background-color: var(--gc-surface-0);
  outline: none;
  cursor: pointer;
  font-family: var(--gc-font);
}
.gc-translate-content {
  padding: 12px 14px;
  min-height: 72px;
}
.gc-translate-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--gc-text-tertiary);
  font-size: 13px;
}
.gc-translate-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: var(--gc-mention-channel-text);
  font-size: 13px;
}
.gc-translate-text {
  margin: 0;
  font-size: 13px;
  line-height: var(--gc-line-height);
  color: var(--gc-text-primary);
  word-break: break-word;
}
.gc-translate-original-wrap {
  border-top: 1px solid var(--gc-divider);
}
.gc-translate-original-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font);
  transition: background var(--gc-transition-fast);
}
.gc-translate-original-toggle:hover { background: var(--gc-surface-1); }
.gc-translate-original-text {
  margin: 0;
  padding: 0 14px 12px;
  font-size: 12px;
  line-height: var(--gc-line-height);
  color: var(--gc-text-tertiary);
  word-break: break-word;
  background-color: var(--gc-surface-1);
}

/* ──────────────────────────────────────────────────────────────────────────
   SummarizeModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-summarize-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.gc-summarize-modal {
  background-color: var(--gc-surface-0);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-4);
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
}
.gc-summarize-controls {
  padding: 16px 20px;
  border-bottom: 1px solid var(--gc-divider);
  display: flex;
  align-items: center;
  gap: 12px;
}
.gc-style-toggle {
  display: flex;
  gap: 2px;
  padding: 3px;
  background-color: var(--gc-surface-2);
  border-radius: 8px;
  flex: 1 1;
}
.gc-style-toggle__btn {
  flex: 1 1;
  padding: 5px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: var(--gc-font);
  background-color: transparent;
  color: var(--gc-text-tertiary);
  box-shadow: none;
  transition: all var(--gc-transition-fast);
  text-transform: capitalize;
}
.gc-style-toggle__btn.is-active {
  background-color: var(--gc-surface-0);
  color: var(--gc-text-primary);
  box-shadow: var(--gc-elev-1);
}
.gc-btn-generate {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: var(--gc-radius-card);
  border: none;
  background-color: var(--gc-primary);
  color: var(--gc-on-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--gc-font);
  white-space: nowrap;
  transition: background var(--gc-transition-fast);
}
.gc-btn-generate:hover { background-color: var(--gc-primary-hover); }
.gc-btn-generate:disabled,
.gc-btn-generate.is-busy {
  background-color: var(--gc-surface-3);
  color: var(--gc-text-disabled);
  cursor: not-allowed;
}
.gc-summarize-body {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gc-error-pill-soft {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background-color: var(--gc-mention-channel-bg);
  border-radius: var(--gc-radius-card);
  color: var(--gc-mention-channel-text);
  font-size: 13px;
}
.gc-summarize-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background-color: var(--gc-surface-1);
  border-radius: var(--gc-radius-card);
  border: 1px solid var(--gc-border);
}
.gc-skeleton-line {
  height: 13px;
  border-radius: 6px;
  background-color: var(--gc-surface-3);
  animation: gc-pulse 1.5s ease-in-out infinite;
  width: var(--skeleton-w, 90%);
}
@keyframes gc-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}
.gc-summary-result {
  background-color: var(--gc-surface-1);
  border-radius: var(--gc-radius-card);
  border: 1px solid var(--gc-border);
  overflow: hidden;
}
.gc-summary-result__body { padding: 14px 16px; }
.gc-summary-result__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--gc-text-primary);
  word-break: break-word;
  white-space: pre-wrap;
}
.gc-summary-result__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-top: 1px solid var(--gc-divider);
  background-color: var(--gc-surface-2);
}
.gc-summary-result__meta {
  font-size: 11px;
  color: var(--gc-text-tertiary);
}
.gc-btn-copy {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-0);
  cursor: pointer;
  font-size: 12px;
  color: var(--gc-text-secondary);
  font-family: var(--gc-font);
  transition: all var(--gc-transition-fast);
}
.gc-btn-copy:hover { background: var(--gc-surface-3); }
.gc-btn-copy.is-copied { color: var(--gc-online); }
.gc-summarize-empty {
  text-align: center;
  padding: 32px 16px;
  color: var(--gc-text-tertiary);
  font-size: 13px;
}
.gc-summarize-empty strong { color: var(--gc-text-secondary); }

/* ──────────────────────────────────────────────────────────────────────────
   SearchSpotlight
   ────────────────────────────────────────────────────────────────────────── */
.gc-spotlight-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10vh;
}
.gc-spotlight-modal {
  width: 600px;
  max-width: calc(100vw - 32px);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-4);
  background: var(--gc-surface-0);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.gc-spotlight-search {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--gc-border);
  gap: 10px;
}
.gc-spotlight-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  color: var(--gc-text-primary);
  font-family: var(--gc-font);
}
.gc-spotlight-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--gc-border);
  border-top-color: var(--gc-primary);
  border-radius: 50%;
  animation: gc-spin 0.7s linear infinite;
  flex-shrink: 0;
}
.gc-spotlight-kbd {
  font-size: 11px;
  padding: 2px 6px;
  border: 1px solid var(--gc-border);
  border-radius: 4px;
  color: var(--gc-text-tertiary);
  cursor: pointer;
}
.gc-spotlight-filters {
  display: flex;
  gap: 8px;
  padding: 10px 16px;
}
.gc-spotlight-filters.has-results { border-bottom: 1px solid var(--gc-border); }
.gc-spotlight-chip {
  padding: 4px 12px;
  border-radius: var(--gc-radius-pill);
  border: none;
  cursor: pointer;
  font-size: var(--gc-font-size-sm);
  font-weight: 400;
  background: var(--gc-surface-2);
  color: var(--gc-text-secondary);
  transition: background var(--gc-transition-fast);
}
.gc-spotlight-chip.is-active {
  font-weight: 600;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
}
.gc-spotlight-results {
  overflow-y: auto;
  max-height: 380px;
}
.gc-spotlight-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 16px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background var(--gc-transition-fast);
}
.gc-spotlight-row.is-active { background: var(--gc-surface-2); }
.gc-spotlight-row__title {
  font-size: var(--gc-font-size-base);
  font-weight: 600;
  color: var(--gc-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-spotlight-row__ts {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  flex-shrink: 0;
}
.gc-spotlight-row__snippet {
  font-size: var(--gc-font-size-sm);
  color: var(--gc-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 1px;
}
.gc-spotlight-row__conv {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  margin-top: 1px;
}
.gc-spotlight-mark {
  background: var(--gc-primary-container);
  color: var(--gc-text-primary);
  border-radius: 2px;
}
.gc-spotlight-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: var(--gc-font-size-base);
}
.gc-spotlight-footer {
  display: flex;
  gap: 16px;
  padding: 8px 16px;
  border-top: 1px solid var(--gc-border);
  color: var(--gc-text-tertiary);
  font-size: var(--gc-font-size-xs);
}

/* ──────────────────────────────────────────────────────────────────────────
   ConversationSettingsModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-settings-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.gc-settings-modal {
  background: var(--gc-surface-0);
  border-radius: 12px;
  width: 480px;
  max-width: 92vw;
  padding: 24px;
  font-family: var(--gc-font);
  box-shadow: var(--gc-elev-3);
  color: var(--gc-text-primary);
}
.gc-settings-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.gc-settings-subtitle {
  margin-top: 4px;
  color: var(--gc-text-secondary);
  font-size: 13px;
}
.gc-settings-block {
  margin-top: 24px;
  padding: 16px;
  background: var(--gc-surface-1);
  border-radius: 8px;
}
.gc-settings-label-row {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.gc-settings-checkbox {
  width: 18px;
  height: 18px;
}
.gc-settings-feature-name { font-weight: 600; }
.gc-settings-feature-hint {
  font-size: 12px;
  color: var(--gc-text-tertiary);
}
.gc-settings-sub-row {
  margin-top: 12px;
  padding-left: 30px;
}
.gc-settings-sub-label {
  font-size: 13px;
  color: var(--gc-text-secondary);
}
.gc-settings-select {
  margin-top: 6px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--gc-outline);
  border-radius: 6px;
  background: var(--gc-surface-0);
  font-size: 13px;
}
.gc-settings-error {
  margin-top: 12px;
  color: var(--gc-dnd);
  font-size: 13px;
}
.gc-settings-actions {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.gc-btn-outline-md {
  padding: 8px 16px;
  border: 1px solid var(--gc-outline);
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
}
.gc-btn-filled-md {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: var(--gc-primary);
  color: #fff;
  cursor: pointer;
}
.gc-btn-filled-md:disabled { opacity: 0.6; }

/* ── Phase 12: Cross-org admin lifecycle ────────────────────────────────── */
.gc-settings-section { padding: 12px 0 4px; border-top: 1px solid var(--gc-outline); margin-top: 16px; }
.gc-settings-section > h3 { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--gc-muted, #6b7280); margin: 0 0 10px; font-weight: 600; }
.gc-settings-action { margin-top: 10px; display: flex; flex-direction: column; gap: 6px; }
.gc-settings-action__error { color: var(--gc-dnd, #b91c1c); font-size: 12px; margin: 0; }
.gc-settings-hint { color: var(--gc-muted, #6b7280); font-size: 12px; margin: 6px 0 0; }
.gc-settings-label { font-size: 12px; color: var(--gc-muted, #6b7280); margin-bottom: 2px; }
/* gc-btn base + variants (Phase 12 — do not duplicate existing gc-btn-* rules) */
.gc-btn { padding: 6px 12px; border-radius: 6px; font-size: 13px; cursor: pointer; border: 1px solid transparent; display: inline-flex; align-items: center; gap: 4px; }
.gc-btn--primary { background: var(--gc-primary, #2563eb); color: #fff; border-color: var(--gc-primary, #2563eb); }
.gc-btn--primary:hover:not(:disabled) { background: var(--gc-primary-hover, #1d4ed8); border-color: var(--gc-primary-hover, #1d4ed8); }
.gc-btn--primary:disabled { opacity: .5; cursor: default; }
.gc-btn--danger-outline { border-color: var(--gc-dnd, #b91c1c); color: var(--gc-dnd, #b91c1c); background: transparent; }
.gc-btn--danger-outline:hover:not(:disabled) { background: rgba(185, 28, 28, 0.06); }
.gc-btn--ghost { border-color: var(--gc-outline, #e5e7eb); color: var(--gc-text-primary, #111827); background: transparent; }
.gc-btn--ghost:hover { background: var(--gc-surface-1, #f3f4f6); }

/* ──────────────────────────────────────────────────────────────────────────
   Toggle switch (shared)
   ────────────────────────────────────────────────────────────────────────── */
.gc-toggle {
  width: 40px;
  height: 22px;
  border-radius: var(--gc-radius-pill);
  background-color: var(--gc-surface-3);
  border: none;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: background-color var(--gc-transition-fast);
}
.gc-toggle.is-on { background-color: var(--gc-primary); }
.gc-toggle__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--gc-surface-0);
  transition: left var(--gc-transition-fast);
  box-shadow: var(--gc-elev-1);
}
.gc-toggle.is-on .gc-toggle__thumb { left: 21px; }

/* ──────────────────────────────────────────────────────────────────────────
   PollCreatorModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-poll-creator-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.gc-poll-creator-body {
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.gc-poll-option-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-poll-option-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gc-text-tertiary);
  padding: 4px;
  border-radius: 6px;
  display: flex;
}
.gc-poll-option-remove:disabled {
  cursor: not-allowed;
  color: var(--gc-text-disabled);
}
.gc-poll-add-option {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px dashed var(--gc-border);
  background: none;
  border-radius: var(--gc-radius-card);
  padding: 8px 12px;
  font-size: 13px;
  color: var(--gc-primary);
  cursor: pointer;
  width: 100%;
  font-family: var(--gc-font);
}
.gc-poll-add-option:hover { background: var(--gc-primary-container); }
.gc-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.gc-toggle-row__label {
  font-size: 14px;
  font-weight: 500;
  color: var(--gc-text-primary);
}
.gc-toggle-row__sub {
  font-size: 12px;
  color: var(--gc-text-tertiary);
  margin-top: 1px;
}
.gc-expiry-segmented {
  display: grid;
  grid-template-columns: var(--expiry-cols, repeat(4, 1fr));
  gap: 6px;
  padding: 4px;
  background: var(--gc-surface-2);
  border-radius: var(--gc-radius-pill);
  border: 1px solid var(--gc-border);
}
.gc-expiry-chip {
  appearance: none;
  border: none;
  cursor: pointer;
  padding: 7px 10px;
  border-radius: var(--gc-radius-pill);
  font-family: var(--gc-font);
  font-size: 13px;
  font-weight: 500;
  color: var(--gc-text-secondary);
  background: transparent;
  box-shadow: none;
  transition: background 160ms cubic-bezier(0.33, 1, 0.68, 1), color 160ms ease;
}
.gc-expiry-chip.is-active {
  font-weight: 600;
  color: var(--gc-on-primary);
  background: var(--gc-primary);
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.12);
}
.gc-poll-creator-footer {
  padding: 14px 20px;
  border-top: 1px solid var(--gc-divider);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.gc-btn-outline-card:hover { background: var(--gc-surface-2); }
.gc-btn-primary-card:hover:not(:disabled):not(.is-disabled) { background-color: var(--gc-primary-hover); }

/* ──────────────────────────────────────────────────────────────────────────
   PollVoterDetailModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-poll-voter-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 29, 20, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.gc-poll-voter-modal {
  background-color: var(--gc-surface-0);
  border-radius: var(--gc-radius-modal);
  box-shadow: var(--gc-elev-4);
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--gc-font);
}
.gc-poll-voter-header {
  padding: 18px 22px 14px;
  border-bottom: 1px solid var(--gc-divider);
  position: relative;
  background: linear-gradient(180deg, var(--gc-primary-container) 0%, var(--gc-surface-0) 100%);
  flex-shrink: 0;
}
.gc-poll-voter-header__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.gc-poll-voter-header__icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: var(--gc-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(15, 29, 20, 0.15);
}
.gc-poll-voter-header__eyebrow {
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--gc-text-tertiary);
  margin-bottom: 2px;
}
.gc-poll-voter-header__question {
  font-size: 16px;
  font-weight: 600;
  color: var(--gc-text-primary);
  line-height: 1.35;
  word-break: break-word;
  /* A long question would otherwise eat the whole 85vh and starve the voter
     list this modal exists to show. The full text stays readable in the chat
     bubble behind the modal. */
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gc-poll-voter-header__meta {
  margin-top: 6px;
  font-size: 12px;
  color: var(--gc-text-secondary);
  display: flex;
  align-items: center;
  gap: 6px;
}
.gc-poll-voter-header__meta-strong { font-weight: 600; }
.gc-poll-voter-header__meta-dot { color: var(--gc-text-disabled); }
.gc-poll-voter-header__meta-anon {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--gc-text-tertiary);
}
.gc-poll-voter-close {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid var(--gc-border);
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  color: var(--gc-text-secondary);
  display: flex;
  flex-shrink: 0;
  transition: background var(--gc-transition-fast);
}
.gc-poll-voter-close:hover { background: var(--gc-surface-2); }
.gc-poll-voter-body {
  padding: 14px 18px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gc-poll-voter-anon-notice {
  padding: 24px 16px;
  border-radius: var(--gc-radius-card);
  border: 1px dashed var(--gc-border);
  background: var(--gc-surface-1);
  text-align: center;
  color: var(--gc-text-tertiary);
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.gc-poll-voter-anon-icon { opacity: 0.6; }
.gc-poll-voter-anon__title {
  font-weight: 600;
  color: var(--gc-text-secondary);
  margin-bottom: 2px;
}
.gc-poll-option-section {
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  overflow: hidden;
  background: var(--gc-surface-0);
  /* These sections are flex items of the column-flex .gc-poll-voter-body. With
     the default flex-shrink:1 they compress to fit the modal instead of
     overflowing it, and because they set overflow:hidden their automatic
     minimum size resolves to 0 - so a 10-voter option silently collapsed and
     clipped its own list while the body reported nothing to scroll. Holding
     natural height is what lets the body's overflow-y:auto actually scroll. */
  flex-shrink: 0;
}
.gc-poll-option-header {
  position: relative;
  padding: 10px 14px;
}
.gc-poll-option-header.has-voters { border-bottom: 1px solid var(--gc-divider); }
.gc-poll-option-bar {
  position: absolute;
  inset: 0;
  width: var(--poll-pct, 0%);
  background: var(--gc-surface-2);
  opacity: 0.7;
  transition: width 480ms cubic-bezier(0.33, 1, 0.68, 1);
}
.gc-poll-option-bar.is-mine { background: var(--gc-primary-container); }
.gc-poll-option-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}
.gc-poll-option-text {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: var(--gc-text-primary);
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-poll-option-text.is-mine { font-weight: 600; }
.gc-poll-option-count {
  font-size: 12px;
  color: var(--gc-text-tertiary);
  flex-shrink: 0;
}
.gc-poll-option-pct {
  font-size: 13px;
  font-weight: 700;
  color: var(--gc-text-secondary);
  min-width: 38px;
  text-align: right;
  flex-shrink: 0;
}
.gc-poll-option-pct.is-mine { color: var(--gc-primary); }
.gc-poll-voter-list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
  background: var(--gc-surface-1);
}
.gc-poll-voter-li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px;
}
.gc-poll-voter-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--voter-bg, var(--gc-primary));
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px var(--gc-surface-1);
}
.gc-poll-voter-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 500;
  color: var(--gc-text-primary);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gc-poll-voter-name.is-mine {
  font-weight: 600;
  color: var(--gc-primary);
}
.gc-poll-voter-me-pill {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--gc-primary);
  background: var(--gc-primary-container);
  padding: 2px 7px;
  border-radius: var(--gc-radius-pill);
}
.gc-poll-no-votes {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--gc-surface-1);
  color: var(--gc-text-tertiary);
  font-size: 12px;
  font-style: italic;
}
.gc-poll-no-votes-icon { opacity: 0.5; }

/* ──────────────────────────────────────────────────────────────────────────
   ScheduleMeetingModal
   ────────────────────────────────────────────────────────────────────────── */
.gc-sched-modal {
  background: var(--gc-surface-0);
  border-radius: 18px;
  width: 760px;
  max-width: 100%;
  padding: 16px 20px 14px;
  font-family: var(--gc-font);
  box-shadow: 0 24px 56px rgba(15, 29, 20, 0.18), 0 6px 16px rgba(15, 29, 20, 0.08);
  border: 1px solid var(--gc-border);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
}
.gc-sched-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.gc-sched-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.gc-sched-title {
  margin: 0;
  font-size: 16px;
  font-family: var(--gc-font-display);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gc-text-primary);
}
.gc-sched-subtitle {
  font-size: 11px;
  color: var(--gc-text-tertiary);
  margin-top: 1px;
}
.gc-sched-close {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: none;
  background: var(--gc-surface-2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gc-text-secondary);
}
.gc-sched-eyebrow {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary);
  margin-bottom: 4px;
  font-family: var(--gc-font-display);
}
.gc-sched-eyebrow.is-row {
  display: flex;
  align-items: center;
  gap: 5px;
}
.gc-sched-eyebrow__optional {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: var(--gc-text-disabled);
}
.gc-sched-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--gc-border);
  border-radius: 11px;
  font-size: 13px;
  box-sizing: border-box;
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  font-family: var(--gc-font);
  transition: border-color 200ms ease, box-shadow 200ms ease;
}
.gc-sched-input.is-textarea { resize: vertical; }
.gc-sched-grid {
  display: grid;
  grid-template-columns: minmax(320px, 1.05fr) minmax(220px, 0.95fr);
  gap: 12px;
  margin-bottom: 10px;
}
.gc-sched-right-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gc-sched-preview {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 11px;
  color: var(--gc-text-tertiary);
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--gc-surface-1);
  border: 1px solid var(--gc-divider);
  margin-top: auto;
}
.gc-sched-preview__icon { margin-top: 2px; }
.gc-sched-preview__title {
  color: var(--gc-text-secondary);
  font-weight: 600;
  font-size: 11.5px;
}
.gc-sched-preview__tz {
  margin-top: 2px;
  font-size: 10.5px;
}
.gc-sched-inline-cal {
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);
}
.gc-sched-cal-month {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 14px;
  color: var(--gc-text-primary);
  letter-spacing: -0.01em;
}
.gc-sched-cal-nav {
  color: var(--gc-text-secondary);
  background: transparent;
}
.gc-sched-cal-nav:hover { background: var(--gc-surface-2); }
.gc-sched-day-disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.gc-sched-attendees-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 88px;
  overflow-y: auto;
  border: 1px solid var(--gc-border);
  border-radius: 11px;
  padding: 8px;
  background: var(--gc-surface-1);
}
.gc-sched-attendee-chip {
  padding: 5px 11px;
  border-radius: var(--gc-radius-pill);
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-0);
  color: var(--gc-text-primary);
  font-size: 12px;
  cursor: pointer;
  font-family: var(--gc-font-display);
  font-weight: 600;
  transition: all 180ms ease;
}
.gc-sched-attendee-chip.is-on {
  border-color: var(--gc-primary);
  background: var(--gc-primary-container);
  color: var(--gc-primary);
}
.gc-sched-attendees-empty {
  font-size: 12px;
  color: var(--gc-text-tertiary);
  padding: 4px 2px;
}
.gc-sched-error {
  color: var(--gc-dnd);
  font-size: 12px;
  margin-bottom: 8px;
  padding: 6px 10px;
  border-radius: 9px;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.18);
}
.gc-sched-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.gc-sched-btn-cancel {
  padding: 7px 16px;
  border: 1px solid var(--gc-border);
  border-radius: 11px;
  background: var(--gc-surface-0);
  color: var(--gc-text-secondary);
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 600;
  font-family: var(--gc-font-display);
  transition: background 180ms ease;
}
.gc-sched-btn-submit {
  padding: 7px 16px;
  border: none;
  border-radius: 11px;
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  font-family: var(--gc-font-display);
  letter-spacing: 0.005em;
  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);
  transition: opacity 180ms ease, transform 180ms ease;
}
.gc-sched-btn-submit:disabled {
  cursor: default;
  opacity: 0.55;
}

/* ──────────────────────────────────────────────────────────────────────────
   PollCard
   ────────────────────────────────────────────────────────────────────────── */
.gc-poll-card {
  /* Border + shadow dropped so the poll reads as one clean surface inside the
     bubble, not a framed box nested in another frame. */
  background: var(--gc-surface-1);
  border: none;
  border-radius: var(--gc-radius-card);
  padding: 14px 16px;
  max-width: 420px;
  font-family: var(--gc-font);
  box-shadow: none;
}
.gc-poll-card__header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
}
.gc-poll-card__icon {
  color: var(--gc-primary);
  flex-shrink: 0;
  margin-top: 2px;
}
.gc-poll-card__question {
  font-weight: 600;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
  line-height: 1.4;
}
.gc-poll-card__chips {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
}
.gc-poll-card__chip-closed {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
  background: var(--gc-surface-3);
  padding: 1px 7px;
  border-radius: var(--gc-radius-pill);
  font-weight: 600;
}
.gc-poll-card__chip-meta {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
}
.gc-poll-kebab-wrap {
  position: relative;
  flex-shrink: 0;
}
.gc-poll-kebab-btn {
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gc-text-tertiary);
  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);
}
.gc-poll-kebab-btn:hover,
.gc-poll-kebab-btn.is-open {
  background: var(--gc-surface-3);
  color: var(--gc-text-secondary);
}
.gc-poll-kebab-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  border-radius: var(--gc-radius-card);
  box-shadow: var(--gc-elev-3);
  padding: 4px;
  min-width: 168px;
  z-index: 20;
  font-family: var(--gc-font);
}
.gc-poll-kebab-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: var(--gc-text-primary);
  text-align: left;
  font-family: inherit;
  transition: background var(--gc-transition-fast);
}
.gc-poll-kebab-item:hover { background: var(--gc-surface-2); }
.gc-poll-kebab-item__icon { color: var(--gc-primary); }
.gc-poll-kebab-item__count {
  font-size: 11px;
  color: var(--gc-text-tertiary);
  font-weight: 600;
}
.gc-poll-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gc-poll-option {
  position: relative;
  width: 100%;
  text-align: left;
  background: var(--gc-surface-0);
  border: 1.5px solid var(--gc-border);
  border-radius: 6px;
  padding: 8px 10px;
  cursor: default;
  overflow: hidden;
  transition: border-color var(--gc-transition-fast);
}
.gc-poll-option.is-votable { cursor: pointer; }
.gc-poll-option.is-selected,
.gc-poll-option.is-voted { border-color: var(--gc-primary); }
.gc-poll-option__bar {
  position: absolute;
  inset: 0;
  background: var(--gc-primary-container);
  border-radius: 5px;
  transform-origin: left center;
}
.gc-poll-option__row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
}
.gc-poll-option__check {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 2px solid var(--gc-border-strong);
  background: transparent;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--gc-transition-fast);
}
.gc-poll-option__check.is-single { border-radius: 50%; }
.gc-poll-option__check.is-on {
  border-color: var(--gc-primary);
  background: var(--gc-primary);
}
.gc-poll-option__voted-mark {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--gc-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gc-poll-option__text {
  flex: 1 1;
  font-size: var(--gc-font-size-base);
  color: var(--gc-text-primary);
  font-weight: 400;
  line-height: 1.3;
}
.gc-poll-option__text.is-voted { font-weight: 600; }
.gc-poll-option__stats {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.gc-poll-option__stats-count {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
}
.gc-poll-option__stats-pct {
  font-size: var(--gc-font-size-sm);
  font-weight: 600;
  color: var(--gc-text-secondary);
  min-width: 34px;
  text-align: right;
}
.gc-poll-option__stats-pct.is-voted { color: var(--gc-primary); }
.gc-poll-option__voter-stack-wrap {
  position: relative;
  z-index: 1;
}
.gc-voter-stack {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}
.gc-voter-stack__avatars { display: flex; }
.gc-voter-avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--voter-bg, var(--gc-primary));
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--gc-surface-0);
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.05);
}
.gc-voter-avatar.is-overflow {
  background: var(--gc-surface-3);
  color: var(--gc-text-secondary);
}
.gc-voter-avatar.is-stacked { margin-left: -5px; }
.gc-voter-stack__label {
  font-size: 11px;
  color: var(--gc-text-tertiary);
}
.gc-poll-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.gc-poll-card__footer-meta {
  font-size: var(--gc-font-size-xs);
  color: var(--gc-text-tertiary);
}
.gc-poll-vote-btn {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  border: none;
  border-radius: var(--gc-radius-pill);
  padding: 5px 16px;
  font-size: var(--gc-font-size-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);
  font-family: var(--gc-font);
}
.gc-poll-vote-btn:disabled,
.gc-poll-vote-btn.is-disabled {
  background: var(--gc-surface-3);
  color: var(--gc-text-disabled);
  cursor: not-allowed;
}
.gc-poll-update-btn {
  background: none;
  border: 1px solid var(--gc-primary);
  color: var(--gc-primary);
  border-radius: var(--gc-radius-pill);
  padding: 4px 14px;
  font-size: var(--gc-font-size-sm);
  font-weight: 600;
  cursor: pointer;
  font-family: var(--gc-font);
}
.gc-poll-update-btn:disabled { cursor: not-allowed; }

/* ──────────────────────────────────────────────────────────────────────────
   MessageBubble
   ────────────────────────────────────────────────────────────────────────── */
.gc-msg-deleted-pill {
  padding: 7px 14px 7px 11px;
  background: var(--gc-primary-container, #dcefe1);
  border: 1px dashed var(--gc-primary, #1f2e23);
  color: var(--gc-primary, #1f2e23);
  font-family: var(--gc-font-display, "Plus Jakarta Sans", system-ui, sans-serif);
  font-size: 11.5px;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.06), inset 0 0 0 1px rgba(255, 255, 255, 0.3);
  opacity: 0.92;
}
.gc-msg-deleted-glyph {
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.65);
  color: var(--gc-primary, #1f2e23);
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(31, 46, 35, 0.18);
}
.gc-msg-deleted-text {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
}
.gc-msg-deleted-text__primary {
  font-weight: 600;
  font-style: italic;
}
.gc-msg-deleted-text__attribution {
  font-size: 9.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 700;
  opacity: 0.62;
  border-left: 1px solid currentColor;
  padding-left: 8px;
  margin-left: -2px;
}
.gc-msg-task-link {
  color: var(--gc-accent-strong);
  background: var(--gc-accent-soft);
  border: 1px solid rgba(16, 185, 129, 0.25);
}
.gc-msg-task-link__icon { color: var(--gc-accent); }

/* ── Chat task card (Phase 9) ─────────────────────────────────────────────
   Compact clickable card rendered inside task_link message bubbles.
   Uses --gc-* tokens so it inherits all theme variants automatically.    */
.gc-task-card {
  border: 1px solid var(--gc-border, #e5e7eb);
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  background: var(--gc-surface-0, #ffffff);
  transition: box-shadow 120ms ease, transform 120ms ease;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gc-task-card:hover { box-shadow: 0 2px 10px rgba(0,0,0,.06); }
.gc-task-card:focus-visible { outline: 2px solid var(--gc-focus, #3b82f6); outline-offset: 2px; }
.gc-task-card--deleted { opacity: 0.55; cursor: default; }
.gc-task-card__header { display: flex; gap: 8px; align-items: center; }
.gc-task-card__status {
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  background: var(--gc-accent-soft, #eef2ff);
  color: var(--gc-accent-strong, #4338ca);
}
.gc-task-card__status--open     { background: #dbeafe; color: #1d4ed8; }
.gc-task-card__status--progress { background: #fef3c7; color: #b45309; }
.gc-task-card__status--done     { background: #d1fae5; color: #047857; }
.gc-task-card__status--blocked  { background: #fee2e2; color: #b91c1c; }
.gc-task-card__priority { font-size: 11px; color: var(--gc-text-secondary, #6b7280); }
.gc-task-card__title { font-weight: 600; font-size: 14px; line-height: 1.35; color: var(--gc-text-primary); }
.gc-task-card__meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--gc-text-secondary, #6b7280);
}
.gc-task-card__deleted { font-style: italic; color: var(--gc-text-secondary, #6b7280); font-size: 12px; }
.gc-task-card__cta {
  align-self: flex-start;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--gc-border, #e5e7eb);
  background: transparent;
  cursor: pointer;
  color: var(--gc-text-primary);
}
.gc-task-card__cta:hover { background: var(--gc-surface-hover, #f3f4f6); }

/* ── Org affiliation badge (Phase 10) ─────────────────────────────────────── */
.gc-org-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  vertical-align: middle;
  white-space: nowrap;
}
.gc-org-badge--md { font-size: 12px; padding: 2px 10px; }
.gc-org-badge--default {
  background: var(--gc-org-default-bg, #e0e7ff);
  color: var(--gc-org-default-fg, #3730a3);
}

/* ── Cross-org roster panel (Phase 11) ────────────────────────────────────── */
.gc-roster { padding: 12px 16px; display:flex; flex-direction:column; gap:16px; }
.gc-roster__heading { display:flex; align-items:center; gap:6px; font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:0.04em; color: var(--gc-muted, #6b7280); margin: 0 0 8px 0; }
.gc-roster__count { font-weight:500; color: var(--gc-muted, #6b7280); }
.gc-roster__list { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:6px; }
.gc-roster__row { display:flex; align-items:center; gap:8px; font-size:13px; }
.gc-roster__avatar { width:24px; height:24px; border-radius:50%; object-fit:cover; }
.gc-roster__name { flex:1 1; }
.gc-roster__admin-chip { font-size:10px; padding:1px 6px; border-radius:9999px; background: var(--gc-admin-chip-bg, #fef3c7); color: var(--gc-admin-chip-fg, #92400e); font-weight:500; }

/* External chat: start a 1:1 with a partner-org member from the roster. */
.gc-roster__message-btn {
  margin-left: auto;
  flex: none;
  font-size: 10.5px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 9999px;
  border: 1px solid var(--gc-border-strong);
  background: var(--gc-surface-0);
  color: var(--gc-text-secondary);
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
}
.gc-roster__message-btn:hover:not(:disabled) {
  background: var(--gc-primary-container);
  color: var(--gc-text-primary);
}
.gc-roster__message-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.gc-msg-selected { background: var(--gc-primary-container); }
.gc-msg-row {
  contain: layout paint;
}
.gc-msg-select-check {
  background: var(--gc-surface-0);
  border-color: var(--gc-border-strong);
}
.gc-msg-select-check.is-on {
  background: var(--gc-primary);
  border-color: var(--gc-primary);
  box-shadow: var(--gc-elev-2);
  transform: scale(1.1);
}
.gc-msg-sender-name {
  font-family: var(--gc-font-display);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gc-text-primary);
}
.gc-msg-sender-subtitle { color: var(--gc-text-tertiary); }
.gc-msg-sender-btn { --tw-ring-color: var(--gc-primary); }
.gc-msg-forwarded {
  font-size: 11px;
  font-style: italic;
  color: var(--gc-text-tertiary);
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.gc-msg-forwarded.is-mine { color: rgba(247, 250, 246, 0.7); }
.gc-msg-edited { color: var(--gc-text-tertiary); }
.gc-msg-edited.is-mine { color: rgba(247, 250, 246, 0.65); }
.gc-msg-content-mine { color: #f4faf6; }
.gc-msg-content-theirs { color: var(--gc-text-primary); }

/* Inline markdown emphasis inside chat bubbles.
   Browser default <strong> = "bolder" which renders muddy on Electron when
   there's no explicit weight set. Force the real 700 weight (Inter ships
   700) and inherit the bubble's text color so bold-on-mine stays bright
   off-white instead of falling back to the UA's default dark grey. */
.gc-msg-content-mine strong,
.gc-msg-content-mine b,
.gc-msg-content-theirs strong,
.gc-msg-content-theirs b {
  font-weight: 700;
  color: inherit;
}
/* Chat emphasis stays in the normal chat typeface. The project-wide
   \`.gt-themed em\` rule (Fraunces serif italic, !important) is an editorial
   accent meant for headings/labels — in a normal chat bubble it turns any
   \`*italic*\` (or rich-text italic) into a jarring serif run. Override the
   font-family here so bubble italics read as plain slanted Inter, not an
   editorial flourish. Equal specificity to \`.gt-themed em\` but later in the
   cascade, so the !important wins. */
.gc-msg-content-mine em,
.gc-msg-content-mine i,
.gc-msg-content-theirs em,
.gc-msg-content-theirs i,
.chat-rich-render em,
.chat-rich-render i,
.chat-rich-render .ProseMirror em,
.chat-rich-render .ProseMirror i {
  font-family: var(--gc-font) !important;
  font-feature-settings: normal;
  font-style: italic;
  color: inherit;
}
.gc-msg-content-mine code,
.gc-msg-content-theirs code {
  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.88em;
  padding: 1px 5px;
  border-radius: 4px;
}
.gc-msg-content-mine code {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}
.gc-msg-content-theirs code {
  background: rgba(15, 29, 20, 0.06);
  color: var(--gc-text-primary);
}
.gc-msg-content-mine a.gc-msg-link,
.gc-msg-content-theirs a.gc-msg-link {
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
  overflow-wrap: anywhere;
}
.gc-msg-content-mine a.gc-msg-link,
.gc-msg-content-mine a.gc-msg-link * {
  color: #ffffff !important;
  text-decoration: underline !important;
  text-decoration-color: #ffffff !important;
  opacity: 1 !important;
}
.gc-msg-content-mine a.gc-msg-link:hover,
.gc-msg-content-mine a.gc-msg-link:hover * {
  opacity: 0.85 !important;
}
.gc-msg-content-theirs a.gc-msg-link {
  color: var(--gc-text-link);
  text-decoration-color: color-mix(in srgb, var(--gc-text-link) 60%, transparent);
}
.gc-msg-content-theirs a.gc-msg-link:hover {
  text-decoration-color: var(--gc-text-link);
  filter: brightness(0.9);
}

/* ── Long-message "Read more" clamp ─────────────────────────────
   Collapses tall message bodies to ~300px with a soft fade-out and a
   Read more / Show less toggle. Clamps by rendered height so it works
   for both plain and rich (ProseMirror) bodies. */
.gc-collapsible { position: relative; }
.gc-collapsible__body { overflow: hidden; }
.gc-collapsible__body.is-faded {
  mask-image: linear-gradient(180deg, #000 calc(100% - 42px), transparent);
}
.gc-collapsible__toggle {
  display: inline-block;
  margin-top: 5px;
  padding: 1px 0;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gc-accent-strong);
  background: none;
  border: 0;
  cursor: pointer;
  transition: opacity 140ms ease;
}
.gc-collapsible__toggle:hover { text-decoration: underline; }
.gc-collapsible__toggle:active { opacity: 0.7; }
.gc-bubble-mine .gc-collapsible__toggle { color: #a7f3d0; }
.gc-msg-thread-chip {
  color: var(--gc-accent-strong);
  background: var(--gc-accent-soft);
  border: 1px solid rgba(16, 185, 129, 0.25);
}
.gc-reaction-pill {
  background: var(--gc-surface-0);
  border: 1px solid var(--gc-border);
  --tw-ring-color: var(--gc-primary);
}
.gc-reaction-pill:hover {
  border-color: var(--gc-primary);
  background: var(--gc-primary-container);
}
.gc-msg-time {
  color: var(--gc-text-tertiary);
  font-family: var(--gc-font-mono);
  letter-spacing: 0.02em;
}
.gc-msg-seen-icon { color: var(--gc-accent-strong); }
.gc-msg-action-bar {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--gc-border);
  box-shadow: 0 6px 18px rgba(15, 29, 20, 0.09), 0 1px 3px rgba(15, 29, 20, 0.05);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
}
/* Unified action-bar buttons (reply / quick-emoji / picker / more).
   Replaces the old per-button hover:bg-gray-100 with a sage-tinted
   hover so the whole toolbar reads as one Forest-Sage control.
   NOTE: .gc-msg-action-bar is an always-light frosted surface in
   every theme (like the emoji-pop / menu popovers), so these colours
   are fixed for a light background rather than theme tokens — token
   text would flip light in dark mode and vanish on the white bar. */
.gc-msg-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #4a5852;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, transform 150ms ease;
}
.gc-msg-action-btn:hover {
  background: rgba(4, 120, 87, 0.10);
  color: #047857;
  transform: translateY(-1px);
}
.gc-msg-action-btn:active { transform: translateY(0) scale(0.92); }
.gc-msg-action-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #047857;
}
/* Quick-emoji buttons render a glyph, not an icon — bump the type size */
.gc-msg-action-btn--emoji { font-size: 17px; line-height: 1; }
/* Reply is the primary action — always tinted, with a stronger hover */
.gc-msg-action-btn--reply { color: #047857; }
.gc-msg-action-btn--reply:hover { background: rgba(4, 120, 87, 0.16); }
/* Hairline separators that split the bar into reply | react | utilities */
.gc-msg-action-sep {
  align-self: stretch;
  width: 1px;
  margin: 4px 2px;
  background: rgba(15, 29, 20, 0.10);
}
.gc-msg-portal-scrim {
  position: fixed;
  inset: 0;
  z-index: 1000;
}
.gc-msg-emoji-pop {
  z-index: 1001;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--gc-border);
  border-radius: 14px;
  padding: 8px 10px;
  display: flex;
  gap: 6px;
  white-space: nowrap;
  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}
.gc-msg-emoji-pop-btn {
  font-size: 20px;
  padding: 2px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 160ms ease;
}
.gc-msg-emoji-pop-btn:hover { transform: scale(1.15); }
.gc-msg-action-menu {
  z-index: 1001;
  width: 224px;
  max-width: calc(100vw - 20px);
  max-height: min(70vh, 420px);
  overflow-y: auto;
  margin-top: 8px;
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(15, 29, 20, 0.08);
  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}
.gc-msg-menu-section {
  color: var(--gc-text-disabled);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px 2px;
}
.gc-msg-menu-section.has-divider {
  border-top: 1px solid var(--gc-divider);
  padding-top: 5px;
  margin-top: 2px;
}
.gc-msg-menu-section__leaf {
  width: 5px;
  height: 5px;
}
.gc-msg-menu-section__leaf.is-danger { background: var(--gc-dnd); }
.gc-msg-menu-section__eyebrow { font-size: 9px; }
.gc-msg-menu-item { color: var(--gc-text-primary); }
.gc-msg-menu-item.is-delete { color: var(--gc-dnd); }
.gc-msg-menu-item-icon { color: var(--gc-text-secondary); }

/* ──────────────────────────────────────────────────────────────────────────
   TaskCreate
   ────────────────────────────────────────────────────────────────────────── */
.gc-task-backdrop {
  background: rgba(15, 29, 20, 0.32);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 100;
}
.gc-task-modal-wrap { z-index: 101; }

/* ──────────────────────────────────────────────────────────────────────────
   TaskCreate modal — responsive sizing
   Desktop: centred card, max-height 90dvh, scrolls internally.
   Mobile : full-screen sheet. Header + body + footer become a flex column
            so the body grows/shrinks to fit and the action footer (Next /
            Submit) is always anchored at the bottom, in view. Respects the
            device safe-area at the bottom.
   ────────────────────────────────────────────────────────────────────────── */
.gc-task-create-wrap {
  height: 100vh;
  height: 100dvh;
}
.gc-task-create-tray { min-height: 100dvh; }
.gc-task-create-card {
  max-height: 90vh;
  max-height: 90dvh;
}
.gc-task-create-body {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

@media (max-width: 767px) {
  /* Mobile-only: card is a centered popup, NOT a full-screen sheet.
     The inline style (maxHeight: 92dvh) takes precedence so the modal
     fits the content with a small margin around it, rather than
     filling the entire viewport. Border radius preserved for the
     proper "modal popup" look. */
  .gc-task-create-card {
    max-height: 92dvh;
  }
  /* Footer respects the device safe-area on phones (e.g. iPhone home
     indicator) so the Back / Next / Create buttons clear the OS bar. */
  .gc-task-create-footer {
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  }
  /* Mobile-only: hide the "FORM COMPLETION xx%" progress block. Tailwind
     \`hidden md:block\` was inconsistent across builds, so we belt-and-brace
     with a dedicated class + !important to guarantee it doesn't show on
     phones. The header is already tall (title + tabs); the progress bar
     was eating space and pushing the action footer below the viewport. */
  .gc-task-create-progress {
    display: none !important;
  }
  /* Mobile-only: tighten header padding so the title block is compact and
     leaves more room for form fields above the action footer. */
  .gc-task-create-header-mobile {
    padding: 14px 16px !important;
  }
  .gc-task-create-h2-mobile {
    font-size: 18px !important;
  }
  /* Mobile-only: tabs become a single-row horizontal scroller so all four
     (Basic / Details / Approval Chain / Checklist) are reachable without
     wrapping into a second line. */
  .gc-task-create-tabs {
    padding: 6px 12px 0 12px !important;
  }
  .gc-task-create-tabs nav {
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scrollbar-width: none;
  }
  .gc-task-create-tabs nav::-webkit-scrollbar { display: none; }
  .gc-task-create-tabs nav > button {
    flex-shrink: 0 !important;
    padding: 8px 14px !important;
    font-size: 12.5px !important;
    white-space: nowrap;
  }
  /* Mobile-only: form body padding tightened. */
  .gc-task-create-body {
    padding: 16px !important;
  }
  /* Mobile-only: stack footer button rows tightly. */
  .gc-task-create-footer {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.gc-task-header {
  background: linear-gradient(135deg, var(--gt-primary-container) 0%, var(--gt-surface-1) 100%);
  border-bottom: 1px solid var(--gt-divider);
}
.gc-task-leaf-md { width: 10px; height: 10px; }
.gc-task-h2 {
  font-size: 22px;
  color: var(--gt-text-primary);
}
.gc-task-h2-em { color: var(--gt-accent-strong); }
.gc-task-page-sub-pad { margin-top: 4px; }
.gc-task-progress-row { font-size: 11px; }
.gc-task-progress-label { margin-bottom: 0; }
.gc-task-progress-pct { color: var(--gt-accent-strong); }
.gc-task-progress-fill-w { width: var(--task-progress, 0%); }
.gc-task-step-border { border-bottom: 1px solid var(--gt-border); }
.gc-task-step-btn {
  padding: 10px 18px;
  font-family: var(--gt-font-display);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
}
.gc-task-step-btn.is-active {
  border-bottom-color: var(--gt-primary);
  background: var(--gt-surface-0);
}

/* ───────────────────────────────────────────────────────────────────
   Mobile polish for the Create-New-Task sheet.

   - .gc-task-input adds a brand-tinted focus ring (replacing the
     hard blue ring) so the inputs match the rest of the green app.
   - .gc-task-cta-mobile turns the primary "Next / Create" button
     into a full-width brand-green pill on phones.
   - .gc-task-step-btn pills get a stronger active state on phones
     (filled chip vs. the desktop bottom-border).
   ─────────────────────────────────────────────────────────────── */
.gc-task-input:focus {
  outline: none;
  border-color: var(--gt-primary) !important;
  box-shadow: 0 0 0 3px color-mix(in oklab, var(--gt-primary) 18%, transparent) !important;
}
.gc-task-cta-mobile {
  background: linear-gradient(135deg, var(--gt-primary) 0%, var(--gt-primary-deep) 100%);
  color: #ffffff;
  border: none;
}
.gc-task-cta-mobile:hover {
  background: linear-gradient(135deg, var(--gt-primary-hover) 0%, var(--gt-primary-deep) 100%);
}
.gc-task-cta-mobile:active {
  transform: translateY(1px);
}
@media (max-width: 767px) {
  /* Make the tab strip feel like proper iOS-style segmented chips on
     phones: active tab is a filled brand-tinted pill instead of just
     a bottom border. */
  .gc-task-step-btn.is-active {
    background: var(--gt-primary-container) !important;
    color: var(--gt-primary-deep) !important;
    border-bottom-color: transparent !important;
    border-radius: 999px !important;
    box-shadow: 0 1px 2px rgba(15, 45, 31, 0.08);
  }
  .gc-task-step-border {
    border-bottom-color: transparent !important;
    padding-bottom: 6px;
  }
}
.gc-task-dropdown { z-index: 200; }
.gc-task-z-120 { z-index: 120; }
.gc-task-badge-blue {
  background: linear-gradient(135deg, #60a5fa 0%, #2563eb 100%);
  box-shadow: 0 4px 10px -2px rgba(37, 99, 235, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.35);
}
.gc-task-btn-blue {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 6px 14px -4px rgba(37, 99, 235, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.30);
}
.gc-task-btn-add-first {
  border-color: #93c5fd;
  color: #2563eb;
  background: #eff6ff;
}
.gc-task-blue-circle {
  background: #dbeafe;
  color: #1d4ed8;
}
.gc-task-badge-orange {
  background: linear-gradient(135deg, #fb923c 0%, #ea580c 100%);
  box-shadow: 0 4px 10px -2px rgba(234, 88, 12, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.35);
}
.gc-task-btn-orange {
  background: linear-gradient(135deg, #fb923c 0%, #ea580c 100%);
  box-shadow: 0 6px 14px -4px rgba(234, 88, 12, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.30);
}
.gc-task-flow-prep {
  background: #dbeafe;
  border: 2px solid #2563eb;
}
.gc-task-flow-prep-text { color: #1d4ed8; }
.gc-task-flow-line { background: #cbd5e1; }
.gc-task-flow-approver {
  background: #fed7aa;
  border: 2px solid #ea580c;
}
.gc-task-flow-approver-text { color: #c2410c; }
.gc-task-flow-done {
  background: #bbf7d0;
  border: 2px solid #10b981;
}
.gc-task-flow-done-text { color: #047857; }
.gc-task-orange-circle {
  background: #fed7aa;
  color: #c2410c;
}

/* ──────────────────────────────────────────────────────────────────────────
   Chat.tsx — top-level page shell
   ────────────────────────────────────────────────────────────────────────── */
.gc-section-label {
  color: var(--gc-text-tertiary);
}
.gc-chat-shell {
  font-family: var(--gc-font);
  color: var(--gc-text-primary);
}
.gc-chat-sidebar {
  background: var(--gc-surface-0);
  border-right: 1px solid var(--gc-border);
}
.gc-chat-sidebar__header {
  background: var(--gc-surface-0);
  border-bottom: 1px solid var(--gc-divider);
}
.gc-chat-sidebar__eyebrow { color: var(--gc-text-tertiary); }
.gc-chat-sidebar__title {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 26px;
  color: var(--gc-text-primary);
  letter-spacing: -0.03em;
}
.gc-chat-sidebar__title-em {
  font-weight: 500;
  color: var(--gc-primary);
  font-size: 28px;
}
.gc-chat-logout-btn {
  background: transparent;
  color: var(--gc-text-secondary);
  border: 1px solid var(--gc-border);
}
.gc-chat-sidebar-more-btn {
  background: transparent;
  border: 1px solid var(--gc-border);
}
.gc-chat-new-btn {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  box-shadow: var(--gc-elev-2);
}
.gc-chat-status-end-btn {
  height: 28px;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid rgba(245, 158, 11, 0.42);
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
  font-size: 10.5px;
  font-weight: 800;
  white-space: nowrap;
  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease, opacity 0.16s ease;
}
.gc-chat-status-end-btn:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.58);
  transform: translateY(-1px);
}
.gc-chat-status-end-btn.is-dnd {
  border-color: rgba(220, 38, 38, 0.42);
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
}
.gc-chat-status-end-btn.is-dnd:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.18);
  border-color: rgba(220, 38, 38, 0.6);
}
.gc-chat-status-end-btn:disabled {
  opacity: 0.62;
  cursor: wait;
  transform: none;
}
.gc-chat-search-icon { color: var(--gc-text-tertiary); }
.gc-chat-main {
  background: var(--gc-surface-1);
}
.gc-chat-header {
  background: var(--gc-surface-0);
  border-bottom: 1px solid var(--gc-divider);
  box-shadow: var(--gc-elev-1);
  min-height: 52px;
}
.gc-chat-header__group-icon {
  background: linear-gradient(135deg, var(--gc-primary) 0%, var(--gc-primary-soft) 100%);
  color: var(--gc-on-primary);
}
.gc-chat-header__name {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.015em;
  color: var(--gc-text-primary);
}
.gc-chat-header__sub {
  color: var(--gc-text-tertiary);
  font-size: 10px;
}
.gc-chat-e2ee-chip {
  color: var(--gc-accent-strong);
  background: var(--gc-accent-soft);
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.gc-chat-onleave-chip-sm {
  font-size: 9px;
  padding: 2px 6px;
}
.gc-away-control {
  position: relative;
  z-index: 35;
}
.gc-away-control.is-menu-item {
  width: 100%;
}
.gc-away-control__triggers {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
  z-index: 45;
}
.gc-away-control.is-menu-item .gc-away-control__triggers {
  display: block;
  width: 100%;
}
.gc-away-control__trigger {
  height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0 9px;
  border-radius: 999px;
  border: 1px solid rgba(245, 158, 11, 0.32);
  background: rgba(245, 158, 11, 0.1);
  color: #b45309;
  font-size: 11px;
  font-weight: 700;
  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}
.gc-away-control__trigger:hover {
  background: rgba(245, 158, 11, 0.16);
  border-color: rgba(245, 158, 11, 0.48);
  transform: translateY(-1px);
}
.gc-away-control__trigger.is-menu-item {
  width: 100%;
  height: auto;
  min-height: 42px;
  justify-content: flex-start;
  gap: 10px;
  padding: 11px 14px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: var(--gc-text-primary, #111827);
  font-size: 13.5px;
  font-weight: 500;
  text-align: left;
  transform: none;
}
.gc-away-control__trigger.is-menu-item:hover {
  background: var(--gc-surface-2, #f3f4f6);
  border-color: transparent;
  transform: none;
}
.gc-away-control__trigger.is-disabled,
.gc-away-control__trigger:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}
.gc-away-control__trigger.is-disabled:hover,
.gc-away-control__trigger:disabled:hover {
  background: transparent;
  border-color: transparent;
  transform: none;
}
.gc-away-control__trigger.is-menu-item.is-away svg {
  color: #d97706;
}
.gc-away-control__trigger.is-dnd {
  border-color: rgba(220, 38, 38, 0.34);
  background: rgba(220, 38, 38, 0.1);
  color: #b91c1c;
}
.gc-away-control__trigger.is-menu-item.is-dnd {
  border-color: transparent;
  background: transparent;
  color: var(--gc-text-primary, #111827);
}
.gc-away-control__trigger.is-menu-item.is-dnd svg {
  color: #dc2626;
}
.gc-away-control__trigger.is-dnd:hover {
  background: rgba(220, 38, 38, 0.16);
  border-color: rgba(220, 38, 38, 0.5);
}
.gc-away-control__trigger.is-menu-item.is-dnd:hover {
  background: var(--gc-surface-2, #f3f4f6);
  border-color: transparent;
}
.gc-away-control__trigger.is-active {
  background: #f59e0b;
  border-color: #fbbf24;
  color: #111827;
}
.gc-away-control__trigger.is-menu-item.is-active {
  background: var(--gc-surface-2, #f3f4f6);
  color: var(--gc-text-primary, #111827);
}
.gc-away-control__trigger.is-dnd.is-active {
  background: #dc2626;
  border-color: #f87171;
  color: #ffffff;
}
.gc-away-control__trigger.is-menu-item.is-dnd.is-active {
  background: var(--gc-surface-2, #f3f4f6);
  border-color: transparent;
  color: var(--gc-text-primary, #111827);
}
.gc-away-popover {
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 40;
  width: min(280px, calc(100vw - 24px));
  padding: 12px;
  border: 1px solid var(--gc-border);
  border-radius: 12px;
  background: var(--gc-surface-0);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  transform-origin: top right;
  animation: gc-away-popover-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.gc-away-control.is-menu-item .gc-away-popover {
  top: calc(100% + 8px);
  right: 0;
}
.gc-away-popover__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: var(--gc-text);
  font-size: 12px;
  font-weight: 800;
}
.gc-away-popover__header button {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: var(--gc-text-tertiary);
}
.gc-away-popover__header button:hover {
  background: var(--gc-surface-2);
  color: var(--gc-text);
}
.gc-away-field {
  display: grid;
  gap: 5px;
  margin-top: 8px;
  color: var(--gc-text-tertiary);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.gc-away-field input,
.gc-away-field textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--gc-border);
  background: var(--gc-surface-1);
  color: var(--gc-text);
  font-size: 12px;
  font-weight: 600;
}
.gc-away-field input {
  height: 34px;
  padding: 0 9px;
}
.gc-away-field textarea {
  min-height: 68px;
  padding: 8px 9px;
  resize: vertical;
  line-height: 1.35;
}
.gc-away-quick {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 10px;
}
.gc-away-quick button {
  height: 28px;
  border-radius: 999px;
  border: 1px solid rgba(245, 158, 11, 0.28);
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
  font-size: 10.5px;
  font-weight: 800;
  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}
.gc-away-quick button:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.44);
  transform: translateY(-1px);
}
.gc-away-quick button:disabled {
  opacity: 0.55;
  cursor: default;
}
.gc-away-error {
  margin-top: 9px;
  color: #dc2626;
  font-size: 11px;
  font-weight: 600;
}
.gc-away-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  margin-top: 12px;
}
.gc-away-actions button {
  height: 30px;
  border-radius: 999px;
  padding: 0 11px;
  font-size: 11px;
  font-weight: 800;
}
.gc-away-actions__end {
  color: #b45309;
  background: rgba(245, 158, 11, 0.12);
}
.gc-away-actions__save {
  color: #ffffff;
  background: #059669;
}
.gc-chat-meet-btn {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  border: 1px solid var(--gc-border-strong);
  font-family: var(--gc-font-display);
}
.gc-chat-header-menu {
  font-family: var(--gc-font);
}
.gc-chat-header-menu__emoji { font-size: 16px; }
.gc-chat-header-menu__ttl {
  color: #9aa0a6;
}
.gc-chat-header-menu__ttl.is-on { color: var(--gc-primary); }
.gc-chat-bulk-banner {
  background: var(--gc-primary-container);
  color: var(--gc-primary);
  border-bottom: 1px solid var(--gc-border);
}
.gc-chat-bulk-cancel { color: var(--gc-primary); }
.gc-chat-stream {
  background:
    radial-gradient(circle at 0% 0%, rgba(220, 239, 225, 0.35) 0%, transparent 32%),
    radial-gradient(circle at 100% 100%, rgba(236, 246, 238, 0.45) 0%, transparent 36%),
    var(--gc-surface-1);
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
  contain: layout paint;
}
.gc-chat-poll-fallback {
  background: var(--gc-surface-1);
  border: 1px dashed var(--gc-border);
  border-radius: var(--gc-radius-card);
  padding: 10px 12px;
  max-width: 380px;
  font-size: 12px;
  color: var(--gc-text-secondary);
}
.gc-chat-poll-fallback__title {
  font-weight: 600;
  color: var(--gc-text-secondary);
  margin-bottom: 4px;
}
.gc-chat-composer {
  background: var(--gc-surface-0);
  border-top: 1px solid var(--gc-divider);
}

/* ──────────────────────────────────────────────────────────────────────────
   Upload progress card — slides above the composer while an attachment is
   uploading. Indeterminate shimmer while the percentage advances, then a
   brief success state before the card slides out.
   ────────────────────────────────────────────────────────────────────────── */
.gc-upload-card-wrap {
  background: var(--gc-surface-0);
  animation: gc-upload-card-in 220ms cubic-bezier(0.22, 1, 0.36, 1);
}
.gc-upload-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--gc-surface-2);
  border: 1px solid var(--gc-border);
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);
  transition: background 220ms ease, border-color 220ms ease;
}
.gc-upload-card.is-done {
  background: rgba(16, 185, 129, 0.10);
  border-color: rgba(16, 185, 129, 0.30);
}
.gc-upload-card__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: var(--gc-accent-soft, rgba(16, 185, 129, 0.14));
  color: var(--gc-accent-strong, #059669);
  transition: background 220ms ease, color 220ms ease;
}
.gc-upload-card.is-done .gc-upload-card__icon {
  background: rgba(16, 185, 129, 0.20);
  color: #047857;
}
.gc-upload-card__body { min-width: 0; flex: 1 1; }
.gc-upload-card__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 5px;
}
.gc-upload-card__name {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gc-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.gc-upload-card__batch {
  color: var(--gc-text-tertiary);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  margin-right: 2px;
}
.gc-upload-card__pct {
  font-size: 11px;
  font-weight: 600;
  color: var(--gc-text-secondary);
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}
.gc-upload-card__bar {
  height: 4px;
  border-radius: 9999px;
  background: rgba(15, 29, 20, 0.08);
  overflow: hidden;
  position: relative;
}
.gc-upload-card__bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #34d399 0%, #10b981 50%, #059669 100%);
  border-radius: 9999px;
  transition: width 200ms ease-out;
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.15);
  position: relative;
}
.gc-upload-card__bar-fill::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%);
  animation: gc-upload-shimmer 1.4s linear infinite;
}
.gc-upload-card.is-done .gc-upload-card__bar-fill::after {
  display: none;
}
.gc-upload-card__meta {
  margin-top: 4px;
  font-size: 10.5px;
  color: var(--gc-text-tertiary);
  font-variant-numeric: tabular-nums;
}
@keyframes gc-upload-card-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes gc-upload-shimmer {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* ──────────────────────────────────────────────────────────────────────────
   Document preview modal — fullscreen lightbox-style overlay that hosts a
   Google Docs Viewer iframe so PDFs, XLS, DOC, PPT all preview the same way
   without needing bucket CORS (Google's server fetches the file).
   ────────────────────────────────────────────────────────────────────────── */
.gc-doc-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(15, 29, 20, 0.78);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: grid;
  place-items: center;
  padding: 24px;
  animation: gc-doc-modal-in 180ms cubic-bezier(0.22, 1, 0.36, 1);
}
.gc-doc-modal {
  width: min(1100px, 96vw);
  height: min(820px, 92vh);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 29, 20, 0.45);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.gc-doc-modal__bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f8faf9;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.gc-doc-modal__title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  min-width: 0;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-doc-modal__actions { display: flex; align-items: center; gap: 6px; }
.gc-doc-modal__btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: transparent;
  color: #374151;
  border: 1px solid transparent;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
  cursor: pointer;
}
.gc-doc-modal__btn:hover {
  background: rgba(15, 29, 20, 0.06);
  border-color: rgba(15, 29, 20, 0.10);
  color: #111827;
}
.gc-doc-modal__body {
  flex: 1 1;
  min-height: 0;
  background: #f3f4f6;
  position: relative;
}
.gc-doc-modal__iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: #ffffff;
}
.gc-doc-modal__loader {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #6b7280;
  font-size: 12.5px;
  pointer-events: none;
}
.gc-doc-modal__empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  text-align: center;
  padding: 24px;
  color: #4b5563;
  font-size: 13px;
}
.gc-doc-modal__primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #059669;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: background 160ms ease, transform 160ms ease;
}
.gc-doc-modal__primary:hover {
  background: #047857;
  transform: translateY(-1px);
}
@keyframes gc-doc-modal-in {
  from { opacity: 0; transform: scale(0.98); }
  to   { opacity: 1; transform: scale(1); }
}

/* Hover overlay on the document card preview area — shows a "Click to preview"
   prompt with an expand icon over the thumbnail/icon tile. */
.gc-att-doc__hover {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(180deg, rgba(15, 29, 20, 0.36) 0%, rgba(15, 29, 20, 0.62) 100%);
  color: #ffffff;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  opacity: 0;
  transition: opacity 180ms ease;
  pointer-events: none;
  z-index: 1;
}
.gc-att-doc:hover .gc-att-doc__hover,
.gc-att-doc:focus-visible .gc-att-doc__hover {
  opacity: 1;
}
.gc-att-doc__hover svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.30));
}

/* ──────────────────────────────────────────────────────────────────────────
   Composer action sheet — mobile-only WhatsApp-style grid that opens above
   the input row when the user taps the "+" trigger. Hosts the four actions
   (Attach / Voice / Poll / Task) as large icon tiles.
   ────────────────────────────────────────────────────────────────────────── */
.gc-composer-sheet__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.18);
  z-index: 30;
  animation: gc-composer-sheet-fade 180ms ease both;
}
.gc-composer-sheet {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: calc(100% + 6px);
  background: var(--gc-surface-0, #ffffff);
  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));
  border-radius: 16px;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.05);
  z-index: 31;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  padding: 14px 12px;
  font-family: var(--gc-font);
  animation: gc-composer-sheet-rise 200ms cubic-bezier(0.33, 1, 0.68, 1) both;
}
.gc-composer-sheet__tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 4px;
  background: transparent;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-family: inherit;
  transition: background var(--gc-transition-fast, 160ms ease);
}
.gc-composer-sheet__tile:hover:not(:disabled),
.gc-composer-sheet__tile:active:not(:disabled) {
  background: var(--gc-surface-2, #f3f4f6);
}
.gc-composer-sheet__tile:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gc-composer-sheet__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gc-composer-sheet__icon.is-attach {
  background: #dbeafe;
  color: #2563eb;
}
.gc-composer-sheet__icon.is-voice {
  background: #fee2e2;
  color: #dc2626;
}
.gc-composer-sheet__icon.is-poll {
  background: #dcefe1;
  color: #047857;
}
.gc-composer-sheet__icon.is-task {
  background: #fef3c7;
  color: #b45309;
}
.gc-composer-sheet__label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--gc-text-secondary, #4b5563);
  letter-spacing: 0.01em;
}

@keyframes gc-composer-sheet-rise {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes gc-composer-sheet-fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.gc-chat-textarea {
  color: var(--gc-text-primary);
  min-height: 34px;
  max-height: 100px;
}
.gc-chat-send-btn {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  box-shadow: var(--gc-elev-2);
}
.gc-chat-add-members,
.gc-chat-role-chip {
  color: var(--gc-accent-strong);
  background: var(--gc-accent-soft);
  border: 1px solid rgba(16, 185, 129, 0.25);
}
.gc-chat-profile-header {
  background: var(--gc-primary-container);
  border-bottom: 1px solid var(--gc-border);
}
.gc-profile-modal-backdrop {
  background: rgba(3, 7, 12, 0.58);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: gc-profile-backdrop-in 220ms ease-out both;
}
.gc-profile-modal-shell {
  --gc-profile-genie-dx: 0px;
  --gc-profile-genie-dy: -18px;
  --gc-profile-genie-scale-x: 0.2;
  --gc-profile-genie-scale-y: 0.08;
  position: fixed;
  inset: 0;
  margin: auto;
  width: min(520px, calc(100vw - 32px));
  height: fit-content;
  max-height: min(720px, calc(100dvh - 48px));
  overflow: hidden;
  border: 1px solid var(--gc-border);
  border-radius: 28px;
  box-shadow:
    0 38px 110px rgba(0, 0, 0, 0.42),
    0 12px 34px rgba(0, 0, 0, 0.22);
  transform: translate3d(0, 0, 0);
  transform-origin: center center;
  will-change: transform, opacity, filter, border-radius;
  animation: gc-profile-genie-in 440ms cubic-bezier(0.18, 0.98, 0.2, 1) both;
}
@keyframes gc-profile-backdrop-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes gc-profile-genie-in {
  0% {
    opacity: 0.86;
    transform:
      translate3d(var(--gc-profile-genie-dx), var(--gc-profile-genie-dy), 0)
      scaleX(var(--gc-profile-genie-scale-x))
      scaleY(var(--gc-profile-genie-scale-y))
      skewY(-8deg);
    border-radius: 999px;
    filter: blur(0.8px);
  }
  54% {
    opacity: 1;
    transform: translate3d(-16px, 7px, 0) scaleX(1.045) scaleY(0.99) skewY(1.6deg);
    border-radius: 34px;
    filter: blur(0);
  }
  80% {
    opacity: 1;
    transform: translate3d(4px, -2px, 0) scaleX(0.992) scaleY(1.006);
    border-radius: 26px;
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scaleX(1) scaleY(1);
    border-radius: 28px;
  }
}
@media (max-width: 520px) {
  .gc-profile-modal-shell {
    width: calc(100vw - 24px);
    max-height: calc(100dvh - 24px);
    border-radius: 22px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .gc-profile-modal-backdrop,
  .gc-profile-modal-shell {
    animation: none;
    will-change: auto;
  }
  .gc-profile-modal-shell {
    transform: translate3d(0, 0, 0);
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   Mobile-only top header — sits above the Messages sidebar on phone
   viewports. Shows "TeamLio Chat" + chat/task notification bells + a
   3-dot kebab menu with a Profile option. Hidden on desktop.
   ────────────────────────────────────────────────────────────────────────── */
.gc-mobile-top-header { display: none; }

@media (max-width: 767px) {
  .gc-mobile-top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 12px 0 16px;
    background: var(--gc-primary, #1f2e23);
    color: var(--gc-on-primary, #f7faf6);
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 30;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}

.gc-mobile-top-header__title {
  font-family: var(--gc-font-display);
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.01em;
  color: inherit;
}
.gc-mobile-top-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.gc-mobile-top-header__icon-btn {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 9999px;
  background: transparent;
  border: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background var(--gc-transition-fast, 160ms ease);
  padding: 0;
}
.gc-mobile-top-header__icon-btn:hover,
.gc-mobile-top-header__icon-btn.is-open {
  background: rgba(255, 255, 255, 0.12);
}
.gc-mobile-top-header__badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9999px;
  background: #dc2626;
  color: #ffffff;
  font-size: 9.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--gc-primary, #1f2e23);
}

.gc-mobile-top-header__menu-wrap { position: relative; }
.gc-mobile-top-header__menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 180px;
  background: var(--gc-surface-0, #ffffff);
  color: var(--gc-text-primary, #111827);
  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
  z-index: 60;
  overflow: hidden;
  font-family: var(--gc-font);
}
.gc-mobile-top-header__menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gc-text-primary, #111827);
  text-align: left;
  font-family: inherit;
  transition: background var(--gc-transition-fast, 160ms ease);
}
.gc-mobile-top-header__menu-item:hover {
  background: var(--gc-surface-2, #f3f4f6);
}
.gc-mobile-top-header__menu-item.is-danger { color: #dc2626; }
.gc-mobile-top-header__menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 55;
  background: transparent;
}

/* ──────────────────────────────────────────────────────────────────────────
   Mobile chat icon trio + kebab menu in the "Messages" sidebar header
   (replaces the desktop Logout + "+" buttons on phone-sized viewports).
   ────────────────────────────────────────────────────────────────────────── */
.gc-chat-mobile-icon-btn {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 9999px;
  background: transparent;
  border: none;
  color: var(--gc-text-secondary, #4b5563);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background var(--gc-transition-fast, 160ms ease);
}
.gc-chat-mobile-icon-btn:hover,
.gc-chat-mobile-icon-btn.is-open {
  background: var(--gc-surface-2, #f3f4f6);
  color: var(--gc-text-primary, #111827);
}
.gc-chat-mobile-icon-btn__badge {
  position: absolute;
  top: 3px;
  right: 3px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9999px;
  background: #dc2626;
  color: #ffffff;
  font-size: 9.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--gc-surface-0, #ffffff);
  pointer-events: none;
}
.gc-chat-mobile-icon-btn__wrap { position: relative; }
.gc-chat-mobile-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 180px;
  background: var(--gc-surface-0, #ffffff);
  color: var(--gc-text-primary, #111827);
  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
  z-index: 60;
  overflow: hidden;
  font-family: var(--gc-font);
  transform-origin: top right;
  animation: gc-menu-in 160ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.gc-chat-desktop-status-menu {
  min-width: 190px;
  overflow: visible;
}

@keyframes gc-menu-in {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes gc-away-popover-in {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .gc-chat-mobile-menu,
  .gc-away-popover {
    animation: none;
  }
}
.gc-chat-mobile-menu__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gc-text-primary, #111827);
  text-align: left;
  font-family: inherit;
  transition: background var(--gc-transition-fast, 160ms ease);
}
.gc-chat-mobile-menu__item:hover { background: var(--gc-surface-2, #f3f4f6); }
.gc-chat-mobile-menu__item.is-danger { color: #dc2626; }
.gc-chat-mobile-menu__backdrop {
  position: fixed;
  inset: 0;
  z-index: 55;
  background: transparent;
}

/* Notification popovers triggered by the mobile chat header bell / chat icons.
   On mobile the popover content panel takes a comfortable share of the screen
   width and caps its height so the inner list stays scrollable. */
.gc-chat-mobile-popover {
  /* Use min-width + width: max-content fallback so the popover never collapses
     to the natural width of its content (which is what was making the empty
     state text wrap per-character). */
  width: min(360px, calc(100vw - 24px)) !important;
  min-width: 280px;
  max-width: calc(100vw - 24px);
  max-height: min(70vh, 480px);
  background: var(--gc-surface-0, #ffffff);
  color: var(--gc-text-primary, #111827);
  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 60;
  font-family: var(--gc-font);
  box-sizing: border-box;
}
.gc-chat-mobile-popover__title {
  padding: 12px 14px;
  font-weight: 600;
  font-size: 14px;
  color: var(--gc-text-primary, #111827);
  border-bottom: 1px solid var(--gc-divider, rgba(0, 0, 0, 0.06));
  flex-shrink: 0;
}
.gc-chat-mobile-popover__body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

/* ──────────────────────────────────────────────────────────────────────────
   Mobile FAB — WhatsApp-style floating action button at bottom-right
   that opens the New Conversation modal. Sits above the bottom tab bar
   (which is 56px tall on mobile) and respects the device safe area.
   Hidden on desktop and when a conversation is open.
   ────────────────────────────────────────────────────────────────────────── */
.gc-chat-fab { display: none; }

@media (max-width: 767px) {
  .gc-chat-fab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 20px;
    /* sit above the 56px tab bar + device safe-area inset */
    bottom: calc(56px + 20px + env(safe-area-inset-bottom, 0px));
    width: 56px;
    height: 56px;
    border-radius: 18px;
    border: none;
    background: var(--gc-primary, #1f2e23);
    color: var(--gc-on-primary, #f7faf6);
    box-shadow: 0 8px 22px rgba(15, 29, 20, 0.35), 0 2px 6px rgba(15, 29, 20, 0.15);
    cursor: pointer;
    z-index: 45;
    transition: transform var(--gc-transition-fast, 160ms ease), box-shadow var(--gc-transition-fast, 160ms ease);
  }
  .gc-chat-fab:hover { transform: translateY(-1px); }
  .gc-chat-fab:active { transform: scale(0.96); }
  /* Hide the FAB when a conversation is open so it doesn't cover the composer */
  body[data-conv-open="true"] .gc-chat-fab { display: none; }
}

/* Presence filter chips — each variant carries its own colour so the user
   can scan online/away/offline at a glance without relying on a tiny dot. */
.gc-presence-filter-row {
  box-sizing: border-box;
  width: 100%;
  gap: 4px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: none;
}
.gc-presence-filter-row::-webkit-scrollbar {
  display: none;
}
.gc-presence-filter-chip {
  background: var(--gc-surface-0);
  color: var(--gc-text-secondary);
  border-color: var(--gc-border);
  font-family: var(--gc-font-display);
  font-size: 9.5px;
  line-height: 1;
  letter-spacing: 0;
  min-height: 24px;
  padding: 2px 6px;
  white-space: nowrap;
  flex: 0 0 auto;
}
.gc-presence-filter-chip:not(.gc-presence-filter-chip--icon-only) {
  flex: 1 1 auto;
  justify-content: center;
  min-width: max-content;
}
.gc-presence-filter-chip:hover {
  filter: brightness(0.98);
}
.gc-presence-filter-chip-pair {
  display: inline-flex;
  flex: 1.6 1 auto;
  align-items: center;
  gap: 4px;
  min-width: 0;
  white-space: nowrap;
}
.gc-presence-filter-chip--icon-only {
  position: relative;
  flex: 0 0 26px;
  width: 26px;
  min-width: 26px;
  height: 24px;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
/* Online — emerald */
.gc-presence-filter-chip.is-online {
  background: rgba(16, 185, 129, 0.10);
  color: rgb(4, 120, 87);
  border-color: rgba(16, 185, 129, 0.30);
}
.gc-presence-filter-chip.is-online.is-active {
  background: rgb(16, 185, 129);
  color: #fff;
  border-color: rgb(16, 185, 129);
}

/* Away — amber */
.gc-presence-filter-chip.is-away {
  background: rgba(245, 158, 11, 0.10);
  color: rgb(146, 64, 14);
  border-color: rgba(245, 158, 11, 0.30);
}
.gc-presence-filter-chip.is-away.is-active {
  background: rgb(245, 158, 11);
  color: #fff;
  border-color: rgb(245, 158, 11);
}

/* Offline — neutral slate */
.gc-presence-filter-chip.is-offline {
  background: rgba(100, 116, 139, 0.08);
  color: rgb(71, 85, 105);
  border-color: rgba(100, 116, 139, 0.25);
}
.gc-presence-filter-chip.is-offline.is-active {
  background: rgb(100, 116, 139);
  color: #fff;
  border-color: rgb(100, 116, 139);
}

/* Groups — violet */
.gc-presence-filter-chip.is-groups {
  background: rgba(139, 92, 246, 0.10);
  color: rgb(91, 33, 182);
  border-color: rgba(139, 92, 246, 0.30);
}
.gc-presence-filter-chip.is-groups.is-active {
  background: rgb(139, 92, 246);
  color: #fff;
  border-color: rgb(139, 92, 246);
}

/* Internal — slate. Deliberately quieter than External: it is the ordinary
   case, and the one worth spotting is a chat that leaves the company. */
.gc-presence-filter-chip.is-internal {
  background: rgba(100, 116, 139, 0.10);
  color: rgb(51, 65, 85);
  border-color: rgba(100, 116, 139, 0.30);
}
.gc-presence-filter-chip.is-internal.is-active {
  background: rgb(100, 116, 139);
  color: #fff;
  border-color: rgb(100, 116, 139);
}

/* External — amber, the same register as the cross-org badges elsewhere */
.gc-presence-filter-chip.is-external {
  background: rgba(217, 119, 6, 0.10);
  color: rgb(146, 64, 14);
  border-color: rgba(217, 119, 6, 0.30);
}
.gc-presence-filter-chip.is-external.is-active {
  background: rgb(217, 119, 6);
  color: #fff;
  border-color: rgb(217, 119, 6);
}

/* Archived — warm gray */
.gc-presence-filter-chip.is-archived {
  background: rgba(120, 113, 108, 0.08);
  color: rgb(87, 83, 78);
  border-color: rgba(120, 113, 108, 0.25);
}
.gc-presence-filter-chip.is-archived.is-active {
  background: rgb(87, 83, 78);
  color: #fff;
  border-color: rgb(87, 83, 78);
}

/* Default "All" active state — keeps the existing primary look */
.gc-presence-filter-chip.is-active {
  background: var(--gc-primary);
  color: var(--gc-on-primary);
  border-color: var(--gc-primary);
}

/* ──────────────────────────────────────────────────────────────────────────
   AppShell — mobile responsive layout
   Below 768px, hide the desktop sidebar and show the WhatsApp-style bottom
   tab bar. Above 768px the desktop sidebar shows and the bottom bar is hidden.
   ────────────────────────────────────────────────────────────────────────── */
.gt-app-shell {
  display: flex;
  gap: 4px;
  padding: 4px;
  height: 100vh;                /* fallback for older browsers */
  height: 100dvh;               /* dynamic viewport height — shrinks/grows with mobile chrome */
  width: 100vw;
  overflow: hidden;
  background: linear-gradient(135deg, #eef2ee 0%, #e6ebe6 100%);
}
.gt-app-main {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04), 0 6px 18px rgba(15, 29, 20, 0.05);
}

/* Let the app-shell's flex stretch size the rail. A percentage height uses the
   full viewport even after Electron adds title-bar padding, which pushes the
   rail's bottom edge past the shell and clips its lower margin/radius. */
.gt-app-shell > .gt-sidebar {
  min-height: 0;
  height: auto;
}

/* ──────────────────────────────────────────────────────────────────────────
   Desktop (Electron) custom title bar — replaces the native OS title bar.
   A slim draggable strip sits in the top gradient margin. macOS shows its
   native traffic lights positioned into this strip (see electron/main.js);
   Windows & Linux render the min/max/close buttons at the right. The
   .gt-app-shell gains matching top padding so the floating cards sit below it.
   Only active inside the desktop build (html.is-desktop-electron). */
:root {
  --gt-titlebar-h: 30px;
}

.gt-titlebar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--gt-titlebar-h);
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  z-index: 1000;
  -webkit-app-region: drag;
  app-region: drag;
  -webkit-user-select: none;
  user-select: none;
}

/* Keep macOS's native traffic-light cluster out of the drag region so the
   buttons stay clickable. */
html.os-mac .gt-titlebar {
  padding-left: 80px;
}

.gt-titlebar-controls {
  display: flex;
  align-items: stretch;
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

.gt-titlebar-btn {
  width: 46px;
  height: var(--gt-titlebar-h);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--gt-text-secondary, #4b5563);
  cursor: pointer;
  transition: background var(--gt-t-fast, 0.15s ease),
    color var(--gt-t-fast, 0.15s ease);
}
.gt-titlebar-btn:hover {
  background: var(--gt-surface-2, rgba(15, 29, 20, 0.08));
}
.gt-titlebar-btn--close:hover {
  background: #e81123;
  color: #ffffff;
}
.gt-titlebar-icon {
  width: 15px;
  height: 15px;
}

/* Reserve room for the strip on Windows/Linux (where it hosts the custom
   min/max/close buttons). macOS has no strip — the native traffic lights
   overlay the sidebar's top-left directly, WhatsApp-style, and the cleared
   region in .gt-sidebar-header below serves as the window drag area. */
html.is-desktop-electron.os-custom-controls .gt-app-shell {
  padding-top: calc(4px + var(--gt-titlebar-h));
}

/* macOS WhatsApp-style title bar: native traffic lights sit over the
   sidebar's top edge. Pad the sidebar header content down so the brand
   and collapse button clear the lights, and make the cleared region a
   window drag handle. The button itself opts out of dragging. */
html.os-mac .gt-sidebar .gt-sidebar-header {
  padding-top: 32px;
  min-height: 80px;
  -webkit-app-region: drag;
  app-region: drag;
}
html.os-mac .gt-sidebar-collapse {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

/* Bigger macOS window-drag target: the conversation-list header (the "TeamLio"
   bar at the top of the chat panel) is also draggable, so the window isn't only
   movable by the slim icon-rail header. Interactive children opt back out so
   their clicks/typing still work. */
html.os-mac .gc-chat-sidebar__header {
  -webkit-app-region: drag;
  app-region: drag;
}
html.os-mac .gc-chat-sidebar__header button,
html.os-mac .gc-chat-sidebar__header a,
html.os-mac .gc-chat-sidebar__header input,
html.os-mac .gc-chat-sidebar__header textarea,
html.os-mac .gc-chat-sidebar__header .gc-away-control,
html.os-mac .gc-chat-sidebar__header .gc-away-popover,
html.os-mac .gc-chat-sidebar__header [role="button"] {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

.gt-mobile-bottom-nav {
  display: none;
}

/* Mobile-only top header — blank white bar pinned at the top of the
   viewport. Height + padding-top respect env(safe-area-inset-top) so
   the page content sits below the device notch / status bar instead
   of being clipped. Hidden on desktop. */
.gt-mobile-top-header {
  display: none;
}

@media (max-width: 767px) {
  .gt-mobile-top-header {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: calc(48px + env(safe-area-inset-top, 0px));
    padding-top: env(safe-area-inset-top, 0px);
    background: var(--gt-surface-0, #ffffff);
    border-bottom: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
    z-index: 60;
  }
}

/* Even when a chat conversation is open on mobile, keep the safe-area
   top header visible so the device status bar / notch doesn't clip the
   conversation header. */

@media (max-width: 767px) {
  .gt-sidebar { display: none !important; }

  /* Drop the floating-card chrome on mobile — content needs the full
     viewport, and the device chrome already supplies framing. */
  .gt-app-shell {
    padding: 0;
    gap: 0;
    background: #ffffff;
  }
  .gt-app-main {
    border-radius: 0;
    box-shadow: none;
    /* Reserve room for the fixed mobile top header (48px) + safe-area-inset-top
       at the top, and the bottom tab bar (56px) + safe-area-inset-bottom at
       the bottom. Prevents content from being clipped by the device chrome
       (notch / status bar / OS nav gesture area). */
    padding-top: calc(48px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  }

  .gt-mobile-bottom-nav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 56px;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    background: var(--gt-surface-0, #ffffff);
    border-top: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.08));
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
    z-index: 50;
    align-items: stretch;
    justify-content: space-around;
    font-family: var(--gt-font);
  }
}

.gt-mobile-bottom-nav__tab {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--gt-text-tertiary, #6b7280);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 6px 4px;
  text-decoration: none;
  transition: color var(--gt-t-fast, 160ms ease);
  position: relative;
}
.gt-mobile-bottom-nav__tab:hover {
  color: var(--gt-text-secondary, #374151);
}
.gt-mobile-bottom-nav__tab.is-active {
  color: var(--gt-primary, #1f2e23);
}
.gt-mobile-bottom-nav__tab.is-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 3px;
  border-radius: 0 0 3px 3px;
  background: var(--gt-primary, #1f2e23);
}
.gt-mobile-bottom-nav__icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gt-mobile-bottom-nav__icon {
  width: 22px;
  height: 22px;
}
.gt-mobile-bottom-nav__badge {
  position: absolute;
  top: -4px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9999px;
  background: var(--gt-primary, #1f2e23);
  color: var(--gt-on-primary, #ffffff);
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--gt-surface-0, #ffffff);
}
.gt-mobile-bottom-nav__dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gt-primary, #1f2e23);
  border: 2px solid var(--gt-surface-0, #ffffff);
}

/* Hide the mobile bottom nav when the user is inside an active conversation
   on a phone — Chat.tsx sets data-conv-open="true" on the shell. Mirrors
   WhatsApp's behaviour of giving the message thread the full screen.
   Also reserves the device's safe-area-inset-bottom so the composer
   doesn't get clipped behind the OS gesture/navigation bar. */
@media (max-width: 767px) {
  body[data-conv-open="true"] .gt-mobile-bottom-nav { display: none; }
  body[data-conv-open="true"] .gt-app-main {
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
  /* The chat surface itself: pin its height to the visible viewport so the
     scrollable messages list can shrink and the composer stays in view. */
  body[data-conv-open="true"] .gc-shell {
    /* Fit inside the visible area below the white safe-area top header
       (48px + the device's safe-area-inset-top). Avoids the chat shell
       extending below the viewport bottom when the top header is shown. */
    height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));
    min-height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));
    max-height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));
  }
  /* Composer should sit flush against the safe area, not the raw viewport edge. */
  body[data-conv-open="true"] .gc-chat-composer {
    padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   TodoPlanner — Today / Upcoming / Missed columns
   Desktop (≥768px): 3-column grid (unchanged behaviour).
   Mobile  (<768px): horizontal swipe carousel with scroll-snap, plus
                     left/right arrow buttons and dot indicators.
   ────────────────────────────────────────────────────────────────────────── */
.gt-planner-carousel { width: 100%; }

/* Desktop track = grid */
.gt-planner-carousel__track {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

/* Carousel nav (arrows + dots) is desktop-hidden */
.gt-planner-carousel__nav { display: none; }

@media (max-width: 767px) {
  /* Mobile track = horizontal snap scroller */
  .gt-planner-carousel__track {
    display: flex;
    grid-template-columns: none;
    gap: 0;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    /* let the scroller pull to the page edges so swipe feels native */
    margin: 0 -16px;
    padding: 0 16px;
  }
  .gt-planner-carousel__track::-webkit-scrollbar { display: none; }
  .gt-planner-carousel__track > * {
    flex: 0 0 100%;
    min-width: 100%;
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  /* Mobile nav: arrows on the sides + dots in the middle */
  .gt-planner-carousel__nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 4px 10px;
  }
  .gt-planner-carousel__arrow {
    width: 34px;
    height: 34px;
    border-radius: 9999px;
    background: var(--gt-surface-0, #ffffff);
    border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
    color: var(--gt-text-secondary, #374151);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: background var(--gt-t-fast, 160ms ease), transform var(--gt-t-fast, 160ms ease);
    flex-shrink: 0;
  }
  .gt-planner-carousel__arrow:hover { background: var(--gt-surface-2, #f3f4f6); }
  .gt-planner-carousel__arrow:active { transform: scale(0.96); }
  .gt-planner-carousel__arrow:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .gt-planner-carousel__dots {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
    justify-content: center;
  }
  /* High-specificity selector so this beats the global
     \`.gt-themed [role="tab"]\` rule which would otherwise give the
     buttons \`border-radius: 0\` and 10×16 padding (turning them into
     rectangles). */
  .gt-planner-carousel .gt-planner-carousel__dot[role="tab"],
  .gt-planner-carousel button.gt-planner-carousel__dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    flex-shrink: 0;
    border-radius: 50%;
    background: var(--gt-border-strong, rgba(0, 0, 0, 0.22));
    border: none;
    border-bottom: none;
    cursor: pointer;
    padding: 0;
    box-sizing: border-box;
    transition: background var(--gt-t-fast, 160ms ease), transform var(--gt-t-fast, 160ms ease);
  }
  .gt-planner-carousel .gt-planner-carousel__dot[role="tab"].is-active,
  .gt-planner-carousel button.gt-planner-carousel__dot.is-active {
    background: var(--gt-primary, #1f2e23);
    transform: scale(1.15);
  }
  .gt-planner-carousel__dot-label {
    font-family: var(--gt-font-display);
    font-size: 13px;
    font-weight: 700;
    color: var(--gt-text-primary, #111827);
    letter-spacing: -0.01em;
    margin-right: 4px;
  }

  /* On mobile the columns no longer need a fixed min-height — they live inside
     the snap track, and the empty state has its own height. */
  .gt-planner-carousel .gt-column { min-height: 0; }
  .gt-planner-carousel .gt-column > div[class*="min-h-"] {
    min-height: 320px;
    max-height: 70dvh;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   Daily Planner mobile hamburger — links to the rest of Task Management
   (Projects / Tasks / Clients / Reports). Mobile-only.
   ────────────────────────────────────────────────────────────────────────── */
.gt-planner-mobile-menu-wrap { display: none; }

@media (max-width: 767px) {
  .gt-planner-mobile-menu-wrap {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 20;
  }
}

.gt-planner-mobile-menu-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-text-secondary, #4b5563);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: background var(--gt-t-fast, 160ms ease), color var(--gt-t-fast, 160ms ease), box-shadow var(--gt-t-fast, 160ms ease);
}
.gt-planner-mobile-menu-btn:hover,
.gt-planner-mobile-menu-btn.is-open {
  background: var(--gt-surface-2, #f3f4f6);
  color: var(--gt-text-primary, #111827);
}

.gt-planner-mobile-menu__backdrop {
  position: fixed;
  inset: 0;
  z-index: 49;
  background: transparent;
}
.gt-planner-mobile-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 200px;
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-text-primary, #111827);
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
  z-index: 50;
  overflow: hidden;
  padding: 4px;
  font-family: var(--gt-font);
}
.gt-planner-mobile-menu__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gt-text-primary, #111827);
  text-align: left;
  font-family: inherit;
  border-radius: 8px;
  transition: background var(--gt-t-fast, 160ms ease);
}
.gt-planner-mobile-menu__item:hover {
  background: var(--gt-surface-2, #f3f4f6);
}
.gt-planner-mobile-menu__item > svg {
  color: var(--gt-primary, #1f2e23);
  flex-shrink: 0;
}

/* Compact the Daily Planner hero on mobile so the cards underneath
   sit closer to the page top, eliminating the empty band the user
   noticed below the title. */
@media (max-width: 767px) {
  .gt-page-hero { padding-bottom: 8px; }
  .gt-page-hero h1.gt-page-title { font-size: 22px; line-height: 1.15; }
  .gt-page-hero .gt-page-sub { font-size: 12.5px; margin-top: 2px; }
  .gt-page-hero .gt-eyebrow-row { margin-bottom: 4px; }
}

/* ──────────────────────────────────────────────────────────────────────────
   Shared mobile back-arrow — used on Projects / Tasks / Clients / Reports
   and other task-management sub-pages so users can return to the Daily
   Planner (entry point from the hamburger menu) with one tap. Hidden on
   desktop where the sidebar already exposes the nav.
   ────────────────────────────────────────────────────────────────────────── */
.gt-page-back-btn {
  display: none;
}
@media (max-width: 767px) {
  .gt-page-back-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    padding: 6px 10px 6px 6px;
    border-radius: 9999px;
    background: var(--gt-surface-0, #ffffff);
    border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
    color: var(--gt-text-secondary, #4b5563);
    font-family: var(--gt-font);
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    transition: background var(--gt-t-fast, 160ms ease);
  }
  .gt-page-back-btn:hover { background: var(--gt-surface-2, #f3f4f6); }
  .gt-page-back-btn:active { transform: scale(0.97); }
}


/* ──────────────────────────────────────────────────────────────────────────
   Project Management — status filter grid.
   Mobile: 2-col (set inline). Desktop: 5-col.
   ────────────────────────────────────────────────────────────────────────── */
@media (min-width: 768px) {
  .gt-project-status-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   TaskList page — mobile-friendly tab row + action buttons
   ────────────────────────────────────────────────────────────────────────── */
.gt-tasks-scope-tab {
  padding: 10px 18px;
  font-family: var(--gt-font-display);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--gt-text-tertiary, #6b7280);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}
.gt-tasks-scope-tab.is-active {
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-primary-deep, var(--gt-primary, #1f2e23));
  border-bottom-color: var(--gt-primary, #1f2e23);
  box-shadow: var(--gt-elev-1);
}

/* Hide the scope-tabs horizontal scrollbar on mobile for a cleaner look. */
.gt-tasks-scope-tabs nav { scrollbar-width: none; }
.gt-tasks-scope-tabs nav::-webkit-scrollbar { display: none; }

@media (max-width: 767px) {
  .gt-tasks-scope-tab {
    padding: 9px 12px;
    font-size: 12.5px;
    gap: 6px;
  }
  /* "Recently Deleted" becomes an icon-only square on phones. */
  .gt-task-trash-btn {
    width: 42px;
    height: 42px;
    padding: 0 !important;
    justify-content: center;
    flex-shrink: 0;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   Daily Planner mobile filter icon — replaces the inline Priority + Status
   dropdowns on phones. Tapping it opens a popover with both selects.
   ────────────────────────────────────────────────────────────────────────── */
.gt-planner-filter-icon-btn {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-text-secondary, #4b5563);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background var(--gt-t-fast, 160ms ease), color var(--gt-t-fast, 160ms ease);
}
.gt-planner-filter-icon-btn:hover,
.gt-planner-filter-icon-btn.is-open {
  background: var(--gt-surface-2, #f3f4f6);
  color: var(--gt-text-primary, #111827);
}
.gt-planner-filter-icon-btn__dot {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--gt-primary, #1f2e23);
  border: 2px solid var(--gt-surface-0, #ffffff);
}

.gt-planner-filter-popover__backdrop {
  position: fixed;
  inset: 0;
  z-index: 49;
  background: transparent;
}
.gt-planner-filter-popover {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: min(280px, calc(100vw - 32px));
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-text-primary, #111827);
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
  z-index: 50;
  padding: 12px;
  font-family: var(--gt-font);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gt-planner-filter-popover__title {
  font-weight: 600;
  font-size: 13px;
  color: var(--gt-text-primary, #111827);
  padding-bottom: 4px;
  border-bottom: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));
  margin-bottom: 4px;
}
.gt-planner-filter-popover__label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary, #6b7280);
  margin-top: 4px;
}
.gt-planner-filter-popover__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 6px;
  border-top: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));
  padding-top: 10px;
}
.gt-planner-filter-popover__reset {
  background: transparent;
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
  color: var(--gt-text-secondary, #4b5563);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
}
.gt-planner-filter-popover__done {
  background: var(--gt-primary, #1f2e23);
  border: none;
  color: var(--gt-on-primary, #ffffff);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

/* On mobile the History button becomes icon-only (text hidden via JSX). */
@media (max-width: 767px) {
  .gt-planner-history-btn {
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 10px;
    justify-content: center;
    flex-shrink: 0;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   Task Reports — collapsible filter trigger
   ────────────────────────────────────────────────────────────────────────── */
.gt-reports-filter-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));
  background: var(--gt-surface-0, #ffffff);
  color: var(--gt-text-primary, #111827);
  font-family: var(--gt-font);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  min-width: 140px;
  transition: background var(--gt-t-fast, 160ms ease), border-color var(--gt-t-fast, 160ms ease);
}
.gt-reports-filter-trigger:hover {
  background: var(--gt-surface-2, #f3f4f6);
  border-color: var(--gt-border-strong, rgba(0, 0, 0, 0.18));
}
.gt-reports-filter-trigger[aria-expanded="true"] {
  border-color: var(--gt-primary, #1f2e23);
  color: var(--gt-primary-deep, var(--gt-primary, #1f2e23));
}
.gt-reports-filter-trigger__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--gt-primary, #1f2e23);
  display: inline-block;
  margin-left: 2px;
}

.gt-reports-filter-panel {
  animation: gt-fade-up 260ms cubic-bezier(0.33, 1, 0.68, 1) both;
  transform-origin: top left;
}

/* ──────────────────────────────────────────────────────────────────────────
   TaskStats — colorful status tile grid.
   Mobile: 3 cols (set inline).
   Desktop (≥768px): one row of N tiles (N = --task-stats-desktop-cols).
   ────────────────────────────────────────────────────────────────────────── */
@media (min-width: 768px) {
  .gt-task-stats-grid {
    grid-template-columns: repeat(var(--task-stats-desktop-cols, 6), minmax(0, 1fr)) !important;
    gap: 8px !important;
  }
}

/* ──────────────────────────────────────────────────────────────────────────
   Task create/edit modal — mobile sizing for the section tabs so all 5 fit
   on a single line with a horizontal scroll fallback.
   ────────────────────────────────────────────────────────────────────────── */
.gt-task-tabs { scrollbar-width: none; }
.gt-task-tabs::-webkit-scrollbar { display: none; }

@media (max-width: 767px) {
  .gt-task-tabs > button {
    padding: 9px 12px !important;
    font-size: 12.5px !important;
  }
}


/* ──────────────────────────────────────────────────────────────────────────
   Login page — responsive layout
   Desktop (≥768px): 2-column grid (editorial copy + form card).
   Mobile  (<768px): single column, editorial copy stacks above the form.
   ────────────────────────────────────────────────────────────────────────── */
.gt-login-page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  background: var(--gt-surface-1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: var(--gt-font);
  color: var(--gt-text-primary);
  overflow-x: hidden;
}
.gt-login-blobs {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.gt-login-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(20px);
  opacity: 0.7;
}
.gt-login-blob.is-primary {
  top: -120px;
  left: -120px;
  width: 360px;
  height: 360px;
  background: radial-gradient(closest-side, var(--gt-primary-container), transparent 70%);
}
.gt-login-blob.is-accent {
  bottom: -160px;
  right: -100px;
  width: 420px;
  height: 420px;
  filter: blur(24px);
  opacity: 0.6;
  background: radial-gradient(closest-side, var(--gt-accent-soft), transparent 70%);
}
.gt-login-grid {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 880px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 440px);
  gap: 56px;
  align-items: center;
}
@media (max-width: 767px) {
  /* Mobile login fills the full device height. The editorial copy sits at
     the top, the sign-in card grows to fill the remaining space, so there
     are no awkward empty bands at the top or bottom. */
  .gt-login-page {
    align-items: stretch;
    padding: 0;
  }
  .gt-login-grid {
    /* Mobile: hide the editorial copy and centre the sign-in form so the
       full device height is just the form. */
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr;
    gap: 0;
    max-width: none;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    min-height: 100dvh;
    padding: 24px 20px max(24px, env(safe-area-inset-bottom, 0px));
  }

  /* Hide the editorial column on phones — only the sign-in form shows. */
  .gt-login-editorial { display: none; }
  /* Shrink/hide oversized decorative blobs so they don't fight the small viewport */
  .gt-login-blob.is-primary { width: 220px; height: 220px; top: -80px; left: -80px; }
  .gt-login-blob.is-accent { width: 260px; height: 260px; bottom: -120px; right: -80px; }

  /* Sign-in card entrance — fades up on load. */
  .gt-login-card {
    animation: gt-fade-up 520ms cubic-bezier(0.33, 1, 0.68, 1) 60ms both;
    padding: 28px 22px;
    gap: 16px;
    width: 100%;
    max-width: 420px;
    align-self: center;
  }
  .gt-login-card-title { font-size: 22px; }
  .gt-login-input { font-size: 16px; padding-top: 12px; padding-bottom: 12px; }
  .gt-login-submit { padding-top: 14px; padding-bottom: 14px; font-size: 15px; }
}
.gt-login-editorial { min-width: 0; }
.gt-login-eyebrow {
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.gt-login-eyebrow-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gt-primary);
  display: inline-block;
}
.gt-login-headline {
  font-family: var(--gt-font-display);
  font-size: clamp(28px, 7vw, 56px);
  line-height: 1.05;
  letter-spacing: var(--gt-letter-display);
  color: var(--gt-text-primary);
  margin: 0;
}
.gt-login-headline em {
  color: var(--gt-primary);
  font-style: italic;
}
.gt-login-tagline {
  margin-top: 18px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--gt-text-secondary);
  max-width: 420px;
}
@media (max-width: 767px) {
  .gt-login-tagline { font-size: 14px; margin-top: 12px; }
}

.gt-login-card {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
@media (max-width: 767px) {
  .gt-login-card { padding: 24px; }
}
.gt-login-card-eyebrow {
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--gt-text-tertiary);
  margin-bottom: 6px;
}
.gt-login-card-title {
  font-family: var(--gt-font-display);
  font-size: 24px;
  margin: 0;
  color: var(--gt-text-primary);
}
.gt-login-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gt-login-input-wrap { position: relative; }
.gt-login-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--gt-text-tertiary);
  pointer-events: none;
}
.gt-login-input {
  width: 100%;
  padding-left: 36px;
}
.gt-login-input.has-trailing { padding-right: 40px; }
.gt-login-eye-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--gt-text-tertiary);
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gt-login-error {
  font-size: 13px;
  color: #9b2f24;
  background: rgba(196, 87, 76, 0.08);
  border: 1px solid rgba(196, 87, 76, 0.25);
  border-radius: 10px;
  padding: 10px 12px;
}
.gt-login-submit {
  width: 100%;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
}
/* Sign in with Google — the button itself is rendered by Google Identity
   Services, so this only positions it and separates it from the email form. */
.gt-login-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--gt-text-tertiary);
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.gt-login-divider::before,
.gt-login-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: var(--gt-border);
}
/* Google caps its own button at 400px and styles it itself, so the real one is
   rendered invisible and scaled (in Login.tsx) over .gt-login-google-face —
   ours, which carries the Continue button's own classes so the two can never
   drift apart. Clicks land on Google's button; only ours is seen. */
.gt-login-google {
  position: relative;
}
.gt-login-google:focus-within .gt-login-google-face {
  box-shadow: 0 0 0 3px var(--gt-primary-soft);
}
.gt-login-google-face.gt-btn {
  /* gt-login-submit adds a top margin; here it would leave the invisible
     Google button overhanging the visible one by those pixels. */
  margin: 0;
  gap: 10px;
  border: 1px solid var(--gt-border);
  background: var(--gt-surface-2);
  color: var(--gt-text-primary);
}
.gt-login-google:hover .gt-login-google-face.gt-btn {
  background: var(--gt-surface-hover);
}
.gt-login-google-real {
  position: absolute;
  inset: 0;
  overflow: hidden;
  opacity: 0;
}

.gt-login-foot {
  font-size: 12px;
  color: var(--gt-text-tertiary);
  text-align: center;
  margin-top: 4px;
}

/* Compact variant — smaller card for the multi-step flow */
.gt-login-card--compact {
  padding: 24px 26px;
  gap: 14px;
  max-width: 380px;
  width: 100%;
  justify-self: end;
}
.gt-login-card--compact .gt-login-card-title { font-size: 22px; }
.gt-login-card--compact .gt-login-input { padding-top: 10px; padding-bottom: 10px; }
.gt-login-card--compact .gt-login-submit { padding-top: 11px; padding-bottom: 11px; }
@media (max-width: 767px) {
  .gt-login-card--compact { padding: 24px 22px; max-width: 420px; justify-self: center; }
}

.gt-login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Organisation list */
.gt-login-orglist {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
  margin: 0 -4px;
  padding: 0 4px;
}
.gt-login-org {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));
  border-radius: 12px;
  background: var(--gt-surface-2, #fff);
  cursor: pointer;
  transition: border-color 160ms, background 160ms, transform 160ms;
}
.gt-login-org:hover {
  border-color: var(--gt-text-primary);
  background: var(--gt-surface-1, #faf8f3);
}
.gt-login-org:active { transform: translateY(1px); }
.gt-login-org-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--gt-tint, rgba(15, 118, 110, 0.1));
  color: var(--gt-text-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gt-login-org-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}
.gt-login-org-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--gt-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gt-login-org-sub {
  font-size: 12px;
  color: var(--gt-text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gt-login-org-arrow {
  color: var(--gt-text-tertiary);
  flex-shrink: 0;
}

/* "Signing in to X" chip + back button */
.gt-login-orgchip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--gt-tint, rgba(15, 118, 110, 0.1));
  color: var(--gt-text-primary);
  font-size: 12px;
  align-self: flex-start;
  max-width: 100%;
  overflow: hidden;
}
.gt-login-orgchip > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gt-login-back {
  width: 100%;
  justify-content: center;
  gap: 6px;
  background: transparent;
  color: var(--gt-text-tertiary);
  font-size: 13px;
  padding: 8px 12px;
}
.gt-login-back:hover { color: var(--gt-text-primary); }

/* ─── Chat Notifications Panel (CNP) ──────────────────────────────────────── */
.cnp-root {
  display: flex;
  flex-direction: column;
  font-family: var(--gc-font-display, 'DM Sans', sans-serif);
}

/* Empty state */
.cnp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 32px 20px;
  color: var(--gc-text-tertiary, #9ca3af);
}
.cnp-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: var(--gc-surface-2, #f3f4f6);
  color: var(--gc-text-tertiary, #9ca3af);
  margin-bottom: 4px;
}
.cnp-empty-title {
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--gc-text-secondary, #374151);
  letter-spacing: -0.01em;
}
.cnp-empty-sub {
  margin: 0;
  font-size: 12px;
  color: var(--gc-text-tertiary, #9ca3af);
}

/* Toolbar: count + mark-all */
.cnp-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 6px;
  border-bottom: 1px solid var(--gc-border, rgba(0,0,0,.06));
}
.cnp-toolbar-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--gc-text-tertiary, #9ca3af);
}
.cnp-mark-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1.5px solid var(--gc-primary, #1f4d3f);
  background: transparent;
  color: var(--gc-primary, #1f4d3f);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 140ms ease, color 140ms ease;
  letter-spacing: -0.01em;
}
.cnp-mark-all-btn:hover {
  background: var(--gc-primary, #1f4d3f);
  color: #fff;
}

/* List */
.cnp-list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

/* Row */
.cnp-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px 0 0;
  border-bottom: 1px solid var(--gc-border, rgba(0,0,0,.04));
  transition: background 120ms ease;
}
.cnp-item:hover { background: var(--gc-surface-2, #f9fafb); }
.cnp-item:last-child { border-bottom: none; }

.cnp-item-btn {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 6px 9px 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
}

/* Color-coded initials avatar */
.cnp-avatar {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: var(--gc-font-display, sans-serif);
}

/* Name + preview */
.cnp-item-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.cnp-item-name {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gc-text-primary, #111827);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cnp-item-preview {
  font-size: 11.5px;
  color: var(--gc-text-tertiary, #9ca3af);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Time + count pill (right column) */
.cnp-item-meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}
.cnp-item-time {
  font-size: 10.5px;
  font-family: var(--gc-font-mono, monospace);
  color: var(--gc-text-tertiary, #9ca3af);
  letter-spacing: 0.02em;
}
.cnp-item-count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--gc-primary, #1f4d3f);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: -0.01em;
}

/* Per-item ✓ button */
.cnp-check-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  border: 1.5px solid var(--gc-border, rgba(0,0,0,.10));
  background: var(--gc-surface-0, #fff);
  color: var(--gc-primary, #1f4d3f);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 140ms ease, background 120ms ease;
}
.cnp-item:hover .cnp-check-btn { opacity: 1; }
.cnp-check-btn:hover {
  background: var(--gc-primary, #1f4d3f);
  color: #fff;
  border-color: var(--gc-primary, #1f4d3f);
}

/* Mobile badge — use primary green instead of red */
.gc-chat-mobile-icon-btn__badge {
  background: var(--gc-primary, #1f4d3f) !important;
}

/* ── One rounded container holding all 3 panels flush ──────────────────── */
html body .gc-chat-shell {
  margin: 10px;
  height: calc(100% - 20px);
  border-radius: 18px;
  padding: 0;
  gap: 0;
  box-shadow: 0 2px 12px -4px rgba(20, 20, 18, 0.10);
}
html body .gc-chat-sidebar,
html body .gc-chat-main,
html body .gc-right-panel {
  border-radius: 0 !important;
}
@media (max-width: 767px) {
  html body .gc-chat-shell {
    margin: 0;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}


/* ──────────────────────────────────────────────────────────────────────────
   Client / Vendor Management — Editorial ledger aesthetic
   ─────────────────────────────────────────────────────────────────────────
   Component prefix: .cm-*  (Client Management)
   Used by ClientsPage.tsx and the cloned VendorsPage.tsx.
   ──────────────────────────────────────────────────────────────────────── */

/* ----- Buttons (primary / ghost) ----- */
.cm-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-family: var(--gt-font);
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: -0.005em;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),
              color var(--gt-t-fast), transform var(--gt-t-fast),
              box-shadow var(--gt-t-fast);
  white-space: nowrap;
  line-height: 1;
}
.cm-btn:focus-visible {
  outline: 2px solid var(--gt-primary);
  outline-offset: 2px;
}
.cm-btn-primary {
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  border-color: var(--gt-primary);
  box-shadow: var(--gt-glow-soft);
}
.cm-btn-primary:hover {
  background: var(--gt-primary-hover);
  border-color: var(--gt-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--gt-glow);
}
.cm-btn-primary:active { transform: translateY(0); }
.cm-btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}
.cm-btn-ghost {
  background: var(--gt-surface-0);
  color: var(--gt-primary);
  border-color: var(--gt-border-strong);
}
.cm-btn-ghost:hover {
  background: var(--gt-surface-1);
  border-color: var(--gt-primary);
}
.cm-btn-spinner {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1.5px solid rgba(255,255,255,0.35);
  border-top-color: var(--gt-on-primary);
  animation: cm-spin 0.7s linear infinite;
}
@keyframes cm-spin { to { transform: rotate(360deg); } }

/* ----- Import dropdown ----- */
.cm-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  box-shadow: var(--gt-elev-4);
  overflow: hidden;
  z-index: 10;
  animation: cm-pop-down 220ms cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes cm-pop-down {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.cm-dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-family: var(--gt-font);
  font-size: 13.5px;
  color: var(--gt-text-secondary);
  background: transparent;
  border: 0;
  border-top: 1px dashed var(--gt-divider);
  text-align: left;
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast);
}
.cm-dropdown-item:first-child { border-top: 0; }
.cm-dropdown-item:hover {
  background: var(--gt-surface-1);
  color: var(--gt-primary);
}
.cm-dropdown-item svg { color: var(--gt-primary); flex-shrink: 0; }

/* ----- Stat tiles (editorial ledger rows) ----- */
.cm-stats {
  margin-top: 28px;
  display: none;
  gap: 14px;
}
@media (min-width: 768px) {
  .cm-stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.cm-stat-tile {
  position: relative;
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  padding: 18px 22px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 18px;
  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid),
              transform var(--gt-t-mid);
  overflow: hidden;
}
.cm-stat-tile::before {
  content: "";
  position: absolute;
  top: 0; bottom: 0; left: 0;
  width: 3px;
  background: var(--gt-primary);
  transform: scaleY(0.3);
  transform-origin: center;
  transition: transform var(--gt-t-mid);
}
.cm-stat-tile:hover {
  border-color: var(--gt-border-strong);
  box-shadow: var(--gt-elev-2);
  transform: translateY(-2px);
}
.cm-stat-tile:hover::before { transform: scaleY(0.85); }
.cm-stat-index {
  font-family: var(--gt-font-mono);
  font-size: 10.5px;
  font-weight: 500;
  color: var(--gt-text-tertiary);
  letter-spacing: 0.04em;
  padding-top: 4px;
  align-self: start;
}
.cm-stat-eyebrow {
  font-family: var(--gt-font);
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: var(--gt-letter-eyebrow);
  color: var(--gt-text-tertiary);
  margin: 0 0 6px;
}
.cm-stat-value {
  font-family: var(--gt-font-display);
  font-size: 30px;
  font-weight: 700;
  letter-spacing: var(--gt-letter-display);
  color: var(--gt-text-primary);
  line-height: 1;
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.cm-stat-suffix {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  color: var(--gt-text-tertiary);
  letter-spacing: -0.005em;
}
.cm-stat-accent {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 400;
  font-size: 12.5px;
  color: var(--gt-text-tertiary);
  opacity: 0.7;
  margin: 0;
  align-self: end;
  padding-bottom: 2px;
}

/* ----- Search row ----- */
.cm-search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
  padding-bottom: 14px;
  border-bottom: 1px dashed var(--gt-border);
  flex-wrap: wrap;
}
.cm-search {
  position: relative;
  flex: 1 1;
  max-width: 460px;
  min-width: 240px;
}
.cm-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 17px;
  color: var(--gt-text-tertiary);
  pointer-events: none;
}
.cm-search-input {
  width: 100%;
  padding: 12px 40px 12px 42px;
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: 12px;
  font-family: var(--gt-font);
  font-size: 14px;
  color: var(--gt-text-primary);
  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast),
              background var(--gt-t-fast);
}
.cm-search-input::placeholder {
  color: var(--gt-text-tertiary);
  font-style: italic;
}
.cm-search-input:focus {
  outline: none;
  border-color: var(--gt-primary);
  box-shadow: 0 0 0 3px var(--gt-primary-container);
  background: var(--gt-surface-0);
}
.cm-search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--gt-text-tertiary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast);
}
.cm-search-clear:hover {
  background: var(--gt-surface-2);
  color: var(--gt-primary);
}
.cm-search-meta {
  font-family: var(--gt-font);
  font-size: 12.5px;
  color: var(--gt-text-tertiary);
  letter-spacing: 0.005em;
  white-space: nowrap;
}
.cm-search-meta em {
  font-family: var(--gt-font-serif);
  font-style: italic;
  color: var(--gt-text-secondary);
}

/* ----- Loading state ----- */
.cm-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  gap: 18px;
}
.cm-spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid var(--gt-border);
  border-top-color: var(--gt-primary);
  animation: cm-spin 0.8s linear infinite;
}
.cm-loading-text {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-size: 14px;
  color: var(--gt-text-tertiary);
  margin: 0;
}

/* ----- Empty state (cornered frame) ----- */
.cm-empty {
  display: flex;
  justify-content: center;
  padding: 24px 0 48px;
}
.cm-empty-frame {
  position: relative;
  max-width: 520px;
  width: 100%;
  padding: 56px 48px 48px;
  text-align: center;
  background: var(--gt-surface-1);
  border-radius: var(--gt-radius-card);
}
.cm-empty-corner {
  position: absolute;
  width: 22px;
  height: 22px;
  border: 1.5px solid var(--gt-primary);
  opacity: 0.55;
}
.cm-empty-corner-tl { top: 14px; left: 14px;  border-right: 0; border-bottom: 0; }
.cm-empty-corner-tr { top: 14px; right: 14px; border-left: 0;  border-bottom: 0; }
.cm-empty-corner-bl { bottom: 14px; left: 14px;  border-right: 0; border-top: 0; }
.cm-empty-corner-br { bottom: 14px; right: 14px; border-left: 0;  border-top: 0; }
.cm-empty-eyebrow {
  font-family: var(--gt-font);
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--gt-text-tertiary);
  margin: 0 0 18px;
}
.cm-empty-title {
  font-family: var(--gt-font-display);
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--gt-text-primary);
  margin: 0 0 12px;
  line-height: 1.15;
}
.cm-empty-title em {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 500;
  color: var(--gt-primary);
}
.cm-empty-sub {
  font-family: var(--gt-font);
  font-size: 14px;
  color: var(--gt-text-secondary);
  margin: 0 0 26px;
  line-height: 1.5;
}
.cm-empty-cta {
  display: inline-flex;
}

/* ----- Modal (overlay + sheet) ----- */
.cm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 24, 18, 0.42);
  backdrop-filter: blur(6px);
  animation: cm-fade-in 200ms ease-out;
}
@keyframes cm-fade-in { from { opacity: 0; } to { opacity: 1; } }
.cm-modal {
  position: relative;
  width: 100%;
  max-width: 880px;
  max-height: 92vh;
  background: var(--gt-surface-1);
  border-radius: var(--gt-radius-modal);
  box-shadow: var(--gt-elev-5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: cm-modal-in 360ms cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes cm-modal-in {
  from { opacity: 0; transform: translateY(14px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.cm-modal-header {
  position: relative;
  padding: 32px 40px 26px;
  background: var(--gt-surface-1);
  border-bottom: 1px dashed var(--gt-border-strong);
  flex-shrink: 0;
}
.cm-modal-eyebrow-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.cm-modal-leaf {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: var(--gt-primary);
  border-radius: 50%;
  box-shadow: 0 0 0 4px var(--gt-primary-container);
}
.cm-modal-eyebrow {
  font-family: var(--gt-font);
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: var(--gt-letter-eyebrow);
  color: var(--gt-text-tertiary);
}
.cm-modal-title {
  font-family: var(--gt-font-display);
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--gt-text-primary);
  margin: 0 0 8px;
  line-height: 1.1;
}
.cm-modal-title em {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 500;
  color: var(--gt-primary);
}
.cm-modal-sub {
  font-family: var(--gt-font);
  font-size: 14px;
  color: var(--gt-text-secondary);
  margin: 0;
  line-height: 1.55;
  max-width: 560px;
}
.cm-modal-sub em.gt-serif-italic {
  font-family: var(--gt-font-serif);
  font-style: italic;
  color: var(--gt-text-primary);
}
.cm-modal-close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 1px solid var(--gt-border);
  border-radius: 10px;
  color: var(--gt-text-secondary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast),
              border-color var(--gt-t-fast);
}
.cm-modal-close:hover {
  background: var(--gt-surface-0);
  color: var(--gt-primary);
  border-color: var(--gt-primary);
}
.cm-modal-form {
  padding: 28px 40px 0;
  overflow-y: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.cm-modal-footer {
  position: sticky;
  bottom: 0;
  margin: 0 -40px;
  padding: 18px 40px;
  background: var(--gt-surface-1);
  border-top: 1px solid var(--gt-border);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

/* ----- Section (form group) ----- */
.cm-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.cm-section-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 2px;
}
.cm-section-rule {
  flex-shrink: 0;
  width: 28px;
  height: 1px;
  background: var(--gt-primary);
  opacity: 0.55;
}
.cm-section-eyebrow {
  font-family: var(--gt-font-mono);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--gt-primary);
  text-transform: lowercase;
}
.cm-section-title {
  font-family: var(--gt-font-display);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--gt-text-primary);
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.cm-section-title em {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-weight: 500;
  color: var(--gt-primary);
}
.cm-section-count {
  font-family: var(--gt-font-mono);
  font-size: 11px;
  font-weight: 500;
  color: var(--gt-text-tertiary);
  background: var(--gt-surface-2);
  border-radius: 6px;
  padding: 3px 7px;
  letter-spacing: 0.04em;
}
.cm-add-branch {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: var(--gt-primary-container);
  color: var(--gt-primary);
  border: 1px dashed var(--gt-primary);
  border-radius: 999px;
  font-family: var(--gt-font);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.005em;
  cursor: pointer;
  transition: background var(--gt-t-fast), border-style var(--gt-t-fast),
              transform var(--gt-t-fast);
}
.cm-add-branch:hover {
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  border-style: solid;
  transform: translateY(-1px);
}

/* ----- Form fields ----- */
.cm-field { display: flex; flex-direction: column; }
.cm-field-label {
  display: block;
  font-family: var(--gt-font);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--gt-text-secondary);
  margin-bottom: 8px;
}
.cm-field-required {
  color: var(--gt-dnd);
  font-weight: 700;
  margin-left: 2px;
}
.cm-input {
  width: 100%;
  padding: 12px 16px;
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-input);
  font-family: var(--gt-font);
  font-size: 14px;
  color: var(--gt-text-primary);
  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast),
              background var(--gt-t-fast);
}
.cm-input::placeholder {
  color: var(--gt-text-tertiary);
  font-style: italic;
}
.cm-input:focus {
  outline: none;
  border-color: var(--gt-primary);
  box-shadow: 0 0 0 3px var(--gt-primary-container);
}
.cm-input:hover:not(:focus):not(.is-error) {
  border-color: var(--gt-border-strong);
}
.cm-input.is-error {
  border-color: var(--gt-dnd);
}
.cm-input.is-error:focus {
  box-shadow: 0 0 0 3px rgba(196, 87, 76, 0.16);
}
.cm-input-mono {
  font-family: var(--gt-font-mono);
  letter-spacing: 0.01em;
}
.cm-input-with-action { padding-right: 96px; }
.cm-field-error {
  font-family: var(--gt-font);
  font-size: 12px;
  color: var(--gt-dnd);
  margin: 6px 0 0;
  font-style: italic;
}
.cm-fetch-btn {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  padding: 7px 14px;
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  border: 0;
  border-radius: 9px;
  font-family: var(--gt-font);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 180ms ease, background var(--gt-t-fast);
}
.cm-fetch-btn.is-visible {
  opacity: 1;
  pointer-events: auto;
}
.cm-fetch-btn:hover {
  background: var(--gt-primary-hover);
}

/* ----- Branch card ----- */
.cm-branch-card {
  position: relative;
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  border-radius: var(--gt-radius-card);
  padding: 24px 24px 22px;
  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid);
}
.cm-branch-card:hover {
  border-color: var(--gt-border-strong);
  box-shadow: var(--gt-elev-1);
}
.cm-branch-tag {
  position: absolute;
  top: -10px;
  left: 18px;
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 12px;
  background: var(--gt-primary);
  color: var(--gt-on-primary);
  border-radius: 999px;
  box-shadow: var(--gt-glow-soft);
}
.cm-branch-tag-num {
  font-family: var(--gt-font-mono);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  opacity: 0.7;
}
.cm-branch-tag-label {
  font-family: var(--gt-font-serif);
  font-style: italic;
  font-size: 12px;
  font-weight: 500;
}
.cm-branch-remove {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--gt-text-tertiary);
  cursor: pointer;
  transition: background var(--gt-t-fast), color var(--gt-t-fast);
}
.cm-branch-remove:hover {
  background: #fdecea;
  color: var(--gt-dnd);
}
.cm-branch-empty {
  text-align: center;
  padding: 36px 24px;
  background: var(--gt-surface-2);
  border: 1px dashed var(--gt-border-strong);
  border-radius: var(--gt-radius-card);
}
.cm-branch-empty-eyebrow {
  font-family: var(--gt-font);
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--gt-text-tertiary);
  margin: 0 0 10px;
}
.cm-branch-empty-text {
  font-family: var(--gt-font);
  font-size: 13.5px;
  color: var(--gt-text-secondary);
  margin: 0;
}
.cm-branch-empty-text em.gt-serif-italic {
  font-family: var(--gt-font-serif);
  font-style: italic;
  color: var(--gt-text-primary);
}

/* Responsive — tighten modal padding on small screens */
@media (max-width: 640px) {
  .cm-modal-header { padding: 24px 22px 20px; }
  .cm-modal-form   { padding: 22px 22px 0; gap: 26px; }
  .cm-modal-footer { margin: 0 -22px; padding: 16px 22px; }
  .cm-modal-title  { font-size: 26px; }
  .cm-empty-frame  { padding: 44px 24px 36px; }
  .cm-empty-title  { font-size: 24px; }
}

/* ── BrandColorSetting ─────────────────────────────────────────────────────── */
.gc-brand-color-setting { padding: 16px; border: 1px solid var(--gc-border, #e5e7eb); border-radius: 8px; max-width: 480px; }
.gc-brand-color-setting__heading h3 { margin: 0 0 4px; font-size: 14px; font-weight: 600; }
.gc-brand-color-setting__hint { margin: 0 0 12px; color: var(--gc-muted, #6b7280); font-size: 12px; }
.gc-brand-color-setting__row { display:flex; align-items:center; gap:10px; margin-top:10px; flex-wrap: wrap; }
.gc-brand-color-setting__toggle { display:flex; align-items:center; gap:8px; font-size: 13px; cursor: pointer; }
.gc-brand-color-setting__label { font-size: 12px; color: var(--gc-muted); }
.gc-brand-color-setting__hex { padding: 4px 8px; border-radius: 4px; border: 1px solid var(--gc-border, #e5e7eb); font-family: monospace; font-size: 12px; width: 100px; }
.gc-brand-color-setting__preview-label { font-size: 12px; color: var(--gc-muted); }
.gc-brand-color-setting__saved { color: var(--gc-success, #047857); font-size: 12px; }

/* ── ClientsPage — workspace button on linked client rows ──────────────────── */
.gc-clients-row__workspace-btn { font-size: 12px; }

/* ── Call-row: reveal hover actions, mute the subtitle, missed -> danger token ── */
.gc-call-row__actions { opacity: 0; transition: opacity var(--gc-transition-fast); }
.gc-call-row:hover .gc-call-row__actions,
.gc-call-row:focus-within .gc-call-row__actions { opacity: 1; }
.gc-call-row__sub { color: var(--gc-text-tertiary); }
.gc-call-row--missed .gc-text-display-bold,
.gc-call-row--missed .gc-call-row__sub { color: var(--gc-dnd); }

/* ── In-chat call event card — WhatsApp-style, replaces the old centred pill ──
   Aligns like a message: calls I started (.is-mine) on the right, received on
   the left. Whole card is a button that rings back. ─────────────────────────── */
.gc-call-card-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 2px 14px;
  margin: 2px 0;
}
.gc-call-card-row.is-mine { justify-content: flex-end; }

.gc-call-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 240px;
  max-width: min(340px, 78%);
  padding: 9px 14px;
  border-radius: 16px;
  background: var(--gc-surface-2);
  border: 1px solid var(--gc-border);
  text-align: left;
  cursor: pointer;
  transition: background var(--gc-transition-fast), border-color var(--gc-transition-fast);
}
.gc-call-card:hover { background: var(--gc-surface-1); border-color: var(--gc-border-strong); }
.gc-call-card:focus-visible { outline: 2px solid var(--gc-primary); outline-offset: 2px; }

.gc-call-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 9999px;
  background: color-mix(in srgb, var(--gc-text-tertiary) 18%, transparent);
  color: var(--gc-text-secondary);
}

.gc-call-card__body { display: flex; flex-direction: column; min-width: 0; flex: 1 1; }
.gc-call-card__title {
  font-family: var(--gc-font-display);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--gc-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-call-card__sub {
  font-size: 12px;
  line-height: 1.3;
  color: var(--gc-text-tertiary);
  margin-top: 1px;
}
.gc-call-card__time {
  align-self: flex-end;
  flex-shrink: 0;
  font-size: 10.5px;
  color: var(--gc-text-tertiary);
}

/* Missed / unanswered → danger token on the icon, title and subtitle. */
.gc-call-card--missed .gc-call-card__icon {
  background: color-mix(in srgb, var(--gc-dnd) 16%, transparent);
  color: var(--gc-dnd);
}
.gc-call-card--missed .gc-call-card__title,
.gc-call-card--missed .gc-call-card__sub { color: var(--gc-dnd); }

/* ── Employee Hub · Workflow ───────────────────────────────────────────── */
.gt-workflow-page {
  min-height: 100%;
  padding: clamp(18px, 3vw, 34px);
  background: var(--gt-surface-1);
  color: var(--gt-text-primary);
  overflow: auto;
}
.gt-workflow-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin-bottom: 24px; }
.gt-workflow-header__copy { display: flex; align-items: center; gap: 14px; min-width: 0; }
.gt-workflow-header__icon { display: grid; place-items: center; width: 48px; height: 48px; flex: 0 0 auto; border-radius: 14px; background: var(--gt-accent-strong); color: var(--gt-surface-0); }
.gt-workflow-header__icon svg { width: 23px; height: 23px; }
.gt-workflow-header h1 { margin: 0; font-size: clamp(25px, 3vw, 38px); line-height: 1.08; font-weight: 750; letter-spacing: -0.025em; }
.gt-workflow-header h1 em { color: var(--gt-accent); font-family: Georgia, serif; }
.gt-workflow-header p { margin: 6px 0 0; color: var(--gt-text-tertiary); }
.gt-workflow-header__actions { display: flex; gap: 10px; align-items: center; }
.gt-workflow-panel, .gt-workflow-card, .gt-workflow-metric {
  background: var(--gt-surface-0);
  border: 1px solid var(--gt-border);
  box-shadow: var(--gt-elev-1);
}
.gt-workflow-panel { border-radius: 18px; padding: 20px; margin-bottom: 22px; }
.gt-workflow-filters { display: flex; flex-wrap: wrap; align-items: end; gap: 12px; }
.gt-workflow-filters label, .gt-workflow-date-range label { display: grid; gap: 6px; color: var(--gt-text-secondary); font-size: 12px; font-weight: 650; }
.gt-workflow-filters input, .gt-workflow-filters select, .gt-workflow-date-range input {
  min-height: 44px; border: 1px solid var(--gt-border); border-radius: 11px; padding: 0 13px;
  background: var(--gt-surface-1); color: var(--gt-text-primary); font: inherit;
}
.gt-workflow-filters .is-grow { flex: 1 1 260px; }
.gt-workflow-button { min-height: 44px; border: 1px solid var(--gt-accent); border-radius: 11px; padding: 0 18px; background: var(--gt-accent-strong); color: var(--gt-surface-0); font-weight: 700; cursor: pointer; transition: filter var(--gt-t-fast), box-shadow var(--gt-t-fast); }
.gt-workflow-button.is-secondary { background: transparent; color: var(--gt-text-primary); border-color: var(--gt-border-strong); }
.gt-workflow-button:hover { filter: brightness(1.08); }
.gt-workflow-button:focus-visible, .gt-workflow-tabs button:focus-visible, button.gt-workflow-card:focus-visible { outline: 2px solid var(--gt-accent); outline-offset: 3px; }
.gt-workflow-date-range { display: flex; align-items: end; gap: 8px; }
.gt-workflow-date-range > svg { margin-bottom: 12px; width: 17px; color: var(--gt-text-tertiary); }
.gt-workflow-tabs { display: inline-flex; padding: 4px; border: 1px solid var(--gt-border); border-radius: 11px; background: var(--gt-surface-2); }
.gt-workflow-tabs button { border: 0; border-radius: 8px; padding: 8px 16px; background: transparent; color: var(--gt-text-secondary); cursor: pointer; font-weight: 650; }
.gt-workflow-tabs button.is-active { background: var(--gt-surface-0); color: var(--gt-accent-strong); box-shadow: var(--gt-elev-1); }
.gt-workflow-metrics { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; margin-bottom: 22px; }
.gt-workflow-metric { border-radius: 16px; padding: 18px; display: grid; gap: 5px; }
.gt-workflow-metric span { color: var(--gt-text-tertiary); font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }
.gt-workflow-metric strong { font-size: clamp(24px, 3vw, 34px); line-height: 1; }
.gt-workflow-metric small { color: var(--gt-text-tertiary); }
.gt-workflow-metric.is-positive strong { color: var(--gt-green-600); }
.gt-workflow-metric.is-warning strong { color: var(--gt-amber-600); }
.gt-workflow-card-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(275px, 1fr)); gap: 16px; }
.gt-workflow-card { border-radius: 17px; padding: 20px; color: inherit; }
button.gt-workflow-card { text-align: left; cursor: pointer; transition: border-color var(--gt-t-fast), transform var(--gt-t-fast); }
button.gt-workflow-card:hover { border-color: var(--gt-accent); transform: translateY(-1px); }
.gt-workflow-state { min-height: 180px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; text-align: center; color: var(--gt-text-tertiary); }
.gt-workflow-state > svg { width: 28px; height: 28px; }
.gt-workflow-table-wrap { width: 100%; overflow-x: auto; border: 1px solid var(--gt-border); border-radius: 15px; background: var(--gt-surface-0); }
.gt-workflow-table { width: 100%; min-width: 720px; border-collapse: collapse; }
.gt-workflow-table th, .gt-workflow-table td { padding: 13px 16px; border-bottom: 1px solid var(--gt-divider); text-align: left; }
.gt-workflow-table th { background: var(--gt-surface-2); color: var(--gt-text-tertiary); font-size: 11px; text-transform: uppercase; letter-spacing: .05em; }
.gt-workflow-timeline { display: grid; gap: 10px; }
.gt-workflow-timeline__item { display: grid; grid-template-columns: 120px 1fr auto; gap: 14px; align-items: start; padding: 14px; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-0); }
.gt-workflow-badge { display: inline-flex; align-items: center; width: fit-content; border-radius: 999px; padding: 4px 10px; background: var(--gt-accent-soft); color: var(--gt-accent-strong); font-size: 12px; font-weight: 700; }

/* Activity Report — mirrors the production TeamLio reporting hierarchy. */
.gt-activity-report-page > * { width: min(100%, 1152px); margin-inline: auto; }
.gt-activity-report-page .gt-workflow-header { margin-bottom: 16px; }
.gt-activity-report-page .gt-workflow-header__icon { width: 42px; height: 42px; border-radius: 12px; }
.gt-activity-report-page .gt-workflow-header__icon svg { width: 20px; height: 20px; }
.gt-activity-report-page .gt-workflow-header h1 { font-size: clamp(24px, 2.5vw, 32px); }
.gt-activity-report-page .gt-workflow-header p { margin-top: 4px; font-size: 13px; }
.gt-activity-report-filters { align-items: center; padding: 10px; gap: 8px; border-radius: 14px; }
.gt-activity-report-filters label > span { position: absolute; width: 1px; height: 1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
.gt-activity-report-filters .gt-workflow-tabs { align-self: stretch; }
.gt-activity-report-filters .gt-workflow-tabs button { min-width: 84px; padding: 6px 14px; text-transform: lowercase; }
.gt-activity-report-filters .gt-workflow-date-range { align-items: center; border: 1px solid var(--gt-border); border-radius: 10px; padding: 0 8px; background: var(--gt-surface-1); }
.gt-activity-report-filters .gt-workflow-date-range > svg { width: 15px; margin: 0; }
.gt-activity-report-filters input, .gt-activity-report-filters select { min-height: 36px; border: 0; background: transparent; font-size: 12px; }
.gt-activity-report-filters .gt-workflow-date-range input { width: 112px; padding-inline: 6px; }
.gt-activity-report-filters > label { flex: 0 1 210px; min-width: 0; }
.gt-activity-report-filters select { width: 100%; min-width: 0; border: 1px solid var(--gt-border); background: var(--gt-surface-1); }
.gt-activity-report-filters .gt-workflow-button { min-height: 36px; border-radius: 999px; padding-inline: 18px; }

.gt-activity-monthly { padding: 20px 22px; }
.gt-activity-monthly > h2 { display: flex; align-items: center; gap: 8px; margin: 0 0 14px; color: var(--gt-text-secondary); font-size: 13px; font-weight: 700; }
.gt-activity-monthly > h2 svg { width: 15px; height: 15px; color: var(--gt-accent); }
.gt-activity-monthly__grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.gt-activity-monthly__grid article { display: grid; justify-items: center; gap: 5px; padding: 20px 12px; border-radius: 13px; background: var(--gt-surface-2); text-align: center; }
.gt-activity-monthly__grid span { color: var(--gt-text-tertiary); font-size: 10px; text-transform: uppercase; }
.gt-activity-monthly__grid strong { font-size: clamp(22px, 2.5vw, 30px); line-height: 1; font-variant-numeric: tabular-nums; }
.gt-activity-monthly__grid small { color: var(--gt-text-tertiary); font-size: 10px; }
.gt-activity-monthly__grid .is-positive strong { color: var(--gt-green-600); }
.gt-activity-monthly__grid .is-warning strong { color: var(--gt-amber-600); }

.gt-activity-focus { padding: 18px 20px; }
.gt-activity-focus__metrics { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; }
.gt-activity-focus__metrics article { display: flex; align-items: center; gap: 10px; min-width: 0; padding: 12px; border: 1px solid var(--gt-border); border-radius: 13px; background: var(--gt-surface-1); }
.gt-activity-focus__icon { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 auto; border-radius: 10px; background: var(--gt-accent-soft); color: var(--gt-accent); }
.gt-activity-focus__icon svg { width: 17px; height: 17px; }
.gt-activity-focus__metrics article > span:last-child { display: grid; min-width: 0; gap: 2px; }
.gt-activity-focus__metrics small { color: var(--gt-text-tertiary); font-size: 9px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }
.gt-activity-focus__metrics strong { overflow: hidden; font-size: clamp(16px, 2vw, 21px); line-height: 1.05; text-overflow: ellipsis; white-space: nowrap; font-variant-numeric: tabular-nums; }
.gt-activity-focus__metrics .is-positive .gt-activity-focus__icon, .gt-activity-focus__metrics .is-positive strong { color: var(--gt-green-600); }
.gt-activity-focus__metrics .is-warning .gt-activity-focus__icon, .gt-activity-focus__metrics .is-warning strong { color: var(--gt-amber-600); }
.gt-activity-focus__legend { display: flex; align-items: center; justify-content: flex-end; gap: 14px; margin: 15px 0 7px; color: var(--gt-text-secondary); font-size: 11px; font-weight: 650; }
.gt-activity-focus__legend > span:first-child { margin-right: auto; color: var(--gt-text-tertiary); font-size: 10px; letter-spacing: .06em; text-transform: uppercase; }
.gt-activity-focus__legend i, .gt-activity-productivity__legend i { display: inline-block; width: 8px; height: 8px; margin-right: 5px; border-radius: 3px; }
.gt-activity-focus .is-active, .gt-activity-productivity .is-active { background: var(--gt-green-600); }
.gt-activity-focus .is-idle, .gt-activity-productivity .is-idle { background: var(--gt-amber-600); }
.gt-activity-focus__bar, .gt-activity-productivity__bar { display: flex; height: 9px; overflow: hidden; border-radius: 999px; background: var(--gt-surface-2); }

.gt-activity-sessions, .gt-activity-summary { display: grid; gap: 16px; }
.gt-activity-session { padding: 0; overflow: hidden; }
.gt-activity-session__header { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 15px 20px; border-bottom: 1px solid var(--gt-border); }
.gt-activity-session__avatar { display: grid; place-items: center; width: 36px; height: 36px; flex: 0 0 auto; border-radius: 11px; background: var(--gt-accent-soft); color: var(--gt-accent); }
.gt-activity-session__avatar svg { width: 17px; height: 17px; }
.gt-activity-session__identity { display: grid; gap: 2px; }
.gt-activity-session__identity strong { font-size: 14px; }
.gt-activity-session__identity small { color: var(--gt-text-tertiary); font-size: 11px; }
.gt-activity-session__chips { display: flex; flex-wrap: wrap; gap: 7px; margin-left: auto; }
.gt-activity-chip { display: grid; min-width: 66px; gap: 4px; padding: 7px 10px; border: 1px solid var(--gt-border); border-radius: 11px; background: var(--gt-surface-1); text-align: center; }
.gt-activity-chip small { color: var(--gt-text-tertiary); font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
.gt-activity-chip strong { font-size: 13px; line-height: 1; font-variant-numeric: tabular-nums; }
.gt-activity-chip.is-positive strong { color: var(--gt-green-600); }
.gt-activity-chip.is-warning strong { color: var(--gt-amber-600); }
.gt-activity-session__body { display: grid; gap: 22px; padding: 20px; }
.gt-activity-productivity { padding: 13px 15px; border: 1px solid var(--gt-border); border-radius: 13px; background: var(--gt-surface-1); }
.gt-activity-productivity > div:first-child { display: flex; flex-wrap: wrap; align-items: baseline; gap: 8px; margin-bottom: 9px; }
.gt-activity-productivity > div > span:first-child { color: var(--gt-text-tertiary); font-size: 10px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }
.gt-activity-productivity strong { color: var(--gt-green-600); font-size: 23px; line-height: 1; }
.gt-activity-productivity small { color: var(--gt-text-tertiary); font-size: 10px; }
.gt-activity-productivity__legend { display: inline-flex; align-items: center; gap: 3px; margin-left: auto; color: var(--gt-text-secondary); font-size: 10px; font-weight: 650; }
.gt-activity-productivity__legend > span { display: inline-flex; align-items: center; white-space: nowrap; }
.gt-activity-productivity__legend > span + span { margin-left: 8px; }
.gt-activity-productivity .is-productive { background: #22c55e; }
.gt-activity-productivity .is-neutral { background: #9ca3af; }
.gt-activity-productivity .is-unproductive { background: #ef4444; }
.gt-activity-ai-button { display: inline-flex; align-items: center; gap: 6px; min-height: 30px; margin-left: 10px; padding: 5px 12px; border: 0; border-radius: 999px; background: linear-gradient(135deg, #7c3aed, #a855f7); color: #fff; font: inherit; font-weight: 750; cursor: pointer; }
.gt-activity-ai-button svg { width: 13px; height: 13px; }
.gt-activity-ai-button:disabled { cursor: wait; opacity: .65; }
.gt-activity-ai-button:focus-visible, .gt-activity-application > button:focus-visible, .gt-activity-app-details button:focus-visible { outline: 2px solid #a855f7; outline-offset: 2px; }
.gt-activity-ai-panel { margin-top: 12px; overflow: hidden; border: 1px solid color-mix(in srgb, #a855f7 40%, var(--gt-border)); border-radius: 12px; background: color-mix(in srgb, #a855f7 8%, var(--gt-surface-0)); }
.gt-activity-ai-panel > header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 8px 13px; border-bottom: 1px solid color-mix(in srgb, #a855f7 30%, var(--gt-border)); background: color-mix(in srgb, #a855f7 12%, var(--gt-surface-1)); }
.gt-activity-ai-panel > header > span, .gt-activity-ai-panel button, .gt-activity-ai-panel p { display: flex; align-items: center; gap: 6px; }
.gt-activity-ai-panel svg { width: 13px; height: 13px; }
.gt-activity-ai-panel header small { padding: 2px 7px; border-radius: 999px; background: color-mix(in srgb, #a855f7 18%, transparent); color: #a855f7; }
.gt-activity-ai-panel button { border: 0; background: transparent; color: var(--gt-text-secondary); font: inherit; cursor: pointer; }
.gt-activity-ai-panel > div { padding: 12px 14px; }
.gt-activity-ai-panel p { margin: 0; line-height: 1.55; white-space: pre-wrap; }
.gt-activity-ai-panel p.is-error { color: var(--gt-dnd); }

.gt-activity-breakdown > h3 { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin: 0 0 10px; color: var(--gt-text-secondary); font-size: 12px; font-weight: 700; }
.gt-activity-breakdown > h3 > span, .gt-activity-breakdown > h3 small { display: inline-flex; align-items: center; gap: 7px; }
.gt-activity-breakdown > h3 svg { width: 14px; height: 14px; }
.gt-activity-breakdown > h3 small { padding: 4px 9px; border-radius: 999px; background: var(--gt-accent-soft); color: var(--gt-accent); font-size: 10px; }
.gt-activity-breakdown__rows { overflow: hidden; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-1); }
.gt-activity-breakdown__rows article { display: grid; grid-template-columns: minmax(150px, 1fr) minmax(80px, 160px) 64px 70px; align-items: center; gap: 10px; padding: 9px 12px; border-bottom: 1px solid var(--gt-divider); }
.gt-activity-breakdown__rows article:last-child { border-bottom: 0; }
.gt-activity-breakdown__copy { display: grid; min-width: 0; gap: 2px; }
.gt-activity-breakdown__copy strong { overflow: hidden; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.gt-activity-breakdown__copy small { overflow: hidden; color: var(--gt-text-tertiary); font-size: 9px; text-overflow: ellipsis; white-space: nowrap; }
.gt-activity-breakdown__progress { height: 6px; overflow: hidden; border-radius: 999px; background: var(--gt-border); }
.gt-activity-breakdown__progress i { display: block; height: 100%; border-radius: inherit; background: var(--gt-accent); }
.gt-activity-breakdown__rows article > span:nth-last-child(2) { color: var(--gt-accent); font-size: 10px; font-weight: 700; text-align: right; }
.gt-activity-breakdown__rows time { color: var(--gt-text-tertiary); font-family: var(--gt-font-mono); font-size: 9px; text-align: right; }
.gt-activity-session__empty { padding: 20px; color: var(--gt-text-tertiary); text-align: center; }

.gt-activity-application-rows { overflow: hidden; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-1); }
.gt-activity-application + .gt-activity-application { border-top: 1px solid var(--gt-divider); }
.gt-activity-application > button { display: grid; grid-template-columns: minmax(130px, 1fr) minmax(90px, 2fr) auto auto 28px 18px; align-items: center; gap: 10px; width: 100%; padding: 10px 12px; border: 0; background: transparent; color: var(--gt-text-primary); text-align: left; cursor: pointer; }
.gt-activity-application > button:hover, .gt-activity-application.is-expanded > button { background: var(--gt-accent-soft); }
.gt-activity-application__duration { padding: 3px 8px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 10px; font-weight: 700; white-space: nowrap; }
.gt-activity-category { padding: 3px 8px; border-radius: 999px; font-size: 9px; font-weight: 750; }
.gt-activity-category.is-productive { background: color-mix(in srgb, #22c55e 16%, transparent); color: #22c55e; }
.gt-activity-category.is-neutral { background: color-mix(in srgb, #9ca3af 18%, transparent); color: var(--gt-text-secondary); }
.gt-activity-category.is-unproductive { background: color-mix(in srgb, #ef4444 16%, transparent); color: #ef4444; }
.gt-activity-application__count { display: grid; place-items: center; min-width: 25px; height: 25px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-tertiary); font-size: 9px; }
.gt-activity-application__chevron { width: 14px; height: 14px; color: var(--gt-text-tertiary); transition: transform var(--gt-t-fast); }
.gt-activity-application.is-expanded .gt-activity-application__chevron { transform: rotate(180deg); }
.gt-activity-app-details { margin: 0 10px 10px; overflow: hidden; border: 1px solid var(--gt-border-strong); border-radius: 12px; background: var(--gt-surface-0); }
.gt-activity-app-details > header { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-bottom: 1px solid var(--gt-border); background: var(--gt-accent-soft); }
.gt-activity-app-details > header > span { padding: 2px 8px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 9px; }
.gt-activity-app-details > header button { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; border: 0; background: transparent; color: var(--gt-text-secondary); font: inherit; cursor: pointer; }
.gt-activity-app-details > header svg { width: 13px; height: 13px; }
.gt-activity-app-details__stats { display: flex; flex-wrap: wrap; gap: 24px; padding: 12px 16px; border-bottom: 1px solid var(--gt-border); }
.gt-activity-app-details__stats > span { display: grid; gap: 3px; }
.gt-activity-app-details__stats small { color: var(--gt-text-tertiary); font-size: 9px; text-transform: uppercase; }
.gt-activity-app-details__stats strong { font-size: 18px; }
.gt-activity-app-details__events { max-height: 460px; overflow-y: auto; }
.gt-activity-app-details__events article { display: grid; grid-template-columns: 86px 64px minmax(0, 1fr) 48px; align-items: start; gap: 10px; padding: 10px 16px; border-bottom: 1px solid var(--gt-divider); }
.gt-activity-app-details__events article:last-child { border-bottom: 0; }
.gt-activity-app-details__events time { color: var(--gt-text-tertiary); font-family: var(--gt-font-mono); font-size: 10px; }
.gt-activity-event-state { color: var(--gt-green-600); font-size: 10px; text-transform: capitalize; }
.gt-activity-app-details__events article > span:nth-child(3) { display: grid; min-width: 0; gap: 2px; }
.gt-activity-app-details__events article strong { overflow: hidden; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.gt-activity-app-details__events article small { color: var(--gt-text-tertiary); font-size: 9px; }
.gt-activity-app-details__events article em { overflow: hidden; color: var(--gt-accent); font-size: 9px; font-style: normal; text-overflow: ellipsis; white-space: nowrap; }
.gt-activity-app-details__events article b { font-size: 10px; text-align: right; }
.gt-activity-app-details__events > p { margin: 0; padding: 22px; color: var(--gt-text-tertiary); text-align: center; }

.gt-activity-summary__header { display: flex; align-items: center; gap: 12px; padding: 15px 20px; border-bottom: 1px solid var(--gt-border); }
.gt-activity-summary__header > span:nth-child(2) { display: grid; gap: 2px; }
.gt-activity-summary__header > span:nth-child(2) small { color: var(--gt-text-tertiary); font-size: 10px; }
.gt-activity-summary__header > span:last-child { margin-left: auto; padding: 4px 9px; border-radius: 999px; background: var(--gt-accent-soft); color: var(--gt-accent); font-size: 10px; font-weight: 700; }
.gt-activity-summary__totals { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; padding: 18px 20px 0; }
.gt-activity-summary__totals .gt-activity-chip { padding: 13px; }
.gt-activity-summary__totals .gt-activity-chip strong { font-size: 17px; }
.gt-activity-summary__sessions { padding: 18px 20px 20px; }
.gt-activity-summary__sessions h3 { margin: 0 0 9px; color: var(--gt-text-tertiary); font-size: 10px; letter-spacing: .06em; text-transform: uppercase; }
.gt-activity-summary__sessions article { display: grid; grid-template-columns: minmax(150px, 1fr) auto auto auto; align-items: center; gap: 16px; padding: 10px 12px; border-radius: 10px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 11px; }
.gt-activity-summary__sessions article + article { margin-top: 7px; }
.gt-activity-summary__sessions article > span { display: inline-flex; align-items: center; gap: 6px; }
.gt-activity-summary__sessions article svg { width: 12px; height: 12px; color: var(--gt-text-tertiary); }
.gt-activity-summary__sessions article i { color: var(--gt-text-tertiary); }
.gt-activity-summary__sessions article strong { color: var(--gt-green-600); }
.gt-activity-summary__sessions article small { color: var(--gt-amber-600); }

@media (max-width: 900px) {
  .gt-workflow-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .gt-activity-focus__metrics { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .gt-activity-session__chips { width: 100%; margin-left: 48px; }
}
@media (max-width: 767px) {
  .gt-workflow-page { padding: 16px 14px 92px; }
  .gt-workflow-header { align-items: flex-start; flex-direction: column; }
  .gt-workflow-header__actions, .gt-workflow-filters, .gt-workflow-date-range { width: 100%; }
  .gt-workflow-filters > *, .gt-workflow-date-range label { flex: 1 1 100%; width: 100%; }
  .gt-workflow-date-range { flex-wrap: wrap; }
  .gt-workflow-date-range > svg { display: none; }
  .gt-workflow-metrics { grid-template-columns: 1fr 1fr; gap: 10px; }
  .gt-workflow-timeline__item { grid-template-columns: 1fr; }
  .gt-activity-report-page .gt-workflow-header { flex-direction: row; }
  .gt-activity-report-filters > *, .gt-activity-report-filters .gt-workflow-date-range { width: 100%; }
  .gt-activity-report-filters .gt-workflow-tabs button { flex: 1 1; }
  .gt-activity-monthly__grid, .gt-activity-summary__totals { grid-template-columns: 1fr 1fr; }
  .gt-activity-focus__metrics { grid-template-columns: 1fr 1fr; }
  .gt-activity-focus__metrics article:last-child { grid-column: 1 / -1; }
  .gt-activity-session__chips { margin-left: 0; }
  .gt-activity-productivity__legend { width: 100%; margin-left: 0; }
  .gt-activity-ai-button { margin-left: 0; }
  .gt-activity-breakdown__rows article { grid-template-columns: minmax(0, 1fr) auto; }
  .gt-activity-breakdown__progress { grid-column: 1 / -1; grid-row: 2; }
  .gt-activity-breakdown__rows time { display: none; }
  .gt-activity-summary__sessions article { grid-template-columns: 1fr auto; gap: 7px 12px; }
  .gt-activity-application > button { grid-template-columns: minmax(0, 1fr) auto auto 18px; }
  .gt-activity-application > button .gt-activity-breakdown__progress { grid-column: 1 / -1; grid-row: 2; }
  .gt-activity-application__count { display: none; }
  .gt-activity-app-details__events article { grid-template-columns: 70px minmax(0, 1fr) auto; }
  .gt-activity-app-details__events .gt-activity-event-state { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .gt-workflow-button, button.gt-workflow-card { transition: none; }
  button.gt-workflow-card:hover { transform: none; }
}

/* ── Hidden desktop window ──────────────────────────────────────────────────
   Electron runs this window with backgroundThrottling off (presence heartbeats
   must keep their timing), which also keeps the Page Visibility API reporting
   "visible" while the window sits in the tray. CSS animations would therefore
   keep the render pipeline busy at 60 fps for nobody. utils/windowVisibility
   stamps <html data-window-hidden> from the main process's authoritative
   visibility signal; everything decorative freezes until the window is back. */
html[data-window-hidden] *:not([data-state]),
html[data-window-hidden] *:not([data-state])::before,
html[data-window-hidden] *:not([data-state])::after {
  animation-play-state: paused !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global-theme.css"],"names":[],"mappings":"AAAA;;;;;;6EAM6E;;AAI7E;;;;;;;;;;;;;;;;;;;;;;;;;;iFA0BiF;;AAEjF;;EAEE,6EAA6E;;EAE7E,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;EAC1B,+BAA+B;;EAE/B,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;;EAE3B,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;;EAEvB,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;;EAErB,aAAa;EACb,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,iBAAiB;EACjB,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;;EAEjC,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,gDAAgD;EAChD,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;EAC7C,8CAA8C;EAC9C,8CAA8C;;EAE9C,cAAc;EACd,6CAA6C;EAC7C,+EAA+E;EAC/E,qFAAqF;EACrF,wFAAwF;EACxF,wFAAwF;EACxF,iDAAiD;EACjD,qDAAqD;;EAErD,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,eAAe;EACf,0EAA0E;EAC1E,sEAAsE;EACtE,8DAA8D;EAC9D,gFAAgF;EAChF,6BAA6B;EAC7B,2BAA2B;;EAE3B,gBAAgB;EAChB,iDAAiD;EACjD,iDAAiD;EACjD,+CAA+C;;EAE/C,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;;EAE9B,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;;EAGpB,6EAA6E;;EAE7E,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,+BAA+B;;EAE/B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;;EAE9B,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;;EAE3B,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;;EAE/B,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;;EAElB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;;EAE/B,cAAc;EACd,iBAAiB;EACjB,+EAA+E;EAC/E,+EAA+E;EAC/E,gFAAgF;EAChF,kFAAkF;EAClF,mFAAmF;;EAEnF,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;;EAEtB,mCAAmC;EACnC,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;;EAEtB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,eAAe;EACf,oEAAoE;EACpE,sEAAsE;EACtE,8DAA8D;EAC9D,gFAAgF;EAChF,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;;EAE3B,gBAAgB;EAChB,0DAA0D;EAC1D,yDAAyD;EACzD,wDAAwD;;EAExD,gEAAgE;EAChE,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;AAClC;;;AAGA;;iFAEiF;AACjF;EACE,kBAAkB;;EAElB,sEAAsE;EACtE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,+BAA+B;;EAE/B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;;EAE3B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;;EAEvB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;;EAEjC;;yDAEuD;EACvD,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,0CAA0C;EAC1C,yEAAyE;EACzE,+EAA+E;EAC/E,kFAAkF;EAClF,kFAAkF;EAClF,oDAAoD;EACpD,wDAAwD;;EAExD,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,oEAAoE;EACpE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,+BAA+B;;EAE/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;;EAE/B,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;;EAE9B,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;;EAE/B,2CAA2C;EAC3C,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;AAClC;;;AAGA;;;iFAGiF;AACjF;EACE,kBAAkB;;EAElB,6EAA6E;;EAE7E;6EAC2E;EAC3E,uBAAuB,IAAI,+CAA+C;EAC1E,uBAAuB,IAAI,oBAAoB;EAC/C,uBAAuB,IAAI,iCAAiC;EAC5D,uBAAuB,IAAI,wBAAwB;EACnD,6CAA6C;EAC7C,0BAA0B;EAC1B,+BAA+B;;EAE/B,kDAAkD;EAClD,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,8CAA8C;EAC9C,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;;EAE3B,yDAAyD;EACzD,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;;EAEvB,qCAAqC;EACrC,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;;EAErB,sDAAsD;EACtD,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;;EAEjC,+DAA+D;EAC/D,gDAAgD;EAChD,8EAA8E;EAC9E,+EAA+E;EAC/E,gFAAgF;EAChF,gFAAgF;EAChF,6CAA6C;EAC7C,mDAAmD;;EAEnD,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;;EAE9B,kCAAkC;EAClC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;;EAGpB,6EAA6E;;EAE7E,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,+BAA+B;;EAE/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;;EAE/B,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;;EAErB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;;EAExB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;;EAE9B,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;;EAE3B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;;EAElB,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;;EAE/B,iBAAiB;EACjB,gDAAgD;EAChD,8EAA8E;EAC9E,+EAA+E;EAC/E,gFAAgF;EAChF,gFAAgF;;EAEhF,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;;;iFAIiF;AACjF,2CAA2C,wCAAwC,EAAE;AACrF,4CAA4C,yCAAyC,EAAE,uCAAuC,EAAE;AAChI,4CAA4C,gDAAgD,EAAE;;AAE9F,4DAA4D;AAC5D,4CAA4C,yBAAyB,EAAE;AACvE,oEAAoE;AACpE,8CAA8C,gCAAgC,EAAE;;AAEhF,kEAAkE;AAClE;kDACkD,yCAAyC,EAAE;;AAE7F,sDAAsD;AACtD,4CAA4C,kCAAkC,EAAE;;AAEhF,uDAAuD;AACvD;EACE,kDAAkD;EAClD,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;oEACoE;AACpE;;;;;;EAME,0CAA0C;EAC1C,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;;;;;;EAME,0CAA0C;EAC1C,+CAA+C;EAC/C,8BAA8B;AAChC;AACA,kCAAkC,yCAAyC,EAAE,qBAAqB,EAAE;;AAEpG,2CAA2C;AAC3C,4BAA4B,6CAA6C,EAAE;AAC3E;EACE,wCAAwC;EACxC,sCAAsC;EACtC,0CAA0C;AAC5C;AACA,qCAAqC,kCAAkC,EAAE,wCAAwC,EAAE;AACnH,kCAAkC,8CAA8C,EAAE;AAClF,6CAA6C,8CAA8C,EAAE;AAC7F;;EAEE,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;;;;;;;EAOE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA,8DAA8D;AAC9D;EACE,kDAAkD;EAClD,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA,iDAAiD;AACjD;;;;EAIE,6CAA6C;AAC/C;;;AAGA;;iFAEiF;AACjF;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;;AAGA;;iFAEiF;AACjF;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;;AAGA;;;;;iFAKiF;AACjF;gCACgC,gDAAgD,EAAE;;AAElF;;;;;;;;;;;;;;;sCAesC,gDAAgD,EAAE;;AAExF;;;;;;;;;;;kCAWkC,wCAAwC,EAAE;;AAE5E;;;;;;;;;qCASqC,0CAA0C,EAAE;;AAEjF;;;;;;;;;qCASqC,yCAAyC,EAAE;;AAEhF;;;;;;;;;;uCAUuC,yCAAyC,EAAE;;AAElF;;gDAEgD,0CAA0C,EAAE;;AAE5F,oEAAoE;AACpE;;;;;gDAKgD,oDAAoD,EAAE;;AAEtG;;oDAEoD;AACpD;;;;;;;;;gCASgC,gDAAgD,EAAE,wCAAwC,EAAE;;AAE5H,6FAA6F;AAC7F;;;;;;;mCAOmC,yBAAyB,EAAE;;AAE9D;;;mCAGmC,yBAAyB,EAAE;;AAE9D;;;qCAGqC,yBAAyB,EAAE;;AAEhE;;;;;qCAKqC,yBAAyB,EAAE;;AAEhE,8EAA8E;AAC9E;;;sCAGsC,yBAAyB,EAAE;AACjE;oCACoC,yBAAyB,EAAE;AAC/D;qCACqC,yBAAyB,EAAE;AAChE;;;uCAGuC,yBAAyB,EAAE;;;AAGlE;;;;;;;;iFAQiF;;AAEjF,8EAA8E;AAC9E;;;EAGE,kDAAkD;EAClD,kDAAkD;AACpD;AACA,2CAA2C,8CAA8C,EAAE;AAC3F;;2CAE2C,yBAAyB,EAAE;;AAEtE;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;AACA,2CAA2C,gCAAgC,EAAE;AAC7E;;2CAE2C,yBAAyB,EAAE;;AAEtE,8EAA8E;AAC9E;EACE,mDAAmD;EACnD,mDAAmD;AACrD;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE,6EAA6E;AAC7E;;;EAGE,kDAAkD;EAClD,kDAAkD;AACpD;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE,+EAA+E;AAC/E;;;EAGE,mDAAmD;EACnD,mDAAmD;AACrD;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE,6EAA6E;AAC7E;;EAEE,gDAAgD;EAChD,6CAA6C;AAC/C;AACA;2CAC2C,yCAAyC,EAAE;;AAEtF;;EAEE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;2CAC2C,yBAAyB,EAAE;;AAEtE;4EAC4E;AAC5E;;;;;;;;;oDASoD,gDAAgD,EAAE;;AAEtG,yEAAyE;AACzE;;;2CAG2C,wCAAwC,EAAE;;AAErF;;;;;;;iFAOiF;;AAEjF,mDAAmD;AACnD,gCAAgC,+BAA+B,EAAE;;AAEjE;;iFAEiF;AACjF,oCAAoC,0CAA0C,EAAE;AAChF;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA,qCAAqC,gBAAgB,EAAE;;AAEvD;;sCAEsC;AACtC;EACE,uFAAuF;EACvF,cAAc;AAChB;;AAEA;;sCAEsC;AACtC,sCAAsC,+BAA+B,EAAE;AACvE,sCAAsC,+BAA+B,EAAE;AACvE,6CAA6C,+BAA+B,EAAE;;AAE9E,8EAA8E;;AAE9E;6EAC6E;AAC7E,sEAAsE,uBAAuB,EAAE;AAC/F,4EAA4E,8BAA8B,EAAE;;AAE5G;6CAC6C;AAC7C;0CAC0C,0CAA0C,EAAE;AACtF;oDACoD,kCAAkC,EAAE;;AAExF;mDACmD;AACnD,yDAAyD,cAAc,EAAE;AACzE,yDAAyD,cAAc,EAAE;AACzE,yDAAyD,cAAc,EAAE;AACzE,2DAA2D,cAAc,EAAE;AAC3E,2DAA2D,cAAc,EAAE;AAC3E,2DAA2D,cAAc,EAAE;;AAE3E;2EAC2E;AAC3E;;;;uCAIuC,gDAAgD,EAAE;;AAEzF;;8EAE8E;AAC9E,yDAAyD,yBAAyB,EAAE;AACpF,yDAAyD,yBAAyB,EAAE;AACpF,yDAAyD,yBAAyB,EAAE;AACpF,yDAAyD,yBAAyB,EAAE;;AAEpF;0EAC0E;AAC1E;;;;EAIE,0CAA0C;EAC1C,iCAAiC;AACnC;AACA,wCAAwC,yCAAyC,EAAE;;AAEnF,2EAA2E;AAC3E;;;EAGE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;yEAGyE;AACzE;;;EAGE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA,yCAAyC,+BAA+B,EAAE;AAC1E;gDACgD,8BAA8B,EAAE;AAChF,yCAAyC,4BAA4B,EAAE;;AAEvE,oEAAoE;AACpE;4CAC4C,+BAA+B,EAAE;AAC7E;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;AACA,0CAA0C,+BAA+B,EAAE;;AAE3E,qDAAqD;AACrD;EACE,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA,oEAAoE;AACpE,sDAAsD,mBAAmB,EAAE,cAAc,EAAE;AAC3F,sDAAsD,uCAAuC,EAAE,kCAAkC,EAAE;AACnI,6CAA6C,+BAA+B,EAAE;AAC9E,6CAA6C,mBAAmB,EAAE;AAClE,6CAA6C,mBAAmB,EAAE;;AAElE;;;gFAGgF;AAChF,iCAAiC,qCAAqC,EAAE;AACxE,8DAA8D,qCAAqC,EAAE;AACrG,iDAAiD,+BAA+B,EAAE;AAClF,8EAA8E,+BAA+B,EAAE;;AAE/G;;;;2DAI2D;AAC3D;;kCAEkC,wDAAwD,EAAE;AAC5F;;;oCAGoC,6CAA6C,EAAE;AACnF;sCACsC,gCAAgC,EAAE;AACxE;oCACoC,oCAAoC,EAAE;AAC1E;;;;uCAIuC,yBAAyB,EAAE;AAClE;wCACwC,gCAAgC,EAAE;;AAE1E,4EAA4E;AAC5E;EACE,sCAAsC;AACxC;AACA,OAAO,6BAA6B,EAAE;AACtC;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,6DAA6D;EAC7D,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;AACA,4EAA4E;AAC5E,yBAAyB,oBAAoB,EAAE;AAC/C,SAAS,2BAA2B,EAAE;AACtC;;EAEE,4CAA4C;AAC9C;AACA;qCACqC,2CAA2C,EAAE;;AAElF,kEAAkE;AAClE;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;AACA,IAAI,+BAA+B,EAAE,iBAAiB,EAAE;AACxD;EACE,iCAAiC;EACjC,kBAAkB;AACpB;AACA,uBAAuB,gCAAgC,EAAE;AACzD,KAAK,YAAY,EAAE,uCAAuC,EAAE;;AAE5D,cAAc;AACd,cAAc,uCAAuC,EAAE,6BAA6B,EAAE;;AAEtF;;6EAE6E;AAC7E;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;6EAI6E;AAC7E;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,aAAa;AACb,uBAAuB,gDAAgD,EAAE;AACzE,yBAAyB,gDAAgD,EAAE;AAC3E,0BAA0B,gDAAgD,EAAE;AAC5E,0BAA0B,gDAAgD,EAAE;;AAE5E,YAAY;AACZ,8BAA8B,0CAA0C,EAAE;AAC1E,8BAA8B,yCAAyC,EAAE;AACzE,8BAA8B,gDAAgD,EAAE;;AAEhF,SAAS;AACT,4BAA4B,yCAAyC,EAAE;AACvE,4BAA4B,yCAAyC,EAAE;AACvE;4BAC4B,0CAA0C,EAAE;AACxE;4BAC4B,wCAAwC,EAAE;;AAEtE,qCAAqC;AACrC;;;2DAG2D,mCAAmC,EAAE;;AAEhG,uGAAuG,gDAAgD,EAAE;AACzJ,2GAA2G,wDAAwD,EAAE,wCAAwC,EAAE;AAC/M;;;uDAGuD,8CAA8C,EAAE,yBAAyB,EAAE;AAClI,2GAA2G,oDAAoD,EAAE;;AAEjK,4FAA4F,yCAAyC,EAAE;AACvI;4FAC4F,0CAA0C,EAAE;;AAExI;;;yCAGyC,6CAA6C,EAAE,uDAAuD,EAAE;AACjJ;6CAC6C,0CAA0C,EAAE;;AAEzF,oHAAoH,gDAAgD,EAAE;AACtK,uHAAuH,wDAAwD,EAAE;AACjL,6HAA6H,mCAAmC,EAAE;;AAElK;+EAC+E;AAC/E;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0CE,wCAAwC;EACxC,iCAAiC;EACjC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;mDAEmD;AACnD;;;;;;;;;;;;;EAaE,kCAAkC;EAClC,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;iDACiD;AACjD;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;EAQE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;;;;;;EAME,mCAAmC;EACnC,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;;;EAGE,yCAAyC;AAC3C;AACA,qEAAqE;AACrE;;;;EAIE,0CAA0C;EAC1C,6CAA6C;EAC7C,wCAAwC;EACxC,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;;;;;;;;EAQE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAE3B,mCAAmC;EACnC,qDAAqD;EACrD,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;;mDAEmD,8CAA8C,EAAE,yBAAyB,EAAE;AAC9H;;uDAEuD,mCAAmC,EAAE;AAC5F,6EAA6E,gDAAgD,EAAE;AAC/H,gFAAgF,wDAAwD,EAAE;AAC1I,oHAAoH,wCAAwC,EAAE;;AAE9J,sBAAsB;AACtB;;;;;;;;;;;EAWE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,mGAAmG;AACrG;AACA;;;EAGE,0CAA0C;EAC1C,aAAa;EACb,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,mCAAmC,EAAE,qBAAqB,EAAE,6BAA6B,EAAE,4BAA4B,EAAE;AACjK,8CAA8C,6BAA6B,EAAE,4BAA4B,EAAE;AAC3G,aAAa,oDAAoD,EAAE,qBAAqB,EAAE;;AAE1F;;;6EAG6E;;AAE7E,qEAAqE;AACrE;;;;;;;gBAOgB,2BAA2B,EAAE;;AAE7C;;EAEE,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;AACA,gBAAgB,kDAAkD,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACjI,gBAAgB,iBAAiB,GAAG,gBAAgB,EAAE;AACtD,gBAAgB,kBAAkB,EAAE,iBAAiB,EAAE;AACvD,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE;AACtD;;;;;;2EAM2E;AAC3E;;;;;;;;;;;;;;EAcE,4CAA4C;EAC5C,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,yDAAyD;AACzD;;;;EAIE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;;;;;EAKE,4CAA4C;EAC5C,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,kCAAkC,gBAAgB,EAAE,6BAA6B,EAAE;AACnF,kCAAkC,gCAAgC,EAAE;;AAEpE,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA,wDAAwD,8BAA8B,EAAE;;AAExF;mEACmE;AACnE;;;;;;;;EAQE,0CAA0C;EAC1C,6CAA6C;EAC7C,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,4DAA4D;AAC5D;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,+DAA+D;AACjE;;AAEA,wEAAwE;AACxE,6BAA6B,gDAAgD,EAAE,wCAAwC,EAAE;AACzH,6BAA6B,gDAAgD,EAAE,wCAAwC,EAAE;AACzH,6BAA6B,gDAAgD,EAAE;AAC/E,6BAA6B,wDAAwD,EAAE,wCAAwC,EAAE;AACjI,6BAA6B,gDAAgD,EAAE;AAC/E,6BAA6B,8CAA8C,EAAE,sCAAsC,EAAE;AACrH,6BAA6B,0CAA0C,EAAE,yBAAyB,EAAE;AACpG,6BAA6B,gDAAgD,EAAE;AAC/E,6BAA6B,mDAAmD,EAAE;;AAElF,iCAAiC,mCAAmC,EAAE;AACtE,sCAAsC,sCAAsC,EAAE;AAC9E,sCAAsC,yCAAyC,EAAE;AACjF,sCAAsC,wCAAwC,EAAE;AAChF,sCAAsC,wCAAwC,EAAE;AAChF,sCAAsC,wCAAwC,EAAE;AAChF,wCAAwC,wCAAwC,EAAE;AAClF,sCAAsC,wCAAwC,EAAE;AAChF,sCAAsC,+BAA+B,EAAE;;AAEvE,4BAA4B,yCAAyC,EAAE;AACvE,4BAA4B,yCAAyC,EAAE;AACvE,6BAA6B,0CAA0C,EAAE;;AAEzE,oDAAoD;AACpD;qCACqC,6CAA6C,EAAE;;AAEpF,mCAAmC;AACnC,mBAAmB,2BAA2B,EAAE,6BAA6B,EAAE;;AAE/E;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,mDAAmD;AACrD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA,sBAAsB,0CAA0C,EAAE;AAClE,4BAA4B,mCAAmC,EAAE;;AAEjE,6EAA6E;AAC7E;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;;;;2EAK2E;;AAE3E,oDAAoD;AACpD;;;;EAIE,6CAA6C;EAC7C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,0EAA0E;AAC1E;;;;;;;;;EASE,0CAA0C;EAC1C,wCAAwC;EACxC,6CAA6C;EAC7C,gDAAgD;EAChD,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;;;;EAIE,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;mCACmC,+BAA+B,EAAE;;AAEpE,+CAA+C;AAC/C;;;EAGE,0CAA0C;AAC5C;;AAEA,sEAAsE;AACtE;;EAEE,wCAAwC;EACxC,sCAAsC;EACtC,wCAAwC;EACxC,+CAA+C;EAC/C,4BAA4B;EAC5B,8CAA8C;EAC9C,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,8CAA8C;AAChD;;AAEA,8DAA8D;AAC9D;;EAEE,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,0EAA0E;AAC5E;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA,sEAAsE;AACtE;;;EAGE,0CAA0C;EAC1C,6CAA6C;EAC7C,wCAAwC;EACxC,gDAAgD;EAChD,sCAAsC;EACtC,iFAAiF;AACnF;AACA;;;EAGE,0CAA0C;EAC1C,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;;;2EAG2E;;AAE3E,wEAAwE;AACxE;;;;;;;EAOE,gDAAgD;EAChD,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,wEAAwE;AACxE;;;;;EAKE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;;0BAE0B,wDAAwD,EAAE,wCAAwC,EAAE;AAC9H,2BAA2B,qDAAqD,EAAE,0CAA0C,EAAE;AAC9H;;4BAE4B,mDAAmD,EAAE,wCAAwC,EAAE;;AAE3H,sBAAsB;AACtB;;8BAE8B,8CAA8C,EAAE;AAC9E,gCAAgC,gDAAgD,EAAE;AAClF;;gCAEgC,gDAAgD,EAAE;;AAElF,yBAAyB;AACzB;;yBAEyB,gDAAgD,EAAE;AAC3E,2BAA2B,qDAAqD,EAAE;AAClF;;2BAE2B,kDAAkD,EAAE;;AAE/E,mBAAmB;AACnB;8BAC8B,0CAA0C,EAAE;AAC1E;;;8BAG8B,wCAAwC,EAAE;;AAExE;mEACmE;AACnE;;;;;;;;;EASE,0CAA0C;EAC1C,iCAAiC;EACjC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;;;;2DAI2D;AAC3D;;;;EAIE,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;qEAGqE;AACrE;;;;;EAKE,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;qDAEqD;AACrD;;EAEE,2BAA2B;EAC3B,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;;;;EAIE,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;8DAE8D;AAC9D;;;EAGE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;;2EAG2E;AAC3E;;;;;;;;;;;EAWE,kCAAkC;EAClC,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;iDACiD;AACjD;;;EAGE,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;EAC3B,8CAA8C;EAC9C,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;;;;;;EAME,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;EAEE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;;EAEE,yCAAyC;EACzC,sCAAsC;AACxC;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;kDACkD;AAClD;;;EAGE,0CAA0C;EAC1C,6CAA6C;EAC7C,+CAA+C;EAC/C,wCAAwC;EACxC,gCAAgC;EAChC,wCAAwC;EACxC,uCAAuC;AACzC;AACA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;0EAG0E;AAC1E;;;;;;;EAOE,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,0DAA0D;EAC1D,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;;;;;;;;EAQE,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;;0EAE0E;AAC1E;;;EAGE,wCAAwC;AAC1C;AACA;;;;;;;;;;EAUE,yCAAyC;AAC3C;;AAEA,+EAA+E;AAC/E;;EAEE,mCAAmC;AACrC;;AAEA,uDAAuD;AACvD;;2CAE2C,0CAA0C,EAAE,2CAA2C,EAAE;;AAEpI,sCAAsC;AACtC;EACE,uCAAuC;AACzC;;AAEA;qDACqD;AACrD;;;;;;;;;;;;;EAaE,0CAA0C;EAC1C,iCAAiC;EACjC,6CAA6C;EAC7C,uCAAuC;EACvC,+CAA+C;EAC/C,0GAA0G;AAC5G;AACA;;;;EAIE,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;;;2EAG2E;;AAE3E,kDAAkD;AAClD;;;;;;EAME;;;;;;4BAM0B;AAC5B;;AAEA,wCAAwC;AACxC;;EAEE,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;;EAEE,+DAA+D;AACjE;;AAEA,yCAAyC;AACzC;;;EAGE,uCAAuC;AACzC;;AAEA,wCAAwC;AACxC;;;;;;EAME,2DAA2D;AAC7D;;AAEA,4BAA4B;AAC5B;;EAEE,qDAAqD;EACrD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,8DAA8D;AAChE;;AAEA,iEAAiE;AACjE;;;EAGE,0CAA0C;EAC1C,wCAAwC;EACxC,6CAA6C;EAC7C,+CAA+C;EAC/C,uCAAuC;EACvC,sCAAsC;AACxC;AACA;;2EAE2E;AAC3E;EACE,wCAAwC;EACxC,+CAA+C;EAC/C,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,8CAA8C;AAChD;;AAEA,iEAAiE;AACjE,iEAAiE;AACjE,iEAAiE;AACjE,iEAAiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;;2EAI2E;AAC3E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,oBAAoB,aAAa,EAAE;AACnC,gBAAgB,kBAAkB,EAAE,UAAU,EAAE;;AAEhD,yEAAyE;AACzE;EACE,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;AACvC;AACA,eAAe,yCAAyC,EAAE;;AAE1D,wCAAwC;AACxC;EACE,qBAAqB;EACrB,UAAU,EAAE,WAAW;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,6BAA6B;EAC7B,gDAAgD;AAClD;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAEhB,wBAAwB;EACxB,qCAAqC;EACrC,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,6BAA6B,EAAE;AAC5C;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B;;;;+BAI6B;AAC/B;AACA,mBAAmB,aAAa,EAAE;AAClC,eAAe,kBAAkB,EAAE;AACnC;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,+BAA+B;AACjC;AACA,mBAAmB,gBAAgB,EAAE;AACrC,qBAAqB,4BAA4B,EAAE;AACnD,uBAAuB,4BAA4B,EAAE;;AAErD,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,mGAAmG;EACnG,gBAAgB;AAClB;AACA,qBAAqB,aAAa,EAAE;AACpC,iBAAiB,kBAAkB,EAAE;AACrC;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,8DAA8D;AAChE;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,6BAA6B;EAC7B,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,uCAAuC,aAAa,EAAE;AACtD;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B;;;8BAG4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mFAAmF;AACnF;EACE,+BAA+B;EAC/B;;;qDAGmD;EACnD,sBAAsB;AACxB;AACA;EACE,wCAAwC;EACxC,wHAAwH;EACxH,UAAU;AACZ;AACA,wBAAwB,aAAa,EAAE;AACvC,oBAAoB,kBAAkB,EAAE;AACxC;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;AACA;EACE,uCAAuC;AACzC;AACA,6BAA6B,aAAa,EAAE;AAC5C,yBAAyB,qCAAqC,EAAE;AAChE,yBAAyB,mCAAmC,EAAE;AAC9D,yBAAyB,kCAAkC,EAAE;AAC7D,yBAAyB,kCAAkC,EAAE;;AAE7D,gEAAgE;AAChE;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,gDAAgD;EAChD,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,6CAA6C;EAC7C,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,6CAA6C;EAC7C,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF;;;;;;EAME,6CAA6C;EAC7C,kDAAkD;EAClD,0CAA0C;EAC1C,uCAAuC;AACzC;AACA,0CAA0C,uDAAuD,EAAE;AACnG,0CAA0C,qDAAqD,EAAE;AACjG,0CAA0C,oDAAoD,EAAE;AAChG,0CAA0C,oDAAoD,EAAE;AAChG,0CAA0C,+CAA+C,EAAE;AAC3F;EACE,gDAAgD;EAChD,uCAAuC;AACzC;AACA,gDAAgD,uDAAuD,EAAE;AACzG,gDAAgD,qDAAqD,EAAE;AACvG,gDAAgD,oDAAoD,EAAE;AACtG,gDAAgD,oDAAoD,EAAE;AACtG,gDAAgD,+CAA+C,EAAE;;AAEjG,yCAAyC;AACzC;EACE,kDAAkD;EAClD,kDAAkD;EAClD,mDAAmD;EACnD,uCAAuC;AACzC;AACA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;AACpB;AACA,6BAA6B,aAAa,EAAE;;AAE5C,wCAAwC;AACxC;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB;;;;;+BAK6B;EAC7B,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;AACtD,gCAAgC,4BAA4B,EAAE;;AAE9D;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,6BAA6B,aAAa,EAAE;AAC5C,yBAAyB,kBAAkB,EAAE,UAAU,EAAE;AACzD;EACE,mCAAmC;EACnC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;AACzC;AACA,yCAAyC,oCAAoC,EAAE,qBAAqB,EAAE;AACtG;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA,uCAAuC,mBAAmB,EAAE;;AAE5D,gBAAgB,iBAAiB,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC9D,gBAAgB,kBAAkB,EAAE,eAAe,EAAE;;AAErD;;;;sDAIsD;AACtD;EACE;IACE,WAAW;EACb;EACA;IACE,SAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uDAAuD;IACvD,oBAAoB;IACpB,eAAe;IACf,sBAAsB;EACxB;EACA;IACE;kEAC8D;IAC9D,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB,EAAE,mBAAmB;EACzC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mEAAmE;EACnE,gBAAgB;EAChB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,WAAW,EAAE,YAAY;EACzB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,8FAA8F;AAChG;AACA,qBAAqB,+BAA+B,EAAE,wBAAwB,EAAE,8BAA8B,EAAE;AAChH,qBAAqB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAErE,4DAA4D;AAC5D;;;EAGE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mGAAmG;EACnG,gBAAgB;AAClB;AACA,oDAAoD,8BAA8B,EAAE;AACpF;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa,EAAE,mBAAmB;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAE,YAAY;EACzB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,sEAAsE;EACtE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;;IAEE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,WAAW;EACb;AACF;;AAEA,qCAAqC;AACrC;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB;EACjB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;AACA,6BAA6B,qCAAqC,EAAE;;AAEpE;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;AAClB;AACA,2BAA2B,mCAAmC,EAAE;;AAEhE;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;AACA,6BAA6B,kCAAkC,EAAE;;AAEjE;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;AACA,0BAA0B,kCAAkC,EAAE;;AAE9D,uBAAuB,uCAAuC,GAAG,kCAAkC,EAAE;AACrG,uBAAuB,wCAAwC,EAAE,mCAAmC,EAAE;AACtG,uBAAuB,oCAAoC,MAAM,+BAA+B,EAAE;AAClG,uBAAuB,uCAAuC,GAAG,kCAAkC,EAAE;AACrG,uBAAuB,+BAA+B,WAAW,+BAA+B,EAAE;AAClG,uBAAuB,uCAAuC,GAAG,6BAA6B,EAAE;AAChG,uBAAuB,iCAAiC,SAAS,4BAA4B,EAAE;;AAE/F,oDAAoD;AACpD;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,0BAA0B,+BAA+B,EAAE,wBAAwB,EAAE;AACrF,2BAA2B,uCAAuC,EAAE;AACpE;EACE,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;AACjC;;AAEA;;2EAE2E;AAC3E;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B;;;;;gCAK8B;AAChC;AACA,qBAAqB,sBAAsB,EAAE,4BAA4B,EAAE,+BAA+B,EAAE;AAC5G,qBAAqB,sBAAsB,EAAE;;AAE7C,kBAAkB;AAClB,6BAA6B,4BAA4B,EAAE,8BAA8B,EAAE;AAC3F,6BAA6B,4BAA4B,EAAE,6BAA6B,EAAE;AAC1F,6BAA6B,4BAA4B,EAAE,6BAA6B,EAAE;AAC1F,6BAA6B,4BAA4B,EAAE,cAAc,EAAE;AAC3E,6BAA6B,4BAA4B,EAAE,cAAc,EAAE;AAC3E,6BAA6B,4BAA4B,EAAE,cAAc,EAAE;;AAE3E,uBAAuB;AACvB,oCAAoC,oCAAoC,EAAE,+BAA+B,EAAE;AAC3G,oCAAoC,iCAAiC,EAAE,4BAA4B,EAAE;AACrG,oCAAoC,iCAAiC,EAAE,4BAA4B,EAAE;;AAErG;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;AACf;AACA,uBAAuB,YAAY,EAAE;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,SAAS;EACtB,2BAA2B;EAC3B,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA,2CAA2C,mBAAmB,EAAE;;AAEhE;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,2DAA2D;EAC3D,0BAA0B;AAC5B;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;AACA,cAAc,+DAA+D,EAAE;AAC/E,cAAc,2DAA2D,EAAE;;AAE3E,qBAAqB;AACrB;;kCAEkC,WAAW,EAAE,YAAY,EAAE;AAC7D;;wCAEwC,uBAAuB,EAAE;AACjE;;;EAGE,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;;EAGE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,oCAAoC,oDAAoD,EAAE,qBAAqB,EAAE;;AAEjH,wBAAwB;AACxB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;;mEAGmE;AACnE;EACE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+FAA+F;AACjG;AACA,mBAAmB,aAAa,EAAE;AAClC;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;AACA,eAAe,kBAAkB,EAAE,UAAU,EAAE;AAC/C;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa,EAAE,mBAAmB,EAAE,QAAQ;AAC9C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE;;AAEnC,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;EACZ,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;EACxB,mBAAmB,EAAE,uBAAuB;EAC5C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW,EAAE,YAAY;EACzB,6CAA6C;EAC7C,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,kBAAkB;AAClB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B,iBAAiB,2BAA2B,EAAE;AAC9C,iBAAiB,yBAAyB,EAAE;;AAE5C,qBAAqB;AACrB;EACE,+BAA+B;AACjC;AACA,6CAA6C,aAAa,EAAE;AAC5D;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;2EAG2E;AAC3E;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;;;EAIE,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;;;;;;;;;;;;EAYE,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;;;;;EAKE,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAE3B,mCAAmC;EACnC,qDAAqD;EACrD,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;;;;;;;EAOE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,qDAAqD;AACrD;;;;;;;;;;8BAU8B,mCAAmC,EAAE;;AAEnE,uGAAuG,gDAAgD,EAAE;AACzJ,2GAA2G,wDAAwD,EAAE,wCAAwC,EAAE;AAC/M,qNAAqN,8CAA8C,EAAE,yBAAyB,EAAE;AAChS,2GAA2G,oDAAoD,EAAE;;AAEjK,4FAA4F,yCAAyC,EAAE;AACvI;4FAC4F,0CAA0C,EAAE;AACxI,yCAAyC,0CAA0C,EAAE;;AAErF,qKAAqK,6CAA6C,EAAE,uDAAuD,EAAE;AAC7Q,uFAAuF,0CAA0C,EAAE;;AAEnI,oHAAoH,gDAAgD,EAAE;AACtK,uHAAuH,wDAAwD,EAAE;AACjL,6HAA6H,mCAAmC,EAAE;;AAElK,mDAAmD;AACnD;;;EAGE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB,uBAAuB,gDAAgD,EAAE;AACzE,yBAAyB,gDAAgD,EAAE;AAC3E,0BAA0B,gDAAgD,EAAE;AAC5E,8BAA8B,0CAA0C,EAAE;AAC1E,8BAA8B,yCAAyC,EAAE;AACzE,8BAA8B,gDAAgD,EAAE;;AAEhF,4BAA4B,yCAAyC,EAAE;AACvE,4BAA4B,yCAAyC,EAAE;AACvE,4BAA4B,0CAA0C,EAAE;AACxE,4BAA4B,0CAA0C,EAAE;AACxE;4BAC4B,wCAAwC,EAAE;;AAEtE,qBAAqB;AACrB,+CAA+C,6CAA6C,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;;AAE9J,mDAAmD;AACnD;;;;;;;;;;;EAWE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,mGAAmG;AACrG;AACA;;;;;;;;;;EAUE,0CAA0C;EAC1C,aAAa;EACb,4CAA4C;AAC9C;;AAEA,kDAAkD;AAClD,+JAA+J,8CAA8C,EAAE,yBAAyB,EAAE;AAC1O,2KAA2K,mCAAmC,EAAE;AAChN,6EAA6E,gDAAgD,EAAE;AAC/H,gFAAgF,wDAAwD,EAAE;AAC1I,oHAAoH,wCAAwC,EAAE;;AAE9J,6BAA6B;AAC7B;;;;EAIE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB,4BAA4B,wBAAwB,EAAE;;AAEtD;;;2EAG2E;AAC3E;;EAEE,gCAAgC;EAChC,wCAAwC;AAC1C;AACA;;EAEE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,iEAAiE;AACjE,iEAAiE;AACjE,iEAAiE;AACjE,iEAAiE;AACjE;;;;;;2EAM2E;;AAE3E;;;;;CAKC;;AAID;;;4EAG4E;AAC5E;;EAEE;;0CAEwC;EACxC,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;sEACsE;;AAEtE;;+DAE+D;AAC/D,kBAAkB,+BAA+B,EAAE;AACnD,kBAAkB,+BAA+B,EAAE;AACnD,kBAAkB,+BAA+B,EAAE;AACnD,qBAAqB,6BAA6B,EAAE;AACpD,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,wBAAwB,EAAE;AAC/C,mBAAmB,gCAAgC,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1I,mBAAmB,qCAAqC,EAAE,kCAAkC,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEpJ,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C,gCAAgC,WAAW,EAAE,YAAY,EAAE;AAC3D,sCAAsC,uBAAuB,EAAE;AAC/D;EACE,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,4CAA4C,mCAAmC,EAAE,4BAA4B,EAAE,6BAA6B,EAAE;;AAE9I,uEAAuE;AACvE;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA,oBAAoB,aAAa,EAAE;AACnC,gBAAgB,kBAAkB,EAAE,UAAU,EAAE;;AAEhD,sEAAsE;;AAEtE,gEAAgE;AAChE;EACE,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX;;;;;;GAMC;AACH;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,UAAU,EAAE,WAAW;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,yCAAyC;AAC3C;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB;;uCAEqC;AACvC;AACA,qBAAqB,mCAAmC,EAAE;AAC1D;EACE,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,SAAS,EAAE,YAAY;EAChC,UAAU;EACV,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;qCAEmC;EACnC;;;4EAG0E;AAC5E;AACA;EACE,mBAAmB;EACnB;;qCAEmC;AACrC;AACA;EACE,yBAAyB;EACzB;;+DAE6D;AAC/D;AACA;EACE,mBAAmB;EACnB;;qCAEmC;AACrC;AACA;EACE,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,oCAAoC;EACpC,iCAAiC;EACjC,0FAA0F;EAC1F,4CAA4C;AAC9C;AACA,wBAAwB,0CAA0C,EAAE;AACpE;;;;;;;EAOE,iCAAiC;AACnC;AACA;;;EAGE,yBAAyB;EACzB,qCAAqC;EACrC,yCAAyC;EACzC,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,0FAA0F;EAC1F,kCAAkC;AACpC;;AAEA;;;;;sEAKsE;AACtE;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,uDAAuD;EAEvD,gBAAgB;EAChB,gBAAgB;AAClB;AACA,4EAA4E;AAC5E;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,qEAAqE;EACrE,+CAA+C;AACjD;AACA,oCAAoC,eAAe,EAAE;AACrD;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,sCAAsC;AACxC;AACA,2CAA2C,sBAAsB,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,8DAA8D;AAC9D;EACE,+BAA+B;AACjC;AACA;EACE,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA,qCAAqC,cAAc,EAAE;AACrD,mCAAmC,+BAA+B,EAAE;AACpE,oCAAoC,qCAAqC,EAAE;;AAE3E,sDAAsD;AACtD;EACE,gBAAgB;AAClB;AACA,8BAA8B,aAAa,EAAE;AAC7C;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;;GAOC;EACD;;;yBAGuB;EACvB,+CAA+C;AACjD;AACA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,yEAAyE;AACzE;EACE,oCAAoC;AACtC;AACA;EACE,qEAAqE;AACvE;AACA;EACE,oCAAoC;AACtC;;AAEA;;;;;wEAKwE;AACxE;EACE,sCAAsC;EACtC,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,0BAA0B;EAC1B,sCAAsC;EACtC;;;;;GAKC;EACD,kEAAkE;AACpE;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,6EAA6E;AAC/E;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf;kDACgD;AAClD;AACA;EACE,mEAAmE;EACnE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uEAAuE;AACzE;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;uEACuE;AACvE,gBAAgB,sBAAsB,EAAE,wBAAwB,EAAE;AAClE,oCAAoC,sBAAsB,EAAE,wBAAwB,EAAE;AACtF,kCAAkC,sBAAsB,EAAE,wBAAwB,EAAE;;AAEpF,iDAAiD;AACjD;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,8HAA8H;AAChI;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,wFAAwF;AAC1F;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;;;qEAGqE;AACrE;EACE,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;AACA,cAAc,+DAA+D,EAAE;;AAE/E;;+DAE+D;AAC/D;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,mBAAmB;EACnB,wFAAwF;AAC1F;AACA,wBAAwB,qCAAqC,EAAE;;AAE/D,8CAA8C;AAC9C;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB;;;;mDAIiD;AACnD;AACA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AACA,qBAAqB,sBAAsB,EAAE;AAC7C;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,6CAA6C;AAC/C;AACA,uBAAuB,8BAA8B,EAAE,YAAY,EAAE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,SAAS;EACtB,2BAA2B;EAC3B,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,2CAA2C,gCAAgC,EAAE;;AAE7E;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;AACA;EACE;;0EAEwE;EACxE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB;;;sCAGoC;EACpC,gBAAgB;EAChB,2BAA2B;EAC3B,gEAAgE;AAClE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,0BAA0B,+BAA+B,EAAE;AAC3D,2BAA2B,uCAAuC,EAAE;AACpE;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,uCAAuC;EACvC,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,oDAAoD;AACtD;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gFAAgF;AAClF;;AAEA,gEAAgE;AAChE;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,uEAAuE;AACzE;AACA,+BAA+B,8BAA8B,EAAE;AAC/D,+BAA+B,6BAA6B,EAAE;;AAE9D,oBAAoB;AACpB;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;iDACiD;;AAEjD,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB;wDACsD;AACxD;AACA,+BAA+B,sCAAsC,GAAG,iCAAiC,EAAE;AAC3G,+BAA+B,oCAAoC,KAAK,+BAA+B,EAAE;AACzG,+BAA+B,sEAAsE,EAAE,oBAAoB,EAAE;AAC7H,+BAA+B,uCAAuC,EAAE,kCAAkC,EAAE;AAC5G,+BAA+B,qCAAqC,IAAI,gCAAgC,EAAE;;AAE1G,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iEAAiE;EACjE,kBAAkB;AACpB;AACA,8BAA8B,uCAAuC,EAAE;AACvE,8BAA8B,qCAAqC,EAAE;AACrE,8BAA8B,yBAAyB,EAAE;AACzD,8BAA8B,wCAAwC,EAAE;AACxE,8BAA8B,sCAAsC,EAAE;AACtE,yBAAyB,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACvE,yBAAyB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd;0DACwD;AAC1D;AACA;;;;;EAKE,mBAAmB;AACrB;AACA,mCAAmC,kCAAkC,EAAE;AACvE,iCAAiC,gCAAgC,EAAE;AACnE,gCAAgC,oBAAoB,EAAE;AACtD,oCAAoC,mCAAmC,EAAE;AACzE,kCAAkC,iCAAiC,EAAE;AACrE;;EAEE,aAAa;AACf;;AAEA;iEACiE;AACjE;EACE,mBAAmB;EACnB;;qCAEmC;AACrC;AACA;EACE,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;kEACkE;AAClE;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C;;mCAEiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,mGAAmG;EACnG,4BAA4B;AAC9B;AACA;EACE,wHAAwH;AAC1H;AACA;EACE,uHAAuH;AACzH;AACA;EACE,uHAAuH;AACzH;AACA;EACE,wHAAwH;AAC1H;AACA;EACE,wHAAwH;AAC1H;AACA;EACE,qBAAqB;AACvB;AACA;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,4CAA4C;EAC5C,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,4EAA4E;AAC9E;AACA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,6EAA6E;AAC/E;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,sDAAsD;EACtD;;2CAEyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,sDAAsD;EACtD;;2CAEyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mEAAmE;EACnE,4DAA4D;EAC5D,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;+EAK+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB;;;+CAG6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA,2BAA2B,cAAc,EAAE;;AAE3C,kEAAkE;AAClE;EACE;kEACgE;EAChE,cAAc;EACd,sCAAsC;EACtC;;;oCAGkC;EAClC,6CAA6C;AAC/C;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qFAAqF;EACrF;;oCAEkC;AACpC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE;kEACgE;EAChE,cAAc;EACd,oCAAoC;EACpC;;;oCAGkC;EAClC,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,qDAAqD;AACvD;;AAEA,4EAA4E;AAC5E;EACE;kEACgE;EAChE,cAAc;EACd,qCAAqC;EACrC;;;mCAGiC;EACjC,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qFAAqF;EACrF;;mCAEiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;EAC/B,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,iDAAiD;AACjD;;;EAGE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ;yDACuD;AACzD;AACA,+BAA+B,wBAAwB,EAAE,2BAA2B,EAAE;AACtF,gCAAgC,wBAAwB,EAAE;;AAE1D;;;;;;;+EAO+E;AAC/E;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,gFAAgF;EAChF,oFAAoF;EACpF,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mFAAmF;EACnF,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;;;+EAI+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,+EAA+E;EAC/E,+EAA+E;EAC/E,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qEAAqE;EACrE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACnF,0BAA0B,+BAA+B,EAAE;AAC3D;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;;;+EAG+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf;;;4DAG0D;EAC1D,mBAAmB;AACrB;AACA;EACE,yEAAyE;EACzE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,oEAAoE;AACtE;;AAEA;;;+EAG+E;AAC/E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;;;;GAIC;EACD,6EAA6E;EAC7E,mFAAmF;EACnF,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;+EAI+E;AAC/E,wCAAwC,WAAW,EAAE;;;AAGrD;;;;;2EAK2E;;AAE3E,8DAA8D;AAC9D;;EAEE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA,gFAAgF;AAChF;;;;;EAKE,4BAA4B;EAC5B,2CAA2C;EAC3C,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA,4EAA4E;AAC5E;;EAEE,wCAAwC;EACxC,sCAAsC;EACtC,wCAAwC;EACxC,+CAA+C;EAC/C,8CAA8C;EAC9C,2BAA2B;EAC3B,4BAA4B;EAC5B,2GAA2G;AAC7G;AACA;;EAEE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;;EAEE,0CAA0C;EAC1C,wCAAwC;EACxC,6CAA6C;EAC7C,+CAA+C;EAC/C,8CAA8C;EAC9C,2BAA2B;EAC3B,iFAAiF;AACnF;AACA;;EAEE,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;;EAEE,kCAAkC;EAClC,0CAA0C;EAC1C,wCAAwC;EACxC,+CAA+C;AACjD;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;EACxC,+CAA+C;EAC/C,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E;;;EAGE,0CAA0C;EAC1C,yCAAyC;EACzC,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,mDAAmD;AACnD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iEAAiE;AACnE;AACA,gCAAgC,6BAA6B,EAAE;;AAE/D,iDAAiD;AACjD;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;;AAEA,2BAA2B;AAC3B;EACE,wDAAwD;EACxD,wCAAwC;EACxC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;;EAEE,wCAAwC;AAC1C;;AAEA,0EAA0E;AAC1E;;;;;EAKE,0CAA0C;AAC5C;;AAEA,0DAA0D;AAC1D;;EAEE,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;;;;;6EAK6E;;AAE7E,6EAA6E;AAC7E;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+EAA+E;EAC/E,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,8FAA8F;AAChG;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,qCAAqC,UAAU,EAAE;AACjD;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB;uEACqE;AACvE;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,+BAA+B;AACjC;;AAEA;;;0EAG0E;AAC1E;EACE,uBAAuB;EACvB,MAAM;AACR;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,UAAU;EACV,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf;;yCAEuC;AACzC;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,cAAc;EACd,gDAAgD;AAClD;AACA;;;;6BAI6B;AAC7B;;EAEE;;sCAEoC;AACtC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;;EAEE,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;EACV,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,gEAAgE;AAClE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,yCAAyC;AAC3C;AACA;;EAEE,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,wFAAwF;EACxF,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,6BAA6B;EAC7B,UAAU;EACV,sFAAsF;AACxF;AACA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oDAAoD;EACpD,6BAA6B;EAC7B,8DAA8D;AAChE;AACA;EACE,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,KAAK,UAAU,EAAE,4CAA4C,EAAE;EAC/D,MAAM,UAAU,EAAE,2CAA2C,EAAE;EAC/D,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;AACA;EACE,KAAK,oBAAoB,EAAE;AAC7B;AACA;EACE;;;;;;IAME,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,2DAA2D;EAC3D,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;;AAEA;iFACiF;AACjF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,UAAU;EACV,8BAA8B;AAChC;AACA;;EAEE,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,+DAA+D;AACjE;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,wEAAwE;;AAExE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,oCAAoC;EACpC,WAAW;EACX,4BAA4B;AAC9B;AACA,kDAAkD,UAAU,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf;2CACyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,+DAA+D;AACjE;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA,uBAAuB,SAAO,EAAE,gBAAgB,EAAE;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,4EAA4E;AAC5E;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B;2CACyC;EACzC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB,EAAE,cAAc;AACrC;AACA;EACE,iCAAiC,EAAE,4BAA4B;AACjE;AACA;EACE,oCAAoC,EAAE,+BAA+B;AACvE;AACA;EACE,iCAAiC,EAAE,4BAA4B;AACjE;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf;qEACmE;AACrE;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA,kDAAkD,2BAA2B,EAAE;;AAE/E,mDAAmD;AACnD;EACE,uCAAuC,EAAE,kCAAkC;AAC7E;AACA;EACE,wCAAwC,EAAE,mCAAmC;AAC/E;AACA;EACE,iCAAiC,EAAE,4BAA4B;AACjE;AACA;EACE,oCAAoC,EAAE,+BAA+B;AACvE;AACA;EACE,oCAAoC,EAAE,+BAA+B;AACvE;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;qEACmE;EACnE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iEAAiE;EACjE,mBAAmB;AACrB;AACA,2BAA2B,6BAA6B,EAAE;AAC1D;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;yEACyE;AACzE;;;0BAG0B,2BAA2B,EAAE;;AAEvD;;;;+EAI+E;AAC/E;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;;;;;6EAM6E;AAC7E;;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mDAAmD;AACrD;AACA;;;;EAIE,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA,sDAAsD;AACtD;EACE,yBAAyB;AAC3B;;AAEA;;;;+EAI+E;;AAE/E,+EAA+E;AAC/E;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;AACA,4BAA4B,4BAA4B,EAAE;AAC1D,4BAA4B,4BAA4B,EAAE;;AAE1D,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B,oBAAoB,8BAA8B,EAAE;AACpD;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sFAAsF;EACtF,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,YAAY;EACZ,cAAc;AAChB;;AAEA,+DAA+D;AAC/D,eAAe,8BAA8B,EAAE;AAC/C,yBAAyB,6BAA6B,EAAE;;AAExD,4DAA4D;AAC5D,gBAAgB,8BAA8B,EAAE,gBAAgB,EAAE;AAClE;;0EAE0E;AAC1E,oCAAoC,uBAAuB,EAAE;;AAE7D,qDAAqD;AACrD;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD,eAAe,cAAc,EAAE;;AAE/B,4CAA4C;AAC5C,kBAAkB,oBAAoB,EAAE;;AAExC,mFAAmF;AACnF;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA,mCAAmC,4BAA4B,EAAE;;AAEjE,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C,iBAAiB,oBAAoB,EAAE;AACvC,uBAAuB,sBAAsB,EAAE;AAC/C,uBAAuB,sBAAsB,EAAE;;AAE/C,iDAAiD;AACjD;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;+EAE+E;AAC/E;EACE,yHAAyH;AAC3H;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,iFAAiF;EACjF,iFAAiF;EACjF,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,uEAAuE;EACvE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;AACA,0BAA0B,+BAA+B,EAAE;AAC3D;EACE,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;AAClB;AACA,oCAAoC,uCAAuC,EAAE;AAC7E;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,+BAA+B;EAC/B;iFAC+E;EAC/E,YAAY;EACZ,wCAAwC;EACxC,sCAAsC;EACtC,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,gDAAgD;AAClD;AACA,gCAAgC,YAAY,EAAE;AAC9C,4BAA4B,+BAA+B,EAAE;;AAE7D;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iFAAiF;AACnF;AACA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;+EAE+E;AAC/E;EACE;;;uBAGqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;AACjC;AACA,6BAA6B,gBAAgB,EAAE;AAC/C;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE;;qEAEmE;EACnE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B;;gEAE8D;EAC9D,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,qBAAqB;EACrB,4BAA4B;EAC5B,8EAA8E;AAChF;AACA,qEAAqE;AACrE,0BAA0B,cAAc,EAAE;AAC1C;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;AACA,gDAAgD,QAAQ,EAAE,kBAAkB,EAAE;AAC9E;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uDAAuD;AACzD;AACA,sDAAsD,sBAAsB,EAAE;;AAE9E;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,eAAe;AACjB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,sCAAsC;EACtC,sBAAsB;AACxB;AACA,6BAA6B,mBAAmB,EAAE;AAClD;EACE,eAAe;EACf,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C;EAC5C,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,gDAAgD;EAChD,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA,6BAA6B,YAAY,EAAE;;AAE3C;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,MAAM;EACN,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA,uBAAuB,+BAA+B,EAAE;AACxD;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA,2BAA2B,oBAAoB,EAAE;AACjD;EACE,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;AACA,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,oBAAoB,EAAE;AACzD,oCAAoC,8BAA8B,EAAE;AACpE;EACE,iBAAiB;EACjB,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mFAAmF;AACrF;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;;+EAE+E;AAC/E,uBAAuB,2BAA2B,EAAE;AACpD;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,oCAAoC;EACpC,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA,uBAAuB,gBAAgB,EAAE;AACzC;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA,yBAAyB,gBAAgB,EAAE;AAC3C,gCAAgC,uBAAuB,EAAE;AACzD,+BAA+B,8BAA8B,EAAE;;AAE/D;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,0DAA0D;EAC1D,cAAc;AAChB;AACA,oCAAoC,yBAAyB,EAAE;AAC/D;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,iFAAiF;EACjF,iFAAiF;EACjF,mBAAmB;EACnB,2BAA2B;EAC3B,uEAAuE;EACvE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yEAAyE;EACzE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB,+BAA+B,EAAE;AACvD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,6CAA6C;AAC/C;AACA,gCAAgC,6BAA6B,EAAE;AAC/D;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;AACA,0BAA0B,8BAA8B,EAAE;AAC1D;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE;;uBAEqB;AACvB;AACA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;AACA,wBAAwB,SAAO,EAAE;AACjC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;AACjB;AACA,qCAAqC,+BAA+B,EAAE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;AACA,0BAA0B,gBAAgB,EAAE,YAAY,EAAE;AAC1D,gCAAgC,YAAY,EAAE;;AAE9C;;+EAE+E;AAC/E;EACE,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA,8BAA8B,kBAAkB,EAAE;AAClD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;AACA,wCAAwC,oCAAoC,EAAE;AAC9E,uCAAuC,oCAAoC,EAAE;AAC7E;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;AACA,+BAA+B,+BAA+B,EAAE;;AAEhE;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA,yBAAyB,YAAY,EAAE;AACvC,2BAA2B,YAAY,EAAE;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;AACA,kBAAkB,+BAA+B,EAAE;AACnD;EACE,iBAAiB;EACjB,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;AAClD;AACA;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;AACvD;EACE,kBAAkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,uBAAuB,sBAAsB,EAAE;;AAE/C;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;;mEAEmE;AACnE,2BAA2B,aAAa,EAAE;;AAE1C;EACE;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,2CAA2C;IAC3C,4EAA4E;EAC9E;EACA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,WAAW;IACX,iDAAiD;EACnD;AACF;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;AACA,sBAAsB,8BAA8B,EAAE;AACtD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,gDAAgD;AAClD;AACA,qBAAqB,+BAA+B,EAAE;AACtD;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;AACA,gBAAgB,8BAA8B,EAAE;AAChD;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,gDAAgD;AAClD;AACA,sBAAsB,+BAA+B,EAAE;AACvD;EACE,kDAAkD;AACpD;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,wBAAwB;AAC1B;AACA,sBAAsB,8BAA8B,EAAE;AACtD;EACE,iEAAiE;EACjE,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;AACrC;AACA,4BAA4B,8BAA8B,EAAE;AAC5D,sBAAsB,8BAA8B,EAAE;AACtD,eAAe,oBAAoB,EAAE;AACrC,kBAAkB,uCAAuC,EAAE;AAC3D;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;EACpC,+BAA+B;EAC/B,kDAAkD;EAClD,2BAA2B;AAC7B;AACA,qBAAqB,+BAA+B,EAAE;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,gDAAgD;AAClD;AACA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,kCAAkC,+BAA+B,EAAE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;AACA,0BAA0B,qBAAqB,EAAE;AACjD,4BAA4B,oBAAoB,EAAE;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,uEAAoE;AACpE;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,SAAS;AACX;AACA,eAAe,aAAa,EAAE;AAC9B,wCAAwC,eAAe,EAAE,gBAAgB,EAAE;AAC3E,2CAA2C,aAAa,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AAC7F,mDAAmD,eAAe,EAAE;AACpE,mBAAmB,+BAA+B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC9G,oBAAoB,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC9G,wBAAwB,uBAAuB,EAAE,UAAU,EAAE;AAC7D,iBAAiB,0BAA0B,EAAE,0BAA0B,EAAE;AACzE,oBAAoB,gCAAgC,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE1F;;+EAE+E;AAC/E;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,mCAAmC;EACnC,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,gDAAgD;EAChD,eAAe;AACjB;AACA,sBAAsB,mCAAmC,EAAE;AAC3D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,iDAAiD;EACjD,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA,iCAAiC,gBAAgB,EAAE;AACnD,gCAAgC,+BAA+B,EAAE;AACjE;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA,2BAA2B,gBAAgB,EAAE;AAC7C;EACE,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,+BAA+B,wBAAwB,EAAE;AACzD;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA,iBAAiB,kBAAkB,EAAE;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;AACtC;AACA;;;;;8DAK8D;AAC9D;EACE,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;;;EAKE;AACF;EACE,cAAc,kBAAkB,6CAA6C;EAC7E,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C;;kEAEgE;EAChE;;gCAE8B;EAC9B,WAAW;AACb;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,qDAAqD;EACrD,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,4BAA4B,gCAAgC,EAAE,UAAU,EAAE;AAC1E;EACE,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,iFAAiF;AACnF;AACA,0CAA0C,+BAA+B,EAAE;AAC3E;EACE,qCAAqC;EACrC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB,sBAAsB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,uDAAuD;AACzD;AACA,2BAA2B,oCAAoC,EAAE,2BAA2B,EAAE;AAC9F,0BAA0B,cAAc,EAAE;AAC1C,uBAAuB,+BAA+B,EAAE;;AAExD,wDAAwD;AACxD;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;AACvB;AACA,wCAAwC,UAAU,EAAE;AACpD;EACE,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;AACA,0BAA0B,qCAAqC,EAAE;AACjE,2BAA2B,oCAAoC,EAAE;AACjE,6BAA6B,YAAY,EAAE,eAAe,EAAE;AAC5D,gCAAgC,oCAAoC,EAAE;AACtE;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gFAAgF;AAClF;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,UAAU;EACV,8BAA8B;AAChC;AACA,iDAAiD,UAAU,EAAE;;AAE7D,WAAW;AACX;EACE,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,qDAAqD;EACrD,gDAAgD;EAChD,0EAA0E;AAC5E;AACA,6CAA6C,wBAAwB,EAAE,2BAA2B,EAAE;AACpG,8CAA8C,wBAAwB,EAAE;AACxE;EACE,eAAe;EACf,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,iCAAiC,uCAAuC,EAAE;AAC1E,iCAAiC,mBAAmB,EAAE,YAAY,EAAE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,iFAAiF;EACjF,kCAAkC;EAClC,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;AACf;AACA,kCAAkC,kBAAkB,EAAE;AACtD;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA,uEAAuE;AACvE,0EAA0E;AAC1E;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB;;mEAEiE;EACjE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;AACA,8BAA8B,6BAA6B,EAAE;AAC7D;;;;oEAIoE;AACpE;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;wEAGwE;AACxE;EACE,gCAAgC,aAAa,EAAE;AACjD;;AAEA;kDACkD;AAClD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,4CAA4C;EAC5C,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;AACA,kCAAkC,+BAA+B,EAAE;AACnE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;oEACoE;AACpE;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;AACA,2CAA2C,6BAA6B,EAAE;AAC1E,+BAA+B,eAAe,EAAE,YAAY,EAAE;;AAE9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,sEAAsE;EACtE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,iCAAiC;AACnC;AACA,wBAAwB,+BAA+B,EAAE;AACzD;oCACoC,uCAAuC,EAAE;AAC7E;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,mBAAmB,aAAa,EAAE;AAClC;EACE,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;+EAE+E;AAC/E,oBAAoB,cAAc,EAAE;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;EACxC,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,6BAA6B,gBAAgB,EAAE;AAC/C;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;AACA,gCAAgC,cAAc,EAAE;AAChD;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,6BAA6B,wBAAwB,EAAE;AACvD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;AACA,4BAA4B,+BAA+B,EAAE;AAC7D;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,gDAAgD;AAClD;AACA,sCAAsC,+BAA+B,EAAE;AACvE;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;AAC5B;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gDAAgD;AAClD;AACA,yBAAyB,yCAAyC,EAAE;AACpE;;EAEE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;EAC9C,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;AAC/B;AACA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;AACA,2BAA2B,kBAAkB,EAAE;AAC/C;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA,qBAAqB,+BAA+B,EAAE;AACtD,yBAAyB,uBAAuB,EAAE;AAClD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;AACA,6BAA6B,+BAA+B,EAAE;;AAE9D;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;AACX;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA,oCAAoC,yCAAyC,EAAE;AAC/E;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gDAAgD;AAClD;AACA,8BAA8B,+BAA+B,EAAE;AAC/D;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,4BAA4B,gBAAgB,EAAE;AAC9C;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;AACA,6BAA6B,YAAY,EAAE;;AAE3C,8EAA8E;AAC9E,uBAAuB,mBAAmB,EAAE,uCAAuC,EAAE,gBAAgB,EAAE;AACvG,4BAA4B,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACrK,sBAAsB,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzF,6BAA6B,6BAA6B,EAAE,eAAe,EAAE,SAAS,EAAE;AACxF,oBAAoB,+BAA+B,EAAE,eAAe,EAAE,eAAe,EAAE;AACvF,qBAAqB,eAAe,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AAC3F,iFAAiF;AACjF,UAAU,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,6BAA6B,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvK,mBAAmB,sCAAsC,EAAE,WAAW,EAAE,wCAAwC,EAAE;AAClH,wCAAwC,4CAA4C,EAAE,8CAA8C,EAAE;AACtI,4BAA4B,WAAW,EAAE,eAAe,EAAE;AAC1D,0BAA0B,oCAAoC,EAAE,6BAA6B,EAAE,uBAAuB,EAAE;AACxH,+CAA+C,mCAAmC,EAAE;AACpF,iBAAiB,wCAAwC,EAAE,sCAAsC,EAAE,uBAAuB,EAAE;AAC5H,uBAAuB,wCAAwC,EAAE;;AAEjE;;+EAE+E;AAC/E;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sDAAsD;AACxD;AACA,mBAAmB,mCAAmC,EAAE;AACxD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,4BAA4B;AAC9B;AACA,qCAAqC,UAAU,EAAE;;AAEjD;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;AACA,4BAA4B,uCAAuC,EAAE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,6EAA6E;AAC/E;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA,6BAA6B,+BAA+B,EAAE;AAC9D,8DAA8D,yCAAyC,EAAE;;AAEzG;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,6FAA6F;EAC7F,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB;;+BAE6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,qCAAqC,gBAAgB,EAAE;AACvD,kCAAkC,8BAA8B,EAAE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,cAAc;EACd,gDAAgD;AAClD;AACA,6BAA6B,+BAA+B,EAAE;AAC9D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA,2BAA2B,YAAY,EAAE;AACzC;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;EAChB,+BAA+B;EAC/B;;;;;8EAK4E;EAC5E,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA,oCAAoC,0CAA0C,EAAE;AAChF;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,YAAY;EACZ,sDAAsD;AACxD;AACA,8BAA8B,uCAAuC,EAAE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA,+BAA+B,gBAAgB,EAAE;AACjD;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA,8BAA8B,wBAAwB,EAAE;AACxD;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,uCAAuC;EACvC,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA,yBAAyB,YAAY,EAAE;;AAEvC;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,iFAAiF;EACjF,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA,8BAA8B,gBAAgB,EAAE;AAChD;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;AAClB;AACA,0BAA0B,eAAe,EAAE;AAC3C;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA,0BAA0B,+BAA+B,EAAE;AAC3D;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,4CAA4C;EAC5C,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE;wDACsD;EACtD,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,iFAAiF;AACnF;AACA;;EAEE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;AACA,4BAA4B,+BAA+B,EAAE;AAC7D,4BAA4B,wBAAwB,EAAE;AACtD;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;AACA,6BAA6B,eAAe,EAAE;AAC9C;2BAC2B,+BAA+B,EAAE;AAC5D;EACE,kBAAkB;EAClB,QAAQ;EACR,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA,mCAAmC,kBAAkB,EAAE;AACvD;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAO;EACP,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA,iCAAiC,gBAAgB,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;AACA,sCAAsC,wBAAwB,EAAE;AAChE;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,2BAA2B,aAAa,EAAE;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA,8BAA8B,iBAAiB,EAAE;AACjD;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iFAAiF;EACjF,2BAA2B;AAC7B;AACA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,oCAAoC;EACpC,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,+BAA+B,mBAAmB,EAAE;;AAEpD;;+EAE+E;AAC/E;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,6CAA6C;EAC7C,iCAAiC;EACjC,+EAA+E;EAC/E,iBAAiB;EACjB,sBAAsB;EACtB,sFAAsF;EACtF,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;EACd,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,0CAA0C;AAC5C;AACA,0BAA0B,uBAAuB,EAAE;;AAEnD;;2EAE2E;AAC3E;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,uDAAuD;EACvD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,sBAAsB,sCAAsC,EAAE;AAC9D,8BAA8B,2CAA2C,EAAE,mBAAmB,EAAE;AAChG,yBAAyB,aAAa,EAAE,eAAe,EAAE;AACzD,wBAAwB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACtE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,uCAAuC;AACzC;AACA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,0BAA0B,eAAe,EAAE,wCAAwC,EAAE;AACrF,uBAAuB,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AAC5G;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;AAC1C;AACA,yBAAyB,kBAAkB,EAAE,wCAAwC,EAAE,eAAe,EAAE;AACxG;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;AACA,2BAA2B,4CAA4C,EAAE;;AAEzE,gFAAgF;AAChF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA,oBAAoB,eAAe,EAAE,iBAAiB,EAAE;AACxD;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA,gFAAgF;AAChF,aAAa,kBAAkB,EAAE,YAAY,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AAChF,sBAAsB,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,cAAc,EAAE,eAAe,EAAE,wBAAwB,EAAE,qBAAqB,EAAE,+BAA+B,EAAE,iBAAiB,EAAE;AACvM,oBAAoB,eAAe,EAAE,+BAA+B,EAAE;AACtE,mBAAmB,eAAe,EAAE,SAAS,EAAE,QAAQ,EAAE,YAAY,EAAE,qBAAqB,EAAE,OAAO,EAAE;AACvG,kBAAkB,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,cAAc,EAAE;AAC7E,qBAAqB,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACnF,mBAAmB,QAAM,EAAE;AAC3B,yBAAyB,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,4CAA4C,EAAE,uCAAuC,EAAE,eAAe,EAAE;;AAExL,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB,uCAAuC,EAAE;AAC5D;EACE,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA,0BAA0B,8BAA8B,EAAE;AAC1D,qBAAqB,kCAAkC,EAAE;AACzD;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,4BAA4B,+BAA+B,EAAE;AAC7D,iBAAiB,8BAA8B,EAAE;AACjD,yBAAyB,gCAAgC,EAAE;AAC3D,uBAAuB,cAAc,EAAE;AACvC,yBAAyB,6BAA6B,EAAE;;AAExD;;;;qEAIqE;AACrE;;;;EAIE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;qCAMqC;AACrC;;;;;;;;EAQE,sCAAsC;EACtC,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,qCAAqC;EACrC,yCAAyC;EACzC,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,+EAA+E;AACjF;AACA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;;;kDAGkD;AAClD,kBAAkB,kBAAkB,EAAE;AACtC,wBAAwB,gBAAgB,EAAE;AAC1C;EAEE,wEAAwE;AAC1E;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;AACA,gCAAgC,0BAA0B,EAAE;AAC5D,iCAAiC,YAAY,EAAE;AAC/C,0CAA0C,cAAc,EAAE;AAC1D;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;AACA,oBAAoB,8BAA8B,EAAE;AACpD;EACE,qCAAqC;EACrC,kCAAkC;EAClC,+EAA+E;EAC/E,0CAA0C;EAC1C,kDAAkD;AACpD;AACA;;;;;;oEAMoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yEAAyE;AAC3E;AACA;EACE,kCAAkC;EAClC,cAAc;EACd,2BAA2B;AAC7B;AACA,4BAA4B,oCAAoC,EAAE;AAClE;EACE,aAAa;EACb,6CAA6C;AAC/C;AACA,yEAAyE;AACzE,4BAA4B,eAAe,EAAE,cAAc,EAAE;AAC7D,uEAAuE;AACvE,4BAA4B,cAAc,EAAE;AAC5C,kCAAkC,kCAAkC,EAAE;AACtE,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iFAAiF;EACjF,0CAA0C;EAC1C,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;AACA,8BAA8B,sBAAsB,EAAE;AACtD;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,iFAAiF;EACjF,0CAA0C;EAC1C,kDAAkD;AACpD;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA,uCAAuC,yBAAyB,EAAE;AAClE,gCAAgC,cAAc,EAAE;AAChD,oBAAoB,6BAA6B,EAAE;AACnD,8BAA8B,oBAAoB,EAAE;AACpD,yBAAyB,+BAA+B,EAAE;;AAE1D;;+EAE+E;AAC/E;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;AACd;AACA,sBAAsB,YAAY,EAAE;;AAEpC;;;;;;;+EAO+E;AAC/E;EACE,aAAa;EACb,cAAc;AAChB;AACA,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE;;;;iCAI+B;EAC/B;IACE,iBAAiB;EACnB;EACA;uEACqE;EACrE;IACE,6DAA6D;EAC/D;EACA;;;;yEAIuE;EACvE;IACE,wBAAwB;EAC1B;EACA;gEAC8D;EAC9D;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;mCAEiC;EACjC;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;EACvB;EACA,8CAA8C,aAAa,EAAE;EAC7D;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;EACrB;EACA,8CAA8C;EAC9C;IACE,wBAAwB;EAC1B;EACA,mDAAmD;EACnD;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,6FAA6F;EAC7F,0CAA0C;AAC5C;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA,iBAAiB,8BAA8B,EAAE;AACjD,wBAAwB,eAAe,EAAE;AACzC,wBAAwB,eAAe,EAAE;AACzC,0BAA0B,gBAAgB,EAAE;AAC5C,wBAAwB,8BAA8B,EAAE;AACxD,2BAA2B,+BAA+B,EAAE;AAC5D,uBAAuB,yCAAyC,EAAE;AAClE;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;;;;;;;;;oEASoE;AACpE;EACE,aAAa;EACb,0CAA0C;EAC1C,wFAAwF;AAC1F;AACA;EACE,sFAAsF;EACtF,cAAc;EACd,YAAY;AACd;AACA;EACE,4FAA4F;AAC9F;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;uBAEqB;EACrB;IACE,kDAAkD;IAClD,wCAAwC;IACxC,2CAA2C;IAC3C,+BAA+B;IAC/B,4CAA4C;EAC9C;EACA;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;AACF;AACA,oBAAoB,YAAY,EAAE;AAClC,iBAAiB,YAAY,EAAE;AAC/B;EACE,6DAA6D;EAC7D,4FAA4F;AAC9F;AACA;EACE,6DAA6D;EAC7D,4FAA4F;AAC9F;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6DAA6D;EAC7D,4FAA4F;AAC9F;AACA;EACE,6DAA6D;EAC7D,4FAA4F;AAC9F;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,0BAA0B,cAAc,EAAE;AAC1C,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,8BAA8B,cAAc,EAAE;AAC9C;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,0BAA0B,cAAc,EAAE;AAC1C;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA,4BAA4B,8BAA8B,EAAE;AAC5D;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oGAAoG;AACtG;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA,uBAAuB,8BAA8B,EAAE;AACvD;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,sFAAsF;EACtF,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,2BAA2B;EAC3B,kEAAkE;AACpE;AACA;EACE,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,yCAAyC;EACzC,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;AACA,8BAA8B,eAAe,EAAE;AAC/C;EACE,cAAc;AAChB;AACA,kCAAkC,wBAAwB,EAAE;AAC5D;EACE,uCAAuC;EACvC,wBAAwB;EACxB,yCAAyC;AAC3C;AACA,uBAAuB,wBAAwB,EAAE;AACjD;EACE;;;uBAGqB;EACrB,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;;;;+EAI+E;AAC/E;EACE,+BAA+B;EAC/B,iEAAiE;AACnE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,4CAA4C;EAC5C,0DAA0D;AAC5D;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2DAA2D;EAC3D,uCAAuC;EACvC,mDAAmD;AACrD;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA,wBAAwB,YAAY,EAAE,SAAO,EAAE;AAC/C;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yEAAyE;EACzE,qBAAqB;EACrB,gCAAgC;EAChC,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gGAAgG;EAChG,iDAAiD;AACnD;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;;;;+EAI+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+DAA+D;AACjE;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,4EAA4E;EAC5E,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;6DAC6D;AAC7D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2FAA2F;EAC3F,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kDAAkD;AACpD;;AAEA;;;;+EAI+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,WAAW;EACX,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,wCAAwC;EACxC,uDAAuD;EACvD,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,2EAA2E;AAC7E;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,4DAA4D;AAC9D;AACA;;EAEE,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,qDAAqD;AACvD;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB;;mCAEiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,sDAAsD;EACtD,0EAA0E;AAC5E;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE;IACE,aAAa;IACb;;;;kBAIc;IACd,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,8EAA8E;IAC9E,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,UAAU;IACV,gEAAgE;IAChE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mDAAmD;IACnD,mBAAmB;EACrB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;;;;+EAI+E;AAC/E,wBAAwB,aAAa,EAAE;;AAEvC;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;IACtB,sCAAsC;IACtC,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yCAAyC;EAC3C;AACF;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4DAA4D;EAC5D,UAAU;AACZ;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA,mCAAmC,kBAAkB,EAAE;AACvD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,uDAAuD;EACvD,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,4DAA4D;AAC9D;AACA;EACE,wCAAwC;AAC1C;AACA,6CAA6C,cAAc,EAAE;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;+EAG+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,4DAA4D;AAC9D;AACA;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,oBAAoB;AACtB;AACA,iCAAiC,kBAAkB,EAAE;AACrD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,uDAAuD;EACvD,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,4DAA4D;AAC9D;AACA,mCAAmC,wCAAwC,EAAE;AAC7E,uCAAuC,cAAc,EAAE;AACvD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;;kEAEkE;AAClE;EACE;;sCAEoC;EACpC,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wCAAwC;EACxC,sCAAsC;EACtC,uDAAuD;EACvD,mBAAmB;EACnB,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,+DAA+D;EAC/D,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;;+EAK+E;AAC/E,eAAe,aAAa,EAAE;;AAE9B;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,wDAAwD;IACxD,4DAA4D;IAC5D,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;IACtC,oCAAoC;IACpC,+EAA+E;IAC/E,eAAe;IACf,WAAW;IACX,6GAA6G;EAC/G;EACA,qBAAqB,2BAA2B,EAAE;EAClD,sBAAsB,sBAAsB,EAAE;EAC9C,8EAA8E;EAC9E,2CAA2C,aAAa,EAAE;AAC5D;;AAEA;4EAC4E;AAC5E;EACE,sBAAsB;EACtB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;AACjC;;AAEA;wEACwE;AACxE;EACE,qCAAqC;EACrC,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA,0EAA0E;AAC1E;EACE,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;EACrC,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;+EAI+E;AAC/E;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa,iBAAiB,gCAAgC;EAC9D,cAAc,gBAAgB,+DAA+D;EAC7F,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;AAC/D;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;qEAMqE;AACrE;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;4BAC4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf;sCACoC;AACtC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;uEAGuE;AACvE;EACE,6CAA6C;AAC/C;;AAEA;;;gEAGgE;AAChE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;oCAGoC;AACpC;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;;;;;;EAOE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;yCAGyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,kDAAkD;IAClD,0CAA0C;IAC1C,wCAAwC;IACxC,+DAA+D;IAC/D,yCAAyC;IACzC,WAAW;EACb;AACF;;AAEA;;yBAEyB;;AAEzB;EACE,cAAc,wBAAwB,EAAE;;EAExC;gEAC8D;EAC9D;IACE,UAAU;IACV,MAAM;IACN,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB;;;oDAGgD;IAChD,uDAAuD;IACvD,6DAA6D;EAC/D;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gDAAgD;IAChD,wCAAwC;IACxC,4DAA4D;IAC5D,0CAA0C;IAC1C,WAAW;IACX,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;;;;8DAI8D;AAC9D;EACE,oDAAoD,aAAa,EAAE;EACnE;IACE,gDAAgD;EAClD;EACA;0EACwE;EACxE;IACE;;0EAEsE;IACtE,2DAA2D;IAC3D,+DAA+D;IAC/D,+DAA+D;EACjE;EACA,gFAAgF;EAChF;IACE,4DAA4D;EAC9D;AACF;;AAEA;;;;;+EAK+E;AAC/E,uBAAuB,WAAW,EAAE;;AAEpC,yBAAyB;AACzB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,mDAAmD;AACnD,4BAA4B,aAAa,EAAE;;AAE3C;EACE,4CAA4C;EAC5C;IACE,aAAa;IACb,2BAA2B;IAC3B,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,iCAAiC;IACjC,qBAAqB;IACrB,kEAAkE;IAClE,eAAe;IACf,eAAe;EACjB;EACA,iDAAiD,aAAa,EAAE;EAChE;IACE,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA,yDAAyD;EACzD;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wCAAwC;IACxC,uDAAuD;IACvD,wCAAwC;IACxC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,2FAA2F;IAC3F,cAAc;EAChB;EACA,oCAAoC,wCAAwC,EAAE;EAC9E,qCAAqC,sBAAsB,EAAE;EAC7D;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;IACP,uBAAuB;EACzB;EACA;;;mBAGiB;EACjB;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,wDAAwD;IACxD,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,2FAA2F;EAC7F;EACA;;IAEE,sCAAsC;IACtC,sBAAsB;EACxB;EACA;IACE,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;8DAC4D;EAC5D,kCAAkC,aAAa,EAAE;EACjD;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;;;+EAG+E;AAC/E,+BAA+B,aAAa,EAAE;;AAE9C;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,wCAAwC;EACxC,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,yCAAyC;EACzC,gIAAgI;AAClI;AACA;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,uDAAuD;EACvD,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;6BAE6B;AAC7B;EACE,gBAAgB,mBAAmB,EAAE;EACrC,iCAAiC,eAAe,EAAE,iBAAiB,EAAE;EACrE,6BAA6B,iBAAiB,EAAE,eAAe,EAAE;EACjE,gCAAgC,kBAAkB,EAAE;AACtD;;AAEA;;;;;+EAK+E;AAC/E;EACE,aAAa;AACf;AACA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;IACxC,uDAAuD;IACvD,wCAAwC;IACxC,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mDAAmD;EACrD;EACA,0BAA0B,wCAAwC,EAAE;EACpE,2BAA2B,sBAAsB,EAAE;AACrD;;;AAGA;;;+EAG+E;AAC/E;EACE;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,yDAAyD;EACzD,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E,2BAA2B,qBAAqB,EAAE;AAClD,8CAA8C,aAAa,EAAE;;AAE7D;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ;EACV;EACA,8DAA8D;EAC9D;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA;;;+EAG+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,wCAAwC;EACxC,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,uFAAuF;AACzF;AACA;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,wCAAwC;EACxC,sCAAsC;EACtC,uDAAuD;EACvD,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,+DAA+D;EAC/D,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,4DAA4D;EAC5D,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,uDAAuD;EACvD,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;EACvD,wCAAwC;EACxC,sCAAsC;EACtC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8FAA8F;AAChG;AACA;EACE,wCAAwC;EACxC,0DAA0D;AAC5D;AACA;EACE,wCAAwC;EACxC,yDAAyD;AAC3D;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;AAC5B;;AAEA;;;;+EAI+E;AAC/E;EACE;IACE,2FAA2F;IAC3F,mBAAmB;EACrB;AACF;;AAEA;;;+EAG+E;AAC/E,gBAAgB,qBAAqB,EAAE;AACvC,mCAAmC,aAAa,EAAE;;AAElD;EACE;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;;;AAGA;;;;+EAI+E;AAC/E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uFAAuF;AACzF;AACA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,iFAAiF;AACnF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;;uDAEqD;EACrD;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE;6CACyC;IACzC,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,MAAM;IACN,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,8DAA8D;EAChE;;EAEA,uEAAuE;EACvE,sBAAsB,aAAa,EAAE;EACrC,kFAAkF;EAClF,4BAA4B,YAAY,EAAE,aAAa,EAAE,UAAU,EAAE,WAAW,EAAE;EAClF,2BAA2B,YAAY,EAAE,aAAa,EAAE,cAAc,EAAE,YAAY,EAAE;;EAEtF,8CAA8C;EAC9C;IACE,oEAAoE;IACpE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;EACA,uBAAuB,eAAe,EAAE;EACxC,kBAAkB,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;EAC5E,mBAAmB,iBAAiB,EAAE,oBAAoB,EAAE,eAAe,EAAE;AAC/E;AACA,sBAAsB,YAAY,EAAE;AACpC;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,iBAAiB;EACjB,wCAAwC;EACxC,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;AACzD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB,aAAa,EAAE;AAClC;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA,+BAA+B,mBAAmB,EAAE;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;8EAC8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;AACA;;;oEAGoE;AACpE;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE;iEAC+D;EAC/D,SAAS;EACT,SAAS;EACT,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA,+CAA+C,eAAe,EAAE;AAChE,0CAA0C,iBAAiB,EAAE,oBAAoB,EAAE;AACnF,2CAA2C,iBAAiB,EAAE,oBAAoB,EAAE;AACpF;EACE,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACxF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;EACvD,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,iEAAiE;AACnE;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA,uBAAuB,0BAA0B,EAAE;AACnD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;EACnD,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mDAAmD;EACnD,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AACA,uBAAuB,6BAA6B,EAAE;;AAEtD,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,uCAAuC;AACzC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,0DAA0D;AAC5D;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0DAA0D;EAC1D,iCAAiC;AACnC;AACA,kBAAkB,wCAAwC,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qDAAqD;AACvD;AACA,iCAAiC,UAAU,EAAE;AAC7C;EACE,sCAAsC;EACtC,WAAW;EACX,wCAAwC;AAC1C;;AAEA,oDAAoD;AACpD;EACE,iDAAiD;AACnD;;AAEA,6EAA6E;AAC7E;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,MAAM;EACN,kDAAkD;AACpD;AACA;;;EAGE,2BAA2B;AAC7B;AACA;EACE;IACE,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;;AAGA;;;;;6EAK6E;;AAE7E,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf;;yCAEuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA,yBAAyB,wBAAwB,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;EACtC,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,0DAA0D;AAC5D;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;AACA,gCAAgC,aAAa,EAAE;AAC/C;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA,wBAAwB,wBAAwB,EAAE,cAAc,EAAE;;AAElE,mDAAmD;AACnD;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gDAAgD;EAClD;AACF;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT;uCACqC;EACrC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,SAAS,EAAE,OAAO;EAC1B,UAAU;EACV,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA,8BAA8B,uBAAuB,EAAE;AACvD;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,6BAA6B;EAC7B;yCACuC;AACzC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,iDAAiD;EACjD,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,+DAA+D;AACjE;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;AACA,sBAAsB,SAAS,EAAE,UAAU,GAAG,eAAe,EAAE,gBAAgB,EAAE;AACjF,sBAAsB,SAAS,EAAE,WAAW,EAAE,cAAc,GAAG,gBAAgB,EAAE;AACjF,sBAAsB,YAAY,EAAE,UAAU,GAAG,eAAe,EAAE,aAAa,EAAE;AACjF,sBAAsB,YAAY,EAAE,WAAW,EAAE,cAAc,GAAG,aAAa,EAAE;AACjF;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;AACtC;AACA,wBAAwB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAChE;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,iDAAiD;EACjD,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf;2CACyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf;wCACsC;AACxC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,6BAA6B;EAC7B;yCACuC;AACzC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,iDAAiD;AACnD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,2DAA2D;AAC7D;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,oEAAoE;AACtE;AACA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,+DAA+D;AACjE;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,oBAAoB,EAAE,SAAS,EAAE;EACpD,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;EACxD,mBAAmB,eAAe,EAAE;EACpC,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,eAAe,EAAE;AACtC;;AAEA,iFAAiF;AACjF,0BAA0B,aAAa,EAAE,2CAA2C,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC5H,sCAAsC,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC1F,gCAAgC,gBAAgB,EAAE,+BAA+B,EAAE,eAAe,EAAE;AACpG,+BAA+B,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAC7G,kCAAkC,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,eAAe,EAAE,eAAe,EAAE;AAC/G,iCAAiC,eAAe,EAAE,sBAAsB,EAAE;AAC1E,+BAA+B,gBAAgB,EAAE,kBAAkB,EAAE,2CAA2C,EAAE,sBAAsB,EAAE,eAAe,EAAE,YAAY,EAAE;AACzK,yCAAyC,eAAe,EAAE,sBAAsB,EAAE;AAClF,iCAAiC,iCAAiC,EAAE,eAAe,EAAE;;AAErF,iFAAiF;AACjF,iCAAiC,eAAe,EAAE;;AAElD,oFAAoF;AACpF,wBAAwB,UAAU,EAAE,6CAA6C,EAAE;AACnF;kDACkD,UAAU,EAAE;AAC9D,oBAAoB,8BAA8B,EAAE;AACpD;yCACyC,oBAAoB,EAAE;;AAE/D;;kFAEkF;AAClF;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;AACA,4BAA4B,yBAAyB,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,wFAAwF;AAC1F;AACA,sBAAsB,+BAA+B,EAAE,qCAAqC,EAAE;AAC9F,8BAA8B,oCAAoC,EAAE,mBAAmB,EAAE;;AAEzF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,wEAAwE;EACxE,+BAA+B;AACjC;;AAEA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,SAAO,EAAE;AACpF;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,wEAAwE;AACxE;EACE,8DAA8D;EAC9D,oBAAoB;AACtB;AACA;2CAC2C,oBAAoB,EAAE;;AAEjE,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;AAChB;AACA,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC1H,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AACzF,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,mCAAmC,EAAE,0BAA0B,EAAE;AACjM,gCAAgC,WAAW,EAAE,YAAY,EAAE;AAC3D,yBAAyB,SAAS,EAAE,iCAAiC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACtI,4BAA4B,uBAAuB,EAAE,2BAA2B,EAAE;AAClF,wBAAwB,eAAe,EAAE,8BAA8B,EAAE;AACzE,+BAA+B,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC9E;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC9E,uBAAuB,aAAa,EAAE,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACpF,4DAA4D,aAAa,EAAE,QAAQ,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACzJ;EACE,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,eAAe;EAC1F,+BAA+B,EAAE,6BAA6B,EAAE,aAAa;AAC/E;AACA,gCAAgC,eAAe,EAAE;AACjD,sBAAsB,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,eAAe,EAAE,mCAAmC,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,eAAe,EAAE,gEAAgE,EAAE;AACxR,mCAAmC,uBAAuB,EAAE,6BAA6B,EAAE,qCAAqC,EAAE;AAClI,4BAA4B,wBAAwB,EAAE;AACtD,mHAAmH,mCAAmC,EAAE,mBAAmB,EAAE;AAC7K,0BAA0B,aAAa,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AACrE,gCAAgC,mBAAmB,EAAE,WAAW,EAAE,8BAA8B,EAAE;AAClG,oBAAoB,oBAAoB,EAAE,YAAY,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAClJ,2BAA2B,SAAS,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC1K,qCAAqC,+BAA+B,EAAE,8BAA8B,EAAE,4BAA4B,EAAE;AACpI,uBAAuB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACxH,sBAAsB,mBAAmB,EAAE,aAAa,EAAE,aAAa,EAAE,QAAQ,EAAE;AACnF,2BAA2B,8BAA8B,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAChJ,6BAA6B,iCAAiC,EAAE,cAAc,EAAE;AAChF,4BAA4B,8BAA8B,EAAE;AAC5D,yCAAyC,0BAA0B,EAAE;AACrE,wCAAwC,0BAA0B,EAAE;AACpE,yBAAyB,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE;AACjH,oBAAoB,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE;AACxE,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,qEAAqE,EAAE;AACpI,gCAAgC,8BAA8B,EAAE,2BAA2B,EAAE;AAC7F,qBAAqB,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AAC5L,2BAA2B,WAAW,EAAE,YAAY,EAAE;AACtD,0BAA0B,WAAW,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AACnJ,qBAAqB,WAAW,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC/E,+CAA+C,kBAAkB,EAAE,0CAA0C,EAAE,gBAAgB,EAAE;AACjI,wBAAwB,+BAA+B,EAAE,8BAA8B,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC5J,wBAAwB,aAAa,EAAE,SAAS,EAAE;AAClD,8BAA8B,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,kBAAkB,EAAE,aAAa,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAC5N,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,iCAAiC,EAAE,8BAA8B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEnO,0EAA0E;AAC1E,+BAA+B,wBAAwB,EAAE,mBAAmB,EAAE;AAC9E,+CAA+C,mBAAmB,EAAE;AACpE,qDAAqD,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACrG,yDAAyD,WAAW,EAAE,YAAY,EAAE;AACpF,kDAAkD,mCAAmC,EAAE;AACvF,iDAAiD,eAAe,EAAE,eAAe,EAAE;AACnF,8BAA8B,mBAAmB,EAAE,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACjG,2CAA2C,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,UAAU,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9K,gDAAgD,mBAAmB,EAAE;AACrE,uDAAuD,eAAe,EAAE,iBAAiB,EAAE,yBAAyB,EAAE;AACtH,sDAAsD,mBAAmB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,cAAc,EAAE,+BAA+B,EAAE;AACrL,4DAA4D,WAAW,EAAE,SAAS,EAAE;AACpF,wEAAwE,gBAAgB,EAAE,SAAS,EAAE,uBAAuB,EAAE,eAAe,EAAE;AAC/I,4DAA4D,YAAY,EAAE,mBAAmB,EAAE;AAC/F,sCAAsC,eAAe,EAAE,YAAY,EAAE;AACrE,qCAAqC,WAAW,EAAE,YAAY,EAAE,kCAAkC,EAAE,+BAA+B,EAAE;AACrI,kDAAkD,gBAAgB,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;;AAEhH,uBAAuB,kBAAkB,EAAE;AAC3C,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChK,gCAAgC,WAAW,EAAE,YAAY,EAAE,uBAAuB,EAAE;AACpF,6BAA6B,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AACzG,qCAAqC,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AACnL,kCAAkC,8BAA8B,EAAE,eAAe,EAAE,yBAAyB,EAAE;AAC9G,oCAAoC,mCAAmC,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAC7H,mCAAmC,8BAA8B,EAAE,eAAe,EAAE;AACpF,iDAAiD,0BAA0B,EAAE;AAC7E,gDAAgD,0BAA0B,EAAE;;AAE5E,qBAAqB,kBAAkB,EAAE;AACzC,8BAA8B,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AAC1G,sCAAsC,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE,aAAa,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAC5M,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,iCAAiC,EAAE,uBAAuB,EAAE;AAC3L,+BAA+B,WAAW,EAAE,YAAY,EAAE;AAC1D,wDAAwD,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE;AAC/F,oCAAoC,8BAA8B,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACxJ,qCAAqC,gBAAgB,EAAE,iCAAiC,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,kCAAkC,EAAE;AAC/L,qHAAqH,0BAA0B,EAAE;AACjJ,mHAAmH,0BAA0B,EAAE;AAC/I,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,SAAS,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/L,gDAAgD,kBAAkB,EAAE,8BAA8B,EAAE,eAAe,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACvK,oEAAoE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC3J,sEAAsE,+BAA+B,EAAE;AACvG,kEAAkE,+BAA+B,EAAE;AACnG,0DAA0D,aAAa,EAAE,WAAW,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,+BAA+B,EAAE;;AAE/J,8CAA8C,aAAa,EAAE,SAAS,EAAE;AACxE,uBAAuB,UAAU,EAAE,gBAAgB,EAAE;AACrD,+BAA+B,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,yCAAyC,EAAE;AAC9J,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,iCAAiC,EAAE,uBAAuB,EAAE;AAC/L,mCAAmC,WAAW,EAAE,YAAY,EAAE;AAC9D,iCAAiC,aAAa,EAAE,QAAQ,EAAE;AAC1D,wCAAwC,eAAe,EAAE;AACzD,uCAAuC,8BAA8B,EAAE,eAAe,EAAE;AACxF,8BAA8B,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAC3F,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,iBAAiB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AAC/L,0BAA0B,8BAA8B,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAC9I,2BAA2B,eAAe,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAChG,uCAAuC,0BAA0B,EAAE;AACnE,sCAAsC,0BAA0B,EAAE;AAClE,6BAA6B,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE;AACtE,4BAA4B,kBAAkB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAC1I,8CAA8C,aAAa,EAAE,eAAe,EAAE,qBAAqB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnI,qDAAqD,8BAA8B,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAC1K,mCAAmC,0BAA0B,EAAE,eAAe,EAAE,cAAc,EAAE;AAChG,kCAAkC,8BAA8B,EAAE,eAAe,EAAE;AACnF,oCAAoC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChL,2CAA2C,oBAAoB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3G,kDAAkD,gBAAgB,EAAE;AACpE,2CAA2C,mBAAmB,EAAE;AAChE,wCAAwC,mBAAmB,EAAE;AAC7D,6CAA6C,mBAAmB,EAAE;AAClE,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,SAAS,EAAE,oBAAoB,EAAE,qDAAqD,EAAE,WAAW,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7R,6BAA6B,WAAW,EAAE,YAAY,EAAE;AACxD,kCAAkC,YAAY,EAAE,YAAY,EAAE;AAC9D,uIAAuI,0BAA0B,EAAE,mBAAmB,EAAE;AACxL,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE,mEAAmE,EAAE,mBAAmB,EAAE,+DAA+D,EAAE;AACvN,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,iBAAiB,EAAE,0EAA0E,EAAE,gEAAgE,EAAE;AACjR,+FAA+F,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC7I,4BAA4B,WAAW,EAAE,YAAY,EAAE;AACvD,qCAAqC,gBAAgB,EAAE,oBAAoB,EAAE,wDAAwD,EAAE,cAAc,EAAE;AACvJ,+BAA+B,SAAS,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,aAAa,EAAE,eAAe,EAAE;AACpI,8BAA8B,kBAAkB,EAAE;AAClD,0BAA0B,SAAS,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AAC/E,mCAAmC,oBAAoB,EAAE;;AAEzD,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnM,wEAAwE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC7H,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D,oCAAoC,gBAAgB,EAAE,oBAAoB,EAAE,iCAAiC,EAAE,uBAAuB,EAAE,eAAe,EAAE;AACzJ,+BAA+B,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAC3I,uCAAuC,aAAa,EAAE,uEAAuE,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,0CAA0C,EAAE;AAC9N,kDAAkD,gBAAgB,EAAE;AACpE,+BAA+B,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE;AACtE,sCAAsC,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvH,qCAAqC,gBAAgB,EAAE,8BAA8B,EAAE,cAAc,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrJ,mCAAmC,WAAW,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;AACtH,qCAAqC,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,4BAA4B,EAAE;AACzH,gEAAgE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/I,oCAAoC,8BAA8B,EAAE,gCAAgC,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACzI,8BAA8B,aAAa,EAAE,8BAA8B,EAAE,kBAAkB,EAAE;;AAEjG,gCAAgC,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AAC5I,sDAAsD,uCAAuC,EAAE;AAC/F,oCAAoC,aAAa,EAAE,+EAA+E,EAAE,mBAAmB,EAAE,SAAS,EAAE,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,uBAAuB,EAAE,6BAA6B,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC3S,yFAAyF,iCAAiC,EAAE;AAC5H,qCAAqC,gBAAgB,EAAE,oBAAoB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACvM,wBAAwB,gBAAgB,EAAE,oBAAoB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClG,sCAAsC,wDAAwD,EAAE,cAAc,EAAE;AAChH,mCAAmC,wDAAwD,EAAE,+BAA+B,EAAE;AAC9H,wCAAwC,wDAAwD,EAAE,cAAc,EAAE;AAClH,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,oBAAoB,EAAE,+BAA+B,EAAE,8BAA8B,EAAE,cAAc,EAAE;AAC5M,oCAAoC,WAAW,EAAE,YAAY,EAAE,8BAA8B,EAAE,sCAAsC,EAAE;AACvI,yEAAyE,yBAAyB,EAAE;AACpG,2BAA2B,mBAAmB,EAAE,gBAAgB,EAAE,yCAAyC,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AACnK,oCAAoC,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,yCAAyC,EAAE,iCAAiC,EAAE;AACrL,2CAA2C,gBAAgB,EAAE,oBAAoB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,cAAc,EAAE;AACrK,2CAA2C,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,SAAS,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,aAAa,EAAE,eAAe,EAAE;AACxN,wCAAwC,WAAW,EAAE,YAAY,EAAE;AACnE,kCAAkC,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,kBAAkB,EAAE,yCAAyC,EAAE;AAC5I,yCAAyC,aAAa,EAAE,QAAQ,EAAE;AAClE,wCAAwC,8BAA8B,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACnH,yCAAyC,eAAe,EAAE;AAC1D,mCAAmC,iBAAiB,EAAE,gBAAgB,EAAE;AACxE,2CAA2C,aAAa,EAAE,oDAAoD,EAAE,kBAAkB,EAAE,SAAS,EAAE,kBAAkB,EAAE,0CAA0C,EAAE;AAC/M,sDAAsD,gBAAgB,EAAE;AACxE,wCAAwC,8BAA8B,EAAE,gCAAgC,EAAE,eAAe,EAAE;AAC3H,2BAA2B,0BAA0B,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACpG,+DAA+D,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE;AACtG,kDAAkD,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnI,iDAAiD,8BAA8B,EAAE,cAAc,EAAE;AACjG,8CAA8C,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC3K,6CAA6C,eAAe,EAAE,iBAAiB,EAAE;AACjF,uCAAuC,SAAS,EAAE,aAAa,EAAE,8BAA8B,EAAE,kBAAkB,EAAE;;AAErH,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,yCAAyC,EAAE;AAC7I,mDAAmD,aAAa,EAAE,QAAQ,EAAE;AAC5E,yDAAyD,8BAA8B,EAAE,eAAe,EAAE;AAC1G,iDAAiD,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,iCAAiC,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3M,+BAA+B,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACjI,iDAAiD,aAAa,EAAE;AAChE,wDAAwD,eAAe,EAAE;AACzE,iCAAiC,uBAAuB,EAAE;AAC1D,oCAAoC,eAAe,EAAE,8BAA8B,EAAE,eAAe,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACxJ,yCAAyC,aAAa,EAAE,wDAAwD,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,eAAe,EAAE;AAC9Q,mDAAmD,eAAe,EAAE;AACpE,gDAAgD,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrG,6CAA6C,WAAW,EAAE,YAAY,EAAE,8BAA8B,EAAE;AACxG,2CAA2C,8BAA8B,EAAE;AAC3E,gDAAgD,0BAA0B,EAAE;AAC5E,+CAA+C,0BAA0B,EAAE;;AAE3E;EACE,uBAAuB,gDAAgD,EAAE;EACzE,8BAA8B,gDAAgD,EAAE;EAChF,8BAA8B,WAAW,EAAE,iBAAiB,EAAE;AAChE;AACA;EACE,oBAAoB,uBAAuB,EAAE;EAC7C,sBAAsB,uBAAuB,EAAE,sBAAsB,EAAE;EACvE,8EAA8E,WAAW,EAAE;EAC3F,0DAA0D,cAAc,EAAE,WAAW,EAAE;EACvF,0BAA0B,eAAe,EAAE;EAC3C,gCAAgC,aAAa,EAAE;EAC/C,uBAAuB,8BAA8B,EAAE,SAAS,EAAE;EAClE,8BAA8B,0BAA0B,EAAE;EAC1D,+CAA+C,mBAAmB,EAAE;EACpE,uFAAuF,WAAW,EAAE;EACpG,uDAAuD,SAAO,EAAE;EAChE,2DAA2D,8BAA8B,EAAE;EAC3F,8BAA8B,8BAA8B,EAAE;EAC9D,iDAAiD,mBAAmB,EAAE;EACtE,8BAA8B,cAAc,EAAE;EAC9C,oCAAoC,WAAW,EAAE,cAAc,EAAE;EACjE,yBAAyB,cAAc,EAAE;EACzC,uCAAuC,0CAA0C,EAAE;EACnF,mCAAmC,mBAAmB,EAAE,WAAW,EAAE;EACrE,oCAAoC,aAAa,EAAE;EACnD,yCAAyC,+BAA+B,EAAE,aAAa,EAAE;EACzF,oCAAoC,oDAAoD,EAAE;EAC1F,qEAAqE,mBAAmB,EAAE,WAAW,EAAE;EACvG,kCAAkC,aAAa,EAAE;EACjD,2CAA2C,+CAA+C,EAAE;EAC5F,4DAA4D,aAAa,EAAE;AAC7E;AACA;EACE,+CAA+C,gBAAgB,EAAE;EACjE,gCAAgC,eAAe,EAAE;AACnD;;AAEA;;;;;;+EAM+E;AAC/E;;;EAGE,uCAAuC;AACzC","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────────\n   TeamLio Global Theme — single unified design system\n   ─────────────────────────────────────────────────────────────────────────\n   The task management aesthetic, applied across the whole project:\n   warm cream surfaces, dark forest green primary, Plus Jakarta Sans display\n   font, Fraunces serif italic accents, soft rounded surfaces, no glass.\n   ──────────────────────────────────────────────────────────────────────── */\n\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400;1,9..144,500;1,9..144,600&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n\n/* ════════════════════════════════════════════════════════════════════════════\n   DESIGN TOKENS — single source of truth\n   ────────────────────────────────────────────────────────────────────────────\n\n   This block defines EVERY design token used in the app:\n     • Colours (surfaces, text, borders, brand, accent, status, priority…)\n     • Typography (font families, letter-spacing)\n     • Radii, shadows, transitions\n     • Layout sizing, density\n\n   Theming model:\n     • :root                       → light theme (default)\n     • [data-theme=\"dark\"]         → dark theme\n     • [data-theme=\"hc\"]           → high-contrast theme\n     • Add more themes by adding a [data-theme=\"...\"] block below.\n\n   How to switch the active theme at runtime:\n     Set `data-theme=\"<name>\"` on <html>. The helper in src/lib/theme.ts does\n     this + persists the choice to localStorage. The picker UI lives in\n     ProfileTab.tsx.\n\n   Variable naming:\n     • --gt-* tokens drive the global shell (tasks, calendar, sidebar, …).\n     • --gc-* tokens drive the chat surfaces.\n     They are kept side-by-side so one theme override updates both palettes\n     and chat + the rest of the app stay visually unified.\n   ════════════════════════════════════════════════════════════════════════════ */\n\n:root {\n\n  /* ── GLOBAL THEME (--gt-*) ─────────────────────────────────────────────── */\n\n  /* Surfaces */\n  --gt-surface-0: #ffffff;\n  --gt-surface-1: #ffffff;\n  --gt-surface-2: #f5f5f5;\n  --gt-surface-3: #e7e7e7;\n  --gt-surface-hover: rgba(15, 45, 31, 0.04);\n  --gt-surface-rail: #ffffff;\n  --gt-surface-rail-soft: #ffffff;\n\n  /* Brand */\n  --gt-primary: #0f2d1f;\n  --gt-primary-hover: #0a1f15;\n  --gt-primary-soft: #1f4030;\n  --gt-primary-deep: #061812;\n  --gt-primary-container: #e8efe9;\n  --gt-primary-container-hover: #d4ddd6;\n  --gt-on-primary: #ffffff;\n\n  /* Accent */\n  --gt-accent: #1f4030;\n  --gt-accent-soft: #d4ddd6;\n  --gt-accent-strong: #0f2d1f;\n\n  /* Text */\n  --gt-text-primary: #1a1a1a;\n  --gt-text-secondary: #4a4a4a;\n  --gt-text-tertiary: #8a8580;\n  --gt-text-muted: #6b7280;\n  --gt-text-disabled: #b8b3ac;\n  --gt-text-link: #0f2d1f;\n\n  /* Borders */\n  --gt-border: #e8e3d8;\n  --gt-border-strong: #d6d0c2;\n  --gt-divider: #efeae0;\n\n  /* Status */\n  --gt-online: #2f9e6c;\n  --gt-away: #d4a356;\n  --gt-dnd: #c4574c;\n  --gt-offline: #b8b3ac;\n\n  /* Priority */\n  --gt-prio-urgent-bg: #fee2e2;\n  --gt-prio-urgent-fg: #991b1b;\n  --gt-prio-urgent-dot: #dc2626;\n  --gt-prio-high-bg:  #ffedd5;\n  --gt-prio-high-fg:  #9a3412;\n  --gt-prio-high-dot: #ea580c;\n  --gt-prio-med-bg:   #fef3c7;\n  --gt-prio-med-fg:   #854d0e;\n  --gt-prio-med-dot:  #d97706;\n  --gt-prio-low-bg:   #dbeafe;\n  --gt-prio-low-fg:   #1e3a8a;\n  --gt-prio-low-dot:  #2563eb;\n\n  /* Status pills */\n  --gt-status-pending-bg:   #f4f1ea;\n  --gt-status-pending-fg:   #6a665e;\n  --gt-status-progress-bg:  #e8eef6;\n  --gt-status-progress-fg:  #2f4a73;\n  --gt-status-progress-dot: #6a8bbd;\n  --gt-status-done-bg:      #e8efe9;\n  --gt-status-done-fg:      #0f2d1f;\n  --gt-status-overdue-bg:   #fdecea;\n  --gt-status-overdue-fg:   #a83c34;\n\n  /* Shared UI palette */\n  --gt-white:        #ffffff;\n  --gt-green-100:    #dcfce7;\n  --gt-green-500:    #22c55e;\n  --gt-green-600:    #16a34a;\n  --gt-green-700:    #15803d;\n  --gt-green-800:    #166534;\n  --gt-green-soft:   #e7f0ea;\n  --gt-green-muted:  #86b89a;\n  --gt-red-100:      #fee2e2;\n  --gt-red-500:      #ef4444;\n  --gt-red-600:      #dc2626;\n  --gt-red-700:      #b91c1c;\n  --gt-red-800:      #991b1b;\n  --gt-amber-100:    #fef3c7;\n  --gt-amber-500:    #f59e0b;\n  --gt-amber-600:    #d97706;\n  --gt-amber-800:    #92400e;\n  --gt-amber-900:    #854d0e;\n  --gt-orange-100:   #ffedd5;\n  --gt-orange-500:   #f97316;\n  --gt-orange-600:   #ea580c;\n  --gt-orange-800:   #9a3412;\n  --gt-blue-100:     #dbeafe;\n  --gt-blue-500:     #3b82f6;\n  --gt-blue-600:     #2563eb;\n  --gt-blue-800:     #1e40af;\n  --gt-blue-900:     #1e3a8a;\n  --gt-purple-100:   #f3e8ff;\n  --gt-purple-500:   #a855f7;\n  --gt-purple-600:   #9333ea;\n  --gt-purple-800:   #6b21a8;\n  --gt-emerald-500:  #10b981;\n  --gt-emerald-600:  #059669;\n  --gt-cyan-600:     #0891b2;\n  --gt-indigo-500:   #6366f1;\n  --gt-violet-500:   #8b5cf6;\n  --gt-violet-600:   #7c3aed;\n  --gt-teal-500:     #14b8a6;\n  --gt-teal-600:     #0d9488;\n  --gt-yellow-500:   #eab308;\n  --gt-gray-500:     #6b7280;\n  --gt-gray-700:     #374151;\n  --gt-slate-100:    #f1f5f9;\n  --gt-slate-200:    #eef1f5;\n  --gt-slate-400:    #94a3b8;\n  --gt-slate-600:    #475569;\n  --gt-slate-700:    #334155;\n  --gt-overlay-white-22: rgba(255, 255, 255, 0.22);\n  --gt-overlay-red-18:   rgba(220, 38, 38, 0.18);\n  --gt-overlay-slate-28: rgba(15, 23, 42, 0.28);\n  --gt-overlay-slate-55: rgba(15, 23, 42, 0.55);\n  --gt-overlay-blue-25:  rgba(37, 99, 235, 0.25);\n  --gt-overlay-green-25: rgba(22, 163, 74, 0.25);\n\n  /* Elevation */\n  --gt-elev-1: 0 1px 2px rgba(20, 20, 18, 0.04);\n  --gt-elev-2: 0 2px 8px rgba(20, 20, 18, 0.05), 0 1px 2px rgba(20, 20, 18, 0.04);\n  --gt-elev-3: 0 8px 24px -6px rgba(20, 20, 18, 0.08), 0 2px 6px rgba(20, 20, 18, 0.04);\n  --gt-elev-4: 0 16px 40px -10px rgba(20, 20, 18, 0.12), 0 4px 10px rgba(20, 20, 18, 0.06);\n  --gt-elev-5: 0 28px 64px -14px rgba(20, 20, 18, 0.16), 0 8px 16px rgba(20, 20, 18, 0.08);\n  --gt-glow: 0 4px 14px -4px rgba(15, 45, 31, 0.18);\n  --gt-glow-soft: 0 2px 8px -3px rgba(15, 45, 31, 0.12);\n\n  /* Radius */\n  --gt-radius-card: 18px;\n  --gt-radius-modal: 22px;\n  --gt-radius-sheet: 24px;\n  --gt-radius-pill: 9999px;\n  --gt-radius-input: 14px;\n\n  /* Typography */\n  --gt-font: 'Plus Jakarta Sans', 'Inter', 'Segoe UI', system-ui, sans-serif;\n  --gt-font-display: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;\n  --gt-font-serif: 'Fraunces', 'Iowan Old Style', Georgia, serif;\n  --gt-font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;\n  --gt-letter-display: -0.025em;\n  --gt-letter-eyebrow: 0.10em;\n\n  /* Transitions */\n  --gt-t-fast: 150ms cubic-bezier(0.33, 1, 0.68, 1);\n  --gt-t-mid:  240ms cubic-bezier(0.33, 1, 0.68, 1);\n  --gt-t-slow: 360ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Glass aliases (kept solid) */\n  --gt-glass-soft: #ffffff;\n  --gt-glass-mid:  #ffffff;\n  --gt-glass-firm: #ffffff;\n  --gt-glass-mint: #f4f1ea;\n  --gt-glass-edge: #e8e3d8;\n  --gt-grad-from: #1f4030;\n  --gt-grad-via:  #143020;\n  --gt-grad-to:   #0f2d1f;\n  --gt-grad-aurora: #0f2d1f;\n  --gt-grad-aurora-soft: #e8efe9;\n\n  /* Heatmap */\n  --gt-heat-0: #f4f1ea;\n  --gt-heat-1: #e8efe9;\n  --gt-heat-2: #d4ddd6;\n  --gt-heat-3: #9eb3a4;\n  --gt-heat-4: #4d6857;\n  --gt-heat-5: #0f2d1f;\n\n\n  /* ── CHAT (--gc-*) ─────────────────────────────────────────────────────── */\n\n  /* Surfaces */\n  --gc-surface-0: #ffffff;\n  --gc-surface-1: #ffffff;\n  --gc-surface-2: #fafafa;\n  --gc-surface-3: #e7e7e7;\n  --gc-surface-hover: rgba(31, 46, 35, 0.045);\n  --gc-surface-rail: #dcefe1;\n  --gc-surface-rail-soft: #ecf6ee;\n\n  /* Brand: deep forest */\n  --gc-primary: #1f2e23;\n  --gc-primary-hover: #15211a;\n  --gc-primary-soft: #2a3d30;\n  --gc-primary-container: #dcefe1;\n  --gc-primary-container-hover: #c8e3cf;\n  --gc-on-primary: #f7faf6;\n\n  /* Sent bubble */\n  --gc-bubble-mine-bg: #2f4a3c;\n  --gc-bubble-mine-bg-hover: #355241;\n  --gc-bubble-mine-text: #f4faf6;\n\n  /* Accent */\n  --gc-accent: #10b981;\n  --gc-accent-soft: #d1fae5;\n  --gc-accent-strong: #047857;\n\n  /* Text */\n  --gc-text-primary: #000000;\n  --gc-text-secondary: #3d4a42;\n  --gc-text-tertiary: #6b766f;\n  --gc-text-disabled: #9ba49d;\n  --gc-text-link: #047857;\n  --gc-text-on-rail: #1f2e23;\n  --gc-text-on-rail-mute: #4b5b51;\n\n  /* Status */\n  --gc-online: #10b981;\n  --gc-away: #f59e0b;\n  --gc-dnd: #dc2626;\n  --gc-offline: #9ba49d;\n  --gc-meeting: #047857;\n  --gc-info: #1f2e23;\n\n  /* Borders & Dividers */\n  --gc-border: #e3ebe0;\n  --gc-border-strong: #cdd8c9;\n  --gc-divider: #ecf0e9;\n\n  /* Mention / Highlight */\n  --gc-mention-bg: #fef3c7;\n  --gc-mention-text: #854d0e;\n  --gc-mention-channel-bg: #fee2e2;\n  --gc-mention-channel-text: #991b1b;\n  --gc-self-mention-bg: #d1fae5;\n  --gc-self-mention-text: #047857;\n\n  /* Elevation */\n  --gc-elev-0: none;\n  --gc-elev-1: 0 1px 2px rgba(15, 29, 20, 0.05), 0 1px 3px rgba(15, 29, 20, 0.03);\n  --gc-elev-2: 0 2px 8px rgba(15, 29, 20, 0.06), 0 1px 2px rgba(15, 29, 20, 0.04);\n  --gc-elev-3: 0 8px 24px rgba(15, 29, 20, 0.08), 0 2px 6px rgba(15, 29, 20, 0.05);\n  --gc-elev-4: 0 16px 40px rgba(15, 29, 20, 0.10), 0 4px 12px rgba(15, 29, 20, 0.06);\n  --gc-elev-5: 0 28px 64px rgba(15, 29, 20, 0.14), 0 10px 20px rgba(15, 29, 20, 0.08);\n\n  /* Layout */\n  --gc-rail-width: 72px;\n  --gc-sidebar-width: 340px;\n  --gc-sidebar-min: 260px;\n  --gc-sidebar-max: 480px;\n  --gc-thread-width: 360px;\n  --gc-thread-min: 280px;\n  --gc-thread-max: 600px;\n\n  /* Density: Comfortable (default) */\n  --gc-msg-row-height: 36px;\n  --gc-msg-padding-v: 6px;\n  --gc-msg-padding-h: 16px;\n  --gc-avatar-size: 36px;\n\n  /* Border Radius */\n  --gc-radius-card: 14px;\n  --gc-radius-modal: 16px;\n  --gc-radius-sheet: 22px;\n  --gc-radius-pill: 9999px;\n  --gc-radius-avatar: 50%;\n  --gc-radius-bubble: 18px;\n\n  /* Typography */\n  --gc-font: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;\n  --gc-font-display: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;\n  --gc-font-serif: 'Fraunces', 'Iowan Old Style', Georgia, serif;\n  --gc-font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;\n  --gc-font-size-base: 14px;\n  --gc-line-height: 1.55;\n  --gc-font-size-sm: 12.5px;\n  --gc-font-size-xs: 11px;\n  --gc-letter-display: -0.02em;\n  --gc-letter-eyebrow: 0.08em;\n\n  /* Transitions */\n  --gc-transition-fast: 120ms cubic-bezier(0.33, 1, 0.68, 1);\n  --gc-transition-mid: 220ms cubic-bezier(0.33, 1, 0.68, 1);\n  --gc-transition-slow: 360ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Presence pill — used in Employees rows + ChatHeader DM line */\n  --gc-status-online-bg:   #dcfce7;\n  --gc-status-online-fg:   #14532d;\n  --gc-status-online-dot:  #10b981;\n  --gc-status-offline-bg:  #f1f5f9;\n  --gc-status-offline-fg:  #475569;\n  --gc-status-offline-dot: #94a3b8;\n  --gc-status-away-bg:     #fef9c3;\n  --gc-status-away-fg:     #713f12;\n  --gc-status-away-dot:    #eab308;\n  --gc-status-leave-bg:    #fef3c7;\n  --gc-status-leave-fg:    #78350f;\n  --gc-status-leave-dot:   #f59e0b;\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   DARK THEME\n   ════════════════════════════════════════════════════════════════════════════ */\n[data-theme=\"dark\"] {\n  color-scheme: dark;\n\n  /* Global (--gt-*) — neutral black/charcoal surfaces (no green tint) */\n  --gt-surface: #141414;\n  --gt-surface-0: #141414;\n  --gt-surface-1: #0a0a0a;\n  --gt-surface-2: #1c1c1c;\n  --gt-surface-3: #2a2a2a;\n  --gt-surface-hover: rgba(255, 255, 255, 0.06);\n  --gt-surface-rail: #141414;\n  --gt-surface-rail-soft: #1a1a1a;\n\n  --gt-primary: #059669;\n  --gt-primary-hover: #047857;\n  --gt-primary-soft: #b9d6c0;\n  --gt-primary-deep: #ecf6ee;\n  --gt-primary-container: #1f2e23;\n  --gt-primary-container-hover: #28392d;\n  --gt-on-primary: #ffffff;\n\n  --gt-accent: #6ee7b7;\n  --gt-accent-soft: #1f2e23;\n  --gt-accent-strong: #a7f3d0;\n\n  --gt-text-primary: #ededed;\n  --gt-text-secondary: #c7c7c7;\n  --gt-text-tertiary: #8f8f8f;\n  --gt-text-muted: #8f8f8f;\n  --gt-text-disabled: #5e5e5e;\n  --gt-text-link: #6ee7b7;\n\n  --gt-border: #2a2a2a;\n  --gt-border-strong: #3a3a3a;\n  --gt-divider: #1e1e1e;\n\n  --gt-status-pending-bg:   #1d2820;\n  --gt-status-pending-fg:   #c4cfc6;\n  --gt-status-progress-bg:  #1c2738;\n  --gt-status-progress-fg:  #cbd9ec;\n  --gt-status-done-bg:      #1f2e23;\n  --gt-status-done-fg:      #dcefe1;\n  --gt-status-overdue-bg:   #2a1717;\n  --gt-status-overdue-fg:   #f5b3aa;\n\n  /* Priority palette — dark values (light defaults are cream/pink and were\n     bleeding through via the .bg-amber-50/.bg-red-50 → prio compat mappings,\n     e.g. the pinned-messages bar). Dark bg + light fg. */\n  --gt-prio-urgent-bg: #2a1717;\n  --gt-prio-urgent-fg: #f5b3aa;\n  --gt-prio-urgent-dot: #f87171;\n  --gt-prio-high-bg:  #2a1d10;\n  --gt-prio-high-fg:  #fdba74;\n  --gt-prio-high-dot: #fb923c;\n  --gt-prio-med-bg:   #2a2410;\n  --gt-prio-med-fg:   #fcd34d;\n  --gt-prio-med-dot:  #fbbf24;\n  --gt-prio-low-bg:   #15233a;\n  --gt-prio-low-fg:   #93c5fd;\n  --gt-prio-low-dot:  #60a5fa;\n\n  --gt-elev-1: 0 1px 2px rgba(0, 0, 0, 0.30);\n  --gt-elev-2: 0 2px 8px rgba(0, 0, 0, 0.35), 0 1px 2px rgba(0, 0, 0, 0.30);\n  --gt-elev-3: 0 8px 24px -6px rgba(0, 0, 0, 0.45), 0 2px 6px rgba(0, 0, 0, 0.30);\n  --gt-elev-4: 0 16px 40px -10px rgba(0, 0, 0, 0.55), 0 4px 10px rgba(0, 0, 0, 0.35);\n  --gt-elev-5: 0 28px 64px -14px rgba(0, 0, 0, 0.65), 0 8px 16px rgba(0, 0, 0, 0.40);\n  --gt-glow: 0 4px 14px -4px rgba(110, 231, 183, 0.20);\n  --gt-glow-soft: 0 2px 8px -3px rgba(110, 231, 183, 0.14);\n\n  --gt-glass-soft: #141414;\n  --gt-glass-mid:  #1c1c1c;\n  --gt-glass-firm: #2a2a2a;\n  --gt-glass-mint: #1f2e23;\n  --gt-glass-edge: #2a2a2a;\n\n  --gt-heat-0: #19241e;\n  --gt-heat-1: #1f2e23;\n  --gt-heat-2: #2a3d30;\n  --gt-heat-3: #4d6857;\n  --gt-heat-4: #8eb39a;\n  --gt-heat-5: #dcefe1;\n\n  /* Chat (--gc-*) — neutral black/charcoal surfaces (no green tint) */\n  --gc-surface-0: #141414;\n  --gc-surface-1: #0a0a0a;\n  --gc-surface-2: #1c1c1c;\n  --gc-surface-3: #2a2a2a;\n  --gc-surface-hover: rgba(255, 255, 255, 0.06);\n  --gc-surface-rail: #161616;\n  --gc-surface-rail-soft: #1f1f1f;\n\n  --gc-text-primary: #ededed;\n  --gc-text-secondary: #c7c7c7;\n  --gc-text-tertiary: #8f8f8f;\n  --gc-text-disabled: #5e5e5e;\n  --gc-text-link: #6ee7b7;\n  --gc-text-on-rail: #e8e8e8;\n  --gc-text-on-rail-mute: #9a9a9a;\n\n  --gc-border: #2a2a2a;\n  --gc-border-strong: #3a3a3a;\n  --gc-divider: #1e1e1e;\n\n  --gc-primary: #059669;\n  --gc-primary-hover: #047857;\n  --gc-primary-soft: #b9d6c0;\n  --gc-primary-container: #1f2e23;\n  --gc-primary-container-hover: #28392d;\n  --gc-on-primary: #ffffff;\n\n  --gc-bubble-mine-bg: #355241;\n  --gc-bubble-mine-bg-hover: #3d5d4a;\n  --gc-bubble-mine-text: #f4faf6;\n\n  --gc-mention-bg: #3c2e0a;\n  --gc-mention-text: #fde68a;\n  --gc-self-mention-bg: #064e3b;\n  --gc-self-mention-text: #6ee7b7;\n\n  /* Presence pills tuned for dark surfaces */\n  --gc-status-online-bg:   #042f1f;\n  --gc-status-online-fg:   #6ee7b7;\n  --gc-status-offline-bg:  #1f2937;\n  --gc-status-offline-fg:  #cbd5e1;\n  --gc-status-away-bg:     #422006;\n  --gc-status-away-fg:     #fde68a;\n  --gc-status-leave-bg:    #422006;\n  --gc-status-leave-fg:    #fcd34d;\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   HIGH-CONTRAST THEME — accessibility-first.\n   Every token gets a high-contrast value (no fall-through to light defaults).\n   ════════════════════════════════════════════════════════════════════════════ */\n[data-theme=\"hc\"] {\n  color-scheme: dark;\n\n  /* ── Global (--gt-*) ───────────────────────────────────────────────────── */\n\n  /* Surfaces — pure-black page, stepped grays for cards & hover so layered\n     elements visually separate without breaking the high-contrast palette. */\n  --gt-surface-0: #161616;   /* cards / popovers — lift off the black page */\n  --gt-surface-1: #000000;   /* page background */\n  --gt-surface-2: #2a2a2a;   /* card hover, secondary panels */\n  --gt-surface-3: #404040;   /* tertiary / dividers */\n  --gt-surface-hover: rgba(255, 255, 255, 0.10);\n  --gt-surface-rail: #0a0a0a;\n  --gt-surface-rail-soft: #161616;\n\n  /* Brand — bright mint for max contrast on black */\n  --gt-primary: #6ee7b7;\n  --gt-primary-hover: #a7f3d0;\n  --gt-primary-soft: #34d399;\n  --gt-primary-deep: #d1fae5;\n  --gt-primary-container: #064e3b;\n  --gt-primary-container-hover: #065f46;\n  --gt-on-primary: #000000;\n\n  /* Accent — bright too, no dark forest tones */\n  --gt-accent: #6ee7b7;\n  --gt-accent-soft: #064e3b;\n  --gt-accent-strong: #a7f3d0;\n\n  /* Text — pure white primary, light grays for secondary */\n  --gt-text-primary: #ffffff;\n  --gt-text-secondary: #e0e0e0;\n  --gt-text-tertiary: #c0c0c0;\n  --gt-text-muted: #c0c0c0;\n  --gt-text-disabled: #8a8a8a;\n  --gt-text-link: #a7f3d0;\n\n  /* Borders — white at full strength */\n  --gt-border: #6a6a6a;\n  --gt-border-strong: #ffffff;\n  --gt-divider: #4a4a4a;\n\n  /* Status */\n  --gt-online: #69f0ae;\n  --gt-away: #ffd54f;\n  --gt-dnd: #ff5252;\n  --gt-offline: #9e9e9e;\n\n  /* Priority pills — dark cushion + bright foreground */\n  --gt-prio-urgent-bg: #4a0e0e;\n  --gt-prio-urgent-fg: #ffb3b3;\n  --gt-prio-urgent-dot: #ff5252;\n  --gt-prio-high-bg:  #4a2a0e;\n  --gt-prio-high-fg:  #ffd1a0;\n  --gt-prio-high-dot: #ff9645;\n  --gt-prio-med-bg:   #4a3a0e;\n  --gt-prio-med-fg:   #ffe7a0;\n  --gt-prio-med-dot:  #ffd54f;\n  --gt-prio-low-bg:   #0e2a4a;\n  --gt-prio-low-fg:   #a0c8ff;\n  --gt-prio-low-dot:  #5aa0ff;\n\n  /* Status pills — same pattern */\n  --gt-status-pending-bg:   #2d2d2d;\n  --gt-status-pending-fg:   #e0e0e0;\n  --gt-status-progress-bg:  #0e2a4a;\n  --gt-status-progress-fg:  #a0c8ff;\n  --gt-status-progress-dot: #5aa0ff;\n  --gt-status-done-bg:      #064e3b;\n  --gt-status-done-fg:      #a7f3d0;\n  --gt-status-overdue-bg:   #4a0e0e;\n  --gt-status-overdue-fg:   #ffb3b3;\n\n  /* Elevation — heavy shadows so cards still separate on black */\n  --gt-elev-1: 0 0 0 1px rgba(255, 255, 255, 0.10);\n  --gt-elev-2: 0 0 0 1px rgba(255, 255, 255, 0.14), 0 2px 8px rgba(0, 0, 0, 0.5);\n  --gt-elev-3: 0 0 0 1px rgba(255, 255, 255, 0.18), 0 8px 24px rgba(0, 0, 0, 0.6);\n  --gt-elev-4: 0 0 0 1px rgba(255, 255, 255, 0.22), 0 16px 40px rgba(0, 0, 0, 0.7);\n  --gt-elev-5: 0 0 0 1px rgba(255, 255, 255, 0.26), 0 28px 64px rgba(0, 0, 0, 0.8);\n  --gt-glow: 0 0 0 2px rgba(110, 231, 183, 0.5);\n  --gt-glow-soft: 0 0 0 1px rgba(110, 231, 183, 0.35);\n\n  /* Glass / gradient aliases */\n  --gt-glass-soft: #0a0a0a;\n  --gt-glass-mid:  #1a1a1a;\n  --gt-glass-firm: #2d2d2d;\n  --gt-glass-mint: #064e3b;\n  --gt-glass-edge: #ffffff;\n  --gt-grad-from: #a7f3d0;\n  --gt-grad-via:  #6ee7b7;\n  --gt-grad-to:   #34d399;\n  --gt-grad-aurora: #6ee7b7;\n  --gt-grad-aurora-soft: #064e3b;\n\n  /* Heatmap — black → bright mint */\n  --gt-heat-0: #1a1a1a;\n  --gt-heat-1: #064e3b;\n  --gt-heat-2: #065f46;\n  --gt-heat-3: #34d399;\n  --gt-heat-4: #6ee7b7;\n  --gt-heat-5: #d1fae5;\n\n\n  /* ── Chat (--gc-*) ─────────────────────────────────────────────────────── */\n\n  --gc-surface-0: #161616;\n  --gc-surface-1: #000000;\n  --gc-surface-2: #2a2a2a;\n  --gc-surface-3: #404040;\n  --gc-surface-hover: rgba(255, 255, 255, 0.10);\n  --gc-surface-rail: #0a0a0a;\n  --gc-surface-rail-soft: #161616;\n\n  --gc-text-primary: #ffffff;\n  --gc-text-secondary: #e0e0e0;\n  --gc-text-tertiary: #c0c0c0;\n  --gc-text-disabled: #8a8a8a;\n  --gc-text-link: #a7f3d0;\n  --gc-text-on-rail: #ffffff;\n  --gc-text-on-rail-mute: #c0c0c0;\n\n  --gc-border: #6a6a6a;\n  --gc-border-strong: #ffffff;\n  --gc-divider: #4a4a4a;\n\n  --gc-primary: #6ee7b7;\n  --gc-primary-hover: #a7f3d0;\n  --gc-primary-soft: #34d399;\n  --gc-primary-container: #064e3b;\n  --gc-primary-container-hover: #065f46;\n  --gc-on-primary: #000000;\n\n  --gc-bubble-mine-bg: #064e3b;\n  --gc-bubble-mine-bg-hover: #065f46;\n  --gc-bubble-mine-text: #ffffff;\n\n  --gc-accent: #6ee7b7;\n  --gc-accent-soft: #064e3b;\n  --gc-accent-strong: #a7f3d0;\n\n  --gc-online: #69f0ae;\n  --gc-away: #ffd54f;\n  --gc-dnd: #ff5252;\n  --gc-offline: #9e9e9e;\n  --gc-meeting: #a7f3d0;\n  --gc-info: #ffffff;\n\n  --gc-mention-bg: #4a3a0e;\n  --gc-mention-text: #ffe7a0;\n  --gc-mention-channel-bg: #4a0e0e;\n  --gc-mention-channel-text: #ffb3b3;\n  --gc-self-mention-bg: #064e3b;\n  --gc-self-mention-text: #a7f3d0;\n\n  --gc-elev-0: none;\n  --gc-elev-1: 0 0 0 1px rgba(255, 255, 255, 0.10);\n  --gc-elev-2: 0 0 0 1px rgba(255, 255, 255, 0.14), 0 2px 8px rgba(0, 0, 0, 0.5);\n  --gc-elev-3: 0 0 0 1px rgba(255, 255, 255, 0.18), 0 8px 24px rgba(0, 0, 0, 0.6);\n  --gc-elev-4: 0 0 0 1px rgba(255, 255, 255, 0.22), 0 16px 40px rgba(0, 0, 0, 0.7);\n  --gc-elev-5: 0 0 0 1px rgba(255, 255, 255, 0.26), 0 28px 64px rgba(0, 0, 0, 0.8);\n\n  /* Presence pills */\n  --gc-status-online-bg:   #064e3b;\n  --gc-status-online-fg:   #a7f3d0;\n  --gc-status-online-dot:  #6ee7b7;\n  --gc-status-offline-bg:  #2d2d2d;\n  --gc-status-offline-fg:  #c0c0c0;\n  --gc-status-offline-dot: #9e9e9e;\n  --gc-status-away-bg:     #4a3a0e;\n  --gc-status-away-fg:     #ffe7a0;\n  --gc-status-away-dot:    #ffd54f;\n  --gc-status-leave-bg:    #4a2a0e;\n  --gc-status-leave-fg:    #ffd1a0;\n  --gc-status-leave-dot:   #ff9645;\n}\n\n/* ════════════════════════════════════════════════════════════════════════════\n   HC overrides for components that hard-code colours via inline style.\n   These are component-specific patches — inline style has higher specificity\n   than a class rule, so we use !important here on purpose.\n   ════════════════════════════════════════════════════════════════════════════ */\n[data-theme=\"hc\"] .gt-stat-value         { color: var(--gt-text-primary) !important; }\n[data-theme=\"hc\"] .gt-stat                { border-color: var(--gt-border) !important; box-shadow: var(--gt-elev-1) !important; }\n[data-theme=\"hc\"] .gt-stat:hover          { border-color: var(--gt-border-strong) !important; }\n\n/* Inline `color: '#991b1b'` (overdue red) → bright HC red */\n[data-theme=\"hc\"] [style*=\"#991b1b\"]      { color: #ffb3b3 !important; }\n/* Inline overdue card border `rgba(220,38,38,...)` → keep visible */\n[data-theme=\"hc\"] [style*=\"rgba(220,38,38\"] { border-color: #ff5252 !important; }\n\n/* Inline accent-strong text colour reads as the new bright mint */\n[data-theme=\"hc\"] [style*=\"--gt-accent-strong\"],\n[data-theme=\"hc\"] [style*=\"--gc-accent-strong\"] { color: var(--gt-accent-strong) !important; }\n\n/* Page hero gradient title — keep the italic bright */\n[data-theme=\"hc\"] .gt-page-title em       { color: var(--gt-accent) !important; }\n\n/* Filter / scope tab bar — make active state legible */\n[data-theme=\"hc\"] .gt-tasks-scope-tab.is-active {\n  background: var(--gt-primary-container) !important;\n  color: var(--gt-primary-deep) !important;\n  border-color: var(--gt-border-strong) !important;\n}\n\n/* Inputs, textareas, selects, buttons — force a visible outline so the\n   user can find every interactive surface against the black page. */\n[data-theme=\"hc\"] input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n[data-theme=\"hc\"] textarea,\n[data-theme=\"hc\"] select,\n[data-theme=\"hc\"] .gt-input,\n[data-theme=\"hc\"] .gt-textarea,\n[data-theme=\"hc\"] .gt-select {\n  background: var(--gt-surface-0) !important;\n  color: var(--gt-text-primary) !important;\n  border: 1px solid var(--gt-border) !important;\n}\n[data-theme=\"hc\"] input:focus,\n[data-theme=\"hc\"] textarea:focus,\n[data-theme=\"hc\"] select:focus,\n[data-theme=\"hc\"] .gt-input:focus,\n[data-theme=\"hc\"] .gt-textarea:focus,\n[data-theme=\"hc\"] .gt-select:focus {\n  border-color: var(--gt-primary) !important;\n  outline: 2px solid var(--gt-primary) !important;\n  outline-offset: 1px !important;\n}\n[data-theme=\"hc\"] ::placeholder { color: var(--gt-text-tertiary) !important; opacity: 1 !important; }\n\n/* All gt-btn variants get a visible edge */\n[data-theme=\"hc\"] .gt-btn { border: 1px solid var(--gt-border) !important; }\n[data-theme=\"hc\"] .gt-btn.is-primary {\n  background: var(--gt-primary) !important;\n  color: var(--gt-on-primary) !important;\n  border-color: var(--gt-primary) !important;\n}\n[data-theme=\"hc\"] .gt-btn.is-ghost { background: transparent !important; color: var(--gt-text-primary) !important; }\n[data-theme=\"hc\"] .gt-btn:hover { background: var(--gt-surface-hover) !important; }\n[data-theme=\"hc\"] .gt-btn.is-primary:hover { background: var(--gt-primary-hover) !important; }\n[data-theme=\"hc\"] .gt-btn:disabled,\n[data-theme=\"hc\"] .gt-btn[aria-disabled=\"true\"] {\n  opacity: 0.55 !important;\n}\n\n/* Card-ish containers — ensure they have a visible edge over the black page */\n[data-theme=\"hc\"] .gt-card,\n[data-theme=\"hc\"] .gt-dropdown,\n[data-theme=\"hc\"] .gt-popover,\n[data-theme=\"hc\"] .gt-modal,\n[data-theme=\"hc\"] .gt-sheet,\n[data-theme=\"hc\"] .gt-stat,\n[data-theme=\"hc\"] .gt-stat-tile {\n  background: var(--gt-surface-0) !important;\n  border: 1px solid var(--gt-border) !important;\n}\n\n/* Sidebar item visibility — active state pops against black */\n[data-theme=\"hc\"] .gt-sidebar-item.is-active {\n  background: var(--gt-primary-container) !important;\n  color: var(--gt-primary-deep) !important;\n  border-color: var(--gt-border-strong) !important;\n}\n\n/* Chat side: bubbles, inputs, message composer */\n[data-theme=\"hc\"] .gc-bubble,\n[data-theme=\"hc\"] .gc-card,\n[data-theme=\"hc\"] .gc-composer,\n[data-theme=\"hc\"] .gc-popover {\n  border: 1px solid var(--gc-border) !important;\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   DENSITY OVERRIDES (chat only) — orthogonal to theme\n   ════════════════════════════════════════════════════════════════════════════ */\n[data-chat-density=\"compact\"] {\n  --gc-msg-row-height: 28px;\n  --gc-msg-padding-v: 3px;\n  --gc-avatar-size: 28px;\n}\n[data-chat-density=\"spacious\"] {\n  --gc-msg-row-height: 44px;\n  --gc-msg-padding-v: 10px;\n  --gc-avatar-size: 44px;\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   REDUCED MOTION — collapse all transition durations to 0\n   ════════════════════════════════════════════════════════════════════════════ */\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --gt-t-fast: 0ms;\n    --gt-t-mid: 0ms;\n    --gt-t-slow: 0ms;\n    --gc-transition-fast: 0ms;\n    --gc-transition-mid: 0ms;\n    --gc-transition-slow: 0ms;\n  }\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   DARK-MODE TAILWIND-CLASS OVERRIDES\n   Tailwind utility classes that hardcode light-mode colours (bg-white,\n   text-gray-*, border-gray-*) don't adapt automatically. These rules pin them\n   to theme tokens so dark/HC themes look correct without per-component edits.\n   ════════════════════════════════════════════════════════════════════════════ */\n[data-theme=\"dark\"] .bg-white,\n[data-theme=\"hc\"]   .bg-white { background-color: var(--gt-surface-0) !important; }\n\n[data-theme=\"dark\"] .bg-gray-50,\n[data-theme=\"dark\"] .bg-gray-100,\n[data-theme=\"dark\"] .bg-slate-50,\n[data-theme=\"dark\"] .bg-slate-100,\n[data-theme=\"dark\"] .bg-neutral-50,\n[data-theme=\"dark\"] .bg-neutral-100,\n[data-theme=\"dark\"] .bg-zinc-50,\n[data-theme=\"dark\"] .bg-zinc-100,\n[data-theme=\"dark\"] .bg-stone-50,\n[data-theme=\"dark\"] .bg-stone-100,\n[data-theme=\"hc\"]   .bg-gray-50,\n[data-theme=\"hc\"]   .bg-gray-100,\n[data-theme=\"hc\"]   .bg-slate-50,\n[data-theme=\"hc\"]   .bg-slate-100,\n[data-theme=\"hc\"]   .bg-neutral-50,\n[data-theme=\"hc\"]   .bg-neutral-100 { background-color: var(--gt-surface-2) !important; }\n\n[data-theme=\"dark\"] .text-gray-900,\n[data-theme=\"dark\"] .text-gray-800,\n[data-theme=\"dark\"] .text-slate-900,\n[data-theme=\"dark\"] .text-slate-800,\n[data-theme=\"dark\"] .text-neutral-900,\n[data-theme=\"dark\"] .text-neutral-800,\n[data-theme=\"dark\"] .text-zinc-900,\n[data-theme=\"dark\"] .text-zinc-800,\n[data-theme=\"dark\"] .text-black,\n[data-theme=\"hc\"]   .text-gray-900,\n[data-theme=\"hc\"]   .text-gray-800,\n[data-theme=\"hc\"]   .text-black { color: var(--gt-text-primary) !important; }\n\n[data-theme=\"dark\"] .text-gray-700,\n[data-theme=\"dark\"] .text-gray-600,\n[data-theme=\"dark\"] .text-slate-700,\n[data-theme=\"dark\"] .text-slate-600,\n[data-theme=\"dark\"] .text-neutral-700,\n[data-theme=\"dark\"] .text-neutral-600,\n[data-theme=\"dark\"] .text-zinc-700,\n[data-theme=\"dark\"] .text-zinc-600,\n[data-theme=\"hc\"]   .text-gray-700,\n[data-theme=\"hc\"]   .text-gray-600 { color: var(--gt-text-secondary) !important; }\n\n[data-theme=\"dark\"] .text-gray-500,\n[data-theme=\"dark\"] .text-gray-400,\n[data-theme=\"dark\"] .text-slate-500,\n[data-theme=\"dark\"] .text-slate-400,\n[data-theme=\"dark\"] .text-neutral-500,\n[data-theme=\"dark\"] .text-neutral-400,\n[data-theme=\"dark\"] .text-zinc-500,\n[data-theme=\"dark\"] .text-zinc-400,\n[data-theme=\"hc\"]   .text-gray-500,\n[data-theme=\"hc\"]   .text-gray-400 { color: var(--gt-text-tertiary) !important; }\n\n[data-theme=\"dark\"] .border-gray-100,\n[data-theme=\"dark\"] .border-gray-200,\n[data-theme=\"dark\"] .border-gray-300,\n[data-theme=\"dark\"] .border-slate-100,\n[data-theme=\"dark\"] .border-slate-200,\n[data-theme=\"dark\"] .border-slate-300,\n[data-theme=\"dark\"] .border-neutral-200,\n[data-theme=\"dark\"] .border-zinc-200,\n[data-theme=\"hc\"]   .border-gray-100,\n[data-theme=\"hc\"]   .border-gray-200,\n[data-theme=\"hc\"]   .border-gray-300 { border-color: var(--gt-border) !important; }\n\n[data-theme=\"dark\"] .divide-gray-100 > * + *,\n[data-theme=\"dark\"] .divide-gray-200 > * + *,\n[data-theme=\"dark\"] .divide-slate-200 > * + * { border-color: var(--gt-divider) !important; }\n\n/* Hover state — gray-50/100 backgrounds on hover should adapt too */\n[data-theme=\"dark\"] .hover\\:bg-gray-50:hover,\n[data-theme=\"dark\"] .hover\\:bg-gray-100:hover,\n[data-theme=\"dark\"] .hover\\:bg-slate-50:hover,\n[data-theme=\"dark\"] .hover\\:bg-slate-100:hover,\n[data-theme=\"hc\"]   .hover\\:bg-gray-50:hover,\n[data-theme=\"hc\"]   .hover\\:bg-gray-100:hover { background-color: var(--gt-surface-hover) !important; }\n\n/* Dark-mode and HC: bg-black / very-dark-gray classes should still respect\n   the theme's surface tokens (so HC stat tiles use the same black as the\n   rest of the shell, not a stray Tailwind black). */\n[data-theme=\"dark\"] .bg-gray-800,\n[data-theme=\"dark\"] .bg-gray-900,\n[data-theme=\"dark\"] .bg-slate-800,\n[data-theme=\"dark\"] .bg-slate-900,\n[data-theme=\"dark\"] .bg-neutral-900,\n[data-theme=\"dark\"] .bg-zinc-900,\n[data-theme=\"dark\"] .bg-black,\n[data-theme=\"hc\"]   .bg-gray-800,\n[data-theme=\"hc\"]   .bg-gray-900,\n[data-theme=\"hc\"]   .bg-black { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }\n\n/* Coloured text utilities used for status / numbers — keep them readable on dark surfaces. */\n[data-theme=\"hc\"] .text-emerald-600,\n[data-theme=\"hc\"] .text-emerald-700,\n[data-theme=\"hc\"] .text-emerald-800,\n[data-theme=\"hc\"] .text-green-600,\n[data-theme=\"hc\"] .text-green-700,\n[data-theme=\"hc\"] .text-green-800,\n[data-theme=\"hc\"] .text-teal-600,\n[data-theme=\"hc\"] .text-teal-700 { color: #a7f3d0 !important; }\n\n[data-theme=\"hc\"] .text-red-600,\n[data-theme=\"hc\"] .text-red-700,\n[data-theme=\"hc\"] .text-rose-600,\n[data-theme=\"hc\"] .text-rose-700 { color: #ffb3b3 !important; }\n\n[data-theme=\"hc\"] .text-blue-600,\n[data-theme=\"hc\"] .text-blue-700,\n[data-theme=\"hc\"] .text-indigo-600,\n[data-theme=\"hc\"] .text-indigo-700 { color: #a0c8ff !important; }\n\n[data-theme=\"hc\"] .text-amber-600,\n[data-theme=\"hc\"] .text-amber-700,\n[data-theme=\"hc\"] .text-yellow-600,\n[data-theme=\"hc\"] .text-yellow-700,\n[data-theme=\"hc\"] .text-orange-600,\n[data-theme=\"hc\"] .text-orange-700 { color: #ffe7a0 !important; }\n\n/* Mirror these for dark mode (less aggressive — only the darkest variants). */\n[data-theme=\"dark\"] .text-emerald-700,\n[data-theme=\"dark\"] .text-emerald-800,\n[data-theme=\"dark\"] .text-green-700,\n[data-theme=\"dark\"] .text-green-800 { color: #6ee7b7 !important; }\n[data-theme=\"dark\"] .text-red-700,\n[data-theme=\"dark\"] .text-red-800 { color: #fca5a5 !important; }\n[data-theme=\"dark\"] .text-blue-700,\n[data-theme=\"dark\"] .text-blue-800 { color: #93c5fd !important; }\n[data-theme=\"dark\"] .text-amber-700,\n[data-theme=\"dark\"] .text-amber-800,\n[data-theme=\"dark\"] .text-yellow-700,\n[data-theme=\"dark\"] .text-yellow-800 { color: #fde68a !important; }\n\n\n/* ════════════════════════════════════════════════════════════════════════════\n   INLINE-STYLE HARDCODE OVERRIDES\n   Some legacy components (TaskReports, TaskStats, TodoPlanner, TodoCard,\n   JourneyStrip, ProjectDetails) ship inline style objects with literal\n   hex / rgba values that ignore the active theme. We catch those by\n   attribute substring selector and remap them so dark / HC themes don't\n   end up with bright pastel chips floating on black surfaces.\n   Match strings come straight from the values the components emit.\n   ════════════════════════════════════════════════════════════════════════════ */\n\n/* ── Blue pastels (#dbeafe / #eff6ff / #bfdbfe / rgba(59,130,246,…)) ────── */\n[data-theme=\"dark\"] [style*=\"rgba(59,130,246\"],\n[data-theme=\"dark\"] [style*=\"#dbeafe\"],\n[data-theme=\"dark\"] [style*=\"#eff6ff\"] {\n  background-color: rgba(96,165,250,0.14) !important;\n  border-color:     rgba(96,165,250,0.30) !important;\n}\n[data-theme=\"dark\"] [style*=\"#bfdbfe\"]   { border-color: rgba(96,165,250,0.35) !important; }\n[data-theme=\"dark\"] [style*=\"#1e40af\"],\n[data-theme=\"dark\"] [style*=\"#1d4ed8\"],\n[data-theme=\"dark\"] [style*=\"#1e3a8a\"]   { color: #93c5fd !important; }\n\n[data-theme=\"hc\"]   [style*=\"rgba(59,130,246\"],\n[data-theme=\"hc\"]   [style*=\"#dbeafe\"],\n[data-theme=\"hc\"]   [style*=\"#eff6ff\"] {\n  background-color: #0e2a4a !important;\n  border-color:     #5aa0ff !important;\n}\n[data-theme=\"hc\"]   [style*=\"#bfdbfe\"]   { border-color: #5aa0ff !important; }\n[data-theme=\"hc\"]   [style*=\"#1e40af\"],\n[data-theme=\"hc\"]   [style*=\"#1d4ed8\"],\n[data-theme=\"hc\"]   [style*=\"#1e3a8a\"]   { color: #a0c8ff !important; }\n\n/* ── Green / emerald pastels (rgba(34,197,94,…) / #15803d / #166534) ────── */\n[data-theme=\"dark\"] [style*=\"rgba(34,197,94\"] {\n  background-color: rgba(110,231,183,0.12) !important;\n  border-color:     rgba(110,231,183,0.28) !important;\n}\n[data-theme=\"dark\"] [style*=\"#15803d\"],\n[data-theme=\"dark\"] [style*=\"#166534\"]   { color: #6ee7b7 !important; }\n\n[data-theme=\"hc\"]   [style*=\"rgba(34,197,94\"] {\n  background-color: #064e3b !important;\n  border-color:     #6ee7b7 !important;\n}\n[data-theme=\"hc\"]   [style*=\"#15803d\"],\n[data-theme=\"hc\"]   [style*=\"#166534\"]   { color: #a7f3d0 !important; }\n\n/* ── Amber / yellow pastels (rgba(234,179,8,…) / #854d0e / #fef3c7) ────── */\n[data-theme=\"dark\"] [style*=\"rgba(234,179,8\"],\n[data-theme=\"dark\"] [style*=\"#fef3c7\"],\n[data-theme=\"dark\"] [style*=\"#fff7e0\"] {\n  background-color: rgba(253,224,71,0.10) !important;\n  border-color:     rgba(253,224,71,0.28) !important;\n}\n[data-theme=\"dark\"] [style*=\"#854d0e\"],\n[data-theme=\"dark\"] [style*=\"#713f12\"]   { color: #fde68a !important; }\n\n[data-theme=\"hc\"]   [style*=\"rgba(234,179,8\"],\n[data-theme=\"hc\"]   [style*=\"#fef3c7\"],\n[data-theme=\"hc\"]   [style*=\"#fff7e0\"] {\n  background-color: #4a3a0e !important;\n  border-color:     #ffd54f !important;\n}\n[data-theme=\"hc\"]   [style*=\"#854d0e\"],\n[data-theme=\"hc\"]   [style*=\"#713f12\"]   { color: #ffe7a0 !important; }\n\n/* ── Red / rose pastels (rgba(220,38,38,…) / #991b1b / #fee2e2 / #fdecea) ── */\n[data-theme=\"dark\"] [style*=\"rgba(220,38,38\"],\n[data-theme=\"dark\"] [style*=\"#fee2e2\"],\n[data-theme=\"dark\"] [style*=\"#fdecea\"] {\n  background-color: rgba(252,165,165,0.10) !important;\n  border-color:     rgba(252,165,165,0.30) !important;\n}\n[data-theme=\"dark\"] [style*=\"#991b1b\"],\n[data-theme=\"dark\"] [style*=\"#a83c34\"]   { color: #fca5a5 !important; }\n\n[data-theme=\"hc\"]   [style*=\"rgba(220,38,38\"],\n[data-theme=\"hc\"]   [style*=\"#fee2e2\"],\n[data-theme=\"hc\"]   [style*=\"#fdecea\"] {\n  background-color: #4a0e0e !important;\n  border-color:     #ff5252 !important;\n}\n[data-theme=\"hc\"]   [style*=\"#991b1b\"],\n[data-theme=\"hc\"]   [style*=\"#a83c34\"]   { color: #ffb3b3 !important; }\n\n/* ── Neutral / slate (rgba(107,114,128,…) / #6b7280 / #374151 / #f1f5f9) ─ */\n[data-theme=\"dark\"] [style*=\"rgba(107,114,128\"],\n[data-theme=\"dark\"] [style*=\"#f1f5f9\"] {\n  background-color: var(--gt-surface-2) !important;\n  border-color:     var(--gt-border) !important;\n}\n[data-theme=\"dark\"] [style*=\"#374151\"],\n[data-theme=\"dark\"] [style*=\"#6b7280\"]   { color: var(--gt-text-tertiary) !important; }\n\n[data-theme=\"hc\"]   [style*=\"rgba(107,114,128\"],\n[data-theme=\"hc\"]   [style*=\"#f1f5f9\"] {\n  background-color: #2d2d2d !important;\n  border-color:     #ffffff !important;\n}\n[data-theme=\"hc\"]   [style*=\"#374151\"],\n[data-theme=\"hc\"]   [style*=\"#6b7280\"]   { color: #e0e0e0 !important; }\n\n/* ── Hardcoded white backgrounds in inline styles (`background:'#fff'`,\n   `background:'#ffffff'`, `background-color:'#fff'`) → use theme surface. */\n[data-theme=\"dark\"] [style*=\"background: #fff\"],\n[data-theme=\"dark\"] [style*=\"background:#fff\"],\n[data-theme=\"dark\"] [style*=\"background: #ffffff\"],\n[data-theme=\"dark\"] [style*=\"background:#ffffff\"],\n[data-theme=\"dark\"] [style*=\"background-color: #fff\"],\n[data-theme=\"dark\"] [style*=\"background-color:#fff\"],\n[data-theme=\"hc\"]   [style*=\"background: #fff\"],\n[data-theme=\"hc\"]   [style*=\"background:#fff\"],\n[data-theme=\"hc\"]   [style*=\"background: #ffffff\"],\n[data-theme=\"hc\"]   [style*=\"background:#ffffff\"] { background-color: var(--gt-surface-0) !important; }\n\n/* Inline `color: #111827` / `#1f2937` (dark text) → theme primary text */\n[data-theme=\"dark\"] [style*=\"#111827\"],\n[data-theme=\"dark\"] [style*=\"#1f2937\"],\n[data-theme=\"hc\"]   [style*=\"#111827\"],\n[data-theme=\"hc\"]   [style*=\"#1f2937\"]   { color: var(--gt-text-primary) !important; }\n\n/* ════════════════════════════════════════════════════════════════════════════\n   DARK THEME — component overrides for HARD-CODED light values.\n   The dark token block above flips every --gc- and --gt- variable, so anything\n   built on tokens adapts automatically. The rules below patch the handful of\n   chat component styles that were authored with hard-coded light colours\n   (white/cream popover surfaces, light status chips) and so ignore the tokens.\n   Scoped to [data-theme=\"dark\"] only — the HC theme has its own block above.\n   ════════════════════════════════════════════════════════════════════════════ */\n\n/* Chat shell background (was hard-coded #ffffff) */\n[data-theme=\"dark\"] .gc-shell { background: var(--gc-surface-0); }\n\n/* App frame — the outer shell had a light sage gradient and the inner card a\n   hard-coded white bg + light glow (this was the \"white frame\" around the app).\n   !important so it also wins over the higher-specificity Electron shell rules. */\n[data-theme=\"dark\"] .gt-app-shell { background: var(--gt-surface-1) !important; }\n[data-theme=\"dark\"] .gt-app-main {\n  background: var(--gt-surface-1) !important;\n  box-shadow: none !important;\n}\n[data-theme=\"dark\"] .gc-chat-shell { box-shadow: none; }\n\n/* Primary CTA gradient (e.g. \"Employee Planner\") used primary→primary-deep;\n   primary-deep is pale in dark, so white label vanished. Use a solid emerald\n   gradient so the white text reads. */\n[data-theme=\"dark\"] .gc-task-cta-mobile {\n  background: linear-gradient(135deg, var(--gt-primary) 0%, var(--gt-primary-hover) 100%);\n  color: #ffffff;\n}\n\n/* Ambient pale-mint radial \"glows\" layered over the message stream / empty\n   state / thread panel — they read as a light diagonal wash on black. Drop the\n   glows and use flat dark surfaces. */\n[data-theme=\"dark\"] .gc-chat-stream { background: var(--gc-surface-0); }\n[data-theme=\"dark\"] .gc-empty-state { background: var(--gc-surface-1); }\n[data-theme=\"dark\"] .gc-thread-panel__body { background: var(--gc-surface-1); }\n\n/* ── Contrast fixes (dark) ──────────────────────────────────────────────── */\n\n/* Generic themed links were var(--gt-primary) = emerald (~4:1 on black). Use\n   the brighter mint accent so links (incl. the app-sidebar NavLinks) read. */\n[data-theme=\"dark\"] .gt-themed a:not(.gt-btn):not([class*=\"text-\"]) { color: var(--gt-accent); }\n[data-theme=\"dark\"] .gt-themed a:not(.gt-btn):not([class*=\"text-\"]):hover { color: var(--gt-accent-strong); }\n\n/* App sidebar nav — keep items neutral (the link rule above was tinting every\n   row green); accent only the active item. */\n[data-theme=\"dark\"] .gt-sidebar-item,\n[data-theme=\"dark\"] .gt-sidebar-subitem { color: var(--gt-text-secondary) !important; }\n[data-theme=\"dark\"] .gt-sidebar-item.is-active,\n[data-theme=\"dark\"] .gt-sidebar-subitem.is-active { color: var(--gt-accent) !important; }\n\n/* Presence filter chips — inactive label colours were dark (built for a light\n   chip); brighten so they read on the dark chip. */\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-online { color: #6ee7b7; }\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-away   { color: #fbbf24; }\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-groups { color: #c4b5fd; }\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-internal { color: #cbd5e1; }\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-external { color: #fcd34d; }\n[data-theme=\"dark\"] .gc-presence-filter-chip.is-archived { color: #d6d3d1; }\n\n/* Tailwind opacity-modified gray surfaces (e.g. the \"Repeat this task\" card's\n   bg-gray-50/70) aren't in the compat net — map the common ones to dark. */\n[data-theme=\"dark\"] .bg-gray-50\\/70,\n[data-theme=\"dark\"] .bg-gray-50\\/60,\n[data-theme=\"dark\"] .bg-gray-50\\/50,\n[data-theme=\"dark\"] .bg-gray-100\\/70,\n[data-theme=\"dark\"] .bg-gray-100\\/60 { background-color: var(--gt-surface-2) !important; }\n\n/* Status stat tiles (Projects/Tasks pages) render inline mid-600 text on a\n   faint colour tint — too dark on black. Brighten via the serialized rgba bg\n   hook (inactive tiles only; active tiles use a solid hex bg + white text). */\n[data-theme=\"dark\"] [style*=\"rgba(34, 197, 94, 0.1\"]   { color: #4ade80 !important; }\n[data-theme=\"dark\"] [style*=\"rgba(234, 179, 8, 0.1\"]   { color: #fbbf24 !important; }\n[data-theme=\"dark\"] [style*=\"rgba(59, 130, 246, 0.1\"]  { color: #60a5fa !important; }\n[data-theme=\"dark\"] [style*=\"rgba(107, 114, 128, 0.1\"] { color: #9ca3af !important; }\n\n/* Pale green/emerald banner gradients (e.g. the \"Task Summary\" card) aren't in\n   the compat flatten list → stay near-white. Flatten to a dark surface. */\n[data-theme=\"dark\"] [class*=\"from-green-50\"][class*=\"to-emerald-50\"],\n[data-theme=\"dark\"] [class*=\"from-emerald-50\"][class*=\"to-green-50\"],\n[data-theme=\"dark\"] [class*=\"from-green-50\"][class*=\"to-green-100\"],\n[data-theme=\"dark\"] [class*=\"from-emerald-50\"][class*=\"to-emerald-100\"] {\n  background: var(--gt-surface-2) !important;\n  background-image: none !important;\n}\n[data-theme=\"dark\"] .border-green-200 { border-color: var(--gt-border) !important; }\n\n/* Floating popovers / dropdowns — were hard-coded white frosted surfaces */\n[data-theme=\"dark\"] .gc-ios-menu,\n[data-theme=\"dark\"] .gc-filter-menu,\n[data-theme=\"dark\"] .gc-time-pop {\n  background: var(--gc-surface-2);\n  border-color: var(--gc-border);\n}\n\n/* Message hover controls — action bar / emoji popover / action menu.\n   The menu items use --gc-text-* tokens (light in dark mode), so the surface\n   MUST go dark for them to read. The bar's buttons use fixed slate/emerald\n   colours tuned for a light bar, so re-tint them for the dark surface. */\n[data-theme=\"dark\"] .gc-msg-action-bar,\n[data-theme=\"dark\"] .gc-msg-emoji-pop,\n[data-theme=\"dark\"] .gc-msg-action-menu {\n  background: var(--gc-surface-2);\n  border-color: var(--gc-border);\n}\n[data-theme=\"dark\"] .gc-msg-action-btn { color: var(--gc-text-secondary); }\n[data-theme=\"dark\"] .gc-msg-action-btn:hover,\n[data-theme=\"dark\"] .gc-msg-action-btn--reply { color: var(--gc-accent-strong); }\n[data-theme=\"dark\"] .gc-msg-action-sep { background: var(--gc-border); }\n\n/* Document viewer modal (was hard-coded #fff / #f8faf9 / #f3f4f6) */\n[data-theme=\"dark\"] .gc-doc-modal,\n[data-theme=\"dark\"] .gc-doc-modal__iframe { background: var(--gc-surface-1); }\n[data-theme=\"dark\"] .gc-doc-modal__bar {\n  background: var(--gc-surface-2);\n  border-bottom-color: var(--gc-border);\n}\n[data-theme=\"dark\"] .gc-doc-modal__body { background: var(--gc-surface-0); }\n\n/* Error banner — light red (#fef2f2) → dark maroon */\n[data-theme=\"dark\"] .gc-error-banner {\n  background-color: var(--gt-status-overdue-bg);\n  color: var(--gt-status-overdue-fg);\n}\n\n/* Task-card status chips + task-flow accents (light tints → dark) */\n[data-theme=\"dark\"] .gc-task-card__status--progress { background: #2e2410; color: #fcd34d; }\n[data-theme=\"dark\"] .gc-task-card__status--blocked  { background: var(--gt-status-overdue-bg); color: var(--gt-status-overdue-fg); }\n[data-theme=\"dark\"] .gc-task-btn-add-first { background: var(--gc-surface-2); }\n[data-theme=\"dark\"] .gc-task-flow-approver { background: #3a2a14; }\n[data-theme=\"dark\"] .gc-task-orange-circle { background: #3a2a14; }\n\n/* Quoted reply snippet — the base wash is a near-black tint tuned for the light\n   \"theirs\" bubble; on dark surfaces it vanishes, so lift the card with a faint\n   light wash. The sent (mine) bubble stays green in both themes — re-assert its\n   recessed dark wash at higher specificity so the rule above doesn't leak in. */\n[data-theme=\"dark\"] .gc-quoted { background: rgba(255, 255, 255, 0.05); }\n[data-theme=\"dark\"] .gc-quoted[data-clickable=\"true\"]:hover { background: rgba(255, 255, 255, 0.09); }\n[data-theme=\"dark\"] .gc-bubble-mine .gc-quoted { background: rgba(0, 0, 0, 0.18); }\n[data-theme=\"dark\"] .gc-bubble-mine .gc-quoted[data-clickable=\"true\"]:hover { background: rgba(0, 0, 0, 0.26); }\n\n/* ── Semantic status Tailwind utilities (red = error, amber/orange = warning) ──\n   The compat layer below remaps grays/blues/greens in BOTH themes; these\n   semantic scales are NOT in it, so we remap them under dark only (light keeps\n   Tailwind's own red/amber, which read fine on light surfaces). Solid red/amber\n   buttons (bg-red-500/600) are intentionally left vivid. */\n[data-theme=\"dark\"] .bg-red-50,\n[data-theme=\"dark\"] .bg-red-100,\n[data-theme=\"dark\"] .bg-red-200 { background-color: var(--gt-status-overdue-bg) !important; }\n[data-theme=\"dark\"] .text-red-400,\n[data-theme=\"dark\"] .text-red-500,\n[data-theme=\"dark\"] .text-red-600,\n[data-theme=\"dark\"] .text-red-700 { color: var(--gt-status-overdue-fg) !important; }\n[data-theme=\"dark\"] .border-red-100,\n[data-theme=\"dark\"] .border-red-200 { border-color: #5a2a2a !important; }\n[data-theme=\"dark\"] .bg-amber-50,\n[data-theme=\"dark\"] .bg-amber-100 { background-color: #2e2410 !important; }\n[data-theme=\"dark\"] .text-amber-500,\n[data-theme=\"dark\"] .text-amber-600,\n[data-theme=\"dark\"] .text-amber-700,\n[data-theme=\"dark\"] .text-amber-800,\n[data-theme=\"dark\"] .text-orange-500 { color: #fcd34d !important; }\n[data-theme=\"dark\"] .border-amber-100,\n[data-theme=\"dark\"] .border-amber-200 { border-color: #5a4410 !important; }\n\n/* ── Apply base typography & background globally ──────────────────────── */\nhtml, body {\n  font-family: var(--gt-font) !important;\n}\nhtml { color: var(--gt-text-primary); }\nbody {\n  color: var(--gt-text-primary);\n  background: var(--gt-surface-1);\n  transition: background var(--gt-t-mid), color var(--gt-t-mid);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n/* Force theme font on every element so Tailwind/shadcn defaults never win */\n*, *::before, *::after { font-family: inherit; }\nbody * { font-family: var(--gt-font); }\nbody em, body i, body cite, body q, body blockquote, body figcaption, body dfn,\nbody .gt-serif-italic, body .serif-italic {\n  font-family: var(--gt-font-serif) !important;\n}\nbody code, body pre, body kbd, body samp,\nbody .gt-numerals, body .font-mono { font-family: var(--gt-font-mono) !important; }\n\n/* Raw HTML elements — base typography that applies project-wide */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--gt-font-display);\n  color: var(--gt-text-primary);\n  letter-spacing: -0.02em;\n  font-weight: 700;\n}\np { color: var(--gt-text-secondary); line-height: 1.55; }\nem, i, cite, q, blockquote, figcaption, dfn {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n}\ncode, pre, kbd, samp { font-family: var(--gt-font-mono); }\nhr { border: none; border-top: 1px solid var(--gt-divider); }\n\n/* Selection */\n::selection { background: var(--gt-primary-container); color: var(--gt-primary-deep); }\n\n/* Default focus ring on any interactive element.\n   No visible ring — each component decides its own focus treatment instead\n   of a global pill, which leaked rounded outlines into chat rows / header. */\n*:focus-visible {\n  outline: none;\n  box-shadow: none;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Global Tailwind compatibility — applied to any page wrapped in gt-themed.\n   Maps generic blue/indigo/purple/gray utility classes to theme tokens so\n   legacy pages adopt the active theme without rewrites.\n   ──────────────────────────────────────────────────────────────────────── */\n.gt-themed {\n  font-family: var(--gt-font);\n  color: var(--gt-text-primary);\n}\n.gt-themed h1, .gt-themed h2, .gt-themed h3, .gt-themed h4 {\n  font-family: var(--gt-font-display);\n  letter-spacing: -0.01em;\n  color: var(--gt-text-primary);\n}\n\n/* Surfaces */\n.gt-themed .bg-white { background-color: var(--gt-surface-0) !important; }\n.gt-themed .bg-gray-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-gray-100 { background-color: var(--gt-surface-2) !important; }\n.gt-themed .bg-gray-200 { background-color: var(--gt-surface-3) !important; }\n\n/* Borders */\n.gt-themed .border-gray-100 { border-color: var(--gt-divider) !important; }\n.gt-themed .border-gray-200 { border-color: var(--gt-border) !important; }\n.gt-themed .border-gray-300 { border-color: var(--gt-border-strong) !important; }\n\n/* Text */\n.gt-themed .text-gray-400 { color: var(--gt-text-disabled) !important; }\n.gt-themed .text-gray-500 { color: var(--gt-text-tertiary) !important; }\n.gt-themed .text-gray-600,\n.gt-themed .text-gray-700 { color: var(--gt-text-secondary) !important; }\n.gt-themed .text-gray-800,\n.gt-themed .text-gray-900 { color: var(--gt-text-primary) !important; }\n\n/* Blue / indigo / purple → primary */\n.gt-themed .text-blue-500, .gt-themed .text-blue-600, .gt-themed .text-blue-700,\n.gt-themed .text-indigo-500, .gt-themed .text-indigo-600, .gt-themed .text-indigo-700,\n.gt-themed .text-purple-500, .gt-themed .text-purple-600, .gt-themed .text-purple-700,\n.gt-themed .text-violet-500, .gt-themed .text-violet-600 { color: var(--gt-primary) !important; }\n\n.gt-themed .bg-blue-50, .gt-themed .bg-indigo-50, .gt-themed .bg-purple-50, .gt-themed .bg-violet-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-blue-100, .gt-themed .bg-indigo-100, .gt-themed .bg-purple-100, .gt-themed .bg-violet-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }\n.gt-themed .bg-blue-500, .gt-themed .bg-blue-600,\n.gt-themed .bg-indigo-500, .gt-themed .bg-indigo-600,\n.gt-themed .bg-purple-500, .gt-themed .bg-purple-600,\n.gt-themed .bg-violet-500, .gt-themed .bg-violet-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }\n.gt-themed .bg-blue-700, .gt-themed .bg-indigo-700, .gt-themed .bg-purple-700, .gt-themed .bg-violet-700 { background-color: var(--gt-primary-hover) !important; }\n\n.gt-themed .border-blue-200, .gt-themed .border-indigo-200, .gt-themed .border-purple-200 { border-color: var(--gt-border) !important; }\n.gt-themed .border-blue-500, .gt-themed .border-indigo-500, .gt-themed .border-purple-500,\n.gt-themed .border-blue-600, .gt-themed .border-indigo-600, .gt-themed .border-purple-600 { border-color: var(--gt-primary) !important; }\n\n.gt-themed .focus\\:ring-blue-500:focus,\n.gt-themed .focus\\:ring-indigo-500:focus,\n.gt-themed .focus\\:ring-purple-500:focus,\n.gt-themed .focus\\:ring-blue-400:focus { --tw-ring-color: var(--gt-primary) !important; box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important; }\n.gt-themed .focus\\:border-blue-500:focus,\n.gt-themed .focus\\:border-indigo-500:focus { border-color: var(--gt-primary) !important; }\n\n.gt-themed .hover\\:bg-blue-50:hover, .gt-themed .hover\\:bg-indigo-50:hover, .gt-themed .hover\\:bg-purple-50:hover { background-color: var(--gt-surface-1) !important; }\n.gt-themed .hover\\:bg-blue-100:hover, .gt-themed .hover\\:bg-indigo-100:hover, .gt-themed .hover\\:bg-purple-100:hover { background-color: var(--gt-primary-container) !important; }\n.gt-themed .hover\\:text-blue-600:hover, .gt-themed .hover\\:text-indigo-600:hover, .gt-themed .hover\\:text-purple-600:hover { color: var(--gt-primary) !important; }\n\n/* Gradient backgrounds → flat primary (small accents like icon squares).\n   Comprehensive coverage of common AI-slop 2-stop saturated gradient combos. */\n.gt-themed [class*=\"from-blue-400\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-blue-700\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-cyan-500\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-cyan-600\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-indigo-500\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-indigo-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-indigo-600\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-purple-700\"],\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-purple-500\"],\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-indigo-600\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-indigo-600\"][class*=\"to-purple-700\"],\n.gt-themed [class*=\"from-violet-500\"][class*=\"to-purple-500\"],\n.gt-themed [class*=\"from-violet-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-violet-600\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-purple-500\"][class*=\"to-pink-500\"],\n.gt-themed [class*=\"from-purple-500\"][class*=\"to-pink-600\"],\n.gt-themed [class*=\"from-purple-600\"][class*=\"to-pink-500\"],\n.gt-themed [class*=\"from-purple-600\"][class*=\"to-pink-600\"],\n.gt-themed [class*=\"from-purple-600\"][class*=\"to-purple-700\"],\n.gt-themed [class*=\"from-pink-500\"][class*=\"to-rose-500\"],\n.gt-themed [class*=\"from-pink-500\"][class*=\"to-rose-600\"],\n.gt-themed [class*=\"from-pink-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-fuchsia-500\"][class*=\"to-pink-500\"],\n.gt-themed [class*=\"from-fuchsia-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-cyan-500\"][class*=\"to-blue-500\"],\n.gt-themed [class*=\"from-cyan-500\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-cyan-600\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-emerald-500\"][class*=\"to-teal-500\"],\n.gt-themed [class*=\"from-emerald-500\"][class*=\"to-teal-600\"],\n.gt-themed [class*=\"from-emerald-600\"][class*=\"to-teal-600\"],\n.gt-themed [class*=\"from-green-500\"][class*=\"to-emerald-500\"],\n.gt-themed [class*=\"from-green-500\"][class*=\"to-emerald-600\"],\n.gt-themed [class*=\"from-green-500\"][class*=\"to-teal-500\"],\n.gt-themed [class*=\"from-orange-500\"][class*=\"to-pink-500\"],\n.gt-themed [class*=\"from-orange-500\"][class*=\"to-red-500\"],\n.gt-themed [class*=\"from-yellow-500\"][class*=\"to-orange-500\"],\n.gt-themed [class*=\"from-rose-500\"][class*=\"to-pink-500\"] {\n  background: var(--gt-primary) !important;\n  background-image: none !important;\n  color: #ffffff !important;\n  box-shadow: var(--gt-glow-soft) !important;\n}\n\n/* Hero card strips — saturated gradient with hero-sized padding (p-6/p-8 or\n   substantial px-/py-) → FLATTEN to transparent. Distinguishes from small\n   icon accents above by requiring large padding. */\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-8\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-8\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-600\"][class*=\"to-pink-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-8\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-600\"][class*=\"to-purple-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-600\"][class*=\"to-purple-600\"][class*=\"p-8\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-600\"][class*=\"to-purple-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-600\"][class*=\"to-purple-600\"][class*=\"p-8\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-purple-600\"][class*=\"p-6\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-purple-600\"][class*=\"p-8\"] {\n  background: transparent !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n\n/* Inside those flat hero strips, white text & light-tinted text become muted\n   theme text so they read on the cream surface */\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]),\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]),\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]),\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-600\"][class*=\"to-purple-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]),\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-600\"][class*=\"to-purple-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]),\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] *:not(svg):not([class*=\"gt-\"]) {\n  color: inherit;\n}\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] h1,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] h2,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] h1,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] h2,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h1,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h2,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h1,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h2 {\n  color: var(--gt-text-primary) !important;\n  font-family: var(--gt-font-display) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] h2 em,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] h2 em,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] h2 em {\n  color: var(--gt-primary) !important;\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-weight: 500 !important;\n}\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-600\"][class*=\"to-purple-600\"][class*=\"p-6\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-600\"][class*=\"to-purple-600\"][class*=\"p-6\"] .text-white {\n  color: var(--gt-text-primary) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] [class*=\"text-white/\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] [class*=\"text-white/\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] [class*=\"text-white/\"] {\n  color: var(--gt-text-tertiary) !important;\n}\n/* Inner translucent widgets in flat hero strips → solid theme card */\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-blue-500\"][class*=\"to-indigo-600\"][class*=\"p-6\"] [class*=\"bg-white/\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-purple-500\"][class*=\"to-pink-600\"][class*=\"p-6\"] [class*=\"bg-white/\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-500\"][class*=\"to-purple-600\"][class*=\"p-6\"] [class*=\"bg-white/\"],\n.gt-themed [class*=\"bg-gradient-to-\"][class*=\"from-indigo-600\"][class*=\"to-purple-600\"][class*=\"p-6\"] [class*=\"bg-white/\"] {\n  background: var(--gt-surface-2) !important;\n  border: 1px solid var(--gt-border) !important;\n  color: var(--gt-text-primary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* Banner gradients → flat cream */\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-indigo-50\"],\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-purple-50\"],\n.gt-themed [class*=\"from-indigo-50\"][class*=\"to-purple-50\"],\n.gt-themed [class*=\"from-purple-50\"][class*=\"to-pink-50\"],\n.gt-themed [class*=\"from-violet-50\"][class*=\"to-pink-50\"],\n.gt-themed [class*=\"from-slate-50\"][class*=\"to-blue-50\"],\n.gt-themed [class*=\"from-gray-50\"][class*=\"to-gray-100\"],\n.gt-themed [class*=\"from-gray-50\"][class*=\"to-white\"][class*=\"to-gray-50\"] {\n  background: var(--gt-surface-1) !important;\n  background-image: none !important;\n}\n\n/* Text-gradient titles → solid primary */\n.gt-themed [class*=\"bg-clip-text\"][class*=\"text-transparent\"] {\n  background: none !important;\n  -webkit-background-clip: initial !important;\n  background-clip: initial !important;\n  -webkit-text-fill-color: var(--gt-primary) !important;\n  color: var(--gt-primary) !important;\n  font-family: var(--gt-font-display);\n  letter-spacing: -0.03em;\n}\n\n/* Emerald / green accents → primary */\n.gt-themed .bg-emerald-500, .gt-themed .bg-green-500,\n.gt-themed .bg-emerald-600, .gt-themed .bg-green-600,\n.gt-themed .bg-teal-500, .gt-themed .bg-teal-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }\n.gt-themed .text-emerald-500, .gt-themed .text-emerald-600,\n.gt-themed .text-green-500, .gt-themed .text-green-600,\n.gt-themed .text-teal-500, .gt-themed .text-teal-600 { color: var(--gt-primary) !important; }\n.gt-themed .bg-emerald-50, .gt-themed .bg-green-50, .gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-emerald-100, .gt-themed .bg-green-100, .gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; }\n.gt-themed .text-emerald-700, .gt-themed .text-green-700, .gt-themed .text-emerald-800, .gt-themed .text-teal-700 { color: var(--gt-primary-deep) !important; }\n\n/* Inputs auto-style */\n.gt-themed input[type=\"text\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"email\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"number\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"search\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"tel\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"url\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"date\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"time\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"datetime-local\"]:not([class*=\"gt-\"]),\n.gt-themed textarea:not([class*=\"gt-\"]),\n.gt-themed select:not([class*=\"gt-\"]) {\n  background: var(--gt-surface-0);\n  border-color: var(--gt-border);\n  color: var(--gt-text-primary);\n  font-family: var(--gt-font);\n  border-radius: var(--gt-radius-input);\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);\n}\n.gt-themed input:not([class*=\"gt-\"]):focus,\n.gt-themed textarea:not([class*=\"gt-\"]):focus,\n.gt-themed select:not([class*=\"gt-\"]):focus {\n  border-color: var(--gt-primary) !important;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);\n}\n\n/* Themed scrollbars */\n.gt-themed *::-webkit-scrollbar { width: 10px; height: 10px; }\n.gt-themed *::-webkit-scrollbar-track { background: transparent; }\n.gt-themed *::-webkit-scrollbar-thumb { background: var(--gt-border-strong); border-radius: 9999px; border: 2px solid transparent; background-clip: padding-box; }\n.gt-themed *::-webkit-scrollbar-thumb:hover { background: var(--gt-primary); background-clip: padding-box; }\n.gt-themed { scrollbar-color: var(--gt-border-strong) transparent; scrollbar-width: thin; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   PROJECT-WIDE THEMING — applied via the global gt-themed wrapper so every\n   page inherits the task-management aesthetic without rewrites.\n   ──────────────────────────────────────────────────────────────────────── */\n\n/* Typography — all headings use display font with refined tracking */\n.gt-themed,\n.gt-themed p,\n.gt-themed span,\n.gt-themed div,\n.gt-themed label,\n.gt-themed li,\n.gt-themed td,\n.gt-themed th { font-family: var(--gt-font); }\n\n.gt-themed h1, .gt-themed h2, .gt-themed h3,\n.gt-themed h4, .gt-themed h5, .gt-themed h6 {\n  font-family: var(--gt-font-display);\n  color: var(--gt-text-primary);\n  letter-spacing: -0.02em;\n  font-weight: 700;\n}\n.gt-themed h1 { font-size: clamp(1.75rem, 1.2rem + 1.6vw, 2.25rem); line-height: 1.1; letter-spacing: -0.03em; font-weight: 800; }\n.gt-themed h2 { font-size: 1.5rem;  line-height: 1.2; }\n.gt-themed h3 { font-size: 1.25rem; line-height: 1.25; }\n.gt-themed h4 { font-size: 1.05rem; line-height: 1.3; }\n/* ──────────────────────────────────────────────────────────────────────\n   Fraunces serif italic — applied globally for editorial accents.\n   Covers <em>, <i>, <cite>, <q>, <blockquote>, <figcaption>, <address>,\n   form <label> elements, table caption, and any element marked\n   .gt-serif-italic / .serif-italic / .italic-accent.\n   These rules apply project-wide because <body> carries .gt-themed.\n   ────────────────────────────────────────────────────────────────────── */\n.gt-themed em,\n.gt-themed i,\n.gt-themed cite,\n.gt-themed q,\n.gt-themed blockquote,\n.gt-themed figcaption,\n.gt-themed address,\n.gt-themed caption,\n.gt-themed dfn,\n.gt-themed .gt-serif-italic,\n.gt-themed .serif-italic,\n.gt-themed .italic-accent,\n.gt-themed h1 em, .gt-themed h2 em, .gt-themed h3 em, .gt-themed h4 em,\n.gt-themed h1 i,  .gt-themed h2 i,  .gt-themed h3 i,  .gt-themed h4 i {\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-feature-settings: 'ss01', 'ss03';\n}\n\n/* Form labels use Fraunces italic for editorial polish */\n.gt-themed label,\n.gt-themed legend,\n.gt-themed .form-label,\n.gt-themed .gt-field-label-italic {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-text-secondary);\n  letter-spacing: 0.005em;\n}\n\n/* Modal / dialog titles get a subtle italic accent on every <em> they contain */\n.gt-themed [role=\"dialog\"] h1 em,\n.gt-themed [role=\"dialog\"] h2 em,\n.gt-themed [role=\"dialog\"] h3 em,\n.gt-themed [role=\"dialog\"] h4 em,\n.gt-themed [role=\"dialog\"] em {\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-weight: 600;\n  color: var(--gt-primary);\n}\n.gt-themed strong, .gt-themed b { font-weight: 700; color: var(--gt-text-primary); }\n.gt-themed code, .gt-themed pre { font-family: var(--gt-font-mono); }\n\n/* Links pick up theme primary */\n.gt-themed a:not(.gt-btn):not([class*=\"text-\"]) {\n  color: var(--gt-text-link);\n  transition: color var(--gt-t-fast);\n}\n.gt-themed a:not(.gt-btn):not([class*=\"text-\"]):hover { color: var(--gt-primary-hover); }\n\n/* Generic card-like containers — any white rounded surface picks up the soft\n   theme card look unless it already declares an explicit border. */\n.gt-themed .bg-white.rounded-xl,\n.gt-themed .bg-white.rounded-2xl,\n.gt-themed .bg-white.rounded-3xl,\n.gt-themed .bg-white.shadow,\n.gt-themed .bg-white.shadow-sm,\n.gt-themed .bg-white.shadow-md,\n.gt-themed .bg-white.shadow-lg,\n.gt-themed .bg-white.shadow-xl {\n  background: var(--gt-surface-0) !important;\n  border: 1px solid var(--gt-border) !important;\n  box-shadow: var(--gt-elev-1) !important;\n  border-radius: var(--gt-radius-card) !important;\n}\n\n/* Bare buttons (no styling class) get the soft theme look */\n.gt-themed button:not([class*=\"bg-\"]):not([class*=\"gt-\"]):not([class*=\"gc-\"]):not([class*=\"rounded\"]):not([class*=\"cm-\"]):not(:disabled) {\n  font-family: var(--gt-font-display);\n  font-weight: 600;\n  color: var(--gt-text-primary);\n  transition: color var(--gt-t-fast), background var(--gt-t-fast);\n}\n\n/* shadcn-style class overrides (bg-card / bg-muted / bg-popover etc.) */\n.gt-themed .bg-card        { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }\n.gt-themed .bg-popover     { background-color: var(--gt-surface-0) !important; color: var(--gt-text-primary) !important; }\n.gt-themed .bg-muted       { background-color: var(--gt-surface-2) !important; }\n.gt-themed .bg-accent      { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }\n.gt-themed .bg-secondary   { background-color: var(--gt-surface-2) !important; }\n.gt-themed .bg-primary     { background-color: var(--gt-primary) !important; color: var(--gt-on-primary) !important; }\n.gt-themed .bg-destructive { background-color: var(--gt-dnd) !important; color: #ffffff !important; }\n.gt-themed .bg-background  { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-foreground  { background-color: var(--gt-text-primary) !important; }\n\n.gt-themed .text-primary       { color: var(--gt-primary) !important; }\n.gt-themed .text-primary-foreground { color: var(--gt-on-primary) !important; }\n.gt-themed .text-muted-foreground   { color: var(--gt-text-tertiary) !important; }\n.gt-themed .text-card-foreground    { color: var(--gt-text-primary) !important; }\n.gt-themed .text-popover-foreground { color: var(--gt-text-primary) !important; }\n.gt-themed .text-foreground         { color: var(--gt-text-primary) !important; }\n.gt-themed .text-secondary-foreground { color: var(--gt-text-primary) !important; }\n.gt-themed .text-accent-foreground  { color: var(--gt-primary-deep) !important; }\n.gt-themed .text-destructive        { color: var(--gt-dnd) !important; }\n\n.gt-themed .border-border { border-color: var(--gt-border) !important; }\n.gt-themed .border-input  { border-color: var(--gt-border) !important; }\n.gt-themed .border-primary { border-color: var(--gt-primary) !important; }\n\n/* Tailwind ring tokens used by shadcn focus rings */\n.gt-themed .ring-ring,\n.gt-themed .focus\\:ring-ring:focus { --tw-ring-color: var(--gt-primary) !important; }\n\n/* Tables — subtle theme defaults */\n.gt-themed table { font-family: var(--gt-font); color: var(--gt-text-primary); }\n\n.gt-themed .pr-table thead th,\n.gt-shell .pr-table thead th,\n.pr-table thead th {\n  white-space: nowrap;\n  overflow-wrap: normal;\n  word-break: normal;\n  vertical-align: middle;\n}\n\n.gt-sticky-table-wrap {\n  position: relative;\n  overflow: auto;\n  max-height: 70vh;\n}\n\n.gt-sticky-table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.gt-sticky-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 6;\n  background: var(--gt-surface-1, #f8fafc);\n}\n\n.gt-sticky-table .gt-sticky-col {\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  background: var(--gt-surface-0, #ffffff);\n  box-shadow: 1px 0 0 var(--gt-border, #e5e7eb);\n}\n\n.gt-sticky-table thead .gt-sticky-col {\n  z-index: 8;\n  background: var(--gt-surface-1, #f8fafc);\n}\n\n.gt-sticky-table .gt-sticky-col-select {\n  left: 0;\n  width: 48px;\n  min-width: 48px;\n}\n\n.gt-sticky-table .gt-sticky-col-after-select {\n  left: 48px;\n}\n\n.gt-sticky-table tbody tr:hover .gt-sticky-col {\n  background: var(--gt-surface-1, #f8fafc);\n}\n.gt-attendance-table thead th {\n  color: var(--gt-text-secondary) !important;\n  background: var(--gt-surface-2, #f8fafc) !important;\n}\n.gt-attendance-table tbody td {\n  color: var(--gt-text-secondary);\n}\n.gt-attendance-table tbody .gt-sticky-col {\n  background: transparent !important;\n  box-shadow: none;\n}\n.gt-attendance-table tbody tr:hover .gt-sticky-col {\n  background: transparent !important;\n}\n.gt-attendance-detail-row:hover {\n  background-color: rgba(255, 255, 255, 0.055) !important;\n}\n.gt-attendance-detail-row.is-clickable:hover {\n  background-color: rgba(16, 185, 129, 0.12) !important;\n}\n.gt-attendance-employee-name {\n  color: var(--gt-text-primary) !important;\n}\n.gt-attendance-employee-code {\n  color: var(--gt-text-tertiary) !important;\n}\n.gt-att-pill,\n.gt-att-summary {\n  border-style: solid !important;\n  border-width: 1px !important;\n  font-weight: 700 !important;\n}\n.gt-att-pill.gt-att-pill--present,\n.gt-att-pill.gt-att-pill--present.bg-green-100,\n.gt-att-summary.gt-att-summary--present,\n.gt-att-summary.gt-att-summary--present.bg-green-100 {\n  background-color: #d8f5e6 !important;\n  color: #064e2b !important;\n  border-color: #86efac !important;\n}\n.gt-att-pill.gt-att-pill--leave,\n.gt-att-pill.gt-att-pill--leave.bg-amber-100,\n.gt-att-summary.gt-att-summary--leave,\n.gt-att-summary.gt-att-summary--leave.bg-amber-100 {\n  background-color: #fef3c7 !important;\n  color: #713f12 !important;\n  border-color: #facc15 !important;\n}\n.gt-att-pill.gt-att-pill--absent,\n.gt-att-pill.gt-att-pill--absent.bg-red-100,\n.gt-att-summary.gt-att-summary--absent,\n.gt-att-summary.gt-att-summary--absent.bg-red-100 {\n  background-color: #fee2e2 !important;\n  color: #7f1d1d !important;\n  border-color: #fca5a5 !important;\n}\n.gt-att-summary.gt-att-summary--total,\n.gt-att-summary.gt-att-summary--total.bg-blue-100 {\n  background-color: #dbeafe !important;\n  color: #1e3a8a !important;\n  border-color: #93c5fd !important;\n}\n[data-theme=\"dark\"] .gt-attendance-table thead th {\n  color: #d6d6d6 !important;\n}\n[data-theme=\"dark\"] .gt-attendance-employee-code {\n  color: #ababab !important;\n}\n.gt-themed thead th {\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  border-bottom: 1px solid var(--gt-border);\n}\n.gt-themed tbody tr { border-bottom: 1px solid var(--gt-divider); }\n.gt-themed tbody tr:hover { background: var(--gt-surface-hover); }\n\n/* Remove leftover backdrop-filter blur on visible UI inside themed regions */\n.gt-themed [class*=\"backdrop-blur\"]:not([class*=\"bg-black\"]) {\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   GLOBAL MODAL THEMING — covers portaled modals that render at body level.\n   Body carries the .gt-themed class (set by useTheme hook), so all the\n   project-wide rules above also apply to dialogs/sheets/popovers. These\n   extra rules tighten common modal patterns.\n   ────────────────────────────────────────────────────────────────────── */\n\n/* Modal scrims — soft dim, subtle blur, no aurora */\n.gt-themed .fixed.inset-0[class*=\"bg-black\"],\nbody > [data-radix-portal] [class*=\"bg-black/\"],\nbody > [role=\"dialog\"] + .fixed.inset-0,\n.gt-themed [data-state=\"open\"][class*=\"bg-black\"] {\n  background: rgba(20, 20, 18, 0.40) !important;\n  backdrop-filter: blur(4px) !important;\n  -webkit-backdrop-filter: blur(4px) !important;\n}\n\n/* Dialog/sheet content surfaces — cream card with theme border + shadow */\n.gt-themed [role=\"dialog\"]:not(.gt-modal):not([class*=\"gt-\"]),\n.gt-themed [data-radix-dialog-content],\n.gt-themed [data-radix-popover-content],\n.gt-themed [data-radix-dropdown-menu-content],\n.gt-themed [data-radix-context-menu-content],\n.gt-themed [data-radix-hover-card-content],\n.gt-themed [data-radix-tooltip-content],\n.gt-themed [data-state=\"open\"][role=\"menu\"],\n.gt-themed [data-state=\"open\"][role=\"listbox\"] {\n  background: var(--gt-surface-0) !important;\n  color: var(--gt-text-primary) !important;\n  border: 1px solid var(--gt-border) !important;\n  border-radius: var(--gt-radius-modal) !important;\n  box-shadow: var(--gt-elev-4) !important;\n  font-family: var(--gt-font) !important;\n}\n\n/* Tooltip is smaller — keep tighter */\n.gt-themed [data-radix-tooltip-content] {\n  font-size: 11.5px !important;\n  padding: 6px 10px !important;\n  border-radius: 8px !important;\n  box-shadow: var(--gt-elev-3) !important;\n}\n\n/* Modal headings */\n.gt-themed [role=\"dialog\"] h1,\n.gt-themed [role=\"dialog\"] h2,\n.gt-themed [role=\"dialog\"] h3,\n.gt-themed [role=\"dialog\"] h4 {\n  font-family: var(--gt-font-display);\n  color: var(--gt-text-primary);\n  letter-spacing: -0.02em;\n}\n\n/* Modal body text */\n.gt-themed [role=\"dialog\"] p,\n.gt-themed [role=\"dialog\"] label { color: var(--gt-text-secondary); }\n\n/* Modal divider lines — subtle theme divider */\n.gt-themed [role=\"dialog\"] hr,\n.gt-themed [role=\"dialog\"] [class*=\"border-t\"],\n.gt-themed [role=\"dialog\"] [class*=\"border-b\"] {\n  border-color: var(--gt-divider) !important;\n}\n\n/* Modal action buttons — bare submit/save buttons get theme primary */\n.gt-themed [role=\"dialog\"] button[type=\"submit\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]),\n.gt-themed form button[type=\"submit\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]) {\n  background: var(--gt-primary) !important;\n  color: var(--gt-on-primary) !important;\n  border: 1px solid transparent !important;\n  border-radius: var(--gt-radius-pill) !important;\n  padding: 9px 18px !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  cursor: pointer !important;\n  transition: background var(--gt-t-fast) !important;\n}\n.gt-themed [role=\"dialog\"] button[type=\"submit\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover,\n.gt-themed form button[type=\"submit\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover {\n  background: var(--gt-primary-hover) !important;\n}\n\n/* Modal close (X) icon button — soft cream with theme hover */\n.gt-themed [role=\"dialog\"] button[aria-label*=\"close\" i]:not([class*=\"gt-\"]),\n.gt-themed [role=\"dialog\"] button[aria-label*=\"Close\" i]:not([class*=\"gt-\"]) {\n  color: var(--gt-text-tertiary) !important;\n  background: transparent !important;\n  border-radius: 10px !important;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast) !important;\n}\n.gt-themed [role=\"dialog\"] button[aria-label*=\"close\" i]:not([class*=\"gt-\"]):hover,\n.gt-themed [role=\"dialog\"] button[aria-label*=\"Close\" i]:not([class*=\"gt-\"]):hover {\n  background: var(--gt-surface-2) !important;\n  color: var(--gt-text-primary) !important;\n}\n\n/* Inputs / selects / textareas inside modals — pick up theme styles */\n.gt-themed [role=\"dialog\"] input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([class*=\"gt-\"]),\n.gt-themed [role=\"dialog\"] textarea:not([class*=\"gt-\"]),\n.gt-themed [role=\"dialog\"] select:not([class*=\"gt-\"]) {\n  background: var(--gt-surface-0) !important;\n  border: 1px solid var(--gt-border) !important;\n  color: var(--gt-text-primary) !important;\n  border-radius: var(--gt-radius-input) !important;\n  font-family: var(--gt-font) !important;\n  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast) !important;\n}\n.gt-themed [role=\"dialog\"] input:focus:not([class*=\"gt-\"]),\n.gt-themed [role=\"dialog\"] textarea:focus:not([class*=\"gt-\"]),\n.gt-themed [role=\"dialog\"] select:focus:not([class*=\"gt-\"]) {\n  border-color: var(--gt-primary) !important;\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   DASHBOARD & GENERAL PAGE THEMING — covers translucent cards, colored\n   100-tone backgrounds, and any leftover glass-y patterns project-wide.\n   ────────────────────────────────────────────────────────────────────── */\n\n/* Kill translucent white \"glass\" cards (bg-white/80, /70, /50, /60 …) */\n.gt-themed [class*=\"bg-white/\"],\n.gt-themed .bg-white\\/80,\n.gt-themed .bg-white\\/70,\n.gt-themed .bg-white\\/60,\n.gt-themed .bg-white\\/50,\n.gt-themed .bg-white\\/40,\n.gt-themed .bg-white\\/30 {\n  background-color: var(--gt-surface-0) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* Kill all backdrop-blur on visible chrome (modal scrims keep theirs) */\n.gt-themed .backdrop-blur,\n.gt-themed .backdrop-blur-sm,\n.gt-themed .backdrop-blur-md,\n.gt-themed .backdrop-blur-lg,\n.gt-themed .backdrop-blur-xl {\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* Color-100 soft backgrounds → soft theme tints */\n.gt-themed .bg-green-100,\n.gt-themed .bg-emerald-100,\n.gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }\n.gt-themed .bg-red-100   { background-color: var(--gt-prio-urgent-bg) !important; color: var(--gt-prio-urgent-fg) !important; }\n.gt-themed .bg-orange-100,\n.gt-themed .bg-amber-100,\n.gt-themed .bg-yellow-100 { background-color: var(--gt-prio-high-bg) !important; color: var(--gt-prio-high-fg) !important; }\n\n/* Color-200 borders */\n.gt-themed .border-green-200,\n.gt-themed .border-emerald-200,\n.gt-themed .border-teal-200 { border-color: var(--gt-accent-soft) !important; }\n.gt-themed .border-red-200    { border-color: rgba(220, 38, 38, 0.25) !important; }\n.gt-themed .border-orange-200,\n.gt-themed .border-amber-200,\n.gt-themed .border-yellow-200 { border-color: rgba(217, 119, 6, 0.25) !important; }\n\n/* Color-50 backgrounds */\n.gt-themed .bg-green-50,\n.gt-themed .bg-emerald-50,\n.gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-red-50    { background-color: var(--gt-prio-urgent-bg) !important; }\n.gt-themed .bg-orange-50,\n.gt-themed .bg-amber-50,\n.gt-themed .bg-yellow-50 { background-color: var(--gt-prio-med-bg) !important; }\n\n/* Color text 600 */\n.gt-themed .text-red-600,\n.gt-themed .text-red-500    { color: var(--gt-prio-urgent-fg) !important; }\n.gt-themed .text-orange-600,\n.gt-themed .text-orange-500,\n.gt-themed .text-amber-600,\n.gt-themed .text-yellow-600 { color: var(--gt-prio-high-fg) !important; }\n\n/* Neutral page-wrapper gradients (gray/slate/stone/neutral/zinc) → flat cream.\n   These are page backgrounds, not hero strips — keep them light. */\n.gt-themed [class*=\"from-gray-\"][class*=\"via-gray-\"],\n.gt-themed [class*=\"from-slate-\"][class*=\"via-slate-\"],\n.gt-themed [class*=\"from-stone-\"][class*=\"via-stone-\"],\n.gt-themed [class*=\"from-neutral-\"][class*=\"via-neutral-\"],\n.gt-themed [class*=\"from-zinc-\"][class*=\"via-zinc-\"],\n.gt-themed [class*=\"from-gray-50\"],\n.gt-themed [class*=\"from-gray-100\"],\n.gt-themed [class*=\"from-slate-50\"],\n.gt-themed [class*=\"from-slate-100\"] {\n  background: var(--gt-surface-1) !important;\n  background-image: none !important;\n  color: var(--gt-text-primary) !important;\n  box-shadow: none !important;\n}\n\n/* White-card wrappers that exist solely to frame a saturated hero gradient\n   (e.g. PayrollRecord's `bg-white shadow-xl rounded-2xl overflow-hidden`\n   wrapping `bg-gradient-to-r via-purple-600`) — dissolve into the page\n   surface so the page reads flat like the Task Management pattern.\n   Uses :has() (Chrome 105+, Safari 15.4+, Firefox 121+). */\n.gt-themed [class*=\"bg-white\"][class*=\"rounded-2xl\"]:has(> [class*=\"bg-gradient-to-r\"][class*=\"via-\"]),\n.gt-themed [class*=\"bg-white\"][class*=\"rounded-2xl\"]:has(> [class*=\"bg-gradient-to-br\"][class*=\"via-\"]),\n.gt-themed [class*=\"bg-white\"][class*=\"rounded-3xl\"]:has(> [class*=\"bg-gradient-to-r\"][class*=\"via-\"]),\n.gt-themed [class*=\"bg-white\"][class*=\"rounded-xl\"]:has(> [class*=\"bg-gradient-to-r\"][class*=\"via-\"]) {\n  background: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  overflow: visible !important;\n  border: 0 !important;\n}\n\n/* Generic page-frame cards: a width-constrained `max-w-* mx-auto bg-white\n   shadow-* rounded-*` outer wrapper used as the page's only visual container\n   (e.g. PayrollSetting, AddPayroll, changepass). Flatten so the content sits\n   directly on the cream page surface like every other themed page. */\n.gt-themed [class*=\"max-w-\"][class*=\"mx-auto\"][class*=\"bg-white\"][class*=\"shadow-xl\"][class*=\"rounded-2xl\"],\n.gt-themed [class*=\"max-w-\"][class*=\"mx-auto\"][class*=\"bg-white\"][class*=\"shadow-2xl\"][class*=\"rounded-2xl\"],\n.gt-themed [class*=\"max-w-\"][class*=\"mx-auto\"][class*=\"bg-white\"][class*=\"shadow-lg\"][class*=\"rounded-2xl\"],\n.gt-themed [class*=\"max-w-\"][class*=\"mx-auto\"][class*=\"bg-white\"][class*=\"shadow-xl\"][class*=\"rounded-3xl\"],\n.gt-themed [class*=\"max-w-\"][class*=\"mx-auto\"][class*=\"bg-white\"][class*=\"shadow-2xl\"][class*=\"rounded-3xl\"] {\n  background: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: 0 !important;\n  padding-left: clamp(16px, 3vw, 28px) !important;\n  padding-right: clamp(16px, 3vw, 28px) !important;\n}\n\n/* Centered-title pattern: a lone `text-center` heading at the top of a page\n   (no eyebrow, no subtitle) — left-align so it matches the editorial Task\n   Management header pattern across the entire app. */\n.gt-themed h1[class*=\"text-center\"]:not([class*=\"bg-clip\"]),\n.gt-themed h2[class*=\"text-center\"]:not([class*=\"bg-clip\"]) {\n  text-align: left !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.025em !important;\n  color: var(--gt-text-primary) !important;\n  font-size: clamp(28px, 3.2vw, 40px) !important;\n  line-height: 1.1 !important;\n}\n.gt-themed h1[class*=\"text-center\"] em,\n.gt-themed h1[class*=\"text-center\"] i,\n.gt-themed h2[class*=\"text-center\"] em,\n.gt-themed h2[class*=\"text-center\"] i {\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-weight: 500 !important;\n  color: var(--gt-primary) !important;\n  letter-spacing: 0 !important;\n}\n\n/* Subtle inner-tinted sections (`bg-gradient-to-br from-gray-50 to-white`\n   etc.) used as form-card backgrounds inside flattened wrappers — keep flat\n   theme surface so they don't reintroduce visual containers */\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"from-gray-50\"][class*=\"to-white\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"from-slate-50\"][class*=\"to-white\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"from-gray-50\"][class*=\"to-white\"] {\n  background: transparent !important;\n  background-image: none !important;\n}\n\n/* Saturated hero gradients (multi-stop with via- and SATURATED color stops\n   like 500/600/700 blues, purples, cyans, indigos, pinks) → FLATTEN entirely.\n   Per global design rule: every page header should look like the Task module\n   pattern (eyebrow + title + subtitle on cream surface, no colored box). */\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-purple-600\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-purple-500\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-blue-600\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-indigo-600\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-pink-500\"],\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-cyan-600\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-purple-600\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-blue-600\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-indigo-600\"],\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-purple-600\"],\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-blue-600\"] {\n  background: transparent !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/* Heading inside a flattened hero gets the proper page-title treatment so\n   it reads as editorial type, not a box label. */\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] h1,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] h1,\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] h1 {\n  color: var(--gt-text-primary) !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 700 !important;\n  font-size: clamp(28px, 3.2vw, 40px) !important;\n  letter-spacing: -0.025em !important;\n  line-height: 1.1 !important;\n  margin: 0 !important;\n}\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] h1 i,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] h1 i,\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] h1 em,\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] h1 i {\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-weight: 500 !important;\n  color: var(--gt-primary) !important;\n  letter-spacing: 0 !important;\n}\n\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] h2,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] h2 {\n  color: var(--gt-text-primary) !important;\n  font-family: var(--gt-font-display) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] p,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] p {\n  color: var(--gt-text-tertiary) !important;\n  font-family: var(--gt-font) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] span:not([class*=\"bg-\"]),\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] span:not([class*=\"bg-\"]) {\n  color: inherit !important;\n}\n\n/* Translucent inner widgets that used to live on a dark hero (e.g. bg-white/10)\n   become subtle theme cards on the flat surface */\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] [class*=\"bg-white/\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] [class*=\"bg-white/\"],\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] [class*=\"bg-white/\"] {\n  background: var(--gt-surface-0) !important;\n  border: 1px solid var(--gt-border) !important;\n  border-radius: var(--gt-radius-card) !important;\n  color: var(--gt-text-primary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  box-shadow: var(--gt-elev-1) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] [class*=\"bg-white/\"] *,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] [class*=\"bg-white/\"] *,\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] [class*=\"bg-white/\"] * {\n  color: var(--gt-text-primary) !important;\n}\n\n/* Gradient-text headings (bg-gradient + bg-clip-text + text-transparent on\n   an h1/h2/h3) are a common AI-slop pattern. Flatten globally — heading\n   becomes solid theme-primary text. The useTitleAccent hook still wraps the\n   last word in <em> so the editorial italic accent appears as designed. */\n.gt-themed h1[class*=\"bg-clip-text\"],\n.gt-themed h2[class*=\"bg-clip-text\"],\n.gt-themed h3[class*=\"bg-clip-text\"],\n.gt-themed h1[class*=\"text-transparent\"][class*=\"bg-gradient\"],\n.gt-themed h2[class*=\"text-transparent\"][class*=\"bg-gradient\"],\n.gt-themed h3[class*=\"text-transparent\"][class*=\"bg-gradient\"],\n.gt-themed [class*=\"bg-clip-text\"][class*=\"text-transparent\"] {\n  background: none !important;\n  background-clip: initial !important;\n  -webkit-background-clip: initial !important;\n  -webkit-text-fill-color: var(--gt-text-primary) !important;\n  color: var(--gt-text-primary) !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.025em !important;\n}\n.gt-themed h1[class*=\"bg-clip-text\"] em,\n.gt-themed h1[class*=\"bg-clip-text\"] i,\n.gt-themed h2[class*=\"bg-clip-text\"] em,\n.gt-themed h2[class*=\"bg-clip-text\"] i,\n.gt-themed h1[class*=\"text-transparent\"][class*=\"bg-gradient\"] em,\n.gt-themed h1[class*=\"text-transparent\"][class*=\"bg-gradient\"] i,\n.gt-themed h2[class*=\"text-transparent\"][class*=\"bg-gradient\"] em,\n.gt-themed h2[class*=\"text-transparent\"][class*=\"bg-gradient\"] i {\n  font-family: var(--gt-font-serif) !important;\n  font-style: italic !important;\n  font-weight: 500 !important;\n  color: var(--gt-primary) !important;\n  -webkit-text-fill-color: var(--gt-primary) !important;\n  letter-spacing: 0 !important;\n}\n\n/* Inside a flattened gradient hero, white/tinted-white text becomes muted\n   secondary text so it reads on the new cream surface. Outside heroes,\n   .text-white retains its original white (for legitimate dark buttons). */\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] .text-white,\n.gt-themed [class*=\"bg-gradient-to-l\"][class*=\"via-\"] .text-white {\n  color: var(--gt-text-primary) !important;\n}\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-blue-100,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-indigo-100,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-indigo-200,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-purple-100,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-purple-200,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-pink-100,\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-cyan-100,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] .text-blue-100,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] .text-indigo-100,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] .text-purple-100 {\n  color: var(--gt-text-tertiary) !important;\n}\n\n/* Icons that used text-white inside the now-flat hero need a theme color too */\n.gt-themed [class*=\"bg-gradient-to-r\"][class*=\"via-\"] .text-white svg,\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"via-\"] .text-white svg {\n  color: var(--gt-primary) !important;\n}\n\n/* Loading spinners using border-blue → theme primary */\n.gt-themed .border-b-2.border-blue-600,\n.gt-themed .border-blue-600.rounded-full,\n.gt-themed .animate-spin.border-blue-600 { border-color: var(--gt-primary) !important; border-bottom-color: transparent !important; }\n\n/* Hover scale on cards stays subtle */\n.gt-themed [class*=\"hover:scale-1\"]:hover {\n  box-shadow: var(--gt-elev-3) !important;\n}\n\n/* Soft duo-gradient stat cards (e.g. from-blue-50 to-blue-100) → cream card\n   with theme border + subtle shadow + smooth hover */\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-blue-100\"],\n.gt-themed [class*=\"from-green-50\"][class*=\"to-green-100\"],\n.gt-themed [class*=\"from-emerald-50\"][class*=\"to-emerald-100\"],\n.gt-themed [class*=\"from-red-50\"][class*=\"to-red-100\"],\n.gt-themed [class*=\"from-orange-50\"][class*=\"to-orange-100\"],\n.gt-themed [class*=\"from-amber-50\"][class*=\"to-amber-100\"],\n.gt-themed [class*=\"from-yellow-50\"][class*=\"to-yellow-100\"],\n.gt-themed [class*=\"from-purple-50\"][class*=\"to-purple-100\"],\n.gt-themed [class*=\"from-violet-50\"][class*=\"to-violet-100\"],\n.gt-themed [class*=\"from-indigo-50\"][class*=\"to-indigo-100\"],\n.gt-themed [class*=\"from-pink-50\"][class*=\"to-pink-100\"],\n.gt-themed [class*=\"from-cyan-50\"][class*=\"to-cyan-100\"],\n.gt-themed [class*=\"from-teal-50\"][class*=\"to-teal-100\"] {\n  background: var(--gt-surface-0) !important;\n  background-image: none !important;\n  border: 1px solid var(--gt-border) !important;\n  box-shadow: var(--gt-elev-1) !important;\n  border-radius: var(--gt-radius-card) !important;\n  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid), transform var(--gt-t-mid) !important;\n}\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-blue-100\"]:hover,\n.gt-themed [class*=\"from-green-50\"][class*=\"to-green-100\"]:hover,\n.gt-themed [class*=\"from-red-50\"][class*=\"to-red-100\"]:hover,\n.gt-themed [class*=\"from-purple-50\"][class*=\"to-purple-100\"]:hover {\n  border-color: var(--gt-border-strong) !important;\n  box-shadow: var(--gt-elev-2) !important;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   UNIVERSAL ANIMATION & MICRO-INTERACTION POLISH\n   Applied broadly inside .gt-themed for consistency with task module.\n   ────────────────────────────────────────────────────────────────────── */\n\n/* Smooth transitions on any interactive surface */\n.gt-themed button,\n.gt-themed a,\n.gt-themed [role=\"button\"],\n.gt-themed [role=\"menuitem\"],\n.gt-themed [role=\"option\"],\n.gt-themed [role=\"tab\"] {\n  transition:\n    background-color var(--gt-t-fast),\n    color var(--gt-t-fast),\n    border-color var(--gt-t-fast),\n    box-shadow var(--gt-t-fast),\n    transform var(--gt-t-fast),\n    opacity var(--gt-t-fast);\n}\n\n/* Subtle press feedback on any button */\n.gt-themed button:active:not(:disabled),\n.gt-themed [role=\"button\"]:active:not([aria-disabled=\"true\"]) {\n  transform: translateY(0.5px);\n}\n\n/* Page mount fade — applied to common page wrapper patterns */\n.gt-themed > main > div > div,\n.gt-themed [class*=\"space-y-\"] {\n  animation: gt-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both;\n}\n\n/* Subtle elevation hop on shadcn Cards */\n.gt-themed [class*=\"rounded-xl\"][class*=\"shadow\"]:hover,\n.gt-themed [class*=\"rounded-2xl\"][class*=\"shadow\"]:hover,\n.gt-themed [class*=\"rounded-3xl\"][class*=\"shadow\"]:hover {\n  box-shadow: var(--gt-elev-3) !important;\n}\n\n/* Dropdown / menu / popover animation */\n.gt-themed [data-state=\"open\"][role=\"menu\"],\n.gt-themed [data-state=\"open\"][role=\"listbox\"],\n.gt-themed [data-radix-popover-content][data-state=\"open\"],\n.gt-themed [data-radix-dropdown-menu-content][data-state=\"open\"],\n.gt-themed [data-radix-context-menu-content][data-state=\"open\"],\n.gt-themed [data-radix-hover-card-content][data-state=\"open\"] {\n  animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;\n}\n\n/* Tab underline animation */\n.gt-themed [role=\"tablist\"] [role=\"tab\"][data-state=\"active\"],\n.gt-themed [role=\"tablist\"] [role=\"tab\"][aria-selected=\"true\"] {\n  border-bottom: 2px solid var(--gt-primary) !important;\n  color: var(--gt-primary) !important;\n  font-weight: 700;\n}\n\n/* Icon-button hover ring */\n.gt-themed button > svg:only-child,\n.gt-themed [role=\"button\"] > svg:only-child {\n  transition: transform var(--gt-t-fast), color var(--gt-t-fast);\n}\n\n/* Toast / notification surfaces (sonner, react-hot-toast etc.) */\n.gt-themed [data-sonner-toast],\n.gt-themed [class*=\"Toastify__toast\"],\n.gt-themed [role=\"status\"][class*=\"rounded\"] {\n  background: var(--gt-surface-0) !important;\n  color: var(--gt-text-primary) !important;\n  border: 1px solid var(--gt-border) !important;\n  border-radius: var(--gt-radius-card) !important;\n  box-shadow: var(--gt-elev-3) !important;\n  font-family: var(--gt-font) !important;\n}\n/* Sonner action buttons (\"Undo\", \"Open planner\"): the generic\n   `.gt-themed button` colour rule would paint their label the same ink as\n   their solid background, hiding it. Give them the theme's primary pill. */\n.gt-themed [data-sonner-toast] button[data-button] {\n  background: var(--gt-primary) !important;\n  color: var(--gt-on-primary, #ffffff) !important;\n  border-radius: var(--gt-radius-pill) !important;\n  font-weight: 600;\n}\n.gt-themed [data-sonner-toast] button[data-button]:hover {\n  background: var(--gt-primary-hover) !important;\n}\n\n/* ============================================================ */\n/* Task Management component classes (.gt-*)                    */\n/* Merged from src/pages/Task/theme/tokens.css                  */\n/* ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --gt-t-fast: 0ms;\n    --gt-t-mid: 0ms;\n    --gt-t-slow: 0ms;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Page shell — transparent so the unified warm-paper backdrop on\n   .gt-app-shell (sage gradient + print-press grain) shows through to\n   every page (tasks, calendar, todo, reports).\n   ────────────────────────────────────────────────────────────────────── */\n.gt-shell {\n  position: relative;\n  min-height: 100%;\n  background: transparent;\n  color: var(--gt-text-primary);\n  font-family: var(--gt-font);\n}\n.gt-shell::before { content: none; }\n.gt-shell > * { position: relative; z-index: 1; }\n\n/* ── Display / eyebrow / serif accents ─────────────────────────────── */\n.gt-display {\n  font-family: var(--gt-font-display);\n  letter-spacing: var(--gt-letter-display);\n  font-weight: 700;\n}\n.gt-eyebrow {\n  font-family: var(--gt-font-display);\n  letter-spacing: var(--gt-letter-eyebrow);\n  text-transform: uppercase;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: var(--gt-text-tertiary);\n}\n.gt-serif-italic {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-feature-settings: 'ss01', 'ss03';\n}\n.gt-numerals { font-feature-settings: 'tnum' 1, 'lnum' 1; }\n\n/* Editorial leaf glyph — solid forest */\n.gt-leaf {\n  display: inline-block;\n  width: 9px; height: 9px;\n  background: var(--gt-primary);\n  border-radius: 100% 0 100% 0;\n  transform: rotate(-15deg);\n  flex-shrink: 0;\n}\n.gt-rule {\n  height: 1px;\n  background: var(--gt-divider);\n}\n\n/* Page title — solid ink + serif italic emphasis */\n.gt-page-title {\n  font-family: var(--gt-font-display);\n  font-weight: 800;\n  letter-spacing: -0.035em;\n  line-height: 1.05;\n  color: var(--gt-text-primary);\n  font-size: clamp(1.95rem, 1.4rem + 2vw, 2.85rem);\n}\n.gt-page-title em {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 600;\n  background: none;\n  -webkit-background-clip: initial;\n  background-clip: initial;\n  -webkit-text-fill-color: currentColor;\n  color: var(--gt-primary);\n  filter: none;\n}\n@keyframes gt-gradient-shift {\n  0%, 100% { background-position: 0% 50%; }\n  50%      { background-position: 100% 50%; }\n}\n.gt-page-sub {\n  font-family: var(--gt-font);\n  color: var(--gt-text-tertiary);\n  font-size: 13.5px;\n  letter-spacing: 0.005em;\n}\n\n/* ── Cards — clean cream with soft border ────────────────────────── */\n.gt-card {\n  position: relative;\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  box-shadow: var(--gt-elev-1);\n  transition:\n    border-color var(--gt-t-fast),\n    box-shadow var(--gt-t-fast),\n    transform var(--gt-t-fast),\n    background var(--gt-t-fast);\n}\n.gt-card::before { content: none; }\n.gt-card > * { position: relative; }\n.gt-card:hover {\n  border-color: var(--gt-border-strong);\n  box-shadow: var(--gt-elev-2);\n  background: var(--gt-surface-0);\n}\n.gt-card.is-flat { box-shadow: none; }\n.gt-card.is-raised { box-shadow: var(--gt-elev-2); }\n.gt-card.is-floating { box-shadow: var(--gt-elev-3); }\n\n/* Bordered column container (Today / Upcoming / Missed) */\n.gt-column {\n  position: relative;\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-sheet);\n  box-shadow: var(--gt-elev-1);\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);\n  overflow: hidden;\n}\n.gt-column::before { content: none; }\n.gt-column > * { position: relative; }\n.gt-column.is-over {\n  background: var(--gt-surface-1);\n  border-color: var(--gt-primary);\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10), var(--gt-elev-2);\n}\n.gt-column-head {\n  display: flex; align-items: center; gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--gt-divider);\n  background: var(--gt-surface-1);\n}\n.gt-column-head .gt-icon-tile {\n  width: 36px; height: 36px;\n  border-radius: 12px;\n  display: flex; align-items: center; justify-content: center;\n  background: var(--gt-primary);\n  color: #ffffff;\n  flex-shrink: 0;\n  box-shadow: var(--gt-glow-soft);\n  position: relative;\n}\n.gt-column-head .gt-icon-tile::after { content: none; }\n.gt-column-head .gt-icon-tile.is-warm  {\n  background: #d4a356;\n  color: #ffffff;\n}\n.gt-column-head .gt-icon-tile.is-alert {\n  background: #c4574c;\n  color: #ffffff;\n}\n.gt-column-head .gt-icon-tile.is-info {\n  background: #6a8bbd;\n  color: #ffffff;\n}\n.gt-column-head .gt-count {\n  margin-left: auto;\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  font-weight: 700;\n  background: var(--gt-surface-2);\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n/* Task card — clean cream with soft border */\n.gt-task-card {\n  position: relative;\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  box-shadow: var(--gt-elev-1);\n  transition:\n    transform var(--gt-t-mid),\n    border-color var(--gt-t-mid),\n    box-shadow var(--gt-t-mid);\n  isolation: isolate;\n  min-height: 300px;\n}\n\n/* Hover-grow — auto-expand a single card on cursor hover (only the hovered card) */\n.gt-hover-grow {\n  transform-origin: center center;\n  transition:\n    transform 220ms cubic-bezier(0.33, 1, 0.68, 1),\n    box-shadow 220ms cubic-bezier(0.33, 1, 0.68, 1),\n    border-color 220ms cubic-bezier(0.33, 1, 0.68, 1);\n  will-change: transform;\n}\n.gt-hover-grow:hover {\n  transform: translateY(-4px) scale(1.025);\n  box-shadow: var(--gt-elev-3, 0 12px 28px -8px rgba(15, 23, 42, 0.18), 0 6px 12px -6px rgba(15, 23, 42, 0.12)) !important;\n  z-index: 5;\n}\n.gt-task-card::before { content: none; }\n.gt-task-card > * { position: relative; }\n.gt-task-card:hover {\n  border-color: var(--gt-border-strong);\n  box-shadow: var(--gt-elev-2);\n}\n.gt-task-card.is-overdue {\n  border-color: var(--gt-prio-urgent-dot);\n}\n.gt-task-card .gt-prio-bar { display: none; }\n.gt-prio-bar.is-urgent { background: var(--gt-prio-urgent-dot); }\n.gt-prio-bar.is-high   { background: var(--gt-prio-high-dot); }\n.gt-prio-bar.is-medium { background: var(--gt-prio-med-dot); }\n.gt-prio-bar.is-low    { background: var(--gt-prio-low-dot); }\n\n/* Priority-tinted cards — vivid left bar, clean white surface */\n.gt-task-card.is-prio-urgent {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-left: 4px solid var(--gt-prio-urgent-dot);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-task-card.is-prio-urgent:hover {\n  border-color: var(--gt-border-strong);\n  border-left-color: var(--gt-prio-urgent-dot);\n  box-shadow: var(--gt-elev-2);\n}\n\n.gt-task-card.is-prio-high {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-left: 4px solid var(--gt-prio-high-dot);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-task-card.is-prio-high:hover {\n  border-color: var(--gt-border-strong);\n  border-left-color: var(--gt-prio-high-dot);\n  box-shadow: var(--gt-elev-2);\n}\n\n.gt-task-card.is-prio-medium {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-left: 4px solid var(--gt-prio-med-dot);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-task-card.is-prio-medium:hover {\n  border-color: var(--gt-border-strong);\n  border-left-color: var(--gt-prio-med-dot);\n  box-shadow: var(--gt-elev-2);\n}\n\n.gt-task-card.is-prio-low {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-left: 4px solid var(--gt-prio-low-dot);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-task-card.is-prio-low:hover {\n  border-color: var(--gt-border-strong);\n  border-left-color: var(--gt-prio-low-dot);\n  box-shadow: var(--gt-elev-2);\n}\n\n/* Daily planner cards (inside .gt-column) — unified clean white with vivid left bar */\n.gt-column .gt-task-card,\n.gt-column .gt-task-card.is-prio-urgent,\n.gt-column .gt-task-card.is-prio-high,\n.gt-column .gt-task-card.is-prio-medium,\n.gt-column .gt-task-card.is-prio-low,\n.gt-column .gt-task-card.is-done {\n  border: 1px solid var(--gt-border) !important;\n  border-left: 4px solid var(--gt-border) !important;\n  background: var(--gt-surface-0) !important;\n  box-shadow: var(--gt-elev-1) !important;\n}\n.gt-column .gt-task-card.is-prio-urgent { border-left-color: var(--gt-prio-urgent-dot) !important; }\n.gt-column .gt-task-card.is-prio-high   { border-left-color: var(--gt-prio-high-dot) !important; }\n.gt-column .gt-task-card.is-prio-medium { border-left-color: var(--gt-prio-med-dot) !important; }\n.gt-column .gt-task-card.is-prio-low    { border-left-color: var(--gt-prio-low-dot) !important; }\n.gt-column .gt-task-card.is-done        { border-left-color: var(--gt-primary) !important; }\n.gt-column .gt-task-card:hover {\n  border-color: var(--gt-border-strong) !important;\n  box-shadow: var(--gt-elev-2) !important;\n}\n.gt-column .gt-task-card.is-prio-urgent:hover { border-left-color: var(--gt-prio-urgent-dot) !important; }\n.gt-column .gt-task-card.is-prio-high:hover   { border-left-color: var(--gt-prio-high-dot) !important; }\n.gt-column .gt-task-card.is-prio-medium:hover { border-left-color: var(--gt-prio-med-dot) !important; }\n.gt-column .gt-task-card.is-prio-low:hover    { border-left-color: var(--gt-prio-low-dot) !important; }\n.gt-column .gt-task-card.is-done:hover        { border-left-color: var(--gt-primary) !important; }\n\n/* Completed state — subtle forest tint */\n.gt-task-card.is-done {\n  background: var(--gt-primary-container) !important;\n  border: 1px solid var(--gt-accent-soft) !important;\n  border-left: 3px solid var(--gt-primary) !important;\n  box-shadow: var(--gt-elev-1) !important;\n}\n.gt-task-card.is-done:hover {\n  border-color: var(--gt-primary-soft) !important;\n  box-shadow: var(--gt-elev-2) !important;\n}\n.gt-task-card.is-done .gt-prio-bar {\n  background: var(--gt-primary) !important;\n}\n\n/* Completed badge — solid forest pill */\n.gt-completed-badge {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: var(--gt-primary);\n  color: #ffffff;\n  font-family: var(--gt-font-display);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  box-shadow: var(--gt-glow-soft);\n  z-index: 2;\n  isolation: isolate;\n}\n.gt-completed-badge::after { content: none; }\n\n/* ── Buttons — dark forest primary ── */\n.gt-btn {\n  display: inline-flex; align-items: center; gap: 8px;\n  padding: 10px 18px;\n  border-radius: var(--gt-radius-pill);\n  border: 1px solid transparent;\n  font-family: var(--gt-font-display);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background var(--gt-t-fast),\n    color var(--gt-t-fast),\n    border-color var(--gt-t-fast),\n    transform var(--gt-t-fast),\n    box-shadow var(--gt-t-fast);\n  user-select: none;\n}\n.gt-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.gt-btn:active:not(:disabled) { transform: translateY(0.5px); }\n\n.gt-btn.is-primary {\n  background: var(--gt-primary);\n  color: #ffffff;\n  border-color: transparent;\n  box-shadow: var(--gt-glow-soft);\n  position: relative;\n  overflow: hidden;\n}\n.gt-btn.is-primary::before { content: none; }\n.gt-btn.is-primary > * { position: relative; z-index: 1; }\n.gt-btn.is-primary:hover:not(:disabled) {\n  background: var(--gt-primary-hover);\n  transform: none;\n  box-shadow: var(--gt-glow);\n}\n.gt-btn.is-accent {\n  background: var(--gt-primary);\n  color: #ffffff;\n  border-color: transparent;\n  box-shadow: var(--gt-glow-soft);\n}\n.gt-btn.is-accent:hover:not(:disabled) {\n  background: var(--gt-primary-hover);\n  transform: none;\n  box-shadow: var(--gt-glow);\n}\n.gt-btn.is-soft {\n  background: var(--gt-primary-container);\n  color: var(--gt-primary-deep);\n  border-color: transparent;\n}\n.gt-btn.is-soft:hover:not(:disabled) {\n  background: var(--gt-primary-container-hover);\n  transform: none;\n}\n.gt-btn.is-ghost {\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  color: var(--gt-text-secondary);\n  border-color: var(--gt-border);\n  box-shadow: none;\n}\n.gt-btn.is-ghost:hover:not(:disabled) {\n  background: var(--gt-surface-1);\n  color: var(--gt-text-primary);\n  border-color: var(--gt-border-strong);\n  transform: none;\n}\n.gt-btn.is-danger {\n  background: #ffffff;\n  color: #a83c34;\n  border-color: var(--gt-prio-urgent-dot);\n}\n.gt-btn.is-danger:hover:not(:disabled) { background: var(--gt-prio-urgent-bg); border-color: #c4574c; }\n.gt-btn.is-info {\n  background: var(--gt-prio-low-bg);\n  color: var(--gt-prio-low-fg);\n  border-color: transparent;\n}\n.gt-btn.is-info:hover:not(:disabled) { background: #d8e1ed; }\n\n.gt-btn.is-sm { padding: 7px 13px; font-size: 12px; gap: 6px; }\n.gt-btn.is-lg { padding: 13px 22px; font-size: 14px; }\n\n/* ProjectsPage action row — \"+ New Project\" + Trash square.\n   On phones the primary pill stretches to fill the available width and the\n   trash button is a fully-rounded \"stadium\" shape next to it so the pair\n   reads as a single pill-style cluster (matches the reference design).\n   On desktop both buttons keep their natural width. */\n@media (max-width: 767px) {\n  .gt-project-actions {\n    width: 100%;\n  }\n  .gt-project-new-btn {\n    flex: 1 1 0;\n    min-width: 0;\n    padding: 13px 18px;\n    /* 999px = fully rounded ends (pill / stadium shape). */\n    border-radius: 999px;\n    font-size: 14px;\n    letter-spacing: 0.01em;\n  }\n  .gt-project-trash-btn {\n    /* Slightly wider than tall so the rounded sides match the primary\n       pill's curvature rather than reading as a perfect circle. */\n    width: 64px;\n    height: 48px;\n    padding: 0;\n    border-radius: 999px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-width: 1.5px;\n  }\n  .gt-project-trash-btn svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.gt-btn-kbd {\n  display: inline-flex; align-items: center;\n  font-family: var(--gt-font-mono);\n  font-size: 10px;\n  padding: 1px 5px;\n  border-radius: 4px;\n  border: 1px solid color-mix(in srgb, currentColor 28%, transparent);\n  margin-left: 4px;\n  opacity: 0.85;\n}\n\n/* Pure icon button */\n.gt-icon-btn {\n  width: 36px; height: 36px;\n  display: inline-flex; align-items: center; justify-content: center;\n  border-radius: 12px;\n  background: transparent;\n  border: 1px solid transparent;\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast), border-color var(--gt-t-fast);\n}\n.gt-icon-btn:hover { background: var(--gt-surface-2); color: var(--gt-primary); border-color: var(--gt-border); }\n.gt-icon-btn.is-sm { width: 30px; height: 30px; border-radius: 10px; }\n\n/* ── Inputs — pill-shaped clean white with soft border ── */\n.gt-input,\n.gt-select,\n.gt-textarea {\n  width: 100%;\n  padding: 11px 16px;\n  border-radius: var(--gt-radius-input);\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  font-family: var(--gt-font);\n  font-size: 13.5px;\n  color: var(--gt-text-primary);\n  outline: none;\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);\n  box-shadow: none;\n}\n.gt-input::placeholder, .gt-textarea::placeholder { color: var(--gt-text-tertiary); }\n.gt-input:focus, .gt-select:focus, .gt-textarea:focus {\n  border-color: var(--gt-primary);\n  background: var(--gt-surface-0);\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);\n}\n.gt-input.is-search {\n  padding-left: 40px;\n  background: var(--gt-surface-2);\n  border-color: var(--gt-border);\n  border-radius: 9999px;\n  box-shadow: none;\n}\n.gt-input.is-search:focus {\n  background: var(--gt-surface-0);\n  border-color: var(--gt-primary);\n}\n\n.gt-field-label {\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  display: block;\n  margin-bottom: 6px;\n}\n\n/* Search input wrapper */\n.gt-search-wrap {\n  position: relative;\n  display: flex; align-items: center;\n}\n.gt-search-wrap > svg {\n  position: absolute;\n  left: 14px;\n  width: 16px; height: 16px;\n  color: var(--gt-text-tertiary);\n  pointer-events: none;\n}\n\n/* Quick-add composer */\n.gt-composer {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-sheet);\n  box-shadow: var(--gt-elev-1);\n  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);\n  position: relative;\n  overflow: visible;\n}\n.gt-composer:focus-within {\n  border-color: var(--gt-primary);\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08), var(--gt-elev-2);\n}\n\n.gt-quickadd-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n.gt-quickadd-control {\n  width: 132px;\n  flex: 0 0 132px;\n  min-width: 0;\n}\n\n.gt-quickadd-chip,\n.gt-quickadd-submit {\n  justify-content: center;\n}\n\n.gt-quickadd-chip {\n  padding-left: 11px;\n  padding-right: 11px;\n}\n\n.gt-quickadd-submit {\n  min-width: 112px;\n  padding-left: 16px;\n  padding-right: 14px;\n}\n\n.gt-quickadd-select {\n  height: 38px;\n  padding-left: 11px;\n  padding-right: 10px;\n  font-size: 13px;\n}\n\n@media (max-width: 640px) {\n  .gt-quickadd-control,\n  .gt-quickadd-submit {\n    flex: 1 1 calc(50% - 4px);\n    width: auto;\n  }\n}\n\n/* ── Pills — soft tinted badges ── */\n.gt-pill {\n  display: inline-flex; align-items: center; gap: 5px;\n  padding: 4px 11px;\n  border-radius: var(--gt-radius-pill);\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.2;\n  white-space: nowrap;\n  border: 1px solid transparent;\n}\n.gt-pill .gt-dot {\n  width: 6px; height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.gt-pill.is-urgent {\n  background: var(--gt-prio-urgent-bg);\n  color: var(--gt-prio-urgent-fg);\n  border-color: rgba(220, 38, 38, 0.25);\n  font-weight: 700;\n}\n.gt-pill.is-urgent .gt-dot { background: var(--gt-prio-urgent-dot); }\n\n.gt-pill.is-high {\n  background: var(--gt-prio-high-bg);\n  color: var(--gt-prio-high-fg);\n  border-color: rgba(234, 88, 12, 0.25);\n  font-weight: 700;\n}\n.gt-pill.is-high .gt-dot { background: var(--gt-prio-high-dot); }\n\n.gt-pill.is-medium {\n  background: var(--gt-prio-med-bg);\n  color: var(--gt-prio-med-fg);\n  border-color: rgba(217, 119, 6, 0.25);\n  font-weight: 700;\n}\n.gt-pill.is-medium .gt-dot { background: var(--gt-prio-med-dot); }\n\n.gt-pill.is-low {\n  background: var(--gt-prio-low-bg);\n  color: var(--gt-prio-low-fg);\n  border-color: rgba(37, 99, 235, 0.25);\n  font-weight: 700;\n}\n.gt-pill.is-low .gt-dot { background: var(--gt-prio-low-dot); }\n\n.gt-pill.is-pending  { background: var(--gt-status-pending-bg);  color: var(--gt-status-pending-fg); }\n.gt-pill.is-progress { background: var(--gt-status-progress-bg); color: var(--gt-status-progress-fg); }\n.gt-pill.is-done     { background: var(--gt-status-done-bg);     color: var(--gt-status-done-fg); }\n.gt-pill.is-overdue  { background: var(--gt-status-overdue-bg);  color: var(--gt-status-overdue-fg); }\n.gt-pill.is-ghost    { background: var(--gt-surface-2);          color: var(--gt-text-secondary); }\n.gt-pill.is-personal { background: var(--gt-primary-container);  color: var(--gt-primary-deep); }\n.gt-pill.is-assigned { background: var(--gt-prio-low-bg);        color: var(--gt-prio-low-fg); }\n\n/* ── Filter dropdown shell — clean white panel ── */\n.gt-dropdown {\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-modal);\n  box-shadow: var(--gt-elev-3);\n  overflow: hidden;\n}\n.gt-dropdown-item {\n  display: flex; align-items: center; gap: 12px;\n  padding: 11px 14px;\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-family: var(--gt-font-display);\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--gt-text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background 160ms ease;\n}\n.gt-dropdown-item:hover { background: var(--gt-surface-1); color: var(--gt-primary); }\n.gt-dropdown-item:active { background: var(--gt-primary-container); }\n.gt-dropdown-divider {\n  height: 1px;\n  margin: 0 12px;\n  background: var(--gt-divider);\n}\n\n/* Segmented control — minimal */\n.gt-segmented {\n  display: flex;\n  padding: 3px;\n  background: var(--gt-surface-2);\n  border-radius: 12px;\n  position: relative;\n  border: 1px solid var(--gt-divider);\n}\n.gt-segmented-pill {\n  flex: 1;\n  padding: 8px 14px;\n  border-radius: 9px;\n  border: none;\n  background: transparent;\n  font-family: var(--gt-font-display);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gt-text-tertiary);\n  cursor: pointer;\n  transition: all var(--gt-t-mid);\n}\n.gt-segmented-pill.is-active {\n  background: var(--gt-primary);\n  color: #ffffff;\n  box-shadow: var(--gt-glow-soft);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   CALENDAR — minimal cream / forest heatmap\n   ────────────────────────────────────────────────────────────────────── */\n.gt-cal-day {\n  width: 36px; height: 36px;\n  display: flex; align-items: center; justify-content: center;\n  border-radius: 10px;\n  font-size: 13px;\n  color: var(--gt-text-secondary);\n  font-family: var(--gt-font-display);\n  font-weight: 600;\n  position: relative;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background: var(--gt-heat-0);\n  transition:\n    background var(--gt-t-mid),\n    color var(--gt-t-mid),\n    transform var(--gt-t-mid),\n    box-shadow var(--gt-t-mid),\n    border-color var(--gt-t-mid);\n}\n.gt-cal-day:hover  { transform: scale(1.06); box-shadow: var(--gt-elev-2); border-color: var(--gt-primary); }\n.gt-cal-day:active { transform: scale(0.96); }\n\n/* Heatmap fills */\n.gt-cal-day[data-heat=\"0\"] { background: var(--gt-heat-0); color: var(--gt-text-tertiary); }\n.gt-cal-day[data-heat=\"1\"] { background: var(--gt-heat-1); color: var(--gt-primary-deep); }\n.gt-cal-day[data-heat=\"2\"] { background: var(--gt-heat-2); color: var(--gt-primary-deep); }\n.gt-cal-day[data-heat=\"3\"] { background: var(--gt-heat-3); color: #ffffff; }\n.gt-cal-day[data-heat=\"4\"] { background: var(--gt-heat-4); color: #ffffff; }\n.gt-cal-day[data-heat=\"5\"] { background: var(--gt-heat-5); color: #ffffff; }\n\n/* State-driven cells */\n.gt-cal-day[data-state=\"absent\"]  { background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg); }\n.gt-cal-day[data-state=\"leave\"]   { background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg); }\n.gt-cal-day[data-state=\"holiday\"] { background: var(--gt-prio-low-bg); color: var(--gt-prio-low-fg); }\n\n.gt-cal-day.is-today {\n  outline: 2px solid var(--gt-primary);\n  outline-offset: 1px;\n  font-weight: 800;\n}\n.gt-cal-day.is-selected {\n  background: var(--gt-primary) !important;\n  color: #ffffff !important;\n  font-weight: 800;\n  box-shadow: var(--gt-glow-soft);\n  outline: none;\n}\n.gt-cal-day.is-other { opacity: 0.4; }\n.gt-cal-day.has-event::after {\n  content: '';\n  position: absolute;\n  bottom: 4px; left: 50%;\n  transform: translateX(-50%);\n  width: 4px; height: 4px;\n  border-radius: 50%;\n  background: var(--gt-primary);\n}\n.gt-cal-day.is-selected.has-event::after { background: #ffffff; }\n\n.gt-cal-weekday {\n  width: 36px;\n  text-align: center;\n  font-family: var(--gt-font-display);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  padding-bottom: 8px;\n}\n\n/* Calendar popover panel */\n.gt-cal-panel {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-modal);\n  box-shadow: var(--gt-elev-4);\n  width: 320px;\n  overflow: hidden;\n  animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  transform-origin: top left;\n}\n.gt-cal-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--gt-divider);\n  background: var(--gt-surface-1);\n}\n.gt-cal-month {\n  font-family: var(--gt-font-display);\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: var(--gt-text-primary);\n}\n.gt-cal-month em {\n  font-family: var(--gt-font-display);\n  font-style: normal;\n  font-weight: 800;\n  color: var(--gt-primary);\n  margin-left: 4px;\n}\n\n/* Calendar legend */\n.gt-cal-legend {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 8px;\n}\n.gt-cal-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--gt-text-tertiary);\n}\n.gt-cal-legend-item .dot {\n  width: 9px; height: 9px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n/* ── Animations ─── */\n@keyframes gt-pop {\n  0%   { opacity: 0; transform: translateY(-6px) scale(0.96); }\n  60%  { opacity: 1; }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes gt-fade-up {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: none; }\n}\n.gt-fade-in { animation: gt-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both; }\n.gt-pop-in  { animation: gt-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both; }\n\n/* Forest scrollbar */\n.gt-scroll::-webkit-scrollbar,\n.gt-shell *::-webkit-scrollbar,\n.gt-themed *::-webkit-scrollbar { width: 10px; height: 10px; }\n.gt-scroll::-webkit-scrollbar-track,\n.gt-shell *::-webkit-scrollbar-track,\n.gt-themed *::-webkit-scrollbar-track { background: transparent; }\n.gt-scroll::-webkit-scrollbar-thumb,\n.gt-shell *::-webkit-scrollbar-thumb,\n.gt-themed *::-webkit-scrollbar-thumb {\n  background: var(--gt-border-strong);\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n.gt-scroll::-webkit-scrollbar-thumb:hover,\n.gt-shell *::-webkit-scrollbar-thumb:hover,\n.gt-themed *::-webkit-scrollbar-thumb:hover {\n  background: var(--gt-primary);\n  background-clip: padding-box;\n}\n.gt-scroll, .gt-shell, .gt-themed { scrollbar-color: var(--gt-border-strong) transparent; scrollbar-width: thin; }\n\n/* ── Header / hero ── */\n.gt-page-hero {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  padding-bottom: 18px;\n  position: relative;\n}\n/* On phone the hero stacks vertically (Tailwind `flex-col` toggles\n   flex-direction). With column direction, `align-items: flex-end` would\n   push every child to the right edge of the screen — left-align the\n   stacked layout so the title + stats start at the page padding. */\n@media (max-width: 767px) {\n  .gt-page-hero {\n    align-items: stretch;\n    text-align: left;\n  }\n}\n.gt-eyebrow-row {\n  display: inline-flex; align-items: center; gap: 8px;\n  margin-bottom: 8px;\n}\n\n/* Status / progress mini bar */\n.gt-progress-track {\n  height: 6px;\n  width: 100%;\n  background: var(--gt-surface-2);\n  border-radius: 999px;\n  overflow: hidden;\n}\n.gt-progress-fill {\n  height: 100%;\n  background: var(--gt-primary);\n  border-radius: 999px;\n  transition: width var(--gt-t-slow);\n  box-shadow: none;\n}\n\n/* Stat tile — clean cream card */\n.gt-stat {\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  padding: 18px 20px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--gt-elev-1);\n  transition: border-color var(--gt-t-mid), transform var(--gt-t-mid), box-shadow var(--gt-t-mid);\n}\n.gt-stat::before { content: none; }\n.gt-stat:hover {\n  border-color: var(--gt-border-strong);\n  box-shadow: var(--gt-elev-2);\n}\n.gt-stat > * { position: relative; z-index: 1; }\n.gt-stat-label {\n  font-family: var(--gt-font-display);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  display: flex; align-items: center; gap: 8px;\n}\n.gt-stat-label > :first-child:not(span) {\n  color: var(--gt-primary);\n}\n.gt-stat-value {\n  font-family: var(--gt-font-display);\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--gt-text-primary);\n  line-height: 1.05;\n  margin-top: 6px;\n  font-feature-settings: 'tnum' 1, 'lnum' 1;\n}\n.gt-stat-foot {\n  font-size: 11px;\n  color: var(--gt-text-tertiary);\n  margin-top: 6px;\n  font-family: var(--gt-font);\n}\n\n/* Avatar plate — solid forest */\n.gt-avatar {\n  width: 36px; height: 36px;\n  border-radius: 50%;\n  background: var(--gt-primary);\n  color: #ffffff;\n  display: inline-flex; align-items: center; justify-content: center;\n  font-family: var(--gt-font-display);\n  font-weight: 700;\n  font-size: 12px;\n  flex-shrink: 0;\n  position: relative;\n  box-shadow: var(--gt-glow-soft);\n  isolation: isolate;\n}\n.gt-avatar::after { content: none; }\n\n/* Modal shell — clean white over soft scrim */\n.gt-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 20, 18, 0.32);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 100;\n  animation: gt-fade-up 220ms ease-out both;\n}\n.gt-modal {\n  background: var(--gt-surface-0);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border-radius: var(--gt-radius-sheet);\n  box-shadow: var(--gt-elev-5);\n  border: 1px solid var(--gt-border);\n  overflow: hidden;\n  animation: gt-pop 280ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  transform-origin: center;\n}\n\n/* Empty state */\n.gt-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--gt-text-tertiary);\n  font-family: var(--gt-font);\n}\n.gt-empty .gt-empty-leaf {\n  display: inline-flex;\n  width: 64px; height: 64px;\n  border-radius: 50%;\n  background: var(--gt-primary-container);\n  color: var(--gt-primary);\n  align-items: center; justify-content: center;\n  margin-bottom: 16px;\n  box-shadow: none;\n}\n.gt-empty .gt-empty-title {\n  font-family: var(--gt-font-display);\n  font-weight: 700;\n  font-size: 15px;\n  color: var(--gt-text-primary);\n  margin-bottom: 4px;\n}\n\n/* Loading dots */\n.gt-loading-ring {\n  width: 32px; height: 32px;\n  border: 3px solid var(--gt-primary-container);\n  border-top-color: var(--gt-primary);\n  border-radius: 50%;\n  animation: gt-spin 700ms linear infinite;\n}\n@keyframes gt-spin { to { transform: rotate(360deg); } }\n\n/* Keyboard hint */\n.gt-kbd {\n  font-family: var(--gt-font-mono);\n  font-size: 10px;\n  padding: 1px 5px;\n  border: 1px solid var(--gt-border-strong);\n  border-radius: 4px;\n  color: var(--gt-text-tertiary);\n  background: var(--gt-surface-0);\n}\n\n/* ── Donut + ring helpers ── */\n.gt-ring-track { stroke: var(--gt-surface-2); }\n.gt-ring-fill  { stroke: var(--gt-primary); }\n\n/* ── Dark theme ── */\n[data-task-theme=\"dark\"] .gt-shell {\n  background: var(--gt-surface-1);\n}\n[data-task-theme=\"dark\"] .gt-shell::before { content: none; }\n[data-task-theme=\"dark\"] .gt-dropdown {\n  background: var(--gt-surface-0);\n  border-color: var(--gt-border);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   AUTO-OVERRIDES for legacy pages (gt-themed wrapper)\n   Maps Tailwind purple/indigo/blue patterns → forest palette.\n   ────────────────────────────────────────────────────────────────────── */\n.gt-themed {\n  font-family: var(--gt-font);\n  color: var(--gt-text-primary);\n}\n\n.gt-themed h1,\n.gt-themed h2,\n.gt-themed h3,\n.gt-themed h4 {\n  font-family: var(--gt-font-display);\n  letter-spacing: -0.01em;\n  color: var(--gt-text-primary);\n}\n\n/* Gradient backgrounds → flat dark forest */\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-purple-700\"],\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-blue-700\"],\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-blue-600\"],\n.gt-themed [class*=\"from-indigo-600\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-violet-500\"][class*=\"to-purple-600\"],\n.gt-themed [class*=\"from-purple-500\"][class*=\"to-pink-500\"],\n.gt-themed [class*=\"from-purple-600\"][class*=\"to-purple-700\"],\n.gt-themed [class*=\"from-emerald-600\"][class*=\"to-teal-600\"],\n.gt-themed [class*=\"from-emerald-500\"][class*=\"to-teal-500\"] {\n  background: var(--gt-primary) !important;\n  color: #ffffff !important;\n  background-image: none !important;\n  box-shadow: var(--gt-glow-soft) !important;\n}\n.gt-themed [class*=\"from-blue-500\"][class*=\"to-purple-600\"]:hover,\n.gt-themed [class*=\"from-blue-600\"][class*=\"to-purple-700\"]:hover,\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-purple-600\"]:hover,\n.gt-themed [class*=\"from-indigo-500\"][class*=\"to-blue-600\"]:hover,\n.gt-themed [class*=\"from-emerald-600\"][class*=\"to-teal-600\"]:hover {\n  background: var(--gt-primary-hover) !important;\n  background-image: none !important;\n}\n\n/* Text-gradient titles → solid forest */\n.gt-themed [class*=\"bg-clip-text\"][class*=\"text-transparent\"] {\n  background: none !important;\n  -webkit-background-clip: initial !important;\n  background-clip: initial !important;\n  -webkit-text-fill-color: var(--gt-primary) !important;\n  color: var(--gt-primary) !important;\n  font-family: var(--gt-font-display);\n  letter-spacing: -0.03em;\n}\n\n/* Banner gradient backgrounds → soft cream */\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-indigo-50\"],\n.gt-themed [class*=\"from-blue-50\"][class*=\"to-purple-50\"],\n.gt-themed [class*=\"from-indigo-50\"][class*=\"to-purple-50\"],\n.gt-themed [class*=\"from-purple-50\"][class*=\"to-pink-50\"],\n.gt-themed [class*=\"from-violet-50\"][class*=\"to-pink-50\"],\n.gt-themed [class*=\"from-slate-50\"][class*=\"to-blue-50\"],\n.gt-themed [class*=\"from-slate-50\"][class*=\"via-blue-50\"] {\n  background: var(--gt-surface-1) !important;\n  background-image: none !important;\n}\n\n/* Plain blue/indigo/purple/violet accents → forest */\n.gt-themed .text-blue-500,\n.gt-themed .text-blue-600,\n.gt-themed .text-blue-700,\n.gt-themed .text-indigo-500,\n.gt-themed .text-indigo-600,\n.gt-themed .text-indigo-700,\n.gt-themed .text-purple-500,\n.gt-themed .text-purple-600,\n.gt-themed .text-purple-700,\n.gt-themed .text-violet-500,\n.gt-themed .text-violet-600 { color: var(--gt-primary) !important; }\n\n.gt-themed .bg-blue-50, .gt-themed .bg-indigo-50, .gt-themed .bg-purple-50, .gt-themed .bg-violet-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-blue-100, .gt-themed .bg-indigo-100, .gt-themed .bg-purple-100, .gt-themed .bg-violet-100 { background-color: var(--gt-primary-container) !important; color: var(--gt-primary-deep) !important; }\n.gt-themed .bg-blue-500, .gt-themed .bg-blue-600, .gt-themed .bg-indigo-500, .gt-themed .bg-indigo-600, .gt-themed .bg-purple-500, .gt-themed .bg-purple-600, .gt-themed .bg-violet-500, .gt-themed .bg-violet-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }\n.gt-themed .bg-blue-700, .gt-themed .bg-indigo-700, .gt-themed .bg-purple-700, .gt-themed .bg-violet-700 { background-color: var(--gt-primary-hover) !important; }\n\n.gt-themed .border-blue-200, .gt-themed .border-indigo-200, .gt-themed .border-purple-200 { border-color: var(--gt-border) !important; }\n.gt-themed .border-blue-500, .gt-themed .border-indigo-500, .gt-themed .border-purple-500,\n.gt-themed .border-blue-600, .gt-themed .border-indigo-600, .gt-themed .border-purple-600 { border-color: var(--gt-primary) !important; }\n.gt-themed .border-l-4.border-blue-500 { border-color: var(--gt-primary) !important; }\n\n.gt-themed .focus\\:ring-blue-500:focus, .gt-themed .focus\\:ring-indigo-500:focus, .gt-themed .focus\\:ring-purple-500:focus, .gt-themed .focus\\:ring-blue-400:focus { --tw-ring-color: var(--gt-primary) !important; box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.10) !important; }\n.gt-themed .focus\\:border-blue-500:focus, .gt-themed .focus\\:border-indigo-500:focus { border-color: var(--gt-primary) !important; }\n\n.gt-themed .hover\\:bg-blue-50:hover, .gt-themed .hover\\:bg-indigo-50:hover, .gt-themed .hover\\:bg-purple-50:hover { background-color: var(--gt-surface-1) !important; }\n.gt-themed .hover\\:bg-blue-100:hover, .gt-themed .hover\\:bg-indigo-100:hover, .gt-themed .hover\\:bg-purple-100:hover { background-color: var(--gt-primary-container) !important; }\n.gt-themed .hover\\:text-blue-600:hover, .gt-themed .hover\\:text-indigo-600:hover, .gt-themed .hover\\:text-purple-600:hover { color: var(--gt-primary) !important; }\n\n/* Default page background gradients → flat cream */\n.gt-themed [class*=\"from-gray-50\"][class*=\"to-gray-100\"],\n.gt-themed [class*=\"from-gray-50\"][class*=\"to-white\"][class*=\"to-gray-50\"],\n.gt-themed [class*=\"bg-gradient-to-br\"][class*=\"from-background\"][class*=\"to-muted\"] {\n  background: var(--gt-surface-1) !important;\n  background-image: none !important;\n}\n\n/* Card surfaces */\n.gt-themed .bg-white { background-color: var(--gt-surface-0) !important; }\n.gt-themed .bg-gray-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-gray-100 { background-color: var(--gt-surface-2) !important; }\n.gt-themed .border-gray-100 { border-color: var(--gt-divider) !important; }\n.gt-themed .border-gray-200 { border-color: var(--gt-border) !important; }\n.gt-themed .border-gray-300 { border-color: var(--gt-border-strong) !important; }\n\n.gt-themed .text-gray-400 { color: var(--gt-text-disabled) !important; }\n.gt-themed .text-gray-500 { color: var(--gt-text-tertiary) !important; }\n.gt-themed .text-gray-600 { color: var(--gt-text-secondary) !important; }\n.gt-themed .text-gray-700 { color: var(--gt-text-secondary) !important; }\n.gt-themed .text-gray-800,\n.gt-themed .text-gray-900 { color: var(--gt-text-primary) !important; }\n\n/* Backdrop / modal */\n.gt-themed .fixed.inset-0[class*=\"bg-black\"] { background: rgba(20, 20, 18, 0.32) !important; backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }\n\n/* Inputs auto-style — pill-shaped rounded inputs */\n.gt-themed input[type=\"text\"]:not(.gt-input):not([class*=\"gt-\"]),\n.gt-themed input[type=\"email\"]:not(.gt-input),\n.gt-themed input[type=\"number\"]:not(.gt-input),\n.gt-themed input[type=\"search\"]:not(.gt-input),\n.gt-themed input[type=\"tel\"]:not(.gt-input),\n.gt-themed input[type=\"url\"]:not(.gt-input),\n.gt-themed input[type=\"date\"]:not(.gt-input),\n.gt-themed input[type=\"time\"]:not(.gt-input),\n.gt-themed input[type=\"datetime-local\"]:not(.gt-input),\n.gt-themed textarea:not(.gt-textarea),\n.gt-themed select:not(.gt-select) {\n  background: var(--gt-surface-0);\n  border-color: var(--gt-border);\n  color: var(--gt-text-primary);\n  font-family: var(--gt-font);\n  border-radius: var(--gt-radius-input);\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast), box-shadow var(--gt-t-fast);\n}\n.gt-themed input[type=\"text\"]:not(.gt-input):focus,\n.gt-themed input[type=\"email\"]:not(.gt-input):focus,\n.gt-themed input[type=\"number\"]:not(.gt-input):focus,\n.gt-themed input[type=\"search\"]:not(.gt-input):focus,\n.gt-themed input[type=\"tel\"]:not(.gt-input):focus,\n.gt-themed input[type=\"date\"]:not(.gt-input):focus,\n.gt-themed input[type=\"time\"]:not(.gt-input):focus,\n.gt-themed input[type=\"datetime-local\"]:not(.gt-input):focus,\n.gt-themed textarea:not(.gt-textarea):focus,\n.gt-themed select:not(.gt-select):focus {\n  border-color: var(--gt-primary) !important;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(15, 45, 31, 0.08);\n}\n\n/* Status / accent token rewrites — forest-first */\n.gt-themed .bg-emerald-500, .gt-themed .bg-green-500, .gt-themed .bg-emerald-600, .gt-themed .bg-green-600, .gt-themed .bg-teal-500, .gt-themed .bg-teal-600 { background-color: var(--gt-primary) !important; color: #ffffff !important; }\n.gt-themed .text-emerald-500, .gt-themed .text-emerald-600, .gt-themed .text-green-500, .gt-themed .text-green-600, .gt-themed .text-teal-500, .gt-themed .text-teal-600 { color: var(--gt-primary) !important; }\n.gt-themed .bg-emerald-50, .gt-themed .bg-green-50, .gt-themed .bg-teal-50 { background-color: var(--gt-surface-1) !important; }\n.gt-themed .bg-emerald-100, .gt-themed .bg-green-100, .gt-themed .bg-teal-100 { background-color: var(--gt-primary-container) !important; }\n.gt-themed .text-emerald-700, .gt-themed .text-green-700, .gt-themed .text-emerald-800, .gt-themed .text-teal-700 { color: var(--gt-primary-deep) !important; }\n\n/* Progress / chart strokes */\n.gt-themed .bg-green-500.h-2,\n.gt-themed .bg-green-500.h-1,\n.gt-themed .bg-emerald-500.h-2,\n.gt-themed .bg-emerald-500.h-1 {\n  background: var(--gt-primary) !important;\n  background-image: none !important;\n}\n\n/* Animation tweaks */\n.gt-themed .animate-pulse { animation-duration: 2.4s; }\n\n/* ──────────────────────────────────────────────────────────────────────\n   GLOBAL GLASS SUPPRESSION — kills any leftover backdrop-filter blur\n   inside the task module so the cream theme stays crisp.\n   ────────────────────────────────────────────────────────────────────── */\n.gt-shell *,\n.gt-themed * {\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n.gt-shell .gt-modal-backdrop,\n.gt-themed .gt-modal-backdrop {\n  backdrop-filter: blur(4px) !important;\n  -webkit-backdrop-filter: blur(4px) !important;\n}\n\n/* ============================================================ */\n/* Chat component classes (.gc-*)                               */\n/* Merged from src/pages/Chat/theme/tokens.css                  */\n/* ============================================================ */\n/* ──────────────────────────────────────────────────────────────────────────\n   Chat Design Tokens — \"Forest Sage\" theme (2026)\n   Inspired by editorial calm + organic warmth. Forest green primary,\n   sage tint surfaces, restrained accents, and a paper-like neutral base.\n   Import in Chat.tsx: import './theme/tokens.css';\n   All chat surfaces should reference these variables — no raw hex inline.\n   ────────────────────────────────────────────────────────────────────── */\n\n/* Distinctive type system — three voices in one chorus:\n   ▸ Plus Jakarta Sans — display + UI labels, geometric warmth\n   ▸ Fraunces — editorial serif (italics for date dividers, pull-quotes)\n   ▸ Inter — body text, optimized at small sizes\n   ▸ JetBrains Mono — code spans, message IDs, technical grit\n*/\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400;1,9..144,500;1,9..144,600&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap');\n\n/* ── High-quality emoji rendering ────────────────────────────────────────\n   Use .gc-emoji on any element rendering raw emoji characters so glyphs\n   resolve to a vector colour set with the same look across every OS.\n   Inheritance + fallback chain protects readability if the webfont fails. */\n.gc-emoji,\n.gc-emoji * {\n  font-family: 'Noto Color Emoji', 'Apple Color Emoji', 'Segoe UI Emoji',\n               'Segoe UI Symbol', 'Twemoji Mozilla', 'EmojiOne Color',\n               'Android Emoji', sans-serif;\n  font-variant-emoji: emoji;\n  font-feature-settings: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n/* Chat-side tokens are defined at the top of this file (one DESIGN TOKENS\n   block holds everything). Layout / component rules continue below. */\n\n/* ──────────────────────────────────────────────────────────\n   Chat-scoped utility classes\n   ────────────────────────────────────────────────────────── */\n.gc-surface-0   { background: var(--gc-surface-0); }\n.gc-surface-1   { background: var(--gc-surface-1); }\n.gc-surface-2   { background: var(--gc-surface-2); }\n.gc-text-primary   { color: var(--gc-text-primary); }\n.gc-text-secondary { color: var(--gc-text-secondary); }\n.gc-text-tertiary  { color: var(--gc-text-tertiary); }\n.gc-border         { border-color: var(--gc-border); }\n.gc-divider        { border-color: var(--gc-divider); }\n.gc-primary        { color: var(--gc-primary); }\n.gc-mention      { background: var(--gc-mention-bg); color: var(--gc-mention-text); border-radius: 4px; padding: 0 4px; font-weight: 600; }\n.gc-self-mention { background: var(--gc-self-mention-bg); color: var(--gc-self-mention-text); border-radius: 4px; padding: 0 4px; font-weight: 600; }\n\n/* Display heading utility */\n.gc-display {\n  font-family: var(--gc-font-display);\n  letter-spacing: var(--gc-letter-display);\n  font-weight: 700;\n}\n.gc-eyebrow {\n  font-family: var(--gc-font-display);\n  letter-spacing: var(--gc-letter-eyebrow);\n  text-transform: uppercase;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n/* Sage-tinted scrollbar — subtle, organic */\n.gc-scroll::-webkit-scrollbar { width: 10px; height: 10px; }\n.gc-scroll::-webkit-scrollbar-track { background: transparent; }\n.gc-scroll::-webkit-scrollbar-thumb {\n  background: var(--gc-border-strong);\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n.gc-scroll::-webkit-scrollbar-thumb:hover { background: var(--gc-text-tertiary); background-clip: padding-box; border: 2px solid transparent; }\n\n/* Chat shell — plain white backdrop (sage gradient + grain removed). */\n.gc-shell {\n  position: relative;\n  background: #ffffff;\n}\n.gc-shell::before { content: none; }\n.gc-shell > * { position: relative; z-index: 1; }\n\n/* Tiny editorial flourishes ─────────────────────────────────────── */\n\n/* Italic serif accent — used inline for emphasis & flourishes */\n.gc-serif-italic {\n  font-family: var(--gc-font-serif);\n  font-style: italic;\n  font-feature-settings: 'ss01', 'ss03';\n}\n\n/* Hand-drawn-feel hairline rule, tapered at both ends */\n.gc-rule {\n  height: 1px;\n  background: linear-gradient(\n    to right,\n    transparent,\n    var(--gc-border-strong) 25%,\n    var(--gc-border-strong) 75%,\n    transparent\n  );\n}\n\n/* Decorative leaf glyph used as a chapter mark in section headers */\n.gc-leaf {\n  display: inline-block;\n  width: 8px; height: 8px;\n  background: var(--gc-accent);\n  border-radius: 100% 0 100% 0;\n  transform: rotate(-15deg);\n  flex-shrink: 0;\n}\n\n/* Numeric oldstyle figures for time stamps & counts */\n.gc-numerals {\n  font-feature-settings: 'tnum' 1, 'lnum' 1;\n}\n\n/* Conversation row — refined active state with leading bar */\n.gc-conv-row {\n  position: relative;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  outline: 0;\n  box-shadow: none;\n  transition:\n    background-color var(--gc-transition-fast),\n    transform var(--gc-transition-fast);\n}\n.gc-conv-row:hover { background: var(--gc-surface-hover); }\n.gc-conv-row.is-active {\n  background: var(--gc-primary-container);\n}\n.gc-conv-row.is-active::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 10px; bottom: 10px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--gc-primary);\n}\n.gc-conv-row__body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  overflow: hidden;\n}\n.gc-conv-row__title-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n.gc-conv-row__identity {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.gc-conv-row__title-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex: 0 1 auto;\n  line-height: 1.2;\n}\n.gc-conv-row__title-text > .truncate {\n  min-width: 0;\n}\n.gc-conv-row__title-presence-dot {\n  flex: 0 0 auto;\n  width: 12px;\n  height: 12px;\n  border-width: 2px;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px rgba(16, 185, 129, 0.22);\n  /* PERF: no idle animation. Every online row used to run four infinite\n     keyframe animations; with a dozen online peers that forced a style\n     recalc + paint + composite on EVERY frame (60/s) for as long as the\n     app was open — even hidden in the tray. Presence is shown statically. */\n}\n.gc-conv-row__title-presence-dot.is-away {\n  background: #facc15;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px rgba(250, 204, 21, 0.38);\n}\n.gc-conv-row__title-presence-dot.is-dnd {\n  background: var(--gc-dnd);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px color-mix(in srgb, var(--gc-dnd) 42%, transparent);\n}\n.gc-conv-row__title-presence-dot.is-leave {\n  background: #f97316;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px rgba(249, 115, 22, 0.42);\n}\n.gc-conv-row__title-presence-dot.is-offline {\n  opacity: 0.78;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.10);\n}\n.gc-conv-row__unread {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: 7px;\n  line-height: 1;\n  flex: 0 0 auto;\n}\n.gc-conv-row__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  min-width: max-content;\n  white-space: nowrap;\n}\n.gc-conv-row__time {\n  flex: 0 0 auto;\n  line-height: 1;\n}\n.gc-conv-row__kebab {\n  flex: 0 0 18px;\n}\n.gc-conv-row__body .gc-row-last {\n  min-width: 0;\n}\n\n/* Sent message bubble — softer dark-teal forest, refined corner */\n.gc-bubble-mine {\n  background: var(--gc-bubble-mine-bg);\n  color: var(--gc-bubble-mine-text);\n  border-radius: var(--gc-radius-bubble) var(--gc-radius-bubble) 4px var(--gc-radius-bubble);\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.08);\n}\n.gc-bubble-mine:hover { background: var(--gc-bubble-mine-bg-hover); }\n.gc-bubble-mine .chat-rich-render,\n.gc-bubble-mine .chat-rich-render .ProseMirror,\n.gc-bubble-mine .chat-rich-render .ProseMirror p,\n.gc-bubble-mine .chat-rich-render .ProseMirror li,\n.gc-bubble-mine .chat-rich-render .ProseMirror span,\n.gc-bubble-mine .chat-rich-render .ProseMirror strong,\n.gc-bubble-mine .chat-rich-render .ProseMirror em {\n  color: var(--gc-bubble-mine-text);\n}\n.gc-bubble-mine .chat-rich-render .ProseMirror a,\n.gc-bubble-mine .chat-rich-render .ProseMirror a *,\n.gc-bubble-mine .chat-rich-render .ProseMirror a span {\n  color: #ffffff !important;\n  text-decoration: underline !important;\n  text-decoration-color: #ffffff !important;\n  text-underline-offset: 2px;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n}\n.gc-bubble-mine .chat-rich-render .ProseMirror a:hover,\n.gc-bubble-mine .chat-rich-render .ProseMirror a:hover * {\n  opacity: 0.85;\n}\n.gc-bubble-mine .chat-rich-render .ProseMirror code,\n.gc-bubble-mine .chat-rich-render .ProseMirror pre {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--gc-bubble-mine-text);\n}\n.gc-bubble-theirs {\n  background: var(--gc-surface-2);\n  color: var(--gc-text-primary);\n  border-radius: var(--gc-radius-bubble) var(--gc-radius-bubble) var(--gc-radius-bubble) 4px;\n  border: 1px solid var(--gc-border);\n}\n\n/* ── Quoted reply snippet (in-bubble + composer pill) ───────────\n   Theme-aware inset card fronted by a gradient \"quote stripe\" on\n   the leading edge. The stripe is the shared signature of a reply —\n   it reappears on the composer ReplyPill so the two read as one\n   system. Adapts to the dark sent bubble (black wash + bright mint\n   stripe) vs the light received bubble (faint wash + deep emerald). */\n.gc-quoted {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin: 0 0 8px;\n  padding: 6px 12px 6px 14px;\n  border: 0;\n  border-radius: 5px 9px 9px 5px;\n  background: rgba(15, 23, 18, 0.045);\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  cursor: default;\n  transition: background 180ms ease, transform 120ms ease;\n  -webkit-appearance: none;\n  appearance: none;\n  overflow: hidden;\n}\n/* The quote stripe — gradient emerald → mint; widens & brightens on hover */\n.gc-quoted::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: linear-gradient(180deg, var(--gc-accent-strong), #34d399);\n  transition: width 160ms ease, filter 160ms ease;\n}\n.gc-quoted[data-clickable=\"true\"] { cursor: pointer; }\n.gc-quoted[data-clickable=\"true\"]:hover {\n  background: rgba(15, 23, 18, 0.08);\n}\n.gc-quoted[data-clickable=\"true\"]:hover::before {\n  width: 4px;\n  filter: brightness(1.12) saturate(1.1);\n}\n.gc-quoted[data-clickable=\"true\"]:active { transform: scale(0.99); }\n\n.gc-quoted__sender {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.75px;\n  font-weight: 600;\n  line-height: 1.3;\n  letter-spacing: -0.005em;\n  color: var(--gc-accent-strong);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-quoted__sender svg { flex-shrink: 0; }\n\n.gc-quoted__text {\n  display: block;\n  font-size: 12.5px;\n  line-height: 1.35;\n  color: var(--gc-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 1px;\n}\n.gc-quoted__text--deleted {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n/* Image-quote layout: text column on the left, thumbnail pinned right */\n.gc-quoted--media {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.gc-quoted__main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n.gc-quoted__thumb {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 6px;\n  object-fit: cover;\n  background: rgba(15, 23, 18, 0.06);\n}\n\n/* Dark sent-bubble context: black wash + bright mint stripe */\n.gc-bubble-mine .gc-quoted {\n  background: rgba(0, 0, 0, 0.13);\n}\n.gc-bubble-mine .gc-quoted::before {\n  background: linear-gradient(180deg, #6ee7b7, #34d399);\n}\n.gc-bubble-mine .gc-quoted[data-clickable=\"true\"]:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n.gc-bubble-mine .gc-quoted__sender { color: #a7f3d0; }\n.gc-bubble-mine .gc-quoted__text { color: rgba(244, 250, 246, 0.8); }\n.gc-bubble-mine .gc-quoted__thumb { background: rgba(255, 255, 255, 0.12); }\n\n/* Loading skeleton: shimmer until original resolves */\n.gc-quoted--loading {\n  min-height: 30px;\n}\n.gc-quoted--loading::before { opacity: 0.65; }\n.gc-bubble-mine .gc-quoted--loading::before {\n  background: rgba(110, 231, 183, 0.5);\n}\n.gc-quoted--loading::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.04) 40%,\n    rgba(255, 255, 255, 0.10) 50%,\n    rgba(255, 255, 255, 0.04) 60%,\n    transparent 100%\n  );\n  /* Finite: a reply whose original is outside the loaded window (or was\n     purged) never resolves, so an infinite shimmer would animate forever in\n     the always-visible message list. Six passes read as \"loading\", then the\n     placeholder rests. */\n  animation: gc-quoted-shimmer 1.6s ease-in-out 6;\n}\n@keyframes gc-quoted-shimmer {\n  0%   { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n/* Composer-pill variant — appears above the input, not inside a bubble */\n.gc-quoted--composer {\n  background: rgba(16, 185, 129, 0.08);\n}\n.gc-quoted--composer::before {\n  background: linear-gradient(180deg, var(--gc-accent-strong), #34d399);\n}\n.gc-quoted--composer:hover {\n  background: rgba(16, 185, 129, 0.12);\n}\n\n/* ── Composer pills (reply + edit banners) ──────────────────────\n   The bar that slides in above the input when you reply to or edit\n   a message. Echoes the gradient quote-stripe from .gc-quoted so the\n   composer previews how the message relates to the thread. Driven by\n   a single --pill-accent variable: reply = emerald (default), edit =\n   amber. Fully token-driven → adapts to light / dark / high-contrast. */\n.gc-compose-pill {\n  --pill-accent: var(--gc-accent-strong);\n  --pill-accent-2: #34d399;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  padding: 9px 12px 9px 15px;\n  border-top: 1px solid var(--gc-border);\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--pill-accent) 10%, transparent),\n    color-mix(in srgb, var(--pill-accent) 3%, transparent) 55%,\n    transparent\n  );\n  animation: gc-compose-pill-in 240ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n.gc-compose-pill__bar {\n  position: absolute;\n  left: 0;\n  top: 7px;\n  bottom: 7px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: linear-gradient(180deg, var(--pill-accent), var(--pill-accent-2));\n}\n.gc-compose-pill__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 27px;\n  height: 27px;\n  border-radius: 9px;\n  color: var(--pill-accent);\n  background: color-mix(in srgb, var(--pill-accent) 14%, transparent);\n}\n.gc-compose-pill__body {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.gc-compose-pill__label {\n  font-size: 11.5px;\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: 0.01em;\n  color: var(--gc-text-secondary);\n}\n.gc-compose-pill__label strong {\n  font-weight: 700;\n  color: var(--pill-accent);\n}\n.gc-compose-pill__text {\n  display: block;\n  max-width: 100%;\n  font-size: 12.5px;\n  line-height: 1.3;\n  color: var(--gc-text-tertiary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-compose-pill__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--gc-text-tertiary);\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease,\n    transform 220ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n.gc-compose-pill__close:hover {\n  background: color-mix(in srgb, var(--pill-accent) 13%, transparent);\n  color: var(--pill-accent);\n  transform: rotate(90deg);\n}\n.gc-compose-pill__close:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--gc-surface-0), 0 0 0 4px var(--pill-accent);\n}\n@keyframes gc-compose-pill-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Edit banner — amber accent (distinct from the emerald reply banner).\n   Amber isn't a theme token, so the accent is set per colour scheme. */\n.gc-edit-pill { --pill-accent: #b45309; --pill-accent-2: #f59e0b; }\n[data-theme=\"dark\"] .gc-edit-pill { --pill-accent: #fbbf24; --pill-accent-2: #f59e0b; }\n[data-theme=\"hc\"] .gc-edit-pill { --pill-accent: #fcd34d; --pill-accent-2: #fbbf24; }\n\n/* Composer — pill input with subtle inner glow */\n.gc-composer {\n  background: var(--gc-surface-2);\n  border: 1px solid var(--gc-border);\n  border-radius: 18px;\n  transition: border-color var(--gc-transition-fast), background var(--gc-transition-fast), box-shadow var(--gc-transition-fast);\n}\n.gc-composer:focus-within {\n  background: var(--gc-surface-0);\n  border-color: var(--gc-primary);\n  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);\n}\n\n/* Sidebar header / search */\n.gc-sidebar-search {\n  background: var(--gc-surface-2);\n  border: 1px solid transparent;\n  border-radius: 12px;\n  transition: background var(--gc-transition-fast), border-color var(--gc-transition-fast);\n}\n.gc-sidebar-search:focus-within {\n  background: var(--gc-surface-0);\n  border-color: var(--gc-primary);\n  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.07);\n}\n\n/* Tiny pulse for status dots\n   PERF: box-shadow ripple triggered repaint on every online dot every frame\n   (very expensive on Electron when many users are online). Switched to an\n   opacity pulse on the dot itself — GPU-composited, no paint cost. */\n.gc-online-dot {\n  background: var(--gc-online);\n}\n\n/* Subtle entrance for the whole shell on first paint */\n@keyframes gc-fade-up {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: none; }\n}\n.gc-fade-in { animation: gc-fade-up 380ms cubic-bezier(0.33, 1, 0.68, 1) both; }\n\n/* ──────────────────────────────────────────────────────────\n   Right panel (Files + Schedule)\n   ────────────────────────────────────────────────────────── */\n.gc-rpanel-card {\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-divider);\n  border-radius: 16px;\n  transition: border-color var(--gc-transition-fast), box-shadow var(--gc-transition-fast);\n}\n.gc-rpanel-card:hover { border-color: var(--gc-border-strong); }\n\n/* Calendar — iOS-inspired, minimal, premium */\n.gc-modal-compact .gc-cal-day {\n  width: 30px; height: 30px;\n  border-radius: 10px;\n  font-size: 12px;\n}\n.gc-modal-compact .gc-cal-weekday {\n  font-size: 10px;\n  letter-spacing: 0.05em;\n}\n.gc-cal-day {\n  width: 34px; height: 34px;\n  display: flex; align-items: center; justify-content: center;\n  border-radius: 12px;\n  font-size: 13px;\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font-display);\n  font-weight: 500;\n  position: relative;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  transition:\n    background 220ms cubic-bezier(0.33, 1, 0.68, 1),\n    color 220ms cubic-bezier(0.33, 1, 0.68, 1),\n    transform 220ms cubic-bezier(0.33, 1, 0.68, 1),\n    box-shadow 220ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-cal-day:hover {\n  background: var(--gc-surface-2);\n  transform: scale(1.04);\n}\n.gc-cal-day:active { transform: scale(0.96); }\n.gc-cal-day.is-today {\n  color: var(--gc-primary);\n  font-weight: 700;\n}\n.gc-cal-day.is-today:not(.is-selected) {\n  background: var(--gc-primary-container);\n}\n.gc-cal-day.is-selected {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(31, 46, 35, 0.18);\n}\n.gc-cal-day.is-other { color: var(--gc-text-disabled); opacity: 0.5; }\n.gc-cal-day.has-event::after {\n  content: '';\n  position: absolute;\n  bottom: 5px; left: 50%;\n  transform: translateX(-50%);\n  width: 4px; height: 4px;\n  border-radius: 50%;\n  background: var(--gc-accent);\n}\n.gc-cal-day.is-selected.has-event::after { background: var(--gc-on-primary); }\n\n.gc-cal-weekday {\n  width: 34px;\n  text-align: center;\n  font-family: var(--gc-font-display);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n  padding-bottom: 6px;\n}\n\n/* ──────────────────────────────────────────────────────────\n   iOS-style dropdown menu (Meeting picker, etc.)\n   ────────────────────────────────────────────────────────── */\n@keyframes gc-menu-pop {\n  0%   { opacity: 0; transform: translateY(-6px) scale(0.96); }\n  60%  { opacity: 1; }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes gc-menu-pop-out {\n  from { opacity: 1; transform: translateY(0) scale(1); }\n  to   { opacity: 0; transform: translateY(-6px) scale(0.96); }\n}\n.gc-ios-menu {\n  /* PERF: Removed `backdrop-filter: blur(20px) saturate(180%)` — Electron's\n     compositor can't GPU-accelerate it, causing big lag whenever this menu\n     opens. Solid bg is a near-identical look at a fraction of the cost. */\n  background: #ffffff;\n  border: 1px solid rgba(15, 29, 20, 0.08);\n  border-radius: 16px;\n  box-shadow:\n    0 12px 32px rgba(15, 29, 20, 0.14),\n    0 4px 8px rgba(15, 29, 20, 0.06),\n    0 0 0 0.5px rgba(15, 29, 20, 0.04);\n  overflow: hidden;\n  transform-origin: top right;\n  animation: gc-menu-pop 220ms cubic-bezier(0.33, 1, 0.68, 1) both;\n}\n.gc-ios-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 14px;\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-family: var(--gc-font-display);\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background 160ms ease;\n}\n.gc-ios-menu-item:hover { background: var(--gc-surface-2); }\n.gc-ios-menu-item:active { background: var(--gc-primary-container); }\n.gc-ios-menu-item .gc-ios-menu-glyph {\n  width: 30px; height: 30px;\n  border-radius: 9px;\n  display: flex; align-items: center; justify-content: center;\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  flex-shrink: 0;\n}\n.gc-ios-menu-item .gc-ios-menu-glyph.is-accent {\n  background: var(--gc-accent-soft);\n  color: var(--gc-accent-strong);\n}\n.gc-ios-menu-divider {\n  height: 1px;\n  margin: 0 12px;\n  background: var(--gc-divider);\n}\n\n/* iOS-style segmented control reused for calendar filter pills */\n.gc-segmented {\n  display: flex;\n  padding: 3px;\n  background: var(--gc-surface-2);\n  border-radius: 11px;\n  position: relative;\n}\n.gc-segmented-pill {\n  flex: 1;\n  padding: 7px 10px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  font-family: var(--gc-font-display);\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  color: var(--gc-text-tertiary);\n  cursor: pointer;\n  transition: all 220ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-segmented-pill.is-active {\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  box-shadow: 0 1px 3px rgba(15, 29, 20, 0.10), 0 0 0 0.5px rgba(15, 29, 20, 0.04);\n}\n\n/* Three-dot bubble menu — same pop animation but origin-aware */\n@keyframes gc-bubble-menu-pop {\n  0%   { opacity: 0; transform: translateY(4px) scale(0.94); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n.gc-bubble-menu {\n  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;\n}\n.gc-bubble-menu.origin-right { transform-origin: bottom right; }\n.gc-bubble-menu.origin-left  { transform-origin: bottom left; }\n\n/* File-icon plate */\n.gc-file-icon {\n  width: 36px; height: 36px;\n  border-radius: 10px;\n  display: flex; align-items: center; justify-content: center;\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Presence + Leave Status — 2026-05-03 (priority: on_leave > dnd/away > online > offline)\n   ────────────────────────────────────────────────────────────────────────── */\n/* Presence status pill tokens (--gc-status-*-{bg,fg,dot}) live in the\n   DESIGN TOKENS block at the top of this file. */\n\n/* Pill — used in Employees rows + ChatHeader DM line */\n.gc-presence-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px 3px 8px;\n  border-radius: 999px;\n  font-family: var(--gc-font-display);\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.2;\n  white-space: nowrap;\n  transition: background-color 300ms cubic-bezier(0.33, 1, 0.68, 1),\n              color 300ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-presence-pill.is-online  { background: var(--gc-status-online-bg);  color: var(--gc-status-online-fg); }\n.gc-presence-pill.is-away    { background: var(--gc-status-away-bg);    color: var(--gc-status-away-fg); }\n.gc-presence-pill.is-dnd     { background: color-mix(in srgb, var(--gc-dnd) 14%, var(--gc-surface-0)); color: var(--gc-dnd); }\n.gc-presence-pill.is-offline { background: var(--gc-status-offline-bg); color: var(--gc-status-offline-fg); }\n.gc-presence-pill.is-leave   { background: var(--gc-status-leave-bg);   color: var(--gc-status-leave-fg); }\n\n/* Dot — small variant for avatar overlays + roster rows */\n.gc-presence-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 2px solid var(--gc-surface-0, #fff);\n  transition: background-color 300ms cubic-bezier(0.33, 1, 0.68, 1);\n  position: relative;\n}\n.gc-presence-dot.is-online  { background: var(--gc-status-online-dot); }\n.gc-presence-dot.is-away    { background: var(--gc-status-away-dot); }\n.gc-presence-dot.is-dnd     { background: var(--gc-dnd); }\n.gc-presence-dot.is-offline { background: var(--gc-status-offline-dot); }\n.gc-presence-dot.is-leave   { background: var(--gc-status-leave-dot); }\n.gc-presence-dot.is-sm { width: 8px; height: 8px; border-width: 1.5px; }\n.gc-presence-dot.is-lg { width: 12px; height: 12px; border-width: 2.5px; }\n.gc-presence-dot--icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  line-height: 0;\n}\n.gc-presence-dot--icon .gc-presence-icon-glyph {\n  display: block;\n  transition: transform 260ms cubic-bezier(0.33, 1, 0.68, 1),\n              opacity 260ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-presence-dot--icon.is-online,\n.gc-presence-dot--icon.is-away,\n.gc-presence-dot--icon.is-dnd,\n.gc-presence-dot--icon.is-offline,\n.gc-presence-dot--icon.is-leave {\n  color: currentColor;\n}\n.gc-presence-dot--icon.is-online { color: var(--gc-status-online-dot); }\n.gc-presence-dot--icon.is-away { color: var(--gc-status-away-dot); }\n.gc-presence-dot--icon.is-dnd { color: var(--gc-dnd); }\n.gc-presence-dot--icon.is-offline { color: var(--gc-status-offline-dot); }\n.gc-presence-dot--icon.is-leave { color: var(--gc-status-leave-dot); }\n.gc-presence-dot--icon.is-online::after,\n.gc-presence-dot--icon:not(.is-online)::after {\n  content: none;\n}\n\n/* Conversation title dots intentionally override the shared presence palette:\n   Away and Leave must read differently in the dense chat list. */\n.gc-conv-row__title-presence-dot.is-away {\n  background: #facc15;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px rgba(250, 204, 21, 0.38);\n}\n.gc-conv-row__title-presence-dot.is-leave {\n  background: #f97316;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.12),\n    0 0 12px rgba(249, 115, 22, 0.42);\n}\n\n/* Static halo ring — only on truly online (not on_leave). Was an infinite\n   pulse; see the PERF note on .gc-conv-row__title-presence-dot. */\n.gc-presence-dot.is-online::after {\n  content: '';\n  position: absolute;\n  inset: -3px;\n  border-radius: 50%;\n  border: 2px solid var(--gc-status-online-dot);\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n/* Avatar overlay positioning helper */\n.gc-presence-overlay {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  z-index: 2;\n  pointer-events: none;\n}\n\n/* Compact DM avatar presence strip */\n.gc-avatar-presence-frame {\n  width: 40px;\n  height: 40px;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  isolation: isolate;\n}\n.gc-avatar-presence-frame .gc-avatar,\n.gc-avatar-presence-frame .gc-avatar__inner,\n.gc-avatar-presence-frame .gc-avatar__img {\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n}\n.gc-avatar-presence-strip {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  height: 18px;\n  padding: 0 2px 3px;\n  pointer-events: none;\n  overflow: hidden;\n  color: #ffffff;\n  font-family: var(--gc-font-display);\n  font-size: 8px;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1;\n  text-align: center;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  box-shadow:\n    0 -1px 0 rgba(255, 255, 255, 0.10) inset,\n    0 -6px 14px rgba(0, 0, 0, 0.18);\n}\n.gc-avatar-presence-strip__text {\n  position: relative;\n  z-index: 1;\n  display: block;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-avatar-presence-strip::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.26) 48%, transparent 100%);\n  transform: translateX(-120%);\n}\n.gc-avatar-presence-strip.is-online {\n  background: linear-gradient(180deg, rgba(13, 148, 136, 0) 0%, rgba(13, 148, 136, 0.70) 36%, rgba(4, 120, 87, 0.96) 100%);\n}\n.gc-avatar-presence-strip.is-away {\n  background: linear-gradient(180deg, rgba(234, 179, 8, 0) 0%, rgba(202, 138, 4, 0.72) 36%, rgba(133, 77, 14, 0.96) 100%);\n}\n.gc-avatar-presence-strip.is-dnd {\n  background: linear-gradient(180deg, rgba(220, 38, 38, 0) 0%, rgba(220, 38, 38, 0.74) 36%, rgba(127, 29, 29, 0.97) 100%);\n}\n.gc-avatar-presence-strip.is-offline {\n  background: linear-gradient(180deg, rgba(100, 116, 139, 0) 0%, rgba(71, 85, 105, 0.76) 36%, rgba(30, 41, 59, 0.97) 100%);\n}\n.gc-avatar-presence-strip.is-leave {\n  background: linear-gradient(180deg, rgba(249, 115, 22, 0) 0%, rgba(194, 65, 12, 0.74) 36%, rgba(124, 45, 18, 0.97) 100%);\n}\n.gc-conv-row:hover .gc-avatar-presence-strip {\n  filter: saturate(1.1);\n}\n@media (prefers-reduced-motion: reduce) {\n  .gc-avatar-presence-strip,\n  .gc-avatar-presence-strip::after {\n    animation: none;\n    transition: none;\n  }\n}\n\n/* On-leave system message pill (centered chip rendered by SystemMessagePill) */\n.gc-system-leave-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-family: var(--gc-font-display);\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.3;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);\n  max-width: min(640px, 90%);\n  text-align: center;\n}\n.gc-system-leave-pill.is-start {\n  background: var(--gc-status-leave-bg);\n  color: var(--gc-status-leave-fg);\n  border-color: color-mix(in srgb, var(--gc-status-leave-fg) 28%, transparent);\n}\n.gc-system-leave-pill.is-end {\n  background: var(--gc-status-online-bg);\n  color: var(--gc-status-online-fg);\n  border-color: color-mix(in srgb, var(--gc-status-online-fg) 28%, transparent);\n}\n.gc-system-row--away {\n  margin: 12px 0;\n  padding: 1px 20px;\n}\n.gc-system-away-pill {\n  gap: 8px;\n  padding: 5px 14px;\n  min-height: 30px;\n  max-width: min(560px, calc(100% - 48px));\n  background: #facc15;\n  color: #1f1a05;\n  border-color: color-mix(in srgb, #facc15 72%, #7c4a03);\n  box-shadow:\n    0 8px 20px rgba(250, 204, 21, 0.14),\n    0 1px 0 rgba(255, 255, 255, 0.26) inset;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n.gc-system-away-pill.is-start,\n.gc-system-away-pill.is-end {\n  background: #facc15;\n  color: #1f1a05;\n}\n.gc-system-away-pill.is-dnd {\n  background: #dc2626;\n  color: #ffffff;\n  border-color: color-mix(in srgb, #dc2626 70%, #7f1d1d);\n  box-shadow:\n    0 8px 20px rgba(220, 38, 38, 0.18),\n    0 1px 0 rgba(255, 255, 255, 0.22) inset;\n}\n.gc-away-remind-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 4px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, currentColor 30%, transparent);\n  background: color-mix(in srgb, currentColor 9%, transparent);\n  color: inherit;\n  font: inherit;\n  font-size: 11px;\n  line-height: 1.1;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.gc-away-remind-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, currentColor 16%, transparent);\n}\n.gc-away-remind-btn:disabled {\n  cursor: default;\n  opacity: 0.72;\n}\n.gc-pinned-status-notice {\n  width: fit-content;\n  max-width: calc(100% - 24px);\n  justify-content: center;\n  box-sizing: border-box;\n}\n.gc-pinned-status-notice__content {\n  flex: 0 1 auto;\n  min-width: 0;\n  text-align: center;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Conversation-row status tag — refined editorial chip\n   Used in the chat sidebar, top-right of every DM row.\n   Three variants: is-online (emerald pulse), is-leave (amber breath +\n   leaf glyph), is-offline (quiet slate, no motion).\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-status-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2.5px 8px 2.5px 6px;\n  border-radius: 999px;\n  font-family: var(--gc-font-display);\n  font-size: 8.5px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  line-height: 1;\n  white-space: nowrap;\n  border: 1px solid transparent;\n  position: relative;\n  isolation: isolate;\n  transition:\n    transform 280ms cubic-bezier(0.33, 1, 0.68, 1),\n    box-shadow 280ms cubic-bezier(0.33, 1, 0.68, 1),\n    filter 280ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n\n.gc-status-tag-glyph {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 8px;\n  height: 8px;\n  flex-shrink: 0;\n  position: relative;\n}\n.gc-status-tag-glyph svg { display: block; }\n\n/* — Online — emerald gradient + soft halo + double-pulse ring — */\n.gc-status-tag.is-online {\n  background:\n    linear-gradient(135deg, #ecfdf5 0%, #d1fae5 60%, #a7f3d0 100%);\n  color: #064e3b;\n  border-color: rgba(16, 185, 129, 0.35);\n  box-shadow:\n    0 0 0 1px rgba(16, 185, 129, 0.06) inset,\n    0 1px 2px rgba(6, 78, 59, 0.08),\n    0 0 8px rgba(16, 185, 129, 0.18);\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);\n}\n.gc-status-tag.is-online .gc-status-tag-glyph {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, #34d399 0%, #10b981 60%, #059669 100%);\n  box-shadow:\n    0 0 0 1.5px rgba(16, 185, 129, 0.22),\n    0 0 6px rgba(16, 185, 129, 0.55);\n}\n.gc-status-tag.is-online .gc-status-tag-glyph::before,\n.gc-status-tag.is-online .gc-status-tag-glyph::after {\n  content: '';\n  position: absolute;\n  inset: -2px;\n  border-radius: 50%;\n  border: 1px solid #10b981;\n  pointer-events: none;\n}\n.gc-status-tag.is-online .gc-status-tag-glyph::before {\n  opacity: 0.45;\n}\n.gc-status-tag.is-online .gc-status-tag-glyph::after {\n  display: none;\n}\n\n/* — On Leave — amber gradient + breathing leaf glyph — */\n.gc-status-tag.is-leave {\n  background:\n    linear-gradient(135deg, #fffbeb 0%, #fef3c7 60%, #fde68a 100%);\n  color: #78350f;\n  border-color: rgba(217, 119, 6, 0.4);\n  box-shadow:\n    0 0 0 1px rgba(217, 119, 6, 0.06) inset,\n    0 1px 2px rgba(120, 53, 15, 0.10),\n    0 0 8px rgba(245, 158, 11, 0.22);\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);\n}\n.gc-status-tag.is-leave .gc-status-tag-glyph {\n  color: #b45309;\n  width: 9px;\n  height: 9px;\n  filter: drop-shadow(0 0 2px rgba(245, 158, 11, 0.45));\n}\n\n/* — Away — soft yellow, gentle breathing dot (idle but still connected) — */\n.gc-status-tag.is-away {\n  background:\n    linear-gradient(135deg, #fefce8 0%, #fef9c3 60%, #fef08a 100%);\n  color: #713f12;\n  border-color: rgba(234, 179, 8, 0.38);\n  box-shadow:\n    0 0 0 1px rgba(234, 179, 8, 0.05) inset,\n    0 1px 2px rgba(113, 63, 18, 0.08),\n    0 0 8px rgba(234, 179, 8, 0.18);\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);\n}\n.gc-status-tag.is-away .gc-status-tag-glyph {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, #facc15 0%, #eab308 60%, #ca8a04 100%);\n  box-shadow:\n    0 0 0 1.5px rgba(234, 179, 8, 0.22),\n    0 0 6px rgba(234, 179, 8, 0.40);\n}\n\n/* — Offline — whisper-quiet — */\n.gc-status-tag.is-offline {\n  background: var(--gc-surface-1);\n  color: #64748b;\n  border-color: var(--gc-divider);\n  opacity: 0.78;\n  box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.04) inset;\n}\n.gc-status-tag.is-offline .gc-status-tag-glyph {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  box-shadow: inset 0 0 0 1px #94a3b8;\n}\n\n/* Row-hover lift (parent .gc-conv-row hovered) */\n.gc-conv-row:hover .gc-status-tag.is-online,\n.gc-conv-row:hover .gc-status-tag.is-away,\n.gc-conv-row:hover .gc-status-tag.is-leave {\n  transform: translateY(-0.5px);\n  filter: saturate(1.08);\n}\n.gc-conv-row:hover .gc-status-tag.is-offline {\n  opacity: 0.95;\n}\n\n/* Reduced motion — kill animations but keep visuals intact */\n@media (prefers-reduced-motion: reduce) {\n  .gc-status-tag.is-online .gc-status-tag-glyph::before,\n  .gc-status-tag.is-online .gc-status-tag-glyph::after,\n  .gc-status-tag.is-away .gc-status-tag-glyph,\n  .gc-status-tag.is-leave .gc-status-tag-glyph {\n    animation: none;\n  }\n}\n\n/* Group chat header chip — \"N on leave\" — clickable */\n.gc-group-onleave-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: var(--gc-status-leave-bg);\n  color: var(--gc-status-leave-fg);\n  font-family: var(--gc-font-display);\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: transform 150ms cubic-bezier(0.33, 1, 0.68, 1),\n              filter 150ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-group-onleave-chip:hover { filter: brightness(0.97); transform: translateY(-1px); }\n.gc-group-onleave-chip:active { transform: translateY(0); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Editorial system message divider — replaces the flat italic gray fallback.\n   Used by SystemMessagePill (default branch) and the legacy SystemMessageRow.\n   Composition:\n     [hairline gradient rule] · sparkle · serif-italic copy · sparkle · [rule]\n   The rules fade in from the gutters using a tinted gradient so the row\n   feels like a drop-cap chapter break rather than a generic separator.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-system-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 14px 0;\n  padding: 0 24px;\n  user-select: none;\n  text-align: center;\n}\n.gc-system-row > .gc-system-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  background: var(--gc-status-leave-bg);\n  border: 1px solid color-mix(in srgb, var(--gc-status-leave-fg) 28%, transparent);\n  box-shadow: 0 1px 2px color-mix(in srgb, var(--gc-status-leave-fg) 12%, transparent);\n  max-width: min(640px, 90%);\n}\n.gc-system-flourish {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: color-mix(in srgb, var(--gc-status-leave-fg) 80%, var(--gc-status-leave-bg));\n  flex-shrink: 0;\n}\n.gc-system-text {\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  color: var(--gc-status-leave-fg);\n  text-align: center;\n  padding: 0 2px;\n  line-height: 1.35;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  font-family: var(--gc-font-display);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Deleted message tombstone — refined, with optional deleter attribution.\n   Replaces the previous flat gray italic line. Bubble-aligned, soft-tinted,\n   with a tiny \"trash\" glyph and an italic micro-line for the deleter name.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-deleted-bubble {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px 7px 10px;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--gc-text-tertiary) 6%, var(--gc-surface-0));\n  border: 1px dashed color-mix(in srgb, var(--gc-text-tertiary) 32%, transparent);\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font);\n  font-size: 12.5px;\n  font-style: italic;\n  line-height: 1.35;\n  max-width: min(420px, 78%);\n}\n.gc-deleted-bubble-icon {\n  flex-shrink: 0;\n  color: color-mix(in srgb, var(--gc-dnd) 55%, var(--gc-text-tertiary));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.gc-deleted-bubble-text { display: flex; flex-direction: column; line-height: 1.3; }\n.gc-deleted-bubble-main { color: var(--gc-text-secondary); }\n.gc-deleted-bubble-by {\n  margin-top: 1px;\n  font-style: normal;\n  font-size: 10.5px;\n  color: var(--gc-text-tertiary);\n  letter-spacing: 0.01em;\n}\n.gc-deleted-bubble-by b {\n  font-weight: 600;\n  color: color-mix(in srgb, var(--gc-text-secondary) 88%, var(--gc-primary));\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Header inline action chip — used to surface \"Select messages\" beside the\n   three-dot menu rather than burying it inside a popover.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-header-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 11px 5px 9px;\n  border-radius: 999px;\n  font-family: var(--gc-font-display);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  color: var(--gc-text-secondary);\n  background: var(--gc-surface-2);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 160ms cubic-bezier(0.33,1,0.68,1),\n              color 160ms cubic-bezier(0.33,1,0.68,1),\n              transform 160ms cubic-bezier(0.33,1,0.68,1),\n              border-color 160ms cubic-bezier(0.33,1,0.68,1);\n  white-space: nowrap;\n}\n.gc-header-chip:hover {\n  background: color-mix(in srgb, var(--gc-primary) 8%, var(--gc-surface-2));\n  color: var(--gc-primary);\n  transform: translateY(-1px);\n}\n.gc-header-chip.is-active {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  border-color: color-mix(in srgb, var(--gc-primary) 30%, transparent);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Voice recorder panel — anchored above composer (composer-attached),\n   replacing the prior fullscreen bottom-modal that left huge dead space.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-voice-panel {\n  position: relative;\n  margin: 8px 12px 0;\n  padding: 8px 12px;\n  border-radius: 18px;\n  background: linear-gradient(\n    180deg,\n    color-mix(in srgb, var(--gc-primary) 5%, var(--gc-surface-0)) 0%,\n    var(--gc-surface-0) 100%\n  );\n  border: 1px solid color-mix(in srgb, var(--gc-primary) 22%, var(--gc-border));\n  box-shadow: 0 8px 28px -16px color-mix(in srgb, var(--gc-primary) 40%, transparent);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Section header trailing folio — keeps the calendar's month-nav from\n   colliding with the \"ii. Schedule\" chapter title in the right panel.\n   Adds a small breath gap so chevrons & numerals don't smash into them.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-rpanel-card .gc-cal-header-spacer { height: 6px; }\n\n\n/* ──────────────────────────────────────────────────────────────────────────\n   FINAL FORM-CONTROL & SHADCN POLISH\n   Themes form controls (checkbox, radio, range, date/time pickers) and\n   shadcn Button/Card/Input variants project-wide so every page matches the\n   task management aesthetic.\n   ────────────────────────────────────────────────────────────────────── */\n\n/* Checkbox & radio — themed accent color and minimal visual */\n.gt-themed input[type=\"checkbox\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"radio\"]:not([class*=\"gt-\"]) {\n  accent-color: var(--gt-primary);\n  cursor: pointer;\n}\n\n/* Range slider tone */\n.gt-themed input[type=\"range\"]:not([class*=\"gt-\"]) {\n  accent-color: var(--gt-primary);\n}\n\n/* Native date / time / datetime-local pickers — round corners + theme padding */\n.gt-themed input[type=\"date\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"time\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"datetime-local\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"month\"]:not([class*=\"gt-\"]),\n.gt-themed input[type=\"week\"]:not([class*=\"gt-\"]) {\n  padding: 9px 14px !important;\n  font-family: var(--gt-font-mono) !important;\n  font-feature-settings: 'tnum' 1, 'lnum' 1 !important;\n  letter-spacing: 0.01em !important;\n}\n\n/* shadcn-style Button variants — auto-style by data-variant or class hint */\n.gt-themed button[class*=\"default\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]),\n.gt-themed [data-variant=\"default\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]) {\n  background: var(--gt-primary) !important;\n  color: var(--gt-on-primary) !important;\n  border: 1px solid transparent !important;\n  border-radius: var(--gt-radius-pill) !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 600 !important;\n  padding: 9px 18px !important;\n  transition: background var(--gt-t-fast), transform var(--gt-t-fast), box-shadow var(--gt-t-fast) !important;\n}\n.gt-themed button[class*=\"default\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover,\n.gt-themed [data-variant=\"default\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover {\n  background: var(--gt-primary-hover) !important;\n  box-shadow: var(--gt-glow) !important;\n}\n\n.gt-themed button[class*=\"outline\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):not([class*=\"gc-\"]):not([class*=\"focus:outline-none\"]),\n.gt-themed [data-variant=\"outline\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):not([class*=\"gc-\"]) {\n  background: var(--gt-surface-0) !important;\n  color: var(--gt-text-primary) !important;\n  border: 1px solid var(--gt-border) !important;\n  border-radius: var(--gt-radius-pill) !important;\n  font-family: var(--gt-font-display) !important;\n  font-weight: 600 !important;\n  transition: border-color var(--gt-t-fast), background var(--gt-t-fast) !important;\n}\n.gt-themed button[class*=\"outline\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):not([class*=\"gc-\"]):not([class*=\"focus:outline-none\"]):hover,\n.gt-themed [data-variant=\"outline\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):not([class*=\"gc-\"]):hover {\n  border-color: var(--gt-border-strong) !important;\n  background: var(--gt-surface-1) !important;\n}\n\n.gt-themed button[class*=\"ghost\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]),\n.gt-themed [data-variant=\"ghost\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]) {\n  background: transparent !important;\n  color: var(--gt-text-secondary) !important;\n  border: 1px solid transparent !important;\n  border-radius: var(--gt-radius-pill) !important;\n}\n.gt-themed button[class*=\"ghost\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover,\n.gt-themed [data-variant=\"ghost\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover {\n  background: var(--gt-surface-2) !important;\n  color: var(--gt-text-primary) !important;\n}\n\n.gt-themed button[class*=\"destructive\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]),\n.gt-themed [data-variant=\"destructive\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]) {\n  background: var(--gt-dnd) !important;\n  color: #ffffff !important;\n  border: 1px solid transparent !important;\n  border-radius: var(--gt-radius-pill) !important;\n  font-weight: 600 !important;\n}\n.gt-themed button[class*=\"destructive\"]:not([class*=\"bg-\"]):not([class*=\"gt-\"]):hover {\n  background: #a83c34 !important;\n}\n\n/* shadcn Card pattern — already mapped via .bg-card; ensure padding & radius */\n.gt-themed [class*=\"rounded-lg\"][class*=\"border\"][class*=\"bg-card\"],\n.gt-themed [class*=\"rounded-xl\"][class*=\"border\"][class*=\"bg-card\"],\n.gt-themed [class*=\"rounded-2xl\"][class*=\"border\"][class*=\"bg-card\"] {\n  background: var(--gt-surface-0) !important;\n  border-color: var(--gt-border) !important;\n  box-shadow: var(--gt-elev-1) !important;\n  border-radius: var(--gt-radius-card) !important;\n}\n\n/* shadcn Tab/Trigger — themed underline + colors */\n.gt-themed [role=\"tab\"] {\n  font-family: var(--gt-font-display);\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--gt-text-tertiary);\n  border-radius: 0;\n  border-bottom: 2px solid transparent;\n  padding: 10px 16px;\n  transition: color var(--gt-t-fast), border-color var(--gt-t-fast);\n}\n.gt-themed [role=\"tab\"]:hover { color: var(--gt-text-primary); }\n\n/* shadcn Switch — track + thumb in theme tones */\n.gt-themed [role=\"switch\"][data-state=\"checked\"] {\n  background-color: var(--gt-primary) !important;\n}\n.gt-themed [role=\"switch\"][data-state=\"unchecked\"] {\n  background-color: var(--gt-surface-3) !important;\n}\n\n/* shadcn Avatar fallback */\n.gt-themed [class*=\"rounded-full\"][class*=\"bg-muted\"] {\n  background-color: var(--gt-primary-container) !important;\n  color: var(--gt-primary-deep) !important;\n  font-family: var(--gt-font-display);\n  font-weight: 700;\n}\n\n/* shadcn Separator */\n.gt-themed [role=\"separator\"],\n.gt-themed [data-orientation=\"horizontal\"][class*=\"bg-border\"] {\n  background: var(--gt-divider) !important;\n}\n\n/* Generic page wrappers (min-h-screen / h-screen with light bg) → cream */\n.gt-themed .min-h-screen.bg-white,\n.gt-themed .min-h-screen.bg-gray-50,\n.gt-themed .min-h-screen.bg-gray-100,\n.gt-themed .h-screen.bg-white,\n.gt-themed .h-screen.bg-gray-50 {\n  background: var(--gt-surface-1) !important;\n}\n\n/* Common section divider — dashed border that pages use */\n.gt-themed [class*=\"border-t-2\"][class*=\"border-dashed\"],\n.gt-themed [class*=\"border-b-2\"][class*=\"border-dashed\"] {\n  border-color: var(--gt-border-strong) !important;\n  border-style: dashed !important;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   APP CHROME — Sidebar, Topbar, Page Headers, Stat Tiles, Filter Pills\n   These are the reusable structural components that frame every page.\n   Consuming these classes (rather than raw Tailwind) means a single change\n   in this file restyles the entire application chrome.\n   ──────────────────────────────────────────────────────────────────────── */\n\n/* ── Sidebar ───────────────────────────────────────────────────────────── */\n.gt-sidebar {\n  background: var(--gt-surface-rail-soft);\n  font-family: var(--gt-font);\n  color: var(--gt-text-primary);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 18px;\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04), 0 6px 18px rgba(15, 29, 20, 0.05);\n  transition: width 0.22s ease, background var(--gt-t-mid);\n}\n.gt-sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  border-bottom: 1px solid var(--gt-divider);\n  min-height: 64px;\n  overflow: hidden;\n}\n.gt-sidebar.is-collapsed .gt-sidebar-header {\n  justify-content: center;\n  padding: 26px 12px 10px;\n  overflow: visible;\n}\n.gt-sidebar-brand {\n  font-family: var(--gt-font-display);\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: var(--gt-letter-display);\n  color: var(--gt-text-primary);\n  flex-shrink: 0;\n}\n.gt-sidebar-collapse {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  color: var(--gt-text-tertiary);\n  background: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast), border-color var(--gt-t-fast);\n}\n.gt-sidebar-collapse:hover {\n  background: var(--gt-surface-2);\n  color: var(--gt-text-primary);\n  border-color: var(--gt-border);\n}\n.gt-sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.gt-sidebar-nav::-webkit-scrollbar { width: 6px; }\n.gt-sidebar-nav::-webkit-scrollbar-thumb {\n  background: var(--gt-border-strong);\n  border-radius: 999px;\n}\n\n.gt-sidebar-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-family: var(--gt-font);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gt-text-secondary);\n  background: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast),\n              border-color var(--gt-t-fast), transform var(--gt-t-fast);\n}\n.gt-sidebar-item:hover {\n  background: var(--gt-surface-hover);\n  color: var(--gt-text-primary);\n}\n.gt-sidebar-item.is-active {\n  background: var(--gt-primary-container);\n  color: var(--gt-primary-deep);\n  font-weight: 600;\n}\n.gt-sidebar-item.is-active:hover {\n  background: var(--gt-primary-container-hover);\n}\n.gt-sidebar-item .gt-sidebar-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  color: currentColor;\n  opacity: 0.85;\n}\n.gt-sidebar-item.is-active .gt-sidebar-icon {\n  opacity: 1;\n  color: var(--gt-primary);\n}\n.gt-sidebar-item .gt-sidebar-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  opacity: 1;\n  max-width: 200px;\n  transition: opacity 0.18s ease, max-width 0.18s ease;\n}\n.gt-sidebar-item .gt-sidebar-chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: var(--gt-text-tertiary);\n  opacity: 1;\n  max-width: 20px;\n  overflow: hidden;\n  transition: transform var(--gt-t-fast), opacity 0.18s ease, max-width 0.18s ease;\n}\n.gt-sidebar-item[aria-expanded=\"true\"] .gt-sidebar-chevron {\n  color: var(--gt-text-secondary);\n}\n\n/* Collapsed state — fade labels and chevrons out.\n   Zero the flex gap so group items (which carry an extra hidden chevron\n   child) center on the icon the same way leaf items do — otherwise the\n   gap on either side of the collapsed label pushes the icon off-center. */\n.gt-sidebar.is-collapsed .gt-sidebar-item {\n  justify-content: center;\n  gap: 0;\n}\n.gt-sidebar.is-collapsed .gt-sidebar-label,\n.gt-sidebar.is-collapsed .gt-sidebar-chevron {\n  opacity: 0;\n  max-width: 0;\n  pointer-events: none;\n}\n\n/* Brand text */\n.gt-sidebar-brand {\n  opacity: 1;\n  max-width: 160px;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: opacity 0.18s ease, max-width 0.18s ease;\n}\n.gt-sidebar.is-collapsed .gt-sidebar-brand {\n  opacity: 0;\n  max-width: 0;\n}\n\n/* Sidebar attendance clock — compact rail control above notifications */\n.gt-sidebar-clock-slot {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: 0 8px 8px;\n}\n.gt-sidebar-header .gt-sidebar-clock-slot {\n  padding: 0;\n}\n.gt-sidebar-clock-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 14px;\n  border: 1px solid var(--gt-border);\n  background: var(--gt-surface-1);\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),\n              color var(--gt-t-fast), transform var(--gt-t-fast),\n              box-shadow var(--gt-t-fast);\n}\n.gt-sidebar-clock-btn:hover:not(:disabled):not(.is-disabled) {\n  background: var(--gt-surface-hover);\n  color: var(--gt-text-primary);\n  transform: translateY(-1px);\n}\n.gt-sidebar-clock-btn.is-clock-in {\n  background: linear-gradient(135deg, #ecfdf5 0%, #dff7ec 100%);\n  border-color: rgba(16, 185, 129, 0.36);\n  color: #047857;\n  box-shadow: 0 8px 18px rgba(16, 185, 129, 0.12);\n}\n.gt-sidebar-clock-btn.is-clock-in:hover:not(:disabled):not(.is-disabled) {\n  background: linear-gradient(135deg, #d1fae5 0%, #bbf7d0 100%);\n  border-color: rgba(5, 150, 105, 0.48);\n  color: #065f46;\n  box-shadow: 0 11px 24px rgba(16, 185, 129, 0.22);\n}\n.gt-sidebar-clock-btn.is-clock-out {\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);\n  border-color: rgba(245, 158, 11, 0.42);\n  color: #b45309;\n  box-shadow: 0 8px 18px rgba(245, 158, 11, 0.13);\n}\n.gt-sidebar-clock-btn.is-clock-out:hover:not(:disabled):not(.is-disabled) {\n  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);\n  border-color: rgba(217, 119, 6, 0.54);\n  color: #92400e;\n  box-shadow: 0 11px 24px rgba(245, 158, 11, 0.22);\n}\n/* PERF: static ring instead of a box-shadow keyframe loop (repaint/frame).\n   The hover rule above is more specific, and an animation used to outrank it\n   automatically — so the second selector re-states the ring for the hovered\n   case, or the \"shift running\" cue vanished exactly as the user reached for\n   the button to clock out. */\n.gt-sidebar-clock-btn.is-active,\n.gt-sidebar-clock-btn.is-clock-out.is-active:hover:not(:disabled):not(.is-disabled) {\n  box-shadow:\n    0 8px 18px rgba(245, 158, 11, 0.16),\n    0 0 0 3px rgba(245, 158, 11, 0.14);\n}\n.gt-sidebar-clock-btn.is-done {\n  color: var(--gt-text-tertiary);\n  background: var(--gt-surface-2);\n}\n.gt-sidebar-clock-btn:disabled,\n.gt-sidebar-clock-btn.is-disabled {\n  cursor: default;\n  opacity: 0.72;\n}\n.gt-sidebar-clock-btn__icon {\n  width: 18px;\n  height: 18px;\n}\n.gt-sidebar-clock-btn__icon.is-spinning {\n  animation: gt-spin 0.9s linear infinite;\n}\n.gt-sidebar-clock-btn__dot {\n  position: absolute;\n  right: 7px;\n  top: 7px;\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: #10b981;\n  box-shadow: 0 0 0 2px var(--gt-surface-1);\n}\n.gt-sidebar-clock-tooltip {\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% - 2px);\n  z-index: 40;\n  box-sizing: border-box;\n  width: max-content;\n  max-width: 66px;\n  padding: 5px 7px;\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.94);\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1.05;\n  text-align: center;\n  white-space: normal;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, 2px) scale(0.96);\n  transform-origin: bottom center;\n  transition: opacity var(--gt-t-fast), transform var(--gt-t-fast);\n}\n.gt-sidebar-clock-tooltip::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -4px;\n  width: 8px;\n  height: 8px;\n  background: rgba(15, 23, 42, 0.94);\n  transform: translateX(-50%) rotate(45deg);\n}\n.gt-sidebar-clock-slot:hover .gt-sidebar-clock-tooltip,\n.gt-sidebar-clock-btn:focus-visible + .gt-sidebar-clock-tooltip {\n  opacity: 1;\n  transform: translate(-50%, 0) scale(1);\n}\n.gt-sidebar-clock-confirmation {\n  position: fixed;\n  z-index: 50;\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  box-sizing: border-box;\n  min-height: 44px;\n  max-width: min(248px, calc(100vw - 24px));\n  padding: 9px 12px 10px 10px;\n  border: 1px solid rgba(20, 184, 166, 0.28);\n  border-radius: 12px;\n  background: rgba(240, 253, 250, 0.98);\n  color: #134e4a;\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;\n  overflow: hidden;\n  pointer-events: none;\n  transform: translate(-4px, -50%) scale(0.96);\n  transform-origin: left center;\n  opacity: 0;\n  animation: gt-clock-confirmation-pop 0.32s cubic-bezier(0.2, 0.9, 0.24, 1.18) forwards;\n}\n.gt-sidebar-clock-confirmation.is-out {\n  border-color: rgba(234, 88, 12, 0.28);\n  background: rgba(255, 247, 237, 0.98);\n  color: #7c2d12;\n}\n.gt-sidebar-clock-confirmation::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #0d9488, #14b8a6);\n  transform-origin: left center;\n  animation: gt-clock-confirmation-progress 3.6s linear forwards;\n}\n.gt-sidebar-clock-confirmation.is-out::after {\n  background: linear-gradient(90deg, #ea580c, #f59e0b);\n}\n.gt-sidebar-clock-confirmation__icon {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  color: #0d9488;\n}\n.gt-sidebar-clock-confirmation.is-out .gt-sidebar-clock-confirmation__icon {\n  color: #ea580c;\n}\n.gt-sidebar-clock-confirmation__copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 1.2;\n}\n.gt-sidebar-clock-confirmation__copy strong {\n  font-size: 12.5px;\n  font-weight: 800;\n  color: currentColor;\n  white-space: nowrap;\n}\n.gt-sidebar-clock-confirmation__copy small {\n  font-size: 11px;\n  font-weight: 600;\n  color: currentColor;\n  opacity: 0.74;\n  white-space: nowrap;\n}\n@keyframes gt-spin {\n  to { transform: rotate(360deg); }\n}\n@keyframes gt-clock-confirmation-pop {\n  0% { opacity: 0; transform: translate(-8px, -50%) scale(0.94); }\n  72% { opacity: 1; transform: translate(1px, -50%) scale(1.01); }\n  100% { opacity: 1; transform: translate(0, -50%) scale(1); }\n}\n@keyframes gt-clock-confirmation-progress {\n  to { transform: scaleX(0); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .gt-sidebar-clock-btn,\n  .gt-sidebar-clock-btn.is-active,\n  .gt-sidebar-clock-btn__dot,\n  .gt-sidebar-clock-tooltip,\n  .gt-sidebar-clock-confirmation,\n  .gt-sidebar-clock-confirmation::after {\n    animation: none;\n    transition: none;\n  }\n}\nhtml.os-mac .gt-sidebar-clock-btn {\n  -webkit-app-region: no-drag;\n  app-region: no-drag;\n}\n\n/* Notification bells row */\n.gt-sidebar-bells {\n  display: flex;\n  gap: 4px;\n  padding: 0 8px 8px 8px;\n  justify-content: flex-start;\n  border-bottom: 1px solid var(--gt-divider, rgba(0,0,0,.06));\n  margin-bottom: 8px;\n  transition: justify-content 0s;\n}\n.gt-sidebar-bells.is-collapsed {\n  justify-content: center;\n}\n\n/* Task nav panel — right-edge resize handle. The hit-area is invisible; a small\n   grip pill fades in on hover/drag so it's discoverable without adding chrome. */\n.gt-task-panel__resize::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 3px;\n  height: 34px;\n  border-radius: 999px;\n  background: var(--gt-border-strong);\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n.gt-task-panel__resize:hover::after,\n.gt-task-panel__resize:active::after {\n  opacity: 1;\n}\n\n/* Submenu — animate open/close with max-height */\n.gt-sidebar-submenu-outer {\n  overflow: hidden;\n  transition: max-height 0.25s ease;\n}\n.gt-sidebar-submenu {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin: 4px 0 6px 16px;\n  padding-left: 14px;\n  border-left: 1px solid var(--gt-divider);\n}\n.gt-sidebar-subitem {\n  display: block;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-family: var(--gt-font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gt-text-tertiary);\n  text-decoration: none;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast);\n}\n.gt-sidebar-subitem:hover {\n  background: var(--gt-surface-hover);\n  color: var(--gt-text-primary);\n}\n.gt-sidebar-subitem.is-active {\n  background: var(--gt-primary-container);\n  color: var(--gt-primary-deep);\n  font-weight: 600;\n}\n\n/* .gt-sidebar.is-minimized replaced by .gt-sidebar.is-collapsed above */\n\n.gt-sidebar-tooltip {\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: 10px;\n  padding: 6px 10px;\n  background: var(--gt-primary-deep);\n  color: #ffffff;\n  font-family: var(--gt-font);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity var(--gt-t-fast);\n  z-index: 60;\n  box-shadow: var(--gt-elev-3);\n}\n.gt-sidebar-item-wrap:hover .gt-sidebar-tooltip { opacity: 1; }\n\n.gt-sidebar-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  min-width: 22px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  font-family: var(--gt-font);\n  font-size: 11px;\n  font-weight: 700;\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  line-height: 1;\n}\n\n/* ── Topbar (header) ───────────────────────────────────────────────────── */\n.gt-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 28px;\n  background: var(--gt-surface-rail-soft);\n  border-bottom: 1px solid var(--gt-border);\n  font-family: var(--gt-font);\n  color: var(--gt-text-primary);\n  min-height: 64px;\n  position: relative;\n  z-index: 30;\n}\n.gt-topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n.gt-topbar-action {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast),\n              border-color var(--gt-t-fast);\n}\n.gt-topbar-action:hover {\n  background: var(--gt-surface-2);\n  color: var(--gt-text-primary);\n  border-color: var(--gt-border);\n}\n.gt-topbar-action.is-active {\n  background: var(--gt-primary-container);\n  color: var(--gt-primary-deep);\n  border-color: var(--gt-primary-container-hover);\n}\n.gt-topbar-menu-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  border: 1px solid var(--gt-border);\n  background: var(--gt-surface-0);\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast);\n}\n.gt-topbar-menu-btn:hover {\n  background: var(--gt-surface-2);\n  color: var(--gt-text-primary);\n}\n\n/* ── Page Header ───────────────────────────────────────────────────────── */\n.gt-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 32px 32px 24px;\n  flex-wrap: wrap;\n}\n.gt-page-header-text { flex: 1; min-width: 280px; }\n.gt-page-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.gt-page-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--gt-font);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: var(--gt-letter-eyebrow);\n  color: var(--gt-text-tertiary);\n  margin-bottom: 10px;\n}\n.gt-page-eyebrow::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--gt-primary);\n  display: inline-block;\n}\n.gt-page-heading {\n  font-family: var(--gt-font-display);\n  font-size: clamp(28px, 3.2vw, 40px);\n  font-weight: 700;\n  letter-spacing: var(--gt-letter-display);\n  color: var(--gt-text-primary);\n  line-height: 1.1;\n  margin: 0;\n}\n.gt-page-heading em,\n.gt-page-heading i {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-primary);\n  letter-spacing: 0;\n}\n.gt-page-subheading {\n  font-family: var(--gt-font);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gt-text-tertiary);\n  margin-top: 8px;\n  line-height: 1.5;\n}\n.gt-page-subheading em,\n.gt-page-subheading i {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  color: var(--gt-text-secondary);\n}\n\n/* ── Stat Tile (the \"TOTAL TASKS / OPEN TASKS / OVERDUE\" cards) ───────── */\n.gt-stat-tile {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  padding: 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: var(--gt-elev-1);\n  transition: box-shadow var(--gt-t-fast), transform var(--gt-t-fast),\n              border-color var(--gt-t-fast);\n  font-family: var(--gt-font);\n  position: relative;\n}\n.gt-stat-tile:hover {\n  box-shadow: var(--gt-elev-2);\n  transform: translateY(-1px);\n  border-color: var(--gt-border-strong);\n}\n.gt-stat-tile-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: var(--gt-letter-eyebrow);\n  color: var(--gt-text-tertiary);\n}\n.gt-stat-tile-label-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 7px;\n  background: var(--gt-primary-container);\n  color: var(--gt-primary);\n}\n.gt-stat-tile-value {\n  font-family: var(--gt-font-display);\n  font-size: 38px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: var(--gt-text-primary);\n  line-height: 1;\n}\n.gt-stat-tile-meta {\n  font-size: 12px;\n  color: var(--gt-text-tertiary);\n  font-weight: 500;\n}\n\n/* Stat tile color variants — use the priority/status palette */\n.gt-stat-tile.is-success .gt-stat-tile-label-icon {\n  background: #e8efe9; color: #0f2d1f;\n}\n.gt-stat-tile.is-warning .gt-stat-tile-label-icon {\n  background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg);\n}\n.gt-stat-tile.is-danger .gt-stat-tile-label-icon {\n  background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg);\n}\n.gt-stat-tile.is-info .gt-stat-tile-label-icon {\n  background: var(--gt-prio-low-bg); color: var(--gt-prio-low-fg);\n}\n\n/* ── Filter Pill (the \"All / To Do / In Progress / Blocked\" tabs) ─────── */\n.gt-filter-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  border-radius: 14px;\n  border: 1px solid var(--gt-border);\n  background: var(--gt-surface-0);\n  font-family: var(--gt-font);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),\n              transform var(--gt-t-fast), box-shadow var(--gt-t-fast);\n}\n.gt-filter-pill:hover {\n  border-color: var(--gt-border-strong);\n  transform: translateY(-1px);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-filter-pill.is-active {\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  border-color: var(--gt-primary);\n}\n.gt-filter-pill-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 9px;\n  background: var(--gt-primary-container);\n  color: var(--gt-primary);\n}\n.gt-filter-pill.is-active .gt-filter-pill-icon {\n  background: rgba(255, 255, 255, 0.18);\n  color: var(--gt-on-primary);\n}\n.gt-filter-pill-count {\n  font-family: var(--gt-font-display);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--gt-text-primary);\n  letter-spacing: -0.02em;\n}\n.gt-filter-pill.is-active .gt-filter-pill-count { color: var(--gt-on-primary); }\n\n/* Filter pill semantic variants for state colors */\n.gt-filter-pill.tone-todo .gt-filter-pill-icon {\n  background: var(--gt-status-pending-bg); color: var(--gt-status-pending-fg);\n}\n.gt-filter-pill.tone-progress .gt-filter-pill-icon {\n  background: var(--gt-status-progress-bg); color: var(--gt-status-progress-fg);\n}\n.gt-filter-pill.tone-review .gt-filter-pill-icon {\n  background: var(--gt-prio-med-bg); color: var(--gt-prio-med-fg);\n}\n.gt-filter-pill.tone-blocked .gt-filter-pill-icon {\n  background: var(--gt-prio-urgent-bg); color: var(--gt-prio-urgent-fg);\n}\n.gt-filter-pill.tone-done .gt-filter-pill-icon {\n  background: var(--gt-status-done-bg); color: var(--gt-status-done-fg);\n}\n\n/* ── Page action buttons (Create / Recently Deleted) ──────────────────── */\n.gt-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 22px;\n  border-radius: 999px;\n  border: 1px solid var(--gt-primary);\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  font-family: var(--gt-font);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast),\n              transform var(--gt-t-fast), box-shadow var(--gt-t-fast);\n  text-decoration: none;\n}\n.gt-action-btn:hover {\n  background: var(--gt-primary-hover);\n  border-color: var(--gt-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--gt-glow);\n}\n.gt-action-btn.is-ghost {\n  background: var(--gt-surface-0);\n  color: var(--gt-text-primary);\n  border-color: var(--gt-border-strong);\n}\n.gt-action-btn.is-ghost:hover {\n  background: var(--gt-surface-2);\n  border-color: var(--gt-text-tertiary);\n}\n.gt-action-btn.is-danger-outline {\n  background: transparent;\n  color: var(--gt-dnd);\n  border-color: var(--gt-dnd);\n}\n.gt-action-btn.is-danger-outline:hover {\n  background: var(--gt-prio-urgent-bg);\n  border-color: var(--gt-dnd);\n  color: var(--gt-prio-urgent-fg);\n}\n\n/* ── Tab strip (All Tasks / My Tasks / Team Tasks) ─────────────────────── */\n.gt-tab-strip {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  border-bottom: 1px solid var(--gt-divider);\n  padding: 0 4px;\n}\n.gt-tab-strip-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 4px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: var(--gt-font);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--gt-text-tertiary);\n  cursor: pointer;\n  transition: color var(--gt-t-fast), border-color var(--gt-t-fast);\n  margin-bottom: -1px;\n}\n.gt-tab-strip-item:hover { color: var(--gt-text-primary); }\n.gt-tab-strip-item.is-active {\n  color: var(--gt-text-primary);\n  border-bottom-color: var(--gt-primary);\n}\n\n/* When sidebar/topbar are inside .gt-themed shell, suppress legacy\n   Tailwind compatibility overrides that would otherwise re-paint them. */\n.gt-themed .gt-sidebar,\n.gt-themed .gt-topbar,\n.gt-themed .gt-sidebar *,\n.gt-themed .gt-topbar * { font-family: var(--gt-font); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TeamLio Expense Shell — full TeamLio HR layout for the canonical /expenses\n   route inside Messenger. It intentionally opts out of the floating Messenger\n   AppShell chrome while reusing the same TeamLio tokens and page components.\n   ────────────────────────────────────────────────────────────────────────── */\n.teamlio-expense-shell {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n  background: var(--gt-surface-1, #ffffff);\n  color: var(--gt-text-primary, #1a1a1a);\n  font-family: var(--gt-font);\n}\n\n.teamlio-expense-sidebar.gt-sidebar {\n  width: 264px;\n  min-width: 264px;\n  max-width: 264px;\n  border-radius: 0;\n  box-shadow: none;\n  border-right: 1px solid var(--gt-border, #e8e3d8);\n  background: var(--gt-surface-rail-soft, #ffffff);\n}\n\n.teamlio-expense-sidebar.gt-sidebar.is-collapsed {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.teamlio-expense-sidebar .gt-sidebar-header {\n  min-height: 124px;\n  padding: 26px 20px 20px;\n}\n\n.teamlio-expense-sidebar .gt-sidebar-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.teamlio-expense-sidebar .gt-sidebar-user {\n  min-width: 0;\n  font-family: var(--gt-font-display);\n  font-weight: 800;\n  font-size: 16px;\n  line-height: 1.18;\n  letter-spacing: var(--gt-letter-display);\n  color: var(--gt-text-primary);\n  overflow-wrap: anywhere;\n}\n\n.teamlio-expense-sidebar .gt-sidebar-role {\n  font-family: var(--gt-font-mono);\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--gt-primary);\n  white-space: nowrap;\n}\n\n.teamlio-expense-sidebar .gt-sidebar-company {\n  margin-top: 4px;\n  font-family: var(--gt-font-serif);\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-text-secondary);\n}\n\n.teamlio-expense-shell__main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--gt-surface-1, #ffffff);\n}\n\n.teamlio-expense-topbar.gt-topbar {\n  min-height: 88px;\n  padding: 0 28px;\n  background: var(--gt-surface-rail-soft, #ffffff);\n  border-bottom: 1px solid var(--gt-divider, #efeae0);\n}\n\n.teamlio-expense-ticker {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: var(--gt-primary, #0f2d1f);\n}\n\n.teamlio-expense-ticker strong {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.teamlio-expense-ticker button {\n  flex-shrink: 0;\n  border: 0;\n  background: transparent;\n  color: var(--gt-text-tertiary, #8a8580);\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.teamlio-expense-bell span {\n  position: absolute;\n  top: -3px;\n  right: -3px;\n  min-width: 19px;\n  height: 19px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--gt-red-600, #dc2626);\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 19px;\n  text-align: center;\n}\n\n.teamlio-expense-shell__content {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  background: var(--gt-surface-1, #ffffff);\n}\n\n.teamlio-expense-shell__content > * {\n  min-height: 100%;\n}\n\n@media (max-width: 767px) {\n  .teamlio-expense-shell {\n    display: block;\n    overflow: auto;\n  }\n\n  .teamlio-expense-sidebar.gt-sidebar {\n    display: none !important;\n  }\n\n  .teamlio-expense-topbar.gt-topbar {\n    min-height: 64px;\n    padding: 0 14px;\n  }\n\n  .teamlio-expense-ticker {\n    justify-content: flex-start;\n  }\n\n  .teamlio-expense-ticker strong {\n    font-size: 12px;\n  }\n}\n\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Conversation row — final flat override.\n   Strips visible border / rounded outline / focus ring that leaks in via\n   shadcn's global `* { @apply border-border }` (src/index.css:73) and\n   browser default button styling. The leading active-bar is re-enabled\n   below so the selected-row accent survives.\n   ──────────────────────────────────────────────────────────────────────── */\nhtml body .gc-conv-row,\nhtml body button.gc-conv-row {\n  border: 0 !important;\n  border-radius: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  -webkit-tap-highlight-color: transparent !important;\n}\nhtml body .gc-conv-row:hover,\nhtml body .gc-conv-row:focus,\nhtml body .gc-conv-row:focus-visible,\nhtml body .gc-conv-row.is-active {\n  border: 0 !important;\n  border-radius: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n/* Preserve the leading-bar accent on the active row */\nhtml body .gc-conv-row.is-active::before {\n  display: block !important;\n}\n\n/* ══════════════════════════════════════════════════════════════════════════\n   SHARED REUSABLE UTILITIES — usable globally from any component\n   These replace inline `style={{...}}` blocks that were duplicated across\n   the chat surface. Any component can apply them by className.\n   ══════════════════════════════════════════════════════════════════════════ */\n\n/* — Primary action button (filled). Pair with elevation modifier as needed — */\n.gc-btn-primary {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  box-shadow: var(--gc-elev-2);\n  --tw-ring-color: var(--gc-primary);\n}\n.gc-btn-primary.is-elev-3 { box-shadow: var(--gc-elev-3); }\n.gc-btn-primary.is-elev-1 { box-shadow: var(--gc-elev-1); }\n\n/* — Inline badge filled with primary color (e.g. unread count) — */\n.gc-badge-primary {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-family: var(--gc-font-display);\n}\n\n/* — Display-family text variants — */\n.gc-text-display {\n  font-family: var(--gc-font-display);\n  color: var(--gc-text-primary);\n}\n.gc-text-display-bold {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gc-text-primary);\n}\n\n/* — Tertiary helper text — */\n.gc-text-tertiary { color: var(--gc-text-tertiary); }\n.gc-text-disabled-italic {\n  color: var(--gc-text-disabled);\n  font-style: italic;\n}\n\n/* — Monospace time/numeric stamp — */\n.gc-text-mono-time {\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font-mono);\n  letter-spacing: 0.02em;\n}\n\n/* — Circular icon container filled with primary gradient — */\n.gc-icon-circle-primary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background: linear-gradient(135deg, var(--gc-primary) 0%, var(--gc-primary-soft) 100%);\n  color: var(--gc-on-primary);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n/* — Generic \"message removed\" dot — */\n.gc-removed-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: var(--gc-text-disabled);\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n/* — Conversational text in row: switches color when unread — */\n.gc-row-last { color: var(--gc-text-tertiary); }\n.gc-row-last.is-unread { color: var(--gc-text-primary); }\n\n/* — \"Draft:\" marker, shown in place of the last message — */\n.gc-row-draft { color: var(--gc-accent-strong); font-weight: 600; }\n/* --gc-accent-strong is a deep emerald tuned for white; it goes muddy on the\n   dark surface, so dark mode borrows the brighter accent instead. The high\n   contrast theme redefines the token itself and needs no override here. */\n[data-theme=\"dark\"] .gc-row-draft { color: var(--gc-accent); }\n\n/* — Rich text renderer (TipTap render-only) base — */\n.chat-rich-render {\n  font-size: var(--gc-font-size-md);\n  line-height: 1.45;\n}\n\n/* — Voice audio player (used in attachment bubble) — */\n.gc-voice-audio {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.gc-voice-audio__el {\n  max-width: 320px;\n  height: 36px;\n}\n.gc-link-sm {\n  font-size: 12px;\n  color: var(--gc-link);\n  text-decoration: underline;\n}\n\n/* — Generic flex-shrink helper for svgs/glyphs — */\n.gc-noshrink { flex-shrink: 0; }\n\n/* — Inline-flex tooltip-trigger wrapper — */\n.gc-inline-flex { display: inline-flex; }\n\n/* — Avatar: dynamic size driven by --avatar-size / --avatar-font-size CSS vars — */\n.gc-avatar {\n  position: relative;\n  flex-shrink: 0;\n  width: var(--avatar-size, 36px);\n  height: var(--avatar-size, 36px);\n}\n.gc-avatar__inner {\n  font-size: var(--avatar-font-size, 14px);\n  width: 100%;\n  height: 100%;\n}\n.gc-avatar__status-dot {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n  border: 2px solid var(--gc-surface-0);\n  background: var(--gc-offline);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n.gc-avatar__status-dot.is-online { background: var(--gc-online); }\n\n/* — Google brand controls (used by GoogleConnectModal) — */\n.gc-google-icon-circle {\n  width: 44px;\n  height: 44px;\n  border-radius: 9999px;\n  background: #e8f0fe;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gc-btn-google {\n  background: #1a73e8;\n}\n\n/* — TypingIndicator staggered animation — */\n.gc-typing-dot { animation-delay: 0ms; }\n.gc-typing-dot.is-d1 { animation-delay: 150ms; }\n.gc-typing-dot.is-d2 { animation-delay: 300ms; }\n\n/* — PresenceBadge size modifiers + inner dot — */\n.gc-presence-pill.is-size-sm {\n  font-size: 10px;\n  padding: 2px 8px 2px 6px;\n}\n.gc-presence-pill.is-size-lg {\n  font-size: 13px;\n  padding: 4px 12px 4px 10px;\n}\n.gc-presence-pill__inner-dot {\n  width: 7px;\n  height: 7px;\n  border: none;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   DateDivider\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-date-divider-line {\n  background: linear-gradient(to right, transparent, var(--gc-border-strong) 35%, var(--gc-border-strong) 65%, transparent);\n}\n.gc-date-divider-center {\n  color: var(--gc-text-tertiary);\n}\n.gc-date-divider-flourish {\n  font-size: 9.5px;\n  color: var(--gc-text-disabled);\n  letter-spacing: 0.18em;\n}\n.gc-date-divider-label {\n  font-family: var(--gc-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  font-size: 13.5px;\n  color: var(--gc-text-secondary);\n  letter-spacing: 0.005em;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   FilterDropdown\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-filter-trigger {\n  background: var(--gc-surface-1);\n  color: var(--gc-text-secondary);\n  border: 1px solid var(--gc-border);\n  border-radius: 12px;\n  font-family: var(--gc-font);\n  letter-spacing: -0.005em;\n  box-shadow: none;\n}\n.gc-filter-trigger.is-open {\n  border-color: var(--gc-primary);\n  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);\n}\n.gc-filter-trigger__label {\n  color: var(--gc-text-tertiary);\n  font-weight: 500;\n}\n.gc-filter-trigger__label.is-selected {\n  color: var(--gc-text-primary);\n  font-weight: 600;\n}\n.gc-filter-trigger__chevron {\n  color: var(--gc-text-tertiary);\n  transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-filter-trigger__chevron.is-open {\n  transform: rotate(180deg);\n}\n.gc-filter-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n}\n.gc-filter-menu {\n  z-index: 1001;\n  background: rgba(255, 255, 255, 0.97);\n  border: 1px solid var(--gc-border);\n  border-radius: 14px;\n  padding: 4px;\n  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);\n  /* PERF: backdrop-filter removed for Electron compositor cost — see gc-ios-menu */\n  background: #ffffff;\n  max-height: min(320px, calc(100vh - 64px));\n  overflow-y: auto;\n  font-family: var(--gc-font);\n  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  transform-origin: top left;\n}\n.gc-filter-option {\n  background: transparent;\n  color: var(--gc-text-primary);\n  font-size: 12.5px;\n  font-weight: 500;\n  font-family: var(--gc-font);\n  border: none;\n  cursor: pointer;\n}\n.gc-filter-option:hover { background: var(--gc-surface-2); }\n.gc-filter-option.is-active {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  font-weight: 600;\n}\n.gc-filter-option.is-active:hover { background: var(--gc-primary-container); }\n.gc-filter-option__check-slot {\n  width: 14px;\n  display: inline-flex;\n  justify-content: center;\n  color: var(--gc-primary);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   LinkUnfurl\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-unfurl {\n  max-width: 480px;\n  background: var(--gc-surface-1);\n  /* Keep only the left accent rail; drop the full outline + shadow so it reads\n     as one soft card rather than a heavy framed box. Radius echoes the bubble. */\n  border: none;\n  border-left: 3px solid var(--gc-primary);\n  border-radius: var(--gc-radius-bubble);\n  display: flex;\n  align-items: stretch;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  box-shadow: none;\n}\n.gc-unfurl__body {\n  flex: 1;\n  padding: 10px 12px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.gc-unfurl__site-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 2px;\n}\n.gc-unfurl__favicon {\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.gc-unfurl__site {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.gc-unfurl__title {\n  margin: 0;\n  font-family: var(--gc-font);\n  font-size: var(--gc-font-size-base);\n  font-weight: 600;\n  color: var(--gc-text-primary);\n  line-height: var(--gc-line-height);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.gc-unfurl__desc {\n  margin: 0;\n  font-family: var(--gc-font);\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-secondary);\n  line-height: var(--gc-line-height);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.gc-unfurl__domain {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-link);\n  font-family: var(--gc-font);\n  margin-top: 2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.gc-unfurl__image-wrap {\n  width: 120px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.gc-unfurl__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0 var(--gc-radius-card) var(--gc-radius-card) 0;\n  display: block;\n}\n.gc-unfurl__dismiss {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 22px;\n  height: 22px;\n  border: none;\n  background: var(--gc-surface-2);\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gc-text-tertiary);\n  padding: 0;\n  transition: background var(--gc-transition-fast);\n}\n.gc-unfurl__dismiss.has-image { right: 128px; }\n.gc-unfurl__dismiss:hover { background: var(--gc-surface-3); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   E2EEBadge\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-e2ee-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n.gc-e2ee-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: var(--gc-radius-pill);\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n  font-size: var(--gc-font-size-xs);\n  font-family: var(--gc-font);\n  cursor: pointer;\n  line-height: 1.4;\n  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);\n}\n.gc-e2ee-trigger:hover {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n}\n.gc-e2ee-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n}\n.gc-e2ee-popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 101;\n  width: 280px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  box-shadow: var(--gc-elev-3);\n  padding: 14px 16px;\n  font-family: var(--gc-font);\n}\n.gc-e2ee-popover__arrow {\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n  width: 10px;\n  height: 10px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-bottom: none;\n  border-right: none;\n}\n.gc-e2ee-popover__title {\n  margin: 0 0 6px;\n  font-weight: 600;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n}\n.gc-e2ee-popover__body {\n  margin: 0 0 10px;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-secondary);\n  line-height: var(--gc-line-height);\n}\n.gc-e2ee-popover__meta {\n  margin: 0 0 12px;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-tertiary);\n  line-height: var(--gc-line-height);\n}\n.gc-e2ee-popover__actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n.gc-btn-pill-outline-danger {\n  padding: 4px 10px;\n  border-radius: var(--gc-radius-pill);\n  border: 1px solid var(--gc-border);\n  background: transparent;\n  color: var(--gc-dnd);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  cursor: pointer;\n}\n.gc-btn-pill-primary {\n  padding: 4px 10px;\n  border-radius: var(--gc-radius-pill);\n  border: none;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  cursor: pointer;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   EmptyState\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-empty-state {\n  background:\n    radial-gradient(circle at 28% 32%, rgba(220, 239, 225, 0.55) 0%, transparent 38%),\n    radial-gradient(circle at 72% 78%, rgba(236, 246, 238, 0.6) 0%, transparent 42%),\n    var(--gc-surface-1);\n}\n.gc-empty-state__folio {\n  top: 14%;\n  left: 50%;\n  transform: translateX(-50%);\n  font-family: var(--gc-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  font-size: 240px;\n  line-height: 1;\n  color: var(--gc-primary-container);\n  opacity: 0.55;\n  letter-spacing: -0.03em;\n}\n.gc-empty-state__eyebrow {\n  color: var(--gc-text-tertiary);\n}\n.gc-empty-state__leaf-flip {\n  transform: rotate(165deg);\n}\n.gc-empty-state__headline {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 38px;\n  line-height: 1.05;\n  color: var(--gc-text-primary);\n  letter-spacing: -0.035em;\n  max-width: 520px;\n}\n.gc-empty-state__headline-em {\n  color: var(--gc-primary);\n  font-weight: 500;\n  font-size: 42px;\n}\n.gc-empty-state__tagline {\n  color: var(--gc-text-tertiary);\n  font-size: 14.5px;\n}\n.gc-empty-state__tagline-em {\n  color: var(--gc-text-secondary);\n}\n.gc-empty-state__cta {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  box-shadow: var(--gc-elev-3);\n  font-family: var(--gc-font-display);\n  letter-spacing: 0.005em;\n  --tw-ring-color: var(--gc-primary);\n}\n.gc-empty-state__hint {\n  color: var(--gc-text-disabled);\n}\n.gc-empty-state__kbd {\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  font-family: var(--gc-font-mono);\n  color: var(--gc-text-secondary);\n}\n.gc-empty-state__hint-plus { margin-left: 4px; }\n.gc-empty-state__watermark {\n  bottom: 36px;\n  right: 44px;\n  opacity: 0.18;\n  color: var(--gc-primary);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   MeetInviteCard\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-meet-card {\n  /* Flattened — the message bubble is the single rounded container (matches the\n     already-flat .is-inverted variant and the flush image attachment). The card\n     no longer nests its own framed/shadowed box inside the bubble. */\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  max-width: 360px;\n  font-family: var(--gc-font);\n}\n.gc-meet-card__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n.gc-meet-card__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n}\n.gc-meet-card__title {\n  font-size: 14px;\n  letter-spacing: -0.01em;\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font-display);\n}\n.gc-meet-card__when {\n  font-size: 12px;\n  color: var(--gc-text-secondary);\n  margin-bottom: 2px;\n}\n.gc-meet-card__sender {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n  margin-bottom: 12px;\n}\n.gc-meet-card__join {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: var(--gc-primary);\n  /* Pair with the brand's on-primary foreground; the fallback guarantees a\n     light label even if the token ever fails to resolve, so the text can never\n     inherit the dark bubble color and vanish into the button. */\n  color: var(--gc-on-primary, #f7faf6);\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.005em;\n  font-family: var(--gc-font-display);\n  text-decoration: none;\n  box-shadow: var(--gc-elev-2);\n  transition: background 140ms ease, transform 140ms ease, box-shadow 140ms ease;\n}\n/* Keep the glyphs locked to the label color regardless of cascade. */\n.gc-meet-card__join svg { color: inherit; }\n.gc-meet-card__join:hover {\n  background: var(--gc-primary-hover, #15211a);\n  transform: translateY(-1px);\n  box-shadow: var(--gc-elev-3);\n}\n.gc-meet-card__join:active {\n  transform: translateY(0);\n  box-shadow: var(--gc-elev-1);\n}\n/* Inverted (inside sent bubble) */\n.gc-meet-card.is-inverted {\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  font-family: var(--gc-font, inherit);\n  color: var(--gc-bubble-mine-text);\n  min-width: 220px;\n  max-width: 320px;\n}\n.gc-meet-card.is-inverted .gc-meet-card__head { gap: 8px; margin-bottom: 6px; }\n.gc-meet-card.is-inverted .gc-meet-card__icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.14);\n  color: rgba(255, 255, 255, 0.92);\n}\n.gc-meet-card.is-inverted .gc-meet-card__title {\n  font-size: 13.5px;\n  letter-spacing: -0.005em;\n  color: inherit;\n}\n.gc-meet-card.is-inverted .gc-meet-card__when {\n  font-size: 12px;\n  color: inherit;\n  opacity: 0.78;\n}\n.gc-meet-card.is-inverted .gc-meet-card__sender {\n  font-size: 11px;\n  color: inherit;\n  opacity: 0.6;\n  margin-bottom: 10px;\n}\n.gc-meet-card.is-inverted .gc-meet-card__join {\n  padding: 7px 14px;\n  background: rgba(255, 255, 255, 0.92);\n  color: var(--gc-primary);\n  font-size: 12px;\n  box-shadow: none;\n  transition: transform 120ms ease, background 120ms ease;\n}\n.gc-meet-card.is-inverted .gc-meet-card__join:hover { transform: scale(1.03); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   InstantMeetForm\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-meet-form {\n  margin: 0 12px 12px;\n  padding: 12px;\n  background: var(--gc-surface-1, #f9fafb);\n  border-radius: 12px;\n  border: 1px solid var(--gc-divider, #e5e7eb);\n  font-family: var(--gc-font, inherit);\n}\n.gc-meet-form__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.gc-meet-form__head-title {\n  flex: 1;\n  font-size: 14px;\n}\n.gc-meet-form__close {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n.gc-meet-form__input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--gc-outline, #d1d5db);\n  border-radius: 6px;\n  font-size: 13px;\n  margin-bottom: 10px;\n  background: var(--gc-surface-0, #fff);\n  color: var(--gc-text-primary, #111827);\n  box-sizing: border-box;\n}\n.gc-meet-form__notify-wrap { margin-bottom: 10px; }\n.gc-meet-form__notify-label {\n  font-size: 12px;\n  color: var(--gc-text-secondary, #6b7280);\n  margin-bottom: 6px;\n}\n.gc-meet-form__notify-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  max-height: 96px;\n  overflow-y: auto;\n}\n.gc-meet-form__notify-chip {\n  padding: 4px 10px;\n  border-radius: 9999px;\n  border: 1px solid var(--gc-outline, #d1d5db);\n  background: var(--gc-surface-0, #fff);\n  color: var(--gc-text-primary, #111827);\n  font-size: 12px;\n  cursor: pointer;\n}\n.gc-meet-form__notify-chip.is-on {\n  border-color: var(--gc-primary, #2563eb);\n  background: var(--gc-primary-container, #dbeafe);\n  color: var(--gc-primary, #2563eb);\n}\n.gc-meet-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.gc-btn-outline-sm {\n  padding: 6px 14px;\n  border: 1px solid var(--gc-outline, #d1d5db);\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  font-size: 13px;\n}\n.gc-btn-filled-sm {\n  padding: 6px 14px;\n  border: none;\n  border-radius: 6px;\n  background: var(--gc-primary, #2563eb);\n  color: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n.gc-btn-filled-sm:disabled { opacity: 0.6; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Admin tables (shared between DLP / Holds / Audit tabs)\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-admin-wrap {\n  overflow-x: auto;\n  font-family: var(--gc-font);\n}\n.gc-admin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.gc-admin-table__cell {\n  padding: 8px 10px;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-primary);\n  border-bottom: 1px solid var(--gc-divider);\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.gc-admin-table__head {\n  padding: 8px 10px;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-tertiary);\n  font-weight: 600;\n  background: var(--gc-surface-1);\n  position: sticky;\n  top: 0;\n  border-bottom: 1px solid var(--gc-divider);\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.gc-admin-table__cell.is-mono {\n  font-family: monospace;\n  font-size: 11px;\n}\n.gc-admin-table__row { background: var(--gc-surface-0); }\n/* External chat: shown in place of the composer while a reply is outstanding.\n   The thread stays readable; this says why nothing more can be sent yet. */\n.gc-frozen-notice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--gc-text-tertiary);\n  background: var(--gc-surface-1, transparent);\n  border-top: 1px solid var(--gc-border-strong);\n}\n\n.gc-admin-state {\n  padding: 16px;\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font);\n}\n.gc-admin-state.is-error { color: var(--gc-dnd); }\n.gc-admin-chip-rule {\n  padding: 2px 6px;\n  border-radius: var(--gc-radius-pill);\n  background: var(--gc-surface-2);\n  font-size: var(--gc-font-size-xs);\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n}\n.gc-admin-action-text {\n  color: var(--gc-text-primary);\n  font-weight: 600;\n  font-size: var(--gc-font-size-xs);\n}\n.gc-admin-action-text.is-flagged { color: var(--gc-away); }\n.gc-admin-action-text.is-blocked { color: var(--gc-dnd); }\n.gc-admin-action-text.is-redacted { color: var(--gc-text-tertiary); }\n.gc-admin-btn-review {\n  padding: 3px 10px;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-pill);\n  background: transparent;\n  color: var(--gc-primary);\n  font-size: var(--gc-font-size-xs);\n  cursor: pointer;\n  font-family: var(--gc-font);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   AdminConsole — side panel + tabs\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-admin-console {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 640px;\n  max-width: 100vw;\n  background: var(--gc-surface-0);\n  border-left: 1px solid var(--gc-border);\n  box-shadow: var(--gc-elev-4);\n  display: flex;\n  flex-direction: column;\n  z-index: 200;\n  font-family: var(--gc-font);\n}\n.gc-admin-console__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--gc-divider);\n  flex-shrink: 0;\n}\n.gc-admin-console__title {\n  font-weight: 600;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n}\n.gc-admin-console__close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--gc-text-tertiary);\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: var(--gc-radius-card);\n}\n.gc-admin-console__tabs {\n  display: flex;\n  border-bottom: 1px solid var(--gc-divider);\n  overflow-x: auto;\n  flex-shrink: 0;\n  background: var(--gc-surface-0);\n}\n.gc-admin-console__tab {\n  padding: 8px 16px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--gc-text-secondary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  font-weight: 400;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color var(--gc-transition-fast), border-color var(--gc-transition-fast);\n}\n.gc-admin-console__tab.is-active {\n  border-bottom-color: var(--gc-primary);\n  color: var(--gc-primary);\n  font-weight: 600;\n}\n.gc-admin-console__body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   AdminHoldsTab\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-admin-holds-wrap { font-family: var(--gc-font); }\n.gc-admin-holds-toolbar {\n  padding: 12px 16px;\n  display: flex;\n  justify-content: flex-end;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-btn-primary-pill-sm {\n  padding: 6px 14px;\n  border: none;\n  border-radius: var(--gc-radius-pill);\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  cursor: pointer;\n  font-weight: 500;\n}\n.gc-btn-primary-pill-sm:disabled,\n.gc-btn-primary-pill-sm.is-busy {\n  background: var(--gc-surface-3);\n  cursor: not-allowed;\n}\n.gc-admin-form {\n  padding: 16px;\n  background: var(--gc-surface-1);\n  border-bottom: 1px solid var(--gc-divider);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.gc-form-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-secondary);\n  font-family: var(--gc-font);\n  font-weight: 500;\n}\n.gc-form-input {\n  width: 100%;\n  padding: 6px 10px;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  box-sizing: border-box;\n}\n.gc-form-input--textarea {\n  min-height: 60px;\n  resize: vertical;\n}\n.gc-form-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.gc-form-error {\n  margin: 0;\n  color: var(--gc-dnd);\n  font-size: var(--gc-font-size-sm);\n}\n.gc-form-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n.gc-admin-holds-name { font-weight: 500; }\n.gc-admin-holds-desc {\n  color: var(--gc-text-tertiary);\n  font-size: var(--gc-font-size-xs);\n}\n.gc-admin-holds-active { font-weight: 600; }\n.gc-admin-holds-active.is-yes { color: var(--gc-online); }\n.gc-admin-holds-active.is-no { color: var(--gc-text-disabled); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TimePicker\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-time-trigger {\n  padding: 10px 12px;\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  border: 1px solid var(--gc-border);\n  border-radius: 12px;\n  font-family: var(--gc-font);\n  font-size: 13.5px;\n  text-align: left;\n  box-shadow: none;\n  cursor: pointer;\n}\n.gc-time-trigger.is-open {\n  border-color: var(--gc-primary);\n  box-shadow: 0 0 0 3px rgba(31, 46, 35, 0.08);\n}\n.gc-time-trigger__icon {\n  color: var(--gc-text-tertiary);\n  flex-shrink: 0;\n}\n.gc-time-trigger__value {\n  flex: 1;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n}\n.gc-time-trigger__chevron {\n  color: var(--gc-text-tertiary);\n  transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1);\n  flex-shrink: 0;\n}\n.gc-time-trigger__chevron.is-open { transform: rotate(180deg); }\n.gc-time-pop {\n  z-index: 1001;\n  background: rgba(255, 255, 255, 0.97);\n  border: 1px solid var(--gc-border);\n  border-radius: 16px;\n  padding: 12px;\n  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);\n  /* PERF: backdrop-filter removed for Electron compositor cost — see gc-ios-menu */\n  background: #ffffff;\n  font-family: var(--gc-font);\n  animation: gc-bubble-menu-pop 200ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  transform-origin: top left;\n}\n.gc-time-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 0.85fr;\n  gap: 8px;\n}\n.gc-time-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding-right: 2px;\n}\n.gc-time-col-header {\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font-display);\n  text-align: center;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--gc-divider);\n  margin-bottom: 6px;\n}\n.gc-time-item {\n  width: 100%;\n  padding: 7px 6px;\n  border-radius: 9px;\n  font-size: 13.5px;\n  font-family: var(--gc-font);\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 140ms ease, color 140ms ease, transform 140ms ease;\n  letter-spacing: 0;\n  text-align: center;\n  box-shadow: none;\n}\n.gc-time-item:hover { background: var(--gc-surface-2); }\n.gc-time-item.is-active {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  color: var(--gc-on-primary);\n  background: var(--gc-primary);\n  letter-spacing: -0.005em;\n  box-shadow: 0 4px 10px rgba(15, 29, 20, 0.18);\n}\n.gc-time-item.is-active:hover { background: var(--gc-primary); }\n.gc-time-item.is-period {\n  padding: 12px 6px;\n  font-size: 13px;\n  letter-spacing: 0.08em;\n}\n.gc-time-period-col {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.gc-time-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 10px;\n  margin-top: 10px;\n  border-top: 1px solid var(--gc-divider);\n}\n.gc-time-now-btn {\n  padding: 6px 12px;\n  font-size: 11.5px;\n  font-family: var(--gc-font-display);\n  font-weight: 600;\n  border-radius: 9px;\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-0);\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n  letter-spacing: 0.02em;\n}\n.gc-time-done-btn {\n  padding: 6px 14px;\n  font-size: 12px;\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  border-radius: 9px;\n  border: none;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  cursor: pointer;\n  letter-spacing: 0.005em;\n  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ThreadPanel\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-thread-panel {\n  background: var(--gc-surface-0);\n  border-left: 1px solid var(--gc-divider);\n}\n.gc-thread-panel__header {\n  background: var(--gc-surface-0);\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-thread-panel__icon-square {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n}\n.gc-thread-panel__eyebrow {\n  color: var(--gc-text-tertiary);\n  font-size: 9px;\n}\n.gc-thread-panel__title {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: -0.02em;\n  color: var(--gc-text-primary);\n}\n.gc-thread-panel__close { color: var(--gc-text-tertiary); }\n.gc-thread-panel__close:hover {\n  background: var(--gc-surface-2);\n  color: var(--gc-text-primary);\n}\n.gc-thread-panel__body {\n  background:\n    radial-gradient(circle at 0% 0%, rgba(220, 239, 225, 0.30) 0%, transparent 32%),\n    var(--gc-surface-1);\n}\n.gc-thread-replies-meta {\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font-display);\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.gc-thread-replies-meta__count {\n  color: var(--gc-primary);\n  font-weight: 700;\n}\n.gc-thread-panel__composer {\n  background: var(--gc-surface-2);\n  border-top: 1px solid var(--gc-divider);\n}\n.gc-thread-panel__send {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  box-shadow: var(--gc-elev-2);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   VoiceRecorder\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-voice-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  background: var(--gc-surface-1);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n}\n.gc-voice-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--gc-surface-1);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  color: var(--gc-dnd);\n  font-family: var(--gc-font);\n  font-size: var(--gc-font-size-sm);\n}\n.gc-voice-error__text { flex: 1; }\n.gc-voice-error__close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--gc-text-tertiary);\n  display: flex;\n}\n.gc-voice-icon-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 50%;\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background var(--gc-transition-fast);\n}\n.gc-voice-icon-btn.is-danger {\n  background: var(--gc-mention-channel-bg);\n  color: var(--gc-dnd);\n}\n.gc-voice-icon-btn.is-stop {\n  background: var(--gc-dnd);\n  color: var(--gc-on-primary);\n}\n.gc-voice-icon-btn.is-primary {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n}\n.gc-voice-icon-btn.is-primary.is-busy {\n  background: var(--gc-surface-3);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.gc-voice-record-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.gc-voice-record-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--gc-dnd);\n  flex-shrink: 0;\n}\n.gc-voice-record-time {\n  font-family: var(--gc-font);\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-primary);\n  font-variant-numeric: tabular-nums;\n  min-width: 36px;\n}\n.gc-voice-record-time.is-secondary { color: var(--gc-text-secondary); }\n.gc-voice-bars {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.gc-voice-bar {\n  border-radius: 2px;\n  background: var(--gc-primary);\n  flex-shrink: 0;\n  transition: height 80ms ease;\n}\n.gc-voice-bar.is-static { transition: none; opacity: 0.6; }\n.gc-voice-bar:not(.is-static) { opacity: 0.7; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   EmojiPicker\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-emoji-picker {\n  width: 320px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-4);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--gc-font);\n}\n.gc-emoji-picker__search-wrap {\n  padding: 8px 8px 0;\n  position: relative;\n}\n.gc-emoji-picker__search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--gc-text-tertiary);\n  pointer-events: none;\n}\n.gc-emoji-picker__search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 6px 8px 6px 28px;\n  border: 1px solid var(--gc-border);\n  border-radius: 20px;\n  background: var(--gc-surface-1);\n  color: var(--gc-text-primary);\n  font-size: var(--gc-font-size-sm);\n  outline: none;\n}\n.gc-emoji-picker__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px 4px;\n}\n.gc-emoji-picker__skin-wrap { position: relative; }\n.gc-emoji-picker__skin-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 2px;\n  border-radius: 4px;\n  line-height: 1;\n}\n.gc-emoji-picker__skin-pop {\n  position: absolute;\n  top: 110%;\n  left: 0;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: 8px;\n  padding: 6px 8px;\n  display: flex;\n  gap: 4px;\n  z-index: 10;\n  box-shadow: var(--gc-elev-2);\n}\n.gc-emoji-picker__skin-dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  outline-offset: 1px;\n}\n.gc-emoji-picker__skin-dot.is-default { background: var(--gc-text-secondary); }\n.gc-emoji-picker__skin-dot.is-active { outline: 2px solid var(--gc-primary); }\n.gc-emoji-picker__close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--gc-text-tertiary);\n  display: flex;\n  align-items: center;\n}\n.gc-emoji-picker__tabs {\n  display: flex;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--gc-divider);\n  scrollbar-width: none;\n  padding: 0 4px;\n}\n.gc-emoji-picker__tab {\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px 8px;\n  font-size: 16px;\n  border-bottom: 2px solid transparent;\n  opacity: 0.55;\n  transition: opacity 0.1s, border-color 0.1s;\n}\n.gc-emoji-picker__tab.is-active {\n  border-bottom-color: var(--gc-primary);\n  opacity: 1;\n}\n.gc-emoji-picker__cat-label {\n  padding: 6px 10px 2px;\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.gc-emoji-picker__grid {\n  display: grid;\n  grid-template-columns: repeat(8, 32px);\n  gap: 2px;\n  padding: 4px 8px 10px;\n  overflow-y: auto;\n  max-height: 224px;\n  justify-content: center;\n}\n.gc-emoji-picker__grid-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: var(--gc-font-size-sm);\n  padding: 16px 0;\n}\n.gc-emoji-picker__item {\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n  line-height: 1;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background var(--gc-transition-fast);\n}\n.gc-emoji-picker__item:hover { background: var(--gc-surface-2); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Shared MODAL primitives — reused by Export/Forward/NewConv/Poll/Reminder/etc\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 300;\n}\n.gc-modal-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 301;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.gc-modal-card {\n  width: 460px;\n  max-width: 95vw;\n  background: var(--gc-surface-0);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-5);\n  font-family: var(--gc-font);\n  pointer-events: all;\n}\n.gc-modal-card.is-wide { width: 560px; }\n.gc-modal-card.is-narrow { width: 380px; }\n.gc-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-modal-title {\n  font-weight: 600;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n}\n.gc-modal-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--gc-text-tertiary);\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: var(--gc-radius-card);\n}\n.gc-modal-form {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.gc-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 4px;\n}\n.gc-radio-row {\n  display: flex;\n  gap: 20px;\n}\n.gc-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-primary);\n}\n.gc-radio-input { accent-color: var(--gc-primary); }\n.gc-btn-cancel {\n  padding: 7px 16px;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-pill);\n  background: transparent;\n  color: var(--gc-text-secondary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  cursor: pointer;\n}\n.gc-btn-submit {\n  padding: 7px 18px;\n  border: none;\n  border-radius: var(--gc-radius-pill);\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: var(--gc-font-size-sm);\n  font-family: var(--gc-font);\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: background var(--gc-transition-fast);\n}\n.gc-btn-submit:disabled,\n.gc-btn-submit.is-busy {\n  background: var(--gc-surface-3);\n  cursor: not-allowed;\n}\n.gc-spinner-12 {\n  width: 12px;\n  height: 12px;\n  border: 2px solid var(--gc-on-primary);\n  border-top-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  animation: gc-spin 0.7s linear infinite;\n}\n@keyframes gc-spin { to { transform: rotate(360deg); } }\n.gc-result-pill {\n  padding: 10px 12px;\n  background: var(--gc-primary-container);\n  border-radius: var(--gc-radius-card);\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-primary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gc-result-pill code { font-family: monospace; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ChatRightPanel\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-right-panel {\n  background: var(--gc-surface-1);\n  border-left: 1px solid var(--gc-divider);\n}\n\n/* On phones / tablets (below xl=1280px) the Files & Schedule panel slides\n   in from the right as a fixed overlay rather than living inline. Its\n   sibling backdrop dims the chat behind it and dismisses on tap. */\n.gc-right-panel-backdrop { display: none; }\n\n@media (max-width: 1279px) {\n  .gc-right-panel {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    height: 100dvh;\n    width: 100%;\n    max-width: 360px;\n    z-index: 50;\n    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);\n    animation: gc-right-panel-slide-in 200ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  }\n  .gc-right-panel-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.32);\n    z-index: 45;\n    animation: gc-right-panel-fade-in 200ms ease both;\n  }\n}\n\n@keyframes gc-right-panel-slide-in {\n  from { transform: translateX(100%); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n@keyframes gc-right-panel-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n.gc-section-folio {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gc-primary);\n  letter-spacing: -0.01em;\n}\n.gc-section-title {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: -0.02em;\n  color: var(--gc-text-primary);\n}\n.gc-section-chevron { color: var(--gc-text-tertiary); }\n.gc-section-counter {\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n  font-family: var(--gc-font-display);\n}\n.gc-file-row {\n  color: inherit;\n  background: transparent;\n  transition: background var(--gc-transition-fast);\n}\n.gc-file-row:hover { background: var(--gc-surface-2); }\n.gc-file-badge {\n  background: var(--file-badge-bg);\n  color: var(--file-badge-fg);\n}\n.gc-file-name {\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font-display);\n}\n.gc-file-meta { color: var(--gc-text-tertiary); }\n.gc-mini-cal {\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);\n}\n.gc-mini-cal__month {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--gc-text-primary);\n  letter-spacing: -0.01em;\n}\n.gc-mini-cal__nav {\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n}\n.gc-event-row {\n  background: transparent;\n  transition: background var(--gc-transition-fast);\n}\n.gc-event-row:hover { background: var(--gc-surface-2); }\n.gc-event-row__accent {\n  background: var(--event-accent, var(--gc-primary));\n}\n.gc-event-row__title {\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font-display);\n  letter-spacing: -0.005em;\n}\n.gc-event-row__meta { color: var(--gc-text-tertiary); }\n.gc-event-row__join {\n  background: var(--event-accent-soft, var(--gc-primary-container));\n  color: var(--gc-accent-strong);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n  font-family: var(--gc-font-display);\n}\n.gc-text-tertiary-eyebrow { color: var(--gc-text-tertiary); }\n.gc-text-accent-tag { color: var(--gc-accent-strong); }\n.gc-text-dnd { color: var(--gc-dnd); }\n.gc-divider-top { border-top: 1px solid var(--gc-divider); }\n.gc-close-panel-btn {\n  color: var(--gc-text-secondary);\n  border-color: var(--gc-divider);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   RichTextEditor\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-rte {\n  position: relative;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  background: var(--gc-surface-0);\n  transition: border-color var(--gc-transition-fast);\n  font-family: var(--gc-font);\n}\n.gc-rte.is-focused { border-color: var(--gc-primary); }\n.gc-rte-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: var(--gc-text-secondary);\n  transition: background var(--gc-transition-fast);\n}\n.gc-rte-btn.is-active {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n}\n.gc-rte-bubble {\n  display: flex;\n  gap: 2px;\n  padding: 4px 6px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  box-shadow: var(--gc-elev-3);\n}\n.gc-rte-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--gc-border);\n}\n.gc-rte-toolbar__divider {\n  width: 1px;\n  height: 20px;\n  background: var(--gc-border);\n  margin: 0 4px;\n}\n.gc-rte-editor-wrap {\n  position: relative;\n}\n.gc-rte-editor {\n  min-height: 2.25rem;\n  max-height: 9rem;\n  overflow-y: auto;\n  padding: 8px 12px;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n  line-height: var(--gc-line-height);\n}\n.gc-rte-slash {\n  position: absolute;\n  bottom: 100%;\n  left: 8px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  box-shadow: var(--gc-elev-3);\n  z-index: 50;\n  min-width: 160px;\n  overflow: hidden;\n}\n.gc-rte-slash__item {\n  display: block;\n  width: 100%;\n  padding: 7px 12px;\n  text-align: left;\n  border: none;\n  cursor: pointer;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-primary);\n  background: transparent;\n  font-family: var(--gc-font);\n}\n.gc-rte-slash__item.is-selected { background: var(--gc-surface-2); }\n.gc-rte-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 8px 6px;\n}\n.gc-rte-hint {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  opacity: 0.7;\n}\n.gc-rte-counter {\n  font-size: var(--gc-font-size-xs);\n  color: var(--counter-color, var(--gc-text-tertiary));\n}\n.gc-rte-counter.is-warn { color: var(--gc-away); }\n.gc-rte-counter.is-danger { color: var(--gc-dnd); }\n.gc-rte-send {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: var(--gc-radius-pill);\n  border: none;\n  cursor: pointer;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: var(--gc-font-size-sm);\n  font-weight: 600;\n  font-family: var(--gc-font);\n  transition: background var(--gc-transition-fast);\n}\n.gc-rte-send:disabled {\n  cursor: default;\n  background: var(--gc-surface-2);\n  color: var(--gc-text-disabled);\n}\n\n/* ProseMirror — moved from inline <style> block in RichTextEditor */\n.ProseMirror p.is-editor-empty:first-child::before {\n  content: attr(data-placeholder);\n  color: var(--gc-text-disabled);\n  pointer-events: none;\n  float: left;\n  height: 0;\n}\n.ProseMirror { outline: none; }\n.ProseMirror ul[data-type=\"taskList\"] { padding-left: 0; list-style: none; }\n.ProseMirror ul[data-type=\"taskList\"] li { display: flex; gap: 6px; align-items: flex-start; }\n.ProseMirror ul[data-type=\"taskList\"] li > label { margin-top: 2px; }\n.ProseMirror pre { background: var(--gc-surface-2); border-radius: 6px; padding: 10px 14px; overflow-x: auto; }\n.ProseMirror code { background: var(--gc-surface-2); border-radius: 3px; padding: 1px 4px; font-size: 0.88em; }\n.ProseMirror pre code { background: transparent; padding: 0; }\n.ProseMirror a { color: var(--gc-text-link); text-decoration: underline; }\n.ProseMirror mark { background: var(--gc-mention-bg); border-radius: 2px; padding: 0 2px; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   AdminAuditTab\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-audit-wrap {\n  font-family: var(--gc-font);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n.gc-audit-filterbar {\n  display: flex;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--gc-divider);\n  background: var(--gc-surface-1);\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  align-items: center;\n  flex-shrink: 0;\n}\n.gc-audit-search-wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-pill);\n}\n.gc-audit-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-primary);\n  font-family: inherit;\n}\n.gc-audit-select {\n  padding: 6px 10px;\n  border: 1px solid var(--gc-border);\n  border-radius: 8px;\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  font-size: var(--gc-font-size-sm);\n  font-family: inherit;\n  cursor: pointer;\n}\n.gc-audit-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n.gc-audit-error {\n  margin: 16px;\n  padding: 12px 14px;\n  border: 1px solid rgba(220, 38, 38, 0.25);\n  border-radius: var(--gc-radius-card);\n  background: rgba(220, 38, 38, 0.06);\n  color: var(--gc-dnd);\n  font-size: var(--gc-font-size-sm);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gc-audit-skeleton-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-audit-skeleton-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--gc-surface-2);\n}\n.gc-audit-skeleton-stack {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.gc-audit-skeleton-bar {\n  height: 12px;\n  width: 60%;\n  border-radius: 6px;\n  background: var(--gc-surface-2);\n}\n.gc-audit-skeleton-bar.is-short {\n  height: 10px;\n  width: 35%;\n}\n.gc-audit-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n.gc-audit-empty__icon-circle {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--gc-surface-2);\n  display: grid;\n  place-items: center;\n  color: var(--gc-text-tertiary);\n}\n.gc-audit-empty__title {\n  font-size: var(--gc-font-size-base);\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n}\n.gc-audit-empty__hint {\n  margin-top: 4px;\n  font-size: var(--gc-font-size-sm);\n}\n.gc-audit-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--gc-divider);\n  background: var(--gc-surface-0);\n  transition: background var(--gc-transition-fast);\n  cursor: default;\n}\n.gc-audit-row:hover { background: var(--gc-surface-hover); }\n.gc-audit-row__avatar-wrap {\n  position: relative;\n  padding-top: 2px;\n}\n.gc-audit-row__overlay {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  background: var(--gc-surface-0);\n  border-radius: 8px;\n  padding: 2px;\n  box-shadow: var(--gc-elev-1);\n}\n.gc-audit-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--gc-radius-avatar);\n  background: hsl(var(--avatar-hue, 200), 36%, 88%);\n  color: hsl(var(--avatar-hue, 200), 50%, 26%);\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n.gc-audit-cat-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--cat-bg);\n  color: var(--cat-fg);\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n}\n.gc-audit-row__sentence {\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n  line-height: 1.45;\n  word-break: break-word;\n}\n.gc-audit-row__sentence strong { font-weight: 600; }\n.gc-audit-row__sentence-muted { color: var(--gc-text-secondary); }\n.gc-audit-row__resource-name {\n  font-weight: 500;\n  color: var(--gc-text-primary);\n}\n.gc-audit-row__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n}\n.gc-audit-row__conv-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 1px 8px;\n  border-radius: var(--gc-radius-pill);\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n  font-weight: 500;\n}\n.gc-audit-row__mono {\n  font-family: var(--gc-font-mono, monospace);\n  font-size: 10px;\n}\n.gc-audit-row__pill-wrap { padding-top: 4px; }\n.gc-audit-row__cat-pill {\n  padding: 2px 9px;\n  border-radius: var(--gc-radius-pill);\n  background: var(--cat-pill-bg);\n  color: var(--cat-pill-fg);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.gc-audit-date-header {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 8px 16px;\n  background: var(--gc-surface-1);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n  border-top: 1px solid var(--gc-divider);\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-audit-sentinel {\n  padding: 16px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: var(--gc-font-size-sm);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Admin Away Tracking\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-away-admin-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 14px;\n  min-height: 100%;\n  background: var(--gc-surface-0);\n}\n.gc-away-admin-toolbar {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) auto auto;\n  gap: 10px;\n  align-items: center;\n}\n.gc-away-admin-refresh {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-1);\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n}\n.gc-away-admin-loading {\n  padding: 28px;\n  text-align: center;\n  color: var(--gc-text-secondary);\n}\n.gc-away-admin-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n.gc-away-admin-stat {\n  min-width: 0;\n  padding: 12px;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  background: var(--gc-surface-1);\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 3px 8px;\n  align-items: center;\n}\n.gc-away-admin-stat__icon {\n  grid-row: span 2;\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(250, 204, 21, 0.18);\n  color: #d6a500;\n}\n.gc-away-admin-icon-fallback {\n  display: inline-block;\n  width: 0.5em;\n  height: 0.5em;\n  border-radius: 999px;\n  background: currentColor;\n}\n.gc-away-admin-stat__label {\n  font-size: 11px;\n  color: var(--gc-text-secondary);\n}\n.gc-away-admin-stat strong {\n  color: var(--gc-text-primary);\n  font-size: 18px;\n  line-height: 1.1;\n}\n.gc-away-admin-focus {\n  padding: 10px 12px;\n  border: 1px solid rgba(250, 204, 21, 0.24);\n  border-radius: var(--gc-radius-card);\n  background: rgba(250, 204, 21, 0.08);\n  color: var(--gc-text-secondary);\n  font-size: 13px;\n}\n.gc-away-admin-focus strong {\n  color: var(--gc-text-primary);\n}\n.gc-away-admin-list {\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  overflow: hidden;\n  background: var(--gc-surface-1);\n}\n.gc-away-admin-row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  gap: 12px;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-away-admin-row:last-child {\n  border-bottom: 0;\n}\n.gc-away-admin-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(250, 204, 21, 0.18);\n  color: #8a6500;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n.gc-away-admin-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.gc-away-admin-row__main {\n  min-width: 0;\n}\n.gc-away-admin-row__top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.gc-away-admin-row__top strong {\n  color: var(--gc-text-primary);\n  font-size: 14px;\n  line-height: 1.2;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-away-admin-row__sub {\n  margin-top: 3px;\n  color: var(--gc-text-secondary);\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-away-admin-row__metric {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: var(--gc-text-secondary);\n  font-size: 11px;\n}\n.gc-away-admin-row__metric strong {\n  color: var(--gc-text-primary);\n  font-size: 15px;\n}\n.gc-away-admin-row__metric em {\n  font-style: normal;\n  color: #d6a500;\n}\n.gc-away-admin-badge {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #facc15;\n  color: #1f1a05;\n  font-size: 10px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n@media (max-width: 720px) {\n  .gc-away-admin-toolbar {\n    grid-template-columns: 1fr;\n  }\n  .gc-away-admin-stats {\n    grid-template-columns: 1fr;\n  }\n  .gc-away-admin-row {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n  .gc-away-admin-row__metric {\n    grid-column: 2;\n    text-align: left;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ForwardModal (and shared bits usable by other modals)\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-modal-backdrop-centered {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.gc-modal-shell {\n  background-color: var(--gc-surface-0);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-4);\n  width: 100%;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  overflow: hidden;\n}\n.gc-modal-shell-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-modal-shell-header__left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gc-modal-shell-header__icon { color: var(--gc-primary); }\n.gc-modal-shell-header__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n}\n.gc-modal-shell-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  color: var(--gc-text-tertiary);\n  display: flex;\n}\n.gc-modal-shell-body {\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.gc-modal-shell-footer {\n  padding: 14px 20px;\n  border-top: 1px solid var(--gc-divider);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.gc-error-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background-color: #fef2f2;\n  border-radius: var(--gc-radius-card);\n  color: #b91c1c;\n  font-size: 13px;\n}\n.gc-forward-quote {\n  padding: 12px;\n  border-left: 3px solid var(--gc-primary);\n  background-color: var(--gc-surface-2);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--gc-text-secondary);\n  max-height: 120px;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.gc-field-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gc-text-secondary);\n  margin-bottom: 6px;\n}\n.gc-input-card {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  padding: 8px 12px;\n  font-size: 14px;\n  color: var(--gc-text-primary);\n  background-color: var(--gc-surface-0);\n  outline: none;\n  font-family: var(--gc-font);\n}\n.gc-input-card.is-textarea {\n  resize: vertical;\n  line-height: var(--gc-line-height);\n  padding-bottom: 22px;\n}\n.gc-input-card.has-leading-icon {\n  padding-left: 32px;\n}\n.gc-input-wrap { position: relative; }\n.gc-input-leading-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--gc-text-tertiary);\n}\n.gc-input-counter {\n  position: absolute;\n  bottom: 8px;\n  right: 10px;\n  font-size: 11px;\n  color: var(--gc-text-disabled);\n}\n.gc-list-bordered {\n  max-height: 260px;\n  overflow-y: auto;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n}\n/* The forward picker's list, which must not collapse. It is the only\n   shrinkable item in a flex column, and `overflow-y: auto` makes its\n   min-height resolve to 0 -- so once the preview, caption and search exceed\n   the modal's 90vh the list was squeezed down to a single visible row with a\n   scrollbar. A row is ~57px, so this holds 5-6 of them, and it gives way on\n   a short window rather than pushing the footer off screen. */\n.gc-forward-list {\n  flex: 1 1 auto;\n  min-height: min(368px, 46vh);\n  max-height: min(420px, 52vh);\n}\n.gc-list-empty {\n  padding: 24px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: 13px;\n}\n\n/* ── Call people-picker (\"Add to call\" / \"New call\") ──────────────────────\n * A premium dark \"call sheet\": header + search pinned, ONLY the people list\n * scrolls, Call button pinned at the bottom. Rendered ABOVE the in-call\n * overlay (z 9999) so it stays fully interactive during a live call.\n * Self-contained dark palette → identical in light & dark themes.\n */\n.gc-callpick-backdrop {\n  z-index: 10050;                 /* above .cs-overlay (9999) and pill (9998) */\n  background-color: rgba(6, 11, 14, 0.62);\n}\n\n.gc-callpick.gc-modal-shell {\n  overflow: hidden;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  background:\n    radial-gradient(520px 360px at 50% -10%, rgba(37, 211, 102, 0.16), transparent 60%),\n    linear-gradient(180deg, #1f2c33 0%, #131f26 55%, #0b141a 100%);\n  box-shadow:\n    0 30px 80px rgba(0, 0, 0, 0.6),\n    0 0 0 1px rgba(0, 0, 0, 0.4);\n  color: #fff;\n}\n\n/* Header */\n.gc-callpick .gc-modal-shell-header {\n  padding: 16px 18px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n.gc-callpick__badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  color: #fff;\n  background: linear-gradient(145deg, #25d366, #0d9488);\n  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);\n}\n.gc-callpick .gc-modal-shell-header__title {\n  color: #fff;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n.gc-callpick__close {\n  color: rgba(255, 255, 255, 0.6);\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.gc-callpick__close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Search (pinned) */\n.gc-callpick__search {\n  padding: 14px 18px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.gc-callpick__search-icon { color: rgba(255, 255, 255, 0.45); left: 14px; }\n.gc-callpick__search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 11px 14px 11px 40px;\n  font-size: 14px;\n  font-family: var(--gc-font);\n  color: #fff;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 13px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n.gc-callpick__search-input::placeholder { color: rgba(255, 255, 255, 0.4); }\n.gc-callpick__search-input:focus {\n  border-color: rgba(37, 211, 102, 0.7);\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.18);\n}\n\n/* Selected chips */\n.gc-callpick__chips { display: flex; flex-wrap: wrap; gap: 6px; }\n.gc-callpick__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 9px 3px 4px;\n  border-radius: 999px;\n  border: 1px solid rgba(37, 211, 102, 0.4);\n  background: rgba(37, 211, 102, 0.16);\n  color: #eafff2;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: var(--gc-font);\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n.gc-callpick__chip:hover { background: rgba(37, 211, 102, 0.26); transform: translateY(-1px); }\n.gc-callpick__chip-name { line-height: 1; }\n.gc-callpick__chip-x { color: rgba(255, 255, 255, 0.6); }\n\n/* Scrolling people list — the single scroll container */\n.gc-callpick__list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 4px 10px 8px;\n}\n.gc-callpick__list::-webkit-scrollbar { width: 8px; }\n.gc-callpick__list::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.14);\n  border-radius: 8px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n.gc-callpick__list::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.24);\n  background-clip: padding-box;\n}\n\n.gc-callpick__empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 13px;\n}\n\n.gc-callpick__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 9px 11px;\n  border: none;\n  border-radius: 14px;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--gc-font);\n  transition: background 0.14s ease;\n}\n.gc-callpick__row:hover { background: rgba(255, 255, 255, 0.06); }\n.gc-callpick__row:active { background: rgba(255, 255, 255, 0.1); }\n.gc-callpick__row:disabled { opacity: 0.5; cursor: default; }\n.gc-callpick__row.is-selected { background: rgba(37, 211, 102, 0.15); }\n.gc-callpick__row-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.gc-callpick__row-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-callpick__row-sub {\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.5);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-callpick__check {\n  flex-shrink: 0;\n  width: 23px;\n  height: 23px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transition: background 0.14s ease, border-color 0.14s ease, transform 0.14s ease;\n}\n.gc-callpick__check.is-checked {\n  background: #25d366;\n  border-color: #25d366;\n  transform: scale(1.06);\n  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);\n}\n.gc-callpick__row-call {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #25d366;\n  background: rgba(37, 211, 102, 0.16);\n  opacity: 0;\n  transition: opacity 0.14s ease;\n}\n.gc-callpick__row:hover .gc-callpick__row-call { opacity: 1; }\n\n/* Footer */\n.gc-callpick__footer {\n  padding: 12px 18px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n.gc-callpick__confirm {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  border: none;\n  border-radius: 14px;\n  font-size: 14.5px;\n  font-weight: 700;\n  font-family: var(--gc-font);\n  color: #fff;\n  cursor: pointer;\n  background: linear-gradient(145deg, #25d366, #10b981);\n  box-shadow: 0 10px 24px rgba(37, 211, 102, 0.32);\n  transition: filter 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n.gc-callpick__confirm:hover:not(:disabled) { filter: brightness(1.05); transform: translateY(-1px); }\n.gc-callpick__confirm:active:not(:disabled) { transform: translateY(0); }\n.gc-callpick__confirm:disabled {\n  cursor: default;\n  color: rgba(255, 255, 255, 0.55);\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n.gc-forward-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  width: 100%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: var(--gc-font);\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-forward-option.is-selected { background: var(--gc-primary-container); }\n.gc-forward-option.is-disabled { cursor: not-allowed; opacity: 0.5; }\n.gc-checkbox {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 1.5px solid var(--gc-border);\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gc-checkbox.is-checked {\n  border-color: var(--gc-primary);\n  background-color: var(--gc-primary);\n  color: white;\n}\n.gc-forward-option__name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-forward-option__type {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n}\n.gc-btn-outline-card {\n  padding: 8px 18px;\n  border-radius: var(--gc-radius-card);\n  border: 1px solid var(--gc-border);\n  background: none;\n  font-size: 14px;\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n  font-family: var(--gc-font);\n}\n.gc-btn-primary-card {\n  padding: 8px 20px;\n  border-radius: var(--gc-radius-card);\n  border: none;\n  background-color: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--gc-font);\n}\n.gc-btn-primary-card:disabled,\n.gc-btn-primary-card.is-disabled {\n  background-color: var(--gc-surface-3);\n  color: var(--gc-text-disabled);\n  cursor: not-allowed;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   NewConvModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-new-conv-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 29, 20, 0.42);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  z-index: 1000;\n  padding: 28px 16px;\n}\n.gc-new-conv-modal {\n  background: var(--gc-surface-0);\n  border-radius: 16px;\n  width: min(480px, calc(100vw - 24px));\n  font-family: var(--gc-font);\n  box-shadow: 0 24px 56px rgba(15, 29, 20, 0.18), 0 6px 16px rgba(15, 29, 20, 0.08);\n  border: 1px solid var(--gc-border);\n  overflow: hidden;\n  max-height: min(680px, calc(100vh - 32px));\n  display: flex;\n  flex-direction: column;\n}\n.gc-new-conv-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-new-conv-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 13px;\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gc-new-conv-title {\n  margin: 0;\n  font-size: 20px;\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  letter-spacing: 0;\n  color: var(--gc-text-primary);\n}\n.gc-new-conv-subtitle {\n  font-size: 13px;\n  color: var(--gc-text-tertiary);\n  margin-top: 3px;\n}\n.gc-new-conv-close {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: none;\n  background: var(--gc-surface-2);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gc-text-secondary);\n}\n.gc-new-conv-body {\n  padding: 18px 22px 20px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n.gc-new-conv-segmented-wrap { margin-bottom: 16px; }\n.gc-new-conv-segmented-wrap .gc-segmented-pill {\n  padding: 10px 12px;\n  font-size: 13px;\n}\n.gc-input-pill {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--gc-border);\n  border-radius: 12px;\n  font-size: 14.5px;\n  box-sizing: border-box;\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font);\n  outline: none;\n}\n.gc-input-pill.has-leading-icon { padding-left: 40px; }\n.gc-input-pill.is-invalid {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.08);\n}\n.gc-new-conv-group-setup {\n  display: grid;\n  grid-template-columns: 180px minmax(0, 1fr);\n  gap: 12px;\n  align-items: stretch;\n  margin-bottom: 14px;\n}\n.gc-new-conv-group-photo-row {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n  padding: 10px 12px;\n  border: 1px solid var(--gc-border);\n  border-radius: 13px;\n  background: var(--gc-surface-1);\n}\n.gc-new-conv-photo-button {\n  position: relative;\n  flex-shrink: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n.gc-new-conv-photo-button__badge {\n  position: absolute;\n  right: -3px;\n  bottom: -3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid var(--gc-surface-1);\n  background: var(--gt-accent, #1f4d3f);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gc-new-conv-photo-hint {\n  min-width: 0;\n  color: var(--gc-text-tertiary);\n  font-size: 12.5px;\n  line-height: 1.3;\n}\n.gc-new-conv-group-fields {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  min-width: 0;\n}\n.gc-new-conv-group-description {\n  min-height: 48px;\n  max-height: 76px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  resize: vertical;\n}\n.gc-new-conv-name-error {\n  margin: 6px 4px 0;\n  font-size: 12px;\n  color: #dc2626;\n  line-height: 1.35;\n}\n.gc-input-pill-wrap {\n  position: relative;\n  margin-bottom: 14px;\n}\n.gc-input-pill-wrap__icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--gc-text-tertiary);\n  pointer-events: none;\n}\n.gc-user-list {\n  max-height: clamp(260px, 42vh, 360px);\n  overflow-y: auto;\n  margin: 0 -6px;\n  padding: 2px 6px;\n}\n.gc-user-list__loading,\n.gc-user-list__empty {\n  text-align: center;\n  padding: 34px 0;\n  font-size: 13px;\n  color: var(--gc-text-tertiary);\n}\n.gc-user-list__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 30px 0;\n}\n/* External chat: divider above partner-company people in the picker. */\n/* Internal / external filter above the people list in New conversation. */\n.gc-scope-filter {\n  display: flex;\n  gap: 6px;\n  margin: 8px 0 2px;\n}\n.gc-scope-filter__btn {\n  flex: 1;\n  padding: 5px 8px;\n  /* \"Other companies\" wraps mid-phrase at 375px and makes every chip 46px\n     tall. Measured on a phone viewport: nowrap fits all three in 302px of\n     318px, so flex just hands the longest label the extra width. */\n  white-space: nowrap;\n  font-size: 11.5px;\n  font-weight: 500;\n  border-radius: 999px;\n  border: 1px solid var(--gc-border-strong);\n  background: transparent;\n  color: var(--gc-text-tertiary);\n  cursor: pointer;\n}\n.gc-scope-filter__btn:hover { color: var(--gc-text-primary); }\n/* --gc-primary / --gc-on-primary, not --gc-accent-soft: the accent tokens are\n   declared in :root and [data-theme=\"hc\"] but NOT in [data-theme=\"dark\"], so\n   in dark mode the pale :root mint stayed behind near-white text and the label\n   vanished. --gc-on-primary exists precisely to be legible on --gc-primary,\n   and it is what .gc-presence-filter-chip.is-active already uses. */\n.gc-scope-filter__btn.is-on {\n  background: var(--gc-primary);\n  border-color: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-weight: 600;\n}\n\n/* On a phone the org badge and the subtitle say the same thing, and the badge\n   costs 111px of a 351px row -- measured at 375px, it squeezed \"Acme Logistics\n   Private Limited\" down to 74px. Drop the badge there and let the subtitle\n   spell the organisation out, which is the whole point of showing it. */\n@media (max-width: 480px) {\n  .gc-user-option .gc-org-badge { display: none; }\n}\n\n/* A group picker lists colleagues and people at other organisations in one\n   scroll, so each run of rows says which it is. */\n.gc-user-list__section {\n  padding: 8px 10px 4px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n}\n\n/* The people picked for a group. They are shown as chips because the two\n   halves of the directory scroll independently -- and the external half is\n   re-queried on every keystroke -- so a pick can easily be off screen. */\n.gc-new-conv-picked {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 8px 0 2px;\n}\n.gc-new-conv-picked__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  padding: 4px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--gc-border-strong);\n  background: var(--gc-surface-2, transparent);\n  color: var(--gc-text-primary);\n  font-size: 11.5px;\n  cursor: pointer;\n}\n.gc-new-conv-picked__chip:hover { border-color: var(--gc-primary); }\n.gc-new-conv-picked__name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 140px;\n}\n/* The company is what tells two same-named people apart, so it rides along on\n   the chip rather than only on the row that is no longer visible. */\n.gc-new-conv-picked__org {\n  color: var(--gc-text-tertiary);\n  font-size: 10.5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 110px;\n}\n\n/* External results are paged: the platform is bigger than one company. */\n.gc-user-list__more {\n  display: block;\n  width: 100%;\n  padding: 9px;\n  margin-top: 4px;\n  font-size: 12px;\n  background: transparent;\n  border: 0;\n  color: var(--gc-text-tertiary);\n  cursor: pointer;\n}\n.gc-user-list__more:hover:not(:disabled) { color: var(--gc-text-primary); }\n.gc-user-list__more:disabled { cursor: default; opacity: 0.6; }\n\n.gc-user-list__section-heading {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n  padding: 10px 8px 4px;\n  border-top: 1px solid var(--gc-border-subtle, var(--gc-border-strong));\n  margin-top: 6px;\n}\n.gc-user-option {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  cursor: pointer;\n  background: transparent;\n  transition: background 160ms ease;\n}\n.gc-user-option:hover { background: var(--gc-surface-2); }\n.gc-user-option.is-selected,\n.gc-user-option.is-selected:hover { background: var(--gc-primary-container); }\n.gc-user-option__name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font-display);\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-user-option__sub {\n  font-size: 12.5px;\n  color: var(--gc-text-tertiary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 1px;\n}\n.gc-user-option__check {\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  border: 2px solid var(--gc-border);\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 160ms ease;\n}\n.gc-user-option__check.is-on {\n  border-color: var(--gc-primary);\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n}\n.gc-hidden-input { display: none; }\n.gc-new-conv-footer {\n  padding: 14px 22px;\n  border-top: 1px solid var(--gc-divider);\n  background: var(--gc-surface-1);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.gc-new-conv-footer__hint {\n  font-size: 12.5px;\n  color: var(--gc-text-tertiary);\n}\n.gc-new-conv-submit {\n  margin-left: auto;\n  padding: 11px 22px;\n  border: none;\n  border-radius: 12px;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: var(--gc-font-display);\n  letter-spacing: 0;\n  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);\n  transition: opacity 180ms ease;\n}\n.gc-new-conv-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n@media (max-width: 520px) {\n  .gc-new-conv-backdrop {\n    padding: 18px 10px;\n  }\n\n  .gc-new-conv-header {\n    gap: 12px;\n    padding: 16px;\n  }\n\n  .gc-new-conv-title {\n    font-size: 18px;\n  }\n\n  .gc-new-conv-subtitle {\n    font-size: 12px;\n  }\n\n  .gc-new-conv-body {\n    padding: 16px;\n  }\n\n  .gc-new-conv-group-setup {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .gc-user-list {\n    max-height: clamp(220px, 40vh, 320px);\n  }\n\n  .gc-new-conv-footer {\n    padding: 12px 16px;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ReminderModal (amber accent variant)\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-reminder-icon { color: #f59e0b; }\n.gc-reminder-quote {\n  padding: 10px;\n  border-left: 3px solid #f59e0b;\n  background-color: var(--gc-surface-2);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--gc-text-secondary);\n  max-height: 80px;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.gc-preset-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n.gc-preset-btn {\n  padding: 10px 12px;\n  border-radius: var(--gc-radius-card);\n  border: 1px solid var(--gc-border);\n  background-color: var(--gc-surface-0);\n  cursor: pointer;\n  text-align: left;\n  font-family: var(--gc-font);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.gc-preset-btn.is-active {\n  border-color: var(--gc-primary);\n  background-color: var(--gc-primary-container);\n}\n.gc-preset-btn__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n}\n.gc-preset-btn__time {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n}\n.gc-btn-amber {\n  padding: 8px 20px;\n  border-radius: var(--gc-radius-card);\n  border: none;\n  background-color: #f59e0b;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--gc-font);\n}\n.gc-btn-amber:disabled,\n.gc-btn-amber.is-disabled {\n  background-color: var(--gc-surface-3);\n  color: var(--gc-text-disabled);\n  cursor: not-allowed;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   RemindersList\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-reminders-aside {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  width: 380px;\n  max-width: 100vw;\n  background-color: var(--gc-surface-0);\n  border-left: 1px solid var(--gc-divider);\n  box-shadow: var(--gc-elev-3);\n  z-index: 55;\n  display: flex;\n  flex-direction: column;\n}\n.gc-reminders-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-reminders-header__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n}\n.gc-reminders-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px;\n}\n.gc-reminders-state {\n  padding: 30px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n}\n.gc-reminders-empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.gc-reminders-empty__icon {\n  margin: 0 auto 10px;\n  opacity: 0.4;\n  display: block;\n}\n.gc-reminders-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.gc-reminder-card {\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  padding: 12px;\n  background-color: var(--gc-surface-0);\n}\n.gc-reminder-edit-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.gc-edit-input {\n  border: 1px solid var(--gc-border);\n  border-radius: 6px;\n  padding: 6px 8px;\n  font-size: 13px;\n}\n.gc-edit-input.is-textarea { resize: vertical; }\n.gc-edit-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n.gc-btn-mini-outline {\n  padding: 4px 10px;\n  font-size: 12px;\n  border: 1px solid var(--gc-border);\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.gc-btn-mini-primary {\n  padding: 4px 10px;\n  font-size: 12px;\n  border: none;\n  background: var(--gc-primary);\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.gc-reminder-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n.gc-reminder-card__when {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #b45309;\n  font-size: 12px;\n  font-weight: 600;\n}\n.gc-reminder-card__actions {\n  display: flex;\n  gap: 2px;\n}\n.gc-icon-action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  color: var(--gc-text-tertiary);\n  display: flex;\n}\n.gc-icon-action-btn.is-danger { color: #b91c1c; }\n.gc-reminder-card__note {\n  font-size: 13px;\n  color: var(--gc-text-primary);\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n.gc-reminder-card__meta {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n}\n.gc-reminder-card__jump {\n  background: none;\n  border: none;\n  color: var(--gc-primary);\n  cursor: pointer;\n  font-size: 11px;\n  margin-left: 8px;\n  padding: 0;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TranslatePanel\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-translate-panel {\n  width: 280px;\n  background-color: var(--gc-surface-0);\n  border-radius: 12px;\n  box-shadow: var(--gc-elev-3);\n  border: 1px solid var(--gc-border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.gc-translate-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-translate-header__title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n}\n.gc-translate-header__icon { color: var(--gc-primary); }\n.gc-translate-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  color: var(--gc-text-tertiary);\n  display: flex;\n  align-items: center;\n  transition: background var(--gc-transition-fast);\n}\n.gc-translate-close:hover { background: var(--gc-surface-2); }\n.gc-translate-lang-row {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-translate-lang-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--gc-text-tertiary);\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.gc-translate-select {\n  width: 100%;\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  padding: 6px 10px;\n  font-size: 13px;\n  color: var(--gc-text-primary);\n  background-color: var(--gc-surface-0);\n  outline: none;\n  cursor: pointer;\n  font-family: var(--gc-font);\n}\n.gc-translate-content {\n  padding: 12px 14px;\n  min-height: 72px;\n}\n.gc-translate-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--gc-text-tertiary);\n  font-size: 13px;\n}\n.gc-translate-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  color: var(--gc-mention-channel-text);\n  font-size: 13px;\n}\n.gc-translate-text {\n  margin: 0;\n  font-size: 13px;\n  line-height: var(--gc-line-height);\n  color: var(--gc-text-primary);\n  word-break: break-word;\n}\n.gc-translate-original-wrap {\n  border-top: 1px solid var(--gc-divider);\n}\n.gc-translate-original-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font);\n  transition: background var(--gc-transition-fast);\n}\n.gc-translate-original-toggle:hover { background: var(--gc-surface-1); }\n.gc-translate-original-text {\n  margin: 0;\n  padding: 0 14px 12px;\n  font-size: 12px;\n  line-height: var(--gc-line-height);\n  color: var(--gc-text-tertiary);\n  word-break: break-word;\n  background-color: var(--gc-surface-1);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   SummarizeModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-summarize-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.gc-summarize-modal {\n  background-color: var(--gc-surface-0);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-4);\n  width: 100%;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  max-height: 85vh;\n  overflow: hidden;\n}\n.gc-summarize-controls {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--gc-divider);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.gc-style-toggle {\n  display: flex;\n  gap: 2px;\n  padding: 3px;\n  background-color: var(--gc-surface-2);\n  border-radius: 8px;\n  flex: 1;\n}\n.gc-style-toggle__btn {\n  flex: 1;\n  padding: 5px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: var(--gc-font);\n  background-color: transparent;\n  color: var(--gc-text-tertiary);\n  box-shadow: none;\n  transition: all var(--gc-transition-fast);\n  text-transform: capitalize;\n}\n.gc-style-toggle__btn.is-active {\n  background-color: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  box-shadow: var(--gc-elev-1);\n}\n.gc-btn-generate {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  border-radius: var(--gc-radius-card);\n  border: none;\n  background-color: var(--gc-primary);\n  color: var(--gc-on-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: var(--gc-font);\n  white-space: nowrap;\n  transition: background var(--gc-transition-fast);\n}\n.gc-btn-generate:hover { background-color: var(--gc-primary-hover); }\n.gc-btn-generate:disabled,\n.gc-btn-generate.is-busy {\n  background-color: var(--gc-surface-3);\n  color: var(--gc-text-disabled);\n  cursor: not-allowed;\n}\n.gc-summarize-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.gc-error-pill-soft {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 14px;\n  background-color: var(--gc-mention-channel-bg);\n  border-radius: var(--gc-radius-card);\n  color: var(--gc-mention-channel-text);\n  font-size: 13px;\n}\n.gc-summarize-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  background-color: var(--gc-surface-1);\n  border-radius: var(--gc-radius-card);\n  border: 1px solid var(--gc-border);\n}\n.gc-skeleton-line {\n  height: 13px;\n  border-radius: 6px;\n  background-color: var(--gc-surface-3);\n  animation: gc-pulse 1.5s ease-in-out infinite;\n  width: var(--skeleton-w, 90%);\n}\n@keyframes gc-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.45; }\n}\n.gc-summary-result {\n  background-color: var(--gc-surface-1);\n  border-radius: var(--gc-radius-card);\n  border: 1px solid var(--gc-border);\n  overflow: hidden;\n}\n.gc-summary-result__body { padding: 14px 16px; }\n.gc-summary-result__text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--gc-text-primary);\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n.gc-summary-result__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  border-top: 1px solid var(--gc-divider);\n  background-color: var(--gc-surface-2);\n}\n.gc-summary-result__meta {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n}\n.gc-btn-copy {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-0);\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--gc-text-secondary);\n  font-family: var(--gc-font);\n  transition: all var(--gc-transition-fast);\n}\n.gc-btn-copy:hover { background: var(--gc-surface-3); }\n.gc-btn-copy.is-copied { color: var(--gc-online); }\n.gc-summarize-empty {\n  text-align: center;\n  padding: 32px 16px;\n  color: var(--gc-text-tertiary);\n  font-size: 13px;\n}\n.gc-summarize-empty strong { color: var(--gc-text-secondary); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   SearchSpotlight\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-spotlight-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 10vh;\n}\n.gc-spotlight-modal {\n  width: 600px;\n  max-width: calc(100vw - 32px);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-4);\n  background: var(--gc-surface-0);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.gc-spotlight-search {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--gc-border);\n  gap: 10px;\n}\n.gc-spotlight-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 16px;\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font);\n}\n.gc-spotlight-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--gc-border);\n  border-top-color: var(--gc-primary);\n  border-radius: 50%;\n  animation: gc-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n.gc-spotlight-kbd {\n  font-size: 11px;\n  padding: 2px 6px;\n  border: 1px solid var(--gc-border);\n  border-radius: 4px;\n  color: var(--gc-text-tertiary);\n  cursor: pointer;\n}\n.gc-spotlight-filters {\n  display: flex;\n  gap: 8px;\n  padding: 10px 16px;\n}\n.gc-spotlight-filters.has-results { border-bottom: 1px solid var(--gc-border); }\n.gc-spotlight-chip {\n  padding: 4px 12px;\n  border-radius: var(--gc-radius-pill);\n  border: none;\n  cursor: pointer;\n  font-size: var(--gc-font-size-sm);\n  font-weight: 400;\n  background: var(--gc-surface-2);\n  color: var(--gc-text-secondary);\n  transition: background var(--gc-transition-fast);\n}\n.gc-spotlight-chip.is-active {\n  font-weight: 600;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n}\n.gc-spotlight-results {\n  overflow-y: auto;\n  max-height: 380px;\n}\n.gc-spotlight-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 16px;\n  text-align: left;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background var(--gc-transition-fast);\n}\n.gc-spotlight-row.is-active { background: var(--gc-surface-2); }\n.gc-spotlight-row__title {\n  font-size: var(--gc-font-size-base);\n  font-weight: 600;\n  color: var(--gc-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-spotlight-row__ts {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  flex-shrink: 0;\n}\n.gc-spotlight-row__snippet {\n  font-size: var(--gc-font-size-sm);\n  color: var(--gc-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 1px;\n}\n.gc-spotlight-row__conv {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  margin-top: 1px;\n}\n.gc-spotlight-mark {\n  background: var(--gc-primary-container);\n  color: var(--gc-text-primary);\n  border-radius: 2px;\n}\n.gc-spotlight-empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: var(--gc-font-size-base);\n}\n.gc-spotlight-footer {\n  display: flex;\n  gap: 16px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--gc-border);\n  color: var(--gc-text-tertiary);\n  font-size: var(--gc-font-size-xs);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ConversationSettingsModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-settings-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.gc-settings-modal {\n  background: var(--gc-surface-0);\n  border-radius: 12px;\n  width: 480px;\n  max-width: 92vw;\n  padding: 24px;\n  font-family: var(--gc-font);\n  box-shadow: var(--gc-elev-3);\n  color: var(--gc-text-primary);\n}\n.gc-settings-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n.gc-settings-subtitle {\n  margin-top: 4px;\n  color: var(--gc-text-secondary);\n  font-size: 13px;\n}\n.gc-settings-block {\n  margin-top: 24px;\n  padding: 16px;\n  background: var(--gc-surface-1);\n  border-radius: 8px;\n}\n.gc-settings-label-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n.gc-settings-checkbox {\n  width: 18px;\n  height: 18px;\n}\n.gc-settings-feature-name { font-weight: 600; }\n.gc-settings-feature-hint {\n  font-size: 12px;\n  color: var(--gc-text-tertiary);\n}\n.gc-settings-sub-row {\n  margin-top: 12px;\n  padding-left: 30px;\n}\n.gc-settings-sub-label {\n  font-size: 13px;\n  color: var(--gc-text-secondary);\n}\n.gc-settings-select {\n  margin-top: 6px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--gc-outline);\n  border-radius: 6px;\n  background: var(--gc-surface-0);\n  font-size: 13px;\n}\n.gc-settings-error {\n  margin-top: 12px;\n  color: var(--gc-dnd);\n  font-size: 13px;\n}\n.gc-settings-actions {\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.gc-btn-outline-md {\n  padding: 8px 16px;\n  border: 1px solid var(--gc-outline);\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n}\n.gc-btn-filled-md {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  background: var(--gc-primary);\n  color: #fff;\n  cursor: pointer;\n}\n.gc-btn-filled-md:disabled { opacity: 0.6; }\n\n/* ── Phase 12: Cross-org admin lifecycle ────────────────────────────────── */\n.gc-settings-section { padding: 12px 0 4px; border-top: 1px solid var(--gc-outline); margin-top: 16px; }\n.gc-settings-section > h3 { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--gc-muted, #6b7280); margin: 0 0 10px; font-weight: 600; }\n.gc-settings-action { margin-top: 10px; display: flex; flex-direction: column; gap: 6px; }\n.gc-settings-action__error { color: var(--gc-dnd, #b91c1c); font-size: 12px; margin: 0; }\n.gc-settings-hint { color: var(--gc-muted, #6b7280); font-size: 12px; margin: 6px 0 0; }\n.gc-settings-label { font-size: 12px; color: var(--gc-muted, #6b7280); margin-bottom: 2px; }\n/* gc-btn base + variants (Phase 12 — do not duplicate existing gc-btn-* rules) */\n.gc-btn { padding: 6px 12px; border-radius: 6px; font-size: 13px; cursor: pointer; border: 1px solid transparent; display: inline-flex; align-items: center; gap: 4px; }\n.gc-btn--primary { background: var(--gc-primary, #2563eb); color: #fff; border-color: var(--gc-primary, #2563eb); }\n.gc-btn--primary:hover:not(:disabled) { background: var(--gc-primary-hover, #1d4ed8); border-color: var(--gc-primary-hover, #1d4ed8); }\n.gc-btn--primary:disabled { opacity: .5; cursor: default; }\n.gc-btn--danger-outline { border-color: var(--gc-dnd, #b91c1c); color: var(--gc-dnd, #b91c1c); background: transparent; }\n.gc-btn--danger-outline:hover:not(:disabled) { background: rgba(185, 28, 28, 0.06); }\n.gc-btn--ghost { border-color: var(--gc-outline, #e5e7eb); color: var(--gc-text-primary, #111827); background: transparent; }\n.gc-btn--ghost:hover { background: var(--gc-surface-1, #f3f4f6); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Toggle switch (shared)\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-toggle {\n  width: 40px;\n  height: 22px;\n  border-radius: var(--gc-radius-pill);\n  background-color: var(--gc-surface-3);\n  border: none;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  transition: background-color var(--gc-transition-fast);\n}\n.gc-toggle.is-on { background-color: var(--gc-primary); }\n.gc-toggle__thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: var(--gc-surface-0);\n  transition: left var(--gc-transition-fast);\n  box-shadow: var(--gc-elev-1);\n}\n.gc-toggle.is-on .gc-toggle__thumb { left: 21px; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   PollCreatorModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-poll-creator-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.gc-poll-creator-body {\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.gc-poll-option-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gc-poll-option-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--gc-text-tertiary);\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n}\n.gc-poll-option-remove:disabled {\n  cursor: not-allowed;\n  color: var(--gc-text-disabled);\n}\n.gc-poll-add-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px dashed var(--gc-border);\n  background: none;\n  border-radius: var(--gc-radius-card);\n  padding: 8px 12px;\n  font-size: 13px;\n  color: var(--gc-primary);\n  cursor: pointer;\n  width: 100%;\n  font-family: var(--gc-font);\n}\n.gc-poll-add-option:hover { background: var(--gc-primary-container); }\n.gc-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.gc-toggle-row__label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n}\n.gc-toggle-row__sub {\n  font-size: 12px;\n  color: var(--gc-text-tertiary);\n  margin-top: 1px;\n}\n.gc-expiry-segmented {\n  display: grid;\n  grid-template-columns: var(--expiry-cols, repeat(4, 1fr));\n  gap: 6px;\n  padding: 4px;\n  background: var(--gc-surface-2);\n  border-radius: var(--gc-radius-pill);\n  border: 1px solid var(--gc-border);\n}\n.gc-expiry-chip {\n  appearance: none;\n  border: none;\n  cursor: pointer;\n  padding: 7px 10px;\n  border-radius: var(--gc-radius-pill);\n  font-family: var(--gc-font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gc-text-secondary);\n  background: transparent;\n  box-shadow: none;\n  transition: background 160ms cubic-bezier(0.33, 1, 0.68, 1), color 160ms ease;\n}\n.gc-expiry-chip.is-active {\n  font-weight: 600;\n  color: var(--gc-on-primary);\n  background: var(--gc-primary);\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.12);\n}\n.gc-poll-creator-footer {\n  padding: 14px 20px;\n  border-top: 1px solid var(--gc-divider);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.gc-btn-outline-card:hover { background: var(--gc-surface-2); }\n.gc-btn-primary-card:hover:not(:disabled):not(.is-disabled) { background-color: var(--gc-primary-hover); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   PollVoterDetailModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-poll-voter-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(15, 29, 20, 0.55);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.gc-poll-voter-modal {\n  background-color: var(--gc-surface-0);\n  border-radius: var(--gc-radius-modal);\n  box-shadow: var(--gc-elev-4);\n  width: 100%;\n  max-width: 480px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--gc-font);\n}\n.gc-poll-voter-header {\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid var(--gc-divider);\n  position: relative;\n  background: linear-gradient(180deg, var(--gc-primary-container) 0%, var(--gc-surface-0) 100%);\n  flex-shrink: 0;\n}\n.gc-poll-voter-header__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n.gc-poll-voter-header__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: var(--gc-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 1px 3px rgba(15, 29, 20, 0.15);\n}\n.gc-poll-voter-header__eyebrow {\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--gc-text-tertiary);\n  margin-bottom: 2px;\n}\n.gc-poll-voter-header__question {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n  line-height: 1.35;\n  word-break: break-word;\n  /* A long question would otherwise eat the whole 85vh and starve the voter\n     list this modal exists to show. The full text stays readable in the chat\n     bubble behind the modal. */\n  display: -webkit-box;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.gc-poll-voter-header__meta {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--gc-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.gc-poll-voter-header__meta-strong { font-weight: 600; }\n.gc-poll-voter-header__meta-dot { color: var(--gc-text-disabled); }\n.gc-poll-voter-header__meta-anon {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--gc-text-tertiary);\n}\n.gc-poll-voter-close {\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid var(--gc-border);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  color: var(--gc-text-secondary);\n  display: flex;\n  flex-shrink: 0;\n  transition: background var(--gc-transition-fast);\n}\n.gc-poll-voter-close:hover { background: var(--gc-surface-2); }\n.gc-poll-voter-body {\n  padding: 14px 18px 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.gc-poll-voter-anon-notice {\n  padding: 24px 16px;\n  border-radius: var(--gc-radius-card);\n  border: 1px dashed var(--gc-border);\n  background: var(--gc-surface-1);\n  text-align: center;\n  color: var(--gc-text-tertiary);\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.gc-poll-voter-anon-icon { opacity: 0.6; }\n.gc-poll-voter-anon__title {\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n  margin-bottom: 2px;\n}\n.gc-poll-option-section {\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  overflow: hidden;\n  background: var(--gc-surface-0);\n  /* These sections are flex items of the column-flex .gc-poll-voter-body. With\n     the default flex-shrink:1 they compress to fit the modal instead of\n     overflowing it, and because they set overflow:hidden their automatic\n     minimum size resolves to 0 - so a 10-voter option silently collapsed and\n     clipped its own list while the body reported nothing to scroll. Holding\n     natural height is what lets the body's overflow-y:auto actually scroll. */\n  flex-shrink: 0;\n}\n.gc-poll-option-header {\n  position: relative;\n  padding: 10px 14px;\n}\n.gc-poll-option-header.has-voters { border-bottom: 1px solid var(--gc-divider); }\n.gc-poll-option-bar {\n  position: absolute;\n  inset: 0;\n  width: var(--poll-pct, 0%);\n  background: var(--gc-surface-2);\n  opacity: 0.7;\n  transition: width 480ms cubic-bezier(0.33, 1, 0.68, 1);\n}\n.gc-poll-option-bar.is-mine { background: var(--gc-primary-container); }\n.gc-poll-option-row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.gc-poll-option-text {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  line-height: 1.3;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-poll-option-text.is-mine { font-weight: 600; }\n.gc-poll-option-count {\n  font-size: 12px;\n  color: var(--gc-text-tertiary);\n  flex-shrink: 0;\n}\n.gc-poll-option-pct {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--gc-text-secondary);\n  min-width: 38px;\n  text-align: right;\n  flex-shrink: 0;\n}\n.gc-poll-option-pct.is-mine { color: var(--gc-primary); }\n.gc-poll-voter-list {\n  list-style: none;\n  margin: 0;\n  padding: 6px 0;\n  background: var(--gc-surface-1);\n}\n.gc-poll-voter-li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 14px;\n}\n.gc-poll-voter-avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--voter-bg, var(--gc-primary));\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px var(--gc-surface-1);\n}\n.gc-poll-voter-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gc-poll-voter-name.is-mine {\n  font-weight: 600;\n  color: var(--gc-primary);\n}\n.gc-poll-voter-me-pill {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--gc-primary);\n  background: var(--gc-primary-container);\n  padding: 2px 7px;\n  border-radius: var(--gc-radius-pill);\n}\n.gc-poll-no-votes {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: var(--gc-surface-1);\n  color: var(--gc-text-tertiary);\n  font-size: 12px;\n  font-style: italic;\n}\n.gc-poll-no-votes-icon { opacity: 0.5; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   ScheduleMeetingModal\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-sched-modal {\n  background: var(--gc-surface-0);\n  border-radius: 18px;\n  width: 760px;\n  max-width: 100%;\n  padding: 16px 20px 14px;\n  font-family: var(--gc-font);\n  box-shadow: 0 24px 56px rgba(15, 29, 20, 0.18), 0 6px 16px rgba(15, 29, 20, 0.08);\n  border: 1px solid var(--gc-border);\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n}\n.gc-sched-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.gc-sched-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gc-sched-title {\n  margin: 0;\n  font-size: 16px;\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gc-text-primary);\n}\n.gc-sched-subtitle {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n  margin-top: 1px;\n}\n.gc-sched-close {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: none;\n  background: var(--gc-surface-2);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gc-text-secondary);\n}\n.gc-sched-eyebrow {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary);\n  margin-bottom: 4px;\n  font-family: var(--gc-font-display);\n}\n.gc-sched-eyebrow.is-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.gc-sched-eyebrow__optional {\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--gc-text-disabled);\n}\n.gc-sched-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--gc-border);\n  border-radius: 11px;\n  font-size: 13px;\n  box-sizing: border-box;\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  font-family: var(--gc-font);\n  transition: border-color 200ms ease, box-shadow 200ms ease;\n}\n.gc-sched-input.is-textarea { resize: vertical; }\n.gc-sched-grid {\n  display: grid;\n  grid-template-columns: minmax(320px, 1.05fr) minmax(220px, 0.95fr);\n  gap: 12px;\n  margin-bottom: 10px;\n}\n.gc-sched-right-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.gc-sched-preview {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  flex-wrap: wrap;\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: var(--gc-surface-1);\n  border: 1px solid var(--gc-divider);\n  margin-top: auto;\n}\n.gc-sched-preview__icon { margin-top: 2px; }\n.gc-sched-preview__title {\n  color: var(--gc-text-secondary);\n  font-weight: 600;\n  font-size: 11.5px;\n}\n.gc-sched-preview__tz {\n  margin-top: 2px;\n  font-size: 10.5px;\n}\n.gc-sched-inline-cal {\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);\n}\n.gc-sched-cal-month {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--gc-text-primary);\n  letter-spacing: -0.01em;\n}\n.gc-sched-cal-nav {\n  color: var(--gc-text-secondary);\n  background: transparent;\n}\n.gc-sched-cal-nav:hover { background: var(--gc-surface-2); }\n.gc-sched-day-disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n.gc-sched-attendees-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  max-height: 88px;\n  overflow-y: auto;\n  border: 1px solid var(--gc-border);\n  border-radius: 11px;\n  padding: 8px;\n  background: var(--gc-surface-1);\n}\n.gc-sched-attendee-chip {\n  padding: 5px 11px;\n  border-radius: var(--gc-radius-pill);\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-0);\n  color: var(--gc-text-primary);\n  font-size: 12px;\n  cursor: pointer;\n  font-family: var(--gc-font-display);\n  font-weight: 600;\n  transition: all 180ms ease;\n}\n.gc-sched-attendee-chip.is-on {\n  border-color: var(--gc-primary);\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n}\n.gc-sched-attendees-empty {\n  font-size: 12px;\n  color: var(--gc-text-tertiary);\n  padding: 4px 2px;\n}\n.gc-sched-error {\n  color: var(--gc-dnd);\n  font-size: 12px;\n  margin-bottom: 8px;\n  padding: 6px 10px;\n  border-radius: 9px;\n  background: rgba(220, 38, 38, 0.08);\n  border: 1px solid rgba(220, 38, 38, 0.18);\n}\n.gc-sched-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.gc-sched-btn-cancel {\n  padding: 7px 16px;\n  border: 1px solid var(--gc-border);\n  border-radius: 11px;\n  background: var(--gc-surface-0);\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: var(--gc-font-display);\n  transition: background 180ms ease;\n}\n.gc-sched-btn-submit {\n  padding: 7px 16px;\n  border: none;\n  border-radius: 11px;\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 700;\n  font-family: var(--gc-font-display);\n  letter-spacing: 0.005em;\n  box-shadow: 0 2px 6px rgba(15, 29, 20, 0.10);\n  transition: opacity 180ms ease, transform 180ms ease;\n}\n.gc-sched-btn-submit:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   PollCard\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-poll-card {\n  /* Border + shadow dropped so the poll reads as one clean surface inside the\n     bubble, not a framed box nested in another frame. */\n  background: var(--gc-surface-1);\n  border: none;\n  border-radius: var(--gc-radius-card);\n  padding: 14px 16px;\n  max-width: 420px;\n  font-family: var(--gc-font);\n  box-shadow: none;\n}\n.gc-poll-card__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.gc-poll-card__icon {\n  color: var(--gc-primary);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.gc-poll-card__question {\n  font-weight: 600;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n  line-height: 1.4;\n}\n.gc-poll-card__chips {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n  flex-wrap: wrap;\n}\n.gc-poll-card__chip-closed {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n  background: var(--gc-surface-3);\n  padding: 1px 7px;\n  border-radius: var(--gc-radius-pill);\n  font-weight: 600;\n}\n.gc-poll-card__chip-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n}\n.gc-poll-kebab-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n.gc-poll-kebab-btn {\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gc-text-tertiary);\n  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);\n}\n.gc-poll-kebab-btn:hover,\n.gc-poll-kebab-btn.is-open {\n  background: var(--gc-surface-3);\n  color: var(--gc-text-secondary);\n}\n.gc-poll-kebab-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  box-shadow: var(--gc-elev-3);\n  padding: 4px;\n  min-width: 168px;\n  z-index: 20;\n  font-family: var(--gc-font);\n}\n.gc-poll-kebab-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  padding: 8px 10px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gc-text-primary);\n  text-align: left;\n  font-family: inherit;\n  transition: background var(--gc-transition-fast);\n}\n.gc-poll-kebab-item:hover { background: var(--gc-surface-2); }\n.gc-poll-kebab-item__icon { color: var(--gc-primary); }\n.gc-poll-kebab-item__count {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n  font-weight: 600;\n}\n.gc-poll-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.gc-poll-option {\n  position: relative;\n  width: 100%;\n  text-align: left;\n  background: var(--gc-surface-0);\n  border: 1.5px solid var(--gc-border);\n  border-radius: 6px;\n  padding: 8px 10px;\n  cursor: default;\n  overflow: hidden;\n  transition: border-color var(--gc-transition-fast);\n}\n.gc-poll-option.is-votable { cursor: pointer; }\n.gc-poll-option.is-selected,\n.gc-poll-option.is-voted { border-color: var(--gc-primary); }\n.gc-poll-option__bar {\n  position: absolute;\n  inset: 0;\n  background: var(--gc-primary-container);\n  border-radius: 5px;\n  transform-origin: left center;\n}\n.gc-poll-option__row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 1;\n}\n.gc-poll-option__check {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  border: 2px solid var(--gc-border-strong);\n  background: transparent;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--gc-transition-fast);\n}\n.gc-poll-option__check.is-single { border-radius: 50%; }\n.gc-poll-option__check.is-on {\n  border-color: var(--gc-primary);\n  background: var(--gc-primary);\n}\n.gc-poll-option__voted-mark {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--gc-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gc-poll-option__text {\n  flex: 1;\n  font-size: var(--gc-font-size-base);\n  color: var(--gc-text-primary);\n  font-weight: 400;\n  line-height: 1.3;\n}\n.gc-poll-option__text.is-voted { font-weight: 600; }\n.gc-poll-option__stats {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.gc-poll-option__stats-count {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n}\n.gc-poll-option__stats-pct {\n  font-size: var(--gc-font-size-sm);\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n  min-width: 34px;\n  text-align: right;\n}\n.gc-poll-option__stats-pct.is-voted { color: var(--gc-primary); }\n.gc-poll-option__voter-stack-wrap {\n  position: relative;\n  z-index: 1;\n}\n.gc-voter-stack {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n}\n.gc-voter-stack__avatars { display: flex; }\n.gc-voter-avatar {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--voter-bg, var(--gc-primary));\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid var(--gc-surface-0);\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.05);\n}\n.gc-voter-avatar.is-overflow {\n  background: var(--gc-surface-3);\n  color: var(--gc-text-secondary);\n}\n.gc-voter-avatar.is-stacked { margin-left: -5px; }\n.gc-voter-stack__label {\n  font-size: 11px;\n  color: var(--gc-text-tertiary);\n}\n.gc-poll-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n.gc-poll-card__footer-meta {\n  font-size: var(--gc-font-size-xs);\n  color: var(--gc-text-tertiary);\n}\n.gc-poll-vote-btn {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  border: none;\n  border-radius: var(--gc-radius-pill);\n  padding: 5px 16px;\n  font-size: var(--gc-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--gc-transition-fast), color var(--gc-transition-fast);\n  font-family: var(--gc-font);\n}\n.gc-poll-vote-btn:disabled,\n.gc-poll-vote-btn.is-disabled {\n  background: var(--gc-surface-3);\n  color: var(--gc-text-disabled);\n  cursor: not-allowed;\n}\n.gc-poll-update-btn {\n  background: none;\n  border: 1px solid var(--gc-primary);\n  color: var(--gc-primary);\n  border-radius: var(--gc-radius-pill);\n  padding: 4px 14px;\n  font-size: var(--gc-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  font-family: var(--gc-font);\n}\n.gc-poll-update-btn:disabled { cursor: not-allowed; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   MessageBubble\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-msg-deleted-pill {\n  padding: 7px 14px 7px 11px;\n  background: var(--gc-primary-container, #dcefe1);\n  border: 1px dashed var(--gc-primary, #1f2e23);\n  color: var(--gc-primary, #1f2e23);\n  font-family: var(--gc-font-display, \"Plus Jakarta Sans\", system-ui, sans-serif);\n  font-size: 11.5px;\n  letter-spacing: 0.01em;\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.06), inset 0 0 0 1px rgba(255, 255, 255, 0.3);\n  opacity: 0.92;\n}\n.gc-msg-deleted-glyph {\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.65);\n  color: var(--gc-primary, #1f2e23);\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(31, 46, 35, 0.18);\n}\n.gc-msg-deleted-text {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.gc-msg-deleted-text__primary {\n  font-weight: 600;\n  font-style: italic;\n}\n.gc-msg-deleted-text__attribution {\n  font-size: 9.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-weight: 700;\n  opacity: 0.62;\n  border-left: 1px solid currentColor;\n  padding-left: 8px;\n  margin-left: -2px;\n}\n.gc-msg-task-link {\n  color: var(--gc-accent-strong);\n  background: var(--gc-accent-soft);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n}\n.gc-msg-task-link__icon { color: var(--gc-accent); }\n\n/* ── Chat task card (Phase 9) ─────────────────────────────────────────────\n   Compact clickable card rendered inside task_link message bubbles.\n   Uses --gc-* tokens so it inherits all theme variants automatically.    */\n.gc-task-card {\n  border: 1px solid var(--gc-border, #e5e7eb);\n  border-radius: 10px;\n  padding: 12px 14px;\n  cursor: pointer;\n  background: var(--gc-surface-0, #ffffff);\n  transition: box-shadow 120ms ease, transform 120ms ease;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.gc-task-card:hover { box-shadow: 0 2px 10px rgba(0,0,0,.06); }\n.gc-task-card:focus-visible { outline: 2px solid var(--gc-focus, #3b82f6); outline-offset: 2px; }\n.gc-task-card--deleted { opacity: 0.55; cursor: default; }\n.gc-task-card__header { display: flex; gap: 8px; align-items: center; }\n.gc-task-card__status {\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: var(--gc-accent-soft, #eef2ff);\n  color: var(--gc-accent-strong, #4338ca);\n}\n.gc-task-card__status--open     { background: #dbeafe; color: #1d4ed8; }\n.gc-task-card__status--progress { background: #fef3c7; color: #b45309; }\n.gc-task-card__status--done     { background: #d1fae5; color: #047857; }\n.gc-task-card__status--blocked  { background: #fee2e2; color: #b91c1c; }\n.gc-task-card__priority { font-size: 11px; color: var(--gc-text-secondary, #6b7280); }\n.gc-task-card__title { font-weight: 600; font-size: 14px; line-height: 1.35; color: var(--gc-text-primary); }\n.gc-task-card__meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: var(--gc-text-secondary, #6b7280);\n}\n.gc-task-card__deleted { font-style: italic; color: var(--gc-text-secondary, #6b7280); font-size: 12px; }\n.gc-task-card__cta {\n  align-self: flex-start;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--gc-border, #e5e7eb);\n  background: transparent;\n  cursor: pointer;\n  color: var(--gc-text-primary);\n}\n.gc-task-card__cta:hover { background: var(--gc-surface-hover, #f3f4f6); }\n\n/* ── Org affiliation badge (Phase 10) ─────────────────────────────────────── */\n.gc-org-badge {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.4;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.gc-org-badge--md { font-size: 12px; padding: 2px 10px; }\n.gc-org-badge--default {\n  background: var(--gc-org-default-bg, #e0e7ff);\n  color: var(--gc-org-default-fg, #3730a3);\n}\n\n/* ── Cross-org roster panel (Phase 11) ────────────────────────────────────── */\n.gc-roster { padding: 12px 16px; display:flex; flex-direction:column; gap:16px; }\n.gc-roster__heading { display:flex; align-items:center; gap:6px; font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:0.04em; color: var(--gc-muted, #6b7280); margin: 0 0 8px 0; }\n.gc-roster__count { font-weight:500; color: var(--gc-muted, #6b7280); }\n.gc-roster__list { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:6px; }\n.gc-roster__row { display:flex; align-items:center; gap:8px; font-size:13px; }\n.gc-roster__avatar { width:24px; height:24px; border-radius:50%; object-fit:cover; }\n.gc-roster__name { flex:1; }\n.gc-roster__admin-chip { font-size:10px; padding:1px 6px; border-radius:9999px; background: var(--gc-admin-chip-bg, #fef3c7); color: var(--gc-admin-chip-fg, #92400e); font-weight:500; }\n\n/* External chat: start a 1:1 with a partner-org member from the roster. */\n.gc-roster__message-btn {\n  margin-left: auto;\n  flex: none;\n  font-size: 10.5px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  border: 1px solid var(--gc-border-strong);\n  background: var(--gc-surface-0);\n  color: var(--gc-text-secondary);\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease;\n}\n.gc-roster__message-btn:hover:not(:disabled) {\n  background: var(--gc-primary-container);\n  color: var(--gc-text-primary);\n}\n.gc-roster__message-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.gc-msg-selected { background: var(--gc-primary-container); }\n.gc-msg-row {\n  contain: layout paint;\n}\n.gc-msg-select-check {\n  background: var(--gc-surface-0);\n  border-color: var(--gc-border-strong);\n}\n.gc-msg-select-check.is-on {\n  background: var(--gc-primary);\n  border-color: var(--gc-primary);\n  box-shadow: var(--gc-elev-2);\n  transform: scale(1.1);\n}\n.gc-msg-sender-name {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gc-text-primary);\n}\n.gc-msg-sender-subtitle { color: var(--gc-text-tertiary); }\n.gc-msg-sender-btn { --tw-ring-color: var(--gc-primary); }\n.gc-msg-forwarded {\n  font-size: 11px;\n  font-style: italic;\n  color: var(--gc-text-tertiary);\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.gc-msg-forwarded.is-mine { color: rgba(247, 250, 246, 0.7); }\n.gc-msg-edited { color: var(--gc-text-tertiary); }\n.gc-msg-edited.is-mine { color: rgba(247, 250, 246, 0.65); }\n.gc-msg-content-mine { color: #f4faf6; }\n.gc-msg-content-theirs { color: var(--gc-text-primary); }\n\n/* Inline markdown emphasis inside chat bubbles.\n   Browser default <strong> = \"bolder\" which renders muddy on Electron when\n   there's no explicit weight set. Force the real 700 weight (Inter ships\n   700) and inherit the bubble's text color so bold-on-mine stays bright\n   off-white instead of falling back to the UA's default dark grey. */\n.gc-msg-content-mine strong,\n.gc-msg-content-mine b,\n.gc-msg-content-theirs strong,\n.gc-msg-content-theirs b {\n  font-weight: 700;\n  color: inherit;\n}\n/* Chat emphasis stays in the normal chat typeface. The project-wide\n   `.gt-themed em` rule (Fraunces serif italic, !important) is an editorial\n   accent meant for headings/labels — in a normal chat bubble it turns any\n   `*italic*` (or rich-text italic) into a jarring serif run. Override the\n   font-family here so bubble italics read as plain slanted Inter, not an\n   editorial flourish. Equal specificity to `.gt-themed em` but later in the\n   cascade, so the !important wins. */\n.gc-msg-content-mine em,\n.gc-msg-content-mine i,\n.gc-msg-content-theirs em,\n.gc-msg-content-theirs i,\n.chat-rich-render em,\n.chat-rich-render i,\n.chat-rich-render .ProseMirror em,\n.chat-rich-render .ProseMirror i {\n  font-family: var(--gc-font) !important;\n  font-feature-settings: normal;\n  font-style: italic;\n  color: inherit;\n}\n.gc-msg-content-mine code,\n.gc-msg-content-theirs code {\n  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.88em;\n  padding: 1px 5px;\n  border-radius: 4px;\n}\n.gc-msg-content-mine code {\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n}\n.gc-msg-content-theirs code {\n  background: rgba(15, 29, 20, 0.06);\n  color: var(--gc-text-primary);\n}\n.gc-msg-content-mine a.gc-msg-link,\n.gc-msg-content-theirs a.gc-msg-link {\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n}\n.gc-msg-content-mine a.gc-msg-link,\n.gc-msg-content-mine a.gc-msg-link * {\n  color: #ffffff !important;\n  text-decoration: underline !important;\n  text-decoration-color: #ffffff !important;\n  opacity: 1 !important;\n}\n.gc-msg-content-mine a.gc-msg-link:hover,\n.gc-msg-content-mine a.gc-msg-link:hover * {\n  opacity: 0.85 !important;\n}\n.gc-msg-content-theirs a.gc-msg-link {\n  color: var(--gc-text-link);\n  text-decoration-color: color-mix(in srgb, var(--gc-text-link) 60%, transparent);\n}\n.gc-msg-content-theirs a.gc-msg-link:hover {\n  text-decoration-color: var(--gc-text-link);\n  filter: brightness(0.9);\n}\n\n/* ── Long-message \"Read more\" clamp ─────────────────────────────\n   Collapses tall message bodies to ~300px with a soft fade-out and a\n   Read more / Show less toggle. Clamps by rendered height so it works\n   for both plain and rich (ProseMirror) bodies. */\n.gc-collapsible { position: relative; }\n.gc-collapsible__body { overflow: hidden; }\n.gc-collapsible__body.is-faded {\n  -webkit-mask-image: linear-gradient(180deg, #000 calc(100% - 42px), transparent);\n  mask-image: linear-gradient(180deg, #000 calc(100% - 42px), transparent);\n}\n.gc-collapsible__toggle {\n  display: inline-block;\n  margin-top: 5px;\n  padding: 1px 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gc-accent-strong);\n  background: none;\n  border: 0;\n  cursor: pointer;\n  transition: opacity 140ms ease;\n}\n.gc-collapsible__toggle:hover { text-decoration: underline; }\n.gc-collapsible__toggle:active { opacity: 0.7; }\n.gc-bubble-mine .gc-collapsible__toggle { color: #a7f3d0; }\n.gc-msg-thread-chip {\n  color: var(--gc-accent-strong);\n  background: var(--gc-accent-soft);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n}\n.gc-reaction-pill {\n  background: var(--gc-surface-0);\n  border: 1px solid var(--gc-border);\n  --tw-ring-color: var(--gc-primary);\n}\n.gc-reaction-pill:hover {\n  border-color: var(--gc-primary);\n  background: var(--gc-primary-container);\n}\n.gc-msg-time {\n  color: var(--gc-text-tertiary);\n  font-family: var(--gc-font-mono);\n  letter-spacing: 0.02em;\n}\n.gc-msg-seen-icon { color: var(--gc-accent-strong); }\n.gc-msg-action-bar {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid var(--gc-border);\n  box-shadow: 0 6px 18px rgba(15, 29, 20, 0.09), 0 1px 3px rgba(15, 29, 20, 0.05);\n  backdrop-filter: saturate(180%) blur(12px);\n  -webkit-backdrop-filter: saturate(180%) blur(12px);\n}\n/* Unified action-bar buttons (reply / quick-emoji / picker / more).\n   Replaces the old per-button hover:bg-gray-100 with a sage-tinted\n   hover so the whole toolbar reads as one Forest-Sage control.\n   NOTE: .gc-msg-action-bar is an always-light frosted surface in\n   every theme (like the emoji-pop / menu popovers), so these colours\n   are fixed for a light background rather than theme tokens — token\n   text would flip light in dark mode and vanish on the white bar. */\n.gc-msg-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #4a5852;\n  cursor: pointer;\n  transition: background 150ms ease, color 150ms ease, transform 150ms ease;\n}\n.gc-msg-action-btn:hover {\n  background: rgba(4, 120, 87, 0.10);\n  color: #047857;\n  transform: translateY(-1px);\n}\n.gc-msg-action-btn:active { transform: translateY(0) scale(0.92); }\n.gc-msg-action-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #047857;\n}\n/* Quick-emoji buttons render a glyph, not an icon — bump the type size */\n.gc-msg-action-btn--emoji { font-size: 17px; line-height: 1; }\n/* Reply is the primary action — always tinted, with a stronger hover */\n.gc-msg-action-btn--reply { color: #047857; }\n.gc-msg-action-btn--reply:hover { background: rgba(4, 120, 87, 0.16); }\n/* Hairline separators that split the bar into reply | react | utilities */\n.gc-msg-action-sep {\n  align-self: stretch;\n  width: 1px;\n  margin: 4px 2px;\n  background: rgba(15, 29, 20, 0.10);\n}\n.gc-msg-portal-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n}\n.gc-msg-emoji-pop {\n  z-index: 1001;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid var(--gc-border);\n  border-radius: 14px;\n  padding: 8px 10px;\n  display: flex;\n  gap: 6px;\n  white-space: nowrap;\n  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);\n  backdrop-filter: saturate(180%) blur(20px);\n  -webkit-backdrop-filter: saturate(180%) blur(20px);\n}\n.gc-msg-emoji-pop-btn {\n  font-size: 20px;\n  padding: 2px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: transform 160ms ease;\n}\n.gc-msg-emoji-pop-btn:hover { transform: scale(1.15); }\n.gc-msg-action-menu {\n  z-index: 1001;\n  width: 224px;\n  max-width: calc(100vw - 20px);\n  max-height: min(70vh, 420px);\n  overflow-y: auto;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid rgba(15, 29, 20, 0.08);\n  box-shadow: 0 16px 40px rgba(15, 29, 20, 0.14), 0 4px 12px rgba(15, 29, 20, 0.06);\n  backdrop-filter: saturate(180%) blur(20px);\n  -webkit-backdrop-filter: saturate(180%) blur(20px);\n}\n.gc-msg-menu-section {\n  color: var(--gc-text-disabled);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px 2px;\n}\n.gc-msg-menu-section.has-divider {\n  border-top: 1px solid var(--gc-divider);\n  padding-top: 5px;\n  margin-top: 2px;\n}\n.gc-msg-menu-section__leaf {\n  width: 5px;\n  height: 5px;\n}\n.gc-msg-menu-section__leaf.is-danger { background: var(--gc-dnd); }\n.gc-msg-menu-section__eyebrow { font-size: 9px; }\n.gc-msg-menu-item { color: var(--gc-text-primary); }\n.gc-msg-menu-item.is-delete { color: var(--gc-dnd); }\n.gc-msg-menu-item-icon { color: var(--gc-text-secondary); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TaskCreate\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-task-backdrop {\n  background: rgba(15, 29, 20, 0.32);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  z-index: 100;\n}\n.gc-task-modal-wrap { z-index: 101; }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TaskCreate modal — responsive sizing\n   Desktop: centred card, max-height 90dvh, scrolls internally.\n   Mobile : full-screen sheet. Header + body + footer become a flex column\n            so the body grows/shrinks to fit and the action footer (Next /\n            Submit) is always anchored at the bottom, in view. Respects the\n            device safe-area at the bottom.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-task-create-wrap {\n  height: 100vh;\n  height: 100dvh;\n}\n.gc-task-create-tray { min-height: 100dvh; }\n.gc-task-create-card {\n  max-height: 90vh;\n  max-height: 90dvh;\n}\n.gc-task-create-body {\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n@media (max-width: 767px) {\n  /* Mobile-only: card is a centered popup, NOT a full-screen sheet.\n     The inline style (maxHeight: 92dvh) takes precedence so the modal\n     fits the content with a small margin around it, rather than\n     filling the entire viewport. Border radius preserved for the\n     proper \"modal popup\" look. */\n  .gc-task-create-card {\n    max-height: 92dvh;\n  }\n  /* Footer respects the device safe-area on phones (e.g. iPhone home\n     indicator) so the Back / Next / Create buttons clear the OS bar. */\n  .gc-task-create-footer {\n    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n  /* Mobile-only: hide the \"FORM COMPLETION xx%\" progress block. Tailwind\n     `hidden md:block` was inconsistent across builds, so we belt-and-brace\n     with a dedicated class + !important to guarantee it doesn't show on\n     phones. The header is already tall (title + tabs); the progress bar\n     was eating space and pushing the action footer below the viewport. */\n  .gc-task-create-progress {\n    display: none !important;\n  }\n  /* Mobile-only: tighten header padding so the title block is compact and\n     leaves more room for form fields above the action footer. */\n  .gc-task-create-header-mobile {\n    padding: 14px 16px !important;\n  }\n  .gc-task-create-h2-mobile {\n    font-size: 18px !important;\n  }\n  /* Mobile-only: tabs become a single-row horizontal scroller so all four\n     (Basic / Details / Approval Chain / Checklist) are reachable without\n     wrapping into a second line. */\n  .gc-task-create-tabs {\n    padding: 6px 12px 0 12px !important;\n  }\n  .gc-task-create-tabs nav {\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    overflow-y: hidden !important;\n    scrollbar-width: none;\n  }\n  .gc-task-create-tabs nav::-webkit-scrollbar { display: none; }\n  .gc-task-create-tabs nav > button {\n    flex-shrink: 0 !important;\n    padding: 8px 14px !important;\n    font-size: 12.5px !important;\n    white-space: nowrap;\n  }\n  /* Mobile-only: form body padding tightened. */\n  .gc-task-create-body {\n    padding: 16px !important;\n  }\n  /* Mobile-only: stack footer button rows tightly. */\n  .gc-task-create-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n.gc-task-header {\n  background: linear-gradient(135deg, var(--gt-primary-container) 0%, var(--gt-surface-1) 100%);\n  border-bottom: 1px solid var(--gt-divider);\n}\n.gc-task-leaf-md { width: 10px; height: 10px; }\n.gc-task-h2 {\n  font-size: 22px;\n  color: var(--gt-text-primary);\n}\n.gc-task-h2-em { color: var(--gt-accent-strong); }\n.gc-task-page-sub-pad { margin-top: 4px; }\n.gc-task-progress-row { font-size: 11px; }\n.gc-task-progress-label { margin-bottom: 0; }\n.gc-task-progress-pct { color: var(--gt-accent-strong); }\n.gc-task-progress-fill-w { width: var(--task-progress, 0%); }\n.gc-task-step-border { border-bottom: 1px solid var(--gt-border); }\n.gc-task-step-btn {\n  padding: 10px 18px;\n  font-family: var(--gt-font-display);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n}\n.gc-task-step-btn.is-active {\n  border-bottom-color: var(--gt-primary);\n  background: var(--gt-surface-0);\n}\n\n/* ───────────────────────────────────────────────────────────────────\n   Mobile polish for the Create-New-Task sheet.\n\n   - .gc-task-input adds a brand-tinted focus ring (replacing the\n     hard blue ring) so the inputs match the rest of the green app.\n   - .gc-task-cta-mobile turns the primary \"Next / Create\" button\n     into a full-width brand-green pill on phones.\n   - .gc-task-step-btn pills get a stronger active state on phones\n     (filled chip vs. the desktop bottom-border).\n   ─────────────────────────────────────────────────────────────── */\n.gc-task-input:focus {\n  outline: none;\n  border-color: var(--gt-primary) !important;\n  box-shadow: 0 0 0 3px color-mix(in oklab, var(--gt-primary) 18%, transparent) !important;\n}\n.gc-task-cta-mobile {\n  background: linear-gradient(135deg, var(--gt-primary) 0%, var(--gt-primary-deep) 100%);\n  color: #ffffff;\n  border: none;\n}\n.gc-task-cta-mobile:hover {\n  background: linear-gradient(135deg, var(--gt-primary-hover) 0%, var(--gt-primary-deep) 100%);\n}\n.gc-task-cta-mobile:active {\n  transform: translateY(1px);\n}\n@media (max-width: 767px) {\n  /* Make the tab strip feel like proper iOS-style segmented chips on\n     phones: active tab is a filled brand-tinted pill instead of just\n     a bottom border. */\n  .gc-task-step-btn.is-active {\n    background: var(--gt-primary-container) !important;\n    color: var(--gt-primary-deep) !important;\n    border-bottom-color: transparent !important;\n    border-radius: 999px !important;\n    box-shadow: 0 1px 2px rgba(15, 45, 31, 0.08);\n  }\n  .gc-task-step-border {\n    border-bottom-color: transparent !important;\n    padding-bottom: 6px;\n  }\n}\n.gc-task-dropdown { z-index: 200; }\n.gc-task-z-120 { z-index: 120; }\n.gc-task-badge-blue {\n  background: linear-gradient(135deg, #60a5fa 0%, #2563eb 100%);\n  box-shadow: 0 4px 10px -2px rgba(37, 99, 235, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.35);\n}\n.gc-task-btn-blue {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  box-shadow: 0 6px 14px -4px rgba(37, 99, 235, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.30);\n}\n.gc-task-btn-add-first {\n  border-color: #93c5fd;\n  color: #2563eb;\n  background: #eff6ff;\n}\n.gc-task-blue-circle {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.gc-task-badge-orange {\n  background: linear-gradient(135deg, #fb923c 0%, #ea580c 100%);\n  box-shadow: 0 4px 10px -2px rgba(234, 88, 12, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.35);\n}\n.gc-task-btn-orange {\n  background: linear-gradient(135deg, #fb923c 0%, #ea580c 100%);\n  box-shadow: 0 6px 14px -4px rgba(234, 88, 12, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.30);\n}\n.gc-task-flow-prep {\n  background: #dbeafe;\n  border: 2px solid #2563eb;\n}\n.gc-task-flow-prep-text { color: #1d4ed8; }\n.gc-task-flow-line { background: #cbd5e1; }\n.gc-task-flow-approver {\n  background: #fed7aa;\n  border: 2px solid #ea580c;\n}\n.gc-task-flow-approver-text { color: #c2410c; }\n.gc-task-flow-done {\n  background: #bbf7d0;\n  border: 2px solid #10b981;\n}\n.gc-task-flow-done-text { color: #047857; }\n.gc-task-orange-circle {\n  background: #fed7aa;\n  color: #c2410c;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Chat.tsx — top-level page shell\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-section-label {\n  color: var(--gc-text-tertiary);\n}\n.gc-chat-shell {\n  font-family: var(--gc-font);\n  color: var(--gc-text-primary);\n}\n.gc-chat-sidebar {\n  background: var(--gc-surface-0);\n  border-right: 1px solid var(--gc-border);\n}\n.gc-chat-sidebar__header {\n  background: var(--gc-surface-0);\n  border-bottom: 1px solid var(--gc-divider);\n}\n.gc-chat-sidebar__eyebrow { color: var(--gc-text-tertiary); }\n.gc-chat-sidebar__title {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 26px;\n  color: var(--gc-text-primary);\n  letter-spacing: -0.03em;\n}\n.gc-chat-sidebar__title-em {\n  font-weight: 500;\n  color: var(--gc-primary);\n  font-size: 28px;\n}\n.gc-chat-logout-btn {\n  background: transparent;\n  color: var(--gc-text-secondary);\n  border: 1px solid var(--gc-border);\n}\n.gc-chat-sidebar-more-btn {\n  background: transparent;\n  border: 1px solid var(--gc-border);\n}\n.gc-chat-new-btn {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  box-shadow: var(--gc-elev-2);\n}\n.gc-chat-status-end-btn {\n  height: 28px;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 0 8px;\n  border-radius: 999px;\n  border: 1px solid rgba(245, 158, 11, 0.42);\n  background: rgba(245, 158, 11, 0.12);\n  color: #d97706;\n  font-size: 10.5px;\n  font-weight: 800;\n  white-space: nowrap;\n  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease, opacity 0.16s ease;\n}\n.gc-chat-status-end-btn:hover:not(:disabled) {\n  background: rgba(245, 158, 11, 0.18);\n  border-color: rgba(245, 158, 11, 0.58);\n  transform: translateY(-1px);\n}\n.gc-chat-status-end-btn.is-dnd {\n  border-color: rgba(220, 38, 38, 0.42);\n  background: rgba(220, 38, 38, 0.12);\n  color: #dc2626;\n}\n.gc-chat-status-end-btn.is-dnd:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.18);\n  border-color: rgba(220, 38, 38, 0.6);\n}\n.gc-chat-status-end-btn:disabled {\n  opacity: 0.62;\n  cursor: wait;\n  transform: none;\n}\n.gc-chat-search-icon { color: var(--gc-text-tertiary); }\n.gc-chat-main {\n  background: var(--gc-surface-1);\n}\n.gc-chat-header {\n  background: var(--gc-surface-0);\n  border-bottom: 1px solid var(--gc-divider);\n  box-shadow: var(--gc-elev-1);\n  min-height: 52px;\n}\n.gc-chat-header__group-icon {\n  background: linear-gradient(135deg, var(--gc-primary) 0%, var(--gc-primary-soft) 100%);\n  color: var(--gc-on-primary);\n}\n.gc-chat-header__name {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: -0.015em;\n  color: var(--gc-text-primary);\n}\n.gc-chat-header__sub {\n  color: var(--gc-text-tertiary);\n  font-size: 10px;\n}\n.gc-chat-e2ee-chip {\n  color: var(--gc-accent-strong);\n  background: var(--gc-accent-soft);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n.gc-chat-onleave-chip-sm {\n  font-size: 9px;\n  padding: 2px 6px;\n}\n.gc-away-control {\n  position: relative;\n  z-index: 35;\n}\n.gc-away-control.is-menu-item {\n  width: 100%;\n}\n.gc-away-control__triggers {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  position: relative;\n  z-index: 45;\n}\n.gc-away-control.is-menu-item .gc-away-control__triggers {\n  display: block;\n  width: 100%;\n}\n.gc-away-control__trigger {\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0 9px;\n  border-radius: 999px;\n  border: 1px solid rgba(245, 158, 11, 0.32);\n  background: rgba(245, 158, 11, 0.1);\n  color: #b45309;\n  font-size: 11px;\n  font-weight: 700;\n  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;\n}\n.gc-away-control__trigger:hover {\n  background: rgba(245, 158, 11, 0.16);\n  border-color: rgba(245, 158, 11, 0.48);\n  transform: translateY(-1px);\n}\n.gc-away-control__trigger.is-menu-item {\n  width: 100%;\n  height: auto;\n  min-height: 42px;\n  justify-content: flex-start;\n  gap: 10px;\n  padding: 11px 14px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: var(--gc-text-primary, #111827);\n  font-size: 13.5px;\n  font-weight: 500;\n  text-align: left;\n  transform: none;\n}\n.gc-away-control__trigger.is-menu-item:hover {\n  background: var(--gc-surface-2, #f3f4f6);\n  border-color: transparent;\n  transform: none;\n}\n.gc-away-control__trigger.is-disabled,\n.gc-away-control__trigger:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n}\n.gc-away-control__trigger.is-disabled:hover,\n.gc-away-control__trigger:disabled:hover {\n  background: transparent;\n  border-color: transparent;\n  transform: none;\n}\n.gc-away-control__trigger.is-menu-item.is-away svg {\n  color: #d97706;\n}\n.gc-away-control__trigger.is-dnd {\n  border-color: rgba(220, 38, 38, 0.34);\n  background: rgba(220, 38, 38, 0.1);\n  color: #b91c1c;\n}\n.gc-away-control__trigger.is-menu-item.is-dnd {\n  border-color: transparent;\n  background: transparent;\n  color: var(--gc-text-primary, #111827);\n}\n.gc-away-control__trigger.is-menu-item.is-dnd svg {\n  color: #dc2626;\n}\n.gc-away-control__trigger.is-dnd:hover {\n  background: rgba(220, 38, 38, 0.16);\n  border-color: rgba(220, 38, 38, 0.5);\n}\n.gc-away-control__trigger.is-menu-item.is-dnd:hover {\n  background: var(--gc-surface-2, #f3f4f6);\n  border-color: transparent;\n}\n.gc-away-control__trigger.is-active {\n  background: #f59e0b;\n  border-color: #fbbf24;\n  color: #111827;\n}\n.gc-away-control__trigger.is-menu-item.is-active {\n  background: var(--gc-surface-2, #f3f4f6);\n  color: var(--gc-text-primary, #111827);\n}\n.gc-away-control__trigger.is-dnd.is-active {\n  background: #dc2626;\n  border-color: #f87171;\n  color: #ffffff;\n}\n.gc-away-control__trigger.is-menu-item.is-dnd.is-active {\n  background: var(--gc-surface-2, #f3f4f6);\n  border-color: transparent;\n  color: var(--gc-text-primary, #111827);\n}\n.gc-away-popover {\n  position: absolute;\n  right: 0;\n  top: 36px;\n  z-index: 40;\n  width: min(280px, calc(100vw - 24px));\n  padding: 12px;\n  border: 1px solid var(--gc-border);\n  border-radius: 12px;\n  background: var(--gc-surface-0);\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);\n  transform-origin: top right;\n  animation: gc-away-popover-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n.gc-away-control.is-menu-item .gc-away-popover {\n  top: calc(100% + 8px);\n  right: 0;\n}\n.gc-away-popover__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  color: var(--gc-text);\n  font-size: 12px;\n  font-weight: 800;\n}\n.gc-away-popover__header button {\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  color: var(--gc-text-tertiary);\n}\n.gc-away-popover__header button:hover {\n  background: var(--gc-surface-2);\n  color: var(--gc-text);\n}\n.gc-away-field {\n  display: grid;\n  gap: 5px;\n  margin-top: 8px;\n  color: var(--gc-text-tertiary);\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.gc-away-field input,\n.gc-away-field textarea {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid var(--gc-border);\n  background: var(--gc-surface-1);\n  color: var(--gc-text);\n  font-size: 12px;\n  font-weight: 600;\n}\n.gc-away-field input {\n  height: 34px;\n  padding: 0 9px;\n}\n.gc-away-field textarea {\n  min-height: 68px;\n  padding: 8px 9px;\n  resize: vertical;\n  line-height: 1.35;\n}\n.gc-away-quick {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n  margin-top: 10px;\n}\n.gc-away-quick button {\n  height: 28px;\n  border-radius: 999px;\n  border: 1px solid rgba(245, 158, 11, 0.28);\n  background: rgba(245, 158, 11, 0.1);\n  color: #d97706;\n  font-size: 10.5px;\n  font-weight: 800;\n  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;\n}\n.gc-away-quick button:hover:not(:disabled) {\n  background: rgba(245, 158, 11, 0.18);\n  border-color: rgba(245, 158, 11, 0.44);\n  transform: translateY(-1px);\n}\n.gc-away-quick button:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n.gc-away-error {\n  margin-top: 9px;\n  color: #dc2626;\n  font-size: 11px;\n  font-weight: 600;\n}\n.gc-away-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 7px;\n  margin-top: 12px;\n}\n.gc-away-actions button {\n  height: 30px;\n  border-radius: 999px;\n  padding: 0 11px;\n  font-size: 11px;\n  font-weight: 800;\n}\n.gc-away-actions__end {\n  color: #b45309;\n  background: rgba(245, 158, 11, 0.12);\n}\n.gc-away-actions__save {\n  color: #ffffff;\n  background: #059669;\n}\n.gc-chat-meet-btn {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  border: 1px solid var(--gc-border-strong);\n  font-family: var(--gc-font-display);\n}\n.gc-chat-header-menu {\n  font-family: var(--gc-font);\n}\n.gc-chat-header-menu__emoji { font-size: 16px; }\n.gc-chat-header-menu__ttl {\n  color: #9aa0a6;\n}\n.gc-chat-header-menu__ttl.is-on { color: var(--gc-primary); }\n.gc-chat-bulk-banner {\n  background: var(--gc-primary-container);\n  color: var(--gc-primary);\n  border-bottom: 1px solid var(--gc-border);\n}\n.gc-chat-bulk-cancel { color: var(--gc-primary); }\n.gc-chat-stream {\n  background:\n    radial-gradient(circle at 0% 0%, rgba(220, 239, 225, 0.35) 0%, transparent 32%),\n    radial-gradient(circle at 100% 100%, rgba(236, 246, 238, 0.45) 0%, transparent 36%),\n    var(--gc-surface-1);\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n  contain: layout paint;\n}\n.gc-chat-poll-fallback {\n  background: var(--gc-surface-1);\n  border: 1px dashed var(--gc-border);\n  border-radius: var(--gc-radius-card);\n  padding: 10px 12px;\n  max-width: 380px;\n  font-size: 12px;\n  color: var(--gc-text-secondary);\n}\n.gc-chat-poll-fallback__title {\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n  margin-bottom: 4px;\n}\n.gc-chat-composer {\n  background: var(--gc-surface-0);\n  border-top: 1px solid var(--gc-divider);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Upload progress card — slides above the composer while an attachment is\n   uploading. Indeterminate shimmer while the percentage advances, then a\n   brief success state before the card slides out.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-upload-card-wrap {\n  background: var(--gc-surface-0);\n  animation: gc-upload-card-in 220ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n.gc-upload-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--gc-surface-2);\n  border: 1px solid var(--gc-border);\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04);\n  transition: background 220ms ease, border-color 220ms ease;\n}\n.gc-upload-card.is-done {\n  background: rgba(16, 185, 129, 0.10);\n  border-color: rgba(16, 185, 129, 0.30);\n}\n.gc-upload-card__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: var(--gc-accent-soft, rgba(16, 185, 129, 0.14));\n  color: var(--gc-accent-strong, #059669);\n  transition: background 220ms ease, color 220ms ease;\n}\n.gc-upload-card.is-done .gc-upload-card__icon {\n  background: rgba(16, 185, 129, 0.20);\n  color: #047857;\n}\n.gc-upload-card__body { min-width: 0; flex: 1; }\n.gc-upload-card__row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 5px;\n}\n.gc-upload-card__name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gc-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n.gc-upload-card__batch {\n  color: var(--gc-text-tertiary);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  margin-right: 2px;\n}\n.gc-upload-card__pct {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--gc-text-secondary);\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n.gc-upload-card__bar {\n  height: 4px;\n  border-radius: 9999px;\n  background: rgba(15, 29, 20, 0.08);\n  overflow: hidden;\n  position: relative;\n}\n.gc-upload-card__bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #34d399 0%, #10b981 50%, #059669 100%);\n  border-radius: 9999px;\n  transition: width 200ms ease-out;\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.15);\n  position: relative;\n}\n.gc-upload-card__bar-fill::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%);\n  animation: gc-upload-shimmer 1.4s linear infinite;\n}\n.gc-upload-card.is-done .gc-upload-card__bar-fill::after {\n  display: none;\n}\n.gc-upload-card__meta {\n  margin-top: 4px;\n  font-size: 10.5px;\n  color: var(--gc-text-tertiary);\n  font-variant-numeric: tabular-nums;\n}\n@keyframes gc-upload-card-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes gc-upload-shimmer {\n  0%   { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Document preview modal — fullscreen lightbox-style overlay that hosts a\n   Google Docs Viewer iframe so PDFs, XLS, DOC, PPT all preview the same way\n   without needing bucket CORS (Google's server fetches the file).\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-doc-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(15, 29, 20, 0.78);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  animation: gc-doc-modal-in 180ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n.gc-doc-modal {\n  width: min(1100px, 96vw);\n  height: min(820px, 92vh);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(15, 29, 20, 0.45);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.gc-doc-modal__bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: #f8faf9;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n.gc-doc-modal__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  min-width: 0;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-doc-modal__actions { display: flex; align-items: center; gap: 6px; }\n.gc-doc-modal__btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  color: #374151;\n  border: 1px solid transparent;\n  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;\n  cursor: pointer;\n}\n.gc-doc-modal__btn:hover {\n  background: rgba(15, 29, 20, 0.06);\n  border-color: rgba(15, 29, 20, 0.10);\n  color: #111827;\n}\n.gc-doc-modal__body {\n  flex: 1;\n  min-height: 0;\n  background: #f3f4f6;\n  position: relative;\n}\n.gc-doc-modal__iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: #ffffff;\n}\n.gc-doc-modal__loader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #6b7280;\n  font-size: 12.5px;\n  pointer-events: none;\n}\n.gc-doc-modal__empty {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  text-align: center;\n  padding: 24px;\n  color: #4b5563;\n  font-size: 13px;\n}\n.gc-doc-modal__primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: #059669;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 160ms ease, transform 160ms ease;\n}\n.gc-doc-modal__primary:hover {\n  background: #047857;\n  transform: translateY(-1px);\n}\n@keyframes gc-doc-modal-in {\n  from { opacity: 0; transform: scale(0.98); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n/* Hover overlay on the document card preview area — shows a \"Click to preview\"\n   prompt with an expand icon over the thumbnail/icon tile. */\n.gc-att-doc__hover {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: linear-gradient(180deg, rgba(15, 29, 20, 0.36) 0%, rgba(15, 29, 20, 0.62) 100%);\n  color: #ffffff;\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  opacity: 0;\n  transition: opacity 180ms ease;\n  pointer-events: none;\n  z-index: 1;\n}\n.gc-att-doc:hover .gc-att-doc__hover,\n.gc-att-doc:focus-visible .gc-att-doc__hover {\n  opacity: 1;\n}\n.gc-att-doc__hover svg {\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.30));\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Composer action sheet — mobile-only WhatsApp-style grid that opens above\n   the input row when the user taps the \"+\" trigger. Hosts the four actions\n   (Attach / Voice / Poll / Task) as large icon tiles.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-composer-sheet__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.18);\n  z-index: 30;\n  animation: gc-composer-sheet-fade 180ms ease both;\n}\n.gc-composer-sheet {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: calc(100% + 6px);\n  background: var(--gc-surface-0, #ffffff);\n  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));\n  border-radius: 16px;\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.05);\n  z-index: 31;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 6px;\n  padding: 14px 12px;\n  font-family: var(--gc-font);\n  animation: gc-composer-sheet-rise 200ms cubic-bezier(0.33, 1, 0.68, 1) both;\n}\n.gc-composer-sheet__tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 4px;\n  background: transparent;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background var(--gc-transition-fast, 160ms ease);\n}\n.gc-composer-sheet__tile:hover:not(:disabled),\n.gc-composer-sheet__tile:active:not(:disabled) {\n  background: var(--gc-surface-2, #f3f4f6);\n}\n.gc-composer-sheet__tile:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.gc-composer-sheet__icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gc-composer-sheet__icon.is-attach {\n  background: #dbeafe;\n  color: #2563eb;\n}\n.gc-composer-sheet__icon.is-voice {\n  background: #fee2e2;\n  color: #dc2626;\n}\n.gc-composer-sheet__icon.is-poll {\n  background: #dcefe1;\n  color: #047857;\n}\n.gc-composer-sheet__icon.is-task {\n  background: #fef3c7;\n  color: #b45309;\n}\n.gc-composer-sheet__label {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--gc-text-secondary, #4b5563);\n  letter-spacing: 0.01em;\n}\n\n@keyframes gc-composer-sheet-rise {\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes gc-composer-sheet-fade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n.gc-chat-textarea {\n  color: var(--gc-text-primary);\n  min-height: 34px;\n  max-height: 100px;\n}\n.gc-chat-send-btn {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  box-shadow: var(--gc-elev-2);\n}\n.gc-chat-add-members,\n.gc-chat-role-chip {\n  color: var(--gc-accent-strong);\n  background: var(--gc-accent-soft);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n}\n.gc-chat-profile-header {\n  background: var(--gc-primary-container);\n  border-bottom: 1px solid var(--gc-border);\n}\n.gc-profile-modal-backdrop {\n  background: rgba(3, 7, 12, 0.58);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: gc-profile-backdrop-in 220ms ease-out both;\n}\n.gc-profile-modal-shell {\n  --gc-profile-genie-dx: 0px;\n  --gc-profile-genie-dy: -18px;\n  --gc-profile-genie-scale-x: 0.2;\n  --gc-profile-genie-scale-y: 0.08;\n  position: fixed;\n  inset: 0;\n  margin: auto;\n  width: min(520px, calc(100vw - 32px));\n  height: fit-content;\n  max-height: min(720px, calc(100dvh - 48px));\n  overflow: hidden;\n  border: 1px solid var(--gc-border);\n  border-radius: 28px;\n  box-shadow:\n    0 38px 110px rgba(0, 0, 0, 0.42),\n    0 12px 34px rgba(0, 0, 0, 0.22);\n  transform: translate3d(0, 0, 0);\n  transform-origin: center center;\n  will-change: transform, opacity, filter, border-radius;\n  animation: gc-profile-genie-in 440ms cubic-bezier(0.18, 0.98, 0.2, 1) both;\n}\n@keyframes gc-profile-backdrop-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n@keyframes gc-profile-genie-in {\n  0% {\n    opacity: 0.86;\n    transform:\n      translate3d(var(--gc-profile-genie-dx), var(--gc-profile-genie-dy), 0)\n      scaleX(var(--gc-profile-genie-scale-x))\n      scaleY(var(--gc-profile-genie-scale-y))\n      skewY(-8deg);\n    border-radius: 999px;\n    filter: blur(0.8px);\n  }\n  54% {\n    opacity: 1;\n    transform: translate3d(-16px, 7px, 0) scaleX(1.045) scaleY(0.99) skewY(1.6deg);\n    border-radius: 34px;\n    filter: blur(0);\n  }\n  80% {\n    opacity: 1;\n    transform: translate3d(4px, -2px, 0) scaleX(0.992) scaleY(1.006);\n    border-radius: 26px;\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scaleX(1) scaleY(1);\n    border-radius: 28px;\n  }\n}\n@media (max-width: 520px) {\n  .gc-profile-modal-shell {\n    width: calc(100vw - 24px);\n    max-height: calc(100dvh - 24px);\n    border-radius: 22px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .gc-profile-modal-backdrop,\n  .gc-profile-modal-shell {\n    animation: none;\n    will-change: auto;\n  }\n  .gc-profile-modal-shell {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Mobile-only top header — sits above the Messages sidebar on phone\n   viewports. Shows \"TeamLio Chat\" + chat/task notification bells + a\n   3-dot kebab menu with a Profile option. Hidden on desktop.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-mobile-top-header { display: none; }\n\n@media (max-width: 767px) {\n  .gc-mobile-top-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 56px;\n    padding: 0 12px 0 16px;\n    background: var(--gc-primary, #1f2e23);\n    color: var(--gc-on-primary, #f7faf6);\n    flex-shrink: 0;\n    position: sticky;\n    top: 0;\n    z-index: 30;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  }\n}\n\n.gc-mobile-top-header__title {\n  font-family: var(--gc-font-display);\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: -0.01em;\n  color: inherit;\n}\n.gc-mobile-top-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.gc-mobile-top-header__icon-btn {\n  position: relative;\n  width: 38px;\n  height: 38px;\n  border-radius: 9999px;\n  background: transparent;\n  border: none;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background var(--gc-transition-fast, 160ms ease);\n  padding: 0;\n}\n.gc-mobile-top-header__icon-btn:hover,\n.gc-mobile-top-header__icon-btn.is-open {\n  background: rgba(255, 255, 255, 0.12);\n}\n.gc-mobile-top-header__badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 9999px;\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 9.5px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--gc-primary, #1f2e23);\n}\n\n.gc-mobile-top-header__menu-wrap { position: relative; }\n.gc-mobile-top-header__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 180px;\n  background: var(--gc-surface-0, #ffffff);\n  color: var(--gc-text-primary, #111827);\n  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));\n  border-radius: 12px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);\n  z-index: 60;\n  overflow: hidden;\n  font-family: var(--gc-font);\n}\n.gc-mobile-top-header__menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--gc-text-primary, #111827);\n  text-align: left;\n  font-family: inherit;\n  transition: background var(--gc-transition-fast, 160ms ease);\n}\n.gc-mobile-top-header__menu-item:hover {\n  background: var(--gc-surface-2, #f3f4f6);\n}\n.gc-mobile-top-header__menu-item.is-danger { color: #dc2626; }\n.gc-mobile-top-header__menu-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 55;\n  background: transparent;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Mobile chat icon trio + kebab menu in the \"Messages\" sidebar header\n   (replaces the desktop Logout + \"+\" buttons on phone-sized viewports).\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-chat-mobile-icon-btn {\n  position: relative;\n  width: 38px;\n  height: 38px;\n  border-radius: 9999px;\n  background: transparent;\n  border: none;\n  color: var(--gc-text-secondary, #4b5563);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: background var(--gc-transition-fast, 160ms ease);\n}\n.gc-chat-mobile-icon-btn:hover,\n.gc-chat-mobile-icon-btn.is-open {\n  background: var(--gc-surface-2, #f3f4f6);\n  color: var(--gc-text-primary, #111827);\n}\n.gc-chat-mobile-icon-btn__badge {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 9999px;\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 9.5px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--gc-surface-0, #ffffff);\n  pointer-events: none;\n}\n.gc-chat-mobile-icon-btn__wrap { position: relative; }\n.gc-chat-mobile-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 180px;\n  background: var(--gc-surface-0, #ffffff);\n  color: var(--gc-text-primary, #111827);\n  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));\n  border-radius: 12px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);\n  z-index: 60;\n  overflow: hidden;\n  font-family: var(--gc-font);\n  transform-origin: top right;\n  animation: gc-menu-in 160ms cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n.gc-chat-desktop-status-menu {\n  min-width: 190px;\n  overflow: visible;\n}\n\n@keyframes gc-menu-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes gc-away-popover-in {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gc-chat-mobile-menu,\n  .gc-away-popover {\n    animation: none;\n  }\n}\n.gc-chat-mobile-menu__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--gc-text-primary, #111827);\n  text-align: left;\n  font-family: inherit;\n  transition: background var(--gc-transition-fast, 160ms ease);\n}\n.gc-chat-mobile-menu__item:hover { background: var(--gc-surface-2, #f3f4f6); }\n.gc-chat-mobile-menu__item.is-danger { color: #dc2626; }\n.gc-chat-mobile-menu__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 55;\n  background: transparent;\n}\n\n/* Notification popovers triggered by the mobile chat header bell / chat icons.\n   On mobile the popover content panel takes a comfortable share of the screen\n   width and caps its height so the inner list stays scrollable. */\n.gc-chat-mobile-popover {\n  /* Use min-width + width: max-content fallback so the popover never collapses\n     to the natural width of its content (which is what was making the empty\n     state text wrap per-character). */\n  width: min(360px, calc(100vw - 24px)) !important;\n  min-width: 280px;\n  max-width: calc(100vw - 24px);\n  max-height: min(70vh, 480px);\n  background: var(--gc-surface-0, #ffffff);\n  color: var(--gc-text-primary, #111827);\n  border: 1px solid var(--gc-border, rgba(0, 0, 0, 0.08));\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 60;\n  font-family: var(--gc-font);\n  box-sizing: border-box;\n}\n.gc-chat-mobile-popover__title {\n  padding: 12px 14px;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--gc-text-primary, #111827);\n  border-bottom: 1px solid var(--gc-divider, rgba(0, 0, 0, 0.06));\n  flex-shrink: 0;\n}\n.gc-chat-mobile-popover__body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Mobile FAB — WhatsApp-style floating action button at bottom-right\n   that opens the New Conversation modal. Sits above the bottom tab bar\n   (which is 56px tall on mobile) and respects the device safe area.\n   Hidden on desktop and when a conversation is open.\n   ────────────────────────────────────────────────────────────────────────── */\n.gc-chat-fab { display: none; }\n\n@media (max-width: 767px) {\n  .gc-chat-fab {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    right: 20px;\n    /* sit above the 56px tab bar + device safe-area inset */\n    bottom: calc(56px + 20px + env(safe-area-inset-bottom, 0px));\n    width: 56px;\n    height: 56px;\n    border-radius: 18px;\n    border: none;\n    background: var(--gc-primary, #1f2e23);\n    color: var(--gc-on-primary, #f7faf6);\n    box-shadow: 0 8px 22px rgba(15, 29, 20, 0.35), 0 2px 6px rgba(15, 29, 20, 0.15);\n    cursor: pointer;\n    z-index: 45;\n    transition: transform var(--gc-transition-fast, 160ms ease), box-shadow var(--gc-transition-fast, 160ms ease);\n  }\n  .gc-chat-fab:hover { transform: translateY(-1px); }\n  .gc-chat-fab:active { transform: scale(0.96); }\n  /* Hide the FAB when a conversation is open so it doesn't cover the composer */\n  body[data-conv-open=\"true\"] .gc-chat-fab { display: none; }\n}\n\n/* Presence filter chips — each variant carries its own colour so the user\n   can scan online/away/offline at a glance without relying on a tiny dot. */\n.gc-presence-filter-row {\n  box-sizing: border-box;\n  width: 100%;\n  gap: 4px;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: visible;\n  scrollbar-width: none;\n}\n.gc-presence-filter-row::-webkit-scrollbar {\n  display: none;\n}\n.gc-presence-filter-chip {\n  background: var(--gc-surface-0);\n  color: var(--gc-text-secondary);\n  border-color: var(--gc-border);\n  font-family: var(--gc-font-display);\n  font-size: 9.5px;\n  line-height: 1;\n  letter-spacing: 0;\n  min-height: 24px;\n  padding: 2px 6px;\n  white-space: nowrap;\n  flex: 0 0 auto;\n}\n.gc-presence-filter-chip:not(.gc-presence-filter-chip--icon-only) {\n  flex: 1 1 auto;\n  justify-content: center;\n  min-width: max-content;\n}\n.gc-presence-filter-chip:hover {\n  filter: brightness(0.98);\n}\n.gc-presence-filter-chip-pair {\n  display: inline-flex;\n  flex: 1.6 1 auto;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  white-space: nowrap;\n}\n.gc-presence-filter-chip--icon-only {\n  position: relative;\n  flex: 0 0 26px;\n  width: 26px;\n  min-width: 26px;\n  height: 24px;\n  justify-content: center;\n  padding-left: 0;\n  padding-right: 0;\n}\n/* Online — emerald */\n.gc-presence-filter-chip.is-online {\n  background: rgba(16, 185, 129, 0.10);\n  color: rgb(4, 120, 87);\n  border-color: rgba(16, 185, 129, 0.30);\n}\n.gc-presence-filter-chip.is-online.is-active {\n  background: rgb(16, 185, 129);\n  color: #fff;\n  border-color: rgb(16, 185, 129);\n}\n\n/* Away — amber */\n.gc-presence-filter-chip.is-away {\n  background: rgba(245, 158, 11, 0.10);\n  color: rgb(146, 64, 14);\n  border-color: rgba(245, 158, 11, 0.30);\n}\n.gc-presence-filter-chip.is-away.is-active {\n  background: rgb(245, 158, 11);\n  color: #fff;\n  border-color: rgb(245, 158, 11);\n}\n\n/* Offline — neutral slate */\n.gc-presence-filter-chip.is-offline {\n  background: rgba(100, 116, 139, 0.08);\n  color: rgb(71, 85, 105);\n  border-color: rgba(100, 116, 139, 0.25);\n}\n.gc-presence-filter-chip.is-offline.is-active {\n  background: rgb(100, 116, 139);\n  color: #fff;\n  border-color: rgb(100, 116, 139);\n}\n\n/* Groups — violet */\n.gc-presence-filter-chip.is-groups {\n  background: rgba(139, 92, 246, 0.10);\n  color: rgb(91, 33, 182);\n  border-color: rgba(139, 92, 246, 0.30);\n}\n.gc-presence-filter-chip.is-groups.is-active {\n  background: rgb(139, 92, 246);\n  color: #fff;\n  border-color: rgb(139, 92, 246);\n}\n\n/* Internal — slate. Deliberately quieter than External: it is the ordinary\n   case, and the one worth spotting is a chat that leaves the company. */\n.gc-presence-filter-chip.is-internal {\n  background: rgba(100, 116, 139, 0.10);\n  color: rgb(51, 65, 85);\n  border-color: rgba(100, 116, 139, 0.30);\n}\n.gc-presence-filter-chip.is-internal.is-active {\n  background: rgb(100, 116, 139);\n  color: #fff;\n  border-color: rgb(100, 116, 139);\n}\n\n/* External — amber, the same register as the cross-org badges elsewhere */\n.gc-presence-filter-chip.is-external {\n  background: rgba(217, 119, 6, 0.10);\n  color: rgb(146, 64, 14);\n  border-color: rgba(217, 119, 6, 0.30);\n}\n.gc-presence-filter-chip.is-external.is-active {\n  background: rgb(217, 119, 6);\n  color: #fff;\n  border-color: rgb(217, 119, 6);\n}\n\n/* Archived — warm gray */\n.gc-presence-filter-chip.is-archived {\n  background: rgba(120, 113, 108, 0.08);\n  color: rgb(87, 83, 78);\n  border-color: rgba(120, 113, 108, 0.25);\n}\n.gc-presence-filter-chip.is-archived.is-active {\n  background: rgb(87, 83, 78);\n  color: #fff;\n  border-color: rgb(87, 83, 78);\n}\n\n/* Default \"All\" active state — keeps the existing primary look */\n.gc-presence-filter-chip.is-active {\n  background: var(--gc-primary);\n  color: var(--gc-on-primary);\n  border-color: var(--gc-primary);\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   AppShell — mobile responsive layout\n   Below 768px, hide the desktop sidebar and show the WhatsApp-style bottom\n   tab bar. Above 768px the desktop sidebar shows and the bottom bar is hidden.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-app-shell {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  height: 100vh;                /* fallback for older browsers */\n  height: 100dvh;               /* dynamic viewport height — shrinks/grows with mobile chrome */\n  width: 100vw;\n  overflow: hidden;\n  background: linear-gradient(135deg, #eef2ee 0%, #e6ebe6 100%);\n}\n.gt-app-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  height: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #ffffff;\n  border-radius: 18px;\n  box-shadow: 0 1px 2px rgba(15, 29, 20, 0.04), 0 6px 18px rgba(15, 29, 20, 0.05);\n}\n\n/* Let the app-shell's flex stretch size the rail. A percentage height uses the\n   full viewport even after Electron adds title-bar padding, which pushes the\n   rail's bottom edge past the shell and clips its lower margin/radius. */\n.gt-app-shell > .gt-sidebar {\n  min-height: 0;\n  height: auto;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Desktop (Electron) custom title bar — replaces the native OS title bar.\n   A slim draggable strip sits in the top gradient margin. macOS shows its\n   native traffic lights positioned into this strip (see electron/main.js);\n   Windows & Linux render the min/max/close buttons at the right. The\n   .gt-app-shell gains matching top padding so the floating cards sit below it.\n   Only active inside the desktop build (html.is-desktop-electron). */\n:root {\n  --gt-titlebar-h: 30px;\n}\n\n.gt-titlebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--gt-titlebar-h);\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  z-index: 1000;\n  -webkit-app-region: drag;\n  app-region: drag;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* Keep macOS's native traffic-light cluster out of the drag region so the\n   buttons stay clickable. */\nhtml.os-mac .gt-titlebar {\n  padding-left: 80px;\n}\n\n.gt-titlebar-controls {\n  display: flex;\n  align-items: stretch;\n  -webkit-app-region: no-drag;\n  app-region: no-drag;\n}\n\n.gt-titlebar-btn {\n  width: 46px;\n  height: var(--gt-titlebar-h);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--gt-text-secondary, #4b5563);\n  cursor: pointer;\n  transition: background var(--gt-t-fast, 0.15s ease),\n    color var(--gt-t-fast, 0.15s ease);\n}\n.gt-titlebar-btn:hover {\n  background: var(--gt-surface-2, rgba(15, 29, 20, 0.08));\n}\n.gt-titlebar-btn--close:hover {\n  background: #e81123;\n  color: #ffffff;\n}\n.gt-titlebar-icon {\n  width: 15px;\n  height: 15px;\n}\n\n/* Reserve room for the strip on Windows/Linux (where it hosts the custom\n   min/max/close buttons). macOS has no strip — the native traffic lights\n   overlay the sidebar's top-left directly, WhatsApp-style, and the cleared\n   region in .gt-sidebar-header below serves as the window drag area. */\nhtml.is-desktop-electron.os-custom-controls .gt-app-shell {\n  padding-top: calc(4px + var(--gt-titlebar-h));\n}\n\n/* macOS WhatsApp-style title bar: native traffic lights sit over the\n   sidebar's top edge. Pad the sidebar header content down so the brand\n   and collapse button clear the lights, and make the cleared region a\n   window drag handle. The button itself opts out of dragging. */\nhtml.os-mac .gt-sidebar .gt-sidebar-header {\n  padding-top: 32px;\n  min-height: 80px;\n  -webkit-app-region: drag;\n  app-region: drag;\n}\nhtml.os-mac .gt-sidebar-collapse {\n  -webkit-app-region: no-drag;\n  app-region: no-drag;\n}\n\n/* Bigger macOS window-drag target: the conversation-list header (the \"TeamLio\"\n   bar at the top of the chat panel) is also draggable, so the window isn't only\n   movable by the slim icon-rail header. Interactive children opt back out so\n   their clicks/typing still work. */\nhtml.os-mac .gc-chat-sidebar__header {\n  -webkit-app-region: drag;\n  app-region: drag;\n}\nhtml.os-mac .gc-chat-sidebar__header button,\nhtml.os-mac .gc-chat-sidebar__header a,\nhtml.os-mac .gc-chat-sidebar__header input,\nhtml.os-mac .gc-chat-sidebar__header textarea,\nhtml.os-mac .gc-chat-sidebar__header .gc-away-control,\nhtml.os-mac .gc-chat-sidebar__header .gc-away-popover,\nhtml.os-mac .gc-chat-sidebar__header [role=\"button\"] {\n  -webkit-app-region: no-drag;\n  app-region: no-drag;\n}\n\n.gt-mobile-bottom-nav {\n  display: none;\n}\n\n/* Mobile-only top header — blank white bar pinned at the top of the\n   viewport. Height + padding-top respect env(safe-area-inset-top) so\n   the page content sits below the device notch / status bar instead\n   of being clipped. Hidden on desktop. */\n.gt-mobile-top-header {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .gt-mobile-top-header {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: calc(48px + env(safe-area-inset-top, 0px));\n    padding-top: env(safe-area-inset-top, 0px);\n    background: var(--gt-surface-0, #ffffff);\n    border-bottom: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);\n    z-index: 60;\n  }\n}\n\n/* Even when a chat conversation is open on mobile, keep the safe-area\n   top header visible so the device status bar / notch doesn't clip the\n   conversation header. */\n\n@media (max-width: 767px) {\n  .gt-sidebar { display: none !important; }\n\n  /* Drop the floating-card chrome on mobile — content needs the full\n     viewport, and the device chrome already supplies framing. */\n  .gt-app-shell {\n    padding: 0;\n    gap: 0;\n    background: #ffffff;\n  }\n  .gt-app-main {\n    border-radius: 0;\n    box-shadow: none;\n    /* Reserve room for the fixed mobile top header (48px) + safe-area-inset-top\n       at the top, and the bottom tab bar (56px) + safe-area-inset-bottom at\n       the bottom. Prevents content from being clipped by the device chrome\n       (notch / status bar / OS nav gesture area). */\n    padding-top: calc(48px + env(safe-area-inset-top, 0px));\n    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .gt-mobile-bottom-nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 56px;\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    background: var(--gt-surface-0, #ffffff);\n    border-top: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.08));\n    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);\n    z-index: 50;\n    align-items: stretch;\n    justify-content: space-around;\n    font-family: var(--gt-font);\n  }\n}\n\n.gt-mobile-bottom-nav__tab {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--gt-text-tertiary, #6b7280);\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  padding: 6px 4px;\n  text-decoration: none;\n  transition: color var(--gt-t-fast, 160ms ease);\n  position: relative;\n}\n.gt-mobile-bottom-nav__tab:hover {\n  color: var(--gt-text-secondary, #374151);\n}\n.gt-mobile-bottom-nav__tab.is-active {\n  color: var(--gt-primary, #1f2e23);\n}\n.gt-mobile-bottom-nav__tab.is-active::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 28px;\n  height: 3px;\n  border-radius: 0 0 3px 3px;\n  background: var(--gt-primary, #1f2e23);\n}\n.gt-mobile-bottom-nav__icon-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.gt-mobile-bottom-nav__icon {\n  width: 22px;\n  height: 22px;\n}\n.gt-mobile-bottom-nav__badge {\n  position: absolute;\n  top: -4px;\n  right: -8px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 9999px;\n  background: var(--gt-primary, #1f2e23);\n  color: var(--gt-on-primary, #ffffff);\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--gt-surface-0, #ffffff);\n}\n.gt-mobile-bottom-nav__dot {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--gt-primary, #1f2e23);\n  border: 2px solid var(--gt-surface-0, #ffffff);\n}\n\n/* Hide the mobile bottom nav when the user is inside an active conversation\n   on a phone — Chat.tsx sets data-conv-open=\"true\" on the shell. Mirrors\n   WhatsApp's behaviour of giving the message thread the full screen.\n   Also reserves the device's safe-area-inset-bottom so the composer\n   doesn't get clipped behind the OS gesture/navigation bar. */\n@media (max-width: 767px) {\n  body[data-conv-open=\"true\"] .gt-mobile-bottom-nav { display: none; }\n  body[data-conv-open=\"true\"] .gt-app-main {\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n  /* The chat surface itself: pin its height to the visible viewport so the\n     scrollable messages list can shrink and the composer stays in view. */\n  body[data-conv-open=\"true\"] .gc-shell {\n    /* Fit inside the visible area below the white safe-area top header\n       (48px + the device's safe-area-inset-top). Avoids the chat shell\n       extending below the viewport bottom when the top header is shown. */\n    height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));\n    min-height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));\n    max-height: calc(100dvh - 48px - env(safe-area-inset-top, 0px));\n  }\n  /* Composer should sit flush against the safe area, not the raw viewport edge. */\n  body[data-conv-open=\"true\"] .gc-chat-composer {\n    padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TodoPlanner — Today / Upcoming / Missed columns\n   Desktop (≥768px): 3-column grid (unchanged behaviour).\n   Mobile  (<768px): horizontal swipe carousel with scroll-snap, plus\n                     left/right arrow buttons and dot indicators.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-planner-carousel { width: 100%; }\n\n/* Desktop track = grid */\n.gt-planner-carousel__track {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n/* Carousel nav (arrows + dots) is desktop-hidden */\n.gt-planner-carousel__nav { display: none; }\n\n@media (max-width: 767px) {\n  /* Mobile track = horizontal snap scroller */\n  .gt-planner-carousel__track {\n    display: flex;\n    grid-template-columns: none;\n    gap: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    /* let the scroller pull to the page edges so swipe feels native */\n    margin: 0 -16px;\n    padding: 0 16px;\n  }\n  .gt-planner-carousel__track::-webkit-scrollbar { display: none; }\n  .gt-planner-carousel__track > * {\n    flex: 0 0 100%;\n    min-width: 100%;\n    scroll-snap-align: start;\n    scroll-snap-stop: always;\n  }\n\n  /* Mobile nav: arrows on the sides + dots in the middle */\n  .gt-planner-carousel__nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 4px 10px;\n  }\n  .gt-planner-carousel__arrow {\n    width: 34px;\n    height: 34px;\n    border-radius: 9999px;\n    background: var(--gt-surface-0, #ffffff);\n    border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n    color: var(--gt-text-secondary, #374151);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    transition: background var(--gt-t-fast, 160ms ease), transform var(--gt-t-fast, 160ms ease);\n    flex-shrink: 0;\n  }\n  .gt-planner-carousel__arrow:hover { background: var(--gt-surface-2, #f3f4f6); }\n  .gt-planner-carousel__arrow:active { transform: scale(0.96); }\n  .gt-planner-carousel__arrow:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n  .gt-planner-carousel__dots {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    justify-content: center;\n  }\n  /* High-specificity selector so this beats the global\n     `.gt-themed [role=\"tab\"]` rule which would otherwise give the\n     buttons `border-radius: 0` and 10×16 padding (turning them into\n     rectangles). */\n  .gt-planner-carousel .gt-planner-carousel__dot[role=\"tab\"],\n  .gt-planner-carousel button.gt-planner-carousel__dot {\n    width: 10px;\n    height: 10px;\n    min-width: 10px;\n    min-height: 10px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: var(--gt-border-strong, rgba(0, 0, 0, 0.22));\n    border: none;\n    border-bottom: none;\n    cursor: pointer;\n    padding: 0;\n    box-sizing: border-box;\n    transition: background var(--gt-t-fast, 160ms ease), transform var(--gt-t-fast, 160ms ease);\n  }\n  .gt-planner-carousel .gt-planner-carousel__dot[role=\"tab\"].is-active,\n  .gt-planner-carousel button.gt-planner-carousel__dot.is-active {\n    background: var(--gt-primary, #1f2e23);\n    transform: scale(1.15);\n  }\n  .gt-planner-carousel__dot-label {\n    font-family: var(--gt-font-display);\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--gt-text-primary, #111827);\n    letter-spacing: -0.01em;\n    margin-right: 4px;\n  }\n\n  /* On mobile the columns no longer need a fixed min-height — they live inside\n     the snap track, and the empty state has its own height. */\n  .gt-planner-carousel .gt-column { min-height: 0; }\n  .gt-planner-carousel .gt-column > div[class*=\"min-h-\"] {\n    min-height: 320px;\n    max-height: 70dvh;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Daily Planner mobile hamburger — links to the rest of Task Management\n   (Projects / Tasks / Clients / Reports). Mobile-only.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-planner-mobile-menu-wrap { display: none; }\n\n@media (max-width: 767px) {\n  .gt-planner-mobile-menu-wrap {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 20;\n  }\n}\n\n.gt-planner-mobile-menu-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-text-secondary, #4b5563);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: background var(--gt-t-fast, 160ms ease), color var(--gt-t-fast, 160ms ease), box-shadow var(--gt-t-fast, 160ms ease);\n}\n.gt-planner-mobile-menu-btn:hover,\n.gt-planner-mobile-menu-btn.is-open {\n  background: var(--gt-surface-2, #f3f4f6);\n  color: var(--gt-text-primary, #111827);\n}\n\n.gt-planner-mobile-menu__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 49;\n  background: transparent;\n}\n.gt-planner-mobile-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 200px;\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-text-primary, #111827);\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);\n  z-index: 50;\n  overflow: hidden;\n  padding: 4px;\n  font-family: var(--gt-font);\n}\n.gt-planner-mobile-menu__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--gt-text-primary, #111827);\n  text-align: left;\n  font-family: inherit;\n  border-radius: 8px;\n  transition: background var(--gt-t-fast, 160ms ease);\n}\n.gt-planner-mobile-menu__item:hover {\n  background: var(--gt-surface-2, #f3f4f6);\n}\n.gt-planner-mobile-menu__item > svg {\n  color: var(--gt-primary, #1f2e23);\n  flex-shrink: 0;\n}\n\n/* Compact the Daily Planner hero on mobile so the cards underneath\n   sit closer to the page top, eliminating the empty band the user\n   noticed below the title. */\n@media (max-width: 767px) {\n  .gt-page-hero { padding-bottom: 8px; }\n  .gt-page-hero h1.gt-page-title { font-size: 22px; line-height: 1.15; }\n  .gt-page-hero .gt-page-sub { font-size: 12.5px; margin-top: 2px; }\n  .gt-page-hero .gt-eyebrow-row { margin-bottom: 4px; }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Shared mobile back-arrow — used on Projects / Tasks / Clients / Reports\n   and other task-management sub-pages so users can return to the Daily\n   Planner (entry point from the hamburger menu) with one tap. Hidden on\n   desktop where the sidebar already exposes the nav.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-page-back-btn {\n  display: none;\n}\n@media (max-width: 767px) {\n  .gt-page-back-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 8px;\n    padding: 6px 10px 6px 6px;\n    border-radius: 9999px;\n    background: var(--gt-surface-0, #ffffff);\n    border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n    color: var(--gt-text-secondary, #4b5563);\n    font-family: var(--gt-font);\n    font-size: 12.5px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background var(--gt-t-fast, 160ms ease);\n  }\n  .gt-page-back-btn:hover { background: var(--gt-surface-2, #f3f4f6); }\n  .gt-page-back-btn:active { transform: scale(0.97); }\n}\n\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Project Management — status filter grid.\n   Mobile: 2-col (set inline). Desktop: 5-col.\n   ────────────────────────────────────────────────────────────────────────── */\n@media (min-width: 768px) {\n  .gt-project-status-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TaskList page — mobile-friendly tab row + action buttons\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-tasks-scope-tab {\n  padding: 10px 18px;\n  font-family: var(--gt-font-display);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--gt-text-tertiary, #6b7280);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.gt-tasks-scope-tab.is-active {\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-primary-deep, var(--gt-primary, #1f2e23));\n  border-bottom-color: var(--gt-primary, #1f2e23);\n  box-shadow: var(--gt-elev-1);\n}\n\n/* Hide the scope-tabs horizontal scrollbar on mobile for a cleaner look. */\n.gt-tasks-scope-tabs nav { scrollbar-width: none; }\n.gt-tasks-scope-tabs nav::-webkit-scrollbar { display: none; }\n\n@media (max-width: 767px) {\n  .gt-tasks-scope-tab {\n    padding: 9px 12px;\n    font-size: 12.5px;\n    gap: 6px;\n  }\n  /* \"Recently Deleted\" becomes an icon-only square on phones. */\n  .gt-task-trash-btn {\n    width: 42px;\n    height: 42px;\n    padding: 0 !important;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Daily Planner mobile filter icon — replaces the inline Priority + Status\n   dropdowns on phones. Tapping it opens a popover with both selects.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-planner-filter-icon-btn {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-text-secondary, #4b5563);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition: background var(--gt-t-fast, 160ms ease), color var(--gt-t-fast, 160ms ease);\n}\n.gt-planner-filter-icon-btn:hover,\n.gt-planner-filter-icon-btn.is-open {\n  background: var(--gt-surface-2, #f3f4f6);\n  color: var(--gt-text-primary, #111827);\n}\n.gt-planner-filter-icon-btn__dot {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--gt-primary, #1f2e23);\n  border: 2px solid var(--gt-surface-0, #ffffff);\n}\n\n.gt-planner-filter-popover__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 49;\n  background: transparent;\n}\n.gt-planner-filter-popover {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  width: min(280px, calc(100vw - 32px));\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-text-primary, #111827);\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));\n  border-radius: 14px;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);\n  z-index: 50;\n  padding: 12px;\n  font-family: var(--gt-font);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.gt-planner-filter-popover__title {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--gt-text-primary, #111827);\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));\n  margin-bottom: 4px;\n}\n.gt-planner-filter-popover__label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary, #6b7280);\n  margin-top: 4px;\n}\n.gt-planner-filter-popover__actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 6px;\n  border-top: 1px solid var(--gt-divider, rgba(0, 0, 0, 0.06));\n  padding-top: 10px;\n}\n.gt-planner-filter-popover__reset {\n  background: transparent;\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n  color: var(--gt-text-secondary, #4b5563);\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: inherit;\n}\n.gt-planner-filter-popover__done {\n  background: var(--gt-primary, #1f2e23);\n  border: none;\n  color: var(--gt-on-primary, #ffffff);\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n/* On mobile the History button becomes icon-only (text hidden via JSX). */\n@media (max-width: 767px) {\n  .gt-planner-history-btn {\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border-radius: 10px;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Task Reports — collapsible filter trigger\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-reports-filter-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.10));\n  background: var(--gt-surface-0, #ffffff);\n  color: var(--gt-text-primary, #111827);\n  font-family: var(--gt-font);\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  min-width: 140px;\n  transition: background var(--gt-t-fast, 160ms ease), border-color var(--gt-t-fast, 160ms ease);\n}\n.gt-reports-filter-trigger:hover {\n  background: var(--gt-surface-2, #f3f4f6);\n  border-color: var(--gt-border-strong, rgba(0, 0, 0, 0.18));\n}\n.gt-reports-filter-trigger[aria-expanded=\"true\"] {\n  border-color: var(--gt-primary, #1f2e23);\n  color: var(--gt-primary-deep, var(--gt-primary, #1f2e23));\n}\n.gt-reports-filter-trigger__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--gt-primary, #1f2e23);\n  display: inline-block;\n  margin-left: 2px;\n}\n\n.gt-reports-filter-panel {\n  animation: gt-fade-up 260ms cubic-bezier(0.33, 1, 0.68, 1) both;\n  transform-origin: top left;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   TaskStats — colorful status tile grid.\n   Mobile: 3 cols (set inline).\n   Desktop (≥768px): one row of N tiles (N = --task-stats-desktop-cols).\n   ────────────────────────────────────────────────────────────────────────── */\n@media (min-width: 768px) {\n  .gt-task-stats-grid {\n    grid-template-columns: repeat(var(--task-stats-desktop-cols, 6), minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Task create/edit modal — mobile sizing for the section tabs so all 5 fit\n   on a single line with a horizontal scroll fallback.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-task-tabs { scrollbar-width: none; }\n.gt-task-tabs::-webkit-scrollbar { display: none; }\n\n@media (max-width: 767px) {\n  .gt-task-tabs > button {\n    padding: 9px 12px !important;\n    font-size: 12.5px !important;\n  }\n}\n\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Login page — responsive layout\n   Desktop (≥768px): 2-column grid (editorial copy + form card).\n   Mobile  (<768px): single column, editorial copy stacks above the form.\n   ────────────────────────────────────────────────────────────────────────── */\n.gt-login-page {\n  position: relative;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  background: var(--gt-surface-1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  font-family: var(--gt-font);\n  color: var(--gt-text-primary);\n  overflow-x: hidden;\n}\n.gt-login-blobs {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n.gt-login-blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(20px);\n  opacity: 0.7;\n}\n.gt-login-blob.is-primary {\n  top: -120px;\n  left: -120px;\n  width: 360px;\n  height: 360px;\n  background: radial-gradient(closest-side, var(--gt-primary-container), transparent 70%);\n}\n.gt-login-blob.is-accent {\n  bottom: -160px;\n  right: -100px;\n  width: 420px;\n  height: 420px;\n  filter: blur(24px);\n  opacity: 0.6;\n  background: radial-gradient(closest-side, var(--gt-accent-soft), transparent 70%);\n}\n.gt-login-grid {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 880px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(360px, 440px);\n  gap: 56px;\n  align-items: center;\n}\n@media (max-width: 767px) {\n  /* Mobile login fills the full device height. The editorial copy sits at\n     the top, the sign-in card grows to fill the remaining space, so there\n     are no awkward empty bands at the top or bottom. */\n  .gt-login-page {\n    align-items: stretch;\n    padding: 0;\n  }\n  .gt-login-grid {\n    /* Mobile: hide the editorial copy and centre the sign-in form so the\n       full device height is just the form. */\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: 1fr;\n    gap: 0;\n    max-width: none;\n    align-items: stretch;\n    justify-content: center;\n    width: 100%;\n    min-height: 100dvh;\n    padding: 24px 20px max(24px, env(safe-area-inset-bottom, 0px));\n  }\n\n  /* Hide the editorial column on phones — only the sign-in form shows. */\n  .gt-login-editorial { display: none; }\n  /* Shrink/hide oversized decorative blobs so they don't fight the small viewport */\n  .gt-login-blob.is-primary { width: 220px; height: 220px; top: -80px; left: -80px; }\n  .gt-login-blob.is-accent { width: 260px; height: 260px; bottom: -120px; right: -80px; }\n\n  /* Sign-in card entrance — fades up on load. */\n  .gt-login-card {\n    animation: gt-fade-up 520ms cubic-bezier(0.33, 1, 0.68, 1) 60ms both;\n    padding: 28px 22px;\n    gap: 16px;\n    width: 100%;\n    max-width: 420px;\n    align-self: center;\n  }\n  .gt-login-card-title { font-size: 22px; }\n  .gt-login-input { font-size: 16px; padding-top: 12px; padding-bottom: 12px; }\n  .gt-login-submit { padding-top: 14px; padding-bottom: 14px; font-size: 15px; }\n}\n.gt-login-editorial { min-width: 0; }\n.gt-login-eyebrow {\n  font-size: 12px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gt-login-eyebrow-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--gt-primary);\n  display: inline-block;\n}\n.gt-login-headline {\n  font-family: var(--gt-font-display);\n  font-size: clamp(28px, 7vw, 56px);\n  line-height: 1.05;\n  letter-spacing: var(--gt-letter-display);\n  color: var(--gt-text-primary);\n  margin: 0;\n}\n.gt-login-headline em {\n  color: var(--gt-primary);\n  font-style: italic;\n}\n.gt-login-tagline {\n  margin-top: 18px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--gt-text-secondary);\n  max-width: 420px;\n}\n@media (max-width: 767px) {\n  .gt-login-tagline { font-size: 14px; margin-top: 12px; }\n}\n\n.gt-login-card {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n@media (max-width: 767px) {\n  .gt-login-card { padding: 24px; }\n}\n.gt-login-card-eyebrow {\n  font-size: 11px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--gt-text-tertiary);\n  margin-bottom: 6px;\n}\n.gt-login-card-title {\n  font-family: var(--gt-font-display);\n  font-size: 24px;\n  margin: 0;\n  color: var(--gt-text-primary);\n}\n.gt-login-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.gt-login-input-wrap { position: relative; }\n.gt-login-input-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: var(--gt-text-tertiary);\n  pointer-events: none;\n}\n.gt-login-input {\n  width: 100%;\n  padding-left: 36px;\n}\n.gt-login-input.has-trailing { padding-right: 40px; }\n.gt-login-eye-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--gt-text-tertiary);\n  padding: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.gt-login-error {\n  font-size: 13px;\n  color: #9b2f24;\n  background: rgba(196, 87, 76, 0.08);\n  border: 1px solid rgba(196, 87, 76, 0.25);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n.gt-login-submit {\n  width: 100%;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n/* Sign in with Google — the button itself is rendered by Google Identity\n   Services, so this only positions it and separates it from the email form. */\n.gt-login-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--gt-text-tertiary);\n  font-size: 11px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n.gt-login-divider::before,\n.gt-login-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: var(--gt-border);\n}\n/* Google caps its own button at 400px and styles it itself, so the real one is\n   rendered invisible and scaled (in Login.tsx) over .gt-login-google-face —\n   ours, which carries the Continue button's own classes so the two can never\n   drift apart. Clicks land on Google's button; only ours is seen. */\n.gt-login-google {\n  position: relative;\n}\n.gt-login-google:focus-within .gt-login-google-face {\n  box-shadow: 0 0 0 3px var(--gt-primary-soft);\n}\n.gt-login-google-face.gt-btn {\n  /* gt-login-submit adds a top margin; here it would leave the invisible\n     Google button overhanging the visible one by those pixels. */\n  margin: 0;\n  gap: 10px;\n  border: 1px solid var(--gt-border);\n  background: var(--gt-surface-2);\n  color: var(--gt-text-primary);\n}\n.gt-login-google:hover .gt-login-google-face.gt-btn {\n  background: var(--gt-surface-hover);\n}\n.gt-login-google-real {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.gt-login-foot {\n  font-size: 12px;\n  color: var(--gt-text-tertiary);\n  text-align: center;\n  margin-top: 4px;\n}\n\n/* Compact variant — smaller card for the multi-step flow */\n.gt-login-card--compact {\n  padding: 24px 26px;\n  gap: 14px;\n  max-width: 380px;\n  width: 100%;\n  justify-self: end;\n}\n.gt-login-card--compact .gt-login-card-title { font-size: 22px; }\n.gt-login-card--compact .gt-login-input { padding-top: 10px; padding-bottom: 10px; }\n.gt-login-card--compact .gt-login-submit { padding-top: 11px; padding-bottom: 11px; }\n@media (max-width: 767px) {\n  .gt-login-card--compact { padding: 24px 22px; max-width: 420px; justify-self: center; }\n}\n\n.gt-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* Organisation list */\n.gt-login-orglist {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 280px;\n  overflow-y: auto;\n  margin: 0 -4px;\n  padding: 0 4px;\n}\n.gt-login-org {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border: 1px solid var(--gt-border, rgba(0, 0, 0, 0.08));\n  border-radius: 12px;\n  background: var(--gt-surface-2, #fff);\n  cursor: pointer;\n  transition: border-color 160ms, background 160ms, transform 160ms;\n}\n.gt-login-org:hover {\n  border-color: var(--gt-text-primary);\n  background: var(--gt-surface-1, #faf8f3);\n}\n.gt-login-org:active { transform: translateY(1px); }\n.gt-login-org-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--gt-tint, rgba(15, 118, 110, 0.1));\n  color: var(--gt-text-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gt-login-org-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n.gt-login-org-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--gt-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gt-login-org-sub {\n  font-size: 12px;\n  color: var(--gt-text-tertiary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gt-login-org-arrow {\n  color: var(--gt-text-tertiary);\n  flex-shrink: 0;\n}\n\n/* \"Signing in to X\" chip + back button */\n.gt-login-orgchip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: var(--gt-tint, rgba(15, 118, 110, 0.1));\n  color: var(--gt-text-primary);\n  font-size: 12px;\n  align-self: flex-start;\n  max-width: 100%;\n  overflow: hidden;\n}\n.gt-login-orgchip > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gt-login-back {\n  width: 100%;\n  justify-content: center;\n  gap: 6px;\n  background: transparent;\n  color: var(--gt-text-tertiary);\n  font-size: 13px;\n  padding: 8px 12px;\n}\n.gt-login-back:hover { color: var(--gt-text-primary); }\n\n/* ─── Chat Notifications Panel (CNP) ──────────────────────────────────────── */\n.cnp-root {\n  display: flex;\n  flex-direction: column;\n  font-family: var(--gc-font-display, 'DM Sans', sans-serif);\n}\n\n/* Empty state */\n.cnp-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 32px 20px;\n  color: var(--gc-text-tertiary, #9ca3af);\n}\n.cnp-empty-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  background: var(--gc-surface-2, #f3f4f6);\n  color: var(--gc-text-tertiary, #9ca3af);\n  margin-bottom: 4px;\n}\n.cnp-empty-title {\n  margin: 0;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--gc-text-secondary, #374151);\n  letter-spacing: -0.01em;\n}\n.cnp-empty-sub {\n  margin: 0;\n  font-size: 12px;\n  color: var(--gc-text-tertiary, #9ca3af);\n}\n\n/* Toolbar: count + mark-all */\n.cnp-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px 6px;\n  border-bottom: 1px solid var(--gc-border, rgba(0,0,0,.06));\n}\n.cnp-toolbar-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--gc-text-tertiary, #9ca3af);\n}\n.cnp-mark-all-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  border: 1.5px solid var(--gc-primary, #1f4d3f);\n  background: transparent;\n  color: var(--gc-primary, #1f4d3f);\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 140ms ease, color 140ms ease;\n  letter-spacing: -0.01em;\n}\n.cnp-mark-all-btn:hover {\n  background: var(--gc-primary, #1f4d3f);\n  color: #fff;\n}\n\n/* List */\n.cnp-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n}\n\n/* Row */\n.cnp-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px 0 0;\n  border-bottom: 1px solid var(--gc-border, rgba(0,0,0,.04));\n  transition: background 120ms ease;\n}\n.cnp-item:hover { background: var(--gc-surface-2, #f9fafb); }\n.cnp-item:last-child { border-bottom: none; }\n\n.cnp-item-btn {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 6px 9px 12px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  text-align: left;\n}\n\n/* Color-coded initials avatar */\n.cnp-avatar {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  font-family: var(--gc-font-display, sans-serif);\n}\n\n/* Name + preview */\n.cnp-item-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.cnp-item-name {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gc-text-primary, #111827);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.cnp-item-preview {\n  font-size: 11.5px;\n  color: var(--gc-text-tertiary, #9ca3af);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Time + count pill (right column) */\n.cnp-item-meta {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n.cnp-item-time {\n  font-size: 10.5px;\n  font-family: var(--gc-font-mono, monospace);\n  color: var(--gc-text-tertiary, #9ca3af);\n  letter-spacing: 0.02em;\n}\n.cnp-item-count {\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: var(--gc-primary, #1f4d3f);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: -0.01em;\n}\n\n/* Per-item ✓ button */\n.cnp-check-btn {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  border: 1.5px solid var(--gc-border, rgba(0,0,0,.10));\n  background: var(--gc-surface-0, #fff);\n  color: var(--gc-primary, #1f4d3f);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 140ms ease, background 120ms ease;\n}\n.cnp-item:hover .cnp-check-btn { opacity: 1; }\n.cnp-check-btn:hover {\n  background: var(--gc-primary, #1f4d3f);\n  color: #fff;\n  border-color: var(--gc-primary, #1f4d3f);\n}\n\n/* Mobile badge — use primary green instead of red */\n.gc-chat-mobile-icon-btn__badge {\n  background: var(--gc-primary, #1f4d3f) !important;\n}\n\n/* ── One rounded container holding all 3 panels flush ──────────────────── */\nhtml body .gc-chat-shell {\n  margin: 10px;\n  height: calc(100% - 20px);\n  border-radius: 18px;\n  padding: 0;\n  gap: 0;\n  box-shadow: 0 2px 12px -4px rgba(20, 20, 18, 0.10);\n}\nhtml body .gc-chat-sidebar,\nhtml body .gc-chat-main,\nhtml body .gc-right-panel {\n  border-radius: 0 !important;\n}\n@media (max-width: 767px) {\n  html body .gc-chat-shell {\n    margin: 0;\n    height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Client / Vendor Management — Editorial ledger aesthetic\n   ─────────────────────────────────────────────────────────────────────────\n   Component prefix: .cm-*  (Client Management)\n   Used by ClientsPage.tsx and the cloned VendorsPage.tsx.\n   ──────────────────────────────────────────────────────────────────────── */\n\n/* ----- Buttons (primary / ghost) ----- */\n.cm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  font-family: var(--gt-font);\n  font-size: 13.5px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background var(--gt-t-fast), border-color var(--gt-t-fast),\n              color var(--gt-t-fast), transform var(--gt-t-fast),\n              box-shadow var(--gt-t-fast);\n  white-space: nowrap;\n  line-height: 1;\n}\n.cm-btn:focus-visible {\n  outline: 2px solid var(--gt-primary);\n  outline-offset: 2px;\n}\n.cm-btn-primary {\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  border-color: var(--gt-primary);\n  box-shadow: var(--gt-glow-soft);\n}\n.cm-btn-primary:hover {\n  background: var(--gt-primary-hover);\n  border-color: var(--gt-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--gt-glow);\n}\n.cm-btn-primary:active { transform: translateY(0); }\n.cm-btn-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n}\n.cm-btn-ghost {\n  background: var(--gt-surface-0);\n  color: var(--gt-primary);\n  border-color: var(--gt-border-strong);\n}\n.cm-btn-ghost:hover {\n  background: var(--gt-surface-1);\n  border-color: var(--gt-primary);\n}\n.cm-btn-spinner {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(255,255,255,0.35);\n  border-top-color: var(--gt-on-primary);\n  animation: cm-spin 0.7s linear infinite;\n}\n@keyframes cm-spin { to { transform: rotate(360deg); } }\n\n/* ----- Import dropdown ----- */\n.cm-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 220px;\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  box-shadow: var(--gt-elev-4);\n  overflow: hidden;\n  z-index: 10;\n  animation: cm-pop-down 220ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n@keyframes cm-pop-down {\n  from { opacity: 0; transform: translateY(-6px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n.cm-dropdown-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  font-family: var(--gt-font);\n  font-size: 13.5px;\n  color: var(--gt-text-secondary);\n  background: transparent;\n  border: 0;\n  border-top: 1px dashed var(--gt-divider);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast);\n}\n.cm-dropdown-item:first-child { border-top: 0; }\n.cm-dropdown-item:hover {\n  background: var(--gt-surface-1);\n  color: var(--gt-primary);\n}\n.cm-dropdown-item svg { color: var(--gt-primary); flex-shrink: 0; }\n\n/* ----- Stat tiles (editorial ledger rows) ----- */\n.cm-stats {\n  margin-top: 28px;\n  display: none;\n  gap: 14px;\n}\n@media (min-width: 768px) {\n  .cm-stats {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n.cm-stat-tile {\n  position: relative;\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  padding: 18px 22px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 18px;\n  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid),\n              transform var(--gt-t-mid);\n  overflow: hidden;\n}\n.cm-stat-tile::before {\n  content: \"\";\n  position: absolute;\n  top: 0; bottom: 0; left: 0;\n  width: 3px;\n  background: var(--gt-primary);\n  transform: scaleY(0.3);\n  transform-origin: center;\n  transition: transform var(--gt-t-mid);\n}\n.cm-stat-tile:hover {\n  border-color: var(--gt-border-strong);\n  box-shadow: var(--gt-elev-2);\n  transform: translateY(-2px);\n}\n.cm-stat-tile:hover::before { transform: scaleY(0.85); }\n.cm-stat-index {\n  font-family: var(--gt-font-mono);\n  font-size: 10.5px;\n  font-weight: 500;\n  color: var(--gt-text-tertiary);\n  letter-spacing: 0.04em;\n  padding-top: 4px;\n  align-self: start;\n}\n.cm-stat-eyebrow {\n  font-family: var(--gt-font);\n  font-size: 10.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: var(--gt-letter-eyebrow);\n  color: var(--gt-text-tertiary);\n  margin: 0 0 6px;\n}\n.cm-stat-value {\n  font-family: var(--gt-font-display);\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: var(--gt-letter-display);\n  color: var(--gt-text-primary);\n  line-height: 1;\n  margin: 0;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.cm-stat-suffix {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--gt-text-tertiary);\n  letter-spacing: -0.005em;\n}\n.cm-stat-accent {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 400;\n  font-size: 12.5px;\n  color: var(--gt-text-tertiary);\n  opacity: 0.7;\n  margin: 0;\n  align-self: end;\n  padding-bottom: 2px;\n}\n\n/* ----- Search row ----- */\n.cm-search-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 28px;\n  padding-bottom: 14px;\n  border-bottom: 1px dashed var(--gt-border);\n  flex-wrap: wrap;\n}\n.cm-search {\n  position: relative;\n  flex: 1;\n  max-width: 460px;\n  min-width: 240px;\n}\n.cm-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 17px;\n  height: 17px;\n  color: var(--gt-text-tertiary);\n  pointer-events: none;\n}\n.cm-search-input {\n  width: 100%;\n  padding: 12px 40px 12px 42px;\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: 12px;\n  font-family: var(--gt-font);\n  font-size: 14px;\n  color: var(--gt-text-primary);\n  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast),\n              background var(--gt-t-fast);\n}\n.cm-search-input::placeholder {\n  color: var(--gt-text-tertiary);\n  font-style: italic;\n}\n.cm-search-input:focus {\n  outline: none;\n  border-color: var(--gt-primary);\n  box-shadow: 0 0 0 3px var(--gt-primary-container);\n  background: var(--gt-surface-0);\n}\n.cm-search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 26px;\n  height: 26px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--gt-text-tertiary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast);\n}\n.cm-search-clear:hover {\n  background: var(--gt-surface-2);\n  color: var(--gt-primary);\n}\n.cm-search-meta {\n  font-family: var(--gt-font);\n  font-size: 12.5px;\n  color: var(--gt-text-tertiary);\n  letter-spacing: 0.005em;\n  white-space: nowrap;\n}\n.cm-search-meta em {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  color: var(--gt-text-secondary);\n}\n\n/* ----- Loading state ----- */\n.cm-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 0;\n  gap: 18px;\n}\n.cm-spinner {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid var(--gt-border);\n  border-top-color: var(--gt-primary);\n  animation: cm-spin 0.8s linear infinite;\n}\n.cm-loading-text {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-size: 14px;\n  color: var(--gt-text-tertiary);\n  margin: 0;\n}\n\n/* ----- Empty state (cornered frame) ----- */\n.cm-empty {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0 48px;\n}\n.cm-empty-frame {\n  position: relative;\n  max-width: 520px;\n  width: 100%;\n  padding: 56px 48px 48px;\n  text-align: center;\n  background: var(--gt-surface-1);\n  border-radius: var(--gt-radius-card);\n}\n.cm-empty-corner {\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  border: 1.5px solid var(--gt-primary);\n  opacity: 0.55;\n}\n.cm-empty-corner-tl { top: 14px; left: 14px;  border-right: 0; border-bottom: 0; }\n.cm-empty-corner-tr { top: 14px; right: 14px; border-left: 0;  border-bottom: 0; }\n.cm-empty-corner-bl { bottom: 14px; left: 14px;  border-right: 0; border-top: 0; }\n.cm-empty-corner-br { bottom: 14px; right: 14px; border-left: 0;  border-top: 0; }\n.cm-empty-eyebrow {\n  font-family: var(--gt-font);\n  font-size: 10.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--gt-text-tertiary);\n  margin: 0 0 18px;\n}\n.cm-empty-title {\n  font-family: var(--gt-font-display);\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--gt-text-primary);\n  margin: 0 0 12px;\n  line-height: 1.15;\n}\n.cm-empty-title em {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-primary);\n}\n.cm-empty-sub {\n  font-family: var(--gt-font);\n  font-size: 14px;\n  color: var(--gt-text-secondary);\n  margin: 0 0 26px;\n  line-height: 1.5;\n}\n.cm-empty-cta {\n  display: inline-flex;\n}\n\n/* ----- Modal (overlay + sheet) ----- */\n.cm-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 24, 18, 0.42);\n  backdrop-filter: blur(6px);\n  animation: cm-fade-in 200ms ease-out;\n}\n@keyframes cm-fade-in { from { opacity: 0; } to { opacity: 1; } }\n.cm-modal {\n  position: relative;\n  width: 100%;\n  max-width: 880px;\n  max-height: 92vh;\n  background: var(--gt-surface-1);\n  border-radius: var(--gt-radius-modal);\n  box-shadow: var(--gt-elev-5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: cm-modal-in 360ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n@keyframes cm-modal-in {\n  from { opacity: 0; transform: translateY(14px) scale(0.985); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n.cm-modal-header {\n  position: relative;\n  padding: 32px 40px 26px;\n  background: var(--gt-surface-1);\n  border-bottom: 1px dashed var(--gt-border-strong);\n  flex-shrink: 0;\n}\n.cm-modal-eyebrow-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.cm-modal-leaf {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  background: var(--gt-primary);\n  border-radius: 50%;\n  box-shadow: 0 0 0 4px var(--gt-primary-container);\n}\n.cm-modal-eyebrow {\n  font-family: var(--gt-font);\n  font-size: 10.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: var(--gt-letter-eyebrow);\n  color: var(--gt-text-tertiary);\n}\n.cm-modal-title {\n  font-family: var(--gt-font-display);\n  font-size: 34px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: var(--gt-text-primary);\n  margin: 0 0 8px;\n  line-height: 1.1;\n}\n.cm-modal-title em {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-primary);\n}\n.cm-modal-sub {\n  font-family: var(--gt-font);\n  font-size: 14px;\n  color: var(--gt-text-secondary);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 560px;\n}\n.cm-modal-sub em.gt-serif-italic {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  color: var(--gt-text-primary);\n}\n.cm-modal-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 1px solid var(--gt-border);\n  border-radius: 10px;\n  color: var(--gt-text-secondary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast),\n              border-color var(--gt-t-fast);\n}\n.cm-modal-close:hover {\n  background: var(--gt-surface-0);\n  color: var(--gt-primary);\n  border-color: var(--gt-primary);\n}\n.cm-modal-form {\n  padding: 28px 40px 0;\n  overflow-y: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.cm-modal-footer {\n  position: sticky;\n  bottom: 0;\n  margin: 0 -40px;\n  padding: 18px 40px;\n  background: var(--gt-surface-1);\n  border-top: 1px solid var(--gt-border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n/* ----- Section (form group) ----- */\n.cm-section {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.cm-section-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 2px;\n}\n.cm-section-rule {\n  flex-shrink: 0;\n  width: 28px;\n  height: 1px;\n  background: var(--gt-primary);\n  opacity: 0.55;\n}\n.cm-section-eyebrow {\n  font-family: var(--gt-font-mono);\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  color: var(--gt-primary);\n  text-transform: lowercase;\n}\n.cm-section-title {\n  font-family: var(--gt-font-display);\n  font-size: 19px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: var(--gt-text-primary);\n  margin: 0;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.cm-section-title em {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-weight: 500;\n  color: var(--gt-primary);\n}\n.cm-section-count {\n  font-family: var(--gt-font-mono);\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--gt-text-tertiary);\n  background: var(--gt-surface-2);\n  border-radius: 6px;\n  padding: 3px 7px;\n  letter-spacing: 0.04em;\n}\n.cm-add-branch {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  background: var(--gt-primary-container);\n  color: var(--gt-primary);\n  border: 1px dashed var(--gt-primary);\n  border-radius: 999px;\n  font-family: var(--gt-font);\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  cursor: pointer;\n  transition: background var(--gt-t-fast), border-style var(--gt-t-fast),\n              transform var(--gt-t-fast);\n}\n.cm-add-branch:hover {\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  border-style: solid;\n  transform: translateY(-1px);\n}\n\n/* ----- Form fields ----- */\n.cm-field { display: flex; flex-direction: column; }\n.cm-field-label {\n  display: block;\n  font-family: var(--gt-font);\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--gt-text-secondary);\n  margin-bottom: 8px;\n}\n.cm-field-required {\n  color: var(--gt-dnd);\n  font-weight: 700;\n  margin-left: 2px;\n}\n.cm-input {\n  width: 100%;\n  padding: 12px 16px;\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-input);\n  font-family: var(--gt-font);\n  font-size: 14px;\n  color: var(--gt-text-primary);\n  transition: border-color var(--gt-t-fast), box-shadow var(--gt-t-fast),\n              background var(--gt-t-fast);\n}\n.cm-input::placeholder {\n  color: var(--gt-text-tertiary);\n  font-style: italic;\n}\n.cm-input:focus {\n  outline: none;\n  border-color: var(--gt-primary);\n  box-shadow: 0 0 0 3px var(--gt-primary-container);\n}\n.cm-input:hover:not(:focus):not(.is-error) {\n  border-color: var(--gt-border-strong);\n}\n.cm-input.is-error {\n  border-color: var(--gt-dnd);\n}\n.cm-input.is-error:focus {\n  box-shadow: 0 0 0 3px rgba(196, 87, 76, 0.16);\n}\n.cm-input-mono {\n  font-family: var(--gt-font-mono);\n  letter-spacing: 0.01em;\n}\n.cm-input-with-action { padding-right: 96px; }\n.cm-field-error {\n  font-family: var(--gt-font);\n  font-size: 12px;\n  color: var(--gt-dnd);\n  margin: 6px 0 0;\n  font-style: italic;\n}\n.cm-fetch-btn {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 7px 14px;\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  border: 0;\n  border-radius: 9px;\n  font-family: var(--gt-font);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 180ms ease, background var(--gt-t-fast);\n}\n.cm-fetch-btn.is-visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n.cm-fetch-btn:hover {\n  background: var(--gt-primary-hover);\n}\n\n/* ----- Branch card ----- */\n.cm-branch-card {\n  position: relative;\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  border-radius: var(--gt-radius-card);\n  padding: 24px 24px 22px;\n  transition: border-color var(--gt-t-mid), box-shadow var(--gt-t-mid);\n}\n.cm-branch-card:hover {\n  border-color: var(--gt-border-strong);\n  box-shadow: var(--gt-elev-1);\n}\n.cm-branch-tag {\n  position: absolute;\n  top: -10px;\n  left: 18px;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 4px 12px;\n  background: var(--gt-primary);\n  color: var(--gt-on-primary);\n  border-radius: 999px;\n  box-shadow: var(--gt-glow-soft);\n}\n.cm-branch-tag-num {\n  font-family: var(--gt-font-mono);\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  opacity: 0.7;\n}\n.cm-branch-tag-label {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  font-size: 12px;\n  font-weight: 500;\n}\n.cm-branch-remove {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--gt-text-tertiary);\n  cursor: pointer;\n  transition: background var(--gt-t-fast), color var(--gt-t-fast);\n}\n.cm-branch-remove:hover {\n  background: #fdecea;\n  color: var(--gt-dnd);\n}\n.cm-branch-empty {\n  text-align: center;\n  padding: 36px 24px;\n  background: var(--gt-surface-2);\n  border: 1px dashed var(--gt-border-strong);\n  border-radius: var(--gt-radius-card);\n}\n.cm-branch-empty-eyebrow {\n  font-family: var(--gt-font);\n  font-size: 10.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--gt-text-tertiary);\n  margin: 0 0 10px;\n}\n.cm-branch-empty-text {\n  font-family: var(--gt-font);\n  font-size: 13.5px;\n  color: var(--gt-text-secondary);\n  margin: 0;\n}\n.cm-branch-empty-text em.gt-serif-italic {\n  font-family: var(--gt-font-serif);\n  font-style: italic;\n  color: var(--gt-text-primary);\n}\n\n/* Responsive — tighten modal padding on small screens */\n@media (max-width: 640px) {\n  .cm-modal-header { padding: 24px 22px 20px; }\n  .cm-modal-form   { padding: 22px 22px 0; gap: 26px; }\n  .cm-modal-footer { margin: 0 -22px; padding: 16px 22px; }\n  .cm-modal-title  { font-size: 26px; }\n  .cm-empty-frame  { padding: 44px 24px 36px; }\n  .cm-empty-title  { font-size: 24px; }\n}\n\n/* ── BrandColorSetting ─────────────────────────────────────────────────────── */\n.gc-brand-color-setting { padding: 16px; border: 1px solid var(--gc-border, #e5e7eb); border-radius: 8px; max-width: 480px; }\n.gc-brand-color-setting__heading h3 { margin: 0 0 4px; font-size: 14px; font-weight: 600; }\n.gc-brand-color-setting__hint { margin: 0 0 12px; color: var(--gc-muted, #6b7280); font-size: 12px; }\n.gc-brand-color-setting__row { display:flex; align-items:center; gap:10px; margin-top:10px; flex-wrap: wrap; }\n.gc-brand-color-setting__toggle { display:flex; align-items:center; gap:8px; font-size: 13px; cursor: pointer; }\n.gc-brand-color-setting__label { font-size: 12px; color: var(--gc-muted); }\n.gc-brand-color-setting__hex { padding: 4px 8px; border-radius: 4px; border: 1px solid var(--gc-border, #e5e7eb); font-family: monospace; font-size: 12px; width: 100px; }\n.gc-brand-color-setting__preview-label { font-size: 12px; color: var(--gc-muted); }\n.gc-brand-color-setting__saved { color: var(--gc-success, #047857); font-size: 12px; }\n\n/* ── ClientsPage — workspace button on linked client rows ──────────────────── */\n.gc-clients-row__workspace-btn { font-size: 12px; }\n\n/* ── Call-row: reveal hover actions, mute the subtitle, missed -> danger token ── */\n.gc-call-row__actions { opacity: 0; transition: opacity var(--gc-transition-fast); }\n.gc-call-row:hover .gc-call-row__actions,\n.gc-call-row:focus-within .gc-call-row__actions { opacity: 1; }\n.gc-call-row__sub { color: var(--gc-text-tertiary); }\n.gc-call-row--missed .gc-text-display-bold,\n.gc-call-row--missed .gc-call-row__sub { color: var(--gc-dnd); }\n\n/* ── In-chat call event card — WhatsApp-style, replaces the old centred pill ──\n   Aligns like a message: calls I started (.is-mine) on the right, received on\n   the left. Whole card is a button that rings back. ─────────────────────────── */\n.gc-call-card-row {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  padding: 2px 14px;\n  margin: 2px 0;\n}\n.gc-call-card-row.is-mine { justify-content: flex-end; }\n\n.gc-call-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 240px;\n  max-width: min(340px, 78%);\n  padding: 9px 14px;\n  border-radius: 16px;\n  background: var(--gc-surface-2);\n  border: 1px solid var(--gc-border);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--gc-transition-fast), border-color var(--gc-transition-fast);\n}\n.gc-call-card:hover { background: var(--gc-surface-1); border-color: var(--gc-border-strong); }\n.gc-call-card:focus-visible { outline: 2px solid var(--gc-primary); outline-offset: 2px; }\n\n.gc-call-card__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 9999px;\n  background: color-mix(in srgb, var(--gc-text-tertiary) 18%, transparent);\n  color: var(--gc-text-secondary);\n}\n\n.gc-call-card__body { display: flex; flex-direction: column; min-width: 0; flex: 1; }\n.gc-call-card__title {\n  font-family: var(--gc-font-display);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--gc-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gc-call-card__sub {\n  font-size: 12px;\n  line-height: 1.3;\n  color: var(--gc-text-tertiary);\n  margin-top: 1px;\n}\n.gc-call-card__time {\n  align-self: flex-end;\n  flex-shrink: 0;\n  font-size: 10.5px;\n  color: var(--gc-text-tertiary);\n}\n\n/* Missed / unanswered → danger token on the icon, title and subtitle. */\n.gc-call-card--missed .gc-call-card__icon {\n  background: color-mix(in srgb, var(--gc-dnd) 16%, transparent);\n  color: var(--gc-dnd);\n}\n.gc-call-card--missed .gc-call-card__title,\n.gc-call-card--missed .gc-call-card__sub { color: var(--gc-dnd); }\n\n/* ── Employee Hub · Workflow ───────────────────────────────────────────── */\n.gt-workflow-page {\n  min-height: 100%;\n  padding: clamp(18px, 3vw, 34px);\n  background: var(--gt-surface-1);\n  color: var(--gt-text-primary);\n  overflow: auto;\n}\n.gt-workflow-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin-bottom: 24px; }\n.gt-workflow-header__copy { display: flex; align-items: center; gap: 14px; min-width: 0; }\n.gt-workflow-header__icon { display: grid; place-items: center; width: 48px; height: 48px; flex: 0 0 auto; border-radius: 14px; background: var(--gt-accent-strong); color: var(--gt-surface-0); }\n.gt-workflow-header__icon svg { width: 23px; height: 23px; }\n.gt-workflow-header h1 { margin: 0; font-size: clamp(25px, 3vw, 38px); line-height: 1.08; font-weight: 750; letter-spacing: -0.025em; }\n.gt-workflow-header h1 em { color: var(--gt-accent); font-family: Georgia, serif; }\n.gt-workflow-header p { margin: 6px 0 0; color: var(--gt-text-tertiary); }\n.gt-workflow-header__actions { display: flex; gap: 10px; align-items: center; }\n.gt-workflow-panel, .gt-workflow-card, .gt-workflow-metric {\n  background: var(--gt-surface-0);\n  border: 1px solid var(--gt-border);\n  box-shadow: var(--gt-elev-1);\n}\n.gt-workflow-panel { border-radius: 18px; padding: 20px; margin-bottom: 22px; }\n.gt-workflow-filters { display: flex; flex-wrap: wrap; align-items: end; gap: 12px; }\n.gt-workflow-filters label, .gt-workflow-date-range label { display: grid; gap: 6px; color: var(--gt-text-secondary); font-size: 12px; font-weight: 650; }\n.gt-workflow-filters input, .gt-workflow-filters select, .gt-workflow-date-range input {\n  min-height: 44px; border: 1px solid var(--gt-border); border-radius: 11px; padding: 0 13px;\n  background: var(--gt-surface-1); color: var(--gt-text-primary); font: inherit;\n}\n.gt-workflow-filters .is-grow { flex: 1 1 260px; }\n.gt-workflow-button { min-height: 44px; border: 1px solid var(--gt-accent); border-radius: 11px; padding: 0 18px; background: var(--gt-accent-strong); color: var(--gt-surface-0); font-weight: 700; cursor: pointer; transition: filter var(--gt-t-fast), box-shadow var(--gt-t-fast); }\n.gt-workflow-button.is-secondary { background: transparent; color: var(--gt-text-primary); border-color: var(--gt-border-strong); }\n.gt-workflow-button:hover { filter: brightness(1.08); }\n.gt-workflow-button:focus-visible, .gt-workflow-tabs button:focus-visible, button.gt-workflow-card:focus-visible { outline: 2px solid var(--gt-accent); outline-offset: 3px; }\n.gt-workflow-date-range { display: flex; align-items: end; gap: 8px; }\n.gt-workflow-date-range > svg { margin-bottom: 12px; width: 17px; color: var(--gt-text-tertiary); }\n.gt-workflow-tabs { display: inline-flex; padding: 4px; border: 1px solid var(--gt-border); border-radius: 11px; background: var(--gt-surface-2); }\n.gt-workflow-tabs button { border: 0; border-radius: 8px; padding: 8px 16px; background: transparent; color: var(--gt-text-secondary); cursor: pointer; font-weight: 650; }\n.gt-workflow-tabs button.is-active { background: var(--gt-surface-0); color: var(--gt-accent-strong); box-shadow: var(--gt-elev-1); }\n.gt-workflow-metrics { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; margin-bottom: 22px; }\n.gt-workflow-metric { border-radius: 16px; padding: 18px; display: grid; gap: 5px; }\n.gt-workflow-metric span { color: var(--gt-text-tertiary); font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }\n.gt-workflow-metric strong { font-size: clamp(24px, 3vw, 34px); line-height: 1; }\n.gt-workflow-metric small { color: var(--gt-text-tertiary); }\n.gt-workflow-metric.is-positive strong { color: var(--gt-green-600); }\n.gt-workflow-metric.is-warning strong { color: var(--gt-amber-600); }\n.gt-workflow-card-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(275px, 1fr)); gap: 16px; }\n.gt-workflow-card { border-radius: 17px; padding: 20px; color: inherit; }\nbutton.gt-workflow-card { text-align: left; cursor: pointer; transition: border-color var(--gt-t-fast), transform var(--gt-t-fast); }\nbutton.gt-workflow-card:hover { border-color: var(--gt-accent); transform: translateY(-1px); }\n.gt-workflow-state { min-height: 180px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; text-align: center; color: var(--gt-text-tertiary); }\n.gt-workflow-state > svg { width: 28px; height: 28px; }\n.gt-workflow-table-wrap { width: 100%; overflow-x: auto; border: 1px solid var(--gt-border); border-radius: 15px; background: var(--gt-surface-0); }\n.gt-workflow-table { width: 100%; min-width: 720px; border-collapse: collapse; }\n.gt-workflow-table th, .gt-workflow-table td { padding: 13px 16px; border-bottom: 1px solid var(--gt-divider); text-align: left; }\n.gt-workflow-table th { background: var(--gt-surface-2); color: var(--gt-text-tertiary); font-size: 11px; text-transform: uppercase; letter-spacing: .05em; }\n.gt-workflow-timeline { display: grid; gap: 10px; }\n.gt-workflow-timeline__item { display: grid; grid-template-columns: 120px 1fr auto; gap: 14px; align-items: start; padding: 14px; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-0); }\n.gt-workflow-badge { display: inline-flex; align-items: center; width: fit-content; border-radius: 999px; padding: 4px 10px; background: var(--gt-accent-soft); color: var(--gt-accent-strong); font-size: 12px; font-weight: 700; }\n\n/* Activity Report — mirrors the production TeamLio reporting hierarchy. */\n.gt-activity-report-page > * { width: min(100%, 1152px); margin-inline: auto; }\n.gt-activity-report-page .gt-workflow-header { margin-bottom: 16px; }\n.gt-activity-report-page .gt-workflow-header__icon { width: 42px; height: 42px; border-radius: 12px; }\n.gt-activity-report-page .gt-workflow-header__icon svg { width: 20px; height: 20px; }\n.gt-activity-report-page .gt-workflow-header h1 { font-size: clamp(24px, 2.5vw, 32px); }\n.gt-activity-report-page .gt-workflow-header p { margin-top: 4px; font-size: 13px; }\n.gt-activity-report-filters { align-items: center; padding: 10px; gap: 8px; border-radius: 14px; }\n.gt-activity-report-filters label > span { position: absolute; width: 1px; height: 1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }\n.gt-activity-report-filters .gt-workflow-tabs { align-self: stretch; }\n.gt-activity-report-filters .gt-workflow-tabs button { min-width: 84px; padding: 6px 14px; text-transform: lowercase; }\n.gt-activity-report-filters .gt-workflow-date-range { align-items: center; border: 1px solid var(--gt-border); border-radius: 10px; padding: 0 8px; background: var(--gt-surface-1); }\n.gt-activity-report-filters .gt-workflow-date-range > svg { width: 15px; margin: 0; }\n.gt-activity-report-filters input, .gt-activity-report-filters select { min-height: 36px; border: 0; background: transparent; font-size: 12px; }\n.gt-activity-report-filters .gt-workflow-date-range input { width: 112px; padding-inline: 6px; }\n.gt-activity-report-filters > label { flex: 0 1 210px; min-width: 0; }\n.gt-activity-report-filters select { width: 100%; min-width: 0; border: 1px solid var(--gt-border); background: var(--gt-surface-1); }\n.gt-activity-report-filters .gt-workflow-button { min-height: 36px; border-radius: 999px; padding-inline: 18px; }\n\n.gt-activity-monthly { padding: 20px 22px; }\n.gt-activity-monthly > h2 { display: flex; align-items: center; gap: 8px; margin: 0 0 14px; color: var(--gt-text-secondary); font-size: 13px; font-weight: 700; }\n.gt-activity-monthly > h2 svg { width: 15px; height: 15px; color: var(--gt-accent); }\n.gt-activity-monthly__grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }\n.gt-activity-monthly__grid article { display: grid; justify-items: center; gap: 5px; padding: 20px 12px; border-radius: 13px; background: var(--gt-surface-2); text-align: center; }\n.gt-activity-monthly__grid span { color: var(--gt-text-tertiary); font-size: 10px; text-transform: uppercase; }\n.gt-activity-monthly__grid strong { font-size: clamp(22px, 2.5vw, 30px); line-height: 1; font-variant-numeric: tabular-nums; }\n.gt-activity-monthly__grid small { color: var(--gt-text-tertiary); font-size: 10px; }\n.gt-activity-monthly__grid .is-positive strong { color: var(--gt-green-600); }\n.gt-activity-monthly__grid .is-warning strong { color: var(--gt-amber-600); }\n\n.gt-activity-focus { padding: 18px 20px; }\n.gt-activity-focus__metrics { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; }\n.gt-activity-focus__metrics article { display: flex; align-items: center; gap: 10px; min-width: 0; padding: 12px; border: 1px solid var(--gt-border); border-radius: 13px; background: var(--gt-surface-1); }\n.gt-activity-focus__icon { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 auto; border-radius: 10px; background: var(--gt-accent-soft); color: var(--gt-accent); }\n.gt-activity-focus__icon svg { width: 17px; height: 17px; }\n.gt-activity-focus__metrics article > span:last-child { display: grid; min-width: 0; gap: 2px; }\n.gt-activity-focus__metrics small { color: var(--gt-text-tertiary); font-size: 9px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }\n.gt-activity-focus__metrics strong { overflow: hidden; font-size: clamp(16px, 2vw, 21px); line-height: 1.05; text-overflow: ellipsis; white-space: nowrap; font-variant-numeric: tabular-nums; }\n.gt-activity-focus__metrics .is-positive .gt-activity-focus__icon, .gt-activity-focus__metrics .is-positive strong { color: var(--gt-green-600); }\n.gt-activity-focus__metrics .is-warning .gt-activity-focus__icon, .gt-activity-focus__metrics .is-warning strong { color: var(--gt-amber-600); }\n.gt-activity-focus__legend { display: flex; align-items: center; justify-content: flex-end; gap: 14px; margin: 15px 0 7px; color: var(--gt-text-secondary); font-size: 11px; font-weight: 650; }\n.gt-activity-focus__legend > span:first-child { margin-right: auto; color: var(--gt-text-tertiary); font-size: 10px; letter-spacing: .06em; text-transform: uppercase; }\n.gt-activity-focus__legend i, .gt-activity-productivity__legend i { display: inline-block; width: 8px; height: 8px; margin-right: 5px; border-radius: 3px; }\n.gt-activity-focus .is-active, .gt-activity-productivity .is-active { background: var(--gt-green-600); }\n.gt-activity-focus .is-idle, .gt-activity-productivity .is-idle { background: var(--gt-amber-600); }\n.gt-activity-focus__bar, .gt-activity-productivity__bar { display: flex; height: 9px; overflow: hidden; border-radius: 999px; background: var(--gt-surface-2); }\n\n.gt-activity-sessions, .gt-activity-summary { display: grid; gap: 16px; }\n.gt-activity-session { padding: 0; overflow: hidden; }\n.gt-activity-session__header { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 15px 20px; border-bottom: 1px solid var(--gt-border); }\n.gt-activity-session__avatar { display: grid; place-items: center; width: 36px; height: 36px; flex: 0 0 auto; border-radius: 11px; background: var(--gt-accent-soft); color: var(--gt-accent); }\n.gt-activity-session__avatar svg { width: 17px; height: 17px; }\n.gt-activity-session__identity { display: grid; gap: 2px; }\n.gt-activity-session__identity strong { font-size: 14px; }\n.gt-activity-session__identity small { color: var(--gt-text-tertiary); font-size: 11px; }\n.gt-activity-session__chips { display: flex; flex-wrap: wrap; gap: 7px; margin-left: auto; }\n.gt-activity-chip { display: grid; min-width: 66px; gap: 4px; padding: 7px 10px; border: 1px solid var(--gt-border); border-radius: 11px; background: var(--gt-surface-1); text-align: center; }\n.gt-activity-chip small { color: var(--gt-text-tertiary); font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }\n.gt-activity-chip strong { font-size: 13px; line-height: 1; font-variant-numeric: tabular-nums; }\n.gt-activity-chip.is-positive strong { color: var(--gt-green-600); }\n.gt-activity-chip.is-warning strong { color: var(--gt-amber-600); }\n.gt-activity-session__body { display: grid; gap: 22px; padding: 20px; }\n.gt-activity-productivity { padding: 13px 15px; border: 1px solid var(--gt-border); border-radius: 13px; background: var(--gt-surface-1); }\n.gt-activity-productivity > div:first-child { display: flex; flex-wrap: wrap; align-items: baseline; gap: 8px; margin-bottom: 9px; }\n.gt-activity-productivity > div > span:first-child { color: var(--gt-text-tertiary); font-size: 10px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }\n.gt-activity-productivity strong { color: var(--gt-green-600); font-size: 23px; line-height: 1; }\n.gt-activity-productivity small { color: var(--gt-text-tertiary); font-size: 10px; }\n.gt-activity-productivity__legend { display: inline-flex; align-items: center; gap: 3px; margin-left: auto; color: var(--gt-text-secondary); font-size: 10px; font-weight: 650; }\n.gt-activity-productivity__legend > span { display: inline-flex; align-items: center; white-space: nowrap; }\n.gt-activity-productivity__legend > span + span { margin-left: 8px; }\n.gt-activity-productivity .is-productive { background: #22c55e; }\n.gt-activity-productivity .is-neutral { background: #9ca3af; }\n.gt-activity-productivity .is-unproductive { background: #ef4444; }\n.gt-activity-ai-button { display: inline-flex; align-items: center; gap: 6px; min-height: 30px; margin-left: 10px; padding: 5px 12px; border: 0; border-radius: 999px; background: linear-gradient(135deg, #7c3aed, #a855f7); color: #fff; font: inherit; font-weight: 750; cursor: pointer; }\n.gt-activity-ai-button svg { width: 13px; height: 13px; }\n.gt-activity-ai-button:disabled { cursor: wait; opacity: .65; }\n.gt-activity-ai-button:focus-visible, .gt-activity-application > button:focus-visible, .gt-activity-app-details button:focus-visible { outline: 2px solid #a855f7; outline-offset: 2px; }\n.gt-activity-ai-panel { margin-top: 12px; overflow: hidden; border: 1px solid color-mix(in srgb, #a855f7 40%, var(--gt-border)); border-radius: 12px; background: color-mix(in srgb, #a855f7 8%, var(--gt-surface-0)); }\n.gt-activity-ai-panel > header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 8px 13px; border-bottom: 1px solid color-mix(in srgb, #a855f7 30%, var(--gt-border)); background: color-mix(in srgb, #a855f7 12%, var(--gt-surface-1)); }\n.gt-activity-ai-panel > header > span, .gt-activity-ai-panel button, .gt-activity-ai-panel p { display: flex; align-items: center; gap: 6px; }\n.gt-activity-ai-panel svg { width: 13px; height: 13px; }\n.gt-activity-ai-panel header small { padding: 2px 7px; border-radius: 999px; background: color-mix(in srgb, #a855f7 18%, transparent); color: #a855f7; }\n.gt-activity-ai-panel button { border: 0; background: transparent; color: var(--gt-text-secondary); font: inherit; cursor: pointer; }\n.gt-activity-ai-panel > div { padding: 12px 14px; }\n.gt-activity-ai-panel p { margin: 0; line-height: 1.55; white-space: pre-wrap; }\n.gt-activity-ai-panel p.is-error { color: var(--gt-dnd); }\n\n.gt-activity-breakdown > h3 { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin: 0 0 10px; color: var(--gt-text-secondary); font-size: 12px; font-weight: 700; }\n.gt-activity-breakdown > h3 > span, .gt-activity-breakdown > h3 small { display: inline-flex; align-items: center; gap: 7px; }\n.gt-activity-breakdown > h3 svg { width: 14px; height: 14px; }\n.gt-activity-breakdown > h3 small { padding: 4px 9px; border-radius: 999px; background: var(--gt-accent-soft); color: var(--gt-accent); font-size: 10px; }\n.gt-activity-breakdown__rows { overflow: hidden; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-1); }\n.gt-activity-breakdown__rows article { display: grid; grid-template-columns: minmax(150px, 1fr) minmax(80px, 160px) 64px 70px; align-items: center; gap: 10px; padding: 9px 12px; border-bottom: 1px solid var(--gt-divider); }\n.gt-activity-breakdown__rows article:last-child { border-bottom: 0; }\n.gt-activity-breakdown__copy { display: grid; min-width: 0; gap: 2px; }\n.gt-activity-breakdown__copy strong { overflow: hidden; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }\n.gt-activity-breakdown__copy small { overflow: hidden; color: var(--gt-text-tertiary); font-size: 9px; text-overflow: ellipsis; white-space: nowrap; }\n.gt-activity-breakdown__progress { height: 6px; overflow: hidden; border-radius: 999px; background: var(--gt-border); }\n.gt-activity-breakdown__progress i { display: block; height: 100%; border-radius: inherit; background: var(--gt-accent); }\n.gt-activity-breakdown__rows article > span:nth-last-child(2) { color: var(--gt-accent); font-size: 10px; font-weight: 700; text-align: right; }\n.gt-activity-breakdown__rows time { color: var(--gt-text-tertiary); font-family: var(--gt-font-mono); font-size: 9px; text-align: right; }\n.gt-activity-session__empty { padding: 20px; color: var(--gt-text-tertiary); text-align: center; }\n\n.gt-activity-application-rows { overflow: hidden; border: 1px solid var(--gt-border); border-radius: 12px; background: var(--gt-surface-1); }\n.gt-activity-application + .gt-activity-application { border-top: 1px solid var(--gt-divider); }\n.gt-activity-application > button { display: grid; grid-template-columns: minmax(130px, 1fr) minmax(90px, 2fr) auto auto 28px 18px; align-items: center; gap: 10px; width: 100%; padding: 10px 12px; border: 0; background: transparent; color: var(--gt-text-primary); text-align: left; cursor: pointer; }\n.gt-activity-application > button:hover, .gt-activity-application.is-expanded > button { background: var(--gt-accent-soft); }\n.gt-activity-application__duration { padding: 3px 8px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 10px; font-weight: 700; white-space: nowrap; }\n.gt-activity-category { padding: 3px 8px; border-radius: 999px; font-size: 9px; font-weight: 750; }\n.gt-activity-category.is-productive { background: color-mix(in srgb, #22c55e 16%, transparent); color: #22c55e; }\n.gt-activity-category.is-neutral { background: color-mix(in srgb, #9ca3af 18%, transparent); color: var(--gt-text-secondary); }\n.gt-activity-category.is-unproductive { background: color-mix(in srgb, #ef4444 16%, transparent); color: #ef4444; }\n.gt-activity-application__count { display: grid; place-items: center; min-width: 25px; height: 25px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-tertiary); font-size: 9px; }\n.gt-activity-application__chevron { width: 14px; height: 14px; color: var(--gt-text-tertiary); transition: transform var(--gt-t-fast); }\n.gt-activity-application.is-expanded .gt-activity-application__chevron { transform: rotate(180deg); }\n.gt-activity-app-details { margin: 0 10px 10px; overflow: hidden; border: 1px solid var(--gt-border-strong); border-radius: 12px; background: var(--gt-surface-0); }\n.gt-activity-app-details > header { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-bottom: 1px solid var(--gt-border); background: var(--gt-accent-soft); }\n.gt-activity-app-details > header > span { padding: 2px 8px; border-radius: 999px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 9px; }\n.gt-activity-app-details > header button { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; border: 0; background: transparent; color: var(--gt-text-secondary); font: inherit; cursor: pointer; }\n.gt-activity-app-details > header svg { width: 13px; height: 13px; }\n.gt-activity-app-details__stats { display: flex; flex-wrap: wrap; gap: 24px; padding: 12px 16px; border-bottom: 1px solid var(--gt-border); }\n.gt-activity-app-details__stats > span { display: grid; gap: 3px; }\n.gt-activity-app-details__stats small { color: var(--gt-text-tertiary); font-size: 9px; text-transform: uppercase; }\n.gt-activity-app-details__stats strong { font-size: 18px; }\n.gt-activity-app-details__events { max-height: 460px; overflow-y: auto; }\n.gt-activity-app-details__events article { display: grid; grid-template-columns: 86px 64px minmax(0, 1fr) 48px; align-items: start; gap: 10px; padding: 10px 16px; border-bottom: 1px solid var(--gt-divider); }\n.gt-activity-app-details__events article:last-child { border-bottom: 0; }\n.gt-activity-app-details__events time { color: var(--gt-text-tertiary); font-family: var(--gt-font-mono); font-size: 10px; }\n.gt-activity-event-state { color: var(--gt-green-600); font-size: 10px; text-transform: capitalize; }\n.gt-activity-app-details__events article > span:nth-child(3) { display: grid; min-width: 0; gap: 2px; }\n.gt-activity-app-details__events article strong { overflow: hidden; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }\n.gt-activity-app-details__events article small { color: var(--gt-text-tertiary); font-size: 9px; }\n.gt-activity-app-details__events article em { overflow: hidden; color: var(--gt-accent); font-size: 9px; font-style: normal; text-overflow: ellipsis; white-space: nowrap; }\n.gt-activity-app-details__events article b { font-size: 10px; text-align: right; }\n.gt-activity-app-details__events > p { margin: 0; padding: 22px; color: var(--gt-text-tertiary); text-align: center; }\n\n.gt-activity-summary__header { display: flex; align-items: center; gap: 12px; padding: 15px 20px; border-bottom: 1px solid var(--gt-border); }\n.gt-activity-summary__header > span:nth-child(2) { display: grid; gap: 2px; }\n.gt-activity-summary__header > span:nth-child(2) small { color: var(--gt-text-tertiary); font-size: 10px; }\n.gt-activity-summary__header > span:last-child { margin-left: auto; padding: 4px 9px; border-radius: 999px; background: var(--gt-accent-soft); color: var(--gt-accent); font-size: 10px; font-weight: 700; }\n.gt-activity-summary__totals { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; padding: 18px 20px 0; }\n.gt-activity-summary__totals .gt-activity-chip { padding: 13px; }\n.gt-activity-summary__totals .gt-activity-chip strong { font-size: 17px; }\n.gt-activity-summary__sessions { padding: 18px 20px 20px; }\n.gt-activity-summary__sessions h3 { margin: 0 0 9px; color: var(--gt-text-tertiary); font-size: 10px; letter-spacing: .06em; text-transform: uppercase; }\n.gt-activity-summary__sessions article { display: grid; grid-template-columns: minmax(150px, 1fr) auto auto auto; align-items: center; gap: 16px; padding: 10px 12px; border-radius: 10px; background: var(--gt-surface-2); color: var(--gt-text-secondary); font-size: 11px; }\n.gt-activity-summary__sessions article + article { margin-top: 7px; }\n.gt-activity-summary__sessions article > span { display: inline-flex; align-items: center; gap: 6px; }\n.gt-activity-summary__sessions article svg { width: 12px; height: 12px; color: var(--gt-text-tertiary); }\n.gt-activity-summary__sessions article i { color: var(--gt-text-tertiary); }\n.gt-activity-summary__sessions article strong { color: var(--gt-green-600); }\n.gt-activity-summary__sessions article small { color: var(--gt-amber-600); }\n\n@media (max-width: 900px) {\n  .gt-workflow-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .gt-activity-focus__metrics { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .gt-activity-session__chips { width: 100%; margin-left: 48px; }\n}\n@media (max-width: 767px) {\n  .gt-workflow-page { padding: 16px 14px 92px; }\n  .gt-workflow-header { align-items: flex-start; flex-direction: column; }\n  .gt-workflow-header__actions, .gt-workflow-filters, .gt-workflow-date-range { width: 100%; }\n  .gt-workflow-filters > *, .gt-workflow-date-range label { flex: 1 1 100%; width: 100%; }\n  .gt-workflow-date-range { flex-wrap: wrap; }\n  .gt-workflow-date-range > svg { display: none; }\n  .gt-workflow-metrics { grid-template-columns: 1fr 1fr; gap: 10px; }\n  .gt-workflow-timeline__item { grid-template-columns: 1fr; }\n  .gt-activity-report-page .gt-workflow-header { flex-direction: row; }\n  .gt-activity-report-filters > *, .gt-activity-report-filters .gt-workflow-date-range { width: 100%; }\n  .gt-activity-report-filters .gt-workflow-tabs button { flex: 1; }\n  .gt-activity-monthly__grid, .gt-activity-summary__totals { grid-template-columns: 1fr 1fr; }\n  .gt-activity-focus__metrics { grid-template-columns: 1fr 1fr; }\n  .gt-activity-focus__metrics article:last-child { grid-column: 1 / -1; }\n  .gt-activity-session__chips { margin-left: 0; }\n  .gt-activity-productivity__legend { width: 100%; margin-left: 0; }\n  .gt-activity-ai-button { margin-left: 0; }\n  .gt-activity-breakdown__rows article { grid-template-columns: minmax(0, 1fr) auto; }\n  .gt-activity-breakdown__progress { grid-column: 1 / -1; grid-row: 2; }\n  .gt-activity-breakdown__rows time { display: none; }\n  .gt-activity-summary__sessions article { grid-template-columns: 1fr auto; gap: 7px 12px; }\n  .gt-activity-application > button { grid-template-columns: minmax(0, 1fr) auto auto 18px; }\n  .gt-activity-application > button .gt-activity-breakdown__progress { grid-column: 1 / -1; grid-row: 2; }\n  .gt-activity-application__count { display: none; }\n  .gt-activity-app-details__events article { grid-template-columns: 70px minmax(0, 1fr) auto; }\n  .gt-activity-app-details__events .gt-activity-event-state { display: none; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .gt-workflow-button, button.gt-workflow-card { transition: none; }\n  button.gt-workflow-card:hover { transform: none; }\n}\n\n/* ── Hidden desktop window ──────────────────────────────────────────────────\n   Electron runs this window with backgroundThrottling off (presence heartbeats\n   must keep their timing), which also keeps the Page Visibility API reporting\n   \"visible\" while the window sits in the tray. CSS animations would therefore\n   keep the render pipeline busy at 60 fps for nobody. utils/windowVisibility\n   stamps <html data-window-hidden> from the main process's authoritative\n   visibility signal; everything decorative freezes until the window is back. */\nhtml[data-window-hidden] *:not([data-state]),\nhtml[data-window-hidden] *:not([data-state])::before,\nhtml[data-window-hidden] *:not([data-state])::after {\n  animation-play-state: paused !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
